var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
(function (global, factory) {
  exports = factory();
})(exports, function () {
  'use strict';

  function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2$2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) {
        _defineProperty$2(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _defineProperty$2(obj, key, value) {
    key = _toPropertyKey$2(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _toPrimitive$2(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey$2(arg) {
    var key = _toPrimitive$2(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2$1(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }
  function _classCallCheck$2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties$2(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$2(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty$1(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits$2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf$2(subClass, superClass);
  }
  function _getPrototypeOf$2(o) {
    _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$2(o);
  }
  function _setPrototypeOf$2(o, p) {
    _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf$2(o, p);
  }
  function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _assertThisInitialized$2(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn$2(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized$2(self);
  }
  function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf$2(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf$2(this || _global).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this || _global, arguments);
      }
      return _possibleConstructorReturn$2(this || _global, result);
    };
  }
  function _superPropBase$2(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf$2(object);
      if (object === null) break;
    }
    return object;
  }
  function _get$2() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get$2 = Reflect.get.bind();
    } else {
      _get$2 = function _get(target, property, receiver) {
        var base = _superPropBase$2(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get$2.apply(this || _global, arguments);
  }
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
  }
  function _toConsumableArray$1(arr) {
    return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
  }
  function _arrayWithoutHoles$1(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
  }
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  function _iterableToArray$1(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  function _unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
  }
  function _arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread$1() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        var F = function () {};
        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function () {
        it = it.call(o);
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  // Copyright 2014 Globo.com Player authors. All rights reserved.
  // Use of this source code is governed by a BSD-style
  // license that can be found in the LICENSE file.

  /* istanbul ignore file */

  /**
   * Array.prototype.find
   *
   * Original source : https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/find
   * See also : https://tc39.github.io/ecma262/#sec-array.prototype.find
   */
  if (!Array.prototype.find) {
    // eslint-disable-next-line
    Object.defineProperty(Array.prototype, "find", {
      // Note: ES6 arrow function syntax is not used on purpose to avoid this to be undefined
      value: function value(predicate) {
        // 1. Let O be ? ToObject(this value).
        if ((this || _global) == null) throw new TypeError("\"this\" is null or not defined");
        var o = Object(this || _global);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== "function") throw new TypeError("predicate must be a function");

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return kValue.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) return kValue;

          // e. Increase k by 1.
          k++;
        }

        // 7. Return undefined.
        return undefined;
      }
    });
  }

  // polyfills for smart TVs

  if (!Object.entries) {
    Object.entries = function (obj) {
      var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
      while (i--) {
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      }
      return resArray;
    };
  }
  if (!Object.values) {
    Object.values = function (obj) {
      var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
      while (i--) {
        resArray[i] = obj[ownProps[i]];
      }
      return resArray;
    };
  }

  /**
   * Object.assign
   * This polyfill doesn't support symbol properties, since ES5 doesn't have symbols anyway
   *
   * Original source : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
   */
  if (typeof Object.assign != "function") {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      // length of function is 2.
      value: function assign(target, varArgs) {
        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError("Cannot convert undefined or null to object");
        }
        var to = Object(target);
        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];
          if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // https://tc39.github.io/ecma262/#sec-array.prototype.findindex
  if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, "findIndex", {
      value: function value(predicate) {
        // 1. Let O be ? ToObject(this value).
        if ((this || _global) == null) {
          throw new TypeError("\"this\" is null or not defined");
        }
        var o = Object(this || _global);

        // 2. Let len be ? ToLength(? Get(O, "length")).
        var len = o.length >>> 0;

        // 3. If IsCallable(predicate) is false, throw a TypeError exception.
        if (typeof predicate !== "function") {
          throw new TypeError("predicate must be a function");
        }

        // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
        var thisArg = arguments[1];

        // 5. Let k be 0.
        var k = 0;

        // 6. Repeat, while k < len
        while (k < len) {
          // a. Let Pk be ! ToString(k).
          // b. Let kValue be ? Get(O, Pk).
          // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
          // d. If testResult is true, return k.
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return k;
          }
          // e. Increase k by 1.
          k++;
        }

        // 7. Return -1.
        return -1;
      },
      configurable: true,
      writable: true
    });
  }

  /* istanbul ignore file */
  // https://github.com/mathiasbynens/small
  var mp4 = "data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=";
  var Media = {
    mp4: mp4
  };

  /* Zepto v1.2.0 - zepto ajax callbacks deferred event ie selector - zeptojs.com/license */
  var Zepto = function () {
    var undefined$1,
      key,
      $,
      classList,
      emptyArray = [],
      concat = emptyArray.concat,
      filter = emptyArray.filter,
      slice = emptyArray.slice,
      document = window.document,
      elementDisplay = {},
      classCache = {},
      cssNumber = {
        "column-count": 1,
        "columns": 1,
        "font-weight": 1,
        "line-height": 1,
        "opacity": 1,
        "z-index": 1,
        "zoom": 1
      },
      fragmentRE = /^\s*<(\w+|!)[^>]*>/,
      singleTagRE = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
      tagExpanderRE = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,
      rootNodeRE = /^(?:body|html)$/i,
      capitalRE = /([A-Z])/g,
      // special attributes that should be get/set via method calls
      methodAttributes = ["val", "css", "html", "text", "data", "width", "height", "offset"],
      adjacencyOperators = ["after", "prepend", "before", "append"],
      table = document.createElement("table"),
      tableRow = document.createElement("tr"),
      containers = {
        "tr": document.createElement("tbody"),
        "tbody": table,
        "thead": table,
        "tfoot": table,
        "td": tableRow,
        "th": tableRow,
        "*": document.createElement("div")
      },
      readyRE = /complete|loaded|interactive/,
      simpleSelectorRE = /^[\w-]*$/,
      class2type = {},
      toString = class2type.toString,
      zepto = {},
      camelize,
      uniq,
      tempParent = document.createElement("div"),
      propMap = {
        "tabindex": "tabIndex",
        "readonly": "readOnly",
        "for": "htmlFor",
        "class": "className",
        "maxlength": "maxLength",
        "cellspacing": "cellSpacing",
        "cellpadding": "cellPadding",
        "rowspan": "rowSpan",
        "colspan": "colSpan",
        "usemap": "useMap",
        "frameborder": "frameBorder",
        "contenteditable": "contentEditable"
      },
      isArray = Array.isArray || function (object) {
        return object instanceof Array;
      };
    zepto.matches = function (element, selector) {
      if (!selector || !element || element.nodeType !== 1) return false;
      var matchesSelector = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.oMatchesSelector || element.matchesSelector;
      if (matchesSelector) return matchesSelector.call(element, selector);
      // fall back to performing a selector:
      var match,
        parent = element.parentNode,
        temp = !parent;
      if (temp) (parent = tempParent).appendChild(element);
      match = ~zepto.qsa(parent, selector).indexOf(element);
      temp && tempParent.removeChild(element);
      return match;
    };
    function type(obj) {
      return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
    }
    function isFunction(value) {
      return type(value) == "function";
    }
    function isWindow(obj) {
      return obj != null && obj == obj.window;
    }
    function isDocument(obj) {
      return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
    }
    function isObject(obj) {
      return type(obj) == "object";
    }
    function isPlainObject(obj) {
      return isObject(obj) && !isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
    }
    function likeArray(obj) {
      var length = !!obj && "length" in obj && obj.length,
        type = $.type(obj);
      return "function" != type && !isWindow(obj) && ("array" == type || length === 0 || typeof length == "number" && length > 0 && length - 1 in obj);
    }
    function compact(array) {
      return filter.call(array, function (item) {
        return item != null;
      });
    }
    function flatten(array) {
      return array.length > 0 ? $.fn.concat.apply([], array) : array;
    }
    camelize = function (str) {
      return str.replace(/-+(.)?/g, function (match, chr) {
        return chr ? chr.toUpperCase() : "";
      });
    };
    function dasherize(str) {
      return str.replace(/::/g, "/").replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2").replace(/([a-z\d])([A-Z])/g, "$1_$2").replace(/_/g, "-").toLowerCase();
    }
    uniq = function (array) {
      return filter.call(array, function (item, idx) {
        return array.indexOf(item) == idx;
      });
    };
    function classRE(name) {
      return name in classCache ? classCache[name] : classCache[name] = new RegExp("(^|\\s)" + name + "(\\s|$)");
    }
    function maybeAddPx(name, value) {
      return typeof value == "number" && !cssNumber[dasherize(name)] ? value + "px" : value;
    }
    function defaultDisplay(nodeName) {
      var element, display;
      if (!elementDisplay[nodeName]) {
        element = document.createElement(nodeName);
        document.body.appendChild(element);
        display = getComputedStyle(element, "").getPropertyValue("display");
        element.parentNode.removeChild(element);
        display == "none" && (display = "block");
        elementDisplay[nodeName] = display;
      }
      return elementDisplay[nodeName];
    }
    function children(element) {
      return "children" in element ? slice.call(element.children) : $.map(element.childNodes, function (node) {
        if (node.nodeType == 1) return node;
      });
    }
    function Z(dom, selector) {
      var i,
        len = dom ? dom.length : 0;
      for (i = 0; i < len; i++) (this || _global)[i] = dom[i];
      (this || _global).length = len;
      (this || _global).selector = selector || "";
    }

    // `$.zepto.fragment` takes a html string and an optional tag name
    // to generate DOM nodes from the given html string.
    // The generated DOM nodes are returned as an array.
    // This function can be overridden in plugins for example to make
    // it compatible with browsers that don't support the DOM fully.
    zepto.fragment = function (html, name, properties) {
      var dom, nodes, container;

      // A special case optimization for a single tag
      if (singleTagRE.test(html)) dom = $(document.createElement(RegExp.$1));
      if (!dom) {
        if (html.replace) html = html.replace(tagExpanderRE, "<$1></$2>");
        if (name === undefined$1) name = fragmentRE.test(html) && RegExp.$1;
        if (!(name in containers)) name = "*";
        container = containers[name];
        container.innerHTML = "" + html;
        dom = $.each(slice.call(container.childNodes), function () {
          container.removeChild(this || _global);
        });
      }
      if (isPlainObject(properties)) {
        nodes = $(dom);
        $.each(properties, function (key, value) {
          if (methodAttributes.indexOf(key) > -1) nodes[key](value);else nodes.attr(key, value);
        });
      }
      return dom;
    };

    // `$.zepto.Z` swaps out the prototype of the given `dom` array
    // of nodes with `$.fn` and thus supplying all the Zepto functions
    // to the array. This method can be overridden in plugins.
    zepto.Z = function (dom, selector) {
      return new Z(dom, selector);
    };

    // `$.zepto.isZ` should return `true` if the given object is a Zepto
    // collection. This method can be overridden in plugins.
    zepto.isZ = function (object) {
      return object instanceof zepto.Z;
    };

    // `$.zepto.init` is Zepto's counterpart to jQuery's `$.fn.init` and
    // takes a CSS selector and an optional context (and handles various
    // special cases).
    // This method can be overridden in plugins.
    zepto.init = function (selector, context) {
      var dom;
      // If nothing given, return an empty Zepto collection
      if (!selector) return zepto.Z();
      // Optimize for string selectors
      else if (typeof selector == "string") {
        selector = selector.trim();
        // If it's a html fragment, create nodes from it
        // Note: In both Chrome 21 and Firefox 15, DOM error 12
        // is thrown if the fragment doesn't begin with <
        if (selector[0] == "<" && fragmentRE.test(selector)) dom = zepto.fragment(selector, RegExp.$1, context), selector = null;
        // If there's a context, create a collection on that context first, and select
        // nodes from there
        else if (context !== undefined$1) return $(context).find(selector);
        // If it's a CSS selector, use it to select nodes.
        else dom = zepto.qsa(document, selector);
      }
      // If a function is given, call it when the DOM is ready
      else if (isFunction(selector)) return $(document).ready(selector);
      // If a Zepto collection is given, just return it
      else if (zepto.isZ(selector)) return selector;else {
        // normalize array if an array of nodes is given
        if (isArray(selector)) dom = compact(selector);
        // Wrap DOM nodes.
        else if (isObject(selector)) dom = [selector], selector = null;
        // If it's a html fragment, create nodes from it
        else if (fragmentRE.test(selector)) dom = zepto.fragment(selector.trim(), RegExp.$1, context), selector = null;
        // If there's a context, create a collection on that context first, and select
        // nodes from there
        else if (context !== undefined$1) return $(context).find(selector);
        // And last but no least, if it's a CSS selector, use it to select nodes.
        else dom = zepto.qsa(document, selector);
      }
      // create a new Zepto collection from the nodes found
      return zepto.Z(dom, selector);
    };

    // `$` will be the base `Zepto` object. When calling this
    // function just call `$.zepto.init, which makes the implementation
    // details of selecting nodes and creating Zepto collections
    // patchable in plugins.
    $ = function (selector, context) {
      return zepto.init(selector, context);
    };
    function extend(target, source, deep) {
      for (key in source) if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
        if (isPlainObject(source[key]) && !isPlainObject(target[key])) target[key] = {};
        if (isArray(source[key]) && !isArray(target[key])) target[key] = [];
        extend(target[key], source[key], deep);
      } else if (source[key] !== undefined$1) target[key] = source[key];
    }

    // Copy all but undefined properties from one or more
    // objects to the `target` object.
    $.extend = function (target) {
      var deep,
        args = slice.call(arguments, 1);
      if (typeof target == "boolean") {
        deep = target;
        target = args.shift();
      }
      args.forEach(function (arg) {
        extend(target, arg, deep);
      });
      return target;
    };

    // `$.zepto.qsa` is Zepto's CSS selector implementation which
    // uses `document.querySelectorAll` and optimizes for some special cases, like `#id`.
    // This method can be overridden in plugins.
    zepto.qsa = function (element, selector) {
      var found,
        maybeID = selector[0] == "#",
        maybeClass = !maybeID && selector[0] == ".",
        nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
        // Ensure that a 1 char tag name still gets checked
        isSimple = simpleSelectorRE.test(nameOnly);
      return element.getElementById && isSimple && maybeID ?
      // Safari DocumentFragment doesn't have getElementById
      (found = element.getElementById(nameOnly)) ? [found] : [] : element.nodeType !== 1 && element.nodeType !== 9 && element.nodeType !== 11 ? [] : slice.call(isSimple && !maybeID && element.getElementsByClassName ?
      // DocumentFragment doesn't have getElementsByClassName/TagName
      maybeClass ? element.getElementsByClassName(nameOnly) :
      // If it's simple, it could be a class
      element.getElementsByTagName(selector) :
      // Or a tag
      element.querySelectorAll(selector) // Or it's not simple, and we need to query all
      );
    };

    function filtered(nodes, selector) {
      return selector == null ? $(nodes) : $(nodes).filter(selector);
    }
    $.contains = document.documentElement.contains ? function (parent, node) {
      return parent !== node && parent.contains(node);
    } : function (parent, node) {
      while (node && (node = node.parentNode)) if (node === parent) return true;
      return false;
    };
    function funcArg(context, arg, idx, payload) {
      return isFunction(arg) ? arg.call(context, idx, payload) : arg;
    }
    function setAttribute(node, name, value) {
      value == null ? node.removeAttribute(name) : node.setAttribute(name, value);
    }

    // access className property while respecting SVGAnimatedString
    function className(node, value) {
      var klass = node.className || "",
        svg = klass && klass.baseVal !== undefined$1;
      if (value === undefined$1) return svg ? klass.baseVal : klass;
      svg ? klass.baseVal = value : node.className = value;
    }

    // "true"  => true
    // "false" => false
    // "null"  => null
    // "42"    => 42
    // "42.5"  => 42.5
    // "08"    => "08"
    // JSON    => parse if valid
    // String  => self
    function deserializeValue(value) {
      try {
        return value ? value == "true" || (value == "false" ? false : value == "null" ? null : +value + "" == value ? +value : /^[\[\{]/.test(value) ? $.parseJSON(value) : value) : value;
      } catch (e) {
        return value;
      }
    }
    $.type = type;
    $.isFunction = isFunction;
    $.isWindow = isWindow;
    $.isArray = isArray;
    $.isPlainObject = isPlainObject;
    $.isEmptyObject = function (obj) {
      var name;
      for (name in obj) return false;
      return true;
    };
    $.isNumeric = function (val) {
      var num = Number(val),
        type = typeof val;
      return val != null && type != "boolean" && (type != "string" || val.length) && !isNaN(num) && isFinite(num) || false;
    };
    $.inArray = function (elem, array, i) {
      return emptyArray.indexOf.call(array, elem, i);
    };
    $.camelCase = camelize;
    $.trim = function (str) {
      return str == null ? "" : String.prototype.trim.call(str);
    };

    // plugin compatibility
    $.uuid = 0;
    $.support = {};
    $.expr = {};
    $.noop = function () {};
    $.map = function (elements, callback) {
      var value,
        values = [],
        i,
        key;
      if (likeArray(elements)) for (i = 0; i < elements.length; i++) {
        value = callback(elements[i], i);
        if (value != null) values.push(value);
      } else for (key in elements) {
        value = callback(elements[key], key);
        if (value != null) values.push(value);
      }
      return flatten(values);
    };
    $.each = function (elements, callback) {
      var i, key;
      if (likeArray(elements)) {
        for (i = 0; i < elements.length; i++) if (callback.call(elements[i], i, elements[i]) === false) return elements;
      } else {
        for (key in elements) if (callback.call(elements[key], key, elements[key]) === false) return elements;
      }
      return elements;
    };
    $.grep = function (elements, callback) {
      return filter.call(elements, callback);
    };
    if (window.JSON) $.parseJSON = JSON.parse;

    // Populate the class2type map
    $.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (i, name) {
      class2type["[object " + name + "]"] = name.toLowerCase();
    });

    // Define methods that will be available on all
    // Zepto collections
    $.fn = {
      constructor: zepto.Z,
      length: 0,
      // Because a collection acts like an array
      // copy over these useful array functions.
      forEach: emptyArray.forEach,
      reduce: emptyArray.reduce,
      push: emptyArray.push,
      sort: emptyArray.sort,
      splice: emptyArray.splice,
      indexOf: emptyArray.indexOf,
      concat: function () {
        var i,
          value,
          args = [];
        for (i = 0; i < arguments.length; i++) {
          value = arguments[i];
          args[i] = zepto.isZ(value) ? value.toArray() : value;
        }
        return concat.apply(zepto.isZ(this || _global) ? this.toArray() : this || _global, args);
      },
      // `map` and `slice` in the jQuery API work differently
      // from their array counterparts
      map: function (fn) {
        return $($.map(this || _global, function (el, i) {
          return fn.call(el, i, el);
        }));
      },
      slice: function () {
        return $(slice.apply(this || _global, arguments));
      },
      ready: function (callback) {
        // need to check if document.body exists for IE as that browser reports
        // document ready when it hasn't yet created the body element
        if (readyRE.test(document.readyState) && document.body) callback($);else document.addEventListener("DOMContentLoaded", function () {
          callback($);
        }, false);
        return this || _global;
      },
      get: function (idx) {
        return idx === undefined$1 ? slice.call(this || _global) : (this || _global)[idx >= 0 ? idx : idx + (this || _global).length];
      },
      toArray: function () {
        return this.get();
      },
      size: function () {
        return (this || _global).length;
      },
      remove: function () {
        return this.each(function () {
          if ((this || _global).parentNode != null) (this || _global).parentNode.removeChild(this || _global);
        });
      },
      each: function (callback) {
        emptyArray.every.call(this || _global, function (el, idx) {
          return callback.call(el, idx, el) !== false;
        });
        return this || _global;
      },
      filter: function (selector) {
        if (isFunction(selector)) return this.not(this.not(selector));
        return $(filter.call(this || _global, function (element) {
          return zepto.matches(element, selector);
        }));
      },
      add: function (selector, context) {
        return $(uniq(this.concat($(selector, context))));
      },
      is: function (selector) {
        return (this || _global).length > 0 && zepto.matches((this || _global)[0], selector);
      },
      not: function (selector) {
        var nodes = [];
        if (isFunction(selector) && selector.call !== undefined$1) this.each(function (idx) {
          if (!selector.call(this || _global, idx)) nodes.push(this || _global);
        });else {
          var excludes = typeof selector == "string" ? this.filter(selector) : likeArray(selector) && isFunction(selector.item) ? slice.call(selector) : $(selector);
          this.forEach(function (el) {
            if (excludes.indexOf(el) < 0) nodes.push(el);
          });
        }
        return $(nodes);
      },
      has: function (selector) {
        return this.filter(function () {
          return isObject(selector) ? $.contains(this || _global, selector) : $(this || _global).find(selector).size();
        });
      },
      eq: function (idx) {
        return idx === -1 ? this.slice(idx) : this.slice(idx, +idx + 1);
      },
      first: function () {
        var el = (this || _global)[0];
        return el && !isObject(el) ? el : $(el);
      },
      last: function () {
        var el = (this || _global)[(this || _global).length - 1];
        return el && !isObject(el) ? el : $(el);
      },
      find: function (selector) {
        var result,
          $this = this || _global;
        if (!selector) result = $();else if (typeof selector == "object") result = $(selector).filter(function () {
          var node = this || _global;
          return emptyArray.some.call($this, function (parent) {
            return $.contains(parent, node);
          });
        });else if ((this || _global).length == 1) result = $(zepto.qsa((this || _global)[0], selector));else result = this.map(function () {
          return zepto.qsa(this || _global, selector);
        });
        return result;
      },
      closest: function (selector, context) {
        var nodes = [],
          collection = typeof selector == "object" && $(selector);
        this.each(function (_, node) {
          while (node && !(collection ? collection.indexOf(node) >= 0 : zepto.matches(node, selector))) node = node !== context && !isDocument(node) && node.parentNode;
          if (node && nodes.indexOf(node) < 0) nodes.push(node);
        });
        return $(nodes);
      },
      parents: function (selector) {
        var ancestors = [],
          nodes = this || _global;
        while (nodes.length > 0) nodes = $.map(nodes, function (node) {
          if ((node = node.parentNode) && !isDocument(node) && ancestors.indexOf(node) < 0) {
            ancestors.push(node);
            return node;
          }
        });
        return filtered(ancestors, selector);
      },
      parent: function (selector) {
        return filtered(uniq(this.pluck("parentNode")), selector);
      },
      children: function (selector) {
        return filtered(this.map(function () {
          return children(this || _global);
        }), selector);
      },
      contents: function () {
        return this.map(function () {
          return (this || _global).contentDocument || slice.call((this || _global).childNodes);
        });
      },
      siblings: function (selector) {
        return filtered(this.map(function (i, el) {
          return filter.call(children(el.parentNode), function (child) {
            return child !== el;
          });
        }), selector);
      },
      empty: function () {
        return this.each(function () {
          (this || _global).innerHTML = "";
        });
      },
      // `pluck` is borrowed from Prototype.js
      pluck: function (property) {
        return $.map(this || _global, function (el) {
          return el[property];
        });
      },
      show: function () {
        return this.each(function () {
          (this || _global).style.display == "none" && ((this || _global).style.display = "");
          if (getComputedStyle(this || _global, "").getPropertyValue("display") == "none") (this || _global).style.display = defaultDisplay((this || _global).nodeName);
        });
      },
      replaceWith: function (newContent) {
        return this.before(newContent).remove();
      },
      wrap: function (structure) {
        var func = isFunction(structure);
        if ((this || _global)[0] && !func) var dom = $(structure).get(0),
          clone = dom.parentNode || (this || _global).length > 1;
        return this.each(function (index) {
          $(this || _global).wrapAll(func ? structure.call(this || _global, index) : clone ? dom.cloneNode(true) : dom);
        });
      },
      wrapAll: function (structure) {
        if ((this || _global)[0]) {
          $((this || _global)[0]).before(structure = $(structure));
          var children;
          // drill down to the inmost element
          while ((children = structure.children()).length) structure = children.first();
          $(structure).append(this || _global);
        }
        return this || _global;
      },
      wrapInner: function (structure) {
        var func = isFunction(structure);
        return this.each(function (index) {
          var self = $(this || _global),
            contents = self.contents(),
            dom = func ? structure.call(this || _global, index) : structure;
          contents.length ? contents.wrapAll(dom) : self.append(dom);
        });
      },
      unwrap: function () {
        this.parent().each(function () {
          $(this || _global).replaceWith($(this || _global).children());
        });
        return this || _global;
      },
      clone: function () {
        return this.map(function () {
          return this.cloneNode(true);
        });
      },
      hide: function () {
        return this.css("display", "none");
      },
      toggle: function (setting) {
        return this.each(function () {
          var el = $(this || _global);
          (setting === undefined$1 ? el.css("display") == "none" : setting) ? el.show() : el.hide();
        });
      },
      prev: function (selector) {
        return $(this.pluck("previousElementSibling")).filter(selector || "*");
      },
      next: function (selector) {
        return $(this.pluck("nextElementSibling")).filter(selector || "*");
      },
      html: function (html) {
        return 0 in arguments ? this.each(function (idx) {
          var originHtml = (this || _global).innerHTML;
          $(this || _global).empty().append(funcArg(this || _global, html, idx, originHtml));
        }) : 0 in (this || _global) ? (this || _global)[0].innerHTML : null;
      },
      text: function (text) {
        return 0 in arguments ? this.each(function (idx) {
          var newText = funcArg(this || _global, text, idx, (this || _global).textContent);
          (this || _global).textContent = newText == null ? "" : "" + newText;
        }) : 0 in (this || _global) ? this.pluck("textContent").join("") : null;
      },
      attr: function (name, value) {
        var result;
        return typeof name == "string" && !(1 in arguments) ? 0 in (this || _global) && (this || _global)[0].nodeType == 1 && (result = (this || _global)[0].getAttribute(name)) != null ? result : undefined$1 : this.each(function (idx) {
          if ((this || _global).nodeType !== 1) return;
          if (isObject(name)) for (key in name) setAttribute(this || _global, key, name[key]);else setAttribute(this || _global, name, funcArg(this || _global, value, idx, this.getAttribute(name)));
        });
      },
      removeAttr: function (name) {
        return this.each(function () {
          (this || _global).nodeType === 1 && name.split(" ").forEach(function (attribute) {
            setAttribute(this || _global, attribute);
          }, this || _global);
        });
      },
      prop: function (name, value) {
        name = propMap[name] || name;
        return 1 in arguments ? this.each(function (idx) {
          (this || _global)[name] = funcArg(this || _global, value, idx, (this || _global)[name]);
        }) : (this || _global)[0] && (this || _global)[0][name];
      },
      removeProp: function (name) {
        name = propMap[name] || name;
        return this.each(function () {
          delete (this || _global)[name];
        });
      },
      data: function (name, value) {
        var attrName = "data-" + name.replace(capitalRE, "-$1").toLowerCase();
        var data = 1 in arguments ? this.attr(attrName, value) : this.attr(attrName);
        return data !== null ? deserializeValue(data) : undefined$1;
      },
      val: function (value) {
        if (0 in arguments) {
          if (value == null) value = "";
          return this.each(function (idx) {
            (this || _global).value = funcArg(this || _global, value, idx, (this || _global).value);
          });
        } else {
          return (this || _global)[0] && ((this || _global)[0].multiple ? $((this || _global)[0]).find("option").filter(function () {
            return (this || _global).selected;
          }).pluck("value") : (this || _global)[0].value);
        }
      },
      offset: function (coordinates) {
        if (coordinates) return this.each(function (index) {
          var $this = $(this || _global),
            coords = funcArg(this || _global, coordinates, index, $this.offset()),
            parentOffset = $this.offsetParent().offset(),
            props = {
              top: coords.top - parentOffset.top,
              left: coords.left - parentOffset.left
            };
          if ($this.css("position") == "static") props["position"] = "relative";
          $this.css(props);
        });
        if (!(this || _global).length) return null;
        if (document.documentElement !== (this || _global)[0] && !$.contains(document.documentElement, (this || _global)[0])) return {
          top: 0,
          left: 0
        };
        var obj = (this || _global)[0].getBoundingClientRect();
        return {
          left: obj.left + window.pageXOffset,
          top: obj.top + window.pageYOffset,
          width: Math.round(obj.width),
          height: Math.round(obj.height)
        };
      },
      css: function (property, value) {
        if (arguments.length < 2) {
          var element = (this || _global)[0];
          if (typeof property == "string") {
            if (!element) return;
            return element.style[camelize(property)] || getComputedStyle(element, "").getPropertyValue(property);
          } else if (isArray(property)) {
            if (!element) return;
            var props = {};
            var computedStyle = getComputedStyle(element, "");
            $.each(property, function (_, prop) {
              props[prop] = element.style[camelize(prop)] || computedStyle.getPropertyValue(prop);
            });
            return props;
          }
        }
        var css = "";
        if (type(property) == "string") {
          if (!value && value !== 0) this.each(function () {
            (this || _global).style.removeProperty(dasherize(property));
          });else css = dasherize(property) + ":" + maybeAddPx(property, value);
        } else {
          for (key in property) if (!property[key] && property[key] !== 0) this.each(function () {
            (this || _global).style.removeProperty(dasherize(key));
          });else css += dasherize(key) + ":" + maybeAddPx(key, property[key]) + ";";
        }
        return this.each(function () {
          (this || _global).style.cssText += ";" + css;
        });
      },
      index: function (element) {
        return element ? this.indexOf($(element)[0]) : this.parent().children().indexOf((this || _global)[0]);
      },
      hasClass: function (name) {
        if (!name) return false;
        return emptyArray.some.call(this || _global, function (el) {
          return this.test(className(el));
        }, classRE(name));
      },
      addClass: function (name) {
        if (!name) return this || _global;
        return this.each(function (idx) {
          if (!("className" in (this || _global))) return;
          classList = [];
          var cls = className(this || _global),
            newName = funcArg(this || _global, name, idx, cls);
          newName.split(/\s+/g).forEach(function (klass) {
            if (!$(this || _global).hasClass(klass)) classList.push(klass);
          }, this || _global);
          classList.length && className(this || _global, cls + (cls ? " " : "") + classList.join(" "));
        });
      },
      removeClass: function (name) {
        return this.each(function (idx) {
          if (!("className" in (this || _global))) return;
          if (name === undefined$1) return className(this || _global, "");
          classList = className(this || _global);
          funcArg(this || _global, name, idx, classList).split(/\s+/g).forEach(function (klass) {
            classList = classList.replace(classRE(klass), " ");
          });
          className(this || _global, classList.trim());
        });
      },
      toggleClass: function (name, when) {
        if (!name) return this || _global;
        return this.each(function (idx) {
          var $this = $(this || _global),
            names = funcArg(this || _global, name, idx, className(this || _global));
          names.split(/\s+/g).forEach(function (klass) {
            (when === undefined$1 ? !$this.hasClass(klass) : when) ? $this.addClass(klass) : $this.removeClass(klass);
          });
        });
      },
      scrollTop: function (value) {
        if (!(this || _global).length) return;
        var hasScrollTop = ("scrollTop" in (this || _global)[0]);
        if (value === undefined$1) return hasScrollTop ? (this || _global)[0].scrollTop : (this || _global)[0].pageYOffset;
        return this.each(hasScrollTop ? function () {
          (this || _global).scrollTop = value;
        } : function () {
          this.scrollTo((this || _global).scrollX, value);
        });
      },
      scrollLeft: function (value) {
        if (!(this || _global).length) return;
        var hasScrollLeft = ("scrollLeft" in (this || _global)[0]);
        if (value === undefined$1) return hasScrollLeft ? (this || _global)[0].scrollLeft : (this || _global)[0].pageXOffset;
        return this.each(hasScrollLeft ? function () {
          (this || _global).scrollLeft = value;
        } : function () {
          this.scrollTo(value, (this || _global).scrollY);
        });
      },
      position: function () {
        if (!(this || _global).length) return;
        var elem = (this || _global)[0],
          // Get *real* offsetParent
          offsetParent = this.offsetParent(),
          // Get correct offsets
          offset = this.offset(),
          parentOffset = rootNodeRE.test(offsetParent[0].nodeName) ? {
            top: 0,
            left: 0
          } : offsetParent.offset();

        // Subtract element margins
        // note: when an element has margin: auto the offsetLeft and marginLeft
        // are the same in Safari causing offset.left to incorrectly be 0
        offset.top -= parseFloat($(elem).css("margin-top")) || 0;
        offset.left -= parseFloat($(elem).css("margin-left")) || 0;

        // Add offsetParent borders
        parentOffset.top += parseFloat($(offsetParent[0]).css("border-top-width")) || 0;
        parentOffset.left += parseFloat($(offsetParent[0]).css("border-left-width")) || 0;

        // Subtract the two offsets
        return {
          top: offset.top - parentOffset.top,
          left: offset.left - parentOffset.left
        };
      },
      offsetParent: function () {
        return this.map(function () {
          var parent = (this || _global).offsetParent || document.body;
          while (parent && !rootNodeRE.test(parent.nodeName) && $(parent).css("position") == "static") parent = parent.offsetParent;
          return parent;
        });
      }
    };

    // for now
    $.fn.detach = $.fn.remove

    // Generate the `width` and `height` functions
    ;

    ["width", "height"].forEach(function (dimension) {
      var dimensionProperty = dimension.replace(/./, function (m) {
        return m[0].toUpperCase();
      });
      $.fn[dimension] = function (value) {
        var offset,
          el = (this || _global)[0];
        if (value === undefined$1) return isWindow(el) ? el["inner" + dimensionProperty] : isDocument(el) ? el.documentElement["scroll" + dimensionProperty] : (offset = this.offset()) && offset[dimension];else return this.each(function (idx) {
          el = $(this || _global);
          el.css(dimension, funcArg(this || _global, value, idx, el[dimension]()));
        });
      };
    });
    function traverseNode(node, fun) {
      fun(node);
      for (var i = 0, len = node.childNodes.length; i < len; i++) traverseNode(node.childNodes[i], fun);
    }

    // Generate the `after`, `prepend`, `before`, `append`,
    // `insertAfter`, `insertBefore`, `appendTo`, and `prependTo` methods.
    adjacencyOperators.forEach(function (operator, operatorIndex) {
      var inside = operatorIndex % 2; //=> prepend, append

      $.fn[operator] = function () {
        // arguments can be nodes, arrays of nodes, Zepto objects and HTML strings
        var argType,
          nodes = $.map(arguments, function (arg) {
            var arr = [];
            argType = type(arg);
            if (argType == "array") {
              arg.forEach(function (el) {
                if (el.nodeType !== undefined$1) return arr.push(el);else if ($.zepto.isZ(el)) return arr = arr.concat(el.get());
                arr = arr.concat(zepto.fragment(el));
              });
              return arr;
            }
            return argType == "object" || arg == null ? arg : zepto.fragment(arg);
          }),
          parent,
          copyByClone = (this || _global).length > 1;
        if (nodes.length < 1) return this || _global;
        return this.each(function (_, target) {
          parent = inside ? target : target.parentNode;

          // convert all methods to a "before" operation
          target = operatorIndex == 0 ? target.nextSibling : operatorIndex == 1 ? target.firstChild : operatorIndex == 2 ? target : null;
          var parentInDocument = $.contains(document.documentElement, parent);
          nodes.forEach(function (node) {
            if (copyByClone) node = node.cloneNode(true);else if (!parent) return $(node).remove();
            parent.insertBefore(node, target);
            if (parentInDocument) traverseNode(node, function (el) {
              if (el.nodeName != null && el.nodeName.toUpperCase() === "SCRIPT" && (!el.type || el.type === "text/javascript") && !el.src) {
                var target = el.ownerDocument ? el.ownerDocument.defaultView : window;
                target["eval"].call(target, el.innerHTML);
              }
            });
          });
        });
      };

      // after    => insertAfter
      // prepend  => prependTo
      // before   => insertBefore
      // append   => appendTo
      $.fn[inside ? operator + "To" : "insert" + (operatorIndex ? "Before" : "After")] = function (html) {
        $(html)[operator](this || _global);
        return this || _global;
      };
    });
    zepto.Z.prototype = Z.prototype = $.fn;

    // Export internal API functions in the `$.zepto` namespace
    zepto.uniq = uniq;
    zepto.deserializeValue = deserializeValue;
    $.zepto = zepto;
    return $;
  }();
  window.Zepto = Zepto;
  window.$ === undefined && (window.$ = Zepto);
  (function ($) {
    var jsonpID = +new Date(),
      document = window.document,
      key,
      name,
      rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
      scriptTypeRE = /^(?:text|application)\/javascript/i,
      xmlTypeRE = /^(?:text|application)\/xml/i,
      jsonType = "application/json",
      htmlType = "text/html",
      blankRE = /^\s*$/,
      originAnchor = document.createElement("a");
    originAnchor.href = window.location.href;

    // trigger a custom event and return false if it was cancelled
    function triggerAndReturn(context, eventName, data) {
      var event = $.Event(eventName);
      $(context).trigger(event, data);
      return !event.isDefaultPrevented();
    }

    // trigger an Ajax "global" event
    function triggerGlobal(settings, context, eventName, data) {
      if (settings.global) return triggerAndReturn(context || document, eventName, data);
    }

    // Number of active Ajax requests
    $.active = 0;
    function ajaxStart(settings) {
      if (settings.global && $.active++ === 0) triggerGlobal(settings, null, "ajaxStart");
    }
    function ajaxStop(settings) {
      if (settings.global && ! --$.active) triggerGlobal(settings, null, "ajaxStop");
    }

    // triggers an extra global event "ajaxBeforeSend" that's like "ajaxSend" but cancelable
    function ajaxBeforeSend(xhr, settings) {
      var context = settings.context;
      if (settings.beforeSend.call(context, xhr, settings) === false || triggerGlobal(settings, context, "ajaxBeforeSend", [xhr, settings]) === false) return false;
      triggerGlobal(settings, context, "ajaxSend", [xhr, settings]);
    }
    function ajaxSuccess(data, xhr, settings, deferred) {
      var context = settings.context,
        status = "success";
      settings.success.call(context, data, status, xhr);
      if (deferred) deferred.resolveWith(context, [data, status, xhr]);
      triggerGlobal(settings, context, "ajaxSuccess", [xhr, settings, data]);
      ajaxComplete(status, xhr, settings);
    }
    // type: "timeout", "error", "abort", "parsererror"
    function ajaxError(error, type, xhr, settings, deferred) {
      var context = settings.context;
      settings.error.call(context, xhr, type, error);
      if (deferred) deferred.rejectWith(context, [xhr, type, error]);
      triggerGlobal(settings, context, "ajaxError", [xhr, settings, error || type]);
      ajaxComplete(type, xhr, settings);
    }
    // status: "success", "notmodified", "error", "timeout", "abort", "parsererror"
    function ajaxComplete(status, xhr, settings) {
      var context = settings.context;
      settings.complete.call(context, xhr, status);
      triggerGlobal(settings, context, "ajaxComplete", [xhr, settings]);
      ajaxStop(settings);
    }
    function ajaxDataFilter(data, type, settings) {
      if (settings.dataFilter == empty) return data;
      var context = settings.context;
      return settings.dataFilter.call(context, data, type);
    }

    // Empty function, used as default callback
    function empty() {}
    $.ajaxJSONP = function (options, deferred) {
      if (!("type" in options)) return $.ajax(options);
      var _callbackName = options.jsonpCallback,
        callbackName = ($.isFunction(_callbackName) ? _callbackName() : _callbackName) || "Zepto" + jsonpID++,
        script = document.createElement("script"),
        originalCallback = window[callbackName],
        responseData,
        abort = function (errorType) {
          $(script).triggerHandler("error", errorType || "abort");
        },
        xhr = {
          abort: abort
        },
        abortTimeout;
      if (deferred) deferred.promise(xhr);
      $(script).on("load error", function (e, errorType) {
        clearTimeout(abortTimeout);
        $(script).off().remove();
        if (e.type == "error" || !responseData) {
          ajaxError(null, errorType || "error", xhr, options, deferred);
        } else {
          ajaxSuccess(responseData[0], xhr, options, deferred);
        }
        window[callbackName] = originalCallback;
        if (responseData && $.isFunction(originalCallback)) originalCallback(responseData[0]);
        originalCallback = responseData = undefined;
      });
      if (ajaxBeforeSend(xhr, options) === false) {
        abort("abort");
        return xhr;
      }
      window[callbackName] = function () {
        responseData = arguments;
      };
      script.src = options.url.replace(/\?(.+)=\?/, "?$1=" + callbackName);
      document.head.appendChild(script);
      if (options.timeout > 0) abortTimeout = setTimeout(function () {
        abort("timeout");
      }, options.timeout);
      return xhr;
    };
    $.ajaxSettings = {
      // Default type of request
      type: "GET",
      // Callback that is executed before request
      beforeSend: empty,
      // Callback that is executed if the request succeeds
      success: empty,
      // Callback that is executed the the server drops error
      error: empty,
      // Callback that is executed on request complete (both: error and success)
      complete: empty,
      // The context for the callbacks
      context: null,
      // Whether to trigger "global" Ajax events
      global: true,
      // Transport
      xhr: function () {
        return new window.XMLHttpRequest();
      },
      // MIME types mapping
      // IIS returns Javascript as "application/x-javascript"
      accepts: {
        script: "text/javascript, application/javascript, application/x-javascript",
        json: jsonType,
        xml: "application/xml, text/xml",
        html: htmlType,
        text: "text/plain"
      },
      // Whether the request is to another domain
      crossDomain: false,
      // Default timeout
      timeout: 0,
      // Whether data should be serialized to string
      processData: true,
      // Whether the browser should be allowed to cache GET responses
      cache: true,
      //Used to handle the raw response data of XMLHttpRequest.
      //This is a pre-filtering function to sanitize the response.
      //The sanitized response should be returned
      dataFilter: empty
    };
    function mimeToDataType(mime) {
      if (mime) mime = mime.split(";", 2)[0];
      return mime && (mime == htmlType ? "html" : mime == jsonType ? "json" : scriptTypeRE.test(mime) ? "script" : xmlTypeRE.test(mime) && "xml") || "text";
    }
    function appendQuery(url, query) {
      if (query == "") return url;
      return (url + "&" + query).replace(/[&?]{1,2}/, "?");
    }

    // serialize payload and append it to the URL for GET requests
    function serializeData(options) {
      if (options.processData && options.data && $.type(options.data) != "string") options.data = $.param(options.data, options.traditional);
      if (options.data && (!options.type || options.type.toUpperCase() == "GET" || "jsonp" == options.dataType)) options.url = appendQuery(options.url, options.data), options.data = undefined;
    }
    $.ajax = function (options) {
      var settings = $.extend({}, options || {}),
        deferred = $.Deferred && $.Deferred(),
        urlAnchor,
        hashIndex;
      for (key in $.ajaxSettings) if (settings[key] === undefined) settings[key] = $.ajaxSettings[key];
      ajaxStart(settings);
      if (!settings.crossDomain) {
        urlAnchor = document.createElement("a");
        urlAnchor.href = settings.url;
        // cleans up URL for .href (IE only), see https://github.com/madrobby/zepto/pull/1049
        urlAnchor.href = urlAnchor.href;
        settings.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
      }
      if (!settings.url) settings.url = window.location.toString();
      if ((hashIndex = settings.url.indexOf("#")) > -1) settings.url = settings.url.slice(0, hashIndex);
      serializeData(settings);
      var dataType = settings.dataType,
        hasPlaceholder = /\?.+=\?/.test(settings.url);
      if (hasPlaceholder) dataType = "jsonp";
      if (settings.cache === false || (!options || options.cache !== true) && ("script" == dataType || "jsonp" == dataType)) settings.url = appendQuery(settings.url, "_=" + Date.now());
      if ("jsonp" == dataType) {
        if (!hasPlaceholder) settings.url = appendQuery(settings.url, settings.jsonp ? settings.jsonp + "=?" : settings.jsonp === false ? "" : "callback=?");
        return $.ajaxJSONP(settings, deferred);
      }
      var mime = settings.accepts[dataType],
        headers = {},
        setHeader = function (name, value) {
          headers[name.toLowerCase()] = [name, value];
        },
        protocol = /^([\w-]+:)\/\//.test(settings.url) ? RegExp.$1 : window.location.protocol,
        xhr = settings.xhr(),
        nativeSetHeader = xhr.setRequestHeader,
        abortTimeout;
      if (deferred) deferred.promise(xhr);
      if (!settings.crossDomain) setHeader("X-Requested-With", "XMLHttpRequest");
      setHeader("Accept", mime || "*/*");
      if (mime = settings.mimeType || mime) {
        if (mime.indexOf(",") > -1) mime = mime.split(",", 2)[0];
        xhr.overrideMimeType && xhr.overrideMimeType(mime);
      }
      if (settings.contentType || settings.contentType !== false && settings.data && settings.type.toUpperCase() != "GET") setHeader("Content-Type", settings.contentType || "application/x-www-form-urlencoded");
      if (settings.headers) for (name in settings.headers) setHeader(name, settings.headers[name]);
      xhr.setRequestHeader = setHeader;
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          xhr.onreadystatechange = empty;
          clearTimeout(abortTimeout);
          var result,
            error = false;
          if (xhr.status >= 200 && xhr.status < 300 || xhr.status == 304 || xhr.status == 0 && protocol == "file:") {
            dataType = dataType || mimeToDataType(settings.mimeType || xhr.getResponseHeader("content-type"));
            if (xhr.responseType == "arraybuffer" || xhr.responseType == "blob") result = xhr.response;else {
              result = xhr.responseText;
              try {
                // http://perfectionkills.com/global-eval-what-are-the-options/
                // sanitize response accordingly if data filter callback provided
                result = ajaxDataFilter(result, dataType, settings);
                if (dataType == "script") (1, eval)(result);else if (dataType == "xml") result = xhr.responseXML;else if (dataType == "json") result = blankRE.test(result) ? null : $.parseJSON(result);
              } catch (e) {
                error = e;
              }
              if (error) return ajaxError(error, "parsererror", xhr, settings, deferred);
            }
            ajaxSuccess(result, xhr, settings, deferred);
          } else {
            ajaxError(xhr.statusText || null, xhr.status ? "error" : "abort", xhr, settings, deferred);
          }
        }
      };
      if (ajaxBeforeSend(xhr, settings) === false) {
        xhr.abort();
        ajaxError(null, "abort", xhr, settings, deferred);
        return xhr;
      }
      var async = "async" in settings ? settings.async : true;
      xhr.open(settings.type, settings.url, async, settings.username, settings.password);
      if (settings.xhrFields) for (name in settings.xhrFields) xhr[name] = settings.xhrFields[name];
      for (name in headers) nativeSetHeader.apply(xhr, headers[name]);
      if (settings.timeout > 0) abortTimeout = setTimeout(function () {
        xhr.onreadystatechange = empty;
        xhr.abort();
        ajaxError(null, "timeout", xhr, settings, deferred);
      }, settings.timeout);

      // avoid sending empty string (#319)
      xhr.send(settings.data ? settings.data : null);
      return xhr;
    };

    // handle optional data/success arguments
    function parseArguments(url, data, success, dataType) {
      if ($.isFunction(data)) dataType = success, success = data, data = undefined;
      if (!$.isFunction(success)) dataType = success, success = undefined;
      return {
        url: url,
        data: data,
        success: success,
        dataType: dataType
      };
    }
    $.get = function /* url, data, success, dataType */
    () {
      return $.ajax(parseArguments.apply(null, arguments));
    };
    $.post = function /* url, data, success, dataType */
    () {
      var options = parseArguments.apply(null, arguments);
      options.type = "POST";
      return $.ajax(options);
    };
    $.getJSON = function /* url, data, success */
    () {
      var options = parseArguments.apply(null, arguments);
      options.dataType = "json";
      return $.ajax(options);
    };
    $.fn.load = function (url, data, success) {
      if (!(this || _global).length) return this || _global;
      var self = this || _global,
        parts = url.split(/\s/),
        selector,
        options = parseArguments(url, data, success),
        callback = options.success;
      if (parts.length > 1) options.url = parts[0], selector = parts[1];
      options.success = function (response) {
        self.html(selector ? $("<div>").html(response.replace(rscript, "")).find(selector) : response);
        callback && callback.apply(self, arguments);
      };
      $.ajax(options);
      return this || _global;
    };
    var escape = encodeURIComponent;
    function serialize(params, obj, traditional, scope) {
      var type,
        array = $.isArray(obj),
        hash = $.isPlainObject(obj);
      $.each(obj, function (key, value) {
        type = $.type(value);
        if (scope) key = traditional ? scope : scope + "[" + (hash || type == "object" || type == "array" ? key : "") + "]";
        // handle data in serializeArray() format
        if (!scope && array) params.add(value.name, value.value);
        // recurse into nested objects
        else if (type == "array" || !traditional && type == "object") serialize(params, value, traditional, key);else params.add(key, value);
      });
    }
    $.param = function (obj, traditional) {
      var params = [];
      params.add = function (key, value) {
        if ($.isFunction(value)) value = value();
        if (value == null) value = "";
        this.push(escape(key) + "=" + escape(value));
      };
      serialize(params, obj, traditional);
      return params.join("&").replace(/%20/g, "+");
    };
  })(Zepto);
  (function ($) {
    // Create a collection of callbacks to be fired in a sequence, with configurable behaviour
    // Option flags:
    //   - once: Callbacks fired at most one time.
    //   - memory: Remember the most recent context and arguments
    //   - stopOnFalse: Cease iterating over callback list
    //   - unique: Permit adding at most one instance of the same callback
    $.Callbacks = function (options) {
      options = $.extend({}, options);
      var memory,
        // Last fire value (for non-forgettable lists)
        fired,
        // Flag to know if list was already fired
        firing,
        // Flag to know if list is currently firing
        firingStart,
        // First callback to fire (used internally by add and fireWith)
        firingLength,
        // End of the loop when firing
        firingIndex,
        // Index of currently firing callback (modified by remove if needed)
        list = [],
        // Actual callback list
        stack = !options.once && [],
        // Stack of fire calls for repeatable lists
        fire = function (data) {
          memory = options.memory && data;
          fired = true;
          firingIndex = firingStart || 0;
          firingStart = 0;
          firingLength = list.length;
          firing = true;
          for (; list && firingIndex < firingLength; ++firingIndex) {
            if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
              memory = false;
              break;
            }
          }
          firing = false;
          if (list) {
            if (stack) stack.length && fire(stack.shift());else if (memory) list.length = 0;else Callbacks.disable();
          }
        },
        Callbacks = {
          add: function () {
            if (list) {
              var start = list.length,
                add = function (args) {
                  $.each(args, function (_, arg) {
                    if (typeof arg === "function") {
                      if (!options.unique || !Callbacks.has(arg)) list.push(arg);
                    } else if (arg && arg.length && typeof arg !== "string") add(arg);
                  });
                };
              add(arguments);
              if (firing) firingLength = list.length;else if (memory) {
                firingStart = start;
                fire(memory);
              }
            }
            return this || _global;
          },
          remove: function () {
            if (list) {
              $.each(arguments, function (_, arg) {
                var index;
                while ((index = $.inArray(arg, list, index)) > -1) {
                  list.splice(index, 1);
                  // Handle firing indexes
                  if (firing) {
                    if (index <= firingLength) --firingLength;
                    if (index <= firingIndex) --firingIndex;
                  }
                }
              });
            }
            return this || _global;
          },
          has: function (fn) {
            return !!(list && (fn ? $.inArray(fn, list) > -1 : list.length));
          },
          empty: function () {
            firingLength = list.length = 0;
            return this || _global;
          },
          disable: function () {
            list = stack = memory = undefined;
            return this || _global;
          },
          disabled: function () {
            return !list;
          },
          lock: function () {
            stack = undefined;
            if (!memory) Callbacks.disable();
            return this || _global;
          },
          locked: function () {
            return !stack;
          },
          fireWith: function (context, args) {
            if (list && (!fired || stack)) {
              args = args || [];
              args = [context, args.slice ? args.slice() : args];
              if (firing) stack.push(args);else fire(args);
            }
            return this || _global;
          },
          fire: function () {
            return Callbacks.fireWith(this || _global, arguments);
          },
          fired: function () {
            return !!fired;
          }
        };
      return Callbacks;
    };
  })(Zepto);
  (function ($) {
    var slice = Array.prototype.slice;
    function Deferred(func) {
      var tuples = [
        // action, add listener, listener list, final state
        ["resolve", "done", $.Callbacks({
          once: 1,
          memory: 1
        }), "resolved"], ["reject", "fail", $.Callbacks({
          once: 1,
          memory: 1
        }), "rejected"], ["notify", "progress", $.Callbacks({
          memory: 1
        })]],
        state = "pending",
        promise = {
          state: function () {
            return state;
          },
          always: function () {
            deferred.done(arguments).fail(arguments);
            return this || _global;
          },
          then: function /* fnDone [, fnFailed [, fnProgress]] */
          () {
            var fns = arguments;
            return Deferred(function (defer) {
              $.each(tuples, function (i, tuple) {
                var fn = $.isFunction(fns[i]) && fns[i];
                deferred[tuple[1]](function () {
                  var returned = fn && fn.apply(this || _global, arguments);
                  if (returned && $.isFunction(returned.promise)) {
                    returned.promise().done(defer.resolve).fail(defer.reject).progress(defer.notify);
                  } else {
                    var context = (this || _global) === promise ? defer.promise() : this || _global,
                      values = fn ? [returned] : arguments;
                    defer[tuple[0] + "With"](context, values);
                  }
                });
              });
              fns = null;
            }).promise();
          },
          promise: function (obj) {
            return obj != null ? $.extend(obj, promise) : promise;
          }
        },
        deferred = {};
      $.each(tuples, function (i, tuple) {
        var list = tuple[2],
          stateString = tuple[3];
        promise[tuple[1]] = list.add;
        if (stateString) {
          list.add(function () {
            state = stateString;
          }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
        }
        deferred[tuple[0]] = function () {
          deferred[tuple[0] + "With"]((this || _global) === deferred ? promise : this || _global, arguments);
          return this || _global;
        };
        deferred[tuple[0] + "With"] = list.fireWith;
      });
      promise.promise(deferred);
      if (func) func.call(deferred, deferred);
      return deferred;
    }
    $.when = function (sub) {
      var resolveValues = slice.call(arguments),
        len = resolveValues.length,
        i = 0,
        remain = len !== 1 || sub && $.isFunction(sub.promise) ? len : 0,
        deferred = remain === 1 ? sub : Deferred(),
        progressValues,
        progressContexts,
        resolveContexts,
        updateFn = function (i, ctx, val) {
          return function (value) {
            ctx[i] = this || _global;
            val[i] = arguments.length > 1 ? slice.call(arguments) : value;
            if (val === progressValues) {
              deferred.notifyWith(ctx, val);
            } else if (! --remain) {
              deferred.resolveWith(ctx, val);
            }
          };
        };
      if (len > 1) {
        progressValues = new Array(len);
        progressContexts = new Array(len);
        resolveContexts = new Array(len);
        for (; i < len; ++i) {
          if (resolveValues[i] && $.isFunction(resolveValues[i].promise)) {
            resolveValues[i].promise().done(updateFn(i, resolveContexts, resolveValues)).fail(deferred.reject).progress(updateFn(i, progressContexts, progressValues));
          } else {
            --remain;
          }
        }
      }
      if (!remain) deferred.resolveWith(resolveContexts, resolveValues);
      return deferred.promise();
    };
    $.Deferred = Deferred;
  })(Zepto);
  (function ($) {
    var _zid = 1,
      undefined$1,
      slice = Array.prototype.slice,
      isFunction = $.isFunction,
      isString = function (obj) {
        return typeof obj == "string";
      },
      handlers = {},
      specialEvents = {},
      focusinSupported = ("onfocusin" in window),
      focus = {
        focus: "focusin",
        blur: "focusout"
      },
      hover = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
      };
    specialEvents.click = specialEvents.mousedown = specialEvents.mouseup = specialEvents.mousemove = "MouseEvents";
    function zid(element) {
      return element._zid || (element._zid = _zid++);
    }
    function findHandlers(element, event, fn, selector) {
      event = parse(event);
      if (event.ns) var matcher = matcherFor(event.ns);
      return (handlers[zid(element)] || []).filter(function (handler) {
        return handler && (!event.e || handler.e == event.e) && (!event.ns || matcher.test(handler.ns)) && (!fn || zid(handler.fn) === zid(fn)) && (!selector || handler.sel == selector);
      });
    }
    function parse(event) {
      var parts = ("" + event).split(".");
      return {
        e: parts[0],
        ns: parts.slice(1).sort().join(" ")
      };
    }
    function matcherFor(ns) {
      return new RegExp("(?:^| )" + ns.replace(" ", " .* ?") + "(?: |$)");
    }
    function eventCapture(handler, captureSetting) {
      return handler.del && !focusinSupported && handler.e in focus || !!captureSetting;
    }
    function realEvent(type) {
      return hover[type] || focusinSupported && focus[type] || type;
    }
    function add(element, events, fn, data, selector, delegator, capture) {
      var id = zid(element),
        set = handlers[id] || (handlers[id] = []);
      events.split(/\s/).forEach(function (event) {
        if (event == "ready") return $(document).ready(fn);
        var handler = parse(event);
        handler.fn = fn;
        handler.sel = selector;
        // emulate mouseenter, mouseleave
        if (handler.e in hover) fn = function (e) {
          var related = e.relatedTarget;
          if (!related || related !== (this || _global) && !$.contains(this || _global, related)) return handler.fn.apply(this || _global, arguments);
        };
        handler.del = delegator;
        var callback = delegator || fn;
        handler.proxy = function (e) {
          e = compatible(e);
          if (e.isImmediatePropagationStopped()) return;
          e.data = data;
          var result = callback.apply(element, e._args == undefined$1 ? [e] : [e].concat(e._args));
          if (result === false) e.preventDefault(), e.stopPropagation();
          return result;
        };
        handler.i = set.length;
        set.push(handler);
        if ("addEventListener" in element) element.addEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
      });
    }
    function remove(element, events, fn, selector, capture) {
      var id = zid(element);
      (events || "").split(/\s/).forEach(function (event) {
        findHandlers(element, event, fn, selector).forEach(function (handler) {
          delete handlers[id][handler.i];
          if ("removeEventListener" in element) element.removeEventListener(realEvent(handler.e), handler.proxy, eventCapture(handler, capture));
        });
      });
    }
    $.event = {
      add: add,
      remove: remove
    };
    $.proxy = function (fn, context) {
      var args = 2 in arguments && slice.call(arguments, 2);
      if (isFunction(fn)) {
        var proxyFn = function () {
          return fn.apply(context, args ? args.concat(slice.call(arguments)) : arguments);
        };
        proxyFn._zid = zid(fn);
        return proxyFn;
      } else if (isString(context)) {
        if (args) {
          args.unshift(fn[context], fn);
          return $.proxy.apply(null, args);
        } else {
          return $.proxy(fn[context], fn);
        }
      } else {
        throw new TypeError("expected function");
      }
    };
    $.fn.bind = function (event, data, callback) {
      return this.on(event, data, callback);
    };
    $.fn.unbind = function (event, callback) {
      return this.off(event, callback);
    };
    $.fn.one = function (event, selector, data, callback) {
      return this.on(event, selector, data, callback, 1);
    };
    var returnTrue = function () {
        return true;
      },
      returnFalse = function () {
        return false;
      },
      ignoreProperties = /^([A-Z]|returnValue$|layer[XY]$|webkitMovement[XY]$)/,
      eventMethods = {
        preventDefault: "isDefaultPrevented",
        stopImmediatePropagation: "isImmediatePropagationStopped",
        stopPropagation: "isPropagationStopped"
      };
    function compatible(event, source) {
      if (source || !event.isDefaultPrevented) {
        source || (source = event);
        $.each(eventMethods, function (name, predicate) {
          var sourceMethod = source[name];
          event[name] = function () {
            (this || _global)[predicate] = returnTrue;
            return sourceMethod && sourceMethod.apply(source, arguments);
          };
          event[predicate] = returnFalse;
        });
        event.timeStamp || (event.timeStamp = Date.now());
        if (source.defaultPrevented !== undefined$1 ? source.defaultPrevented : "returnValue" in source ? source.returnValue === false : source.getPreventDefault && source.getPreventDefault()) event.isDefaultPrevented = returnTrue;
      }
      return event;
    }
    function createProxy(event) {
      var key,
        proxy = {
          originalEvent: event
        };
      for (key in event) if (!ignoreProperties.test(key) && event[key] !== undefined$1) proxy[key] = event[key];
      return compatible(proxy, event);
    }
    $.fn.delegate = function (selector, event, callback) {
      return this.on(event, selector, callback);
    };
    $.fn.undelegate = function (selector, event, callback) {
      return this.off(event, selector, callback);
    };
    $.fn.live = function (event, callback) {
      $(document.body).delegate((this || _global).selector, event, callback);
      return this || _global;
    };
    $.fn.die = function (event, callback) {
      $(document.body).undelegate((this || _global).selector, event, callback);
      return this || _global;
    };
    $.fn.on = function (event, selector, data, callback, one) {
      var autoRemove,
        delegator,
        $this = this || _global;
      if (event && !isString(event)) {
        $.each(event, function (type, fn) {
          $this.on(type, selector, data, fn, one);
        });
        return $this;
      }
      if (!isString(selector) && !isFunction(callback) && callback !== false) callback = data, data = selector, selector = undefined$1;
      if (callback === undefined$1 || data === false) callback = data, data = undefined$1;
      if (callback === false) callback = returnFalse;
      return $this.each(function (_, element) {
        if (one) autoRemove = function (e) {
          remove(element, e.type, callback);
          return callback.apply(this || _global, arguments);
        };
        if (selector) delegator = function (e) {
          var evt,
            match = $(e.target).closest(selector, element).get(0);
          if (match && match !== element) {
            evt = $.extend(createProxy(e), {
              currentTarget: match,
              liveFired: element
            });
            return (autoRemove || callback).apply(match, [evt].concat(slice.call(arguments, 1)));
          }
        };
        add(element, event, callback, data, selector, delegator || autoRemove);
      });
    };
    $.fn.off = function (event, selector, callback) {
      var $this = this || _global;
      if (event && !isString(event)) {
        $.each(event, function (type, fn) {
          $this.off(type, selector, fn);
        });
        return $this;
      }
      if (!isString(selector) && !isFunction(callback) && callback !== false) callback = selector, selector = undefined$1;
      if (callback === false) callback = returnFalse;
      return $this.each(function () {
        remove(this || _global, event, callback, selector);
      });
    };
    $.fn.trigger = function (event, args) {
      event = isString(event) || $.isPlainObject(event) ? $.Event(event) : compatible(event);
      event._args = args;
      return this.each(function () {
        // handle focus(), blur() by calling them directly
        if (event.type in focus && typeof (this || _global)[event.type] == "function") this[event.type]();
        // items in the collection might not be DOM elements
        else if ("dispatchEvent" in (this || _global)) this.dispatchEvent(event);else $(this || _global).triggerHandler(event, args);
      });
    };

    // triggers event handlers on current element just as if an event occurred,
    // doesn't trigger an actual event, doesn't bubble
    $.fn.triggerHandler = function (event, args) {
      var e, result;
      this.each(function (i, element) {
        e = createProxy(isString(event) ? $.Event(event) : event);
        e._args = args;
        e.target = element;
        $.each(findHandlers(element, event.type || event), function (i, handler) {
          result = handler.proxy(e);
          if (e.isImmediatePropagationStopped()) return false;
        });
      });
      return result;
    }

    // shortcut methods for `.bind(event, fn)` for each event type
    ;

    ("focusin focusout focus blur load resize scroll unload click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select keydown keypress keyup error").split(" ").forEach(function (event) {
      $.fn[event] = function (callback) {
        return 0 in arguments ? this.bind(event, callback) : this.trigger(event);
      };
    });
    $.Event = function (type, props) {
      if (!isString(type)) props = type, type = props.type;
      var event = document.createEvent(specialEvents[type] || "Events"),
        bubbles = true;
      if (props) for (var name in props) name == "bubbles" ? bubbles = !!props[name] : event[name] = props[name];
      event.initEvent(type, bubbles, true);
      return compatible(event);
    };
  })(Zepto);
  (function () {
    // getComputedStyle shouldn't freak out when called
    // without a valid element as argument
    try {
      getComputedStyle(undefined);
    } catch (e) {
      var nativeGetComputedStyle = getComputedStyle;
      window.getComputedStyle = function (element, pseudoElement) {
        try {
          return nativeGetComputedStyle(element, pseudoElement);
        } catch (e) {
          return null;
        }
      };
    }
  })();
  (function ($) {
    var zepto = $.zepto,
      oldQsa = zepto.qsa,
      oldMatches = zepto.matches;
    function visible(elem) {
      elem = $(elem);
      return !!(elem.width() || elem.height()) && elem.css("display") !== "none";
    }

    // Implements a subset from:
    // http://api.jquery.com/category/selectors/jquery-selector-extensions/
    //
    // Each filter function receives the current index, all nodes in the
    // considered set, and a value if there were parentheses. The value
    // of `this` is the node currently being considered. The function returns the
    // resulting node(s), null, or undefined.
    //
    // Complex selectors are not supported:
    //   li:has(label:contains("foo")) + li:has(label:contains("bar"))
    //   ul.inner:first > li
    var filters = $.expr[":"] = {
      visible: function () {
        if (visible(this || _global)) return this || _global;
      },
      hidden: function () {
        if (!visible(this || _global)) return this || _global;
      },
      selected: function () {
        if ((this || _global).selected) return this || _global;
      },
      checked: function () {
        if ((this || _global).checked) return this || _global;
      },
      parent: function () {
        return (this || _global).parentNode;
      },
      first: function (idx) {
        if (idx === 0) return this || _global;
      },
      last: function (idx, nodes) {
        if (idx === nodes.length - 1) return this || _global;
      },
      eq: function (idx, _, value) {
        if (idx === value) return this || _global;
      },
      contains: function (idx, _, text) {
        if ($(this || _global).text().indexOf(text) > -1) return this || _global;
      },
      has: function (idx, _, sel) {
        if (zepto.qsa(this || _global, sel).length) return this || _global;
      }
    };
    var filterRe = new RegExp("(.*):(\\w+)(?:\\(([^)]+)\\))?$\\s*"),
      childRe = /^\s*>/,
      classTag = "Zepto" + +new Date();
    function process(sel, fn) {
      // quote the hash in `a[href^=#]` expression
      sel = sel.replace(/=#\]/g, "=\"#\"]");
      var filter,
        arg,
        match = filterRe.exec(sel);
      if (match && match[2] in filters) {
        filter = filters[match[2]], arg = match[3];
        sel = match[1];
        if (arg) {
          var num = Number(arg);
          if (isNaN(num)) arg = arg.replace(/^["']|["']$/g, "");else arg = num;
        }
      }
      return fn(sel, filter, arg);
    }
    zepto.qsa = function (node, selector) {
      return process(selector, function (sel, filter, arg) {
        try {
          var taggedParent;
          if (!sel && filter) sel = "*";else if (childRe.test(sel))
            // support "> *" child queries by tagging the parent node with a
            // unique class and prepending that classname onto the selector
            taggedParent = $(node).addClass(classTag), sel = "." + classTag + " " + sel;
          var nodes = oldQsa(node, sel);
        } catch (e) {
          console.error("error performing selector: %o", selector);
          throw e;
        } finally {
          if (taggedParent) taggedParent.removeClass(classTag);
        }
        return !filter ? nodes : zepto.uniq($.map(nodes, function (n, i) {
          return filter.call(n, i, nodes, arg);
        }));
      });
    };
    zepto.matches = function (node, selector) {
      return process(selector, function (sel, filter, arg) {
        return (!sel || oldMatches(node, sel)) && (!filter || filter.call(node, null, arg) === node);
      });
    };
  })(Zepto);
  var zepto = Zepto;

  /* eslint-disable no-useless-escape */
  // The order of the following arrays is important, be careful if you change it.

  var BROWSER_DATA = [{
    name: "Chromium",
    group: "Chrome",
    identifier: "Chromium/([0-9.]*)"
  }, {
    name: "Chrome Mobile",
    group: "Chrome",
    identifier: "Chrome/([0-9.]*) Mobile",
    versionIdentifier: "Chrome/([0-9.]*)"
  }, {
    name: "Chrome",
    group: "Chrome",
    identifier: "Chrome/([0-9.]*)"
  }, {
    name: "Chrome for iOS",
    group: "Chrome",
    identifier: "CriOS/([0-9.]*)"
  }, {
    name: "Android Browser",
    group: "Chrome",
    identifier: "CrMo/([0-9.]*)"
  }, {
    name: "Firefox",
    group: "Firefox",
    identifier: "Firefox/([0-9.]*)"
  }, {
    name: "Opera Mini",
    group: "Opera",
    identifier: "Opera Mini/([0-9.]*)"
  }, {
    name: "Opera",
    group: "Opera",
    identifier: "Opera ([0-9.]*)"
  }, {
    name: "Opera",
    group: "Opera",
    identifier: "Opera/([0-9.]*)",
    versionIdentifier: "Version/([0-9.]*)"
  }, {
    name: "IEMobile",
    group: "Explorer",
    identifier: "IEMobile/([0-9.]*)"
  }, {
    name: "Internet Explorer",
    group: "Explorer",
    identifier: "MSIE ([a-zA-Z0-9.]*)"
  }, {
    name: "Internet Explorer",
    group: "Explorer",
    identifier: "Trident/([0-9.]*)",
    versionIdentifier: "rv:([0-9.]*)"
  }, {
    name: "Spartan",
    group: "Spartan",
    identifier: "Edge/([0-9.]*)",
    versionIdentifier: "Edge/([0-9.]*)"
  }, {
    name: "Safari",
    group: "Safari",
    identifier: "Safari/([0-9.]*)",
    versionIdentifier: "Version/([0-9.]*)"
  }];

  /* eslint-disable no-useless-escape */
  // The order of the following arrays is important, be careful if you change it.

  var OS_DATA = [{
    name: "Windows 2000",
    group: "Windows",
    identifier: "Windows NT 5.0",
    version: "5.0"
  }, {
    name: "Windows XP",
    group: "Windows",
    identifier: "Windows NT 5.1",
    version: "5.1"
  }, {
    name: "Windows Vista",
    group: "Windows",
    identifier: "Windows NT 6.0",
    version: "6.0"
  }, {
    name: "Windows 7",
    group: "Windows",
    identifier: "Windows NT 6.1",
    version: "7.0"
  }, {
    name: "Windows 8",
    group: "Windows",
    identifier: "Windows NT 6.2",
    version: "8.0"
  }, {
    name: "Windows 8.1",
    group: "Windows",
    identifier: "Windows NT 6.3",
    version: "8.1"
  }, {
    name: "Windows 10",
    group: "Windows",
    identifier: "Windows NT 10.0",
    version: "10.0"
  }, {
    name: "Windows Phone",
    group: "Windows Phone",
    identifier: "Windows Phone ([0-9.]*)"
  }, {
    name: "Windows Phone",
    group: "Windows Phone",
    identifier: "Windows Phone OS ([0-9.]*)"
  }, {
    name: "Windows",
    group: "Windows",
    identifier: "Windows"
  }, {
    name: "Chrome OS",
    group: "Chrome OS",
    identifier: "CrOS"
  }, {
    name: "Android",
    group: "Android",
    identifier: "Android",
    versionIdentifier: "Android ([a-zA-Z0-9.-]*)"
  }, {
    name: "iPad",
    group: "iOS",
    identifier: "iPad",
    versionIdentifier: "OS ([0-9_]*)",
    versionSeparator: "[_|.]"
  }, {
    name: "iPod",
    group: "iOS",
    identifier: "iPod",
    versionIdentifier: "OS ([0-9_]*)",
    versionSeparator: "[_|.]"
  }, {
    name: "iPhone",
    group: "iOS",
    identifier: "iPhone OS",
    versionIdentifier: "OS ([0-9_]*)",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X High Sierra",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])13([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Sierra",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])12([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X El Capitan",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])11([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Yosemite",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])10([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Mavericks",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])9([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Mountain Lion",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])8([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Lion",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])7([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Snow Leopard",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])6([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Leopard",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])5([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Tiger",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])4([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Panther",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])3([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Jaguar",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])2([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Puma",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])1([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS X Cheetah",
    group: "Mac OS",
    identifier: "Mac OS X (10([_|.])0([0-9_.]*))",
    versionSeparator: "[_|.]"
  }, {
    name: "Mac OS",
    group: "Mac OS",
    identifier: "Mac OS"
  }, {
    name: "Ubuntu",
    group: "Linux",
    identifier: "Ubuntu",
    versionIdentifier: "Ubuntu/([0-9.]*)"
  }, {
    name: "Debian",
    group: "Linux",
    identifier: "Debian"
  }, {
    name: "Gentoo",
    group: "Linux",
    identifier: "Gentoo"
  }, {
    name: "Linux",
    group: "Linux",
    identifier: "Linux"
  }, {
    name: "BlackBerry",
    group: "BlackBerry",
    identifier: "BlackBerry"
  }];
  var Browser = {};
  var hasLocalstorage = function hasLocalstorage() {
    try {
      localStorage.setItem("clappr", "clappr");
      localStorage.removeItem("clappr");
      return true;
    } catch (e) {
      return false;
    }
  };
  var hasFlash = function hasFlash() {
    try {
      var fo = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      return !!fo;
    } catch (e) {
      return !!(navigator.mimeTypes && navigator.mimeTypes["application/x-shockwave-flash"] !== undefined && navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin);
    }
  };
  var getBrowserInfo = function getBrowserInfo(ua) {
    var parts = ua.match(/\b(playstation 4|nx|opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [],
      extra;
    if (/trident/i.test(parts[1])) {
      extra = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return {
        name: "IE",
        version: parseInt(extra[1] || "")
      };
    } else if (parts[1] === "Chrome") {
      extra = ua.match(/\bOPR\/(\d+)/);
      if (extra != null) return {
        name: "Opera",
        version: parseInt(extra[1])
      };
      extra = ua.match(/\bEdge\/(\d+)/);
      if (extra != null) return {
        name: "Edge",
        version: parseInt(extra[1])
      };
    } else if (/android/i.test(ua) && (extra = ua.match(/version\/(\d+)/i))) {
      parts.splice(1, 1, "Android WebView");
      parts.splice(2, 1, extra[1]);
    }
    parts = parts[2] ? [parts[1], parts[2]] : [navigator.appName, navigator.appVersion, "-?"];
    return {
      name: parts[0],
      version: parseInt(parts[1])
    };
  };

  //  Get browser data
  var getBrowserData = function getBrowserData() {
    var browserObject = {};
    var userAgent = Browser.userAgent.toLowerCase();

    // Check browser type
    var _iterator = _createForOfIteratorHelper(BROWSER_DATA),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var browser = _step.value;
        var browserRegExp = new RegExp(browser.identifier.toLowerCase());
        var browserRegExpResult = browserRegExp.exec(userAgent);
        if (browserRegExpResult != null && browserRegExpResult[1]) {
          browserObject.name = browser.name;
          browserObject.group = browser.group;

          // Check version
          if (browser.versionIdentifier) {
            var versionRegExp = new RegExp(browser.versionIdentifier.toLowerCase());
            var versionRegExpResult = versionRegExp.exec(userAgent);
            if (versionRegExpResult != null && versionRegExpResult[1]) setBrowserVersion(versionRegExpResult[1], browserObject);
          } else {
            setBrowserVersion(browserRegExpResult[1], browserObject);
          }
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return browserObject;
  };

  // Set browser version
  var setBrowserVersion = function setBrowserVersion(version, browserObject) {
    var splitVersion = version.split(".", 2);
    browserObject.fullVersion = version;

    // Major version
    if (splitVersion[0]) browserObject.majorVersion = parseInt(splitVersion[0]);

    // Minor version
    if (splitVersion[1]) browserObject.minorVersion = parseInt(splitVersion[1]);
  };

  //  Get OS data
  var getOsData = function getOsData() {
    var osObject = {};
    var userAgent = Browser.userAgent.toLowerCase();

    // Check browser type
    var _iterator2 = _createForOfIteratorHelper(OS_DATA),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var os = _step2.value;
        var osRegExp = new RegExp(os.identifier.toLowerCase());
        var osRegExpResult = osRegExp.exec(userAgent);
        if (osRegExpResult != null) {
          osObject.name = os.name;
          osObject.group = os.group;

          // Version defined
          if (os.version) {
            setOsVersion(os.version, os.versionSeparator ? os.versionSeparator : ".", osObject);

            // Version detected
          } else if (osRegExpResult[1]) {
            setOsVersion(osRegExpResult[1], os.versionSeparator ? os.versionSeparator : ".", osObject);

            // Version identifier
          } else if (os.versionIdentifier) {
            var versionRegExp = new RegExp(os.versionIdentifier.toLowerCase());
            var versionRegExpResult = versionRegExp.exec(userAgent);
            if (versionRegExpResult != null && versionRegExpResult[1]) setOsVersion(versionRegExpResult[1], os.versionSeparator ? os.versionSeparator : ".", osObject);
          }
          break;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return osObject;
  };

  // Set OS version
  var setOsVersion = function setOsVersion(version, separator, osObject) {
    var finalSeparator = separator.substr(0, 1) == "[" ? new RegExp(separator, "g") : separator;
    var splitVersion = version.split(finalSeparator, 2);
    if (separator != ".") version = version.replace(new RegExp(separator, "g"), ".");
    osObject.fullVersion = version;

    // Major version
    if (splitVersion && splitVersion[0]) osObject.majorVersion = parseInt(splitVersion[0]);

    // Minor version
    if (splitVersion && splitVersion[1]) osObject.minorVersion = parseInt(splitVersion[1]);
  };

  // Set viewport size
  var getViewportSize = function getViewportSize() {
    var viewportObject = {};
    viewportObject.width = zepto(window).width();
    viewportObject.height = zepto(window).height();
    return viewportObject;
  };

  // Set viewport orientation
  var setViewportOrientation = function setViewportOrientation() {
    switch (window.orientation) {
      case -90:
      case 90:
        Browser.viewport.orientation = "landscape";
        break;
      default:
        Browser.viewport.orientation = "portrait";
        break;
    }
  };
  var getDevice = function getDevice(ua) {
    var platformRegExp = /\((iP(?:hone|ad|od))?(?:[^;]*; ){0,2}([^)]+(?=\)))/;
    var matches = platformRegExp.exec(ua);
    var device = matches && (matches[1] || matches[2]) || "";
    return device;
  };
  var browserInfo = getBrowserInfo(navigator.userAgent);
  Browser.isEdge = /Edg|EdgiOS|EdgA/i.test(navigator.userAgent);
  Browser.isChrome = /Chrome|CriOS/i.test(navigator.userAgent) && !Browser.isEdge;
  Browser.isSafari = /Safari/i.test(navigator.userAgent) && !Browser.isChrome && !Browser.isEdge;
  Browser.isFirefox = /Firefox/i.test(navigator.userAgent);
  Browser.isLegacyIE = !!window.ActiveXObject;
  Browser.isIE = Browser.isLegacyIE || /trident.*rv:1\d/i.test(navigator.userAgent);
  Browser.isIE11 = /trident.*rv:11/i.test(navigator.userAgent);
  Browser.isChromecast = Browser.isChrome && /CrKey/i.test(navigator.userAgent);
  Browser.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone|IEMobile|Mobile Safari|Opera Mini/i.test(navigator.userAgent);
  Browser.isiOS = /iPad|iPhone|iPod/i.test(navigator.userAgent);
  Browser.isAndroid = /Android/i.test(navigator.userAgent);
  Browser.isWindowsPhone = /Windows Phone/i.test(navigator.userAgent);
  Browser.isWin8App = /MSAppHost/i.test(navigator.userAgent);
  Browser.isWiiU = /WiiU/i.test(navigator.userAgent);
  Browser.isPS4 = /PlayStation 4/i.test(navigator.userAgent);
  Browser.hasLocalstorage = hasLocalstorage();
  Browser.hasFlash = hasFlash();

  /**
  * @deprecated
  * This parameter currently exists for retrocompatibility reasons.
  * Use Browser.data.name instead.
  */
  Browser.name = browserInfo.name;

  /**
  * @deprecated
  * This parameter currently exists for retrocompatibility reasons.
  * Use Browser.data.fullVersion instead.
  */
  Browser.version = browserInfo.version;
  Browser.userAgent = navigator.userAgent;
  Browser.data = getBrowserData();
  Browser.os = getOsData();
  Browser.isWindows = /^Windows$/i.test(Browser.os.group);
  Browser.isMacOS = /^Mac OS$/i.test(Browser.os.group);
  Browser.isLinux = /^Linux$/i.test(Browser.os.group);
  Browser.viewport = getViewportSize();
  Browser.device = getDevice(Browser.userAgent);
  typeof window.orientation !== "undefined" && setViewportOrientation();
  var idsCounter = {};
  var videoStack = [];
  var requestAnimationFrame = (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
    window.setTimeout(fn, 1000 / 60);
  }).bind(window);
  var cancelAnimationFrame = (window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout).bind(window);
  function assign$1(obj, source) {
    if (source) {
      for (var prop in source) {
        var propDescriptor = Object.getOwnPropertyDescriptor(source, prop);
        propDescriptor ? Object.defineProperty(obj, prop, propDescriptor) : obj[prop] = source[prop];
      }
    }
    return obj;
  }
  function extend$1(parent, properties) {
    var Surrogate = /*#__PURE__*/function (_parent) {
      _inherits$2(Surrogate, _parent);
      var _super = _createSuper$2(Surrogate);
      function Surrogate() {
        var _this;
        _classCallCheck$2(this || _global, Surrogate);
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [this || _global].concat(args));
        if (properties.initialize) properties.initialize.apply(_assertThisInitialized$2(_this), args);
        return _this;
      }
      return _createClass$2(Surrogate);
    }(parent);
    assign$1(Surrogate.prototype, properties);
    return Surrogate;
  }
  function formatTime$2(time, paddedHours) {
    if (!isFinite(time)) return "--:--";
    time = time * 1000;
    time = parseInt(time / 1000);
    var seconds = time % 60;
    time = parseInt(time / 60);
    var minutes = time % 60;
    time = parseInt(time / 60);
    var hours = time % 24;
    var days = parseInt(time / 24);
    var out = "";
    if (days && days > 0) {
      out += days + ":";
      if (hours < 1) out += "00:";
    }
    if (hours && hours > 0 || paddedHours) out += ("0" + hours).slice(-2) + ":";
    out += ("0" + minutes).slice(-2) + ":";
    out += ("0" + seconds).slice(-2);
    return out.trim();
  }
  var Fullscreen$1 = {
    fullscreenElement: function fullscreenElement() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    },
    requestFullscreen: function requestFullscreen(el) {
      if (el.requestFullscreen) {
        return el.requestFullscreen();
      } else if (el.webkitRequestFullscreen) {
        if (typeof el.then === "function") return el.webkitRequestFullscreen();
        el.webkitRequestFullscreen();
      } else if (el.mozRequestFullScreen) {
        return el.mozRequestFullScreen();
      } else if (el.msRequestFullscreen) {
        return el.msRequestFullscreen();
      } else if (el.querySelector && el.querySelector("video") && el.querySelector("video").webkitEnterFullScreen) {
        el.querySelector("video").webkitEnterFullScreen();
      } else if (el.webkitEnterFullScreen) {
        el.webkitEnterFullScreen();
      }
    },
    cancelFullscreen: function cancelFullscreen() {
      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
      if (el.exitFullscreen) el.exitFullscreen();else if (el.webkitCancelFullScreen) el.webkitCancelFullScreen();else if (el.webkitExitFullscreen) el.webkitExitFullscreen();else if (el.mozCancelFullScreen) el.mozCancelFullScreen();else if (el.msExitFullscreen) el.msExitFullscreen();
    },
    fullscreenEnabled: function fullscreenEnabled() {
      return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
    }
  };
  var Config$1 = /*#__PURE__*/function () {
    function Config() {
      _classCallCheck$2(this || _global, Config);
    }
    _createClass$2(Config, null, [{
      key: "_defaultConfig",
      value: function _defaultConfig() {
        return {
          volume: {
            value: 100,
            parse: parseInt
          }
        };
      }
    }, {
      key: "_defaultValueFor",
      value: function _defaultValueFor(key) {
        try {
          return this._defaultConfig()[key].parse(this._defaultConfig()[key].value);
        } catch (e) {
          return undefined;
        }
      }
    }, {
      key: "_createKeyspace",
      value: function _createKeyspace(key) {
        return "clappr.".concat(document.domain, ".").concat(key);
      }
    }, {
      key: "restore",
      value: function restore(key) {
        if (Browser.hasLocalstorage && localStorage[this._createKeyspace(key)]) return this._defaultConfig()[key].parse(localStorage[this._createKeyspace(key)]);
        return this._defaultValueFor(key);
      }
    }, {
      key: "persist",
      value: function persist(key, value) {
        if (Browser.hasLocalstorage) {
          try {
            localStorage[this._createKeyspace(key)] = value;
            return true;
          } catch (e) {
            return false;
          }
        }
      }
    }]);
    return Config;
  }();
  var QueryString = /*#__PURE__*/function () {
    function QueryString() {
      _classCallCheck$2(this || _global, QueryString);
    }
    _createClass$2(QueryString, null, [{
      key: "params",
      get: function get() {
        var query = window.location.search.substring(1);
        if (query !== (this || _global).query) {
          (this || _global)._urlParams = this.parse(query);
          (this || _global).query = query;
        }
        return (this || _global)._urlParams;
      }
    }, {
      key: "hashParams",
      get: function get() {
        var hash = window.location.hash.substring(1);
        if (hash !== (this || _global).hash) {
          (this || _global)._hashParams = this.parse(hash);
          (this || _global).hash = hash;
        }
        return (this || _global)._hashParams;
      }
    }, {
      key: "parse",
      value: function parse(paramsString) {
        var match;
        var pl = /\+/g,
          // Regex for replacing addition symbol with a space
          search = /([^&=]+)=?([^&]*)/g,
          decode = function decode(s) {
            return decodeURIComponent(s.replace(pl, " "));
          },
          params = {};
        while (match = search.exec(paramsString)) {
          // eslint-disable-line no-cond-assign
          params[decode(match[1]).toLowerCase()] = decode(match[2]);
        }
        return params;
      }
    }]);
    return QueryString;
  }();
  function seekStringToSeconds() {
    var paramName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "t";
    var seconds = 0;
    var seekString = QueryString.params[paramName] || QueryString.hashParams[paramName] || "";
    var parts = seekString.match(/[0-9]+[hms]+/g) || [];
    if (parts.length > 0) {
      var factor = {
        "h": 3600,
        "m": 60,
        "s": 1
      };
      parts.forEach(function (el) {
        if (el) {
          var suffix = el[el.length - 1];
          var time = parseInt(el.slice(0, el.length - 1), 10);
          seconds += time * factor[suffix];
        }
      });
    } else if (seekString) {
      seconds = parseInt(seekString, 10);
    }
    return seconds;
  }
  function uniqueId(prefix) {
    idsCounter[prefix] || (idsCounter[prefix] = 0);
    var id = ++idsCounter[prefix];
    return prefix + id;
  }
  function isNumber(value) {
    return value - parseFloat(value) + 1 >= 0;
  }
  function currentScriptUrl() {
    var scripts = document.getElementsByTagName("script");
    return scripts.length ? scripts[scripts.length - 1].src : "";
  }
  function getBrowserLanguage() {
    return window.navigator && window.navigator.language;
  }
  function now$1() {
    if (window.performance && window.performance.now) return performance.now();
    return Date.now();
  }

  // remove the item from the array if it exists in the array
  function removeArrayItem$1(arr, item) {
    var i = arr.indexOf(item);
    if (i >= 0) arr.splice(i, 1);
  }

  // find an item regardless of its letter case
  function listContainsIgnoreCase$1(item, items) {
    if (item === undefined || items === undefined) return false;
    return items.find(function (itemEach) {
      return item.toLowerCase() === itemEach.toLowerCase();
    }) !== undefined;
  }

  // https://github.com/video-dev/can-autoplay
  function canAutoPlayMedia(cb, options) {
    options = Object.assign({
      inline: false,
      muted: false,
      timeout: 250,
      type: "video",
      source: Media.mp4,
      element: null
    }, options);
    var element = options.element ? options.element : document.createElement(options.type);
    element.muted = options.muted;
    if (options.muted === true) element.setAttribute("muted", "muted");
    if (options.inline === true) element.setAttribute("playsinline", "playsinline");
    element.src = options.source;
    var promise = element.play();
    var timeoutId = setTimeout(function () {
      setResult(false, new Error("Timeout ".concat(options.timeout, " ms has been reached")));
    }, options.timeout);
    var setResult = function setResult(result) {
      var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      clearTimeout(timeoutId);
      cb(result, error);
    };
    if (promise !== undefined) {
      promise.then(function () {
        return setResult(true);
      })["catch"](function (err) {
        return setResult(false, err);
      });
    } else {
      setResult(true);
    }
  }

  // Simple element factory with video recycle feature.
  var DomRecycler = /*#__PURE__*/function () {
    function DomRecycler() {
      _classCallCheck$2(this || _global, DomRecycler);
    }
    _createClass$2(DomRecycler, null, [{
      key: "configure",
      value: function configure(options) {
        (this || _global).options = zepto.extend(true, (this || _global).options, options);
      }
    }, {
      key: "create",
      value: function create(name) {
        if ((this || _global).options.recycleVideo && name === "video" && videoStack.length > 0) return videoStack.shift();
        return document.createElement(name);
      }
    }, {
      key: "garbage",
      value: function garbage(el) {
        if (!(this || _global).options.recycleVideo || el.tagName.toUpperCase() !== "VIDEO") return;
        zepto(el).children().remove();
        Object.values(el.attributes).forEach(function (attr) {
          return el.removeAttribute(attr.name);
        });
        videoStack.push(el);
      }
    }]);
    return DomRecycler;
  }();
  DomRecycler.options = {
    recycleVideo: false
  };
  var DoubleEventHandler = /*#__PURE__*/function () {
    function DoubleEventHandler() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      _classCallCheck$2(this || _global, DoubleEventHandler);
      (this || _global).delay = delay;
      (this || _global).lastTime = 0;
    }
    _createClass$2(DoubleEventHandler, [{
      key: "handle",
      value: function handle(event, cb) {
        var prevented = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        // Based on http://jsfiddle.net/brettwp/J4djY/
        var currentTime = new Date().getTime();
        var diffTime = currentTime - (this || _global).lastTime;
        if (diffTime < (this || _global).delay && diffTime > 0) {
          cb();
          prevented && event.preventDefault();
        }
        (this || _global).lastTime = currentTime;
      }
    }]);
    return DoubleEventHandler;
  }();
  var Utils = {
    Config: Config$1,
    Fullscreen: Fullscreen$1,
    QueryString: QueryString,
    DomRecycler: DomRecycler,
    assign: assign$1,
    extend: extend$1,
    formatTime: formatTime$2,
    seekStringToSeconds: seekStringToSeconds,
    uniqueId: uniqueId,
    currentScriptUrl: currentScriptUrl,
    isNumber: isNumber,
    requestAnimationFrame: requestAnimationFrame,
    cancelAnimationFrame: cancelAnimationFrame,
    getBrowserLanguage: getBrowserLanguage,
    now: now$1,
    removeArrayItem: removeArrayItem$1,
    listContainsIgnoreCase: listContainsIgnoreCase$1,
    canAutoPlayMedia: canAutoPlayMedia,
    Media: Media,
    DoubleEventHandler: DoubleEventHandler
  };

  // Use of this source code is governed by a BSD-style
  // license that can be found in the LICENSE file.

  var BOLD = "font-weight: bold; font-size: 13px;";
  var INFO = "color: #006600;" + BOLD;
  var DEBUG = "color: #0000ff;" + BOLD;
  var WARN = "color: #ff8000;" + BOLD;
  var ERROR = "color: #ff0000;" + BOLD;
  var LEVEL_DEBUG = 0;
  var LEVEL_INFO = 1;
  var LEVEL_WARN = 2;
  var LEVEL_ERROR = 3;
  var LEVEL_DISABLED = LEVEL_ERROR;
  var COLORS = [DEBUG, INFO, WARN, ERROR, ERROR];
  var DESCRIPTIONS = ["debug", "info", "warn", "error", "disabled"];
  var Log = /*#__PURE__*/function () {
    function Log() {
      var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LEVEL_INFO;
      var offLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LEVEL_DISABLED;
      _classCallCheck$2(this || _global, Log);
      (this || _global).EXCLUDE_LIST = ["timeupdate", "playback:timeupdate", "playback:progress", "container:hover", "container:timeupdate", "container:progress"];
      (this || _global).level = level;
      (this || _global).previousLevel = (this || _global).level;
      (this || _global).offLevel = offLevel;
    }
    _createClass$2(Log, [{
      key: "level",
      get: function get() {
        return (this || _global)._level;
      },
      set: function set(newLevel) {
        (this || _global)._level = newLevel;
      }
    }, {
      key: "debug",
      value: function debug(klass) {
        this.log(klass, LEVEL_DEBUG, Array.prototype.slice.call(arguments, 1));
      }
    }, {
      key: "info",
      value: function info(klass) {
        this.log(klass, LEVEL_INFO, Array.prototype.slice.call(arguments, 1));
      }
    }, {
      key: "warn",
      value: function warn(klass) {
        this.log(klass, LEVEL_WARN, Array.prototype.slice.call(arguments, 1));
      }
    }, {
      key: "error",
      value: function error(klass) {
        this.log(klass, LEVEL_ERROR, Array.prototype.slice.call(arguments, 1));
      }
    }, {
      key: "onOff",
      value: function onOff() {
        if ((this || _global).level === (this || _global).offLevel) {
          (this || _global).level = (this || _global).previousLevel;
        } else {
          (this || _global).previousLevel = (this || _global).level;
          (this || _global).level = (this || _global).offLevel;
        }
        // handle instances where console.log is unavailable
        window.console && window.console.log && window.console.log("%c[Clappr.Log] set log level to " + DESCRIPTIONS[(this || _global).level], WARN);
      }
    }, {
      key: "log",
      value: function log(klass, level, message) {
        if ((this || _global).EXCLUDE_LIST.indexOf(message[0]) >= 0) return;
        if (level < (this || _global).level) return;
        if (!message) {
          message = klass;
          klass = null;
        }
        var color = COLORS[level];
        var klassDescription = "";
        if (klass) klassDescription = "[" + klass + "]";
        window.console && window.console.log && window.console.log.apply(console, ["%c[" + DESCRIPTIONS[level] + "]" + klassDescription, color].concat(message));
      }
    }]);
    return Log;
  }();
  Log.LEVEL_DEBUG = LEVEL_DEBUG;
  Log.LEVEL_INFO = LEVEL_INFO;
  Log.LEVEL_WARN = LEVEL_WARN;
  Log.LEVEL_ERROR = LEVEL_ERROR;
  Log.getInstance = function () {
    if ((this || _global)._instance === undefined) (this || _global)._instance = new (this || _global)();
    return (this || _global)._instance;
  };
  Log.setLevel = function (level) {
    this.getInstance().level = level;
  };
  Log.debug = function () {
    this.getInstance().debug.apply(this.getInstance(), arguments);
  };
  Log.info = function () {
    this.getInstance().info.apply(this.getInstance(), arguments);
  };
  Log.warn = function () {
    this.getInstance().warn.apply(this.getInstance(), arguments);
  };
  Log.error = function () {
    this.getInstance().error.apply(this.getInstance(), arguments);
  };
  var slice = Array.prototype.slice;
  var eventSplitter = /\s+/;
  var eventsApi = function eventsApi(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (_typeof(name) === "object") {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }
    return true;
  };
  var triggerEvents = function triggerEvents(events, args, klass, name) {
    var ev,
      i = -1;
    var l = events.length,
      a1 = args[0],
      a2 = args[1],
      a3 = args[2];
    run();
    function run() {
      try {
        switch (args.length) {
          /* eslint-disable curly */
          case 0:
            while (++i < l) {
              (ev = events[i]).callback.call(ev.ctx);
            }
            return;
          case 1:
            while (++i < l) {
              (ev = events[i]).callback.call(ev.ctx, a1);
            }
            return;
          case 2:
            while (++i < l) {
              (ev = events[i]).callback.call(ev.ctx, a1, a2);
            }
            return;
          case 3:
            while (++i < l) {
              (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
            }
            return;
          default:
            while (++i < l) {
              (ev = events[i]).callback.apply(ev.ctx, args);
            }
            return;
        }
      } catch (exception) {
        Log.error.apply(Log, [klass, "error on event", name, "trigger", "-", exception]);
        run();
      }
    }
  };

  /**
   * @class Events
   * @constructor
   * @module base
   */
  var Events = /*#__PURE__*/function () {
    function Events() {
      _classCallCheck$2(this || _global, Events);
    }
    _createClass$2(Events, [{
      key: "on",
      value:
      /**
       * listen to an event indefinitely, if you want to stop you need to call `off`
       * @method on
       * @param {String} name
       * @param {Function} callback
       * @param {Object} context
       */
      function on(name, callback, context) {
        if (!eventsApi(this || _global, "on", name, [callback, context]) || !callback) return this || _global;
        (this || _global)._events || ((this || _global)._events = {});
        var events = (this || _global)._events[name] || ((this || _global)._events[name] = []);
        events.push({
          callback: callback,
          context: context,
          ctx: context || this || _global
        });
        return this || _global;
      }

      /**
       * listen to an event only once
       * @method once
       * @param {String} name
       * @param {Function} callback
       * @param {Object} context
       */
    }, {
      key: "once",
      value: function once(name, callback, context) {
        var _this = this || _global;
        var _once;
        if (!eventsApi(this || _global, "once", name, [callback, context]) || !callback) return this || _global;
        var off = function off() {
          return _this.off(name, _once);
        };
        _once = function once() {
          off();
          callback.apply(this || _global, arguments);
        };
        return this.on(name, _once, context);
      }

      /**
       * stop listening to an event
       * @method off
       * @param {String} name
       * @param {Function} callback
       * @param {Object} context
       */
    }, {
      key: "off",
      value: function off(name, callback, context) {
        var retain, ev, events, names, i, l, j, k;
        if (!(this || _global)._events || !eventsApi(this || _global, "off", name, [callback, context])) return this || _global;
        if (!name && !callback && !context) {
          (this || _global)._events = void 0;
          return this || _global;
        }
        names = name ? [name] : Object.keys((this || _global)._events);
        // jshint maxdepth:5
        for (i = 0, l = names.length; i < l; i++) {
          name = names[i];
          events = (this || _global)._events[name];
          if (events) {
            (this || _global)._events[name] = retain = [];
            if (callback || context) {
              for (j = 0, k = events.length; j < k; j++) {
                ev = events[j];
                if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) retain.push(ev);
              }
            }
            if (!retain.length) delete (this || _global)._events[name];
          }
        }
        return this || _global;
      }

      /**
       * triggers an event given its `name`
       * @method trigger
       * @param {String} name
       */
    }, {
      key: "trigger",
      value: function trigger(name) {
        var klass = (this || _global).name || (this || _global).constructor.name;
        Log.debug.apply(Log, [klass].concat(Array.prototype.slice.call(arguments)));
        if (!(this || _global)._events) return this || _global;
        var args = slice.call(arguments, 1);
        if (!eventsApi(this || _global, "trigger", name, args)) return this || _global;
        var events = (this || _global)._events[name];
        var allEvents = (this || _global)._events.all;
        if (events) triggerEvents(events, args, klass, name);
        if (allEvents) triggerEvents(allEvents, arguments, klass, name);
        return this || _global;
      }

      /**
       * stop listening an event for a given object
       * @method stopListening
       * @param {Object} obj
       * @param {String} name
       * @param {Function} callback
       */
    }, {
      key: "stopListening",
      value: function stopListening(obj, name, callback) {
        var listeningTo = (this || _global)._listeningTo;
        if (!listeningTo) return this || _global;
        var remove = !name && !callback;
        if (!callback && _typeof(name) === "object") callback = this || _global;
        if (obj) (listeningTo = {})[obj._listenId] = obj;
        for (var id in listeningTo) {
          obj = listeningTo[id];
          obj.off(name, callback, this || _global);
          if (remove || Object.keys(obj._events).length === 0) delete (this || _global)._listeningTo[id];
        }
        return this || _global;
      }
    }], [{
      key: "register",
      value: function register(eventName) {
        Events.Custom || (Events.Custom = {});
        var property = typeof eventName === "string" && eventName.toUpperCase().trim();
        if (property && !Events.Custom[property]) {
          Events.Custom[property] = property.toLowerCase().split("_").map(function (value, index) {
            return index === 0 ? value : value = value[0].toUpperCase() + value.slice(1);
          }).join("");
        } else Log.error("Events", "Error when register event: " + eventName);
      }
    }, {
      key: "listAvailableCustomEvents",
      value: function listAvailableCustomEvents() {
        Events.Custom || (Events.Custom = {});
        return Object.keys(Events.Custom).filter(function (property) {
          return typeof Events.Custom[property] === "string";
        });
      }
    }]);
    return Events;
  }();
  var listenMethods = {
    listenTo: "on",
    listenToOnce: "once"
  };
  Object.keys(listenMethods).forEach(function (method) {
    Events.prototype[method] = function (obj, name, callback) {
      var listeningTo = (this || _global)._listeningTo || ((this || _global)._listeningTo = {});
      var id = obj._listenId || (obj._listenId = uniqueId("l"));
      listeningTo[id] = obj;
      if (!callback && _typeof(name) === "object") callback = this || _global;
      obj[listenMethods[method]](name, callback, this || _global);
      return this || _global;
    };
  });

  // PLAYER EVENTS
  /**
   * Fired when the player is ready on startup
   *
   * @event PLAYER_READY
   */
  Events.PLAYER_READY = "ready";
  /**
   * Fired when player resizes
   *
   * @event PLAYER_RESIZE
   * @param {Object} currentSize an object with the current size
   */
  Events.PLAYER_RESIZE = "resize";
  /**
   * Fired when player changes its fullscreen state
   *
   * @event PLAYER_FULLSCREEN
   * @param {Boolean} whether or not the player is on fullscreen mode
   */
  Events.PLAYER_FULLSCREEN = "fullscreen";
  /**
   * Fired when player starts to play
   *
   * @event PLAYER_PLAY
   */
  Events.PLAYER_PLAY = "play";
  /**
   * Fired when player pauses
   *
   * @event PLAYER_PAUSE
   */
  Events.PLAYER_PAUSE = "pause";
  /**
   * Fired when player stops
   *
   * @event PLAYER_STOP
   */
  Events.PLAYER_STOP = "stop";
  /**
   * Fired when player ends the video
   *
   * @event PLAYER_ENDED
   */
  Events.PLAYER_ENDED = "ended";
  /**
   * Fired when player seeks the video
   *
   * @event PLAYER_SEEK
   * @param {Number} time the current time in seconds
   */
  Events.PLAYER_SEEK = "seek";
  /**
   * Fired when player receives an error
   *
   * @event PLAYER_ERROR
   * @param {Object} error the error
   */
  Events.PLAYER_ERROR = "playererror";
  /**
   * Fired when there is an error
   *
   * @event ERROR
   * @param {Object} error
   * the error with the following format `{code, description, level, raw, origin, scope}`
   * @param {String} [options.code]
   * error's code: code to identify error in the following format: origin:code
   * @param {String} [options.description]
   * error's description: description of the error
   * @param {String} [options.level]
   * error's level: FATAL or WARN.
   * @param {String} [options.origin]
   * error's origin. Example: hls, html5, etc
   * @param {String} [options.scope]
   * error's scope. Example: playback, container, etc
   * @param {String} [options.raw]
   * raw error: the initial error received
   */
  Events.ERROR = "error";
  /**
   * Fired when the time is updated on player
   *
   * @event PLAYER_TIMEUPDATE
   * @param {Object} progress Data
   * progress object
   * @param {Number} [progress.current]
   * current time (in seconds)
   * @param {Number} [progress.total]
   * total time (in seconds)
   */
  Events.PLAYER_TIMEUPDATE = "timeupdate";
  /**
   * Fired when player updates its volume
   *
   * @event PLAYER_VOLUMEUPDATE
   * @param {Number} volume the current volume
   */
  Events.PLAYER_VOLUMEUPDATE = "volumeupdate";

  /**
   * Fired when subtitle is available
   *
   * @event PLAYER_SUBTITLE_AVAILABLE
   */
  Events.PLAYER_SUBTITLE_AVAILABLE = "subtitleavailable";

  // Playback Events
  /**
   * Fired when the playback is downloading the media
   *
   * @event PLAYBACK_PROGRESS
   * @param progress {Object}
   * Data progress object
   * @param [progress.start] {Number}
   * start position of buffered content at current position
   * @param [progress.current] {Number}
   * end position of buffered content at current position
   * @param [progress.total] {Number}
   * total content to be downloaded
   * @param buffered {Array}
   * array of buffered segments ({start, end}). [Only for supported playbacks]
   */
  Events.PLAYBACK_PROGRESS = "playback:progress";
  /**
   * Fired when the time is updated on playback
   *
   * @event PLAYBACK_TIMEUPDATE
   * @param {Object} progress Data
   * progress object
   * @param {Number} [progress.current]
   * current time (in seconds)
   * @param {Number} [progress.total]
   * total time (in seconds)
   */
  Events.PLAYBACK_TIMEUPDATE = "playback:timeupdate";
  /**
   * Fired when playback is ready
   *
   * @event PLAYBACK_READY
   */
  Events.PLAYBACK_READY = "playback:ready";
  /**
   * Fired when the playback starts having to buffer because
   * playback can currently not be smooth.
   *
   * This corresponds to the playback `buffering` property being
   * `true`.
   *
   * @event PLAYBACK_BUFFERING
   */
  Events.PLAYBACK_BUFFERING = "playback:buffering";
  /**
   * Fired when the playback has enough in the buffer to be
   * able to play smoothly, after previously being unable to
   * do this.
   *
   * This corresponds to the playback `buffering` property being
   * `false`.
   *
   * @event PLAYBACK_BUFFERFULL
   */
  Events.PLAYBACK_BUFFERFULL = "playback:bufferfull";
  /**
   * Fired when playback changes any settings (volume, seek and etc)
   *
   * @event PLAYBACK_SETTINGSUPDATE
   */
  Events.PLAYBACK_SETTINGSUPDATE = "playback:settingsupdate";
  /**
   * Fired when playback loaded its metadata
   *
   * @event PLAYBACK_LOADEDMETADATA
   * @param {Object} metadata Data
   * settings object
   * @param {Number} [metadata.duration]
   * the playback duration
   * @param {Object} [metadata.data]
   * extra meta data
   */
  Events.PLAYBACK_LOADEDMETADATA = "playback:loadedmetadata";
  /**
   * Fired when playback updates its video quality
   *
   * @event PLAYBACK_HIGHDEFINITIONUPDATE
   * @param {Boolean} isHD
   * true when is on HD, false otherwise
   */
  Events.PLAYBACK_HIGHDEFINITIONUPDATE = "playback:highdefinitionupdate";
  /**
   * Fired when playback updates its bitrate
   *
   * @event PLAYBACK_BITRATE
   * @param {Object} bitrate Data
   * bitrate object
   * @param {Number} [bitrate.bandwidth]
   * bitrate bandwidth when it's available
   * @param {Number} [bitrate.width]
   * playback width (ex: 720, 640, 1080)
   * @param {Number} [bitrate.height]
   * playback height (ex: 240, 480, 720)
   * @param {Number} [bitrate.level]
   * playback level when it's available, it could be just a map for width (0 => 240, 1 => 480, 2 => 720)
   */
  Events.PLAYBACK_BITRATE = "playback:bitrate";
  /**
   * Fired when the playback has its levels
   *
   * @event PLAYBACK_LEVELS_AVAILABLE
   * @param {Array} levels
   * the ordered levels, each one with the following format `{id: 1, label: '500kbps'}` ps: id should be a number >= 0
   * @param {Number} initial
   * the initial level otherwise -1 (AUTO)
   */
  Events.PLAYBACK_LEVELS_AVAILABLE = "playback:levels:available";
  /**
   * Fired when the playback starts to switch level
   *
   * @event PLAYBACK_LEVEL_SWITCH_START
   *
   */
  Events.PLAYBACK_LEVEL_SWITCH_START = "playback:levels:switch:start";
  /**
   * Fired when the playback ends the level switch
   *
   * @event PLAYBACK_LEVEL_SWITCH_END
   *
   */
  Events.PLAYBACK_LEVEL_SWITCH_END = "playback:levels:switch:end";

  /**
   * Fired when playback internal state changes
   *
   * @event PLAYBACK_PLAYBACKSTATE
   * @param {Object} state Data
   * state object
   * @param {String} [state.type]
   * the playback type
   */
  Events.PLAYBACK_PLAYBACKSTATE = "playback:playbackstate";
  /**
   * Fired when DVR becomes enabled/disabled.
   *
   * @event PLAYBACK_DVR
   * @param {boolean} state true if dvr enabled
   */
  Events.PLAYBACK_DVR = "playback:dvr";
  // TODO doc
  Events.PLAYBACK_MEDIACONTROL_DISABLE = "playback:mediacontrol:disable";
  // TODO doc
  Events.PLAYBACK_MEDIACONTROL_ENABLE = "playback:mediacontrol:enable";
  /**
   * Fired when the media for a playback ends.
   *
   * @event PLAYBACK_ENDED
   * @param {String} name the name of the playback
   */
  Events.PLAYBACK_ENDED = "playback:ended";
  /**
   * Fired when user requests `play()`
   *
   * @event PLAYBACK_PLAY_INTENT
   */
  Events.PLAYBACK_PLAY_INTENT = "playback:play:intent";
  /**
   * Fired when the media for a playback starts playing.
   * This is not necessarily when the user requests `play()`
   * The media may have to buffer first.
   * I.e. `isPlaying()` might return `true` before this event is fired,
   * because `isPlaying()` represents the intended state.
   *
   * @event PLAYBACK_PLAY
   */
  Events.PLAYBACK_PLAY = "playback:play";
  /**
   * Fired when the media for a playback pauses.
   *
   * @event PLAYBACK_PAUSE
   */
  Events.PLAYBACK_PAUSE = "playback:pause";
  /**
   * Fired when the media for a playback is seeking.
   *
   * @event PLAYBACK_SEEK
   */
  Events.PLAYBACK_SEEK = "playback:seek";
  /**
   * Fired when the media for a playback is seeked.
   *
   * @event PLAYBACK_SEEKED
   */
  Events.PLAYBACK_SEEKED = "playback:seeked";
  /**
   * Fired when the media for a playback is stopped.
   *
   * @event PLAYBACK_STOP
   */
  Events.PLAYBACK_STOP = "playback:stop";
  /**
   * Fired if an error occurs in the playback.
   *
   * @event PLAYBACK_ERROR
   * @param {Object} error An object containing the error details
   * @param {String} name Playback name
   */
  Events.PLAYBACK_ERROR = "playback:error";
  // TODO doc
  Events.PLAYBACK_STATS_ADD = "playback:stats:add";
  // TODO doc
  Events.PLAYBACK_FRAGMENT_LOADED = "playback:fragment:loaded";
  // TODO doc
  Events.PLAYBACK_LEVEL_SWITCH = "playback:level:switch";
  /**
   * Fired when subtitle is available on playback for display
   *
   * @event PLAYBACK_SUBTITLE_AVAILABLE
   */
  Events.PLAYBACK_SUBTITLE_AVAILABLE = "playback:subtitle:available";
  /**
   * Fired when playback subtitle track has changed
   *
   * @event CONTAINER_SUBTITLE_CHANGED
   * @param {Object} track Data
   * track object
   * @param {Number} [track.id]
   * selected track id
   */
  Events.PLAYBACK_SUBTITLE_CHANGED = "playback:subtitle:changed";

  /**
   * Fired when audio tracks are available to be used on the playback
   * @event PLAYBACK_AUDIO_AVAILABLE
   * @param {import('../playback/playback').AudioTrack[]} tracks - list of available audio tracks
   */
  Events.PLAYBACK_AUDIO_AVAILABLE = "playback:audio:available";

  /**
   * Fired whenever the current audio track has changed
   * @event PLAYBACK_AUDIO_CHANGED
   * @param {import('../playback/playback').AudioTrack} track - audio track active after change
   */
  Events.PLAYBACK_AUDIO_CHANGED = "playback:audio:changed";

  // Core Events
  /**
   * Fired when the containers are created
   *
   * @event CORE_CONTAINERS_CREATED
   */
  Events.CORE_CONTAINERS_CREATED = "core:containers:created";
  /**
   * Fired when the active container changed
   *
   * @event CORE_ACTIVE_CONTAINER_CHANGED
   */
  Events.CORE_ACTIVE_CONTAINER_CHANGED = "core:active:container:changed";
  /**
   * Fired when the options were changed for the core
   *
   * @event CORE_OPTIONS_CHANGE
   * @param {Object} new options provided to configure() method
   */
  Events.CORE_OPTIONS_CHANGE = "core:options:change";
  /**
   * Fired after creating containers, when the core is ready
   *
   * @event CORE_READY
   */
  Events.CORE_READY = "core:ready";
  /**
   * Fired when the fullscreen state change
   *
   * @event CORE_FULLSCREEN
   * @param {Boolean} whether or not the player is on fullscreen mode
   */
  Events.CORE_FULLSCREEN = "core:fullscreen";
  /**
   * Fired when core updates size
   *
   * @event CORE_RESIZE
   * @param {Object} currentSize an object with the current size
   */
  Events.CORE_RESIZE = "core:resize";
  /**
   * Fired when the screen orientation has changed.
   * This event is trigger only for mobile devices.
   *
   * @event CORE_SCREEN_ORIENTATION_CHANGED
   * @param {Object} screen An object with screen orientation
   * screen object
   * @param {Object} [screen.event]
   * window resize event object
   * @param {String} [screen.orientation]
   * screen orientation (ie: 'landscape' or 'portrait')
   */
  Events.CORE_SCREEN_ORIENTATION_CHANGED = "core:screen:orientation:changed";
  /**
   * Fired when occurs mouse move event on core element
   *
   * @event CORE_MOUSE_MOVE
   * @param {Object} event a DOM event
   */
  Events.CORE_MOUSE_MOVE = "core:mousemove";
  /**
   * Fired when occurs mouse leave event on core element
   *
   * @event CORE_MOUSE_LEAVE
   * @param {Object} event a DOM event
   */
  Events.CORE_MOUSE_LEAVE = "core:mouseleave";

  // Container Events
  /**
   * Fired when the container internal state changes
   *
   * @event CONTAINER_PLAYBACKSTATE
   * @param {Object} state Data
   * state object
   * @param {String} [state.type]
   * the playback type
   */
  Events.CONTAINER_PLAYBACKSTATE = "container:playbackstate";
  Events.CONTAINER_PLAYBACKDVRSTATECHANGED = "container:dvr";
  /**
   * Fired when the container updates its bitrate
   *
   * @event CONTAINER_BITRATE
   * @param {Object} bitrate Data
   * bitrate object
   * @param {Number} [bitrate.bandwidth]
   * bitrate bandwidth when it's available
   * @param {Number} [bitrate.width]
   * playback width (ex: 720, 640, 1080)
   * @param {Number} [bitrate.height]
   * playback height (ex: 240, 480, 720)
   * @param {Number} [bitrate.level]
   * playback level when it's available, it could be just a map for width (0 => 240, 1 => 480, 2 => 720)
   */
  Events.CONTAINER_BITRATE = "container:bitrate";
  Events.CONTAINER_STATS_REPORT = "container:stats:report";
  Events.CONTAINER_DESTROYED = "container:destroyed";
  /**
   * Fired when the container is ready
   *
   * @event CONTAINER_READY
   */
  Events.CONTAINER_READY = "container:ready";

  /**
   * Fired when the container was resized.
   *
   * Some fullscreen modes won't trigger this resize since they don't affect the container, only the playback contents.
   *
   * @event CONTAINER_RESIZE
   */
  Events.CONTAINER_RESIZE = "container:resize";
  Events.CONTAINER_ERROR = "container:error";
  /**
   * Fired when the container loaded its metadata
   *
   * @event CONTAINER_LOADEDMETADATA
   * @param {Object} metadata Data
   * settings object
   * @param {Number} [metadata.duration]
   * the playback duration
   * @param {Object} [metadata.data]
   * extra meta data
   */
  Events.CONTAINER_LOADEDMETADATA = "container:loadedmetadata";

  /**
   * Fired when subtitle is available on container for display
   *
   * @event CONTAINER_SUBTITLE_AVAILABLE
   */
  Events.CONTAINER_SUBTITLE_AVAILABLE = "container:subtitle:available";
  /**
   * Fired when subtitle track has changed
   *
   * @event CONTAINER_SUBTITLE_CHANGED
   * @param {Object} track Data
   * track object
   * @param {Number} [track.id]
   * selected track id
   */
  Events.CONTAINER_SUBTITLE_CHANGED = "container:subtitle:changed";

  /**
   * Fired when audio tracks are available to be used on the container
   * @event CONTAINER_AUDIO_AVAILABLE
   * @param {import('../playback/playback').AudioTrack[]} tracks - list of available audio tracks
   */
  Events.CONTAINER_AUDIO_AVAILABLE = "container:audio:available";

  /**
    * Fired whenever the current audio track has changed
    * @event CONTAINER_AUDIO_CHANGED
    * @param {import('../playback/playback').AudioTrack} track - audio track active after change
    */
  Events.CONTAINER_AUDIO_CHANGED = "container:audio:changed";

  /**
   * Fired when the time is updated on container
   *
   * @event CONTAINER_TIMEUPDATE
   * @param {Object} progress Data
   * progress object
   * @param {Number} [progress.current]
   * current time (in seconds)
   * @param {Number} [progress.total]
   * total time (in seconds)
   */
  Events.CONTAINER_TIMEUPDATE = "container:timeupdate";
  /**
   * Fired when the container is downloading the media
   *
   * @event CONTAINER_PROGRESS
   * @param {Object} progress Data
   * progress object
   * @param {Number} [progress.start]
   * initial downloaded content
   * @param {Number} [progress.current]
   * current dowloaded content
   * @param {Number} [progress.total]
   * total content to be downloaded
   */
  Events.CONTAINER_PROGRESS = "container:progress";
  Events.CONTAINER_PLAY = "container:play";
  Events.CONTAINER_STOP = "container:stop";
  Events.CONTAINER_PAUSE = "container:pause";
  Events.CONTAINER_ENDED = "container:ended";
  Events.CONTAINER_CLICK = "container:click";
  Events.CONTAINER_DBLCLICK = "container:dblclick";
  Events.CONTAINER_CONTEXTMENU = "container:contextmenu";
  Events.CONTAINER_MOUSE_ENTER = "container:mouseenter";
  Events.CONTAINER_MOUSE_LEAVE = "container:mouseleave";
  Events.CONTAINER_MOUSE_UP = "container:mouseup";
  Events.CONTAINER_MOUSE_DOWN = "container:mousedown";

  /**
   * Fired when the container seeks the video
   *
   * @event CONTAINER_SEEK
   * @param {Number} time the current time in seconds
   */
  Events.CONTAINER_SEEK = "container:seek";
  /**
   * Fired when the container was finished the seek video
   *
   * @event CONTAINER_SEEKED
   * @param {Number} time the current time in seconds
   */
  Events.CONTAINER_SEEKED = "container:seeked";
  Events.CONTAINER_VOLUME = "container:volume";
  Events.CONTAINER_FULLSCREEN = "container:fullscreen";
  /**
   * Fired when container is buffering
   *
   * @event CONTAINER_STATE_BUFFERING
   */
  Events.CONTAINER_STATE_BUFFERING = "container:state:buffering";
  /**
   * Fired when the container filled the buffer
   *
   * @event CONTAINER_STATE_BUFFERFULL
   */
  Events.CONTAINER_STATE_BUFFERFULL = "container:state:bufferfull";
  /**
   * Fired when the container changes any settings (volume, seek and etc)
   *
   * @event CONTAINER_SETTINGSUPDATE
   */
  Events.CONTAINER_SETTINGSUPDATE = "container:settingsupdate";
  /**
   * Fired when container updates its video quality
   *
   * @event CONTAINER_HIGHDEFINITIONUPDATE
   * @param {Boolean} isHD
   * true when is on HD, false otherwise
   */
  Events.CONTAINER_HIGHDEFINITIONUPDATE = "container:highdefinitionupdate";

  /**
   * Fired when the media control shows
   *
   * @event CONTAINER_MEDIACONTROL_SHOW
   */
  Events.CONTAINER_MEDIACONTROL_SHOW = "container:mediacontrol:show";
  /**
   * Fired when the media control hides
   *
   * @event CONTAINER_MEDIACONTROL_HIDE
   */
  Events.CONTAINER_MEDIACONTROL_HIDE = "container:mediacontrol:hide";
  Events.CONTAINER_MEDIACONTROL_DISABLE = "container:mediacontrol:disable";
  Events.CONTAINER_MEDIACONTROL_ENABLE = "container:mediacontrol:enable";
  Events.CONTAINER_STATS_ADD = "container:stats:add";
  /**
   * Fired when the options were changed for the container
   *
   * @event CONTAINER_OPTIONS_CHANGE
   */
  Events.CONTAINER_OPTIONS_CHANGE = "container:options:change";

  // MediaControl Events
  Events.MEDIACONTROL_RENDERED = "mediacontrol:rendered";
  /**
   * Fired when the player enters/exit on fullscreen
   *
   * @event MEDIACONTROL_FULLSCREEN
   */
  Events.MEDIACONTROL_FULLSCREEN = "mediacontrol:fullscreen";
  /**
   * Fired when the media control shows
   *
   * @event MEDIACONTROL_SHOW
   */
  Events.MEDIACONTROL_SHOW = "mediacontrol:show";
  /**
   * Fired when the media control hides
   *
   * @event MEDIACONTROL_HIDE
   */
  Events.MEDIACONTROL_HIDE = "mediacontrol:hide";
  /**
   * Fired when mouse enters on the seekbar
   *
   * @event MEDIACONTROL_MOUSEMOVE_SEEKBAR
   * @param {Object} event
   * the javascript event
   */
  Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR = "mediacontrol:mousemove:seekbar";
  /**
   * Fired when mouse leaves the seekbar
   *
   * @event MEDIACONTROL_MOUSELEAVE_SEEKBAR
   * @param {Object} event
   * the javascript event
   */
  Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR = "mediacontrol:mouseleave:seekbar";
  /**
   * Fired when the media is being played
   *
   * @event MEDIACONTROL_PLAYING
   */
  Events.MEDIACONTROL_PLAYING = "mediacontrol:playing";
  /**
   * Fired when the media is not being played
   *
   * @event MEDIACONTROL_NOTPLAYING
   */
  Events.MEDIACONTROL_NOTPLAYING = "mediacontrol:notplaying";
  /**
   * Fired when the container was changed
   *
   * @event MEDIACONTROL_CONTAINERCHANGED
   */
  Events.MEDIACONTROL_CONTAINERCHANGED = "mediacontrol:containerchanged";
  /**
   * Fired when the options were changed for the mediacontrol
   *
   * @event MEDIACONTROL_OPTIONS_CHANGE
   */
  Events.MEDIACONTROL_OPTIONS_CHANGE = "mediacontrol:options:change";

  /**
   * @class BaseObject
   * @constructor
   * @extends Events
   * @module base
   */
  var BaseObject = /*#__PURE__*/function (_Events) {
    _inherits$2(BaseObject, _Events);
    var _super = _createSuper$2(BaseObject);
    /**
     * @method constructor
     * @param {Object} options
     */
    function BaseObject() {
      var _this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck$2(this || _global, BaseObject);
      _this = _super.call(this || _global, options);
      _this._options = options;
      _this.uniqueId = uniqueId("o");
      return _this;
    }
    /**
    * a unique id prefixed with `'o'`, `o1, o232`
    *
    * @property uniqueId
    * @type String
    */
    _createClass$2(BaseObject, [{
      key: "options",
      get:
      /**
       * returns the object options
       * @property options
       * @type Object
       */
      function get() {
        return (this || _global)._options;
      }
    }]);
    return BaseObject;
  }(Events);

  /* eslint-disable no-var */
  // Simple JavaScript Templating
  // Paul Miller (http://paulmillr.com)
  // http://underscorejs.org
  // (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  var settings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    "\\": "\\",
    "\r": "r",
    "\n": "n",
    "\t": "t",
    "\u2028": "u2028",
    "\u2029": "u2029"
  };
  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

  // List of HTML entities for escaping.
  var htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#x27;"
  };
  var entityRe = new RegExp("[&<>\"']", "g");
  var escapeExpr = function escapeExpr(string) {
    if (string === null) return "";
    return ("" + string).replace(entityRe, function (match) {
      return htmlEntities[match];
    });
  };
  var counter = 0;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  var tmpl = function tmpl(text, data) {
    var render;

    // Combine delimiters into one regular expression via alternation.
    var matcher = new RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join("|") + "|$", "g");

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, function (match) {
        return "\\" + escapes[match];
      });
      if (escape) source += "'+\n((__t=(" + escape + "))==null?'':escapeExpr(__t))+\n'";
      if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      if (evaluate) source += "';\n" + evaluate + "\n__p+='";
      index = offset + match.length;
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = "with(obj||{}){\n" + source + "}\n";
    source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n//# sourceURL=/microtemplates/source[" + counter++ + "]";
    try {
      /*jshint -W054 */
      // TODO: find a way to avoid eval
      render = new Function(settings.variable || "obj", "escapeExpr", source);
    } catch (e) {
      e.source = source;
      throw e;
    }
    if (data) return render(data, escapeExpr);
    var template = function template(data) {
      return render.call(this || _global, data, escapeExpr);
    };

    // Provide the compiled function source as a convenience for precompilation.
    template.source = "function(" + (settings.variable || "obj") + "){\n" + source + "}";
    return template;
  };
  tmpl.settings = settings;

  // Copyright 2014 Globo.com Player authors. All rights reserved.
  var Styler = {
    getStyleFor: function getStyleFor(style) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        baseUrl: ""
      };
      return zepto("<style class=\"clappr-style\"></style>").html(tmpl(style.toString())(options));
    }
  };
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  /**
   * A base class to create ui object.
   * @class UIObject
   * @constructor
   * @extends BaseObject
   * @module base
   */
  var UIObject = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(UIObject, _BaseObject);
    var _super = _createSuper$2(UIObject);
    /**
     * it builds an ui component by:
     *  * creating an id for the component `cid`
     *  * making sure the element is created `$el`
     *  * delegating all `events` to the element
     * @method constructor
     * @param {Object} options the options object
     */
    function UIObject(options) {
      var _this;
      _classCallCheck$2(this || _global, UIObject);
      _this = _super.call(this || _global, options);
      _this.cid = uniqueId("c");
      _this._ensureElement();
      _this.delegateEvents();
      return _this;
    }

    /**
     * selects within the component.
     * @method $
     * @param {String} selector a selector to find within the component.
     * @return {HTMLElement} an element, if it exists.
     * @example
     * ```javascript
     * fullScreenBarUIComponent.$('.button-full') //will return only `.button-full` within the component
     * ```
     */
    _createClass$2(UIObject, [{
      key: "tagName",
      get:
      /**
       * a unique id prefixed with `'c'`, `c1, c232`
       *
       * @property cid
       * @type String
       */
      /**
       * the dom element itself
       *
       * @property el
       * @type HTMLElement
       */
      /**
       * the dom element wrapped by `$`
       *
       * @property $el
       * @type HTMLElement
       */

      /**
       * gets the tag name for the ui component
       * @method tagName
       * @default div
       * @return {String} tag's name
       */
      function get() {
        return "div";
      }
      /**
       * a literal object mapping element's events to methods
       * @property events
       * @type Object
       * @example
       *
       *```javascript
       *
       * class MyButton extends UIObject {
       *   constructor(options) {
       *     super(options)
       *     this.myId = 0
       *   }
       *   get events() { return { 'click': 'myClick' } }
       *   myClick(){ this.myId = 42 }
       * }
       *
       * // when you click on MyButton the method `myClick` will be called
       *```
       */
    }, {
      key: "events",
      get: function get() {
        return {};
      }
      /**
       * a literal object mapping attributes and values to the element
       * element's attribute name and the value the attribute value
       * @property attributes
       * @type Object
       * @example
       *
       *```javascript
       *
       * class MyButton extends UIObject {
       *    constructor(options) { super(options) }
       *    get attributes() { return { class: 'my-button'} }
       * }
       *
       * // MyButton.el.className will be 'my-button'
       * ```
       */
    }, {
      key: "attributes",
      get: function get() {
        return {};
      }
    }, {
      key: "$",
      value: function $(selector) {
        return (this || _global).$el.find(selector);
      }

      /**
       * render the component, usually attach it to a real existent `element`
       * @method render
       * @return {UIObject} itself
       */
    }, {
      key: "render",
      value: function render() {
        return this || _global;
      }

      /**
       * removes the ui component from DOM
       * @method destroy
       * @return {UIObject} itself
       */
    }, {
      key: "destroy",
      value: function destroy() {
        (this || _global).$el.remove();
        this.stopListening();
        this.undelegateEvents();
        return this || _global;
      }

      /**
       * set element to `el` and `$el`
       * @method setElement
       * @param {HTMLElement} element
       * @param {Boolean} delegate whether is delegate or not
       * @return {UIObject} itself
       */
    }, {
      key: "setElement",
      value: function setElement(element, delegate) {
        if ((this || _global).$el) this.undelegateEvents();
        (this || _global).$el = zepto.zepto.isZ(element) ? element : zepto(element);
        (this || _global).el = (this || _global).$el[0];
        if (delegate !== false) this.delegateEvents();
        return this || _global;
      }

      /**
       * delegates all the original `events` on `element` to its callbacks
       * @method delegateEvents
       * @param {Object} events
       * @return {UIObject} itself
       */
    }, {
      key: "delegateEvents",
      value: function delegateEvents(events) {
        if (!events) events = (this || _global).events;
        this.undelegateEvents();
        for (var key in events) {
          var method = events[key];
          if (method && method.constructor !== Function) method = (this || _global)[events[key]];
          if (!method) continue;
          var match = key.match(delegateEventSplitter);
          var eventName = match[1],
            selector = match[2];
          eventName += ".delegateEvents" + (this || _global).cid;
          if (selector === "") (this || _global).$el.on(eventName, method.bind(this || _global));else (this || _global).$el.on(eventName, selector, method.bind(this || _global));
        }
        return this || _global;
      }

      /**
       * undelegats all the `events`
       * @method undelegateEvents
       * @return {UIObject} itself
       */
    }, {
      key: "undelegateEvents",
      value: function undelegateEvents() {
        (this || _global).$el.off(".delegateEvents" + (this || _global).cid);
        return this || _global;
      }

      /**
       * ensures the creation of this ui component
       * @method _ensureElement
       * @private
       */
    }, {
      key: "_ensureElement",
      value: function _ensureElement() {
        if (!(this || _global).el) {
          var attrs = zepto.extend(true, {}, (this || _global).attributes);
          if ((this || _global).id) attrs.id = (this || _global).id;
          if ((this || _global).className) attrs["class"] = (this || _global).className;
          var $el = zepto(DomRecycler.create((this || _global).tagName)).attr(attrs);
          this.setElement($el, false);
        } else {
          this.setElement((this || _global).el, false);
        }
      }
    }]);
    return UIObject;
  }(BaseObject);

  /**
   * The PlayerError is responsible to receive and propagate errors.
   * @class PlayerError
   * @constructor
   * @extends BaseObject
   * @module components
   */
  var PlayerError = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(PlayerError, _BaseObject);
    var _super = _createSuper$2(PlayerError);
    function PlayerError() {
      var _this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var core = arguments.length > 1 ? arguments[1] : undefined;
      _classCallCheck$2(this || _global, PlayerError);
      _this = _super.call(this || _global, options);
      _this.core = core;
      return _this;
    }

    /**
     * creates and trigger an error.
     * @method createError
     * @param {Object} err should be an object with code, description, level, origin, scope and raw error.
     */
    _createClass$2(PlayerError, [{
      key: "name",
      get: function get() {
        return "error";
      }

      /**
       * @property Levels
       * @type {Object} object with error levels
       */
    }, {
      key: "createError",
      value: function createError(err) {
        if (!(this || _global).core) {
          Log.warn((this || _global).name, "Core is not set. Error: ", err);
          return;
        }
        (this || _global).core.trigger(Events.ERROR, err);
      }
    }], [{
      key: "Levels",
      get: function get() {
        return {
          FATAL: "FATAL",
          WARN: "WARN",
          INFO: "INFO"
        };
      }
    }]);
    return PlayerError;
  }(BaseObject);
  var ErrorMixin = {
    /**
     * creates an error.
     * @method createError
     * @param {Object} error should be an object with code, description, level and raw error.
     * @return {Object} Object with formatted error data including origin and scope
     */
    createError: function createError(error) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        useCodePrefix: true
      };
      var scope = (this || _global).constructor && (this || _global).constructor.type || "";
      var origin = (this || _global).name || scope;
      var i18n = (this || _global).i18n || (this || _global).core && (this || _global).core.i18n || (this || _global).container && (this || _global).container.i18n;
      var prefixedCode = "".concat(origin, ":").concat(error && error.code || "unknown");
      var defaultError = {
        description: "",
        level: PlayerError.Levels.FATAL,
        origin: origin,
        scope: scope,
        raw: {}
      };
      var errorData = Object.assign({}, defaultError, error, {
        code: options.useCodePrefix ? prefixedCode : error.code
      });
      if (i18n && errorData.level == PlayerError.Levels.FATAL && !errorData.UI) {
        var defaultUI = {
          title: i18n.t("default_error_title"),
          message: i18n.t("default_error_message")
        };
        errorData.UI = defaultUI;
      }
      (this || _global).playerError ? (this || _global).playerError.createError(errorData) : Log.warn(origin, "PlayerError is not defined. Error: ", errorData);
      return errorData;
    }
  };
  var UICorePlugin = /*#__PURE__*/function (_UIObject) {
    _inherits$2(UICorePlugin, _UIObject);
    var _super = _createSuper$2(UICorePlugin);
    function UICorePlugin(core) {
      var _this;
      _classCallCheck$2(this || _global, UICorePlugin);
      _this = _super.call(this || _global, core.options);
      _this.core = core;
      _this.enabled = true;
      _this.bindEvents();
      _this.render();
      return _this;
    }
    _createClass$2(UICorePlugin, [{
      key: "playerError",
      get: function get() {
        return (this || _global).core.playerError;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {}
    }, {
      key: "getExternalInterface",
      value: function getExternalInterface() {
        return {};
      }
    }, {
      key: "enable",
      value: function enable() {
        if (!(this || _global).enabled) {
          this.bindEvents();
          (this || _global).$el.show();
          (this || _global).enabled = true;
        }
      }
    }, {
      key: "disable",
      value: function disable() {
        this.stopListening();
        (this || _global).$el.hide();
        (this || _global).enabled = false;
      }
    }, {
      key: "render",
      value: function render() {
        return this || _global;
      }
    }]);
    return UICorePlugin;
  }(UIObject);
  Object.assign(UICorePlugin.prototype, ErrorMixin);
  UICorePlugin.extend = function (properties) {
    return extend$1(UICorePlugin, properties);
  };
  UICorePlugin.type = "core";
  var css_248z$5$1 = ".container[data-container] {\n  position: absolute;\n  background-color: black;\n  height: 100%;\n  width: 100%;\n  max-width: 100%; }\n  .container[data-container] .chromeless {\n    cursor: default; }\n\n[data-player]:not(.nocursor) .container[data-container]:not(.chromeless).pointer-enabled {\n  cursor: pointer; }\n";

  /**
   * An abstraction to represent a container for a given playback
   * TODO: describe its responsabilities
   * @class Container
   * @constructor
   * @extends UIObject
   * @module base
   */
  var Container = /*#__PURE__*/function (_UIObject) {
    _inherits$2(Container, _UIObject);
    var _super = _createSuper$2(Container);
    /**
     * it builds a container
     * @method constructor
     * @param {Object} options the options object
     * @param {Strings} i18n the internationalization component
     */
    function Container(options, i18n, playerError) {
      var _this;
      _classCallCheck$2(this || _global, Container);
      _this = _super.call(this || _global, options);
      _this._i18n = i18n;
      _this.currentTime = 0;
      _this.volume = 100;
      _this.playback = options.playback;
      _this.playerError = playerError;
      _this.settings = zepto.extend(true, {}, _this.playback.settings);
      _this.isReady = false;
      _this.mediaControlDisabled = false;
      _this.plugins = [_this.playback];
      _this.dblTapHandler = new DoubleEventHandler(500);
      _this.clickTimer = null;
      _this.clickDelay = 200; // FIXME: could be a player option
      _this.actionsMetadata = {};
      _this.bindEvents();
      return _this;
    }

    /**
     * binds playback events to the methods of the container.
     * it listens to playback's events and triggers them as container events.
     *
     * | Playback |
     * |----------|
     * | progress |
     * | timeupdate |
     * | ready |
     * | buffering |
     * | bufferfull |
     * | settingsupdate |
     * | loadedmetadata |
     * | highdefinitionupdate |
     * | bitrate |
     * | playbackstate |
     * | dvr |
     * | mediacontrol_disable |
     * | mediacontrol_enable |
     * | ended |
     * | play |
     * | pause |
     * | error |
     *
     * ps: the events usually translate from PLABACK_x to CONTAINER_x, you can check all the events at `Event` class.
     *
     * @method bindEvents
     */
    _createClass$2(Container, [{
      key: "name",
      get:
      /**
       * container's name
       * @method name
       * @default Container
       * @return {String} container's name
       */
      function get() {
        return "Container";
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "container",
          "data-container": ""
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "click": "clicked",
          "dblclick": "dblClicked",
          "touchend": "dblTap",
          "contextmenu": "onContextMenu",
          "mouseenter": "mouseEnter",
          "mouseleave": "mouseLeave",
          "mouseup": "onMouseUp",
          "mousedown": "onMouseDown"
        };
      }

      /**
       * Determine if the playback has ended.
       * @property ended
       * @type Boolean
       */
    }, {
      key: "ended",
      get: function get() {
        return (this || _global).playback.ended;
      }

      /**
       * Determine if the playback is having to buffer in order for
       * playback to be smooth.
       * (i.e if a live stream is playing smoothly, this will be false)
       * @property buffering
       * @type Boolean
       */
    }, {
      key: "buffering",
      get: function get() {
        return (this || _global).playback.buffering;
      }

      /**
       * The internationalization plugin.
       * @property i18n
       * @type {Strings}
       */
    }, {
      key: "i18n",
      get: function get() {
        return (this || _global)._i18n;
      }

      /**
       * checks if has closed caption tracks.
       * @property hasClosedCaptionsTracks
       * @type {Boolean}
       */
    }, {
      key: "hasClosedCaptionsTracks",
      get: function get() {
        return (this || _global).playback.hasClosedCaptionsTracks;
      }

      /**
       * gets the available closed caption tracks.
       * @property closedCaptionsTracks
       * @type {Array} an array of objects with at least 'id' and 'name' properties
       */
    }, {
      key: "closedCaptionsTracks",
      get: function get() {
        return (this || _global).playback.closedCaptionsTracks;
      }

      /**
       * gets the selected closed caption track index. (-1 is disabled)
       * @property closedCaptionsTrackId
       * @type {Number}
       */
    }, {
      key: "closedCaptionsTrackId",
      get: function get() {
        return (this || _global).playback.closedCaptionsTrackId;
      }

      /**
       * sets the selected closed caption track index. (-1 is disabled)
       * @property closedCaptionsTrackId
       * @type {Number}
       */,
      set: function set(trackId) {
        (this || _global).playback.closedCaptionsTrackId = trackId;
      }

      /**
       * returns a list of the available audio tracks.
       * @type {import('../../base/playback/playback').AudioTrack[]} audio tracks
       */
    }, {
      key: "audioTracks",
      get: function get() {
        return (this || _global).playback.audioTracks;
      }

      /**
      * returns the audio track currently in use.
      * @type {import('../../base/playback/playback').AudioTrack} audio track
      */
    }, {
      key: "currentAudioTrack",
      get: function get() {
        return (this || _global).playback.currentAudioTrack;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).playback, Events.PLAYBACK_PROGRESS, (this || _global).onProgress);
        this.listenTo((this || _global).playback, Events.PLAYBACK_TIMEUPDATE, (this || _global).timeUpdated);
        this.listenTo((this || _global).playback, Events.PLAYBACK_READY, (this || _global).ready);
        this.listenTo((this || _global).playback, Events.PLAYBACK_BUFFERING, (this || _global).onBuffering);
        this.listenTo((this || _global).playback, Events.PLAYBACK_BUFFERFULL, (this || _global).bufferfull);
        this.listenTo((this || _global).playback, Events.PLAYBACK_SETTINGSUPDATE, (this || _global).settingsUpdate);
        this.listenTo((this || _global).playback, Events.PLAYBACK_LOADEDMETADATA, (this || _global).loadedMetadata);
        this.listenTo((this || _global).playback, Events.PLAYBACK_HIGHDEFINITIONUPDATE, (this || _global).highDefinitionUpdate);
        this.listenTo((this || _global).playback, Events.PLAYBACK_BITRATE, (this || _global).updateBitrate);
        this.listenTo((this || _global).playback, Events.PLAYBACK_PLAYBACKSTATE, (this || _global).playbackStateChanged);
        this.listenTo((this || _global).playback, Events.PLAYBACK_DVR, (this || _global).playbackDvrStateChanged);
        this.listenTo((this || _global).playback, Events.PLAYBACK_MEDIACONTROL_DISABLE, (this || _global).disableMediaControl);
        this.listenTo((this || _global).playback, Events.PLAYBACK_MEDIACONTROL_ENABLE, (this || _global).enableMediaControl);
        this.listenTo((this || _global).playback, Events.PLAYBACK_SEEK, (this || _global).onSeek);
        this.listenTo((this || _global).playback, Events.PLAYBACK_SEEKED, (this || _global).onSeeked);
        this.listenTo((this || _global).playback, Events.PLAYBACK_ENDED, (this || _global).onEnded);
        this.listenTo((this || _global).playback, Events.PLAYBACK_PLAY, (this || _global).playing);
        this.listenTo((this || _global).playback, Events.PLAYBACK_PAUSE, (this || _global).paused);
        this.listenTo((this || _global).playback, Events.PLAYBACK_STOP, (this || _global).stopped);
        this.listenTo((this || _global).playback, Events.PLAYBACK_ERROR, (this || _global).error);
        this.listenTo((this || _global).playback, Events.PLAYBACK_SUBTITLE_AVAILABLE, (this || _global).subtitleAvailable);
        this.listenTo((this || _global).playback, Events.PLAYBACK_SUBTITLE_CHANGED, (this || _global).subtitleChanged);
        this.listenTo((this || _global).playback, Events.PLAYBACK_AUDIO_AVAILABLE, (this || _global).audioAvailable);
        this.listenTo((this || _global).playback, Events.PLAYBACK_AUDIO_CHANGED, (this || _global).audioChanged);
      }
    }, {
      key: "subtitleAvailable",
      value: function subtitleAvailable() {
        this.trigger(Events.CONTAINER_SUBTITLE_AVAILABLE);
      }
    }, {
      key: "subtitleChanged",
      value: function subtitleChanged(track) {
        this.trigger(Events.CONTAINER_SUBTITLE_CHANGED, track);
      }
    }, {
      key: "audioAvailable",
      value: function audioAvailable(tracks) {
        this.trigger(Events.CONTAINER_AUDIO_AVAILABLE, tracks);
      }
    }, {
      key: "audioChanged",
      value: function audioChanged(track) {
        this.trigger(Events.CONTAINER_AUDIO_CHANGED, track);
      }
    }, {
      key: "playbackStateChanged",
      value: function playbackStateChanged(state) {
        this.trigger(Events.CONTAINER_PLAYBACKSTATE, state);
      }
    }, {
      key: "playbackDvrStateChanged",
      value: function playbackDvrStateChanged(dvrInUse) {
        (this || _global).settings = (this || _global).playback.settings;
        (this || _global).dvrInUse = dvrInUse;
        this.trigger(Events.CONTAINER_PLAYBACKDVRSTATECHANGED, dvrInUse);
      }
    }, {
      key: "updateBitrate",
      value: function updateBitrate(newBitrate) {
        this.trigger(Events.CONTAINER_BITRATE, newBitrate);
      }
    }, {
      key: "statsReport",
      value: function statsReport(metrics) {
        this.trigger(Events.CONTAINER_STATS_REPORT, metrics);
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return (this || _global).playback.getPlaybackType();
      }

      /**
       * returns `true` if DVR is enable otherwise `false`.
       * @method isDvrEnabled
       * @return {Boolean}
       */
    }, {
      key: "isDvrEnabled",
      value: function isDvrEnabled() {
        return !!(this || _global).playback.dvrEnabled;
      }

      /**
       * returns `true` if DVR is in use otherwise `false`.
       * @method isDvrInUse
       * @return {Boolean}
       */
    }, {
      key: "isDvrInUse",
      value: function isDvrInUse() {
        return !!(this || _global).dvrInUse;
      }

      /**
       * destroys the container
       * @method destroy
       */
    }, {
      key: "destroy",
      value: function destroy() {
        this.disableResizeObserver();
        this.trigger(Events.CONTAINER_DESTROYED, this || _global, (this || _global).name);
        this.stopListening();
        (this || _global).plugins.forEach(function (plugin) {
          return plugin.destroy();
        });
        (this || _global).$el.remove();
      }
    }, {
      key: "setStyle",
      value: function setStyle(style) {
        (this || _global).$el.css(style);
      }
    }, {
      key: "animate",
      value: function animate(style, duration) {
        return (this || _global).$el.animate(style, duration).promise();
      }
    }, {
      key: "ready",
      value: function ready() {
        (this || _global).isReady = true;
        this.trigger(Events.CONTAINER_READY, (this || _global).name);
      }
    }, {
      key: "isPlaying",
      value: function isPlaying() {
        return (this || _global).playback.isPlaying();
      }
    }, {
      key: "getStartTimeOffset",
      value: function getStartTimeOffset() {
        return (this || _global).playback.getStartTimeOffset();
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return (this || _global).currentTime;
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        return (this || _global).playback.getDuration();
      }
    }, {
      key: "error",
      value: function error(_error) {
        if (!(this || _global).isReady) this.ready();
        this.trigger(Events.CONTAINER_ERROR, _error, (this || _global).name);
      }
    }, {
      key: "loadedMetadata",
      value: function loadedMetadata(metadata) {
        this.trigger(Events.CONTAINER_LOADEDMETADATA, metadata);
      }
    }, {
      key: "timeUpdated",
      value: function timeUpdated(timeProgress) {
        (this || _global).currentTime = timeProgress.current;
        this.trigger(Events.CONTAINER_TIMEUPDATE, timeProgress, (this || _global).name);
      }
    }, {
      key: "onProgress",
      value: function onProgress() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        (this || _global).trigger.apply(this || _global, [Events.CONTAINER_PROGRESS].concat(args, [(this || _global).name]));
      }
    }, {
      key: "playing",
      value: function playing() {
        this.trigger(Events.CONTAINER_PLAY, (this || _global).name, (this || _global).actionsMetadata.playEvent || {});
        (this || _global).actionsMetadata.playEvent = {};
      }
    }, {
      key: "paused",
      value: function paused() {
        this.trigger(Events.CONTAINER_PAUSE, (this || _global).name, (this || _global).actionsMetadata.pauseEvent || {});
        (this || _global).actionsMetadata.pauseEvent = {};
      }
    }, {
      key: "stopped",
      value: function stopped() {
        this.trigger(Events.CONTAINER_STOP, (this || _global).actionsMetadata.stopEvent || {});
        (this || _global).actionsMetadata.stopEvent = {};
      }

      /**
       * plays the playback
       * @method play
       * @param {Object} customData
       */
    }, {
      key: "play",
      value: function play() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).actionsMetadata.playEvent = customData;
        (this || _global).playback.play(customData);
      }

      /**
       * stops the playback
       * @method stop
       * @param {Object} customData
       */
    }, {
      key: "stop",
      value: function stop() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).actionsMetadata.stopEvent = customData;
        (this || _global).playback.stop(customData);
        (this || _global).currentTime = 0;
      }
    }, {
      key: "switchAudioTrack",
      value: function switchAudioTrack(id) {
        (this || _global).playback.switchAudioTrack(id);
      }

      /**
       * pauses the playback
       * @method pause
       * @param {Object} customData
       */
    }, {
      key: "pause",
      value: function pause() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).actionsMetadata.pauseEvent = customData;
        (this || _global).playback.pause(customData);
      }
    }, {
      key: "onEnded",
      value: function onEnded() {
        this.trigger(Events.CONTAINER_ENDED, this || _global, (this || _global).name);
        (this || _global).currentTime = 0;
      }
    }, {
      key: "clicked",
      value: function clicked() {
        var _this2 = this || _global;
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) {
          // The event is delayed because it can be canceled by a double-click event
          // An example of use is to prevent playback from pausing when switching to full screen
          (this || _global).clickTimer = setTimeout(function () {
            _this2.clickTimer && _this2.trigger(Events.CONTAINER_CLICK, _this2, _this2.name);
          }, (this || _global).clickDelay);
        }
      }
    }, {
      key: "cancelClicked",
      value: function cancelClicked() {
        clearTimeout((this || _global).clickTimer);
        (this || _global).clickTimer = null;
      }
    }, {
      key: "dblClicked",
      value: function dblClicked() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) {
          this.cancelClicked();
          this.trigger(Events.CONTAINER_DBLCLICK, this || _global, (this || _global).name);
        }
      }
    }, {
      key: "dblTap",
      value: function dblTap(evt) {
        var _this3 = this || _global;
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) {
          (this || _global).dblTapHandler.handle(evt, function () {
            _this3.cancelClicked();
            _this3.trigger(Events.CONTAINER_DBLCLICK, _this3, _this3.name);
          });
        }
      }
    }, {
      key: "onContextMenu",
      value: function onContextMenu(event) {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) this.trigger(Events.CONTAINER_CONTEXTMENU, event, (this || _global).name);
      }
    }, {
      key: "seek",
      value: function seek(time) {
        (this || _global).playback.seek(time);
      }
    }, {
      key: "onSeek",
      value: function onSeek(time) {
        this.trigger(Events.CONTAINER_SEEK, time, (this || _global).name);
      }
    }, {
      key: "onSeeked",
      value: function onSeeked() {
        this.trigger(Events.CONTAINER_SEEKED, (this || _global).name);
      }
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {
        var duration = this.getDuration();
        if (percentage >= 0 && percentage <= 100) {
          var time = duration * (percentage / 100);
          this.seek(time);
        }
      }
    }, {
      key: "setVolume",
      value: function setVolume(value) {
        (this || _global).volume = parseFloat(value);
        this.trigger(Events.CONTAINER_VOLUME, (this || _global).volume, (this || _global).name);
        (this || _global).playback.volume((this || _global).volume);
      }
    }, {
      key: "fullscreen",
      value: function fullscreen() {
        this.trigger(Events.CONTAINER_FULLSCREEN, (this || _global).name);
      }
    }, {
      key: "onBuffering",
      value: function onBuffering() {
        this.trigger(Events.CONTAINER_STATE_BUFFERING, (this || _global).name);
      }
    }, {
      key: "bufferfull",
      value: function bufferfull() {
        this.trigger(Events.CONTAINER_STATE_BUFFERFULL, (this || _global).name);
      }

      /**
       * adds plugin to the container
       * @method addPlugin
       * @param {Object} plugin
       */
    }, {
      key: "addPlugin",
      value: function addPlugin(plugin) {
        (this || _global).plugins.push(plugin);
      }

      /**
       * checks if a plugin, given its name, exist
       * @method hasPlugin
       * @param {String} name
       * @return {Boolean}
       */
    }, {
      key: "hasPlugin",
      value: function hasPlugin(name) {
        return !!this.getPlugin(name);
      }

      /**
       * get the plugin given its name
       * @method getPlugin
       * @param {String} name
       */
    }, {
      key: "getPlugin",
      value: function getPlugin(name) {
        return (this || _global).plugins.filter(function (plugin) {
          return plugin.name === name;
        })[0];
      }
    }, {
      key: "mouseEnter",
      value: function mouseEnter() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) this.trigger(Events.CONTAINER_MOUSE_ENTER);
      }
    }, {
      key: "mouseLeave",
      value: function mouseLeave() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) this.trigger(Events.CONTAINER_MOUSE_LEAVE);
      }
    }, {
      key: "mouseUp",
      value: function mouseUp() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) this.trigger(Events.CONTAINER_MOUSE_UP);
      }
    }, {
      key: "mouseDown",
      value: function mouseDown() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) this.trigger(Events.CONTAINER_MOUSE_DOWN);
      }
    }, {
      key: "settingsUpdate",
      value: function settingsUpdate() {
        (this || _global).settings = (this || _global).playback.settings;
        this.trigger(Events.CONTAINER_SETTINGSUPDATE);
      }
    }, {
      key: "highDefinitionUpdate",
      value: function highDefinitionUpdate(isHD) {
        this.trigger(Events.CONTAINER_HIGHDEFINITIONUPDATE, isHD);
      }
    }, {
      key: "isHighDefinitionInUse",
      value: function isHighDefinitionInUse() {
        return (this || _global).playback.isHighDefinitionInUse();
      }
    }, {
      key: "disableMediaControl",
      value: function disableMediaControl() {
        if (!(this || _global).mediaControlDisabled) {
          (this || _global).mediaControlDisabled = true;
          this.trigger(Events.CONTAINER_MEDIACONTROL_DISABLE);
        }
      }
    }, {
      key: "enableMediaControl",
      value: function enableMediaControl() {
        if ((this || _global).mediaControlDisabled) {
          (this || _global).mediaControlDisabled = false;
          this.trigger(Events.CONTAINER_MEDIACONTROL_ENABLE);
        }
      }
    }, {
      key: "updateStyle",
      value: function updateStyle() {
        if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) (this || _global).$el.removeClass("chromeless");else (this || _global).$el.addClass("chromeless");
      }
    }, {
      key: "enableResizeObserver",
      value: function enableResizeObserver() {
        var _this4 = this || _global;
        this.disableResizeObserver();
        (this || _global).resizeObserverInterval = setInterval(function () {
          return _this4.checkResize();
        }, 500);
      }
    }, {
      key: "disableResizeObserver",
      value: function disableResizeObserver() {
        (this || _global).resizeObserverInterval && clearInterval((this || _global).resizeObserverInterval);
      }
    }, {
      key: "checkResize",
      value: function checkResize() {
        var newSize = {
          width: (this || _global).el.clientWidth,
          height: (this || _global).el.clientHeight
        };
        var _ref = (this || _global).currentSize || {},
          width = _ref.width,
          height = _ref.height;
        var isResize = height !== newSize.height || width !== newSize.width;
        if (isResize) {
          (this || _global).currentSize = newSize;
          this.trigger(Events.CONTAINER_RESIZE, newSize);
        }
      }

      /**
       * enables to configure the container after its creation
       * @method configure
       * @param {Object} options all the options to change in form of a javascript object
       */
    }, {
      key: "configure",
      value: function configure(options) {
        (this || _global)._options = zepto.extend(true, (this || _global)._options, options);
        this.updateStyle();
        (this || _global).playback.configure((this || _global).options);
        this.trigger(Events.CONTAINER_OPTIONS_CHANGE);
      }
    }, {
      key: "render",
      value: function render() {
        var style = Styler.getStyleFor(css_248z$5$1.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        (this || _global).$el.append((this || _global).playback.render().el);
        this.updateStyle();
        this.checkResize();
        this.enableResizeObserver();
        return this || _global;
      }
    }]);
    return Container;
  }(UIObject);
  Object.assign(Container.prototype, ErrorMixin);

  /**
   * An object representing a single audio track.
   * @typedef {Object} AudioTrack
   * @property {string} id - A unique identifier for the track. Used to identify it among the others.
   * @property {string} language - The language of the track (e.g., 'en', 'pt-BR').
   * @property {string} [label] - An optional label to be used in the UI to describe the track.
   * @property {('main'|'description')} kind - The category the audio track belongs to.
   * The kind 'description' is applied to audio tracks that narrate or describe the visual content.
   */

  /**
   * An abstraction to represent a generic playback, it's like an interface to be implemented by subclasses.
   * @class Playback
   * @constructor
   * @extends UIObject
   * @module base
   */
  var Playback = /*#__PURE__*/function (_UIObject) {
    _inherits$2(Playback, _UIObject);
    var _super = _createSuper$2(Playback);
    /**
     * @method constructor
     * @param {Object} options the options object
     * @param {Strings} i18n the internationalization component
     */
    function Playback(options, i18n, playerError) {
      var _this;
      _classCallCheck$2(this || _global, Playback);
      _this = _super.call(this || _global, options);
      _this.settings = {};
      _this._i18n = i18n;
      _this.playerError = playerError;
      _this._consented = false;
      return _this;
    }

    /**
     * Gives user consent to playback (mobile devices).
     * @method consent
     * @param {Function} callback function called when playback is consented
     */
    _createClass$2(Playback, [{
      key: "isAudioOnly",
      get:
      /**
      * Determine if the playback does not contain video/has video but video should be ignored.
      * @property isAudioOnly
      * @type Boolean
      */
      function get() {
        return false;
      }
    }, {
      key: "isAdaptive",
      get: function get() {
        return false;
      }

      /**
       * Determine if the playback has ended.
       * @property ended
       * @type Boolean
       */
    }, {
      key: "ended",
      get: function get() {
        return false;
      }

      /**
       * The internationalization plugin.
       * @property i18n
       * @type {Strings}
       */
    }, {
      key: "i18n",
      get: function get() {
        return (this || _global)._i18n;
      }

      /**
       * Determine if the playback is having to buffer in order for
       * playback to be smooth.
       * (i.e if a live stream is playing smoothly, this will be false)
       * @property buffering
       * @type Boolean
       */
    }, {
      key: "buffering",
      get: function get() {
        return false;
      }
    }, {
      key: "consent",
      value: function consent(cb) {
        typeof cb === "function" && cb();
      }

      /**
       * plays the playback.
       * @method play
       */
    }, {
      key: "play",
      value: function play() {}

      /**
       * pauses the playback.
       * @method pause
       */
    }, {
      key: "pause",
      value: function pause() {}

      /**
       * stops the playback.
       * @method stop
       */
    }, {
      key: "stop",
      value: function stop() {}

      /**
       * seeks the playback to a given `time` in seconds
       * @method seek
       * @param {Number} time should be a number between 0 and the video duration
       */
    }, {
      key: "seek",
      value: function seek(time) {} // eslint-disable-line no-unused-vars

      /**
       * seeks the playback to a given `percentage` in percentage
       * @method seekPercentage
       * @param {Number} time should be a number between 0 and 100
       */
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {} // eslint-disable-line no-unused-vars

      /**
       * The time that "0" now represents relative to when playback started.
       * For a stream with a sliding window this will increase as content is
       * removed from the beginning.
       * @method getStartTimeOffset
       * @return {Number} time (in seconds) that time "0" represents.
       */
    }, {
      key: "getStartTimeOffset",
      value: function getStartTimeOffset() {
        return 0;
      }

      /**
       * gets the duration in seconds
       * @method getDuration
       * @return {Number} duration (in seconds) of the current source
       */
    }, {
      key: "getDuration",
      value: function getDuration() {
        return 0;
      }

      /**
       * checks if the playback is playing.
       * @method isPlaying
       * @return {Boolean} `true` if the current playback is playing, otherwise `false`
       */
    }, {
      key: "isPlaying",
      value: function isPlaying() {
        return false;
      }

      /**
       * checks if the playback is ready.
       * @property isReady
       * @type {Boolean} `true` if the current playback is ready, otherwise `false`
       */
    }, {
      key: "isReady",
      get: function get() {
        return false;
      }

      /**
       * checks if the playback has closed caption tracks.
       * @property hasClosedCaptionsTracks
       * @type {Boolean}
       */
    }, {
      key: "hasClosedCaptionsTracks",
      get: function get() {
        return (this || _global).closedCaptionsTracks.length > 0;
      }

      /**
       * gets the playback available closed caption tracks.
       * @property closedCaptionsTracks
       * @type {Array} an array of objects with at least 'id' and 'name' properties
       */
    }, {
      key: "closedCaptionsTracks",
      get: function get() {
        return [];
      }

      /**
       * gets the selected closed caption track index. (-1 is disabled)
       * @property closedCaptionsTrackId
       * @type {Number}
       */
    }, {
      key: "closedCaptionsTrackId",
      get: function get() {
        return -1;
      }

      /**
       * sets the selected closed caption track index. (-1 is disabled)
       * @property closedCaptionsTrackId
       * @type {Number}
       */,
      set: function set(trackId) {} // eslint-disable-line no-unused-vars

      /**
       * returns a list of the available audio tracks for the playback.
       * @type {AudioTrack[]} audio tracks
       */
    }, {
      key: "audioTracks",
      get: function get() {
        return [];
      }

      /**
       * returns the audio track currently in use by the playback.
       * @type {AudioTrack} audio track
       */
    }, {
      key: "currentAudioTrack",
      get: function get() {
        return null;
      }

      /**
       * switches the current audio track used by the playback.
       * @param {string} id - id of the audio track to be set.
       */
    }, {
      key: "switchAudioTrack",
      value: function switchAudioTrack(id) {} // eslint-disable-line no-unused-vars

      /**
       * gets the playback type (`'vod', 'live', 'aod'`)
       * @method getPlaybackType
       * @return {String} you should write the playback type otherwise it'll assume `'no_op'`
       * @example
       * ```javascript
       * html5VideoPlayback.getPlaybackType() //vod
       * html5AudioPlayback.getPlaybackType() //aod
       * html5VideoPlayback.getPlaybackType() //live
       * flashHlsPlayback.getPlaybackType() //live
       * ```
       */
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return Playback.NO_OP;
      }

      /**
       * checks if the playback is in HD.
       * @method isHighDefinitionInUse
       * @return {Boolean} `true` if the playback is playing in HD, otherwise `false`
       */
    }, {
      key: "isHighDefinitionInUse",
      value: function isHighDefinitionInUse() {
        return false;
      }

      /**
       * mutes the playback
       * @method mute
       */
    }, {
      key: "mute",
      value: function mute() {}

      /**
       * restores the playback volume
       * @method unmute
       */
    }, {
      key: "unmute",
      value: function unmute() {}

      /**
       * sets the volume for the playback
       * @method volume
       * @param {Number} value a number between 0 (`muted`) to 100 (`max`)
       */
    }, {
      key: "volume",
      value: function volume(value) {} // eslint-disable-line no-unused-vars

      /**
       * enables to configure the playback after its creation
       * @method configure
       * @param {Object} options all the options to change in form of a javascript object
       */
    }, {
      key: "configure",
      value: function configure(options) {
        (this || _global)._options = zepto.extend(true, (this || _global)._options, options);
      }

      /**
       * attempt to autoplays the playback.
       * @method attemptAutoPlay
       */
    }, {
      key: "attemptAutoPlay",
      value: function attemptAutoPlay() {
        var _this2 = this || _global;
        this.canAutoPlay(function (result, error) {
          // eslint-disable-line no-unused-vars
          result && _this2.play();
        });
      }

      /**
       * checks if the playback can autoplay.
       * @method canAutoPlay
       * @param {Function} callback function where first param is Boolean and second param is playback Error or null
       */
    }, {
      key: "canAutoPlay",
      value: function canAutoPlay(cb) {
        cb(true, null); // Assume playback can autoplay by default
      }
    }]);

    return Playback;
  }(UIObject);
  Object.assign(Playback.prototype, ErrorMixin);
  Playback.extend = function (properties) {
    return extend$1(Playback, properties);
  };

  /**
   * checks if the playback can play a given `source`
   * If a mimeType is provided then this will be used instead of inferring the mimetype
   * from the source extension.
   * @method canPlay
   * @static
   * @param {String} source the given source ex: `http://example.com/play.mp4`
   * @param {String} [mimeType] the given mime type, ex: `'application/vnd.apple.mpegurl'`
   * @return {Boolean} `true` if the playback is playable, otherwise `false`
   */
  Playback.canPlay = function (source, mimeType) {
    // eslint-disable-line no-unused-vars
    return false;
  };

  /**
   * a playback type for video on demand
   *
   * @property VOD
   * @static
   * @type String
   */
  Playback.VOD = "vod";
  /**
   * a playback type for audio on demand
   *
   * @property AOD
   * @static
   * @type String
   */
  Playback.AOD = "aod";
  /**
   * a playback type for live video
   *
   * @property LIVE
   * @static
   * @type String
   */
  Playback.LIVE = "live";
  /**
   * a default playback type
   *
   * @property NO_OP
   * @static
   * @type String
   */
  Playback.NO_OP = "no_op";
  /**
   * the plugin type
   *
   * @property type
   * @static
   * @type String
   */
  Playback.type = "playback";
  var ContainerFactory = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(ContainerFactory, _BaseObject);
    var _super = _createSuper$2(ContainerFactory);
    function ContainerFactory(options, loader, i18n, playerError) {
      var _this;
      _classCallCheck$2(this || _global, ContainerFactory);
      _this = _super.call(this || _global, options);
      _this._i18n = i18n;
      _this.loader = loader;
      _this.playerError = playerError;
      return _this;
    }
    _createClass$2(ContainerFactory, [{
      key: "options",
      get: function get() {
        return (this || _global)._options;
      },
      set: function set(options) {
        (this || _global)._options = options;
      }
    }, {
      key: "createContainers",
      value: function createContainers() {
        var _this2 = this || _global;
        return zepto.Deferred(function (promise) {
          promise.resolve(_this2.options.sources.map(function (source) {
            return _this2.createContainer(source);
          }));
        });
      }
    }, {
      key: "findPlaybackPlugin",
      value: function findPlaybackPlugin(source, mimeType) {
        return (this || _global).loader.playbackPlugins.filter(function (p) {
          return p.canPlay(source, mimeType);
        })[0];
      }
    }, {
      key: "createContainer",
      value: function createContainer(source) {
        var resolvedSource = null;
        var mimeType = (this || _global).options.mimeType;
        if (_typeof(source) === "object") {
          resolvedSource = source.source.toString();
          if (source.mimeType) mimeType = source.mimeType;
        } else {
          resolvedSource = source.toString();
        }
        if (resolvedSource.match(/^\/\//)) resolvedSource = window.location.protocol + resolvedSource;
        var options = _objectSpread2$1(_objectSpread2$1({}, (this || _global).options), {}, {
          src: resolvedSource,
          mimeType: mimeType
        });
        var playbackPlugin = this.findPlaybackPlugin(resolvedSource, mimeType);

        // Fallback to empty playback object until we sort out unsupported sources error without NoOp playback
        var playback = playbackPlugin ? new playbackPlugin(options, (this || _global)._i18n, (this || _global).playerError) : new Playback();
        options = _objectSpread2$1(_objectSpread2$1({}, options), {}, {
          playback: playback
        });
        var container = new Container(options, (this || _global)._i18n, (this || _global).playerError);
        var defer = zepto.Deferred();
        defer.promise(container);
        this.addContainerPlugins(container);
        this.listenToOnce(container, Events.CONTAINER_READY, function () {
          return defer.resolve(container);
        });
        return container;
      }
    }, {
      key: "addContainerPlugins",
      value: function addContainerPlugins(container) {
        (this || _global).loader.containerPlugins.forEach(function (Plugin) {
          container.addPlugin(new Plugin(container));
        });
      }
    }]);
    return ContainerFactory;
  }(BaseObject);
  var css_248z$4$1 = "[data-player] {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -o-user-select: none;\n  user-select: none;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  transform: translate3d(0, 0, 0);\n  position: relative;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-style: normal;\n  font-weight: normal;\n  text-align: center;\n  overflow: hidden;\n  font-size: 100%;\n  font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n  text-shadow: 0 0 0;\n  box-sizing: border-box; }\n  [data-player]:focus {\n    outline: 0; }\n  [data-player] * {\n    box-sizing: inherit; }\n  [data-player] > * {\n    float: none;\n    max-width: none; }\n  [data-player] > div {\n    display: block; }\n  [data-player].fullscreen {\n    width: 100% !important;\n    height: 100% !important;\n    top: 0;\n    left: 0; }\n  [data-player].nocursor {\n    cursor: none; }\n\n.clappr-style {\n  display: none !important; }\n";
  var css_248z$3$1 = "[data-player] div, [data-player] span, [data-player] applet, [data-player] object, [data-player] iframe,\n[data-player] h1, [data-player] h2, [data-player] h3, [data-player] h4, [data-player] h5, [data-player] h6, [data-player] p, [data-player] blockquote, [data-player] pre,\n[data-player] a, [data-player] abbr, [data-player] acronym, [data-player] address, [data-player] big, [data-player] cite, [data-player] code,\n[data-player] del, [data-player] dfn, [data-player] em, [data-player] img, [data-player] ins, [data-player] kbd, [data-player] q, [data-player] s, [data-player] samp,\n[data-player] small, [data-player] strike, [data-player] strong, [data-player] sub, [data-player] sup, [data-player] tt, [data-player] var,\n[data-player] b, [data-player] u, [data-player] i, [data-player] center,\n[data-player] dl, [data-player] dt, [data-player] dd, [data-player] ol, [data-player] ul, [data-player] li,\n[data-player] fieldset, [data-player] form, [data-player] label, [data-player] legend,\n[data-player] table, [data-player] caption, [data-player] tbody, [data-player] tfoot, [data-player] thead, [data-player] tr, [data-player] th, [data-player] td,\n[data-player] article, [data-player] aside, [data-player] canvas, [data-player] details, [data-player] embed,\n[data-player] figure, [data-player] figcaption, [data-player] footer, [data-player] header, [data-player] hgroup,\n[data-player] menu, [data-player] nav, [data-player] output, [data-player] ruby, [data-player] section, [data-player] summary,\n[data-player] time, [data-player] mark, [data-player] audio, [data-player] video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font: inherit;\n  font-size: 100%;\n  vertical-align: baseline; }\n\n[data-player] table {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\n[data-player] caption, [data-player] th, [data-player] td {\n  text-align: left;\n  font-weight: normal;\n  vertical-align: middle; }\n\n[data-player] q, [data-player] blockquote {\n  quotes: none; }\n  [data-player] q:before, [data-player] q:after, [data-player] blockquote:before, [data-player] blockquote:after {\n    content: \"\";\n    content: none; }\n\n[data-player] a img {\n  border: none; }\n";

  /**
   * The Core is responsible to manage Containers and the player state.
   * @class Core
   * @constructor
   * @extends UIObject
   * @module components
   */
  var Core = /*#__PURE__*/function (_UIObject) {
    _inherits$2(Core, _UIObject);
    var _super = _createSuper$2(Core);
    function Core(options) {
      var _this;
      _classCallCheck$2(this || _global, Core);
      _this = _super.call(this || _global, options);
      _this.playerError = new PlayerError(options, _assertThisInitialized$2(_this));
      _this.configureDomRecycler();
      _this.firstResize = true;
      _this.plugins = [];
      _this.containers = [];
      //FIXME fullscreen api sucks
      _this._boundFullscreenHandler = function () {
        return _this.handleFullscreenChange();
      };
      zepto(document).bind("fullscreenchange", _this._boundFullscreenHandler);
      zepto(document).bind("MSFullscreenChange", _this._boundFullscreenHandler);
      zepto(document).bind("mozfullscreenchange", _this._boundFullscreenHandler);
      Browser.isMobile && zepto(window).bind("resize", function (o) {
        _this.handleWindowResize(o);
      });
      return _this;
    }
    _createClass$2(Core, [{
      key: "events",
      get: function get() {
        return {
          "webkitfullscreenchange": "handleFullscreenChange",
          "mousemove": "onMouseMove",
          "mouseleave": "onMouseLeave"
        };
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "data-player": "",
          tabindex: 9999
        };
      }

      /**
       * checks if the core is ready.
       * @property isReady
       * @type {Boolean} `true` if the core is ready, otherwise `false`
       */
    }, {
      key: "isReady",
      get: function get() {
        return !!(this || _global).ready;
      }

      /**
       * The internationalization plugin.
       * @property i18n
       * @type {Strings}
       */
    }, {
      key: "i18n",
      get: function get() {
        return this.getPlugin("strings") || {
          t: function t(key) {
            return key;
          }
        };
      }

      /**
       * @deprecated
       * This property currently exists for backward compatibility reasons.
       * If you need to access the media control instance, use the method getPlugin('media_control').
       * This approach is still not recommended.
       */
    }, {
      key: "mediaControl",
      get: function get() {
        return (this || _global)._mediaControl || ((this || _global)._mediaControl = this.getPlugin("media_control")) || (this || _global).dummyMediaControl;
      }
    }, {
      key: "dummyMediaControl",
      get: function get() {
        if ((this || _global)._dummyMediaControl) return (this || _global)._dummyMediaControl;
        (this || _global)._dummyMediaControl = new UICorePlugin(this || _global);
        return (this || _global)._dummyMediaControl;
      }

      /**
       * gets the active container reference.
       * @property activeContainer
       * @type {Object}
       */
    }, {
      key: "activeContainer",
      get: function get() {
        return (this || _global)._activeContainer;
      }

      /**
       * sets the active container reference and trigger a event with the new reference.
       * @property activeContainer
       * @type {Object}
       */,
      set: function set(container) {
        (this || _global)._activeContainer = container;
        this.trigger(Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global)._activeContainer);
      }

      /**
       * gets the active playback reference.
       * @property activePlayback
       * @type {Object}
       */
    }, {
      key: "activePlayback",
      get: function get() {
        return (this || _global).activeContainer && (this || _global).activeContainer.playback;
      }

      /**
       * gets the active playback's video element.
       * @property activePlaybackEl
       * @type {Object}
       */
    }, {
      key: "activePlaybackEl",
      get: function get() {
        if (!(this || _global).activePlayback) return undefined;
        return (this || _global).activePlayback.$el ? (this || _global).activePlayback.$el.find("video")[0] : (this || _global).activePlayback.el;
      }
    }, {
      key: "configureDomRecycler",
      value: function configureDomRecycler() {
        var recycleVideo = (this || _global).options && (this || _global).options.playback && (this || _global).options.playback.recycleVideo;
        DomRecycler.configure({
          recycleVideo: recycleVideo
        });
      }
    }, {
      key: "createContainers",
      value: function createContainers(options) {
        (this || _global).defer = zepto.Deferred();
        (this || _global).defer.promise(this || _global);
        (this || _global).containerFactory = new ContainerFactory(options, options.loader, (this || _global).i18n, (this || _global).playerError);
        this.prepareContainers();
      }
    }, {
      key: "prepareContainers",
      value: function prepareContainers() {
        var _this2 = this || _global;
        (this || _global).containerFactory.createContainers().then(function (containers) {
          return _this2.setupContainers(containers);
        }).then(function (containers) {
          return _this2.resolveOnContainersReady(containers);
        });
      }
    }, {
      key: "updateSize",
      value: function updateSize() {
        this.isFullscreen() ? this.setFullscreen() : this.setPlayerSize();
      }
    }, {
      key: "setFullscreen",
      value: function setFullscreen() {
        if (!Browser.isiOS) {
          (this || _global).$el.addClass("fullscreen");
          (this || _global).$el.removeAttr("style");
          (this || _global).previousSize = {
            width: (this || _global).options.width,
            height: (this || _global).options.height
          };
          (this || _global).currentSize = {
            width: zepto(window).width(),
            height: zepto(window).height()
          };
        }
      }
    }, {
      key: "setPlayerSize",
      value: function setPlayerSize() {
        (this || _global).$el.removeClass("fullscreen");
        (this || _global).currentSize = (this || _global).previousSize;
        (this || _global).previousSize = {
          width: zepto(window).width(),
          height: zepto(window).height()
        };
        this.resize((this || _global).currentSize);
      }
    }, {
      key: "resize",
      value: function resize(options) {
        if (!isNumber(options.height) && !isNumber(options.width)) {
          (this || _global).el.style.height = "".concat(options.height);
          (this || _global).el.style.width = "".concat(options.width);
        } else {
          (this || _global).el.style.height = "".concat(options.height, "px");
          (this || _global).el.style.width = "".concat(options.width, "px");
        }
        (this || _global).previousSize = {
          width: (this || _global).options.width,
          height: (this || _global).options.height
        };
        (this || _global).options.width = options.width;
        (this || _global).options.height = options.height;
        (this || _global).currentSize = options;
        this.triggerResize((this || _global).currentSize);
      }
    }, {
      key: "enableResizeObserver",
      value: function enableResizeObserver() {
        var _this3 = this || _global;
        this.disableResizeObserver();
        var checkSizeCallback = function checkSizeCallback() {
          _this3.triggerResize({
            width: _this3.el.clientWidth,
            height: _this3.el.clientHeight
          });
        };
        (this || _global).resizeObserverInterval = setInterval(checkSizeCallback, 500);
      }
    }, {
      key: "triggerResize",
      value: function triggerResize(newSize) {
        var thereWasChange = (this || _global).firstResize || (this || _global).oldHeight !== newSize.height || (this || _global).oldWidth !== newSize.width;
        if (thereWasChange) {
          (this || _global).oldHeight = newSize.height;
          (this || _global).oldWidth = newSize.width;
          (this || _global).computedSize = newSize;
          (this || _global).firstResize = false;
          this.trigger(Events.CORE_RESIZE, newSize);
        }
      }
    }, {
      key: "disableResizeObserver",
      value: function disableResizeObserver() {
        (this || _global).resizeObserverInterval && clearInterval((this || _global).resizeObserverInterval);
        (this || _global).resizeObserverInterval = null;
      }
    }, {
      key: "resolveOnContainersReady",
      value: function resolveOnContainersReady(containers) {
        var _this4 = this || _global;
        zepto.when.apply(zepto, containers).done(function () {
          _this4.defer.resolve(_this4);
          _this4.ready = true;
          _this4.trigger(Events.CORE_READY);
        });
      }
    }, {
      key: "addPlugin",
      value: function addPlugin(plugin) {
        (this || _global).plugins.push(plugin);
      }
    }, {
      key: "hasPlugin",
      value: function hasPlugin(name) {
        return !!this.getPlugin(name);
      }
    }, {
      key: "getPlugin",
      value: function getPlugin(name) {
        return (this || _global).plugins.filter(function (plugin) {
          return plugin.name === name;
        })[0];
      }
    }, {
      key: "load",
      value: function load(sources, mimeType) {
        (this || _global).options.mimeType = mimeType;
        sources = sources && sources.constructor === Array ? sources : [sources];
        (this || _global).options.sources = sources;
        (this || _global).containers.forEach(function (container) {
          return container.destroy();
        });
        (this || _global).containerFactory.options = zepto.extend(true, (this || _global).options, {
          sources: sources
        });
        this.prepareContainers();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.disableResizeObserver();
        (this || _global).containers.forEach(function (container) {
          return container.destroy();
        });
        (this || _global).plugins.forEach(function (plugin) {
          return plugin.destroy();
        });
        (this || _global).$el.remove();
        zepto(document).unbind("fullscreenchange", (this || _global)._boundFullscreenHandler);
        zepto(document).unbind("MSFullscreenChange", (this || _global)._boundFullscreenHandler);
        zepto(document).unbind("mozfullscreenchange", (this || _global)._boundFullscreenHandler);
        this.stopListening();
      }
    }, {
      key: "handleFullscreenChange",
      value: function handleFullscreenChange() {
        this.trigger(Events.CORE_FULLSCREEN, this.isFullscreen());
        this.updateSize();
      }
    }, {
      key: "handleWindowResize",
      value: function handleWindowResize(event) {
        var orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
        if ((this || _global)._screenOrientation === orientation) return;
        (this || _global)._screenOrientation = orientation;
        this.triggerResize({
          width: (this || _global).el.clientWidth,
          height: (this || _global).el.clientHeight
        });
        this.trigger(Events.CORE_SCREEN_ORIENTATION_CHANGED, {
          event: event,
          orientation: (this || _global)._screenOrientation
        });
      }
    }, {
      key: "removeContainer",
      value: function removeContainer(container) {
        this.stopListening(container);
        (this || _global).containers = (this || _global).containers.filter(function (c) {
          return c !== container;
        });
      }
    }, {
      key: "setupContainer",
      value: function setupContainer(container) {
        this.listenTo(container, Events.CONTAINER_DESTROYED, (this || _global).removeContainer);
        (this || _global).containers.push(container);
      }
    }, {
      key: "setupContainers",
      value: function setupContainers(containers) {
        containers.forEach((this || _global).setupContainer.bind(this || _global));
        this.trigger(Events.CORE_CONTAINERS_CREATED);
        this.renderContainers();
        (this || _global).activeContainer = containers[0];
        this.render();
        this.appendToParent();
        return (this || _global).containers;
      }
    }, {
      key: "renderContainers",
      value: function renderContainers() {
        var _this5 = this || _global;
        (this || _global).containers.forEach(function (container) {
          return _this5.el.appendChild(container.render().el);
        });
      }
    }, {
      key: "createContainer",
      value: function createContainer(source, options) {
        var container = (this || _global).containerFactory.createContainer(source, options);
        this.setupContainer(container);
        (this || _global).el.appendChild(container.render().el);
        return container;
      }

      /**
       * @deprecated
       * This method currently exists for retrocompatibility reasons.
       * If you want the current container reference, use the activeContainer getter.
       */
    }, {
      key: "getCurrentContainer",
      value: function getCurrentContainer() {
        return (this || _global).activeContainer;
      }

      /**
       * @deprecated
       * This method currently exists for retrocompatibility reasons.
       * If you want the current playback reference, use the activePlayback getter.
       */
    }, {
      key: "getCurrentPlayback",
      value: function getCurrentPlayback() {
        return (this || _global).activePlayback;
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return (this || _global).activeContainer && (this || _global).activeContainer.getPlaybackType();
      }
    }, {
      key: "isFullscreen",
      value: function isFullscreen() {
        var fullscreenElement = Fullscreen$1.fullscreenElement();
        return fullscreenElement && fullscreenElement === (this || _global).el || fullscreenElement && fullscreenElement === (this || _global).activePlaybackEl || (this || _global).activePlaybackEl && (this || _global).activePlaybackEl.webkitDisplayingFullscreen || false;
      }
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        var _this6 = this || _global;
        if (this.isFullscreen()) {
          var fullscreenEl = Browser.isiOS ? (this || _global).activePlaybackEl : document;
          Fullscreen$1.cancelFullscreen(fullscreenEl);
          !Browser.isiOS && (this || _global).$el.removeClass("fullscreen nocursor");
        } else {
          var _fullscreenEl = Browser.isiOS ? (this || _global).activePlaybackEl : (this || _global).el;
          if (!_fullscreenEl) return;
          Browser.isSafari || Browser.isiOS // Safari doesn't return a promise like the other browsers. See more in https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
          ? Fullscreen$1.requestFullscreen(_fullscreenEl) : Fullscreen$1.requestFullscreen(_fullscreenEl).then(function (_) {
            return _;
          }, function (error) {
            return setTimeout(function () {
              // fixes the issue https://github.com/clappr/clappr/issues/1860
              if (!_this6.isFullscreen()) throw new ReferenceError(error);
            }, 600);
          });
          !Browser.isiOS && (this || _global).$el.addClass("fullscreen");
        }
      }
    }, {
      key: "onMouseMove",
      value: function onMouseMove(event) {
        this.trigger(Events.CORE_MOUSE_MOVE, event);
      }
    }, {
      key: "onMouseLeave",
      value: function onMouseLeave(event) {
        this.trigger(Events.CORE_MOUSE_LEAVE, event);
      }

      /**
       * enables to configure the container after its creation
       * @method configure
       * @param {Object} options all the options to change in form of a javascript object
       */
    }, {
      key: "configure",
      value: function configure(options) {
        var _this7 = this || _global;
        (this || _global)._options = zepto.extend(true, (this || _global)._options, options);
        this.configureDomRecycler();
        var sources = options.source || options.sources;
        sources && this.load(sources, options.mimeType || (this || _global).options.mimeType);
        this.trigger(Events.CORE_OPTIONS_CHANGE, options); // Trigger with newly provided options
        (this || _global).containers.forEach(function (container) {
          return container.configure(_this7.options);
        });
      }
    }, {
      key: "appendToParent",
      value: function appendToParent() {
        var style = Styler.getStyleFor(css_248z$4$1.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        var resetStyle = Styler.getStyleFor(css_248z$3$1.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        (this || _global).options.includeResetStyle && (this || _global).$el.append(resetStyle[0]);
        var hasCoreParent = (this || _global).$el.parent() && (this || _global).$el.parent().length;
        !hasCoreParent && (this || _global).$el.appendTo((this || _global).options.parentElement);
      }
    }, {
      key: "render",
      value: function render() {
        (this || _global).options.width = (this || _global).options.width || (this || _global).$el.width();
        (this || _global).options.height = (this || _global).options.height || (this || _global).$el.height();
        var size = {
          width: (this || _global).options.width,
          height: (this || _global).options.height
        };
        (this || _global).previousSize = (this || _global).currentSize = (this || _global).computedSize = size;
        this.updateSize();
        this.enableResizeObserver();
        return this || _global;
      }
    }]);
    return Core;
  }(UIObject);
  Object.assign(Core.prototype, ErrorMixin);

  /**
   * The Core Factory is responsible for instantiate the core and it's plugins.
   * @class CoreFactory
   * @constructor
   * @extends BaseObject
   * @module components
   */
  var CoreFactory = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(CoreFactory, _BaseObject);
    var _super = _createSuper$2(CoreFactory);
    /**
     * it builds the core factory
     * @method constructor
     * @param {Player} player the player object
     */
    function CoreFactory(player) {
      var _this;
      _classCallCheck$2(this || _global, CoreFactory);
      _this = _super.call(this || _global, player.options);
      _this.player = player;
      return _this;
    }

    /**
     * creates a core and its plugins
     * @method create
     * @return {Core} created core
     */
    _createClass$2(CoreFactory, [{
      key: "loader",
      get: function get() {
        return (this || _global).player.loader;
      }
    }, {
      key: "create",
      value: function create() {
        (this || _global).options.loader = (this || _global).loader;
        (this || _global).core = new Core((this || _global).options);
        this.addCorePlugins();
        (this || _global).core.createContainers((this || _global).options);
        return (this || _global).core;
      }

      /**
       * given the core plugins (`loader.corePlugins`) it builds each one
       * @method addCorePlugins
       * @return {Core} the core with all plugins
       */
    }, {
      key: "addCorePlugins",
      value: function addCorePlugins() {
        var _this2 = this || _global;
        (this || _global).loader.corePlugins.forEach(function (Plugin) {
          var plugin = new Plugin(_this2.core);
          _this2.core.addPlugin(plugin);
          _this2.setupExternalInterface(plugin);
        });
        return (this || _global).core;
      }
    }, {
      key: "setupExternalInterface",
      value: function setupExternalInterface(plugin) {
        var externalFunctions = plugin.getExternalInterface();
        for (var key in externalFunctions) {
          (this || _global).player[key] = externalFunctions[key].bind(plugin);
        }
      }
    }]);
    return CoreFactory;
  }(BaseObject);
  var VERSION_REGEX = /(\d+)(?:\.(\d+))?(?:\.(\d+))?/;
  var Version = /*#__PURE__*/function () {
    function Version(major, minor, patch) {
      _classCallCheck$2(this || _global, Version);
      (this || _global).major = parseInt(major || 0, 10);
      (this || _global).minor = parseInt(minor || 0, 10);
      (this || _global).patch = parseInt(patch || 0, 10);
    }
    _createClass$2(Version, [{
      key: "compare",
      value: function compare(other) {
        var diff = (this || _global).major - other.major;
        diff = diff || (this || _global).minor - other.minor;
        diff = diff || (this || _global).patch - other.patch;
        return diff;
      }
    }, {
      key: "inc",
      value: function inc() {
        var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "patch";
        typeof (this || _global)[type] !== "undefined" && ((this || _global)[type] += 1);
        return this || _global;
      }
    }, {
      key: "satisfies",
      value: function satisfies(min, max) {
        return this.compare(min) >= 0 && (!max || this.compare(max) < 0);
      }
    }, {
      key: "toString",
      value: function toString() {
        return "".concat((this || _global).major, ".").concat((this || _global).minor, ".").concat((this || _global).patch);
      }
    }], [{
      key: "parse",
      value: function parse() {
        var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var matches = str.match(VERSION_REGEX) || [];
        var _matches = _slicedToArray(matches, 4),
          major = _matches[1],
          minor = _matches[2],
          patch = _matches[3];
        if (typeof major === "undefined") return null;
        return new Version(major, minor, patch);
      }
    }]);
    return Version;
  }();
  var filterPluginsByType = function filterPluginsByType(plugins, type) {
    if (!plugins || !type) return {};
    return Object.entries(plugins).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        value = _ref2[1];
      return value.type === type;
    }).reduce(function (obj, _ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];
      return obj[key] = value, obj;
    }, {});
  };

  /**
   * It keeps a list of the default plugins (playback, container, core) and it merges external plugins with its internals.
   * @class Loader
   * @constructor
   * @extends BaseObject
   * @module components
   */
  var Loader = function () {
    var registry = {
      plugins: {},
      playbacks: []
    };
    var currentVersion = "0.4.27";
    return /*#__PURE__*/function () {
      /**
       * builds the loader
       * @method constructor
       * @param {Object} externalPlugins the external plugins
       * @param {Number} playerId you can embed multiple instances of clappr, therefore this is the unique id of each one.
       */
      function Loader() {
        var externalPlugins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var playerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        _classCallCheck$2(this || _global, Loader);
        (this || _global).playerId = playerId;
        (this || _global).playbackPlugins = _toConsumableArray$1(registry.playbacks);
        var _Loader$registeredPlu = Loader.registeredPlugins,
          core = _Loader$registeredPlu.core,
          container = _Loader$registeredPlu.container;
        (this || _global).containerPlugins = Object.values(container);
        (this || _global).corePlugins = Object.values(core);
        if (!Array.isArray(externalPlugins)) this.validateExternalPluginsType(externalPlugins);
        this.addExternalPlugins(externalPlugins);
      }

      /**
       * groups by type the external plugins that were passed through `options.plugins` it they're on a flat array
       * @method addExternalPlugins
       * @private
       * @param {Object} an config object or an array of plugins
       * @return {Object} plugins the config object with the plugins separated by type
       */
      _createClass$2(Loader, [{
        key: "groupPluginsByType",
        value: function groupPluginsByType(plugins) {
          if (Array.isArray(plugins)) {
            plugins = plugins.reduce(function (memo, plugin) {
              memo[plugin.type] || (memo[plugin.type] = []);
              memo[plugin.type].push(plugin);
              return memo;
            }, {});
          }
          return plugins;
        }
      }, {
        key: "removeDups",
        value: function removeDups(list) {
          var useReversePrecedence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var groupUp = function groupUp(plugins, plugin) {
            if (plugins[plugin.prototype.name] && useReversePrecedence) return plugins;
            plugins[plugin.prototype.name] && delete plugins[plugin.prototype.name];
            plugins[plugin.prototype.name] = plugin;
            return plugins;
          };
          var pluginsMap = list.reduceRight(groupUp, Object.create(null));
          var plugins = [];
          for (var key in pluginsMap) {
            plugins.unshift(pluginsMap[key]);
          }
          return plugins;
        }

        /**
         * adds all the external plugins that were passed through `options.plugins`
         * @method addExternalPlugins
         * @private
         * @param {Object} plugins the config object with all plugins
         */
      }, {
        key: "addExternalPlugins",
        value: function addExternalPlugins(plugins) {
          var loadExternalPluginsFirst = typeof plugins.loadExternalPluginsFirst === "boolean" ? plugins.loadExternalPluginsFirst : true;
          var loadExternalPlaybacksFirst = typeof plugins.loadExternalPlaybacksFirst === "boolean" ? plugins.loadExternalPlaybacksFirst : true;
          plugins = this.groupPluginsByType(plugins);
          if (plugins.playback) {
            var playbacks = plugins.playback.filter(function (playback) {
              return Loader.checkVersionSupport(playback), true;
            });
            (this || _global).playbackPlugins = loadExternalPlaybacksFirst ? this.removeDups(playbacks.concat((this || _global).playbackPlugins)) : this.removeDups((this || _global).playbackPlugins.concat(playbacks), true);
          }
          if (plugins.container) {
            var containerPlugins = plugins.container.filter(function (plugin) {
              return Loader.checkVersionSupport(plugin), true;
            });
            (this || _global).containerPlugins = loadExternalPluginsFirst ? this.removeDups(containerPlugins.concat((this || _global).containerPlugins)) : this.removeDups((this || _global).containerPlugins.concat(containerPlugins), true);
          }
          if (plugins.core) {
            var corePlugins = plugins.core.filter(function (plugin) {
              return Loader.checkVersionSupport(plugin), true;
            });
            (this || _global).corePlugins = loadExternalPluginsFirst ? this.removeDups(corePlugins.concat((this || _global).corePlugins)) : this.removeDups((this || _global).corePlugins.concat(corePlugins), true);
          }
        }

        /**
         * validate if the external plugins that were passed through `options.plugins` are associated to the correct type
         * @method validateExternalPluginsType
         * @private
         * @param {Object} plugins the config object with all plugins
         */
      }, {
        key: "validateExternalPluginsType",
        value: function validateExternalPluginsType(plugins) {
          var pluginTypes = ["playback", "container", "core"];
          pluginTypes.forEach(function (type) {
            (plugins[type] || []).forEach(function (el) {
              var errorMessage = "external " + el.type + " plugin on " + type + " array";
              if (el.type !== type) throw new ReferenceError(errorMessage);
            });
          });
        }
      }], [{
        key: "registeredPlaybacks",
        get: function get() {
          return _toConsumableArray$1(registry.playbacks);
        }
      }, {
        key: "registeredPlugins",
        get: function get() {
          var plugins = registry.plugins;
          var core = filterPluginsByType(plugins, "core");
          var container = filterPluginsByType(plugins, "container");
          return {
            core: core,
            container: container
          };
        }
      }, {
        key: "checkVersionSupport",
        value: function checkVersionSupport(entry) {
          var _entry$prototype = entry.prototype,
            supportedVersion = _entry$prototype.supportedVersion,
            name = _entry$prototype.name;
          if (!supportedVersion || !supportedVersion.min) {
            Log.warn("Loader", "missing version information for ".concat(name));
            return false;
          }
          var maxVersion = supportedVersion.max ? Version.parse(supportedVersion.max) : Version.parse(supportedVersion.min).inc("minor");
          var minVersion = Version.parse(supportedVersion.min);
          if (!Version.parse(currentVersion).satisfies(minVersion, maxVersion)) {
            Log.warn("Loader", "unsupported plugin ".concat(name, ": Clappr version ").concat(currentVersion, " does not match required range [").concat(minVersion, ",").concat(maxVersion, ")"));
            return false;
          }
          return true;
        }
      }, {
        key: "registerPlugin",
        value: function registerPlugin(pluginEntry) {
          if (!pluginEntry || !pluginEntry.prototype.name) {
            Log.warn("Loader", "missing information to register plugin: ".concat(pluginEntry));
            return false;
          }
          Loader.checkVersionSupport(pluginEntry);
          var pluginRegistry = registry.plugins;
          if (!pluginRegistry) return false;
          var previousEntry = pluginRegistry[pluginEntry.prototype.name];
          if (previousEntry) Log.warn("Loader", "overriding plugin entry: ".concat(pluginEntry.prototype.name, " - ").concat(previousEntry));
          pluginRegistry[pluginEntry.prototype.name] = pluginEntry;
          return true;
        }
      }, {
        key: "registerPlayback",
        value: function registerPlayback(playbackEntry) {
          if (!playbackEntry || !playbackEntry.prototype.name) return false;
          Loader.checkVersionSupport(playbackEntry);
          var playbacks = registry.playbacks;
          var previousEntryIdx = playbacks.findIndex(function (entry) {
            return entry.prototype.name === playbackEntry.prototype.name;
          });
          if (previousEntryIdx >= 0) {
            var previousEntry = playbacks[previousEntryIdx];
            playbacks.splice(previousEntryIdx, 1);
            Log.warn("Loader", "overriding playback entry: ".concat(previousEntry.name, " - ").concat(previousEntry));
          }
          registry.playbacks = [playbackEntry].concat(_toConsumableArray$1(playbacks));
          return true;
        }
      }, {
        key: "unregisterPlugin",
        value: function unregisterPlugin(name) {
          if (!name) return false;
          var plugins = registry.plugins;
          var plugin = plugins[name];
          if (!plugin) return false;
          delete plugins[name];
          return true;
        }
      }, {
        key: "unregisterPlayback",
        value: function unregisterPlayback(name) {
          if (!name) return false;
          var playbacks = registry.playbacks;
          var index = playbacks.findIndex(function (entry) {
            return entry.prototype.name === name;
          });
          if (index < 0) return false;
          playbacks.splice(index, 1);
          registry.playbacks = playbacks;
          return true;
        }
      }, {
        key: "clearPlugins",
        value: function clearPlugins() {
          registry.plugins = {};
        }
      }, {
        key: "clearPlaybacks",
        value: function clearPlaybacks() {
          registry.playbacks = [];
        }
      }]);
      return Loader;
    }();
  }();
  var baseUrl = currentScriptUrl().replace(/\/[^/]+$/, "");

  /**
   * @class Player
   * @constructor
   * @extends BaseObject
   * @module components
   * @example
   * ### Using the Player
   *
   * Add the following script on your HTML:
   * ```html
   * <head>
   *   <script type="text/javascript" src="http://cdn.clappr.io/latest/clappr.min.js"></script>
   * </head>
   * ```
   * Now, create the player:
   * ```html
   * <body>
   *   <div id="player"></div>
   *   <script>
   *     var player = new Clappr.Player({source: "http://your.video/here.mp4", parentId: "#player"});
   *   </script>
   * </body>
   * ```
   */
  var Player = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(Player, _BaseObject);
    var _super = _createSuper$2(Player);
    /**
     * @typedef {Object} PlaybackConfig
     * @prop {boolean} disableContextMenu
     * disables the context menu (right click) on the video element if a HTML5Video playback is used.
     * @prop {boolean} preload
     * video will be preloaded according to `preload` attribute options **default**: `'metadata'`
     * @prop {boolean} controls
     * enabled/disables displaying controls
     * @prop {boolean} crossOrigin
     * enables cross-origin capability for media-resources
     * @prop {boolean} playInline
     * enables in-line video elements
     * @prop {boolean} audioOnly
     * enforce audio-only playback (when possible)
     * @prop {Object} externalTracks
     * pass externaly loaded track to playback
     * @prop {Number} [maxBufferLength]
     * The default behavior for the **HLS playback** is to keep buffering indefinitely, even on VoD.
     * This replicates the behavior for progressive download, which continues buffering when pausing the video, thus making the video available for playback even on slow networks.
     * To change this behavior use `maxBufferLength` where **value is in seconds**.
     * @prop {Number} [maxBackBufferLength]
     * After how much distance of the playhead data should be pruned from the buffer (influences memory consumption
     * of adaptive media-engines like Hls.js or Shaka)
     * @prop {Number} [minBufferLength]
     * After how much data in the buffer at least we attempt to consume it (influences QoS-related behavior
     * of adaptive media-engines like Hls.js or Shaka). If this is too low, and the available bandwidth is varying a lot
     * and too close to the streamed bitrate, we may continuously hit under-runs.
     * @prop {Number} [initialBandwidthEstimate]
     * define an initial bandwidth "guess" (or previously stored/established value) for underlying adaptive-bitreate engines
     * of adaptive playback implementations, like Hls.js or Shaka
     * @prop {Number} [maxAdaptiveBitrate]
     * Limits the streamed bitrate (for adaptive media-engines in underlying playback implementations)
     * @prop {Object} [maxAdaptiveVideoDimensions]
     * Limits the video dimensions in adaptive media-engines. Should be a literal object with `height` and `width`.
     * @prop {Boolean}[enableAutomaticABR] **default**: `true`
     * Allows to enable/disable automatic bitrate switching in adaptive media-engines
     * @prop {String} [preferredTextLanguage] **default**: `'pt-BR'`
     * Allows to set a preferred text language, that may be enabled by the media-engine if available.
     * @prop {String} [preferredAudioLanguage] **default**: `'pt-BR'`
     * Allows to set a preferred audio language, that may be enabled by the media-engine if available.
     */

    /**
     * ## Player's constructor
     *
     * You might pass the options object to build the player.
     * ```javascript
     * var options = {source: "http://example.com/video.mp4", param1: "val1"};
     * var player = new Clappr.Player(options);
     * ```
     *
     * @method constructor
     * @param {Object} options Data
     * options to build a player instance
     * @param {Number} [options.width]
     * player's width **default**: `640`
     * @param {Number} [options.height]
     * player's height **default**: `360`
     * @param {String} [options.parentId]
     * the id of the element on the page that the player should be inserted into
     * @param {Object} [options.parent]
     * a reference to a dom element that the player should be inserted into
     * @param {String} [options.source]
     * The media source URL, or {source: <<source URL>>, mimeType: <<source mime type>>}
     * @param {Object} [options.sources]
     * An array of media source URL's, or an array of {source: <<source URL>>, mimeType: <<source mime type>>}
     * @param {Boolean} [options.autoPlay]
     * automatically play after page load **default**: `false`
     * @param {Boolean} [options.loop]
     * automatically replay after it ends **default**: `false`
     * @param {Boolean} [options.chromeless]
     * player acts in chromeless mode **default**: `false`
     * @param {Boolean} [options.allowUserInteraction]
     * whether or not the player should handle click events when in chromeless mode **default**: `false` on desktops browsers, `true` on mobile.
     * @param {Boolean} [options.disableKeyboardShortcuts]
     * disable keyboard shortcuts. **default**: `false`. `true` if `allowUserInteraction` is `false`.
     * @param {Boolean} [options.mute]
     * start the video muted **default**: `false`
     * @param {String} [options.mimeType]
     * add `mimeType: "application/vnd.apple.mpegurl"` if you need to use a url without extension.
     * @param {Boolean} [options.actualLiveTime]
     * show duration and seek time relative to actual time.
     * @param {String} [options.actualLiveServerTime]
     * specify server time as a string, format: "2015/11/26 06:01:03". This option is meant to be used with actualLiveTime.
     * @param {Boolean} [options.persistConfig]
     * persist player's settings (volume) through the same domain **default**: `true`
     * @param {String} [options.preload] @deprecated
     * video will be preloaded according to `preload` attribute options **default**: `'metadata'`
     * @param {Number} [options.maxBufferLength] @deprecated
     * the default behavior for the **HLS playback** is to keep buffering indefinitely, even on VoD.
     * This replicates the behavior for progressive download, which continues buffering when pausing the video, thus making the video available for playback even on slow networks.
     * To change this behavior use `maxBufferLength` where **value is in seconds**.
     * @param {String} [options.gaAccount]
     * enable Google Analytics events dispatch **(play/pause/stop/buffering/etc)** by adding your `gaAccount`
     * @param {String} [options.gaTrackerName]
     * besides `gaAccount` you can optionally, pass your favorite trackerName as `gaTrackerName`
     * @param {Object} [options.mediacontrol]
     * customize control bar colors, example: `mediacontrol: {seekbar: "#E113D3", buttons: "#66B2FF"}`
     * @param {Boolean} [options.hideMediaControl]
     * control media control auto hide **default**: `true`
     * @param {Boolean} [options.hideVolumeBar]
     * when embedded with width less than 320, volume bar will hide. You can force this behavior for all sizes by adding `true` **default**: `false`
     * @param {String} [options.watermark]
     * put `watermark: 'http://url/img.png'` on your embed parameters to automatically add watermark on your video.
     * You can customize corner position by defining position parameter. Positions can be `bottom-left`, `bottom-right`, `top-left` and `top-right`.
     * @param {String} [options.watermarkLink]
     * `watermarkLink: 'http://example.net/'` - define URL to open when the watermark is clicked. If not provided watermark will not be clickable.
     * @param {Boolean} [options.disableVideoTagContextMenu] @deprecated
     * disables the context menu (right click) on the video element if a HTML5Video playback is used.
     * @param {Boolean} [options.autoSeekFromUrl]
     * Automatically seek to the seconds provided in the url (e.g example.com?t=100) **default**: `true`
     * @param {Boolean} [options.exitFullscreenOnEnd]
     * Automatically exit full screen when the media finishes. **default**: `true`
     * @param {String} [options.poster]
     * define a poster by adding its address `poster: 'http://url/img.png'`. It will appear after video embed, disappear on play and go back when user stops the video.
     * @param {String} [options.playbackNotSupportedMessage]
     * define a custom message to be displayed when a playback is not supported.
     * @param {Object} [options.events]
     * Specify listeners which will be registered with their corresponding player events.
     * E.g. onReady -> "PLAYER_READY", onTimeUpdate -> "PLAYER_TIMEUPDATE"
     * @param {PlaybackConfig} [options.playback]
     * Generic `Playback` component related configuration
     * @param {Boolean} [options.disableErrorScreen]
     * disables the error screen plugin.
     * @param {Number} [options.autoPlayTimeout]
     * autoplay check timeout.
     */

    function Player(options) {
      var _this;
      _classCallCheck$2(this || _global, Player);
      _this = _super.call(this || _global, options);
      var playbackDefaultOptions = {
        recycleVideo: true
      };
      var defaultOptions = {
        playerId: uniqueId(""),
        persistConfig: true,
        width: 640,
        height: 360,
        baseUrl: baseUrl,
        allowUserInteraction: Browser.isMobile,
        includeResetStyle: true,
        playback: playbackDefaultOptions
      };
      _this._options = zepto.extend(true, defaultOptions, options);
      _this.options.sources = _this._normalizeSources(options);
      if (!_this.options.chromeless) {
        // "allowUserInteraction" cannot be false if not in chromeless mode.
        _this.options.allowUserInteraction = true;
      }
      if (!_this.options.allowUserInteraction) {
        // if user iteraction is not allowed ensure keyboard shortcuts are disabled
        _this.options.disableKeyboardShortcuts = true;
      }
      _this._registerOptionEventListeners(_this.options.events);
      _this._coreFactory = new CoreFactory(_assertThisInitialized$2(_this));
      var parentElement = _this._getParentElement(_this.options);
      parentElement && _this.attachTo(parentElement);
      return _this;
    }

    /**
     * Returns the parent element
     * @param {String} parentId
     * @param {Object} parent
     * @returns {Object} the parent element
     */
    _createClass$2(Player, [{
      key: "loader",
      get: function get() {
        if (!(this || _global)._loader) (this || _global)._loader = new Loader((this || _global).options.plugins || {}, (this || _global).options.playerId);
        return (this || _global)._loader;
      }

      /**
       * Determine if the playback has ended.
       * @property ended
       * @type Boolean
       */,
      set: function set(loader) {
        (this || _global)._loader = loader;
      }
    }, {
      key: "ended",
      get: function get() {
        return (this || _global).core.activeContainer.ended;
      }

      /**
       * Determine if the playback is having to buffer in order for
       * playback to be smooth.
       * (i.e if a live stream is playing smoothly, this will be false)
       * @property buffering
       * @type Boolean
       */
    }, {
      key: "buffering",
      get: function get() {
        return (this || _global).core.activeContainer.buffering;
      }

      /*
       * determine if the player is ready.
       * @property isReady
       * @type {Boolean} `true` if the player is ready. ie PLAYER_READY event has fired
       */
    }, {
      key: "isReady",
      get: function get() {
        return !!(this || _global)._ready;
      }

      /**
       * An events map that allows the user to add custom callbacks in player's options.
       * @property eventsMapping
       * @type {Object}
       */
    }, {
      key: "eventsMapping",
      get: function get() {
        return {
          onReady: Events.PLAYER_READY,
          onResize: Events.PLAYER_RESIZE,
          onPlay: Events.PLAYER_PLAY,
          onPause: Events.PLAYER_PAUSE,
          onStop: Events.PLAYER_STOP,
          onEnded: Events.PLAYER_ENDED,
          onSeek: Events.PLAYER_SEEK,
          onError: Events.PLAYER_ERROR,
          onTimeUpdate: Events.PLAYER_TIMEUPDATE,
          onVolumeUpdate: Events.PLAYER_VOLUMEUPDATE,
          onSubtitleAvailable: Events.PLAYER_SUBTITLE_AVAILABLE
        };
      }
    }, {
      key: "_getParentElement",
      value: function _getParentElement(_ref) {
        var parentId = _ref.parentId,
          parent = _ref.parent;
        if (parentId) return document.querySelector(parentId);
        return parent;
      }

      /**
       * You can use this method to attach the player to a given element. You don't need to do this when you specify it during the player instantiation passing the `parentId` param.
       * @method attachTo
       * @param {Object} element a given element.
       * @return {Player} itself
       */
    }, {
      key: "attachTo",
      value: function attachTo(element) {
        (this || _global).options.parentElement = element;
        (this || _global).core = (this || _global)._coreFactory.create();
        this._addEventListeners();
        return this || _global;
      }
    }, {
      key: "_addEventListeners",
      value: function _addEventListeners() {
        if (!(this || _global).core.isReady) this.listenToOnce((this || _global).core, Events.CORE_READY, (this || _global)._onReady);else this._onReady();
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global)._containerChanged);
        this.listenTo((this || _global).core, Events.CORE_FULLSCREEN, (this || _global)._onFullscreenChange);
        this.listenTo((this || _global).core, Events.CORE_RESIZE, (this || _global)._onResize);
        return this || _global;
      }
    }, {
      key: "_addContainerEventListeners",
      value: function _addContainerEventListeners() {
        var container = (this || _global).core.activeContainer;
        if (container) {
          this.listenTo(container, Events.CONTAINER_PLAY, (this || _global)._onPlay);
          this.listenTo(container, Events.CONTAINER_PAUSE, (this || _global)._onPause);
          this.listenTo(container, Events.CONTAINER_STOP, (this || _global)._onStop);
          this.listenTo(container, Events.CONTAINER_ENDED, (this || _global)._onEnded);
          this.listenTo(container, Events.CONTAINER_SEEK, (this || _global)._onSeek);
          this.listenTo(container, Events.CONTAINER_ERROR, (this || _global)._onError);
          this.listenTo(container, Events.CONTAINER_TIMEUPDATE, (this || _global)._onTimeUpdate);
          this.listenTo(container, Events.CONTAINER_VOLUME, (this || _global)._onVolumeUpdate);
          this.listenTo(container, Events.CONTAINER_SUBTITLE_AVAILABLE, (this || _global)._onSubtitleAvailable);
        }
        return this || _global;
      }
    }, {
      key: "_registerOptionEventListeners",
      value: function _registerOptionEventListeners() {
        var _this2 = this || _global;
        var newEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var hasNewEvents = Object.keys(newEvents).length > 0;
        hasNewEvents && Object.keys(events).forEach(function (userEvent) {
          var eventType = _this2.eventsMapping[userEvent];
          eventType && _this2.off(eventType, events[userEvent]);
        });
        Object.keys(newEvents).forEach(function (userEvent) {
          var eventType = _this2.eventsMapping[userEvent];
          if (eventType) {
            var eventFunction = newEvents[userEvent];
            eventFunction = typeof eventFunction === "function" && eventFunction;
            eventFunction && _this2.on(eventType, eventFunction);
          }
        });
        return this || _global;
      }
    }, {
      key: "_containerChanged",
      value: function _containerChanged() {
        this.stopListening();
        this._addEventListeners();
      }
    }, {
      key: "_onReady",
      value: function _onReady() {
        (this || _global)._ready = true;
        this._addContainerEventListeners();
        this.trigger(Events.PLAYER_READY);
      }
    }, {
      key: "_onFullscreenChange",
      value: function _onFullscreenChange(fullscreen) {
        this.trigger(Events.PLAYER_FULLSCREEN, fullscreen);
      }
    }, {
      key: "_onVolumeUpdate",
      value: function _onVolumeUpdate(volume) {
        this.trigger(Events.PLAYER_VOLUMEUPDATE, volume);
      }
    }, {
      key: "_onSubtitleAvailable",
      value: function _onSubtitleAvailable() {
        this.trigger(Events.PLAYER_SUBTITLE_AVAILABLE);
      }
    }, {
      key: "_onResize",
      value: function _onResize(size) {
        this.trigger(Events.PLAYER_RESIZE, size);
      }
    }, {
      key: "_onPlay",
      value: function _onPlay(_) {
        var eventMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.trigger(Events.PLAYER_PLAY, eventMetadata);
      }
    }, {
      key: "_onPause",
      value: function _onPause(_) {
        var eventMetadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.trigger(Events.PLAYER_PAUSE, eventMetadata);
      }
    }, {
      key: "_onStop",
      value: function _onStop() {
        var eventMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.trigger(Events.PLAYER_STOP, this.getCurrentTime(), eventMetadata);
      }
    }, {
      key: "_onEnded",
      value: function _onEnded() {
        this.trigger(Events.PLAYER_ENDED);
      }
    }, {
      key: "_onSeek",
      value: function _onSeek(time) {
        this.trigger(Events.PLAYER_SEEK, time);
      }
    }, {
      key: "_onTimeUpdate",
      value: function _onTimeUpdate(timeProgress) {
        this.trigger(Events.PLAYER_TIMEUPDATE, timeProgress);
      }
    }, {
      key: "_onError",
      value: function _onError(error) {
        this.trigger(Events.PLAYER_ERROR, error);
      }
    }, {
      key: "_normalizeSources",
      value: function _normalizeSources(options) {
        var sources = options.sources || (options.source !== undefined ? [options.source] : []);
        return sources.length === 0 ? [{
          source: "",
          mimeType: ""
        }] : sources;
      }

      /**
       * resizes the current player canvas.
       * @method resize
       * @param {Object} size should be a literal object with `height` and `width`.
       * @return {Player} itself
       * @example
       * ```javascript
       * player.resize({height: 360, width: 640})
       * ```
       */
    }, {
      key: "resize",
      value: function resize(size) {
        (this || _global).core.resize(size);
        return this || _global;
      }

      /**
       * loads a new source.
       * @method load
       * @param {Array|String} sources source or sources of video.
       * An array item can be a string or {source: <<source URL>>, mimeType: <<source mime type>>}
       * @param {String} mimeType a mime type, example: `'application/vnd.apple.mpegurl'`
       * @param {Boolean} [autoPlay=false] whether playing should be started immediately
       * @return {Player} itself
       */
    }, {
      key: "load",
      value: function load(sources, mimeType, autoPlay) {
        if (autoPlay !== undefined) this.configure({
          autoPlay: !!autoPlay
        });
        (this || _global).core.load(sources, mimeType);
        return this || _global;
      }

      /**
       * destroys the current player and removes it from the DOM.
       * @method destroy
       * @return {Player} itself
       */
    }, {
      key: "destroy",
      value: function destroy() {
        this.stopListening();
        (this || _global).core.destroy();
        return this || _global;
      }

      /**
       * Gives user consent to playback. Required by mobile device after a click event before Player.load().
       * @method consent
       * @param {Function} callback function called when current playback is consented
       * @example
       * ```javascript
       * player.consent(function() { doSomethingNext(); });
       * ```
       */
    }, {
      key: "consent",
      value: function consent(cb) {
        (this || _global).core.getCurrentPlayback().consent(cb);
      }

      /**
       * plays the current video (`source`).
       * @method play
       * @param {Object} customData
       * @return {Player} itself
       */
    }, {
      key: "play",
      value: function play() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).core.activeContainer.play(customData);
        return this || _global;
      }

      /**
       * pauses the current video (`source`).
       * @method pause
       * @param {Object} customData
       * @return {Player} itself
       */
    }, {
      key: "pause",
      value: function pause() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).core.activeContainer.pause(customData);
        return this || _global;
      }

      /**
       * stops the current video (`source`).
       * @method stop
       * @param {Object} customData
       * @return {Player} itself
       */
    }, {
      key: "stop",
      value: function stop() {
        var customData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (this || _global).core.activeContainer.stop(customData);
        return this || _global;
      }

      /**
       * seeks the current video (`source`). For example, `player.seek(120)` will seek to second 120 (2minutes) of the current video.
       * @method seek
       * @param {Number} time should be a number between 0 and the video duration.
       * @return {Player} itself
       */
    }, {
      key: "seek",
      value: function seek(time) {
        (this || _global).core.activeContainer.seek(time);
        return this || _global;
      }

      /**
       * seeks the current video (`source`). For example, `player.seek(50)` will seek to the middle of the current video.
       * @method seekPercentage
       * @param {Number} time should be a number between 0 and 100.
       * @return {Player} itself
       */
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {
        (this || _global).core.activeContainer.seekPercentage(percentage);
        return this || _global;
      }

      /**
       * mutes the current video (`source`).
       * @method mute
       * @return {Player} itself
       */
    }, {
      key: "mute",
      value: function mute() {
        (this || _global).core.activePlayback.mute();
        return this || _global;
      }

      /**
       * unmutes the current video (`source`).
       * @method unmute
       * @return {Player} itself
       */
    }, {
      key: "unmute",
      value: function unmute() {
        (this || _global).core.activePlayback.unmute();
        return this || _global;
      }

      /**
       * checks if the player is playing.
       * @method isPlaying
       * @return {Boolean} `true` if the current source is playing, otherwise `false`
       */
    }, {
      key: "isPlaying",
      value: function isPlaying() {
        return (this || _global).core.activeContainer.isPlaying();
      }

      /**
       * returns `true` if DVR is enable otherwise `false`.
       * @method isDvrEnabled
       * @return {Boolean}
       */
    }, {
      key: "isDvrEnabled",
      value: function isDvrEnabled() {
        return (this || _global).core.activeContainer.isDvrEnabled();
      }

      /**
       * returns `true` if DVR is in use otherwise `false`.
       * @method isDvrInUse
       * @return {Boolean}
       */
    }, {
      key: "isDvrInUse",
      value: function isDvrInUse() {
        return (this || _global).core.activeContainer.isDvrInUse();
      }

      /**
       * enables to configure a player after its creation
       * @method configure
       * @param {Object} options all the options to change in form of a javascript object
       * @return {Player} itself
       */
    }, {
      key: "configure",
      value: function configure() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._registerOptionEventListeners(options.events, (this || _global).options.events);
        (this || _global).core.configure(options);
        return this || _global;
      }

      /**
       * get a plugin by its name.
       * @method getPlugin
       * @param {String} name of the plugin.
       * @return {Object} the plugin instance
       * @example
       * ```javascript
       * var poster = player.getPlugin('poster');
       * poster.hidePlayButton();
       * ```
       */
    }, {
      key: "getPlugin",
      value: function getPlugin(name) {
        var plugins = (this || _global).core.plugins.concat((this || _global).core.activeContainer.plugins);
        return plugins.filter(function (plugin) {
          return plugin.name === name;
        })[0];
      }

      /**
       * the current time in seconds.
       * @method getCurrentTime
       * @return {Number} current time (in seconds) of the current source
       */
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return (this || _global).core.activeContainer.getCurrentTime();
      }

      /**
       * The time that "0" now represents relative to when playback started.
       * For a stream with a sliding window this will increase as content is
       * removed from the beginning.
       * @method getStartTimeOffset
       * @return {Number} time (in seconds) that time "0" represents.
       */
    }, {
      key: "getStartTimeOffset",
      value: function getStartTimeOffset() {
        return (this || _global).core.activeContainer.getStartTimeOffset();
      }

      /**
       * the duration time in seconds.
       * @method getDuration
       * @return {Number} duration time (in seconds) of the current source
       */
    }, {
      key: "getDuration",
      value: function getDuration() {
        return (this || _global).core.activeContainer.getDuration();
      }
    }]);
    return Player;
  }(BaseObject);
  Object.assign(Player.prototype, ErrorMixin);

  /**
   * The base class for a container plugin
   * @class ContainerPlugin
   * @constructor
   * @extends BaseObject
   * @module base
   */
  var ContainerPlugin = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(ContainerPlugin, _BaseObject);
    var _super = _createSuper$2(ContainerPlugin);
    function ContainerPlugin(container) {
      var _this;
      _classCallCheck$2(this || _global, ContainerPlugin);
      _this = _super.call(this || _global, container.options);
      _this.container = container;
      _this.enabled = true;
      _this.bindEvents();
      return _this;
    }
    _createClass$2(ContainerPlugin, [{
      key: "playerError",
      get: function get() {
        return (this || _global).container.playerError;
      }
    }, {
      key: "enable",
      value: function enable() {
        if (!(this || _global).enabled) {
          this.bindEvents();
          (this || _global).enabled = true;
        }
      }
    }, {
      key: "disable",
      value: function disable() {
        if ((this || _global).enabled) {
          this.stopListening();
          (this || _global).enabled = false;
        }
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {}
    }, {
      key: "destroy",
      value: function destroy() {
        this.stopListening();
      }
    }]);
    return ContainerPlugin;
  }(BaseObject);
  Object.assign(ContainerPlugin.prototype, ErrorMixin);
  ContainerPlugin.extend = function (properties) {
    return extend$1(ContainerPlugin, properties);
  };
  ContainerPlugin.type = "container";
  var CorePlugin = /*#__PURE__*/function (_BaseObject) {
    _inherits$2(CorePlugin, _BaseObject);
    var _super = _createSuper$2(CorePlugin);
    function CorePlugin(core) {
      var _this;
      _classCallCheck$2(this || _global, CorePlugin);
      _this = _super.call(this || _global, core.options);
      _this.core = core;
      _this.enabled = true;
      _this.bindEvents();
      return _this;
    }
    _createClass$2(CorePlugin, [{
      key: "playerError",
      get: function get() {
        return (this || _global).core.playerError;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {}
    }, {
      key: "enable",
      value: function enable() {
        if (!(this || _global).enabled) {
          this.bindEvents();
          (this || _global).enabled = true;
        }
      }
    }, {
      key: "disable",
      value: function disable() {
        if ((this || _global).enabled) {
          this.stopListening();
          (this || _global).enabled = false;
        }
      }
    }, {
      key: "getExternalInterface",
      value: function getExternalInterface() {
        return {};
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.stopListening();
      }
    }]);
    return CorePlugin;
  }(BaseObject);
  Object.assign(CorePlugin.prototype, ErrorMixin);
  CorePlugin.extend = function (properties) {
    return extend$1(CorePlugin, properties);
  };
  CorePlugin.type = "core";

  /**
   * The base class for an ui container plugin
   * @class UIContainerPlugin
   * @constructor
   * @extends UIObject
   * @module base
   */
  var UIContainerPlugin = /*#__PURE__*/function (_UIObject) {
    _inherits$2(UIContainerPlugin, _UIObject);
    var _super = _createSuper$2(UIContainerPlugin);
    function UIContainerPlugin(container) {
      var _this;
      _classCallCheck$2(this || _global, UIContainerPlugin);
      _this = _super.call(this || _global, container.options);
      _this.container = container;
      _this.enabled = true;
      _this.bindEvents();
      return _this;
    }
    _createClass$2(UIContainerPlugin, [{
      key: "playerError",
      get: function get() {
        return (this || _global).container.playerError;
      }
    }, {
      key: "enable",
      value: function enable() {
        if (!(this || _global).enabled) {
          this.bindEvents();
          (this || _global).$el.show();
          (this || _global).enabled = true;
        }
      }
    }, {
      key: "disable",
      value: function disable() {
        this.stopListening();
        (this || _global).$el.hide();
        (this || _global).enabled = false;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {}
    }]);
    return UIContainerPlugin;
  }(UIObject);
  Object.assign(UIContainerPlugin.prototype, ErrorMixin);
  UIContainerPlugin.extend = function (properties) {
    return extend$1(UIContainerPlugin, properties);
  };
  UIContainerPlugin.type = "container";
  var tracksHTML = "<% for (var i = 0; i < tracks.length; i++) { %>\n  <track data-html5-video-track=\"<%= i %>\" kind=\"<%= tracks[i].kind %>\" label=\"<%= tracks[i].label %>\" srclang=\"<%= tracks[i].lang %>\" src=\"<%= tracks[i].src %>\">\n<% }; %>\n";
  var css_248z$2$1 = "[data-html5-video] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  display: block; }\n";
  var MIMETYPES = {
    "mp4": ["avc1.42E01E", "avc1.58A01E", "avc1.4D401E", "avc1.64001E", "mp4v.20.8", "mp4v.20.240", "mp4a.40.2"].map(function (codec) {
      return "video/mp4; codecs=\"" + codec + ", mp4a.40.2\"";
    }),
    "ogg": ["video/ogg; codecs=\"theora, vorbis\"", "video/ogg; codecs=\"dirac\"", "video/ogg; codecs=\"theora, speex\""],
    "3gpp": ["video/3gpp; codecs=\"mp4v.20.8, samr\""],
    "webm": ["video/webm; codecs=\"vp8, vorbis\""],
    "mkv": ["video/x-matroska; codecs=\"theora, vorbis\""],
    "m3u8": ["application/x-mpegurl"]
  };
  MIMETYPES["ogv"] = MIMETYPES["ogg"];
  MIMETYPES["3gp"] = MIMETYPES["3gpp"];
  var AUDIO_MIMETYPES = {
    "wav": ["audio/wav"],
    "mp3": ["audio/mp3", "audio/mpeg;codecs=\"mp3\""],
    "aac": ["audio/mp4;codecs=\"mp4a.40.5\""],
    "oga": ["audio/ogg"]
  };
  var KNOWN_AUDIO_MIMETYPES = Object.keys(AUDIO_MIMETYPES).reduce(function (acc, k) {
    return [].concat(_toConsumableArray$1(acc), _toConsumableArray$1(AUDIO_MIMETYPES[k]));
  }, []);
  var UNKNOWN_ERROR = {
    code: "unknown",
    message: "unknown"
  };

  // TODO: rename this Playback to HTML5Playback (breaking change, only after 0.3.0)
  var HTML5Video = /*#__PURE__*/function (_Playback) {
    _inherits$2(HTML5Video, _Playback);
    var _super = _createSuper$2(HTML5Video);
    function HTML5Video() {
      var _this;
      _classCallCheck$2(this || _global, HTML5Video);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this || _global].concat(args));
      _this._destroyed = false;
      _this._loadStarted = false;
      _this._isBuffering = false;
      _this._playheadMoving = false;
      _this._playheadMovingTimer = null;
      _this._stopped = false;
      _this._ccTrackId = -1;
      _this._setupSrc(_this.options.src);
      // backwards compatibility (TODO: remove on 0.3.0)
      _this.options.playback || (_this.options.playback = _this.options || {});
      _this.options.playback.disableContextMenu = _this.options.playback.disableContextMenu || _this.options.disableVideoTagContextMenu;
      _this._minDvrSize = _this.isValidMinimumDVRSizeConfig ? _this.minimumDVRSizeConfig : 60;
      var playbackConfig = _this.options.playback;
      var preload = playbackConfig.preload || (Browser.isSafari ? "auto" : _this.options.preload);
      var posterUrl; // FIXME: poster plugin should always convert poster to object with expected properties ?
      if (_this.options.poster) {
        if (typeof _this.options.poster === "string") posterUrl = _this.options.poster;else if (typeof _this.options.poster.url === "string") posterUrl = _this.options.poster.url;
      }
      zepto.extend(true, _this.el, {
        muted: _this.options.mute,
        defaultMuted: _this.options.mute,
        loop: _this.options.loop,
        poster: posterUrl,
        preload: preload || "metadata",
        crossOrigin: playbackConfig.crossOrigin,
        "x-webkit-playsinline": playbackConfig.playInline
      });
      if (playbackConfig.controls || _this.options.useVideoTagDefaultControls) _this.$el.attr("controls", "");
      playbackConfig.playInline && _this.$el.attr({
        playsinline: "playsinline"
      });
      playbackConfig.crossOrigin && _this.$el.attr({
        crossorigin: playbackConfig.crossOrigin
      });

      // TODO should settings be private?
      _this.settings = {
        "default": ["seekbar"]
      };
      _this.settings.left = ["playpause", "position", "duration"];
      _this.settings.right = ["fullscreen", "volume", "hd-indicator"];
      playbackConfig.externalTracks && _this._setupExternalTracks(playbackConfig.externalTracks);
      _this.options.autoPlay && _this.attemptAutoPlay();
      return _this;
    }
    _createClass$2(HTML5Video, [{
      key: "name",
      get: function get() {
        return "html5_video";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "tagName",
      get: function get() {
        return (this || _global).isAudioOnly ? "audio" : "video";
      }
    }, {
      key: "isAudioOnly",
      get: function get() {
        var resourceUrl = (this || _global).options.src;
        var mimeTypes = HTML5Video._mimeTypesForUrl(resourceUrl, AUDIO_MIMETYPES, (this || _global).options.mimeType);
        return (this || _global).options.playback && (this || _global).options.playback.audioOnly || (this || _global).options.audioOnly || KNOWN_AUDIO_MIMETYPES.indexOf(mimeTypes[0]) >= 0;
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "data-html5-video": ""
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "canplay": "_onCanPlay",
          "canplaythrough": "_handleBufferingEvents",
          "durationchange": "_onDurationChange",
          "ended": "_onEnded",
          "error": "_onError",
          "loadeddata": "_onLoadedData",
          "loadedmetadata": "_onLoadedMetadata",
          "pause": "_onPause",
          "playing": "_onPlaying",
          "progress": "_onProgress",
          "seeking": "_onSeeking",
          "seeked": "_onSeeked",
          "stalled": "_handleBufferingEvents",
          "timeupdate": "_onTimeUpdate",
          "waiting": "_onWaiting"
        };
      }

      /**
       * Determine if the playback has ended.
       * @property ended
       * @type Boolean
       */
    }, {
      key: "ended",
      get: function get() {
        return (this || _global).el.ended;
      }

      /**
       * Determine if the playback is having to buffer in order for
       * playback to be smooth.
       * This is related to the PLAYBACK_BUFFERING and PLAYBACK_BUFFERFULL events
       * @property buffering
       * @type Boolean
       */
    }, {
      key: "buffering",
      get: function get() {
        return (this || _global)._isBuffering;
      }
    }, {
      key: "isLive",
      get: function get() {
        return this.getPlaybackType() === Playback.LIVE;
      }
    }, {
      key: "dvrEnabled",
      get: function get() {
        return this.getDuration() >= (this || _global)._minDvrSize && (this || _global).isLive;
      }
    }, {
      key: "minimumDVRSizeConfig",
      get: function get() {
        return (this || _global).options.playback && (this || _global).options.playback.minimumDvrSize;
      }
    }, {
      key: "isValidMinimumDVRSizeConfig",
      get: function get() {
        return typeof (this || _global).minimumDVRSizeConfig !== "undefined" && typeof (this || _global).minimumDVRSizeConfig === "number";
      }
    }, {
      key: "configure",
      value: function configure(options) {
        _get$2(_getPrototypeOf$2(HTML5Video.prototype), "configure", this || _global).call(this || _global, options);
        (this || _global).el.loop = !!options.loop;
      }

      // See Playback.attemptAutoPlay()
    }, {
      key: "attemptAutoPlay",
      value: function attemptAutoPlay() {
        var _this2 = this || _global;
        this.canAutoPlay(function (result, error) {
          error && Log.warn(_this2.name, "autoplay error.", {
            result: result,
            error: error
          });

          // https://github.com/clappr/clappr/issues/1076
          result && setTimeout(function () {
            return !_this2._destroyed && _this2.play();
          }, 0);
        });
      }

      // See Playback.canAutoPlay()
    }, {
      key: "canAutoPlay",
      value: function canAutoPlay(cb) {
        if ((this || _global).options.disableCanAutoPlay) {
          cb(true, null);
          return;
        }
        var opts = {
          timeout: (this || _global).options.autoPlayTimeout || 500,
          inline: (this || _global).options.playback.playInline || false,
          muted: (this || _global).options.mute || false // Known issue: mediacontrols may asynchronously mute video
        };

        // Use current video element if recycling feature enabled with mobile devices
        if (Browser.isMobile && DomRecycler.options.recycleVideo) opts.element = (this || _global).el;

        // Desktop browser autoplay policy may require user action
        // Mobile browser autoplay require user consent and video recycling feature enabled
        // It may returns a false positive with source-less player consent
        canAutoPlayMedia(cb, opts);
      }
    }, {
      key: "_setupExternalTracks",
      value: function _setupExternalTracks(tracks) {
        (this || _global)._externalTracks = tracks.map(function (track) {
          return {
            kind: track.kind || "subtitles",
            // Default is 'subtitles'
            label: track.label,
            lang: track.lang,
            src: track.src
          };
        });
      }

      /**
       * Sets the source url on the <video> element, and also the 'src' property.
       * @method setupSrc
       * @private
       * @param {String} srcUrl The source URL.
       */
    }, {
      key: "_setupSrc",
      value: function _setupSrc(srcUrl) {
        if ((this || _global).el.src === srcUrl) return;
        (this || _global)._ccIsSetup = false;
        (this || _global).el.src = srcUrl;
        (this || _global)._src = (this || _global).el.src;
      }
    }, {
      key: "_onLoadedMetadata",
      value: function _onLoadedMetadata(e) {
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_LOADEDMETADATA, {
          duration: e.target.duration,
          data: e
        });
        this._updateSettings();
        var autoSeekFromUrl = typeof (this || _global)._options.autoSeekFromUrl === "undefined" || (this || _global)._options.autoSeekFromUrl;
        if (this.getPlaybackType() !== Playback.LIVE && autoSeekFromUrl) this._checkInitialSeek();
      }
    }, {
      key: "_onDurationChange",
      value: function _onDurationChange() {
        this._updateSettings();
        this._onTimeUpdate();
        // onProgress uses the duration
        this._onProgress();
      }
    }, {
      key: "_updateSettings",
      value: function _updateSettings() {
        // we can't figure out if hls resource is VoD or not until it is being loaded or duration has changed.
        // that's why we check it again and update media control accordingly.
        if (this.getPlaybackType() === Playback.VOD || this.getPlaybackType() === Playback.AOD) (this || _global).settings.left = ["playpause", "position", "duration"];else (this || _global).settings.left = ["playstop"];
        (this || _global).settings.seekEnabled = this.isSeekEnabled();
        this.trigger(Events.PLAYBACK_SETTINGSUPDATE);
      }
    }, {
      key: "isSeekEnabled",
      value: function isSeekEnabled() {
        return isFinite(this.getDuration());
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        var onDemandType = (this || _global).tagName === "audio" ? Playback.AOD : Playback.VOD;
        return [0, undefined, Infinity].indexOf((this || _global).el.duration) >= 0 ? Playback.LIVE : onDemandType;
      }
    }, {
      key: "isHighDefinitionInUse",
      value: function isHighDefinitionInUse() {
        return false;
      }

      // On mobile device, HTML5 video element "retains" user action consent if
      // load() method is called. See Player.consent().
    }, {
      key: "consent",
      value: function consent(cb) {
        var _this3 = this || _global;
        if (this.isPlaying() || (this || _global).el._consented) {
          _get$2(_getPrototypeOf$2(HTML5Video.prototype), "consent", this || _global).call(this || _global, cb);
        } else {
          var eventHandler = function eventHandler() {
            _this3.el.removeEventListener("loadedmetadata", eventHandler, false);
            _this3.el.removeEventListener("error", eventHandler, false);
            _this3.el._consented = true; // Flag to call load() only once
            _get$2(_getPrototypeOf$2(HTML5Video.prototype), "consent", _this3).call(_this3, cb);
          };
          (this || _global).el.addEventListener("loadedmetadata", eventHandler, false);
          (this || _global).el.addEventListener("error", eventHandler, false);
          (this || _global).el.load();
        }
      }
    }, {
      key: "play",
      value: function play() {
        this.trigger(Events.PLAYBACK_PLAY_INTENT);
        (this || _global)._stopped = false;
        this._setupSrc((this || _global)._src);
        this._handleBufferingEvents();
        var promise = (this || _global).el.play();
        // For more details, see https://developers.google.com/web/updates/2016/03/play-returns-promise
        if (promise && promise["catch"]) promise["catch"](function () {});
      }
    }, {
      key: "pause",
      value: function pause() {
        (this || _global).el.pause();
        (this || _global).dvrEnabled && this._updateDvr(true);
      }
    }, {
      key: "stop",
      value: function stop() {
        this.pause();
        (this || _global)._stopped = true;
        // src will be added again in play()
        (this || _global).el.removeAttribute("src");
        (this || _global).el.load(); // load with no src to stop loading of the previous source and avoid leaks
        this._stopPlayheadMovingChecks();
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_STOP);
      }
    }, {
      key: "volume",
      value: function volume(value) {
        if (value === 0) {
          (this || _global).$el.attr({
            muted: "true"
          });
          (this || _global).el.muted = true;
        } else {
          (this || _global).$el.attr({
            muted: null
          });
          (this || _global).el.muted = false;
          (this || _global).el.volume = value / 100;
        }
      }

      /**
       * @deprecated
       * @private
       */
    }, {
      key: "mute",
      value: function mute() {
        (this || _global).el.muted = true;
      }

      /**
       * @deprecated
       * @private
       */
    }, {
      key: "unmute",
      value: function unmute() {
        (this || _global).el.muted = false;
      }
    }, {
      key: "isMuted",
      value: function isMuted() {
        return (this || _global).el.muted === true || (this || _global).el.volume === 0;
      }
    }, {
      key: "isPlaying",
      value: function isPlaying() {
        return !(this || _global).el.paused && !(this || _global).el.ended;
      }
    }, {
      key: "isReady",
      get: function get() {
        return (this || _global)._isReadyState;
      }
    }, {
      key: "_startPlayheadMovingChecks",
      value: function _startPlayheadMovingChecks() {
        if ((this || _global)._playheadMovingTimer !== null) return;
        (this || _global)._playheadMovingTimeOnCheck = null;
        this._determineIfPlayheadMoving();
        (this || _global)._playheadMovingTimer = setInterval((this || _global)._determineIfPlayheadMoving.bind(this || _global), 500);
      }
    }, {
      key: "_stopPlayheadMovingChecks",
      value: function _stopPlayheadMovingChecks() {
        if ((this || _global)._playheadMovingTimer === null) return;
        clearInterval((this || _global)._playheadMovingTimer);
        (this || _global)._playheadMovingTimer = null;
        (this || _global)._playheadMoving = false;
      }
    }, {
      key: "_determineIfPlayheadMoving",
      value: function _determineIfPlayheadMoving() {
        var before = (this || _global)._playheadMovingTimeOnCheck;
        var now = (this || _global).el.currentTime;
        (this || _global)._playheadMoving = before !== now;
        (this || _global)._playheadMovingTimeOnCheck = now;
        this._handleBufferingEvents();
      }

      // this seems to happen when the user is having to wait
      // for something to happen AFTER A USER INTERACTION
      // e.g the player might be buffering, but when `play()` is called
      // only at this point will this be called.
      // Or the user may seek somewhere but the new area requires buffering,
      // so it will fire then as well.
      // On devices where playing is blocked until requested with a user action,
      // buffering may start, but never finish until the user initiates a play,
      // but this only happens when play is actually requested
    }, {
      key: "_onWaiting",
      value: function _onWaiting() {
        (this || _global)._loadStarted = true;
        this._handleBufferingEvents();
      }

      // called after the first frame has loaded
      // note this doesn't fire on ios before the user has requested play
      // ideally the "loadstart" event would be used instead, but this fires
      // before a user has requested play on iOS, and also this is always fired
      // even if the preload setting is "none". In both these cases this causes
      // infinite buffering until the user does something which isn't great.
    }, {
      key: "_onLoadedData",
      value: function _onLoadedData() {
        (this || _global)._loadStarted = true;
        this._handleBufferingEvents();
      }

      // note this doesn't fire on ios before user has requested play
    }, {
      key: "_onCanPlay",
      value: function _onCanPlay() {
        this._handleBufferingEvents();
      }
    }, {
      key: "_onPlaying",
      value: function _onPlaying() {
        this._checkForClosedCaptions();
        this._startPlayheadMovingChecks();
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_PLAY);
      }
    }, {
      key: "_onPause",
      value: function _onPause() {
        this._stopPlayheadMovingChecks();
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_PAUSE);
      }
    }, {
      key: "_onSeeking",
      value: function _onSeeking() {
        this.trigger(Events.PLAYBACK_SEEK, this.getCurrentTime());
        this._handleBufferingEvents();
      }
    }, {
      key: "_onSeeked",
      value: function _onSeeked() {
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_SEEKED);
      }
    }, {
      key: "_onEnded",
      value: function _onEnded() {
        this._handleBufferingEvents();
        this.trigger(Events.PLAYBACK_ENDED, (this || _global).name);
      }

      // The playback should be classed as buffering if the following are true:
      // - the ready state is less then HAVE_FUTURE_DATA or the playhead isn't moving and it should be
      // - the media hasn't "ended",
      // - the media hasn't been stopped
      // - loading has started
    }, {
      key: "_handleBufferingEvents",
      value: function _handleBufferingEvents() {
        var playheadShouldBeMoving = !(this || _global).el.ended && !(this || _global).el.paused;
        var buffering = (this || _global)._loadStarted && !(this || _global).el.ended && !(this || _global)._stopped && (playheadShouldBeMoving && !(this || _global)._playheadMoving || (this || _global).el.readyState < (this || _global).el.HAVE_FUTURE_DATA);
        if ((this || _global)._isBuffering !== buffering) {
          (this || _global)._isBuffering = buffering;
          if (buffering) this.trigger(Events.PLAYBACK_BUFFERING, (this || _global).name);else this.trigger(Events.PLAYBACK_BUFFERFULL, (this || _global).name);
        }
      }
    }, {
      key: "_onError",
      value: function _onError() {
        var _ref = (this || _global).el.error || UNKNOWN_ERROR,
          code = _ref.code,
          message = _ref.message;
        var isUnknownError = code === UNKNOWN_ERROR.code;
        var formattedError = this.createError({
          code: code,
          description: message,
          raw: (this || _global).el.error,
          level: isUnknownError ? PlayerError.Levels.WARN : PlayerError.Levels.FATAL
        });
        if (isUnknownError) Log.warn((this || _global).name, "HTML5 unknown error: ", formattedError);else this.trigger(Events.PLAYBACK_ERROR, formattedError);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        (this || _global)._destroyed = true;
        (this || _global).handleTextTrackChange && (this || _global).el.textTracks.removeEventListener("change", (this || _global).handleTextTrackChange);
        _get$2(_getPrototypeOf$2(HTML5Video.prototype), "destroy", this || _global).call(this || _global);
        (this || _global).el.removeAttribute("src");
        (this || _global).el.load(); // load with no src to stop loading of the previous source and avoid leaks
        (this || _global)._src = null;
        DomRecycler.garbage((this || _global).el);
      }
    }, {
      key: "_updateDvr",
      value: function _updateDvr(status) {
        this.trigger(Events.PLAYBACK_DVR, status);
        this.trigger(Events.PLAYBACK_STATS_ADD, {
          "dvr": status
        });
      }
    }, {
      key: "seek",
      value: function seek(time) {
        if (time < 0) {
          Log.warn("Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.");
          time = this.getDuration();
        }
        // assume live if time within 3 seconds of end of stream
        (this || _global).dvrEnabled && this._updateDvr(time < this.getDuration() - 3);
        time += (this || _global).el.seekable.start(0);
        (this || _global).el.currentTime = time;
      }
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {
        var time = (this || _global).el.duration * (percentage / 100);
        this.seek(time);
      }
    }, {
      key: "_checkInitialSeek",
      value: function _checkInitialSeek() {
        var seekTime = seekStringToSeconds();
        if (seekTime !== 0) this.seek(seekTime);
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return (this || _global).el.currentTime;
      }
    }, {
      key: "getDuration",
      value: function getDuration() {
        if ((this || _global).isLive) {
          if ((this || _global).el.seekable.length > 0) {
            return (this || _global).el.seekable.end(0) - (this || _global).el.seekable.start(0);
          } else {
            // `seekable` is not available; this is probably OK, but make sure we're
            // updating the control bar to reflect it
            this._scheduleUpdateSettingsCheck();
          }
        }
        return (this || _global).el.duration;
      }
    }, {
      key: "_scheduleUpdateSettingsCheck",
      value: function _scheduleUpdateSettingsCheck() {
        var _this4 = this || _global;
        if ((this || _global)._updateSettingsCheckInFlight) return;
        (this || _global)._updateSettingsCheckInFlight = setTimeout(function () {
          _this4._updateSettings();
          _this4._updateSettingsCheckInFlight = null;
        }, 1000);
      }
    }, {
      key: "_onTimeUpdate",
      value: function _onTimeUpdate() {
        var duration = (this || _global).isLive ? this.getDuration() : (this || _global).el.duration;
        this.trigger(Events.PLAYBACK_TIMEUPDATE, {
          current: (this || _global).el.currentTime,
          total: duration
        }, (this || _global).name);
      }
    }, {
      key: "_onProgress",
      value: function _onProgress() {
        if (!(this || _global).el.buffered.length) return;
        var buffered = [];
        var bufferedPos = 0;
        for (var i = 0; i < (this || _global).el.buffered.length; i++) {
          buffered = [].concat(_toConsumableArray$1(buffered), [{
            start: (this || _global).el.buffered.start(i),
            end: (this || _global).el.buffered.end(i)
          }]);
          if ((this || _global).el.currentTime >= buffered[i].start && (this || _global).el.currentTime <= buffered[i].end) bufferedPos = i;
        }
        var progress = {
          start: buffered[bufferedPos].start,
          current: buffered[bufferedPos].end,
          total: (this || _global).el.duration
        };
        this.trigger(Events.PLAYBACK_PROGRESS, progress, buffered);
      }
    }, {
      key: "_typeFor",
      value: function _typeFor(src) {
        var mimeTypes = HTML5Video._mimeTypesForUrl(src, MIMETYPES, (this || _global).options.mimeType);
        if (mimeTypes.length === 0) mimeTypes = HTML5Video._mimeTypesForUrl(src, AUDIO_MIMETYPES, (this || _global).options.mimeType);
        var mimeType = mimeTypes[0] || "";
        return mimeType.split(";")[0];
      }
    }, {
      key: "_ready",
      value: function _ready() {
        if ((this || _global)._isReadyState) return;
        (this || _global)._isReadyState = true;
        this.trigger(Events.PLAYBACK_READY, (this || _global).name);
      }
    }, {
      key: "_checkForClosedCaptions",
      value: function _checkForClosedCaptions() {
        // Check if CC available only if current playback is HTML5Video
        if ((this || _global).isHTML5Video && !(this || _global)._ccIsSetup) {
          if ((this || _global).hasClosedCaptionsTracks) {
            this.trigger(Events.PLAYBACK_SUBTITLE_AVAILABLE);
            var trackId = (this || _global).closedCaptionsTrackId;
            (this || _global).closedCaptionsTrackId = trackId;
            (this || _global).handleTextTrackChange = (this || _global)._handleTextTrackChange.bind(this || _global);
            (this || _global).el.textTracks.addEventListener("change", (this || _global).handleTextTrackChange);
          }
          (this || _global)._ccIsSetup = true;
        }
      }
    }, {
      key: "_handleTextTrackChange",
      value: function _handleTextTrackChange() {
        var tracks = (this || _global).closedCaptionsTracks;
        var track = tracks.find(function (track) {
          return track.track.mode === "showing";
        }) || {
          id: -1
        };
        if ((this || _global)._ccTrackId !== track.id) {
          (this || _global)._ccTrackId = track.id;
          this.trigger(Events.PLAYBACK_SUBTITLE_CHANGED, {
            id: track.id
          });
        }
      }
    }, {
      key: "isHTML5Video",
      get: function get() {
        return (this || _global).name === HTML5Video.prototype.name;
      }
    }, {
      key: "closedCaptionsTracks",
      get: function get() {
        var id = 0;
        var trackId = function trackId() {
          return id++;
        };
        var textTracks = (this || _global).el.textTracks ? Array.from((this || _global).el.textTracks) : [];
        return textTracks.filter(function (track) {
          return track.kind === "subtitles" || track.kind === "captions";
        }).map(function (track) {
          return {
            id: trackId(),
            name: track.label,
            track: track
          };
        });
      }
    }, {
      key: "closedCaptionsTrackId",
      get: function get() {
        return (this || _global)._ccTrackId;
      },
      set: function set(trackId) {
        if (!isNumber(trackId)) return;
        var tracks = (this || _global).closedCaptionsTracks;
        var showingTrack;

        // Note: -1 is for hide all tracks
        if (trackId !== -1) {
          showingTrack = tracks.find(function (track) {
            return track.id === trackId;
          });
          if (!showingTrack) return; // Track id not found

          if (showingTrack.track.mode === "showing") return; // Track already showing
        }

        // Since it is possible to display multiple tracks,
        // ensure that all tracks are hidden.
        tracks.filter(function (track) {
          return track.track.mode !== "hidden";
        }).forEach(function (track) {
          return track.track.mode = "hidden";
        });
        showingTrack && (showingTrack.track.mode = "showing");
        (this || _global)._ccTrackId = trackId;
        this.trigger(Events.PLAYBACK_SUBTITLE_CHANGED, {
          id: trackId
        });
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(tracksHTML);
      }
    }, {
      key: "render",
      value: function render() {
        if ((this || _global).options.playback.disableContextMenu) {
          (this || _global).$el.on("contextmenu", function () {
            return false;
          });
        }
        if ((this || _global)._externalTracks && (this || _global)._externalTracks.length > 0) {
          (this || _global).$el.html(this.template({
            tracks: (this || _global)._externalTracks
          }));
        }
        this._ready();
        var style = Styler.getStyleFor(css_248z$2$1.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        return this || _global;
      }
    }]);
    return HTML5Video;
  }(Playback);
  HTML5Video._mimeTypesForUrl = function (resourceUrl, mimeTypesByExtension, mimeType) {
    var extension = (resourceUrl.split("?")[0].match(/.*\.(.*)$/) || [])[1];
    var mimeTypes = mimeType || extension && mimeTypesByExtension[extension.toLowerCase()] || [];
    return mimeTypes.constructor === Array ? mimeTypes : [mimeTypes];
  };
  HTML5Video._canPlay = function (type, mimeTypesByExtension, resourceUrl, mimeType) {
    var mimeTypes = HTML5Video._mimeTypesForUrl(resourceUrl, mimeTypesByExtension, mimeType);
    var media = document.createElement(type);
    return !!mimeTypes.filter(function (mediaType) {
      return !!media.canPlayType(mediaType).replace(/no/, "");
    })[0];
  };
  HTML5Video.canPlay = function (resourceUrl, mimeType) {
    return HTML5Video._canPlay("audio", AUDIO_MIMETYPES, resourceUrl, mimeType) || HTML5Video._canPlay("video", MIMETYPES, resourceUrl, mimeType);
  };

  // TODO: remove this playback and change HTML5Video to HTML5Playback (breaking change, only after 0.3.0)
  var HTML5Audio = /*#__PURE__*/function (_HTML5Video) {
    _inherits$2(HTML5Audio, _HTML5Video);
    var _super = _createSuper$2(HTML5Audio);
    function HTML5Audio() {
      _classCallCheck$2(this || _global, HTML5Audio);
      return _super.apply(this || _global, arguments);
    }
    _createClass$2(HTML5Audio, [{
      key: "name",
      get: function get() {
        return "html5_audio";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "tagName",
      get: function get() {
        return "audio";
      }
    }, {
      key: "isAudioOnly",
      get: function get() {
        return true;
      }
    }, {
      key: "updateSettings",
      value: function updateSettings() {
        (this || _global).settings.left = ["playpause", "position", "duration"];
        (this || _global).settings.seekEnabled = this.isSeekEnabled();
        this.trigger(Events.PLAYBACK_SETTINGSUPDATE);
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return Playback.AOD;
      }
    }]);
    return HTML5Audio;
  }(HTML5Video);
  HTML5Audio.canPlay = function (resourceUrl, mimeType) {
    var mimetypes = {
      "wav": ["audio/wav"],
      "mp3": ["audio/mp3", "audio/mpeg;codecs=\"mp3\""],
      "aac": ["audio/mp4;codecs=\"mp4a.40.5\""],
      "oga": ["audio/ogg"]
    };
    return HTML5Video._canPlay("audio", mimetypes, resourceUrl, mimeType);
  };
  var css_248z$1$1 = "[data-html-img] {\n  max-width: 100%;\n  max-height: 100%; }\n";
  var HTMLImg = /*#__PURE__*/function (_Playback) {
    _inherits$2(HTMLImg, _Playback);
    var _super = _createSuper$2(HTMLImg);
    function HTMLImg(params) {
      var _this;
      _classCallCheck$2(this || _global, HTMLImg);
      _this = _super.call(this || _global, params);
      _this.el.src = params.src;
      return _this;
    }
    _createClass$2(HTMLImg, [{
      key: "name",
      get: function get() {
        return "html_img";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "tagName",
      get: function get() {
        return "img";
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "data-html-img": ""
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "load": "_onLoad",
          "abort": "_onError",
          "error": "_onError"
        };
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return Playback.NO_OP;
      }
    }, {
      key: "render",
      value: function render() {
        var style = Styler.getStyleFor(css_248z$1$1.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        this.trigger(Events.PLAYBACK_READY, (this || _global).name);
        return this || _global;
      }
    }, {
      key: "_onLoad",
      value: function _onLoad() {
        this.trigger(Events.PLAYBACK_ENDED, (this || _global).name);
      }
    }, {
      key: "_onError",
      value: function _onError(evt) {
        var m = evt.type === "error" ? "load error" : "loading aborted";
        this.trigger(Events.PLAYBACK_ERROR, {
          message: m
        }, (this || _global).name);
      }
    }]);
    return HTMLImg;
  }(Playback);
  HTMLImg.canPlay = function (resource) {
    return /\.(png|jpg|jpeg|gif|bmp|tiff|pgm|pnm|webp)(|\?.*)$/i.test(resource);
  };
  var noOpHTML = "<canvas data-no-op-canvas></canvas>\n<p data-no-op-msg><%=message%></p><p>\n</p>";
  var css_248z$8 = "[data-no-op] {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  text-align: center; }\n\n[data-no-op] p[data-no-op-msg] {\n  position: absolute;\n  text-align: center;\n  font-size: 25px;\n  left: 0;\n  right: 0;\n  color: white;\n  padding: 10px;\n  /* center vertically */\n  top: 50%;\n  transform: translateY(-50%);\n  max-height: 100%;\n  overflow: auto; }\n\n[data-no-op] canvas[data-no-op-canvas] {\n  background-color: #777;\n  height: 100%;\n  width: 100%; }\n";
  var NoOp = /*#__PURE__*/function (_Playback) {
    _inherits$2(NoOp, _Playback);
    var _super = _createSuper$2(NoOp);
    function NoOp() {
      var _this;
      _classCallCheck$2(this || _global, NoOp);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this || _global].concat(args));
      _this._noiseFrameNum = -1;
      return _this;
    }
    _createClass$2(NoOp, [{
      key: "name",
      get: function get() {
        return "no_op";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(noOpHTML);
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "data-no-op": ""
        };
      }
    }, {
      key: "render",
      value: function render() {
        var playbackNotSupported = (this || _global).options.playbackNotSupportedMessage || (this || _global).i18n.t("playback_not_supported");
        var style = Styler.getStyleFor(css_248z$8.toString(), {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        (this || _global).$el.html(this.template({
          message: playbackNotSupported
        }));
        this.trigger(Events.PLAYBACK_READY, (this || _global).name);
        var showForNoOp = !!((this || _global).options.poster && (this || _global).options.poster.showForNoOp);
        if ((this || _global).options.autoPlay || !showForNoOp) this._animate();
        return this || _global;
      }
    }, {
      key: "_noise",
      value: function _noise() {
        (this || _global)._noiseFrameNum = ((this || _global)._noiseFrameNum + 1) % 5;
        if ((this || _global)._noiseFrameNum) {
          // only update noise every 5 frames to save cpu
          return;
        }
        var idata = (this || _global).context.createImageData((this || _global).context.canvas.width, (this || _global).context.canvas.height);
        var buffer32;
        try {
          buffer32 = new Uint32Array(idata.data.buffer);
        } catch (err) {
          buffer32 = new Uint32Array((this || _global).context.canvas.width * (this || _global).context.canvas.height * 4);
          var data = idata.data;
          for (var i = 0; i < data.length; i++) {
            buffer32[i] = data[i];
          }
        }
        var len = buffer32.length,
          m = Math.random() * 6 + 4;
        var run = 0,
          color = 0;
        for (var _i = 0; _i < len;) {
          if (run < 0) {
            run = m * Math.random();
            var p = Math.pow(Math.random(), 0.4);
            color = 255 * p << 24;
          }
          run -= 1;
          buffer32[_i++] = color;
        }
        (this || _global).context.putImageData(idata, 0, 0);
      }
    }, {
      key: "_loop",
      value: function _loop() {
        var _this2 = this || _global;
        if ((this || _global)._stop) return;
        this._noise();
        (this || _global)._animationHandle = requestAnimationFrame(function () {
          return _this2._loop();
        });
      }
    }, {
      key: "destroy",
      value: function destroy() {
        if ((this || _global)._animationHandle) {
          cancelAnimationFrame((this || _global)._animationHandle);
          (this || _global)._stop = true;
        }
      }
    }, {
      key: "_animate",
      value: function _animate() {
        (this || _global).canvas = (this || _global).$el.find("canvas[data-no-op-canvas]")[0];
        (this || _global).context = (this || _global).canvas.getContext("2d");
        this._loop();
      }
    }]);
    return NoOp;
  }(Playback);
  NoOp.canPlay = function (source) {
    // eslint-disable-line no-unused-vars
    return true;
  };

  /**
   * The internationalization (i18n) plugin
   * @class Strings
   * @constructor
   * @extends CorePlugin
   * @module plugins
   */
  var Strings = /*#__PURE__*/function (_CorePlugin) {
    _inherits$2(Strings, _CorePlugin);
    var _super = _createSuper$2(Strings);
    function Strings(core) {
      var _this;
      _classCallCheck$2(this || _global, Strings);
      _this = _super.call(this || _global, core);
      _this._initializeMessages();
      return _this;
    }
    /**
     * Gets a translated string for the given key.
     * @method t
     * @param {String} key the key to all messages
     * @return {String} translated label
     */
    _createClass$2(Strings, [{
      key: "name",
      get: function get() {
        return "strings";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "t",
      value: function t(key) {
        var lang = this._language();
        var fallbackLang = (this || _global)._messages["en"];
        var i18n = lang && (this || _global)._messages[lang] || fallbackLang;
        return i18n[key] || fallbackLang[key] || key;
      }
    }, {
      key: "_language",
      value: function _language() {
        return (this || _global).core.options.language || getBrowserLanguage();
      }
    }, {
      key: "_initializeMessages",
      value: function _initializeMessages() {
        var defaultMessages = {
          "en": {
            "live": "live",
            "back_to_live": "back to live",
            "disabled": "Disabled",
            "playback_not_supported": "Your browser does not support the playback of this video. Please try using a different browser.",
            "default_error_title": "Could not play video.",
            "default_error_message": "There was a problem trying to load the video."
          },
          "de": {
            "live": "Live",
            "back_to_live": "Zur\xFCck zum Live-Video",
            "disabled": "Deaktiviert",
            "playback_not_supported": "Ihr Browser unterst\xFCtzt das Playback Verfahren nicht. Bitte vesuchen Sie es mit einem anderen Browser.",
            "default_error_title": "Video kann nicht abgespielt werden",
            "default_error_message": "Es gab ein Problem beim Laden des Videos"
          },
          "pt": {
            "live": "ao vivo",
            "back_to_live": "voltar para o ao vivo",
            "disabled": "Desativado",
            "playback_not_supported": "Seu navegador n\xE3o supporta a reprodu\xE7\xE3o deste video. Por favor, tente usar um navegador diferente.",
            "default_error_title": "N\xE3o foi poss\xEDvel reproduzir o v\xEDdeo.",
            "default_error_message": "Ocorreu um problema ao tentar carregar o v\xEDdeo."
          },
          "es_am": {
            "live": "vivo",
            "back_to_live": "volver en vivo",
            "disabled": "No disponible",
            "playback_not_supported": "Su navegador no soporta la reproducci\xF3n de este video. Por favor, utilice un navegador diferente.",
            "default_error_title": "No se puede reproducir el video.",
            "default_error_message": "Se ha producido un error al cargar el video."
          },
          "es": {
            "live": "en directo",
            "back_to_live": "volver al directo",
            "disabled": "No disponible",
            "playback_not_supported": "Este navegador no es compatible para reproducir este v\xEDdeo. Utilice un navegador diferente.",
            "default_error_title": "No se puede reproducir el v\xEDdeo.",
            "default_error_message": "Se ha producido un problema al cargar el v\xEDdeo."
          },
          "ru": {
            "live": "\u043F\u0440\u044F\u043C\u043E\u0439 \u044D\u0444\u0438\u0440",
            "back_to_live": "\u043A \u043F\u0440\u044F\u043C\u043E\u043C\u0443 \u044D\u0444\u0438\u0440\u0443",
            "disabled": "\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
            "playback_not_supported": "\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u0432\u043E\u0441\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u044D\u0442\u043E\u0433\u043E \u0432\u0438\u0434\u0435\u043E. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u043E\u0439 \u0431\u0440\u0430\u0443\u0437\u0435\u0440."
          },
          "bg": {
            "live": "\u043D\u0430 \u0436\u0438\u0432\u043E",
            "back_to_live": "\u0412\u044A\u0440\u043D\u0438 \u043D\u0430 \u0436\u0438\u0432\u043E",
            "disabled": "\u0418\u0437\u043A\u043B\u044E\u0447\u0435\u043D\u043E",
            "playback_not_supported": "\u0412\u0430\u0448\u0438\u044F\u0442 \u0431\u0440\u0430\u0443\u0437\u044A\u0440 \u043D\u0435 \u043F\u043E\u0434\u0434\u044A\u0440\u0436\u0430 \u0432\u044A\u0437\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0436\u0434\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0442\u043E\u0432\u0430 \u0432\u0438\u0434\u0435\u043E. \u041C\u043E\u043B\u044F, \u043F\u0440\u043E\u0431\u0432\u0430\u0439\u0442\u0435 \u0441 \u0434\u0440\u0443\u0433 \u0431\u0440\u0430\u0443\u0437\u044A\u0440.",
            "default_error_title": "\u0412\u0438\u0434\u0435\u043E\u0442\u043E \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u0432\u044A\u0437\u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435.",
            "default_error_message": "\u0412\u044A\u0437\u043D\u0438\u043A\u043D\u0430 \u043F\u0440\u043E\u0431\u043B\u0435\u043C \u043F\u0440\u0438 \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u0432\u0438\u0434\u0435\u043E\u0442\u043E."
          },
          "fr": {
            "live": "en direct",
            "back_to_live": "retour au direct",
            "disabled": "D\xE9sactiv\xE9",
            "playback_not_supported": "Votre navigateur ne supporte pas la lecture de cette vid\xE9o. Merci de tenter sur un autre navigateur.",
            "default_error_title": "Impossible de lire la vid\xE9o.",
            "default_error_message": "Un probl\xE8me est survenu lors du chargement de la vid\xE9o."
          },
          "tr": {
            "live": "canl\u0131",
            "back_to_live": "canl\u0131 yay\u0131na d\xF6n",
            "disabled": "Engelli",
            "playback_not_supported": "Taray\u0131c\u0131n\u0131z bu videoyu oynatma deste\u011Fine sahip de\u011Fil. L\xFCtfen farkl\u0131 bir taray\u0131c\u0131 ile deneyin."
          },
          "et": {
            "live": "Otse\xFClekanne",
            "back_to_live": "Tagasi otse\xFClekande juurde",
            "disabled": "Keelatud",
            "playback_not_supported": "Teie brauser ei toeta selle video taasesitust. Proovige kasutada muud brauserit."
          },
          "ar": {
            "live": "\u0645\u0628\u0627\u0634\u0631",
            "back_to_live": "\u0627\u0644\u0631\u062C\u0648\u0639 \u0625\u0644\u0649 \u0627\u0644\u0645\u0628\u0627\u0634\u0631",
            "disabled": "\u0645\u0639\u0637\u0651\u0644",
            "playback_not_supported": "\u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0630\u064A \u062A\u0633\u062A\u062E\u062F\u0645\u0647 \u0644\u0627 \u064A\u062F\u0639\u0645 \u062A\u0634\u063A\u064A\u0644 \u0647\u0630\u0627 \u0627\u0644\u0641\u064A\u062F\u064A\u0648. \u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u062A\u0635\u0641\u062D \u0622\u062E\u0631.",
            "default_error_title": "\u063A\u064A\u0631 \u0642\u0627\u062F\u0631 \u0627\u0644\u0649 \u0627\u0644\u062A\u0634\u063A\u064A\u0644.",
            "default_error_message": "\u062D\u062F\u062B\u062A \u0645\u0634\u0643\u0644\u0629 \u0623\u062B\u0646\u0627\u0621 \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0641\u064A\u062F\u064A\u0648."
          },
          "zh": {
            "live": "\u76F4\u64AD",
            "back_to_live": "\u8FD4\u56DE\u76F4\u64AD",
            "disabled": "\u5DF2\u7981\u7528",
            "playback_not_supported": "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301\u8BE5\u89C6\u9891\u7684\u64AD\u653E\u3002\u8BF7\u5C1D\u8BD5\u4F7F\u7528\u53E6\u4E00\u4E2A\u6D4F\u89C8\u5668\u3002",
            "default_error_title": "\u65E0\u6CD5\u64AD\u653E\u89C6\u9891\u3002",
            "default_error_message": "\u5728\u5C1D\u8BD5\u52A0\u8F7D\u89C6\u9891\u65F6\u51FA\u73B0\u4E86\u95EE\u9898\u3002"
          }
        };
        (this || _global)._messages = zepto.extend(true, defaultMessages, (this || _global).core.options.strings || {});
        (this || _global)._messages["de-DE"] = (this || _global)._messages["de"];
        (this || _global)._messages["pt-BR"] = (this || _global)._messages["pt"];
        (this || _global)._messages["en-US"] = (this || _global)._messages["en"];
        (this || _global)._messages["bg-BG"] = (this || _global)._messages["bg"];
        (this || _global)._messages["es-419"] = (this || _global)._messages["es_am"];
        (this || _global)._messages["es-ES"] = (this || _global)._messages["es"];
        (this || _global)._messages["fr-FR"] = (this || _global)._messages["fr"];
        (this || _global)._messages["tr-TR"] = (this || _global)._messages["tr"];
        (this || _global)._messages["et-EE"] = (this || _global)._messages["et"];
        (this || _global)._messages["ar-IQ"] = (this || _global)._messages["ar"];
        (this || _global)._messages["zh-CN"] = (this || _global)._messages["zh"];
      }
    }]);
    return Strings;
  }(CorePlugin);
  var SourcesPlugin = /*#__PURE__*/function (_CorePlugin) {
    _inherits$2(SourcesPlugin, _CorePlugin);
    var _super = _createSuper$2(SourcesPlugin);
    function SourcesPlugin() {
      _classCallCheck$2(this || _global, SourcesPlugin);
      return _super.apply(this || _global, arguments);
    }
    _createClass$2(SourcesPlugin, [{
      key: "name",
      get: function get() {
        return "sources";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).core, Events.CORE_CONTAINERS_CREATED, (this || _global).onContainersCreated);
      }
    }, {
      key: "onContainersCreated",
      value: function onContainersCreated() {
        var firstValidSource = (this || _global).core.containers.filter(function (container) {
          return container.playback.name !== "no_op";
        })[0] || (this || _global).core.containers[0];
        firstValidSource && (this || _global).core.containers.forEach(function (container) {
          if (container !== firstValidSource) container.destroy();
        });
      }
    }]);
    return SourcesPlugin;
  }(CorePlugin);

  // Copyright 2014 Globo.com Player authors. All rights reserved.
  var version$1 = "0.4.27";

  // Built-in Plugins/Playbacks

  Loader.registerPlugin(Strings);
  Loader.registerPlugin(SourcesPlugin);
  Loader.registerPlayback(NoOp);
  Loader.registerPlayback(HTMLImg);
  Loader.registerPlayback(HTML5Audio);
  Loader.registerPlayback(HTML5Video);
  var main$1 = {
    Player: Player,
    Events: Events,
    Browser: Browser,
    ContainerPlugin: ContainerPlugin,
    UIContainerPlugin: UIContainerPlugin,
    CorePlugin: CorePlugin,
    UICorePlugin: UICorePlugin,
    Playback: Playback,
    Container: Container,
    Core: Core,
    PlayerError: PlayerError,
    Loader: Loader,
    BaseObject: BaseObject,
    UIObject: UIObject,
    Utils: Utils,
    HTML5Audio: HTML5Audio,
    HTML5Video: HTML5Video,
    HTMLImg: HTMLImg,
    Log: Log,
    Styler: Styler,
    version: version$1,
    template: tmpl,
    $: zepto
  };
  function _classCallCheck$1(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties$1(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey$1(descriptor.key), descriptor);
    }
  }
  function _createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties$1(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _inherits$1(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf$1(subClass, superClass);
  }
  function _getPrototypeOf$1(o) {
    _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf$1(o);
  }
  function _setPrototypeOf$1(o, p) {
    _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf$1(o, p);
  }
  function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _assertThisInitialized$1(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn$1(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized$1(self);
  }
  function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf$1(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf$1(this || _global).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this || _global, arguments);
      }
      return _possibleConstructorReturn$1(this || _global, result);
    };
  }
  function _superPropBase$1(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf$1(object);
      if (object === null) break;
    }
    return object;
  }
  function _get$1() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get$1 = Reflect.get.bind();
    } else {
      _get$1 = function _get(target, property, receiver) {
        var base = _superPropBase$1(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get$1.apply(this || _global, arguments);
  }
  function _toPrimitive$1(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey$1(arg) {
    var key = _toPrimitive$1(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  var ClickToPausePlugin = /*#__PURE__*/function (_ContainerPlugin) {
    _inherits$1(ClickToPausePlugin, _ContainerPlugin);
    var _super = _createSuper$1(ClickToPausePlugin);
    function ClickToPausePlugin(container) {
      _classCallCheck$1(this || _global, ClickToPausePlugin);
      return _super.call(this || _global, container);
    }
    _createClass$1(ClickToPausePlugin, [{
      key: "name",
      get: function get() {
        return "click_to_pause";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "config",
      get: function get() {
        return (this || _global).container.options.clickToPauseConfig || {};
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).container, Events.CONTAINER_CLICK, (this || _global).click);
        this.listenTo((this || _global).container, Events.CONTAINER_SETTINGSUPDATE, (this || _global).settingsUpdate);
      }
    }, {
      key: "click",
      value: function click() {
        var onClickPayload = (this || _global).config.onClickPayload;
        if ((this || _global).container.getPlaybackType() !== Playback.LIVE || (this || _global).container.isDvrEnabled()) {
          if ((this || _global).container.isPlaying()) (this || _global).container.pause(onClickPayload);else (this || _global).container.play(onClickPayload);
        }
      }
    }, {
      key: "settingsUpdate",
      value: function settingsUpdate() {
        var pointerEnabled = (this || _global).container.getPlaybackType() !== Playback.LIVE || (this || _global).container.isDvrEnabled();
        if (pointerEnabled === (this || _global).pointerEnabled) return;
        var method = pointerEnabled ? "addClass" : "removeClass";
        (this || _global).container.$el[method]("pointer-enabled");
        (this || _global).pointerEnabled = pointerEnabled;
      }
    }]);
    return ClickToPausePlugin;
  }(ContainerPlugin);
  var ccIcon = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 49 41.8\" style=\"enable-background:new 0 0 49 41.8;\" xml:space=\"preserve\">\n<path d=\"M47.1,0H3.2C1.6,0,0,1.2,0,2.8v31.5C0,35.9,1.6,37,3.2,37h11.9l3.2,1.9l4.7,2.7c0.9,0.5,2-0.1,2-1.1V37h22.1\n\tc1.6,0,1.9-1.1,1.9-2.7V2.8C49,1.2,48.7,0,47.1,0z M7.2,18.6c0-4.8,3.5-9.3,9.9-9.3c4.8,0,7.1,2.7,7.1,2.7l-2.5,4\n\tc0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2c0,0-2.7,2.9-7.6,2.9\n\tC10.8,27.9,7.2,23.5,7.2,18.6z M36.9,27.9c-6.4,0-9.9-4.4-9.9-9.3c0-4.8,3.5-9.3,9.9-9.3C41.7,9.3,44,12,44,12l-2.5,4\n\tc0,0-1.7-1.7-4.2-1.7c-2.8,0-4.3,2.1-4.3,4.3c0,2.1,1.5,4.4,4.5,4.4c2.5,0,4.9-2.1,4.9-2.1l2.2,4.2C44.5,25,41.9,27.9,36.9,27.9z\"/>\n</svg>";
  var ccHTML = "<button type=\"button\" class=\"cc-button media-control-button media-control-icon\" data-cc-button aria-label=\"<%= ariaLabel %>\"></button>\n<ul>\n  <% if (title) { %>\n  <li data-title><%= title %></li>\n  <% }; %>\n  <li><a href=\"#\" data-cc-select=\"-1\"><%= disabledLabel %></a></li>\n  <% for (var i = 0; i < tracks.length; i++) { %>\n    <li><a href=\"#\" data-cc-select=\"<%= tracks[i].id %>\"><%= tracks[i].label %></a></li>\n  <% }; %>\n</ul>\n";
  var css_248z$7 = ".cc-controls[data-cc-controls] {\n  float: right;\n  position: relative;\n  display: none; }\n  .cc-controls[data-cc-controls].available {\n    display: block; }\n  .cc-controls[data-cc-controls] .cc-button {\n    padding: 6px !important; }\n    .cc-controls[data-cc-controls] .cc-button.enabled {\n      display: block;\n      opacity: 1.0; }\n      .cc-controls[data-cc-controls] .cc-button.enabled:hover {\n        opacity: 1.0;\n        text-shadow: none; }\n  .cc-controls[data-cc-controls] > ul {\n    list-style-type: none;\n    position: absolute;\n    bottom: 25px;\n    border: 1px solid black;\n    display: none;\n    background-color: #e6e6e6; }\n  .cc-controls[data-cc-controls] li {\n    font-size: 10px; }\n    .cc-controls[data-cc-controls] li[data-title] {\n      background-color: #c3c2c2;\n      padding: 5px; }\n    .cc-controls[data-cc-controls] li a {\n      color: #444;\n      padding: 2px 10px;\n      display: block;\n      text-decoration: none; }\n      .cc-controls[data-cc-controls] li a:hover {\n        background-color: #555;\n        color: white; }\n        .cc-controls[data-cc-controls] li a:hover a {\n          color: white;\n          text-decoration: none; }\n    .cc-controls[data-cc-controls] li.current a {\n      color: #f00; }\n";
  var ClosedCaptions$1 = /*#__PURE__*/function (_UICorePlugin) {
    _inherits$1(ClosedCaptions, _UICorePlugin);
    var _super = _createSuper$1(ClosedCaptions);
    function ClosedCaptions(core) {
      var _this;
      _classCallCheck$1(this || _global, ClosedCaptions);
      _this = _super.call(this || _global, core);
      var config = core.options.closedCaptionsConfig;
      _this._title = config && config.title ? config.title : null;
      _this._ariaLabel = config && config.ariaLabel ? config.ariaLabel : "cc-button";
      _this._labelCb = config && config.labelCallback && typeof config.labelCallback === "function" ? config.labelCallback : function (track) {
        return track.name;
      };
      return _this;
    }
    _createClass$1(ClosedCaptions, [{
      key: "name",
      get: function get() {
        return "closed_captions";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(ccHTML);
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "click [data-cc-button]": "toggleContextMenu",
          "click [data-cc-select]": "onTrackSelect"
        };
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "cc-controls",
          "data-cc-controls": ""
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global).containerChanged);
        this.listenTo((this || _global).core.mediaControl, Events.MEDIACONTROL_RENDERED, (this || _global).render);
        this.listenTo((this || _global).core.mediaControl, Events.MEDIACONTROL_HIDE, (this || _global).hideContextMenu);
        this.bindContainerEvents();
      }
    }, {
      key: "bindContainerEvents",
      value: function bindContainerEvents() {
        (this || _global).container = (this || _global).core.activeContainer;
        if ((this || _global).container) {
          this.listenTo((this || _global).container, Events.CONTAINER_SUBTITLE_AVAILABLE, (this || _global).onSubtitleAvailable);
          this.listenTo((this || _global).container, Events.CONTAINER_SUBTITLE_CHANGED, (this || _global).onSubtitleChanged);
          this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).onContainerStop);
        }
      }
    }, {
      key: "onContainerStop",
      value: function onContainerStop() {
        this.ccAvailable(false);
      }
    }, {
      key: "containerChanged",
      value: function containerChanged() {
        this.ccAvailable(false);
        this.stopListening();
        this.bindEvents();
      }
    }, {
      key: "onSubtitleAvailable",
      value: function onSubtitleAvailable() {
        this.renderCcButton();
        this.ccAvailable(true);
      }
    }, {
      key: "onSubtitleChanged",
      value: function onSubtitleChanged(track) {
        this.setCurrentContextMenuElement(track.id);
      }
    }, {
      key: "onTrackSelect",
      value: function onTrackSelect(event) {
        var trackId = parseInt(event.target.dataset.ccSelect, 10);
        (this || _global).container.closedCaptionsTrackId = trackId;
        this.hideContextMenu();
        event.stopPropagation();
        return false;
      }
    }, {
      key: "ccAvailable",
      value: function ccAvailable(hasCC) {
        var method = hasCC ? "addClass" : "removeClass";
        (this || _global).$el[method]("available");
      }
    }, {
      key: "toggleContextMenu",
      value: function toggleContextMenu() {
        (this || _global).$el.find("ul").toggle();
      }
    }, {
      key: "hideContextMenu",
      value: function hideContextMenu() {
        (this || _global).$el.find("ul").hide();
      }
    }, {
      key: "contextMenuElement",
      value: function contextMenuElement(id) {
        return (this || _global).$el.find("ul a" + (!isNaN(id) ? "[data-cc-select=\"" + id + "\"]" : "")).parent();
      }
    }, {
      key: "setCurrentContextMenuElement",
      value: function setCurrentContextMenuElement(trackId) {
        if ((this || _global)._trackId !== trackId) {
          this.contextMenuElement().removeClass("current");
          this.contextMenuElement(trackId).addClass("current");
          var method = trackId > -1 ? "addClass" : "removeClass";
          (this || _global).$ccButton[method]("enabled");
          (this || _global)._trackId = trackId;
        }
      }
    }, {
      key: "renderCcButton",
      value: function renderCcButton() {
        var tracks = (this || _global).container ? (this || _global).container.closedCaptionsTracks : [];
        for (var i = 0; i < tracks.length; i++) tracks[i].label = this._labelCb(tracks[i]);
        var style = Styler.getStyleFor(css_248z$7, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.html(this.template({
          ariaLabel: (this || _global)._ariaLabel,
          disabledLabel: (this || _global).core.i18n.t("disabled"),
          title: (this || _global)._title,
          tracks: tracks
        }));
        (this || _global).$ccButton = (this || _global).$el.find("button.cc-button[data-cc-button]");
        (this || _global).$ccButton.append(ccIcon);
        (this || _global).$el.append(style[0]);
      }
    }, {
      key: "render",
      value: function render() {
        this.renderCcButton();
        var $fullscreen = (this || _global).core.mediaControl.$el.find("button[data-fullscreen]");
        if ($fullscreen[0]) (this || _global).$el.insertAfter($fullscreen);else (this || _global).core.mediaControl.$el.find(".media-control-right-panel[data-media-control]").prepend((this || _global).$el);
        return this || _global;
      }
    }]);
    return ClosedCaptions;
  }(UICorePlugin);
  var dvrHTML = "<div class=\"live-info\"><%= live %></div>\n<button type=\"button\" class=\"live-button\" aria-label=\"<%= backToLive %>\"><%= backToLive %></button>\n";
  var css_248z$6 = ".dvr-controls[data-dvr-controls] {\n  display: inline-block;\n  float: left;\n  color: #fff;\n  line-height: 32px;\n  font-size: 10px;\n  font-weight: bold;\n  margin-left: 6px; }\n  .dvr-controls[data-dvr-controls] .live-info {\n    cursor: default;\n    font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n    text-transform: uppercase; }\n    .dvr-controls[data-dvr-controls] .live-info:before {\n      content: \"\";\n      display: inline-block;\n      position: relative;\n      width: 7px;\n      height: 7px;\n      border-radius: 3.5px;\n      margin-right: 3.5px;\n      background-color: #ff0101; }\n    .dvr-controls[data-dvr-controls] .live-info.disabled {\n      opacity: 0.3; }\n      .dvr-controls[data-dvr-controls] .live-info.disabled:before {\n        background-color: #fff; }\n  .dvr-controls[data-dvr-controls] .live-button {\n    cursor: pointer;\n    outline: none;\n    display: none;\n    border: 0;\n    color: #fff;\n    background-color: transparent;\n    height: 32px;\n    padding: 0;\n    opacity: 0.7;\n    font-family: \"Roboto\", \"Open Sans\", Arial, sans-serif;\n    text-transform: uppercase;\n    transition: all 0.1s ease; }\n    .dvr-controls[data-dvr-controls] .live-button:before {\n      content: \"\";\n      display: inline-block;\n      position: relative;\n      width: 7px;\n      height: 7px;\n      border-radius: 3.5px;\n      margin-right: 3.5px;\n      background-color: #fff; }\n    .dvr-controls[data-dvr-controls] .live-button:hover {\n      opacity: 1;\n      text-shadow: rgba(255, 255, 255, 0.75) 0 0 5px; }\n\n.dvr .dvr-controls[data-dvr-controls] .live-info {\n  display: none; }\n\n.dvr .dvr-controls[data-dvr-controls] .live-button {\n  display: block; }\n\n.dvr.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #005aff; }\n\n.media-control.live[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n  background-color: #ff0101; }\n";
  var DVRControls$1 = /*#__PURE__*/function (_UICorePlugin) {
    _inherits$1(DVRControls, _UICorePlugin);
    var _super = _createSuper$1(DVRControls);
    function DVRControls(core) {
      var _this;
      _classCallCheck$1(this || _global, DVRControls);
      _this = _super.call(this || _global, core);
      _this.settingsUpdate();
      return _this;
    }
    _createClass$1(DVRControls, [{
      key: "template",
      get: function get() {
        return tmpl(dvrHTML);
      }
    }, {
      key: "name",
      get: function get() {
        return "dvr_controls";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "click .live-button": "click"
        };
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "dvr-controls",
          "data-dvr-controls": ""
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.bindCoreEvents();
        this.bindContainerEvents();
      }
    }, {
      key: "bindCoreEvents",
      value: function bindCoreEvents() {
        var _this2 = this || _global;
        if ((this || _global).core.mediaControl.settings) {
          this.listenTo((this || _global).core.mediaControl, Events.MEDIACONTROL_CONTAINERCHANGED, (this || _global).containerChanged);
          this.listenTo((this || _global).core.mediaControl, Events.MEDIACONTROL_RENDERED, (this || _global).settingsUpdate);
          this.listenTo((this || _global).core, Events.CORE_OPTIONS_CHANGE, (this || _global).render);
        } else {
          setTimeout(function () {
            return _this2.bindCoreEvents();
          }, 100);
        }
      }
    }, {
      key: "bindContainerEvents",
      value: function bindContainerEvents() {
        if ((this || _global).core.activeContainer) {
          this.listenToOnce((this || _global).core.activeContainer, Events.CONTAINER_TIMEUPDATE, (this || _global).render);
          this.listenTo((this || _global).core.activeContainer, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (this || _global).dvrChanged);
        }
      }
    }, {
      key: "containerChanged",
      value: function containerChanged() {
        this.stopListening();
        this.bindEvents();
      }
    }, {
      key: "dvrChanged",
      value: function dvrChanged(dvrEnabled) {
        if ((this || _global).core.getPlaybackType() !== Playback.LIVE) return;
        this.settingsUpdate();
        (this || _global).core.mediaControl.$el.addClass("live");
        if (dvrEnabled) {
          (this || _global).core.mediaControl.$el.addClass("dvr");
          (this || _global).core.mediaControl.$el.find(".media-control-indicator[data-position], .media-control-indicator[data-duration]").hide();
        } else {
          (this || _global).core.mediaControl.$el.removeClass("dvr");
        }
      }
    }, {
      key: "click",
      value: function click() {
        var mediaControl = (this || _global).core.mediaControl;
        var container = mediaControl.container;
        if (!container.isPlaying()) container.play();
        if (mediaControl.$el.hasClass("dvr")) container.seek(container.getDuration());
      }
    }, {
      key: "settingsUpdate",
      value: function settingsUpdate() {
        var _this3 = this || _global;
        this.stopListening();
        (this || _global).core.mediaControl.$el.removeClass("live");
        if (this.shouldRender()) {
          this.render();
          (this || _global).$el.click(function () {
            return _this3.click();
          });
        }
        this.bindEvents();
      }
    }, {
      key: "shouldRender",
      value: function shouldRender() {
        var useDvrControls = (this || _global).core.options.useDvrControls === undefined || !!(this || _global).core.options.useDvrControls;
        return useDvrControls && (this || _global).core.getPlaybackType() === Playback.LIVE;
      }
    }, {
      key: "render",
      value: function render() {
        var style = Styler.getStyleFor(css_248z$6, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.html(this.template({
          live: (this || _global).core.i18n.t("live"),
          backToLive: (this || _global).core.i18n.t("back_to_live")
        }));
        (this || _global).$el.append(style[0]);
        if (this.shouldRender()) {
          (this || _global).core.mediaControl.$el.addClass("live");
          (this || _global).core.mediaControl.$(".media-control-left-panel[data-media-control]").append((this || _global).$el);
        }
        return this || _global;
      }
    }]);
    return DVRControls;
  }(UICorePlugin);
  var EndVideo$1 = /*#__PURE__*/function (_CorePlugin) {
    _inherits$1(EndVideo, _CorePlugin);
    var _super = _createSuper$1(EndVideo);
    function EndVideo() {
      _classCallCheck$1(this || _global, EndVideo);
      return _super.apply(this || _global, arguments);
    }
    _createClass$1(EndVideo, [{
      key: "name",
      get: function get() {
        return "end_video";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global).containerChanged);
        var container = (this || _global).core.activeContainer;
        if (container) {
          this.listenTo(container, Events.CONTAINER_ENDED, (this || _global).ended);
          this.listenTo(container, Events.CONTAINER_STOP, (this || _global).ended);
        }
      }
    }, {
      key: "containerChanged",
      value: function containerChanged() {
        this.stopListening();
        this.bindEvents();
      }
    }, {
      key: "ended",
      value: function ended() {
        var exitOnEnd = typeof (this || _global).core.options.exitFullscreenOnEnd === "undefined" || (this || _global).core.options.exitFullscreenOnEnd;
        if (exitOnEnd && (this || _global).core.isFullscreen()) (this || _global).core.toggleFullscreen();
      }
    }]);
    return EndVideo;
  }(CorePlugin);
  var reloadIcon = "<svg fill=\"#FFFFFF\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path d=\"M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z\"/>\n    <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n</svg>";
  var templateHtml = "<div class=\"player-error-screen__content\" data-error-screen>\n  <% if (icon) { %>\n  <div class=\"player-error-screen__icon\" data-error-screen><%= icon %></div>\n  <% } %>\n  <div class=\"player-error-screen__title\" data-error-screen><%= title %></div>\n  <div class=\"player-error-screen__message\" data-error-screen><%= message %></div>\n  <div class=\"player-error-screen__code\" data-error-screen>Error code: <%= code %></div>\n  <div class=\"player-error-screen__reload\" data-error-screen><%= reloadIcon %></div>\n</div>\n";
  var css_248z$5 = "[data-player] .player-error-screen {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #CCCACA;\n  position: absolute;\n  top: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 2000;\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n  [data-player] .player-error-screen__content[data-error-screen] {\n    font-size: 14px;\n    color: #CCCACA;\n    margin-top: 45px; }\n  [data-player] .player-error-screen__title[data-error-screen] {\n    font-weight: bold;\n    line-height: 30px;\n    font-size: 18px; }\n  [data-player] .player-error-screen__message[data-error-screen] {\n    width: 90%;\n    margin: 0 auto; }\n  [data-player] .player-error-screen__code[data-error-screen] {\n    font-size: 13px;\n    margin-top: 15px; }\n  [data-player] .player-error-screen__reload {\n    cursor: pointer;\n    width: 30px;\n    margin: 15px auto 0 !important; }\n";
  var ErrorScreen$1 = /*#__PURE__*/function (_UICorePlugin) {
    _inherits$1(ErrorScreen, _UICorePlugin);
    var _super = _createSuper$1(ErrorScreen);
    function ErrorScreen(core) {
      var _this;
      _classCallCheck$1(this || _global, ErrorScreen);
      _this = _super.call(this || _global, core);
      if (_this.options.disableErrorScreen) return _possibleConstructorReturn$1(_this, _this.disable());
      return _this;
    }
    _createClass$1(ErrorScreen, [{
      key: "name",
      get: function get() {
        return "error_screen";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(templateHtml);
      }
    }, {
      key: "container",
      get: function get() {
        return (this || _global).core.getCurrentContainer();
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "player-error-screen",
          "data-error-screen": ""
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).core, Events.ERROR, (this || _global).onError);
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global).onContainerChanged);
      }
    }, {
      key: "bindReload",
      value: function bindReload() {
        (this || _global).reloadButton = (this || _global).$el.find(".player-error-screen__reload");
        (this || _global).reloadButton && (this || _global).reloadButton.on("click", (this || _global).reload.bind(this || _global));
      }
    }, {
      key: "reload",
      value: function reload() {
        var _this2 = this || _global;
        this.listenToOnce((this || _global).core, Events.CORE_READY, function () {
          return _this2.container.play();
        });
        (this || _global).core.load((this || _global).options.sources, (this || _global).options.mimeType);
        this.unbindReload();
      }
    }, {
      key: "unbindReload",
      value: function unbindReload() {
        (this || _global).reloadButton && (this || _global).reloadButton.off("click");
      }
    }, {
      key: "onContainerChanged",
      value: function onContainerChanged() {
        (this || _global).err = null;
        this.unbindReload();
        this.hide();
      }
    }, {
      key: "onError",
      value: function onError() {
        var err = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (err.level === PlayerError.Levels.FATAL) {
          (this || _global).err = err;
          (this || _global).container.disableMediaControl();
          (this || _global).container.stop();
          this.show();
        }
      }
    }, {
      key: "show",
      value: function show() {
        this.render();
        (this || _global).$el.show();
      }
    }, {
      key: "hide",
      value: function hide() {
        (this || _global).$el.hide();
      }
    }, {
      key: "render",
      value: function render() {
        if (!(this || _global).err) return;
        var style = Styler.getStyleFor(css_248z$5, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.html(this.template({
          title: (this || _global).err.UI.title,
          message: (this || _global).err.UI.message,
          code: (this || _global).err.code,
          icon: (this || _global).err.UI.icon || "",
          reloadIcon: reloadIcon
        }));
        (this || _global).$el.append(style[0]);
        (this || _global).core.$el.append((this || _global).el);
        this.bindReload();
        return this || _global;
      }
    }]);
    return ErrorScreen;
  }(UICorePlugin);
  var playIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M1.425.35L14.575 8l-13.15 7.65V.35z\"/>\n</svg>";
  var pauseIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 14.76H6.43V1.24H1.71v13.52zm7.86-13.52v13.52h4.716V1.24H9.573z\"/>\n</svg>";
  var oldIcon = zepto("link[rel=\"shortcut icon\"]");
  var Favicon$1 = /*#__PURE__*/function (_CorePlugin) {
    _inherits$1(Favicon, _CorePlugin);
    var _super = _createSuper$1(Favicon);
    function Favicon(core) {
      var _this;
      _classCallCheck$1(this || _global, Favicon);
      _this = _super.call(this || _global, core);
      _this._container = null;
      _this.configure();
      return _this;
    }
    _createClass$1(Favicon, [{
      key: "name",
      get: function get() {
        return "favicon";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "oldIcon",
      get: function get() {
        return oldIcon;
      }
    }, {
      key: "configure",
      value: function configure() {
        if ((this || _global).core.options.changeFavicon) {
          if (!(this || _global).enabled) {
            this.stopListening((this || _global).core, Events.CORE_OPTIONS_CHANGE);
            this.enable();
          }
        } else if ((this || _global).enabled) {
          this.disable();
          this.listenTo((this || _global).core, Events.CORE_OPTIONS_CHANGE, (this || _global).configure);
        }
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).core, Events.CORE_OPTIONS_CHANGE, (this || _global).configure);
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global).containerChanged);
        (this || _global).core.activeContainer && this.containerChanged();
      }
    }, {
      key: "containerChanged",
      value: function containerChanged() {
        (this || _global)._container && this.stopListening((this || _global)._container);
        (this || _global)._container = (this || _global).core.activeContainer;
        this.listenTo((this || _global)._container, Events.CONTAINER_PLAY, (this || _global).setPlayIcon);
        this.listenTo((this || _global)._container, Events.CONTAINER_PAUSE, (this || _global).setPauseIcon);
        this.listenTo((this || _global)._container, Events.CONTAINER_STOP, (this || _global).resetIcon);
        this.listenTo((this || _global)._container, Events.CONTAINER_ENDED, (this || _global).resetIcon);
        this.listenTo((this || _global)._container, Events.CONTAINER_ERROR, (this || _global).resetIcon);
        this.resetIcon();
      }
    }, {
      key: "disable",
      value: function disable() {
        _get$1(_getPrototypeOf$1(Favicon.prototype), "disable", this || _global).call(this || _global);
        this.resetIcon();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        _get$1(_getPrototypeOf$1(Favicon.prototype), "destroy", this || _global).call(this || _global);
        this.resetIcon();
      }
    }, {
      key: "createIcon",
      value: function createIcon(svg) {
        var canvas = zepto("<canvas/>");
        canvas[0].width = 16;
        canvas[0].height = 16;
        var ctx = canvas[0].getContext("2d");
        ctx.fillStyle = "#000";
        var d = zepto(svg).find("path").attr("d");
        var path = new Path2D(d);
        ctx.fill(path);
        var icon = zepto("<link rel=\"shortcut icon\" type=\"image/png\"/>");
        icon.attr("href", canvas[0].toDataURL("image/png"));
        return icon;
      }
    }, {
      key: "setPlayIcon",
      value: function setPlayIcon() {
        if (!(this || _global).playIcon) (this || _global).playIcon = this.createIcon(playIcon);
        this.changeIcon((this || _global).playIcon);
      }
    }, {
      key: "setPauseIcon",
      value: function setPauseIcon() {
        if (!(this || _global).pauseIcon) (this || _global).pauseIcon = this.createIcon(pauseIcon);
        this.changeIcon((this || _global).pauseIcon);
      }
    }, {
      key: "resetIcon",
      value: function resetIcon() {
        zepto("link[rel=\"shortcut icon\"]").remove();
        zepto("head").append((this || _global).oldIcon);
      }
    }, {
      key: "changeIcon",
      value: function changeIcon(icon) {
        if (icon) {
          zepto("link[rel=\"shortcut icon\"]").remove();
          zepto("head").append(icon);
        }
      }
    }]);
    return Favicon;
  }(CorePlugin);
  var GoogleAnalytics$1 = /*#__PURE__*/function (_ContainerPlugin) {
    _inherits$1(GoogleAnalytics, _ContainerPlugin);
    var _super = _createSuper$1(GoogleAnalytics);
    function GoogleAnalytics(container) {
      var _this;
      _classCallCheck$1(this || _global, GoogleAnalytics);
      _this = _super.call(this || _global, container);
      if (_this.container.options.gaAccount) {
        _this.account = _this.container.options.gaAccount;
        _this.trackerName = _this.container.options.gaTrackerName ? _this.container.options.gaTrackerName + "." : "Clappr.";
        _this.domainName = _this.container.options.gaDomainName;
        _this.currentHDState = undefined;
        _this.embedScript();
      }
      return _this;
    }
    _createClass$1(GoogleAnalytics, [{
      key: "name",
      get: function get() {
        return "google_analytics";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "embedScript",
      value: function embedScript() {
        var _this2 = this || _global;
        if (!window._gat) {
          var script = document.createElement("script");
          script.setAttribute("type", "text/javascript");
          script.setAttribute("async", "async");
          script.setAttribute("src", "//www.google-analytics.com/ga.js");
          script.onload = function () {
            return _this2.addEventListeners();
          };
          document.body.appendChild(script);
        } else {
          this.addEventListeners();
        }
      }
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this3 = this || _global;
        if ((this || _global).container) {
          this.listenTo((this || _global).container, Events.CONTAINER_READY, (this || _global).onReady);
          this.listenTo((this || _global).container, Events.CONTAINER_PLAY, (this || _global).onPlay);
          this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).onStop);
          this.listenTo((this || _global).container, Events.CONTAINER_PAUSE, (this || _global).onPause);
          this.listenTo((this || _global).container, Events.CONTAINER_ENDED, (this || _global).onEnded);
          this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERING, (this || _global).onBuffering);
          this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERFULL, (this || _global).onBufferFull);
          this.listenTo((this || _global).container, Events.CONTAINER_ERROR, (this || _global).onError);
          this.listenTo((this || _global).container, Events.CONTAINER_PLAYBACKSTATE, (this || _global).onPlaybackChanged);
          this.listenTo((this || _global).container, Events.CONTAINER_VOLUME, function (event) {
            return _this3.onVolumeChanged(event);
          });
          this.listenTo((this || _global).container, Events.CONTAINER_SEEK, function (event) {
            return _this3.onSeek(event);
          });
          this.listenTo((this || _global).container, Events.CONTAINER_FULL_SCREEN, (this || _global).onFullscreen);
          this.listenTo((this || _global).container, Events.CONTAINER_HIGHDEFINITIONUPDATE, (this || _global).onHD);
          this.listenTo((this || _global).container, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (this || _global).onDVR);
        }
        _gaq.push([(this || _global).trackerName + "_setAccount", (this || _global).account]);
        if ((this || _global).domainName) _gaq.push([(this || _global).trackerName + "_setDomainName", (this || _global).domainName]);
      }
    }, {
      key: "onReady",
      value: function onReady() {
        this.push(["Video", "Playback", (this || _global).container.playback.name]);
      }
    }, {
      key: "onPlay",
      value: function onPlay() {
        this.push(["Video", "Play", (this || _global).container.playback.src]);
      }
    }, {
      key: "onStop",
      value: function onStop() {
        this.push(["Video", "Stop", (this || _global).container.playback.src]);
      }
    }, {
      key: "onEnded",
      value: function onEnded() {
        this.push(["Video", "Ended", (this || _global).container.playback.src]);
      }
    }, {
      key: "onBuffering",
      value: function onBuffering() {
        this.push(["Video", "Buffering", (this || _global).container.playback.src]);
      }
    }, {
      key: "onBufferFull",
      value: function onBufferFull() {
        this.push(["Video", "Bufferfull", (this || _global).container.playback.src]);
      }
    }, {
      key: "onError",
      value: function onError() {
        this.push(["Video", "Error", (this || _global).container.playback.src]);
      }
    }, {
      key: "onHD",
      value: function onHD(isHD) {
        var status = isHD ? "ON" : "OFF";
        if (status !== (this || _global).currentHDState) {
          (this || _global).currentHDState = status;
          this.push(["Video", "HD - " + status, (this || _global).container.playback.src]);
        }
      }
    }, {
      key: "onPlaybackChanged",
      value: function onPlaybackChanged(playbackState) {
        if (playbackState.type !== null) this.push(["Video", "Playback Type - " + playbackState.type, (this || _global).container.playback.src]);
      }
    }, {
      key: "onDVR",
      value: function onDVR(dvrInUse) {
        var status = dvrInUse ? "ON" : "OFF";
        this.push(["Interaction", "DVR - " + status, (this || _global).container.playback.src]);
      }
    }, {
      key: "onPause",
      value: function onPause() {
        this.push(["Video", "Pause", (this || _global).container.playback.src]);
      }
    }, {
      key: "onSeek",
      value: function onSeek() {
        this.push(["Video", "Seek", (this || _global).container.playback.src]);
      }
    }, {
      key: "onVolumeChanged",
      value: function onVolumeChanged() {
        this.push(["Interaction", "Volume", (this || _global).container.playback.src]);
      }
    }, {
      key: "onFullscreen",
      value: function onFullscreen() {
        this.push(["Interaction", "Fullscreen", (this || _global).container.playback.src]);
      }
    }, {
      key: "push",
      value: function push(array) {
        var res = [(this || _global).trackerName + "_trackEvent"].concat(array);
        _gaq.push(res);
      }
    }]);
    return GoogleAnalytics;
  }(ContainerPlugin);

  /* eslint-disable */
  // Kibo is released under the MIT License. Copyright (c) 2013 marquete.
  // see https://github.com/marquete/kibo

  var Kibo = function Kibo(element) {
    (this || _global).element = element || window.document;
    this.initialize();
  };
  Kibo.KEY_NAMES_BY_CODE = {
    8: "backspace",
    9: "tab",
    13: "enter",
    16: "shift",
    17: "ctrl",
    18: "alt",
    20: "caps_lock",
    27: "esc",
    32: "space",
    37: "left",
    38: "up",
    39: "right",
    40: "down",
    48: "0",
    49: "1",
    50: "2",
    51: "3",
    52: "4",
    53: "5",
    54: "6",
    55: "7",
    56: "8",
    57: "9",
    65: "a",
    66: "b",
    67: "c",
    68: "d",
    69: "e",
    70: "f",
    71: "g",
    72: "h",
    73: "i",
    74: "j",
    75: "k",
    76: "l",
    77: "m",
    78: "n",
    79: "o",
    80: "p",
    81: "q",
    82: "r",
    83: "s",
    84: "t",
    85: "u",
    86: "v",
    87: "w",
    88: "x",
    89: "y",
    90: "z",
    112: "f1",
    113: "f2",
    114: "f3",
    115: "f4",
    116: "f5",
    117: "f6",
    118: "f7",
    119: "f8",
    120: "f9",
    121: "f10",
    122: "f11",
    123: "f12"
  };
  Kibo.KEY_CODES_BY_NAME = {};
  (function () {
    for (var key in Kibo.KEY_NAMES_BY_CODE) {
      if (Object.prototype.hasOwnProperty.call(Kibo.KEY_NAMES_BY_CODE, key)) {
        Kibo.KEY_CODES_BY_NAME[Kibo.KEY_NAMES_BY_CODE[key]] = +key;
      }
    }
  })();
  Kibo.MODIFIERS = ["shift", "ctrl", "alt"];
  Kibo.registerEvent = function () {
    if (document.addEventListener) {
      return function (element, eventName, func) {
        element.addEventListener(eventName, func, false);
      };
    } else if (document.attachEvent) {
      return function (element, eventName, func) {
        element.attachEvent("on" + eventName, func);
      };
    }
  }();
  Kibo.unregisterEvent = function () {
    if (document.removeEventListener) {
      return function (element, eventName, func) {
        element.removeEventListener(eventName, func, false);
      };
    } else if (document.detachEvent) {
      return function (element, eventName, func) {
        element.detachEvent("on" + eventName, func);
      };
    }
  }();
  Kibo.stringContains = function (string, substring) {
    return string.indexOf(substring) !== -1;
  };
  Kibo.neatString = function (string) {
    return string.replace(/^\s+|\s+$/g, "").replace(/\s+/g, " ");
  };
  Kibo.capitalize = function (string) {
    return string.toLowerCase().replace(/^./, function (match) {
      return match.toUpperCase();
    });
  };
  Kibo.isString = function (what) {
    return Kibo.stringContains(Object.prototype.toString.call(what), "String");
  };
  Kibo.arrayIncludes = function () {
    if (Array.prototype.indexOf) {
      return function (haystack, needle) {
        return haystack.indexOf(needle) !== -1;
      };
    } else {
      return function (haystack, needle) {
        for (var i = 0; i < haystack.length; i++) {
          if (haystack[i] === needle) {
            return true;
          }
        }
        return false;
      };
    }
  }();
  Kibo.extractModifiers = function (keyCombination) {
    var modifiers, i;
    modifiers = [];
    for (i = 0; i < Kibo.MODIFIERS.length; i++) {
      if (Kibo.stringContains(keyCombination, Kibo.MODIFIERS[i])) {
        modifiers.push(Kibo.MODIFIERS[i]);
      }
    }
    return modifiers;
  };
  Kibo.extractKey = function (keyCombination) {
    var keys, i;
    keys = Kibo.neatString(keyCombination).split(" ");
    for (i = 0; i < keys.length; i++) {
      if (!Kibo.arrayIncludes(Kibo.MODIFIERS, keys[i])) {
        return keys[i];
      }
    }
  };
  Kibo.modifiersAndKey = function (keyCombination) {
    var result, key;
    if (Kibo.stringContains(keyCombination, "any")) {
      return Kibo.neatString(keyCombination).split(" ").slice(0, 2).join(" ");
    }
    result = Kibo.extractModifiers(keyCombination);
    key = Kibo.extractKey(keyCombination);
    if (key && !Kibo.arrayIncludes(Kibo.MODIFIERS, key)) {
      result.push(key);
    }
    return result.join(" ");
  };
  Kibo.keyName = function (keyCode) {
    return Kibo.KEY_NAMES_BY_CODE[keyCode + ""];
  };
  Kibo.keyCode = function (keyName) {
    return +Kibo.KEY_CODES_BY_NAME[keyName];
  };
  Kibo.prototype.initialize = function () {
    var i,
      that = this || _global;
    (this || _global).lastKeyCode = -1;
    (this || _global).lastModifiers = {};
    for (i = 0; i < Kibo.MODIFIERS.length; i++) {
      (this || _global).lastModifiers[Kibo.MODIFIERS[i]] = false;
    }
    (this || _global).keysDown = {
      any: []
    };
    (this || _global).keysUp = {
      any: []
    };
    (this || _global).downHandler = this.handler("down");
    (this || _global).upHandler = this.handler("up");
    Kibo.registerEvent((this || _global).element, "keydown", (this || _global).downHandler);
    Kibo.registerEvent((this || _global).element, "keyup", (this || _global).upHandler);
    Kibo.registerEvent(window, "unload", function unloader() {
      Kibo.unregisterEvent(that.element, "keydown", that.downHandler);
      Kibo.unregisterEvent(that.element, "keyup", that.upHandler);
      Kibo.unregisterEvent(window, "unload", unloader);
    });
  };
  Kibo.prototype.handler = function (upOrDown) {
    var that = this || _global;
    return function (e) {
      var i, registeredKeys, lastModifiersAndKey;
      e = e || window.event;
      that.lastKeyCode = e.keyCode;
      for (i = 0; i < Kibo.MODIFIERS.length; i++) {
        that.lastModifiers[Kibo.MODIFIERS[i]] = e[Kibo.MODIFIERS[i] + "Key"];
      }
      if (Kibo.arrayIncludes(Kibo.MODIFIERS, Kibo.keyName(that.lastKeyCode))) {
        that.lastModifiers[Kibo.keyName(that.lastKeyCode)] = true;
      }
      registeredKeys = that["keys" + Kibo.capitalize(upOrDown)];
      for (i = 0; i < registeredKeys.any.length; i++) {
        if (registeredKeys.any[i](e) === false && e.preventDefault) {
          e.preventDefault();
        }
      }
      lastModifiersAndKey = that.lastModifiersAndKey();
      if (registeredKeys[lastModifiersAndKey]) {
        for (i = 0; i < registeredKeys[lastModifiersAndKey].length; i++) {
          if (registeredKeys[lastModifiersAndKey][i](e) === false && e.preventDefault) {
            e.preventDefault();
          }
        }
      }
    };
  };
  Kibo.prototype.registerKeys = function (upOrDown, newKeys, func) {
    var i,
      keys,
      registeredKeys = (this || _global)["keys" + Kibo.capitalize(upOrDown)];
    if (Kibo.isString(newKeys)) {
      newKeys = [newKeys];
    }
    for (i = 0; i < newKeys.length; i++) {
      keys = newKeys[i];
      keys = Kibo.modifiersAndKey(keys + "");
      if (registeredKeys[keys]) {
        registeredKeys[keys].push(func);
      } else {
        registeredKeys[keys] = [func];
      }
    }
    return this || _global;
  };

  // jshint maxdepth:5
  Kibo.prototype.unregisterKeys = function (upOrDown, newKeys, func) {
    var i,
      j,
      keys,
      registeredKeys = (this || _global)["keys" + Kibo.capitalize(upOrDown)];
    if (Kibo.isString(newKeys)) {
      newKeys = [newKeys];
    }
    for (i = 0; i < newKeys.length; i++) {
      keys = newKeys[i];
      keys = Kibo.modifiersAndKey(keys + "");
      if (func === null) {
        delete registeredKeys[keys];
      } else {
        if (registeredKeys[keys]) {
          for (j = 0; j < registeredKeys[keys].length; j++) {
            if (String(registeredKeys[keys][j]) === String(func)) {
              registeredKeys[keys].splice(j, 1);
              break;
            }
          }
        }
      }
    }
    return this || _global;
  };
  Kibo.prototype.off = function (keys) {
    return this.unregisterKeys("down", keys, null);
  };
  Kibo.prototype.delegate = function (upOrDown, keys, func) {
    return func !== null || func !== undefined ? this.registerKeys(upOrDown, keys, func) : this.unregisterKeys(upOrDown, keys, func);
  };
  Kibo.prototype.down = function (keys, func) {
    return this.delegate("down", keys, func);
  };
  Kibo.prototype.up = function (keys, func) {
    return this.delegate("up", keys, func);
  };
  Kibo.prototype.lastKey = function (modifier) {
    if (!modifier) {
      return Kibo.keyName((this || _global).lastKeyCode);
    }
    return (this || _global).lastModifiers[modifier];
  };
  Kibo.prototype.lastModifiersAndKey = function () {
    var result, i;
    result = [];
    for (i = 0; i < Kibo.MODIFIERS.length; i++) {
      if (this.lastKey(Kibo.MODIFIERS[i])) {
        result.push(Kibo.MODIFIERS[i]);
      }
    }
    if (!Kibo.arrayIncludes(result, this.lastKey())) {
      result.push(this.lastKey());
    }
    return result.join(" ");
  };
  var index = {
    Kibo: Kibo
  };
  var css_248z$4 = ".media-control-notransition {\n  transition: none !important; }\n\n.media-control[data-media-control] {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  pointer-events: none; }\n  .media-control[data-media-control].dragging {\n    pointer-events: auto;\n    cursor: grabbing !important;\n    cursor: url(\"closed-hand.cur\"), move; }\n    .media-control[data-media-control].dragging * {\n      cursor: grabbing !important;\n      cursor: url(\"closed-hand.cur\"), move; }\n  .media-control[data-media-control] .media-control-background[data-background] {\n    position: absolute;\n    height: 40%;\n    width: 100%;\n    bottom: 0;\n    background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));\n    will-change: transform, opacity;\n    transition: opacity 0.6s ease-out; }\n  .media-control[data-media-control] .media-control-icon {\n    line-height: 0;\n    letter-spacing: 0;\n    speak: none;\n    color: #fff;\n    opacity: 0.5;\n    vertical-align: middle;\n    text-align: left;\n    transition: all 0.1s ease; }\n  .media-control[data-media-control] .media-control-icon:hover {\n    color: white;\n    opacity: 0.75;\n    text-shadow: rgba(255, 255, 255, 0.8) 0 0 5px; }\n  .media-control[data-media-control].media-control-hide .media-control-background[data-background] {\n    opacity: 0; }\n  .media-control[data-media-control].media-control-hide .media-control-layer[data-controls] {\n    transform: translateY(50px); }\n    .media-control[data-media-control].media-control-hide .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n      opacity: 0; }\n  .media-control[data-media-control] .media-control-layer[data-controls] {\n    position: absolute;\n    transform: translateY(-7px);\n    bottom: 0;\n    width: 100%;\n    height: 32px;\n    font-size: 0;\n    vertical-align: middle;\n    pointer-events: auto;\n    transition: bottom 0.4s ease-out; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-left-panel[data-media-control] {\n      position: absolute;\n      top: 0;\n      left: 4px;\n      height: 100%; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-center-panel[data-media-control] {\n      height: 100%;\n      text-align: center;\n      line-height: 32px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-right-panel[data-media-control] {\n      position: absolute;\n      top: 0;\n      right: 4px;\n      height: 100%; }\n    .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button {\n      background-color: transparent;\n      border: 0;\n      margin: 0 6px;\n      padding: 0;\n      cursor: pointer;\n      display: inline-block;\n      width: 32px;\n      height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg {\n        width: 100%;\n        height: 22px; }\n        .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button svg path {\n          fill: white; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button:focus {\n        outline: none; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-play] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-pause] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-stop] {\n        float: left;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-fullscreen] {\n        float: right;\n        background-color: transparent;\n        border: 0;\n        height: 100%; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator] {\n        background-color: transparent;\n        border: 0;\n        cursor: default;\n        display: none;\n        float: right;\n        height: 100%; }\n        .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled {\n          display: block;\n          opacity: 1.0; }\n          .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-hd-indicator].enabled:hover {\n            opacity: 1.0;\n            text-shadow: none; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playpause] {\n        float: left; }\n      .media-control[data-media-control] .media-control-layer[data-controls] button.media-control-button[data-playstop] {\n        float: left; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position], .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n      display: inline-block;\n      font-size: 10px;\n      color: white;\n      cursor: default;\n      line-height: 32px;\n      position: relative; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-position] {\n      margin: 0 6px 0 7px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration] {\n      color: rgba(255, 255, 255, 0.5);\n      margin-right: 6px; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .media-control-indicator[data-duration]:before {\n        content: \"|\";\n        margin-right: 7px; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] {\n      position: absolute;\n      top: -20px;\n      left: 0;\n      display: inline-block;\n      vertical-align: middle;\n      width: 100%;\n      height: 25px;\n      cursor: pointer; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] {\n        width: 100%;\n        height: 1px;\n        position: relative;\n        top: 12px;\n        background-color: #666666; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-1[data-seekbar] {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          background-color: #c2c2c2;\n          transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-fill-2[data-seekbar] {\n          position: absolute;\n          top: 0;\n          left: 0;\n          width: 0;\n          height: 100%;\n          background-color: #005aff;\n          transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n          opacity: 0;\n          position: absolute;\n          top: -3px;\n          width: 5px;\n          height: 7px;\n          background-color: rgba(255, 255, 255, 0.5);\n          transition: opacity 0.1s ease; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar]:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n        opacity: 1; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled {\n        cursor: default; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar].seek-disabled:hover .bar-background[data-seekbar] .bar-hover[data-seekbar] {\n          opacity: 0; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] {\n        position: absolute;\n        transform: translateX(-50%);\n        top: 2px;\n        left: 0;\n        width: 20px;\n        height: 20px;\n        opacity: 1;\n        transition: all 0.1s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .bar-container[data-seekbar] .bar-scrubber[data-seekbar] .bar-scrubber-icon[data-seekbar] {\n          position: absolute;\n          left: 6px;\n          top: 6px;\n          width: 8px;\n          height: 8px;\n          border-radius: 10px;\n          box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n          background-color: white; }\n    .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] {\n      float: right;\n      display: inline-block;\n      height: 32px;\n      cursor: pointer;\n      margin: 0 6px;\n      box-sizing: border-box; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] {\n        float: left;\n        bottom: 0; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] {\n          background-color: transparent;\n          border: 0;\n          box-sizing: content-box;\n          width: 32px;\n          height: 32px;\n          opacity: 0.5; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume]:hover {\n            opacity: 0.75; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg {\n            height: 24px;\n            position: relative;\n            top: 3px; }\n            .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume] svg path {\n              fill: white; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .drawer-icon-container[data-volume] .drawer-icon[data-volume].muted svg {\n            margin-left: 2px; }\n      .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] {\n        float: left;\n        position: relative;\n        overflow: hidden;\n        top: 6px;\n        width: 42px;\n        height: 18px;\n        padding: 3px 0;\n        transition: width .2s ease-out; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] {\n          height: 1px;\n          position: relative;\n          top: 7px;\n          margin: 0 3px;\n          background-color: #666666; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-1[data-volume] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 0;\n            height: 100%;\n            background-color: #c2c2c2;\n            transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-fill-2[data-volume] {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 0;\n            height: 100%;\n            background-color: #005aff;\n            transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-background[data-volume] .bar-hover[data-volume] {\n            opacity: 0;\n            position: absolute;\n            top: -3px;\n            width: 5px;\n            height: 7px;\n            background-color: rgba(255, 255, 255, 0.5);\n            transition: opacity 0.1s ease; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] {\n          position: absolute;\n          transform: translateX(-50%);\n          top: 0px;\n          left: 0;\n          width: 20px;\n          height: 20px;\n          opacity: 1;\n          transition: all 0.1s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .bar-scrubber[data-volume] .bar-scrubber-icon[data-volume] {\n            position: absolute;\n            left: 6px;\n            top: 6px;\n            width: 8px;\n            height: 8px;\n            border-radius: 10px;\n            box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.2);\n            background-color: white; }\n        .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume] {\n          float: left;\n          width: 4px;\n          padding-left: 2px;\n          height: 12px;\n          opacity: 0.5;\n          box-shadow: inset 2px 0 0 white;\n          transition: transform .2s ease-out; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume].fill {\n            box-shadow: inset 2px 0 0 #fff;\n            opacity: 1; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:nth-of-type(1) {\n            padding-left: 0; }\n          .media-control[data-media-control] .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume] .segmented-bar-element[data-volume]:hover {\n            transform: scaleY(1.5); }\n  .media-control[data-media-control].w320 .media-control-layer[data-controls] .drawer-container[data-volume] .bar-container[data-volume].volume-bar-hide {\n    width: 0;\n    height: 12px;\n    top: 9px;\n    padding: 0; }\n";
  var mediaControlHTML = "<div class=\"media-control-background\" data-background></div>\n<div class=\"media-control-layer\" data-controls>\n  <%  var renderBar = function(name) { %>\n      <div class=\"bar-container\" data-<%= name %>>\n        <div class=\"bar-background\" data-<%= name %>>\n          <div class=\"bar-fill-1\" data-<%= name %>></div>\n          <div class=\"bar-fill-2\" data-<%= name %>></div>\n          <div class=\"bar-hover\" data-<%= name %>></div>\n        </div>\n        <div class=\"bar-scrubber\" data-<%= name %>>\n          <div class=\"bar-scrubber-icon\" data-<%= name %>></div>\n        </div>\n      </div>\n  <%  }; %>\n  <%  var renderSegmentedBar = function(name, segments) {\n      segments = segments || 10; %>\n    <div class=\"bar-container\" data-<%= name %>>\n    <% for (var i = 0; i < segments; i++) { %>\n      <div class=\"segmented-bar-element\" data-<%= name %>></div>\n    <% } %>\n    </div>\n  <% }; %>\n  <% var renderDrawer = function(name, renderContent) { %>\n      <div class=\"drawer-container\" data-<%= name %>>\n        <div class=\"drawer-icon-container\" data-<%= name %>>\n          <div class=\"drawer-icon media-control-icon\" data-<%= name %>></div>\n          <span class=\"drawer-text\" data-<%= name %>></span>\n        </div>\n        <% renderContent(name); %>\n      </div>\n  <% }; %>\n  <% var renderIndicator = function(name) { %>\n      <div class=\"media-control-indicator\" data-<%= name %>></div>\n  <% }; %>\n  <% var renderButton = function(name) { %>\n    <button type=\"button\" class=\"media-control-button media-control-icon\" data-<%= name %> aria-label=\"<%= name %>\"></button>\n  <% }; %>\n  <%  var templates = {\n        bar: renderBar,\n        segmentedBar: renderSegmentedBar,\n      };\n      var render = function(settingsList) {\n        settingsList.forEach(function(setting) {\n          if(setting === \"seekbar\") {\n            renderBar(setting);\n          } else if (setting === \"volume\") {\n            renderDrawer(setting, settings.volumeBarTemplate ? templates[settings.volumeBarTemplate] : function(name) { return renderSegmentedBar(name); });\n          } else if (setting === \"duration\" || setting === \"position\") {\n            renderIndicator(setting);\n          } else {\n            renderButton(setting);\n          }\n        });\n      }; %>\n  <% if (settings.default && settings.default.length) { %>\n  <div class=\"media-control-center-panel\" data-media-control>\n    <% render(settings.default); %>\n  </div>\n  <% } %>\n  <% if (settings.left && settings.left.length) { %>\n  <div class=\"media-control-left-panel\" data-media-control>\n    <% render(settings.left); %>\n  </div>\n  <% } %>\n  <% if (settings.right && settings.right.length) { %>\n  <div class=\"media-control-right-panel\" data-media-control>\n    <% render(settings.right); %>\n  </div>\n  <% } %>\n</div>\n";
  var stopIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M1.712 1.24h12.6v13.52h-12.6z\"/>\n</svg>";
  var volumeIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M11.5 11h-.002v1.502L7.798 10H4.5V6h3.297l3.7-2.502V4.5h.003V11zM11 4.49L7.953 6.5H5v3h2.953L11 11.51V4.49z\"/>\n</svg>";
  var volumeMuteIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#010101\" d=\"M9.75 11.51L6.7 9.5H3.75v-3H6.7L9.75 4.49v.664l.497.498V3.498L6.547 6H3.248v4h3.296l3.7 2.502v-2.154l-.497.5v.662zm3-5.165L12.404 6l-1.655 1.653L9.093 6l-.346.345L10.402 8 8.747 9.654l.346.347 1.655-1.653L12.403 10l.348-.346L11.097 8l1.655-1.655z\"/>\n</svg>";
  var fullscreenIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M7.156 8L4 11.156V8.5H3V13h4.5v-1H4.844L8 8.844 7.156 8zM8.5 3v1h2.657L8 7.157 8.846 8 12 4.844V7.5h1V3H8.5z\"/>\n</svg>";
  var exitFullscreenIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M13.5 3.344l-.844-.844L9.5 5.656V3h-1v4.5H13v-1h-2.656L13.5 3.344zM3 9.5h2.656L2.5 12.656l.844.844L6.5 10.344V13h1V8.5H3v1z\"/>\n</svg>";
  var hdIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\">\n  <path fill=\"#010101\" d=\"M5.375 7.062H2.637V4.26H.502v7.488h2.135V8.9h2.738v2.848h2.133V4.26H5.375v2.802zm5.97-2.81h-2.84v7.496h2.798c2.65 0 4.195-1.607 4.195-3.77v-.022c0-2.162-1.523-3.704-4.154-3.704zm2.06 3.758c0 1.21-.81 1.896-2.03 1.896h-.83V6.093h.83c1.22 0 2.03.696 2.03 1.896v.02z\"/>\n</svg>";
  var Config = Utils.Config,
    Fullscreen = Utils.Fullscreen,
    formatTime$1 = Utils.formatTime,
    extend = Utils.extend,
    removeArrayItem = Utils.removeArrayItem;
  var MediaControl$1 = /*#__PURE__*/function (_UICorePlugin) {
    _inherits$1(MediaControl, _UICorePlugin);
    var _super = _createSuper$1(MediaControl);
    function MediaControl(core) {
      var _this;
      _classCallCheck$1(this || _global, MediaControl);
      _this = _super.call(this || _global, core);
      _this.persistConfig = _this.options.persistConfig;
      _this.currentPositionValue = null;
      _this.currentDurationValue = null;
      _this.keepVisible = false;
      _this.fullScreenOnVideoTagSupported = null; // unknown
      _this.setInitialVolume();
      _this.settings = {
        left: ["play", "stop", "pause"],
        right: ["volume"],
        "default": ["position", "seekbar", "duration"]
      };
      _this.kibo = new Kibo(_this.options.focusElement);
      _this.bindKeyEvents();
      if (_this.container) {
        if (!zepto.isEmptyObject(_this.container.settings)) _this.settings = zepto.extend({}, _this.container.settings);
      } else {
        _this.settings = {};
      }
      _this.userDisabled = false;
      if (_this.container && _this.container.mediaControlDisabled || _this.options.chromeless) _this.disable();
      _this.stopDragHandler = function (event) {
        return _this.stopDrag(event);
      };
      _this.updateDragHandler = function (event) {
        return _this.updateDrag(event);
      };
      zepto(document).bind("mouseup", _this.stopDragHandler);
      zepto(document).bind("mousemove", _this.updateDragHandler);
      return _this;
    }
    _createClass$1(MediaControl, [{
      key: "name",
      get: function get() {
        return "media_control";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "disabled",
      get: function get() {
        var playbackIsNOOP = (this || _global).container && (this || _global).container.getPlaybackType() === Playback.NO_OP;
        return (this || _global).userDisabled || playbackIsNOOP;
      }
    }, {
      key: "container",
      get: function get() {
        return (this || _global).core && (this || _global).core.activeContainer;
      }
    }, {
      key: "playback",
      get: function get() {
        return (this || _global).core && (this || _global).core.activePlayback;
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "media-control",
          "data-media-control": ""
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "click [data-play]": "play",
          "click [data-pause]": "pause",
          "click [data-playpause]": "togglePlayPause",
          "click [data-stop]": "stop",
          "click [data-playstop]": "togglePlayStop",
          "click [data-fullscreen]": "toggleFullscreen",
          "click .bar-container[data-seekbar]": "seek",
          "click .bar-container[data-volume]": "onVolumeClick",
          "click .drawer-icon[data-volume]": "toggleMute",
          "mouseenter .drawer-container[data-volume]": "showVolumeBar",
          "mouseleave .drawer-container[data-volume]": "hideVolumeBar",
          "mousedown .bar-container[data-volume]": "startVolumeDrag",
          "mousemove .bar-container[data-volume]": "mousemoveOnVolumeBar",
          "mousedown .bar-scrubber[data-seekbar]": "startSeekDrag",
          "mousemove .bar-container[data-seekbar]": "mousemoveOnSeekBar",
          "mouseleave .bar-container[data-seekbar]": "mouseleaveOnSeekBar",
          "mouseenter .media-control-layer[data-controls]": "setUserKeepVisible",
          "mouseleave .media-control-layer[data-controls]": "resetUserKeepVisible"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(mediaControlHTML);
      }
    }, {
      key: "volume",
      get: function get() {
        return (this || _global).container && (this || _global).container.isReady ? (this || _global).container.volume : (this || _global).intendedVolume;
      }
    }, {
      key: "muted",
      get: function get() {
        return (this || _global).volume === 0;
      }
    }, {
      key: "getExternalInterface",
      value: function getExternalInterface() {
        var _this2 = this || _global;
        return {
          setVolume: (this || _global).setVolume,
          getVolume: function getVolume() {
            return _this2.volume;
          }
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        var _this3 = this || _global;
        this.stopListening();
        this.listenTo((this || _global).core, Events.CORE_ACTIVE_CONTAINER_CHANGED, (this || _global).onActiveContainerChanged);
        this.listenTo((this || _global).core, Events.CORE_MOUSE_MOVE, (this || _global).show);
        this.listenTo((this || _global).core, Events.CORE_MOUSE_LEAVE, function () {
          return _this3.hide(_this3.options.hideMediaControlDelay);
        });
        this.listenTo((this || _global).core, Events.CORE_FULLSCREEN, (this || _global).show);
        this.listenTo((this || _global).core, Events.CORE_OPTIONS_CHANGE, (this || _global).configure);
        this.listenTo((this || _global).core, Events.CORE_RESIZE, (this || _global).playerResize);
        this.bindContainerEvents();
      }
    }, {
      key: "bindContainerEvents",
      value: function bindContainerEvents() {
        if (!(this || _global).container) return;
        this.listenTo((this || _global).container, Events.CONTAINER_PLAY, (this || _global).changeTogglePlay);
        this.listenTo((this || _global).container, Events.CONTAINER_PAUSE, (this || _global).changeTogglePlay);
        this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).changeTogglePlay);
        this.listenTo((this || _global).container, Events.CONTAINER_DBLCLICK, (this || _global).toggleFullscreen);
        this.listenTo((this || _global).container, Events.CONTAINER_TIMEUPDATE, (this || _global).onTimeUpdate);
        this.listenTo((this || _global).container, Events.CONTAINER_PROGRESS, (this || _global).updateProgressBar);
        this.listenTo((this || _global).container, Events.CONTAINER_SETTINGSUPDATE, (this || _global).settingsUpdate);
        this.listenTo((this || _global).container, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (this || _global).settingsUpdate);
        this.listenTo((this || _global).container, Events.CONTAINER_HIGHDEFINITIONUPDATE, (this || _global).highDefinitionUpdate);
        this.listenTo((this || _global).container, Events.CONTAINER_MEDIACONTROL_DISABLE, (this || _global).disable);
        this.listenTo((this || _global).container, Events.CONTAINER_MEDIACONTROL_ENABLE, (this || _global).enable);
        this.listenTo((this || _global).container, Events.CONTAINER_ENDED, (this || _global).ended);
        this.listenTo((this || _global).container, Events.CONTAINER_VOLUME, (this || _global).onVolumeChanged);
        this.listenTo((this || _global).container, Events.CONTAINER_OPTIONS_CHANGE, (this || _global).setInitialVolume);
        if ((this || _global).container.playback.el.nodeName.toLowerCase() === "video") {
          // wait until the metadata has loaded and then check if fullscreen on video tag is supported
          this.listenToOnce((this || _global).container, Events.CONTAINER_LOADEDMETADATA, (this || _global).onLoadedMetadataOnVideoTag);
        }
      }
    }, {
      key: "disable",
      value: function disable() {
        (this || _global).userDisabled = true;
        this.hide();
        this.unbindKeyEvents();
        (this || _global).$el.hide();
      }
    }, {
      key: "enable",
      value: function enable() {
        if ((this || _global).options.chromeless) return;
        (this || _global).userDisabled = false;
        this.bindKeyEvents();
        this.show();
      }
    }, {
      key: "play",
      value: function play() {
        (this || _global).container && (this || _global).container.play();
      }
    }, {
      key: "pause",
      value: function pause() {
        (this || _global).container && (this || _global).container.pause();
      }
    }, {
      key: "stop",
      value: function stop() {
        (this || _global).container && (this || _global).container.stop();
      }
    }, {
      key: "setInitialVolume",
      value: function setInitialVolume() {
        var initialVolume = (this || _global).persistConfig ? Config.restore("volume") : 100;
        var options = (this || _global).container && (this || _global).container.options || (this || _global).options;
        this.setVolume(options.mute ? 0 : initialVolume, true);
      }
    }, {
      key: "onVolumeChanged",
      value: function onVolumeChanged() {
        this.updateVolumeUI();
      }
    }, {
      key: "onLoadedMetadataOnVideoTag",
      value: function onLoadedMetadataOnVideoTag() {
        var video = (this || _global).playback && (this || _global).playback.el;
        // video.webkitSupportsFullscreen is deprecated but iOS appears to only use this
        // see https://github.com/clappr/clappr/issues/1127
        if (!Fullscreen.fullscreenEnabled() && video.webkitSupportsFullscreen) {
          (this || _global).fullScreenOnVideoTagSupported = true;
          this.settingsUpdate();
        }
      }
    }, {
      key: "updateVolumeUI",
      value: function updateVolumeUI() {
        // this will be called after a render
        if (!(this || _global).rendered) return;

        // update volume bar scrubber/fill on bar mode
        (this || _global).$volumeBarContainer.find(".bar-fill-2").css({});
        var containerWidth = (this || _global).$volumeBarContainer.width();
        var barWidth = (this || _global).$volumeBarBackground.width();
        var offset = (containerWidth - barWidth) / 2;
        var pos = barWidth * (this || _global).volume / 100 + offset;
        (this || _global).$volumeBarFill.css({
          width: "".concat((this || _global).volume, "%")
        });
        (this || _global).$volumeBarScrubber.css({
          left: pos
        });

        // update volume bar segments on segmented bar mode
        (this || _global).$volumeBarContainer.find(".segmented-bar-element").removeClass("fill");
        var item = Math.ceil((this || _global).volume / 10);
        (this || _global).$volumeBarContainer.find(".segmented-bar-element").slice(0, item).addClass("fill");
        (this || _global).$volumeIcon.html("");
        (this || _global).$volumeIcon.removeClass("muted");
        if (!(this || _global).muted) {
          (this || _global).$volumeIcon.append(volumeIcon);
        } else {
          (this || _global).$volumeIcon.append(volumeMuteIcon);
          (this || _global).$volumeIcon.addClass("muted");
        }
        this.applyButtonStyle((this || _global).$volumeIcon);
      }
    }, {
      key: "changeTogglePlay",
      value: function changeTogglePlay() {
        (this || _global).$playPauseToggle.html("");
        (this || _global).$playStopToggle.html("");
        if ((this || _global).container && (this || _global).container.isPlaying()) {
          (this || _global).$playPauseToggle.append(pauseIcon);
          (this || _global).$playStopToggle.append(stopIcon);
          this.trigger(Events.MEDIACONTROL_PLAYING);
        } else {
          (this || _global).$playPauseToggle.append(playIcon);
          (this || _global).$playStopToggle.append(playIcon);
          this.trigger(Events.MEDIACONTROL_NOTPLAYING);
          Browser.isMobile && this.show();
        }
        this.applyButtonStyle((this || _global).$playPauseToggle);
        this.applyButtonStyle((this || _global).$playStopToggle);
      }
    }, {
      key: "mousemoveOnSeekBar",
      value: function mousemoveOnSeekBar(event) {
        if ((this || _global).settings.seekEnabled) {
          var offsetX = event.pageX - (this || _global).$seekBarContainer.offset().left - (this || _global).$seekBarHover.width() / 2;
          (this || _global).$seekBarHover.css({
            left: offsetX
          });
        }
        this.trigger(Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR, event);
      }
    }, {
      key: "mouseleaveOnSeekBar",
      value: function mouseleaveOnSeekBar(event) {
        this.trigger(Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR, event);
      }
    }, {
      key: "onVolumeClick",
      value: function onVolumeClick(event) {
        this.setVolume(this.getVolumeFromUIEvent(event));
      }
    }, {
      key: "mousemoveOnVolumeBar",
      value: function mousemoveOnVolumeBar(event) {
        (this || _global).draggingVolumeBar && this.setVolume(this.getVolumeFromUIEvent(event));
      }
    }, {
      key: "playerResize",
      value: function playerResize(size) {
        (this || _global).$fullscreenToggle.html("");
        var icon = (this || _global).core.isFullscreen() ? exitFullscreenIcon : fullscreenIcon;
        (this || _global).$fullscreenToggle.append(icon);
        this.applyButtonStyle((this || _global).$fullscreenToggle);
        (this || _global).$el.find(".media-control").length !== 0 && (this || _global).$el.removeClass("w320");
        if (size.width <= 320 || (this || _global).options.hideVolumeBar) (this || _global).$el.addClass("w320");
      }
    }, {
      key: "togglePlayPause",
      value: function togglePlayPause() {
        (this || _global).container.isPlaying() ? (this || _global).container.pause() : (this || _global).container.play();
        return false;
      }
    }, {
      key: "togglePlayStop",
      value: function togglePlayStop() {
        (this || _global).container.isPlaying() ? (this || _global).container.stop() : (this || _global).container.play();
      }
    }, {
      key: "startSeekDrag",
      value: function startSeekDrag(event) {
        if (!(this || _global).settings.seekEnabled) return;
        (this || _global).draggingSeekBar = true;
        (this || _global).$el.addClass("dragging");
        (this || _global).$seekBarLoaded.addClass("media-control-notransition");
        (this || _global).$seekBarPosition.addClass("media-control-notransition");
        (this || _global).$seekBarScrubber.addClass("media-control-notransition");
        event && event.preventDefault();
      }
    }, {
      key: "startVolumeDrag",
      value: function startVolumeDrag(event) {
        (this || _global).draggingVolumeBar = true;
        (this || _global).$el.addClass("dragging");
        event && event.preventDefault();
      }
    }, {
      key: "stopDrag",
      value: function stopDrag(event) {
        (this || _global).draggingSeekBar && this.seek(event);
        (this || _global).$el.removeClass("dragging");
        (this || _global).$seekBarLoaded.removeClass("media-control-notransition");
        (this || _global).$seekBarPosition.removeClass("media-control-notransition");
        (this || _global).$seekBarScrubber.removeClass("media-control-notransition dragging");
        (this || _global).draggingSeekBar = false;
        (this || _global).draggingVolumeBar = false;
      }
    }, {
      key: "updateDrag",
      value: function updateDrag(event) {
        if ((this || _global).draggingSeekBar) {
          event.preventDefault();
          var offsetX = event.pageX - (this || _global).$seekBarContainer.offset().left;
          var pos = offsetX / (this || _global).$seekBarContainer.width() * 100;
          pos = Math.min(100, Math.max(pos, 0));
          this.setSeekPercentage(pos);
        } else if ((this || _global).draggingVolumeBar) {
          event.preventDefault();
          this.setVolume(this.getVolumeFromUIEvent(event));
        }
      }
    }, {
      key: "getVolumeFromUIEvent",
      value: function getVolumeFromUIEvent(event) {
        var offsetY = event.pageX - (this || _global).$volumeBarContainer.offset().left;
        var volumeFromUI = offsetY / (this || _global).$volumeBarContainer.width() * 100;
        return volumeFromUI;
      }
    }, {
      key: "toggleMute",
      value: function toggleMute() {
        this.setVolume((this || _global).muted ? 100 : 0);
      }
    }, {
      key: "setVolume",
      value: function setVolume(value) {
        var _this4 = this || _global;
        var isInitialVolume = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        value = Math.min(100, Math.max(value, 0));
        // this will hold the intended volume
        // it may not actually get set to this straight away
        // if the container is not ready etc
        (this || _global).intendedVolume = value;
        (this || _global).persistConfig && !isInitialVolume && Config.persist("volume", value);
        var setWhenContainerReady = function setWhenContainerReady() {
          if (_this4.container && _this4.container.isReady) {
            _this4.container.setVolume(value);
          } else {
            _this4.listenToOnce(_this4.container, Events.CONTAINER_READY, function () {
              _this4.container.setVolume(value);
            });
          }
        };
        if (!(this || _global).container) this.listenToOnce(this || _global, Events.MEDIACONTROL_CONTAINERCHANGED, function () {
          return setWhenContainerReady();
        });else setWhenContainerReady();
      }
    }, {
      key: "toggleFullscreen",
      value: function toggleFullscreen() {
        this.trigger(Events.MEDIACONTROL_FULLSCREEN, (this || _global).name);
        (this || _global).container.fullscreen();
        (this || _global).core.toggleFullscreen();
        this.resetUserKeepVisible();
      }
    }, {
      key: "onActiveContainerChanged",
      value: function onActiveContainerChanged() {
        (this || _global).fullScreenOnVideoTagSupported = null;
        this.bindEvents();
        // set the new container to match the volume of the last one
        this.setInitialVolume();
        this.changeTogglePlay();
        this.bindContainerEvents();
        this.settingsUpdate();
        (this || _global).container && (this || _global).container.trigger(Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (this || _global).container.isDvrInUse());
        (this || _global).container && (this || _global).container.mediaControlDisabled && this.disable();
        this.trigger(Events.MEDIACONTROL_CONTAINERCHANGED);
      }
    }, {
      key: "showVolumeBar",
      value: function showVolumeBar() {
        (this || _global).hideVolumeId && clearTimeout((this || _global).hideVolumeId);
        (this || _global).$volumeBarContainer.removeClass("volume-bar-hide");
      }
    }, {
      key: "hideVolumeBar",
      value: function hideVolumeBar() {
        var _this5 = this || _global;
        var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;
        if (!(this || _global).$volumeBarContainer) return;
        if ((this || _global).draggingVolumeBar) {
          (this || _global).hideVolumeId = setTimeout(function () {
            return _this5.hideVolumeBar();
          }, timeout);
        } else {
          (this || _global).hideVolumeId && clearTimeout((this || _global).hideVolumeId);
          (this || _global).hideVolumeId = setTimeout(function () {
            return _this5.$volumeBarContainer.addClass("volume-bar-hide");
          }, timeout);
        }
      }
    }, {
      key: "ended",
      value: function ended() {
        this.changeTogglePlay();
      }
    }, {
      key: "updateProgressBar",
      value: function updateProgressBar(progress) {
        var loadedStart = progress.start / progress.total * 100;
        var loadedEnd = progress.current / progress.total * 100;
        (this || _global).$seekBarLoaded.css({
          left: "".concat(loadedStart, "%"),
          width: "".concat(loadedEnd - loadedStart, "%")
        });
      }
    }, {
      key: "onTimeUpdate",
      value: function onTimeUpdate(timeProgress) {
        if ((this || _global).draggingSeekBar) return;
        // TODO why should current time ever be negative?
        var position = timeProgress.current < 0 ? timeProgress.total : timeProgress.current;
        (this || _global).currentPositionValue = position;
        (this || _global).currentDurationValue = timeProgress.total;
        this.renderSeekBar();
      }
    }, {
      key: "renderSeekBar",
      value: function renderSeekBar() {
        // this will be triggered as soon as these become available
        if ((this || _global).currentPositionValue === null || (this || _global).currentDurationValue === null) return;

        // default to 100%
        (this || _global).currentSeekBarPercentage = 100;
        if ((this || _global).container && ((this || _global).container.getPlaybackType() !== Playback.LIVE || (this || _global).container.isDvrInUse())) (this || _global).currentSeekBarPercentage = (this || _global).currentPositionValue / (this || _global).currentDurationValue * 100;
        this.setSeekPercentage((this || _global).currentSeekBarPercentage);
        var newPosition = formatTime$1((this || _global).currentPositionValue);
        var newDuration = formatTime$1((this || _global).currentDurationValue);
        if (newPosition !== (this || _global).displayedPosition) {
          (this || _global).$position.text(newPosition);
          (this || _global).displayedPosition = newPosition;
        }
        if (newDuration !== (this || _global).displayedDuration) {
          (this || _global).$duration.text(newDuration);
          (this || _global).displayedDuration = newDuration;
        }
      }
    }, {
      key: "seek",
      value: function seek(event) {
        if (!(this || _global).settings.seekEnabled) return;
        var offsetX = event.pageX - (this || _global).$seekBarContainer.offset().left;
        var pos = offsetX / (this || _global).$seekBarContainer.width() * 100;
        pos = Math.min(100, Math.max(pos, 0));
        (this || _global).container && (this || _global).container.seekPercentage(pos);
        this.setSeekPercentage(pos);
        return false;
      }
    }, {
      key: "setKeepVisible",
      value: function setKeepVisible() {
        (this || _global).keepVisible = true;
      }
    }, {
      key: "resetKeepVisible",
      value: function resetKeepVisible() {
        (this || _global).keepVisible = false;
      }
    }, {
      key: "setUserKeepVisible",
      value: function setUserKeepVisible() {
        (this || _global).userKeepVisible = true;
      }
    }, {
      key: "resetUserKeepVisible",
      value: function resetUserKeepVisible() {
        (this || _global).userKeepVisible = false;
      }
    }, {
      key: "isVisible",
      value: function isVisible() {
        return !(this || _global).$el.hasClass("media-control-hide");
      }
    }, {
      key: "show",
      value: function show(event) {
        var _this6 = this || _global;
        if ((this || _global).disabled) return;
        var timeout = 2000;
        var mousePointerMoved = event && event.clientX !== (this || _global).lastMouseX && event.clientY !== (this || _global).lastMouseY;
        if (!event || mousePointerMoved || navigator.userAgent.match(/firefox/i)) {
          clearTimeout((this || _global).hideId);
          (this || _global).$el.show();
          this.trigger(Events.MEDIACONTROL_SHOW, (this || _global).name);
          (this || _global).container && (this || _global).container.trigger(Events.CONTAINER_MEDIACONTROL_SHOW, (this || _global).name);
          (this || _global).$el.removeClass("media-control-hide");
          (this || _global).hideId = setTimeout(function () {
            return _this6.hide();
          }, timeout);
          if (event) {
            (this || _global).lastMouseX = event.clientX;
            (this || _global).lastMouseY = event.clientY;
          }
        }
        var showing = true;
        this.updateCursorStyle(showing);
      }
    }, {
      key: "hide",
      value: function hide() {
        var _this7 = this || _global;
        var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        if (!this.isVisible()) return;
        var timeout = delay || 2000;
        clearTimeout((this || _global).hideId);
        if (!(this || _global).disabled && (this || _global).options.hideMediaControl === false) return;
        var hasKeepVisibleRequested = (this || _global).userKeepVisible || (this || _global).keepVisible;
        var hasDraggingAction = (this || _global).draggingSeekBar || (this || _global).draggingVolumeBar;
        if (!(this || _global).disabled && (delay || hasKeepVisibleRequested || hasDraggingAction)) {
          (this || _global).hideId = setTimeout(function () {
            return _this7.hide();
          }, timeout);
        } else {
          this.trigger(Events.MEDIACONTROL_HIDE, (this || _global).name);
          (this || _global).container && (this || _global).container.trigger(Events.CONTAINER_MEDIACONTROL_HIDE, (this || _global).name);
          (this || _global).$el.addClass("media-control-hide");
          this.hideVolumeBar(0);
          var showing = false;
          this.updateCursorStyle(showing);
        }
      }
    }, {
      key: "updateCursorStyle",
      value: function updateCursorStyle(showing) {
        if (showing) (this || _global).core.$el.removeClass("nocursor");else if ((this || _global).core.isFullscreen()) (this || _global).core.$el.addClass("nocursor");
      }
    }, {
      key: "settingsUpdate",
      value: function settingsUpdate() {
        var newSettings = this.getSettings();
        if (newSettings && !(this || _global).fullScreenOnVideoTagSupported && !Fullscreen.fullscreenEnabled()) {
          // remove fullscreen from settings if it is present
          newSettings["default"] && removeArrayItem(newSettings["default"], "fullscreen");
          newSettings.left && removeArrayItem(newSettings.left, "fullscreen");
          newSettings.right && removeArrayItem(newSettings.right, "fullscreen");
        }
        var settingsChanged = JSON.stringify((this || _global).settings) !== JSON.stringify(newSettings);
        if (settingsChanged) {
          (this || _global).settings = newSettings;
          this.render();
        }
      }
    }, {
      key: "getSettings",
      value: function getSettings() {
        return zepto.extend(true, {}, (this || _global).container && (this || _global).container.settings);
      }
    }, {
      key: "highDefinitionUpdate",
      value: function highDefinitionUpdate(isHD) {
        (this || _global).isHD = isHD;
        var method = isHD ? "addClass" : "removeClass";
        (this || _global).$hdIndicator[method]("enabled");
      }
    }, {
      key: "createCachedElements",
      value: function createCachedElements() {
        var $layer = (this || _global).$el.find(".media-control-layer");
        (this || _global).$duration = $layer.find(".media-control-indicator[data-duration]");
        (this || _global).$fullscreenToggle = $layer.find("button.media-control-button[data-fullscreen]");
        (this || _global).$playPauseToggle = $layer.find("button.media-control-button[data-playpause]");
        (this || _global).$playStopToggle = $layer.find("button.media-control-button[data-playstop]");
        (this || _global).$position = $layer.find(".media-control-indicator[data-position]");
        (this || _global).$seekBarContainer = $layer.find(".bar-container[data-seekbar]");
        (this || _global).$seekBarHover = $layer.find(".bar-hover[data-seekbar]");
        (this || _global).$seekBarLoaded = $layer.find(".bar-fill-1[data-seekbar]");
        (this || _global).$seekBarPosition = $layer.find(".bar-fill-2[data-seekbar]");
        (this || _global).$seekBarScrubber = $layer.find(".bar-scrubber[data-seekbar]");
        (this || _global).$volumeBarContainer = $layer.find(".bar-container[data-volume]");
        (this || _global).$volumeContainer = $layer.find(".drawer-container[data-volume]");
        (this || _global).$volumeIcon = $layer.find(".drawer-icon[data-volume]");
        (this || _global).$volumeBarBackground = (this || _global).$el.find(".bar-background[data-volume]");
        (this || _global).$volumeBarFill = (this || _global).$el.find(".bar-fill-1[data-volume]");
        (this || _global).$volumeBarScrubber = (this || _global).$el.find(".bar-scrubber[data-volume]");
        (this || _global).$hdIndicator = (this || _global).$el.find("button.media-control-button[data-hd-indicator]");
        this.resetIndicators();
        this.initializeIcons();
      }
    }, {
      key: "resetIndicators",
      value: function resetIndicators() {
        (this || _global).displayedPosition = (this || _global).$position.text();
        (this || _global).displayedDuration = (this || _global).$duration.text();
      }
    }, {
      key: "initializeIcons",
      value: function initializeIcons() {
        var $layer = (this || _global).$el.find(".media-control-layer");
        $layer.find("button.media-control-button[data-play]").append(playIcon);
        $layer.find("button.media-control-button[data-pause]").append(pauseIcon);
        $layer.find("button.media-control-button[data-stop]").append(stopIcon);
        (this || _global).$playPauseToggle.append(playIcon);
        (this || _global).$playStopToggle.append(playIcon);
        (this || _global).$volumeIcon.append(volumeIcon);
        (this || _global).$fullscreenToggle.append(fullscreenIcon);
        (this || _global).$hdIndicator.append(hdIcon);
      }
    }, {
      key: "setSeekPercentage",
      value: function setSeekPercentage(value) {
        value = Math.max(Math.min(value, 100), 0);
        // not changed since last update
        if ((this || _global).displayedSeekBarPercentage === value) return;
        (this || _global).displayedSeekBarPercentage = value;
        (this || _global).$seekBarPosition.removeClass("media-control-notransition");
        (this || _global).$seekBarScrubber.removeClass("media-control-notransition");
        (this || _global).$seekBarPosition.css({
          width: "".concat(value, "%")
        });
        (this || _global).$seekBarScrubber.css({
          left: "".concat(value, "%")
        });
      }
    }, {
      key: "seekRelative",
      value: function seekRelative(delta) {
        if (!(this || _global).settings.seekEnabled) return;
        var currentTime = (this || _global).container.getCurrentTime();
        var duration = (this || _global).container.getDuration();
        var position = Math.min(Math.max(currentTime + delta, 0), duration);
        position = Math.min(position * 100 / duration, 100);
        (this || _global).container.seekPercentage(position);
      }
    }, {
      key: "bindKeyAndShow",
      value: function bindKeyAndShow(key, callback) {
        var _this8 = this || _global;
        (this || _global).kibo.down(key, function () {
          _this8.show();
          return callback();
        });
      }
    }, {
      key: "bindKeyEvents",
      value: function bindKeyEvents() {
        var _this9 = this || _global;
        if (Browser.isMobile || (this || _global).options.disableKeyboardShortcuts) return;
        this.unbindKeyEvents();
        (this || _global).kibo = new Kibo((this || _global).options.focusElement || (this || _global).options.parentElement);
        this.bindKeyAndShow("space", function () {
          return _this9.togglePlayPause();
        });
        this.bindKeyAndShow("left", function () {
          return _this9.seekRelative(-5);
        });
        this.bindKeyAndShow("right", function () {
          return _this9.seekRelative(5);
        });
        this.bindKeyAndShow("shift left", function () {
          return _this9.seekRelative(-10);
        });
        this.bindKeyAndShow("shift right", function () {
          return _this9.seekRelative(10);
        });
        this.bindKeyAndShow("shift ctrl left", function () {
          return _this9.seekRelative(-15);
        });
        this.bindKeyAndShow("shift ctrl right", function () {
          return _this9.seekRelative(15);
        });
        var keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
        keys.forEach(function (i) {
          _this9.bindKeyAndShow(i, function () {
            _this9.settings.seekEnabled && _this9.container && _this9.container.seekPercentage(i * 10);
          });
        });
      }
    }, {
      key: "unbindKeyEvents",
      value: function unbindKeyEvents() {
        if ((this || _global).kibo) {
          (this || _global).kibo.off("space");
          (this || _global).kibo.off("left");
          (this || _global).kibo.off("right");
          (this || _global).kibo.off("shift left");
          (this || _global).kibo.off("shift right");
          (this || _global).kibo.off("shift ctrl left");
          (this || _global).kibo.off("shift ctrl right");
          (this || _global).kibo.off(["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]);
        }
      }
    }, {
      key: "parseColors",
      value: function parseColors() {
        if ((this || _global).options.mediacontrol) {
          (this || _global).buttonsColor = (this || _global).options.mediacontrol.buttons;
          var seekbarColor = (this || _global).options.mediacontrol.seekbar;
          (this || _global).$el.find(".bar-fill-2[data-seekbar]").css("background-color", seekbarColor);
          (this || _global).$el.find(".media-control-icon svg path").css("fill", (this || _global).buttonsColor);
          (this || _global).$el.find(".segmented-bar-element[data-volume]").css("boxShadow", "inset 2px 0 0 " + (this || _global).buttonsColor);
        }
      }
    }, {
      key: "applyButtonStyle",
      value: function applyButtonStyle(element) {
        (this || _global).buttonsColor && element && zepto(element).find("svg path").css("fill", (this || _global).buttonsColor);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        zepto(document).unbind("mouseup", (this || _global).stopDragHandler);
        zepto(document).unbind("mousemove", (this || _global).updateDragHandler);
        this.unbindKeyEvents();
        this.stopListening();
        _get$1(_getPrototypeOf$1(MediaControl.prototype), "destroy", this || _global).call(this || _global);
      }

      /**
       * enables to configure the media control after its creation
       * @method configure
       * @param {Object} options all the options to change in form of a javascript object
       */
    }, {
      key: "configure",
      value: function configure(options) {
        // Check if chromeless mode or if configure is called with new source(s)
        if ((this || _global).options.chromeless || options.source || options.sources) this.disable();else this.enable();
        this.trigger(Events.MEDIACONTROL_OPTIONS_CHANGE);
      }
    }, {
      key: "render",
      value: function render() {
        var _this10 = this || _global;
        var timeout = (this || _global).options.hideMediaControlDelay || 2000;
        (this || _global).settings && (this || _global).$el.html(this.template({
          settings: (this || _global).settings
        }));
        var style = Styler.getStyleFor(css_248z$4, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.append(style[0]);
        this.createCachedElements();
        (this || _global).$playPauseToggle.addClass("paused");
        (this || _global).$playStopToggle.addClass("stopped");
        this.changeTogglePlay();
        if ((this || _global).container) {
          (this || _global).hideId = setTimeout(function () {
            return _this10.hide();
          }, timeout);
          (this || _global).disabled && this.hide();
        }

        // Video volume cannot be changed with Safari on mobile devices
        // Display mute/unmute icon only if Safari version >= 10
        if (Browser.isSafari && Browser.isMobile) {
          if (Browser.version < 10) (this || _global).$volumeContainer.css("display", "none");else (this || _global).$volumeBarContainer.css("display", "none");
        }
        (this || _global).$seekBarPosition.addClass("media-control-notransition");
        (this || _global).$seekBarScrubber.addClass("media-control-notransition");
        var previousSeekPercentage = 0;
        if ((this || _global).displayedSeekBarPercentage) previousSeekPercentage = (this || _global).displayedSeekBarPercentage;
        (this || _global).displayedSeekBarPercentage = null;
        this.setSeekPercentage(previousSeekPercentage);
        setTimeout(function () {
          !_this10.settings.seekEnabled && _this10.$seekBarContainer.addClass("seek-disabled");
          !Browser.isMobile && !_this10.options.disableKeyboardShortcuts && _this10.bindKeyEvents();
          _this10.playerResize({
            width: _this10.options.width,
            height: _this10.options.height
          });
          _this10.hideVolumeBar(0);
        }, 0);
        this.parseColors();
        this.highDefinitionUpdate((this || _global).isHD);
        (this || _global).core.$el.append((this || _global).el);
        (this || _global).rendered = true;
        this.updateVolumeUI();
        this.trigger(Events.MEDIACONTROL_RENDERED);
        return this || _global;
      }
    }]);
    return MediaControl;
  }(UICorePlugin);
  MediaControl$1.extend = function (properties) {
    return extend(MediaControl$1, properties);
  };
  var posterHTML = "<div class=\"play-wrapper\" data-poster></div>\n";
  var css_248z$3 = ".player-poster[data-poster] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  z-index: 998;\n  top: 0;\n  left: 0;\n  background-color: transparent;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50% 50%; }\n  .player-poster[data-poster].clickable {\n    cursor: pointer; }\n  .player-poster[data-poster]:hover .play-wrapper[data-poster] {\n    opacity: 1; }\n  .player-poster[data-poster] .play-wrapper[data-poster] {\n    width: 100%;\n    height: 25%;\n    margin: 0 auto;\n    opacity: 0.75;\n    transition: opacity 0.1s ease; }\n    .player-poster[data-poster] .play-wrapper[data-poster] svg {\n      height: 100%; }\n      .player-poster[data-poster] .play-wrapper[data-poster] svg path {\n        fill: #fff; }\n";
  var PosterPlugin = /*#__PURE__*/function (_UIContainerPlugin) {
    _inherits$1(PosterPlugin, _UIContainerPlugin);
    var _super = _createSuper$1(PosterPlugin);
    function PosterPlugin(container) {
      var _this;
      _classCallCheck$1(this || _global, PosterPlugin);
      _this = _super.call(this || _global, container);
      _this.hasStartedPlaying = false;
      _this.playRequested = false;
      _this.render();
      setTimeout(function () {
        return _this.update();
      }, 0);
      return _this;
    }
    _createClass$1(PosterPlugin, [{
      key: "name",
      get: function get() {
        return "poster";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(posterHTML);
      }
    }, {
      key: "shouldRender",
      get: function get() {
        var showForNoOp = !!((this || _global).options.poster && (this || _global).options.poster.showForNoOp);
        return (this || _global).container.playback.name !== "html_img" && ((this || _global).container.playback.getPlaybackType() !== Playback.NO_OP || showForNoOp);
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "player-poster",
          "data-poster": ""
        };
      }
    }, {
      key: "events",
      get: function get() {
        return {
          "click": "clicked"
        };
      }
    }, {
      key: "showOnVideoEnd",
      get: function get() {
        return !(this || _global).options.poster || (this || _global).options.poster.showOnVideoEnd || (this || _global).options.poster.showOnVideoEnd === undefined;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).onStop);
        this.listenTo((this || _global).container, Events.CONTAINER_PLAY, (this || _global).onPlay);
        this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERING, (this || _global).update);
        this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERFULL, (this || _global).update);
        this.listenTo((this || _global).container, Events.CONTAINER_OPTIONS_CHANGE, (this || _global).render);
        this.listenTo((this || _global).container, Events.CONTAINER_ERROR, (this || _global).onError);
        (this || _global).showOnVideoEnd && this.listenTo((this || _global).container, Events.CONTAINER_ENDED, (this || _global).onStop);
      }
    }, {
      key: "onError",
      value: function onError(error) {
        (this || _global).hasFatalError = error.level === PlayerError.Levels.FATAL;
        if ((this || _global).hasFatalError) {
          (this || _global).hasStartedPlaying = false;
          (this || _global).playRequested = false;
          this.showPlayButton();
        }
      }
    }, {
      key: "onPlay",
      value: function onPlay() {
        (this || _global).hasStartedPlaying = true;
        this.update();
      }
    }, {
      key: "onStop",
      value: function onStop() {
        (this || _global).hasStartedPlaying = false;
        (this || _global).playRequested = false;
        this.update();
      }
    }, {
      key: "updatePlayButton",
      value: function updatePlayButton(show) {
        if (show && (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction)) this.showPlayButton();else this.hidePlayButton();
      }
    }, {
      key: "showPlayButton",
      value: function showPlayButton() {
        if ((this || _global).hasFatalError && !(this || _global).options.disableErrorScreen) return;
        (this || _global).$playButton.show();
        (this || _global).$el.addClass("clickable");
      }
    }, {
      key: "hidePlayButton",
      value: function hidePlayButton() {
        (this || _global).$playButton.hide();
        (this || _global).$el.removeClass("clickable");
      }
    }, {
      key: "clicked",
      value: function clicked() {
        // Let "click_to_pause" plugin handle click event if media has started playing
        if (!(this || _global).hasStartedPlaying) {
          if (!(this || _global).options.chromeless || (this || _global).options.allowUserInteraction) {
            (this || _global).playRequested = true;
            this.update();
            (this || _global).container.playback && ((this || _global).container.playback._consented = true);
            (this || _global).container.play();
          }
          return false;
        }
      }
    }, {
      key: "shouldHideOnPlay",
      value: function shouldHideOnPlay() {
        // Audio broadcasts should keep the poster up; video should hide poster while playing.
        return !(this || _global).container.playback.isAudioOnly;
      }
    }, {
      key: "update",
      value: function update() {
        if (!(this || _global).shouldRender) return;
        var showPlayButton = !(this || _global).playRequested && !(this || _global).hasStartedPlaying && !(this || _global).container.buffering;
        this.updatePlayButton(showPlayButton);
        this.updatePoster();
      }
    }, {
      key: "updatePoster",
      value: function updatePoster() {
        if (!(this || _global).hasStartedPlaying) this.showPoster();else this.hidePoster();
      }
    }, {
      key: "showPoster",
      value: function showPoster() {
        (this || _global).container.disableMediaControl();
        (this || _global).$el.show();
      }
    }, {
      key: "hidePoster",
      value: function hidePoster() {
        (this || _global).container.enableMediaControl();
        if (this.shouldHideOnPlay()) (this || _global).$el.hide();
      }
    }, {
      key: "render",
      value: function render() {
        if (!(this || _global).shouldRender) return;
        var style = Styler.getStyleFor(css_248z$3, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.html(this.template());
        (this || _global).$el.append(style[0]);
        var isRegularPoster = (this || _global).options.poster && (this || _global).options.poster.custom === undefined;
        if (isRegularPoster) {
          var posterUrl = (this || _global).options.poster.url || (this || _global).options.poster;
          (this || _global).$el.css({
            "background-image": "url(" + posterUrl + ")"
          });
          this.removeVideoElementPoster();
        } else if ((this || _global).options.poster) {
          (this || _global).$el.css({
            "background": (this || _global).options.poster.custom
          });
          this.removeVideoElementPoster();
        }
        (this || _global).container.$el.append((this || _global).el);
        (this || _global).$playWrapper = (this || _global).$el.find(".play-wrapper");
        (this || _global).$playWrapper.append(playIcon);
        (this || _global).$playButton = (this || _global).$playWrapper.find("svg");
        (this || _global).$playButton.addClass("poster-icon");
        (this || _global).$playButton.attr("data-poster", "");
        var buttonsColor = (this || _global).options.mediacontrol && (this || _global).options.mediacontrol.buttons;
        if (buttonsColor) (this || _global).$el.find("svg path").css("fill", buttonsColor);
        if ((this || _global).options.mediacontrol && (this || _global).options.mediacontrol.buttons) {
          buttonsColor = (this || _global).options.mediacontrol.buttons;
          (this || _global).$playButton.css("color", buttonsColor);
        }
        this.update();
        return this || _global;
      }
    }, {
      key: "removeVideoElementPoster",
      value: function removeVideoElementPoster() {
        (this || _global).container.playback && (this || _global).container.playback.$el && (this || _global).container.playback.$el[0] && (this || _global).container.playback.$el[0].removeAttribute && (this || _global).container.playback.$el[0].removeAttribute("poster");
      }
    }]);
    return PosterPlugin;
  }(UIContainerPlugin);
  var seekTimeHTML = "<span data-seek-time></span>\n<span data-duration></span>\n";
  var css_248z$2 = ".seek-time[data-seek-time] {\n  position: absolute;\n  white-space: nowrap;\n  height: 20px;\n  line-height: 20px;\n  font-size: 0;\n  left: -100%;\n  bottom: 55px;\n  background-color: rgba(2, 2, 2, 0.5);\n  z-index: 9999;\n  transition: opacity 0.1s ease; }\n  .seek-time[data-seek-time].hidden[data-seek-time] {\n    opacity: 0; }\n  .seek-time[data-seek-time] [data-seek-time] {\n    display: inline-block;\n    color: white;\n    font-size: 10px;\n    padding-left: 7px;\n    padding-right: 7px;\n    vertical-align: top; }\n  .seek-time[data-seek-time] [data-duration] {\n    display: inline-block;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 10px;\n    padding-right: 7px;\n    vertical-align: top; }\n    .seek-time[data-seek-time] [data-duration]:before {\n      content: \"|\";\n      margin-right: 7px; }\n";
  var formatTime = Utils.formatTime;
  var SeekTime$1 = /*#__PURE__*/function (_UICorePlugin) {
    _inherits$1(SeekTime, _UICorePlugin);
    var _super = _createSuper$1(SeekTime);
    function SeekTime(core) {
      var _this;
      _classCallCheck$1(this || _global, SeekTime);
      _this = _super.call(this || _global, core);
      _this.hoveringOverSeekBar = false;
      _this.hoverPosition = null;
      _this.duration = null;
      _this.firstFragDateTime = null;
      _this.actualLiveTime = !!_this.mediaControl.options.actualLiveTime;
      if (_this.actualLiveTime) {
        if (_this.mediaControl.options.actualLiveServerTime) _this.actualLiveServerTimeDiff = new Date().getTime() - new Date(_this.mediaControl.options.actualLiveServerTime).getTime();else _this.actualLiveServerTimeDiff = 0;
      }
      return _this;
    }
    _createClass$1(SeekTime, [{
      key: "name",
      get: function get() {
        return "seek_time";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(seekTimeHTML);
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "class": "seek-time",
          "data-seek-time": ""
        };
      }
    }, {
      key: "mediaControl",
      get: function get() {
        return (this || _global).core.mediaControl;
      }
    }, {
      key: "mediaControlContainer",
      get: function get() {
        return (this || _global).mediaControl.container;
      }
    }, {
      key: "isLiveStreamWithDvr",
      get: function get() {
        return (this || _global).mediaControlContainer && (this || _global).mediaControlContainer.getPlaybackType() === Playback.LIVE && (this || _global).mediaControlContainer.isDvrEnabled();
      }
    }, {
      key: "durationShown",
      get: function get() {
        return (this || _global).isLiveStreamWithDvr && !(this || _global).actualLiveTime;
      }
    }, {
      key: "useActualLiveTime",
      get: function get() {
        return (this || _global).actualLiveTime && (this || _global).isLiveStreamWithDvr;
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).mediaControl, Events.MEDIACONTROL_RENDERED, (this || _global).render);
        this.listenTo((this || _global).mediaControl, Events.MEDIACONTROL_MOUSEMOVE_SEEKBAR, (this || _global).showTime);
        this.listenTo((this || _global).mediaControl, Events.MEDIACONTROL_MOUSELEAVE_SEEKBAR, (this || _global).hideTime);
        this.listenTo((this || _global).mediaControl, Events.MEDIACONTROL_CONTAINERCHANGED, (this || _global).onContainerChanged);
        if ((this || _global).mediaControlContainer) {
          this.listenTo((this || _global).mediaControlContainer, Events.CONTAINER_PLAYBACKDVRSTATECHANGED, (this || _global).update);
          this.listenTo((this || _global).mediaControlContainer, Events.CONTAINER_TIMEUPDATE, (this || _global).updateDuration);
        }
      }
    }, {
      key: "onContainerChanged",
      value: function onContainerChanged() {
        this.stopListening();
        this.bindEvents();
      }
    }, {
      key: "updateDuration",
      value: function updateDuration(timeProgress) {
        (this || _global).duration = timeProgress.total;
        (this || _global).firstFragDateTime = timeProgress.firstFragDateTime;
        this.update();
      }
    }, {
      key: "showTime",
      value: function showTime(event) {
        (this || _global).hoveringOverSeekBar = true;
        this.calculateHoverPosition(event);
        this.update();
      }
    }, {
      key: "hideTime",
      value: function hideTime() {
        (this || _global).hoveringOverSeekBar = false;
        this.update();
      }
    }, {
      key: "calculateHoverPosition",
      value: function calculateHoverPosition(event) {
        var offset = event.pageX - (this || _global).mediaControl.$seekBarContainer.offset().left;
        // proportion into the seek bar that the mouse is hovered over 0-1
        (this || _global).hoverPosition = Math.min(1, Math.max(offset / (this || _global).mediaControl.$seekBarContainer.width(), 0));
      }
    }, {
      key: "getSeekTime",
      value: function getSeekTime() {
        var seekTime, secondsSinceMidnight, d, e;
        if ((this || _global).useActualLiveTime) {
          if ((this || _global).firstFragDateTime) {
            e = new Date((this || _global).firstFragDateTime);
            d = new Date((this || _global).firstFragDateTime);
            d.setHours(0, 0, 0, 0);
            secondsSinceMidnight = (e.getTime() - d.getTime()) / 1000 + (this || _global).duration;
          } else {
            d = new Date(new Date().getTime() - (this || _global).actualLiveServerTimeDiff);
            e = new Date(d);
            secondsSinceMidnight = (e - d.setHours(0, 0, 0, 0)) / 1000;
          }
          seekTime = secondsSinceMidnight - (this || _global).duration + (this || _global).hoverPosition * (this || _global).duration;
          if (seekTime < 0) seekTime += 86400;
        } else {
          seekTime = (this || _global).hoverPosition * (this || _global).duration;
        }
        return {
          seekTime: seekTime,
          secondsSinceMidnight: secondsSinceMidnight
        };
      }
    }, {
      key: "update",
      value: function update() {
        if (!(this || _global).rendered) {
          // update() is always called after a render
          return;
        }
        if (!this.shouldBeVisible()) {
          (this || _global).$el.hide();
          (this || _global).$el.css("left", "-100%");
        } else {
          var seekTime = this.getSeekTime();
          var currentSeekTime = formatTime(seekTime.seekTime, (this || _global).useActualLiveTime);
          // only update dom if necessary, ie time actually changed
          if (currentSeekTime !== (this || _global).displayedSeekTime) {
            (this || _global).$seekTimeEl.text(currentSeekTime);
            (this || _global).displayedSeekTime = currentSeekTime;
          }
          if ((this || _global).durationShown) {
            (this || _global).$durationEl.show();
            var currentDuration = formatTime((this || _global).actualLiveTime ? seekTime.secondsSinceMidnight : (this || _global).duration, (this || _global).actualLiveTime);
            if (currentDuration !== (this || _global).displayedDuration) {
              (this || _global).$durationEl.text(currentDuration);
              (this || _global).displayedDuration = currentDuration;
            }
          } else {
            (this || _global).$durationEl.hide();
          }

          // the element must be unhidden before its width is requested, otherwise it's width will be reported as 0
          (this || _global).$el.show();
          var containerWidth = (this || _global).mediaControl.$seekBarContainer.width();
          var elWidth = (this || _global).$el.width();
          var elLeftPos = (this || _global).hoverPosition * containerWidth;
          elLeftPos -= elWidth / 2;
          elLeftPos = Math.max(0, Math.min(elLeftPos, containerWidth - elWidth));
          (this || _global).$el.css("left", elLeftPos);
        }
      }
    }, {
      key: "shouldBeVisible",
      value: function shouldBeVisible() {
        return (this || _global).mediaControlContainer && (this || _global).mediaControlContainer.settings.seekEnabled && (this || _global).hoveringOverSeekBar && (this || _global).hoverPosition !== null && (this || _global).duration !== null;
      }
    }, {
      key: "render",
      value: function render() {
        var style = Styler.getStyleFor(css_248z$2, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).rendered = true;
        (this || _global).displayedDuration = null;
        (this || _global).displayedSeekTime = null;
        (this || _global).$el.html(this.template());
        (this || _global).$el.append(style[0]);
        (this || _global).$el.hide();
        (this || _global).mediaControl.$el.append((this || _global).el);
        (this || _global).$seekTimeEl = (this || _global).$el.find("[data-seek-time]");
        (this || _global).$durationEl = (this || _global).$el.find("[data-duration]");
        (this || _global).$durationEl.hide();
        this.update();
      }
    }]);
    return SeekTime;
  }(UICorePlugin);
  var spinnerHTML = "<div data-bounce1></div><div data-bounce2></div><div data-bounce3></div>\n";
  var css_248z$1 = ".spinner-three-bounce[data-spinner] {\n  position: absolute;\n  margin: 0 auto;\n  width: 70px;\n  text-align: center;\n  z-index: 999;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  /* center vertically */\n  top: 50%;\n  transform: translateY(-50%); }\n  .spinner-three-bounce[data-spinner] > div {\n    width: 18px;\n    height: 18px;\n    background-color: #FFFFFF;\n    border-radius: 100%;\n    display: inline-block;\n    animation: bouncedelay 1.4s infinite ease-in-out;\n    /* Prevent first frame from flickering when animation starts */\n    animation-fill-mode: both; }\n  .spinner-three-bounce[data-spinner] [data-bounce1] {\n    animation-delay: -0.32s; }\n  .spinner-three-bounce[data-spinner] [data-bounce2] {\n    animation-delay: -0.16s; }\n\n@keyframes bouncedelay {\n  0%, 80%, 100% {\n    transform: scale(0); }\n  40% {\n    transform: scale(1); } }\n";
  var SpinnerThreeBouncePlugin = /*#__PURE__*/function (_UIContainerPlugin) {
    _inherits$1(SpinnerThreeBouncePlugin, _UIContainerPlugin);
    var _super = _createSuper$1(SpinnerThreeBouncePlugin);
    function SpinnerThreeBouncePlugin(container) {
      var _this;
      _classCallCheck$1(this || _global, SpinnerThreeBouncePlugin);
      _this = _super.call(this || _global, container);
      _this.template = tmpl(spinnerHTML);
      _this.showTimeout = null;
      _this.listenTo(_this.container, Events.CONTAINER_STATE_BUFFERING, _this.onBuffering);
      _this.listenTo(_this.container, Events.CONTAINER_STATE_BUFFERFULL, _this.onBufferFull);
      _this.listenTo(_this.container, Events.CONTAINER_STOP, _this.onStop);
      _this.listenTo(_this.container, Events.CONTAINER_ENDED, _this.onStop);
      _this.listenTo(_this.container, Events.CONTAINER_ERROR, _this.onStop);
      _this.render();
      return _this;
    }
    _createClass$1(SpinnerThreeBouncePlugin, [{
      key: "name",
      get: function get() {
        return "spinner";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "attributes",
      get: function get() {
        return {
          "data-spinner": "",
          "class": "spinner-three-bounce"
        };
      }
    }, {
      key: "onBuffering",
      value: function onBuffering() {
        this.show();
      }
    }, {
      key: "onBufferFull",
      value: function onBufferFull() {
        this.hide();
      }
    }, {
      key: "onStop",
      value: function onStop() {
        this.hide();
      }
    }, {
      key: "show",
      value: function show() {
        var _this2 = this || _global;
        if ((this || _global).showTimeout === null) (this || _global).showTimeout = setTimeout(function () {
          return _this2.$el.show();
        }, 300);
      }
    }, {
      key: "hide",
      value: function hide() {
        if ((this || _global).showTimeout !== null) {
          clearTimeout((this || _global).showTimeout);
          (this || _global).showTimeout = null;
        }
        (this || _global).$el.hide();
      }
    }, {
      key: "render",
      value: function render() {
        var style = Styler.getStyleFor(css_248z$1, {
          baseUrl: (this || _global).options.baseUrl
        });
        (this || _global).$el.html(this.template());
        (this || _global).$el.append(style[0]);
        (this || _global).container.$el.append((this || _global).$el);
        (this || _global).$el.hide();
        if ((this || _global).container.buffering) this.onBuffering();
        return this || _global;
      }
    }]);
    return SpinnerThreeBouncePlugin;
  }(UIContainerPlugin);
  var StatsPlugin = /*#__PURE__*/function (_ContainerPlugin) {
    _inherits$1(StatsPlugin, _ContainerPlugin);
    var _super = _createSuper$1(StatsPlugin);
    function StatsPlugin(container) {
      var _this;
      _classCallCheck$1(this || _global, StatsPlugin);
      _this = _super.call(this || _global, container);
      _this.setInitialAttrs();
      _this.reportInterval = _this.options.reportInterval || 5000;
      _this.state = "IDLE";
      return _this;
    }
    _createClass$1(StatsPlugin, [{
      key: "name",
      get: function get() {
        return "stats";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).container.playback, Events.PLAYBACK_PLAY, (this || _global).onPlay);
        this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).onStop);
        this.listenTo((this || _global).container, Events.CONTAINER_ENDED, (this || _global).onStop);
        this.listenTo((this || _global).container, Events.CONTAINER_DESTROYED, (this || _global).onStop);
        this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERING, (this || _global).onBuffering);
        this.listenTo((this || _global).container, Events.CONTAINER_STATE_BUFFERFULL, (this || _global).onBufferFull);
        this.listenTo((this || _global).container, Events.CONTAINER_STATS_ADD, (this || _global).onStatsAdd);
        this.listenTo((this || _global).container, Events.CONTAINER_BITRATE, (this || _global).onStatsAdd);
        this.listenTo((this || _global).container.playback, Events.PLAYBACK_STATS_ADD, (this || _global).onStatsAdd);
      }
    }, {
      key: "setInitialAttrs",
      value: function setInitialAttrs() {
        (this || _global).firstPlay = true;
        (this || _global).startupTime = 0;
        (this || _global).rebufferingTime = 0;
        (this || _global).watchingTime = 0;
        (this || _global).rebuffers = 0;
        (this || _global).externalMetrics = {};
      }
    }, {
      key: "onPlay",
      value: function onPlay() {
        (this || _global).state = "PLAYING";
        (this || _global).watchingTimeInit = Date.now();
        if (!(this || _global).intervalId) (this || _global).intervalId = setInterval((this || _global).report.bind(this || _global), (this || _global).reportInterval);
      }
    }, {
      key: "onStop",
      value: function onStop() {
        clearInterval((this || _global).intervalId);
        this.report();
        (this || _global).intervalId = undefined;
        (this || _global).state = "STOPPED";
      }
    }, {
      key: "onBuffering",
      value: function onBuffering() {
        if ((this || _global).firstPlay) (this || _global).startupTimeInit = Date.now();else (this || _global).rebufferingTimeInit = Date.now();
        (this || _global).state = "BUFFERING";
        (this || _global).rebuffers++;
      }
    }, {
      key: "onBufferFull",
      value: function onBufferFull() {
        if ((this || _global).firstPlay && (this || _global).startupTimeInit) {
          (this || _global).firstPlay = false;
          (this || _global).startupTime = Date.now() - (this || _global).startupTimeInit;
          (this || _global).watchingTimeInit = Date.now();
        } else if ((this || _global).rebufferingTimeInit) {
          (this || _global).rebufferingTime += this.getRebufferingTime();
        }
        (this || _global).rebufferingTimeInit = undefined;
        (this || _global).state = "PLAYING";
      }
    }, {
      key: "getRebufferingTime",
      value: function getRebufferingTime() {
        return Date.now() - (this || _global).rebufferingTimeInit;
      }
    }, {
      key: "getWatchingTime",
      value: function getWatchingTime() {
        var totalTime = Date.now() - (this || _global).watchingTimeInit;
        return totalTime - (this || _global).rebufferingTime;
      }
    }, {
      key: "isRebuffering",
      value: function isRebuffering() {
        return !!(this || _global).rebufferingTimeInit;
      }
    }, {
      key: "onStatsAdd",
      value: function onStatsAdd(metric) {
        zepto.extend((this || _global).externalMetrics, metric);
      }
    }, {
      key: "getStats",
      value: function getStats() {
        var metrics = {
          startupTime: (this || _global).startupTime,
          rebuffers: (this || _global).rebuffers,
          rebufferingTime: this.isRebuffering() ? (this || _global).rebufferingTime + this.getRebufferingTime() : (this || _global).rebufferingTime,
          watchingTime: this.isRebuffering() ? this.getWatchingTime() - this.getRebufferingTime() : this.getWatchingTime()
        };
        zepto.extend(metrics, (this || _global).externalMetrics);
        return metrics;
      }
    }, {
      key: "report",
      value: function report() {
        (this || _global).container.statsReport(this.getStats());
      }
    }]);
    return StatsPlugin;
  }(ContainerPlugin);
  var watermarkHTML = "<div class=\"clappr-watermark\" data-watermark data-watermark-<%=position %>>\n<% if(typeof imageLink !== 'undefined') { %>\n<a target=\"_blank\" href=\"<%= imageLink %>\">\n<% } %>\n<img src=\"<%= imageUrl %>\">\n<% if(typeof imageLink !== 'undefined') { %>\n</a>\n<% } %>\n</div>\n";
  var css_248z = ".clappr-watermark[data-watermark] {\n  position: absolute;\n  min-width: 70px;\n  max-width: 200px;\n  width: 12%;\n  text-align: center;\n  z-index: 10; }\n\n.clappr-watermark[data-watermark] a {\n  outline: none;\n  cursor: pointer; }\n\n.clappr-watermark[data-watermark] img {\n  max-width: 100%; }\n\n.clappr-watermark[data-watermark-bottom-left] {\n  bottom: 10px;\n  left: 10px; }\n\n.clappr-watermark[data-watermark-bottom-right] {\n  bottom: 10px;\n  right: 42px; }\n\n.clappr-watermark[data-watermark-top-left] {\n  top: 10px;\n  left: 10px; }\n\n.clappr-watermark[data-watermark-top-right] {\n  top: 10px;\n  right: 37px; }\n";
  var WaterMarkPlugin = /*#__PURE__*/function (_UIContainerPlugin) {
    _inherits$1(WaterMarkPlugin, _UIContainerPlugin);
    var _super = _createSuper$1(WaterMarkPlugin);
    function WaterMarkPlugin(container) {
      var _this;
      _classCallCheck$1(this || _global, WaterMarkPlugin);
      _this = _super.call(this || _global, container);
      _this.configure();
      return _this;
    }
    _createClass$1(WaterMarkPlugin, [{
      key: "name",
      get: function get() {
        return "watermark";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "template",
      get: function get() {
        return tmpl(watermarkHTML);
      }
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        this.listenTo((this || _global).container, Events.CONTAINER_PLAY, (this || _global).onPlay);
        this.listenTo((this || _global).container, Events.CONTAINER_STOP, (this || _global).onStop);
        this.listenTo((this || _global).container, Events.CONTAINER_OPTIONS_CHANGE, (this || _global).configure);
      }
    }, {
      key: "configure",
      value: function configure() {
        (this || _global).position = (this || _global).options.position || "bottom-right";
        if ((this || _global).options.watermark) {
          (this || _global).imageUrl = (this || _global).options.watermark;
          (this || _global).imageLink = (this || _global).options.watermarkLink;
          this.render();
        } else {
          (this || _global).$el.remove();
        }
      }
    }, {
      key: "onPlay",
      value: function onPlay() {
        if (!(this || _global).hidden) (this || _global).$el.show();
      }
    }, {
      key: "onStop",
      value: function onStop() {
        (this || _global).$el.hide();
      }
    }, {
      key: "render",
      value: function render() {
        (this || _global).$el.hide();
        var style = Styler.getStyleFor(css_248z, {
          baseUrl: (this || _global).options.baseUrl
        });
        var templateOptions = {
          position: (this || _global).position,
          imageUrl: (this || _global).imageUrl,
          imageLink: (this || _global).imageLink
        };
        (this || _global).$el.html(this.template(templateOptions));
        (this || _global).$el.append(style[0]);
        (this || _global).container.$el.append((this || _global).$el);
        return this || _global;
      }
    }]);
    return WaterMarkPlugin;
  }(UIContainerPlugin);
  var Plugins = {
    ClickToPause: ClickToPausePlugin,
    ClosedCaptions: ClosedCaptions$1,
    DVRControls: DVRControls$1,
    EndVideo: EndVideo$1,
    ErrorScreen: ErrorScreen$1,
    Favicon: Favicon$1,
    GoogleAnalytics: GoogleAnalytics$1,
    MediaControl: MediaControl$1,
    Poster: PosterPlugin,
    SeekTime: SeekTime$1,
    SpinnerThreeBounce: SpinnerThreeBouncePlugin,
    Stats: StatsPlugin,
    WaterMark: WaterMarkPlugin
  };
  var version = "0.5.0";
  for (var _i = 0, _Object$values = Object.values(Plugins); _i < _Object$values.length; _i++) {
    var plugin = _Object$values[_i];
    Loader.registerPlugin(plugin);
  }

  // TODO: remove on 0.5.x (backward-compatibility only)
  var ClickToPause = Plugins.ClickToPause,
    ClosedCaptions = Plugins.ClosedCaptions,
    DVRControls = Plugins.DVRControls,
    EndVideo = Plugins.EndVideo,
    ErrorScreen = Plugins.ErrorScreen,
    Favicon = Plugins.Favicon,
    GoogleAnalytics = Plugins.GoogleAnalytics,
    MediaControl = Plugins.MediaControl,
    Poster = Plugins.Poster,
    SeekTime = Plugins.SeekTime,
    SpinnerThreeBounce = Plugins.SpinnerThreeBounce,
    Stats = Plugins.Stats,
    WaterMark = Plugins.WaterMark;
  var BaseExports = _objectSpread2$2(_objectSpread2$2({}, main$1), {}, {
    ClickToPause: ClickToPause,
    ClosedCaptions: ClosedCaptions,
    DVRControls: DVRControls,
    EndVideo: EndVideo,
    ErrorScreen: ErrorScreen,
    Favicon: Favicon,
    GoogleAnalytics: GoogleAnalytics,
    MediaControl: MediaControl,
    Poster: Poster,
    SeekTime: SeekTime,
    SpinnerThreeBounce: SpinnerThreeBounce,
    Stats: Stats,
    WaterMark: WaterMark,
    Vendor: index,
    Plugins: Plugins,
    version: version
  });
  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this || _global).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this || _global, arguments);
      }
      return _possibleConstructorReturn(this || _global, result);
    };
  }
  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }
    return object;
  }
  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get.bind();
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }
        return desc.value;
      };
    }
    return _get.apply(this || _global, arguments);
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof _global !== "undefined" ? _global : typeof self !== "undefined" ? self : {};
  function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
  }
  var hls = {
    exports: {}
  };
  (function (module, exports) {
    typeof window !== "undefined" && function webpackUniversalModuleDefinition(root, factory) {
      module.exports = factory();
    }(commonjsGlobal, () => {
      return (/******/(() => {
          // webpackBootstrap
          /******/
          var __webpack_modules__ = {
            /***/"./src/config.ts":
            /*!***********************!*\
              !*** ./src/config.ts ***!
              \***********************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"enableStreamingMode": () => /* binding */enableStreamingMode,
                /* harmony export */"hlsDefaultConfig": () => /* binding */hlsDefaultConfig,
                /* harmony export */"mergeConfig": () => /* binding */mergeConfig
                /* harmony export */
              });
              /* harmony import */
              var _controller_abr_controller__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./controller/abr-controller */"./src/controller/abr-controller.ts");
              /* harmony import */
              var _controller_audio_stream_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./controller/audio-stream-controller */"./src/controller/audio-stream-controller.ts");
              /* harmony import */
              var _controller_audio_track_controller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./controller/audio-track-controller */"./src/controller/audio-track-controller.ts");
              /* harmony import */
              var _controller_subtitle_stream_controller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./controller/subtitle-stream-controller */"./src/controller/subtitle-stream-controller.ts");
              /* harmony import */
              var _controller_subtitle_track_controller__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./controller/subtitle-track-controller */"./src/controller/subtitle-track-controller.ts");
              /* harmony import */
              var _controller_buffer_controller__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./controller/buffer-controller */"./src/controller/buffer-controller.ts");
              /* harmony import */
              var _controller_timeline_controller__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ./controller/timeline-controller */"./src/controller/timeline-controller.ts");
              /* harmony import */
              var _controller_cap_level_controller__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ./controller/cap-level-controller */"./src/controller/cap-level-controller.ts");
              /* harmony import */
              var _controller_fps_controller__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ./controller/fps-controller */"./src/controller/fps-controller.ts");
              /* harmony import */
              var _controller_eme_controller__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ./controller/eme-controller */"./src/controller/eme-controller.ts");
              /* harmony import */
              var _controller_cmcd_controller__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__( /*! ./controller/cmcd-controller */"./src/controller/cmcd-controller.ts");
              /* harmony import */
              var _utils_xhr_loader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__( /*! ./utils/xhr-loader */"./src/utils/xhr-loader.ts");
              /* harmony import */
              var _utils_fetch_loader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__( /*! ./utils/fetch-loader */"./src/utils/fetch-loader.ts");
              /* harmony import */
              var _utils_cues__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__( /*! ./utils/cues */"./src/utils/cues.ts");
              /* harmony import */
              var _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__( /*! ./utils/mediakeys-helper */"./src/utils/mediakeys-helper.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__( /*! ./utils/logger */"./src/utils/logger.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                  var symbols = Object.getOwnPropertySymbols(object);
                  enumerableOnly && (symbols = symbols.filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                  })), keys.push.apply(keys, symbols);
                }
                return keys;
              }
              function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                  var source = null != arguments[i] ? arguments[i] : {};
                  i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
                    _defineProperty(target, key, source[key]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                  });
                }
                return target;
              }
              function _defineProperty(obj, key, value) {
                if (key in obj) {
                  Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                  });
                } else {
                  obj[key] = value;
                }
                return obj;
              }

              // If possible, keep hlsDefaultConfig shallow
              // It is cloned whenever a new Hls instance is created, by keeping the config
              // shallow the properties are cloned, and we don't end up manipulating the default
              var hlsDefaultConfig = _objectSpread(_objectSpread({
                autoStartLoad: true,
                // used by stream-controller
                startPosition: -1,
                // used by stream-controller
                defaultAudioCodec: undefined,
                // used by stream-controller
                debug: false,
                // used by logger
                capLevelOnFPSDrop: false,
                // used by fps-controller
                capLevelToPlayerSize: false,
                // used by cap-level-controller
                ignoreDevicePixelRatio: false,
                // used by cap-level-controller
                initialLiveManifestSize: 1,
                // used by stream-controller
                maxBufferLength: 30,
                // used by stream-controller
                backBufferLength: Infinity,
                // used by buffer-controller
                maxBufferSize: 60 * 1000 * 1000,
                // used by stream-controller
                maxBufferHole: 0.1,
                // used by stream-controller
                highBufferWatchdogPeriod: 2,
                // used by stream-controller
                nudgeOffset: 0.1,
                // used by stream-controller
                nudgeMaxRetry: 3,
                // used by stream-controller
                maxFragLookUpTolerance: 0.25,
                // used by stream-controller
                liveSyncDurationCount: 3,
                // used by latency-controller
                liveMaxLatencyDurationCount: Infinity,
                // used by latency-controller
                liveSyncDuration: undefined,
                // used by latency-controller
                liveMaxLatencyDuration: undefined,
                // used by latency-controller
                maxLiveSyncPlaybackRate: 1,
                // used by latency-controller
                liveDurationInfinity: false,
                // used by buffer-controller
                liveBackBufferLength: null,
                // used by buffer-controller
                maxMaxBufferLength: 600,
                // used by stream-controller
                enableWorker: true,
                // used by demuxer
                enableSoftwareAES: true,
                // used by decrypter
                manifestLoadingTimeOut: 10000,
                // used by playlist-loader
                manifestLoadingMaxRetry: 1,
                // used by playlist-loader
                manifestLoadingRetryDelay: 1000,
                // used by playlist-loader
                manifestLoadingMaxRetryTimeout: 64000,
                // used by playlist-loader
                startLevel: undefined,
                // used by level-controller
                levelLoadingTimeOut: 10000,
                // used by playlist-loader
                levelLoadingMaxRetry: 4,
                // used by playlist-loader
                levelLoadingRetryDelay: 1000,
                // used by playlist-loader
                levelLoadingMaxRetryTimeout: 64000,
                // used by playlist-loader
                fragLoadingTimeOut: 20000,
                // used by fragment-loader
                fragLoadingMaxRetry: 6,
                // used by fragment-loader
                fragLoadingRetryDelay: 1000,
                // used by fragment-loader
                fragLoadingMaxRetryTimeout: 64000,
                // used by fragment-loader
                startFragPrefetch: false,
                // used by stream-controller
                fpsDroppedMonitoringPeriod: 5000,
                // used by fps-controller
                fpsDroppedMonitoringThreshold: 0.2,
                // used by fps-controller
                appendErrorMaxRetry: 3,
                // used by buffer-controller
                loader: _utils_xhr_loader__WEBPACK_IMPORTED_MODULE_11__["default"],
                // loader: FetchLoader,
                fLoader: undefined,
                // used by fragment-loader
                pLoader: undefined,
                // used by playlist-loader
                xhrSetup: undefined,
                // used by xhr-loader
                licenseXhrSetup: undefined,
                // used by eme-controller
                licenseResponseCallback: undefined,
                // used by eme-controller
                abrController: _controller_abr_controller__WEBPACK_IMPORTED_MODULE_0__["default"],
                bufferController: _controller_buffer_controller__WEBPACK_IMPORTED_MODULE_5__["default"],
                capLevelController: _controller_cap_level_controller__WEBPACK_IMPORTED_MODULE_7__["default"],
                fpsController: _controller_fps_controller__WEBPACK_IMPORTED_MODULE_8__["default"],
                stretchShortVideoTrack: false,
                // used by mp4-remuxer
                maxAudioFramesDrift: 1,
                // used by mp4-remuxer
                forceKeyFrameOnDiscontinuity: true,
                // used by ts-demuxer
                abrEwmaFastLive: 3,
                // used by abr-controller
                abrEwmaSlowLive: 9,
                // used by abr-controller
                abrEwmaFastVoD: 3,
                // used by abr-controller
                abrEwmaSlowVoD: 9,
                // used by abr-controller
                abrEwmaDefaultEstimate: 500000,
                // 500 kbps  // used by abr-controller
                abrBandWidthFactor: 0.95,
                // used by abr-controller
                abrBandWidthUpFactor: 0.7,
                // used by abr-controller
                abrMaxWithRealBitrate: false,
                // used by abr-controller
                maxStarvationDelay: 4,
                // used by abr-controller
                maxLoadingDelay: 4,
                // used by abr-controller
                minAutoBitrate: 0,
                // used by hls
                emeEnabled: false,
                // used by eme-controller
                widevineLicenseUrl: undefined,
                // used by eme-controller
                drmSystemOptions: {},
                // used by eme-controller
                requestMediaKeySystemAccessFunc: _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_14__.requestMediaKeySystemAccess,
                // used by eme-controller
                testBandwidth: true,
                progressive: false,
                lowLatencyMode: true,
                cmcd: undefined,
                enableDateRangeMetadataCues: true,
                enableEmsgMetadataCues: true,
                enableID3MetadataCues: true
              }, timelineConfig()), {}, {
                subtitleStreamController: _controller_subtitle_stream_controller__WEBPACK_IMPORTED_MODULE_3__.SubtitleStreamController,
                subtitleTrackController: _controller_subtitle_track_controller__WEBPACK_IMPORTED_MODULE_4__["default"],
                timelineController: _controller_timeline_controller__WEBPACK_IMPORTED_MODULE_6__.TimelineController,
                audioStreamController: _controller_audio_stream_controller__WEBPACK_IMPORTED_MODULE_1__["default"],
                audioTrackController: _controller_audio_track_controller__WEBPACK_IMPORTED_MODULE_2__["default"],
                emeController: _controller_eme_controller__WEBPACK_IMPORTED_MODULE_9__["default"],
                cmcdController: _controller_cmcd_controller__WEBPACK_IMPORTED_MODULE_10__["default"]
              });
              function timelineConfig() {
                return {
                  cueHandler: _utils_cues__WEBPACK_IMPORTED_MODULE_13__["default"],
                  // used by timeline-controller
                  enableWebVTT: true,
                  // used by timeline-controller
                  enableIMSC1: true,
                  // used by timeline-controller
                  enableCEA708Captions: true,
                  // used by timeline-controller
                  captionsTextTrack1Label: "English",
                  // used by timeline-controller
                  captionsTextTrack1LanguageCode: "en",
                  // used by timeline-controller
                  captionsTextTrack2Label: "Spanish",
                  // used by timeline-controller
                  captionsTextTrack2LanguageCode: "es",
                  // used by timeline-controller
                  captionsTextTrack3Label: "Unknown CC",
                  // used by timeline-controller
                  captionsTextTrack3LanguageCode: "",
                  // used by timeline-controller
                  captionsTextTrack4Label: "Unknown CC",
                  // used by timeline-controller
                  captionsTextTrack4LanguageCode: "",
                  // used by timeline-controller
                  renderTextTracksNatively: true
                };
              }
              function mergeConfig(defaultConfig, userConfig) {
                if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) {
                  throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
                }
                if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) {
                  throw new Error("Illegal hls.js config: \"liveMaxLatencyDurationCount\" must be greater than \"liveSyncDurationCount\"");
                }
                if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) {
                  throw new Error("Illegal hls.js config: \"liveMaxLatencyDuration\" must be greater than \"liveSyncDuration\"");
                }
                return _extends({}, defaultConfig, userConfig);
              }
              function enableStreamingMode(config) {
                var currentLoader = config.loader;
                if (currentLoader !== _utils_fetch_loader__WEBPACK_IMPORTED_MODULE_12__["default"] && currentLoader !== _utils_xhr_loader__WEBPACK_IMPORTED_MODULE_11__["default"]) {
                  // If a developer has configured their own loader, respect that choice
                  _utils_logger__WEBPACK_IMPORTED_MODULE_15__.logger.log("[config]: Custom loader detected, cannot enable progressive streaming");
                  config.progressive = false;
                } else {
                  var canStreamProgressively = (0, _utils_fetch_loader__WEBPACK_IMPORTED_MODULE_12__.fetchSupported)();
                  if (canStreamProgressively) {
                    config.loader = _utils_fetch_loader__WEBPACK_IMPORTED_MODULE_12__["default"];
                    config.progressive = true;
                    config.enableSoftwareAES = true;
                    _utils_logger__WEBPACK_IMPORTED_MODULE_15__.logger.log("[config]: Progressive streaming enabled, using FetchLoader");
                  }
                }
              }

              /***/
            },

            /***/"./src/controller/abr-controller.ts":
            /*!******************************************!*\
              !*** ./src/controller/abr-controller.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _utils_ewma_bandwidth_estimator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/ewma-bandwidth-estimator */"./src/utils/ewma-bandwidth-estimator.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var AbrController = /*#__PURE__*/function () {
                function AbrController(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).lastLoadedFragLevel = 0;
                  (this || _global)._nextAutoLevel = -1;
                  (this || _global).timer = void 0;
                  (this || _global).onCheck = (this || _global)._abandonRulesCheck.bind(this || _global);
                  (this || _global).fragCurrent = null;
                  (this || _global).partCurrent = null;
                  (this || _global).bitrateTestDelay = 0;
                  (this || _global).bwEstimator = void 0;
                  (this || _global).hls = hls;
                  var config = hls.config;
                  (this || _global).bwEstimator = new _utils_ewma_bandwidth_estimator__WEBPACK_IMPORTED_MODULE_1__["default"](config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
                  this.registerListeners();
                }
                var _proto = AbrController.prototype;
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_LOADING, (this || _global).onFragLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_LOADING, (this || _global).onFragLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  this.clearTimer();
                  // @ts-ignore
                  (this || _global).hls = (this || _global).onCheck = null;
                  (this || _global).fragCurrent = (this || _global).partCurrent = null;
                };
                _proto.onFragLoading = function onFragLoading(event, data) {
                  var frag = data.frag;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_4__.PlaylistLevelType.MAIN) {
                    if (!(this || _global).timer) {
                      var _data$part;
                      (this || _global).fragCurrent = frag;
                      (this || _global).partCurrent = (_data$part = data.part) != null ? _data$part : null;
                      (this || _global).timer = self.setInterval((this || _global).onCheck, 100);
                    }
                  }
                };
                _proto.onLevelLoaded = function onLevelLoaded(event, data) {
                  var config = (this || _global).hls.config;
                  if (data.details.live) {
                    (this || _global).bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
                  } else {
                    (this || _global).bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
                  }
                }

                /*
                    This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
                    quickly enough to prevent underbuffering
                  */;
                _proto._abandonRulesCheck = function _abandonRulesCheck() {
                  var frag = (this || _global).fragCurrent,
                    part = (this || _global).partCurrent,
                    hls = (this || _global).hls;
                  var autoLevelEnabled = hls.autoLevelEnabled;
                  hls.config;
                  var media = hls.media;
                  if (!frag || !media) {
                    return;
                  }
                  var stats = part ? part.stats : frag.stats;
                  var duration = part ? part.duration : frag.duration;
                  // If frag loading is aborted, complete, or from lowest level, stop timer and return
                  if (stats.aborted || stats.loaded && stats.loaded === stats.total || frag.level === 0) {
                    this.clearTimer();
                    // reset forced auto level value so that next level will be selected
                    (this || _global)._nextAutoLevel = -1;
                    return;
                  }

                  // This check only runs if we're in ABR mode and actually playing
                  if (!autoLevelEnabled || media.paused || !media.playbackRate || !media.readyState) {
                    return;
                  }
                  var bufferInfo = hls.mainForwardBufferInfo;
                  if (bufferInfo === null) {
                    return;
                  }
                  var requestDelay = performance.now() - stats.loading.start;
                  var playbackRate = Math.abs(media.playbackRate);
                  // In order to work with a stable bandwidth, only begin monitoring bandwidth after half of the fragment has been loaded
                  if (requestDelay <= 500 * duration / playbackRate) {
                    return;
                  }
                  var loadedFirstByte = stats.loaded && stats.loading.first;
                  var bwEstimate = (this || _global).bwEstimator.getEstimate();
                  var levels = hls.levels,
                    minAutoLevel = hls.minAutoLevel;
                  var level = levels[frag.level];
                  var expectedLen = stats.total || Math.max(stats.loaded, Math.round(duration * level.maxBitrate / 8));
                  var loadRate = loadedFirstByte ? stats.loaded * 1000 / requestDelay : 0;

                  // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
                  var fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate;

                  // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
                  var bufferStarvationDelay = bufferInfo.len / playbackRate;

                  // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
                  if (fragLoadedDelay <= bufferStarvationDelay) {
                    return;
                  }
                  var fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
                  var nextLoadLevel;
                  // Iterate through lower level and try to find the largest one that avoids rebuffering
                  for (nextLoadLevel = frag.level - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--) {
                    // compute time to load next fragment at lower level
                    // 0.8 : consider only 80% of current bw to be conservative
                    // 8 = bits per byte (bps/Bps)
                    var levelNextBitrate = levels[nextLoadLevel].maxBitrate;
                    fragLevelNextLoadedDelay = loadRate ? duration * levelNextBitrate / (8 * 0.8 * loadRate) : duration * levelNextBitrate / bwEstimate;
                    if (fragLevelNextLoadedDelay < bufferStarvationDelay) {
                      break;
                    }
                  }
                  // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
                  // to load the current one
                  if (fragLevelNextLoadedDelay >= fragLoadedDelay) {
                    return;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("Fragment " + frag.sn + (part ? " part " + part.index : "") + " of level " + frag.level + " is loading too slowly and will cause an underbuffer; aborting and switching to level " + nextLoadLevel + "\n      Current BW estimate: " + ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(bwEstimate) ? (bwEstimate / 1024).toFixed(3) : "Unknown") + " Kb/s\n      Estimated load time for current fragment: " + fragLoadedDelay.toFixed(3) + " s\n      Estimated load time for the next fragment: " + fragLevelNextLoadedDelay.toFixed(3) + " s\n      Time to underbuffer: " + bufferStarvationDelay.toFixed(3) + " s");
                  hls.nextLoadLevel = nextLoadLevel;
                  if (loadedFirstByte) {
                    // If there has been loading progress, sample bandwidth
                    (this || _global).bwEstimator.sample(requestDelay, stats.loaded);
                  }
                  this.clearTimer();
                  if (frag.loader) {
                    (this || _global).fragCurrent = (this || _global).partCurrent = null;
                    frag.loader.abort();
                  }
                  hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_LOAD_EMERGENCY_ABORTED, {
                    frag: frag,
                    part: part,
                    stats: stats
                  });
                };
                _proto.onFragLoaded = function onFragLoaded(event, _ref) {
                  var frag = _ref.frag,
                    part = _ref.part;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_4__.PlaylistLevelType.MAIN && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.sn)) {
                    var stats = part ? part.stats : frag.stats;
                    var duration = part ? part.duration : frag.duration;
                    // stop monitoring bw once frag loaded
                    this.clearTimer();
                    // store level id after successful fragment load
                    (this || _global).lastLoadedFragLevel = frag.level;
                    // reset forced auto level value so that next level will be selected
                    (this || _global)._nextAutoLevel = -1;

                    // compute level average bitrate
                    if ((this || _global).hls.config.abrMaxWithRealBitrate) {
                      var level = (this || _global).hls.levels[frag.level];
                      var loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
                      var loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
                      level.loaded = {
                        bytes: loadedBytes,
                        duration: loadedDuration
                      };
                      level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
                    }
                    if (frag.bitrateTest) {
                      var fragBufferedData = {
                        stats: stats,
                        frag: frag,
                        part: part,
                        id: frag.type
                      };
                      this.onFragBuffered(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_BUFFERED, fragBufferedData);
                    }
                  }
                };
                _proto.onFragBuffered = function onFragBuffered(event, data) {
                  var frag = data.frag,
                    part = data.part;
                  var stats = part ? part.stats : frag.stats;
                  if (stats.aborted) {
                    return;
                  }
                  // Only count non-alt-audio frags which were actually buffered in our BW calculations
                  if (frag.type !== _types_loader__WEBPACK_IMPORTED_MODULE_4__.PlaylistLevelType.MAIN || frag.sn === "initSegment") {
                    return;
                  }
                  // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
                  // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
                  // is used. If we used buffering in that case, our BW estimate sample will be very large.
                  var processingMs = stats.parsing.end - stats.loading.start;
                  (this || _global).bwEstimator.sample(processingMs, stats.loaded);
                  stats.bwEstimate = (this || _global).bwEstimator.getEstimate();
                  if (frag.bitrateTest) {
                    (this || _global).bitrateTestDelay = processingMs / 1000;
                  } else {
                    (this || _global).bitrateTestDelay = 0;
                  }
                };
                _proto.onError = function onError(event, data) {
                  // stop timer in case of frag loading error
                  switch (data.details) {
                    case _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.FRAG_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.FRAG_LOAD_TIMEOUT:
                      this.clearTimer();
                      break;
                  }
                };
                _proto.clearTimer = function clearTimer() {
                  self.clearInterval((this || _global).timer);
                  (this || _global).timer = undefined;
                }

                // return next auto level
                ;

                _proto.getNextABRAutoLevel = function getNextABRAutoLevel() {
                  var fragCurrent = (this || _global).fragCurrent,
                    partCurrent = (this || _global).partCurrent,
                    hls = (this || _global).hls;
                  var maxAutoLevel = hls.maxAutoLevel,
                    config = hls.config,
                    minAutoLevel = hls.minAutoLevel,
                    media = hls.media;
                  var currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
                  media ? media.currentTime : 0;

                  // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
                  // if we're playing back at the normal rate.
                  var playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1;
                  var avgbw = (this || _global).bwEstimator ? (this || _global).bwEstimator.getEstimate() : config.abrEwmaDefaultEstimate;
                  // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
                  var bufferInfo = hls.mainForwardBufferInfo;
                  var bufferStarvationDelay = (bufferInfo ? bufferInfo.len : 0) / playbackRate;

                  // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
                  var bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, config.abrBandWidthFactor, config.abrBandWidthUpFactor);
                  if (bestLevel >= 0) {
                    return bestLevel;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.trace((bufferStarvationDelay ? "rebuffering expected" : "buffer is empty") + ", finding optimal quality level");
                  // not possible to get rid of rebuffering ... let's try to find level that will guarantee less than maxStarvationDelay of rebuffering
                  // if no matching level found, logic will return 0
                  var maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
                  var bwFactor = config.abrBandWidthFactor;
                  var bwUpFactor = config.abrBandWidthUpFactor;
                  if (!bufferStarvationDelay) {
                    // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
                    var bitrateTestDelay = (this || _global).bitrateTestDelay;
                    if (bitrateTestDelay) {
                      // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                      // max video loading delay used in  automatic start level selection :
                      // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                      // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                      // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                      var maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                      maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                      _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.trace("bitrate test took " + Math.round(1000 * bitrateTestDelay) + "ms, set first fragment max fetchDuration to " + Math.round(1000 * maxStarvationDelay) + " ms");
                      // don't use conservative factor on bitrate test
                      bwFactor = bwUpFactor = 1;
                    }
                  }
                  bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay + maxStarvationDelay, bwFactor, bwUpFactor);
                  return Math.max(bestLevel, 0);
                };
                _proto.findBestLevel = function findBestLevel(currentBw, minAutoLevel, maxAutoLevel, maxFetchDuration, bwFactor, bwUpFactor) {
                  var _level$details;
                  var fragCurrent = (this || _global).fragCurrent,
                    partCurrent = (this || _global).partCurrent,
                    currentLevel = (this || _global).lastLoadedFragLevel;
                  var levels = (this || _global).hls.levels;
                  var level = levels[currentLevel];
                  var live = !!(level !== null && level !== void 0 && (_level$details = level.details) !== null && _level$details !== void 0 && _level$details.live);
                  var currentCodecSet = level === null || level === void 0 ? void 0 : level.codecSet;
                  var currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
                  for (var i = maxAutoLevel; i >= minAutoLevel; i--) {
                    var levelInfo = levels[i];
                    if (!levelInfo || currentCodecSet && levelInfo.codecSet !== currentCodecSet) {
                      continue;
                    }
                    var levelDetails = levelInfo.details;
                    var avgDuration = (partCurrent ? levelDetails === null || levelDetails === void 0 ? void 0 : levelDetails.partTarget : levelDetails === null || levelDetails === void 0 ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
                    var adjustedbw = void 0;
                    // follow algorithm captured from stagefright :
                    // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
                    // Pick the highest bandwidth stream below or equal to estimated bandwidth.
                    // consider only 80% of the available bandwidth, but if we are switching up,
                    // be even more conservative (70%) to avoid overestimating and immediately
                    // switching back.
                    if (i <= currentLevel) {
                      adjustedbw = bwFactor * currentBw;
                    } else {
                      adjustedbw = bwUpFactor * currentBw;
                    }
                    var bitrate = levels[i].maxBitrate;
                    var fetchDuration = bitrate * avgDuration / adjustedbw;
                    _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.trace("level/adjustedbw/bitrate/avgDuration/maxFetchDuration/fetchDuration: " + i + "/" + Math.round(adjustedbw) + "/" + bitrate + "/" + avgDuration + "/" + maxFetchDuration + "/" + fetchDuration);
                    // if adjusted bw is greater than level bitrate AND
                    if (adjustedbw > bitrate && (
                    // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
                    // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
                    // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
                    fetchDuration === 0 || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(fetchDuration) || live && !(this || _global).bitrateTestDelay || fetchDuration < maxFetchDuration)) {
                      // as we are looping from highest to lowest, this will return the best achievable quality level
                      return i;
                    }
                  }
                  // not enough time budget even with quality level 0 ... rebuffering might happen
                  return -1;
                };
                _createClass(AbrController, [{
                  key: "nextAutoLevel",
                  get: function get() {
                    var forcedAutoLevel = (this || _global)._nextAutoLevel;
                    var bwEstimator = (this || _global).bwEstimator;
                    // in case next auto level has been forced, and bw not available or not reliable, return forced value
                    if (forcedAutoLevel !== -1 && !bwEstimator.canEstimate()) {
                      return forcedAutoLevel;
                    }

                    // compute next level using ABR logic
                    var nextABRAutoLevel = this.getNextABRAutoLevel();
                    // use forced auto level when ABR selected level has errored
                    if (forcedAutoLevel !== -1 && (this || _global).hls.levels[nextABRAutoLevel].loadError) {
                      return forcedAutoLevel;
                    }
                    // if forced auto level has been defined, use it to cap ABR computed quality level
                    if (forcedAutoLevel !== -1) {
                      nextABRAutoLevel = Math.min(forcedAutoLevel, nextABRAutoLevel);
                    }
                    return nextABRAutoLevel;
                  },
                  set: function set(nextLevel) {
                    (this || _global)._nextAutoLevel = nextLevel;
                  }
                }]);
                return AbrController;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = AbrController;

              /***/
            },

            /***/"./src/controller/audio-stream-controller.ts":
            /*!***************************************************!*\
              !*** ./src/controller/audio-stream-controller.ts ***!
              \***************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./base-stream-controller */"./src/controller/base-stream-controller.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _fragment_tracker__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./fragment-tracker */"./src/controller/fragment-tracker.ts");
              /* harmony import */
              var _types_level__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../types/level */"./src/types/level.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _loader_fragment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../loader/fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _demux_chunk_cache__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../demux/chunk-cache */"./src/demux/chunk-cache.ts");
              /* harmony import */
              var _demux_transmuxer_interface__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ../demux/transmuxer-interface */"./src/demux/transmuxer-interface.ts");
              /* harmony import */
              var _types_transmuxer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__( /*! ../types/transmuxer */"./src/types/transmuxer.ts");
              /* harmony import */
              var _fragment_finders__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__( /*! ./fragment-finders */"./src/controller/fragment-finders.ts");
              /* harmony import */
              var _utils_discontinuities__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__( /*! ../utils/discontinuities */"./src/utils/discontinuities.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var TICK_INTERVAL = 100; // how often to tick in ms
              var AudioStreamController = /*#__PURE__*/function (_BaseStreamController) {
                _inheritsLoose(AudioStreamController, _BaseStreamController);
                function AudioStreamController(hls, fragmentTracker) {
                  var _this;
                  _this = _BaseStreamController.call(this || _global, hls, fragmentTracker, "[audio-stream-controller]") || this || _global;
                  _this.videoBuffer = null;
                  _this.videoTrackCC = -1;
                  _this.waitingVideoCC = -1;
                  _this.audioSwitch = false;
                  _this.trackId = -1;
                  _this.waitingData = null;
                  _this.mainDetails = null;
                  _this.bufferFlushed = false;
                  _this.cachedTrackLoadedData = null;
                  _this._registerListeners();
                  return _this;
                }
                var _proto = AudioStreamController.prototype;
                _proto.onHandlerDestroying = function onHandlerDestroying() {
                  this._unregisterListeners();
                  (this || _global).mainDetails = null;
                };
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACKS_UPDATED, (this || _global).onAudioTracksUpdated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_SWITCHING, (this || _global).onAudioTrackSwitching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_LOADED, (this || _global).onAudioTrackLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_RESET, (this || _global).onBufferReset, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_FLUSHED, (this || _global).onBufferFlushed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.INIT_PTS_FOUND, (this || _global).onInitPtsFound, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACKS_UPDATED, (this || _global).onAudioTracksUpdated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_SWITCHING, (this || _global).onAudioTrackSwitching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_LOADED, (this || _global).onAudioTrackLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_RESET, (this || _global).onBufferReset, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_FLUSHED, (this || _global).onBufferFlushed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.INIT_PTS_FOUND, (this || _global).onInitPtsFound, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                }

                // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
                ;

                _proto.onInitPtsFound = function onInitPtsFound(event, _ref) {
                  var frag = _ref.frag,
                    id = _ref.id,
                    initPTS = _ref.initPTS;
                  // Always update the new INIT PTS
                  // Can change due level switch
                  if (id === "main") {
                    var cc = frag.cc;
                    (this || _global).initPTS[frag.cc] = initPTS;
                    this.log("InitPTS for cc: " + cc + " found from main: " + initPTS);
                    (this || _global).videoTrackCC = cc;
                    // If we are waiting, tick immediately to unblock audio fragment transmuxing
                    if ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_INIT_PTS) {
                      this.tick();
                    }
                  }
                };
                _proto.startLoad = function startLoad(startPosition) {
                  if (!(this || _global).levels) {
                    (this || _global).startPosition = startPosition;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.STOPPED;
                    return;
                  }
                  var lastCurrentTime = (this || _global).lastCurrentTime;
                  this.stopLoad();
                  this.setInterval(TICK_INTERVAL);
                  (this || _global).fragLoadError = 0;
                  if (lastCurrentTime > 0 && startPosition === -1) {
                    this.log("Override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                    startPosition = lastCurrentTime;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  } else {
                    (this || _global).loadedmetadata = false;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_TRACK;
                  }
                  (this || _global).nextLoadPosition = (this || _global).startPosition = (this || _global).lastCurrentTime = startPosition;
                  this.tick();
                };
                _proto.doTick = function doTick() {
                  switch ((this || _global).state) {
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE:
                      this.doTickIdle();
                      break;
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_TRACK:
                      {
                        var _levels$trackId;
                        var levels = (this || _global).levels,
                          trackId = (this || _global).trackId;
                        var details = levels === null || levels === void 0 ? void 0 : (_levels$trackId = levels[trackId]) === null || _levels$trackId === void 0 ? void 0 : _levels$trackId.details;
                        if (details) {
                          if (this.waitForCdnTuneIn(details)) {
                            break;
                          }
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_INIT_PTS;
                        }
                        break;
                      }
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING_WAITING_RETRY:
                      {
                        var _this$media;
                        var now = performance.now();
                        var retryDate = (this || _global).retryDate;
                        // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                        if (!retryDate || now >= retryDate || (_this$media = (this || _global).media) !== null && _this$media !== void 0 && _this$media.seeking) {
                          this.log("RetryDate reached, switch back to IDLE state");
                          this.resetStartWhenNotLoaded((this || _global).trackId);
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                        }
                        break;
                      }
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_INIT_PTS:
                      {
                        // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                        var waitingData = (this || _global).waitingData;
                        if (waitingData) {
                          var frag = waitingData.frag,
                            part = waitingData.part,
                            cache = waitingData.cache,
                            complete = waitingData.complete;
                          if ((this || _global).initPTS[frag.cc] !== undefined) {
                            (this || _global).waitingData = null;
                            (this || _global).waitingVideoCC = -1;
                            (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING;
                            var payload = cache.flush();
                            var data = {
                              frag: frag,
                              part: part,
                              payload: payload,
                              networkDetails: null
                            };
                            this._handleFragmentLoadProgress(data);
                            if (complete) {
                              _BaseStreamController.prototype._handleFragmentLoadComplete.call(this || _global, data);
                            }
                          } else if ((this || _global).videoTrackCC !== (this || _global).waitingVideoCC) {
                            // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
                            this.log("Waiting fragment cc (" + frag.cc + ") cancelled because video is at cc " + (this || _global).videoTrackCC);
                            this.clearWaitingFragment();
                          } else {
                            // Drop waiting fragment if an earlier fragment is needed
                            var pos = this.getLoadPosition();
                            var bufferInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.bufferInfo((this || _global).mediaBuffer, pos, (this || _global).config.maxBufferHole);
                            var waitingFragmentAtPosition = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_11__.fragmentWithinToleranceTest)(bufferInfo.end, (this || _global).config.maxFragLookUpTolerance, frag);
                            if (waitingFragmentAtPosition < 0) {
                              this.log("Waiting fragment cc (" + frag.cc + ") @ " + frag.start + " cancelled because another fragment at " + bufferInfo.end + " is needed");
                              this.clearWaitingFragment();
                            }
                          }
                        } else {
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                        }
                      }
                  }
                  this.onTickEnd();
                };
                _proto.clearWaitingFragment = function clearWaitingFragment() {
                  var waitingData = (this || _global).waitingData;
                  if (waitingData) {
                    (this || _global).fragmentTracker.removeFragment(waitingData.frag);
                    (this || _global).waitingData = null;
                    (this || _global).waitingVideoCC = -1;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  }
                };
                _proto.resetLoadingState = function resetLoadingState() {
                  this.clearWaitingFragment();
                  _BaseStreamController.prototype.resetLoadingState.call(this || _global);
                };
                _proto.onTickEnd = function onTickEnd() {
                  var media = (this || _global).media;
                  if (!media || !media.readyState) {
                    // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
                    return;
                  }
                  (this || _global).lastCurrentTime = media.currentTime;
                };
                _proto.doTickIdle = function doTickIdle() {
                  var _frag$decryptdata, _frag$decryptdata2;
                  var hls = (this || _global).hls,
                    levels = (this || _global).levels,
                    media = (this || _global).media,
                    trackId = (this || _global).trackId;
                  var config = hls.config;
                  if (!levels || !levels[trackId]) {
                    return;
                  }

                  // if video not attached AND
                  // start fragment already requested OR start frag prefetch not enabled
                  // exit loop
                  // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
                  if (!media && ((this || _global).startFragRequested || !config.startFragPrefetch)) {
                    return;
                  }
                  var levelInfo = levels[trackId];
                  var trackDetails = levelInfo.details;
                  if (!trackDetails || trackDetails.live && (this || _global).levelLastLoaded !== trackId || this.waitForCdnTuneIn(trackDetails)) {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_TRACK;
                    return;
                  }
                  var bufferable = (this || _global).mediaBuffer ? (this || _global).mediaBuffer : (this || _global).media;
                  if ((this || _global).bufferFlushed && bufferable) {
                    (this || _global).bufferFlushed = false;
                    this.afterBufferFlushed(bufferable, _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO);
                  }
                  var bufferInfo = this.getFwdBufferInfo(bufferable, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO);
                  if (bufferInfo === null) {
                    return;
                  }
                  var mainBufferInfo = this.getFwdBufferInfo((this || _global).videoBuffer ? (this || _global).videoBuffer : (this || _global).media, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                  var bufferLen = bufferInfo.len;
                  var maxBufLen = this.getMaxBufferLength(mainBufferInfo === null || mainBufferInfo === void 0 ? void 0 : mainBufferInfo.len);
                  var audioSwitch = (this || _global).audioSwitch;

                  // if buffer length is less than maxBufLen try to load a new fragment
                  if (bufferLen >= maxBufLen && !audioSwitch) {
                    return;
                  }
                  if (!audioSwitch && this._streamEnded(bufferInfo, trackDetails)) {
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_EOS, {
                      type: "audio"
                    });
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ENDED;
                    return;
                  }
                  var fragments = trackDetails.fragments;
                  var start = fragments[0].start;
                  var targetBufferTime = bufferInfo.end;
                  if (audioSwitch && media) {
                    var pos = this.getLoadPosition();
                    targetBufferTime = pos;
                    // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
                    if (trackDetails.PTSKnown && pos < start) {
                      // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
                      if (bufferInfo.end > start || bufferInfo.nextStart) {
                        this.log("Alt audio track ahead of main track, seek to start of alt audio track");
                        media.currentTime = start + 0.05;
                      }
                    }
                  }

                  // buffer audio up to one target duration ahead of main buffer
                  if (mainBufferInfo && targetBufferTime > mainBufferInfo.end + trackDetails.targetduration) {
                    return;
                  }
                  // wait for main buffer after buffing some audio
                  if ((!mainBufferInfo || !mainBufferInfo.len) && bufferInfo.len) {
                    return;
                  }
                  var frag = this.getNextFragment(targetBufferTime, trackDetails);
                  if (!frag) {
                    (this || _global).bufferFlushed = true;
                    return;
                  }
                  if (((_frag$decryptdata = frag.decryptdata) === null || _frag$decryptdata === void 0 ? void 0 : _frag$decryptdata.keyFormat) === "identity" && !((_frag$decryptdata2 = frag.decryptdata) !== null && _frag$decryptdata2 !== void 0 && _frag$decryptdata2.key)) {
                    this.loadKey(frag, trackDetails);
                  } else {
                    this.loadFragment(frag, trackDetails, targetBufferTime);
                  }
                };
                _proto.getMaxBufferLength = function getMaxBufferLength(mainBufferLength) {
                  var maxConfigBuffer = _BaseStreamController.prototype.getMaxBufferLength.call(this || _global);
                  if (!mainBufferLength) {
                    return maxConfigBuffer;
                  }
                  return Math.max(maxConfigBuffer, mainBufferLength);
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  (this || _global).videoBuffer = null;
                  _BaseStreamController.prototype.onMediaDetaching.call(this || _global);
                };
                _proto.onAudioTracksUpdated = function onAudioTracksUpdated(event, _ref2) {
                  var audioTracks = _ref2.audioTracks;
                  this.resetTransmuxer();
                  (this || _global).levels = audioTracks.map(function (mediaPlaylist) {
                    return new _types_level__WEBPACK_IMPORTED_MODULE_5__.Level(mediaPlaylist);
                  });
                };
                _proto.onAudioTrackSwitching = function onAudioTrackSwitching(event, data) {
                  // if any URL found on new audio track, it is an alternate audio track
                  var altAudio = !!data.url;
                  (this || _global).trackId = data.id;
                  var fragCurrent = (this || _global).fragCurrent;
                  if (fragCurrent !== null && fragCurrent !== void 0 && fragCurrent.loader) {
                    fragCurrent.loader.abort();
                  }
                  (this || _global).fragCurrent = null;
                  this.clearWaitingFragment();
                  // destroy useless transmuxer when switching audio to main
                  if (!altAudio) {
                    this.resetTransmuxer();
                  } else {
                    // switching to audio track, start timer if not already started
                    this.setInterval(TICK_INTERVAL);
                  }

                  // should we switch tracks ?
                  if (altAudio) {
                    (this || _global).audioSwitch = true;
                    // main audio track are handled by stream-controller, just do something if switching to alt audio track
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  } else {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.STOPPED;
                  }
                  this.tick();
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).mainDetails = null;
                  (this || _global).fragmentTracker.removeAllFragments();
                  (this || _global).startPosition = (this || _global).lastCurrentTime = 0;
                  (this || _global).bufferFlushed = false;
                };
                _proto.onLevelLoaded = function onLevelLoaded(event, data) {
                  (this || _global).mainDetails = data.details;
                  if ((this || _global).cachedTrackLoadedData !== null) {
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_LOADED, (this || _global).cachedTrackLoadedData);
                    (this || _global).cachedTrackLoadedData = null;
                  }
                };
                _proto.onAudioTrackLoaded = function onAudioTrackLoaded(event, data) {
                  var _track$details;
                  if ((this || _global).mainDetails == null) {
                    (this || _global).cachedTrackLoadedData = data;
                    return;
                  }
                  var levels = (this || _global).levels;
                  var newDetails = data.details,
                    trackId = data.id;
                  if (!levels) {
                    this.warn("Audio tracks were reset while loading level " + trackId);
                    return;
                  }
                  this.log("Track " + trackId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "],duration:" + newDetails.totalduration);
                  var track = levels[trackId];
                  var sliding = 0;
                  if (newDetails.live || (_track$details = track.details) !== null && _track$details !== void 0 && _track$details.live) {
                    var mainDetails = (this || _global).mainDetails;
                    if (!newDetails.fragments[0]) {
                      newDetails.deltaUpdateFailed = true;
                    }
                    if (newDetails.deltaUpdateFailed || !mainDetails) {
                      return;
                    }
                    if (!track.details && newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                      // Make sure our audio rendition is aligned with the "main" rendition, using
                      // pdt as our reference times.
                      (0, _utils_discontinuities__WEBPACK_IMPORTED_MODULE_12__.alignMediaPlaylistByPDT)(newDetails, mainDetails);
                      sliding = newDetails.fragments[0].start;
                    } else {
                      sliding = this.alignPlaylists(newDetails, track.details);
                    }
                  }
                  track.details = newDetails;
                  (this || _global).levelLastLoaded = trackId;

                  // compute start position if we are aligned with the main playlist
                  if (!(this || _global).startFragRequested && ((this || _global).mainDetails || !newDetails.live)) {
                    this.setStartPosition(track.details, sliding);
                  }
                  // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
                  if ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  }

                  // trigger handler right now
                  this.tick();
                };
                _proto._handleFragmentLoadProgress = function _handleFragmentLoadProgress(data) {
                  var _frag$initSegment;
                  var frag = data.frag,
                    part = data.part,
                    payload = data.payload;
                  var config = (this || _global).config,
                    trackId = (this || _global).trackId,
                    levels = (this || _global).levels;
                  if (!levels) {
                    this.warn("Audio tracks were reset while fragment load was in progress. Fragment " + frag.sn + " of level " + frag.level + " will not be buffered");
                    return;
                  }
                  var track = levels[trackId];
                  console.assert(track, "Audio track is defined on fragment load progress");
                  var details = track.details;
                  console.assert(details, "Audio track details are defined on fragment load progress");
                  var audioCodec = config.defaultAudioCodec || track.audioCodec || "mp4a.40.2";
                  var transmuxer = (this || _global).transmuxer;
                  if (!transmuxer) {
                    transmuxer = (this || _global).transmuxer = new _demux_transmuxer_interface__WEBPACK_IMPORTED_MODULE_9__["default"]((this || _global).hls, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO, (this || _global)._handleTransmuxComplete.bind(this || _global), (this || _global)._handleTransmuxerFlush.bind(this || _global));
                  }

                  // Check if we have video initPTS
                  // If not we need to wait for it
                  var initPTS = (this || _global).initPTS[frag.cc];
                  var initSegmentData = (_frag$initSegment = frag.initSegment) === null || _frag$initSegment === void 0 ? void 0 : _frag$initSegment.data;
                  if (initPTS !== undefined) {
                    // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
                    // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
                    var accurateTimeOffset = false; // details.PTSKnown || !details.live;
                    var partIndex = part ? part.index : -1;
                    var partial = partIndex !== -1;
                    var chunkMeta = new _types_transmuxer__WEBPACK_IMPORTED_MODULE_10__.ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
                    transmuxer.push(payload, initSegmentData, audioCodec, "", frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
                  } else {
                    this.log("Unknown video PTS for cc " + frag.cc + ", waiting for video PTS before demuxing audio frag " + frag.sn + " of [" + details.startSN + " ," + details.endSN + "],track " + trackId);
                    var _this$waitingData = (this || _global).waitingData = (this || _global).waitingData || {
                        frag: frag,
                        part: part,
                        cache: new _demux_chunk_cache__WEBPACK_IMPORTED_MODULE_8__["default"](),
                        complete: false
                      },
                      cache = _this$waitingData.cache;
                    cache.push(new Uint8Array(payload));
                    (this || _global).waitingVideoCC = (this || _global).videoTrackCC;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_INIT_PTS;
                  }
                };
                _proto._handleFragmentLoadComplete = function _handleFragmentLoadComplete(fragLoadedData) {
                  if ((this || _global).waitingData) {
                    (this || _global).waitingData.complete = true;
                    return;
                  }
                  _BaseStreamController.prototype._handleFragmentLoadComplete.call(this || _global, fragLoadedData);
                };
                _proto.onBufferReset = function /* event: Events.BUFFER_RESET */
                onBufferReset() {
                  // reset reference to sourcebuffers
                  (this || _global).mediaBuffer = (this || _global).videoBuffer = null;
                  (this || _global).loadedmetadata = false;
                };
                _proto.onBufferCreated = function onBufferCreated(event, data) {
                  var audioTrack = data.tracks.audio;
                  if (audioTrack) {
                    (this || _global).mediaBuffer = audioTrack.buffer || null;
                  }
                  if (data.tracks.video) {
                    (this || _global).videoBuffer = data.tracks.video.buffer || null;
                  }
                };
                _proto.onFragBuffered = function onFragBuffered(event, data) {
                  var frag = data.frag,
                    part = data.part;
                  if (frag.type !== _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO) {
                    if (!(this || _global).loadedmetadata && frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN) {
                      var _ref3;
                      if ((_ref3 = (this || _global).videoBuffer || (this || _global).media) !== null && _ref3 !== void 0 && _ref3.buffered.length) {
                        (this || _global).loadedmetadata = true;
                      }
                    }
                    return;
                  }
                  if (this.fragContextChanged(frag)) {
                    // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
                    // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
                    this.warn("Fragment " + frag.sn + (part ? " p: " + part.index : "") + " of level " + frag.level + " finished buffering, but was aborted. state: " + (this || _global).state + ", audioSwitch: " + (this || _global).audioSwitch);
                    return;
                  }
                  if (frag.sn !== "initSegment") {
                    (this || _global).fragPrevious = frag;
                    if ((this || _global).audioSwitch) {
                      (this || _global).audioSwitch = false;
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_SWITCHED, {
                        id: (this || _global).trackId
                      });
                    }
                  }
                  this.fragBufferedComplete(frag, part);
                };
                _proto.onError = function onError(event, data) {
                  switch (data.details) {
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.FRAG_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.KEY_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.KEY_LOAD_TIMEOUT:
                      // TODO: Skip fragments that do not belong to this.fragCurrent audio-group id
                      this.onFragmentOrKeyLoadError(_types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO, data);
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.AUDIO_TRACK_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT:
                      //  when in ERROR state, don't switch back to IDLE state in case a non-fatal error is received
                      if ((this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ERROR && (this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.STOPPED) {
                        // if fatal error, stop processing, otherwise move to IDLE to retry loading
                        (this || _global).state = data.fatal ? _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ERROR : _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                        this.warn(data.details + " while loading frag, switching to " + (this || _global).state + " state");
                      }
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.BUFFER_FULL_ERROR:
                      // if in appending state
                      if (data.parent === "audio" && ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING || (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSED)) {
                        var flushBuffer = true;
                        var bufferedInfo = this.getFwdBufferInfo((this || _global).mediaBuffer, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO);
                        // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
                        // reduce max buf len if current position is buffered
                        if (bufferedInfo && bufferedInfo.len > 0.5) {
                          flushBuffer = !this.reduceMaxBufferLength(bufferedInfo.len);
                        }
                        if (flushBuffer) {
                          // current position is not buffered, but browser is still complaining about buffer full error
                          // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                          // in that case flush the whole audio buffer to recover
                          this.warn("Buffer full error also media.currentTime is not buffered, flush audio buffer");
                          (this || _global).fragCurrent = null;
                          _BaseStreamController.prototype.flushMainBuffer.call(this || _global, 0, Number.POSITIVE_INFINITY, "audio");
                        }
                        this.resetLoadingState();
                      }
                      break;
                  }
                };
                _proto.onBufferFlushed = function onBufferFlushed(event, _ref4) {
                  var type = _ref4.type;
                  if (type === _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO) {
                    (this || _global).bufferFlushed = true;
                  }
                };
                _proto._handleTransmuxComplete = function _handleTransmuxComplete(transmuxResult) {
                  var _id3$samples;
                  var id = "audio";
                  var hls = (this || _global).hls;
                  var remuxResult = transmuxResult.remuxResult,
                    chunkMeta = transmuxResult.chunkMeta;
                  var context = this.getCurrentContext(chunkMeta);
                  if (!context) {
                    this.warn("The loading context changed while buffering fragment " + chunkMeta.sn + " of level " + chunkMeta.level + ". This chunk will not be buffered.");
                    this.resetStartWhenNotLoaded(chunkMeta.level);
                    return;
                  }
                  var frag = context.frag,
                    part = context.part,
                    details = context.level.details;
                  var audio = remuxResult.audio,
                    text = remuxResult.text,
                    id3 = remuxResult.id3,
                    initSegment = remuxResult.initSegment;

                  // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
                  // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
                  if (this.fragContextChanged(frag) || !details) {
                    return;
                  }
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING;
                  if ((this || _global).audioSwitch && audio) {
                    this.completeAudioSwitch();
                  }
                  if (initSegment !== null && initSegment !== void 0 && initSegment.tracks) {
                    this._bufferInitSegment(initSegment.tracks, frag, chunkMeta);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_PARSING_INIT_SEGMENT, {
                      frag: frag,
                      id: id,
                      tracks: initSegment.tracks
                    });
                    // Only flush audio from old audio tracks when PTS is known on new audio track
                  }

                  if (audio) {
                    var startPTS = audio.startPTS,
                      endPTS = audio.endPTS,
                      startDTS = audio.startDTS,
                      endDTS = audio.endDTS;
                    if (part) {
                      part.elementaryStreams[_loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO] = {
                        startPTS: startPTS,
                        endPTS: endPTS,
                        startDTS: startDTS,
                        endDTS: endDTS
                      };
                    }
                    frag.setElementaryStreamInfo(_loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
                    this.bufferFragmentData(audio, frag, part, chunkMeta);
                  }
                  if (id3 !== null && id3 !== void 0 && (_id3$samples = id3.samples) !== null && _id3$samples !== void 0 && _id3$samples.length) {
                    var emittedID3 = _extends({
                      id: id,
                      frag: frag,
                      details: details
                    }, id3);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_PARSING_METADATA, emittedID3);
                  }
                  if (text) {
                    var emittedText = _extends({
                      id: id,
                      frag: frag,
                      details: details
                    }, text);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.FRAG_PARSING_USERDATA, emittedText);
                  }
                };
                _proto._bufferInitSegment = function _bufferInitSegment(tracks, frag, chunkMeta) {
                  if ((this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING) {
                    return;
                  }
                  // delete any video track found on audio transmuxer
                  if (tracks.video) {
                    delete tracks.video;
                  }

                  // include levelCodec in audio and video tracks
                  var track = tracks.audio;
                  if (!track) {
                    return;
                  }
                  track.levelCodec = track.codec;
                  track.id = "audio";
                  this.log("Init audio buffer, container:" + track.container + ", codecs[parsed]=[" + track.codec + "]");
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_CODECS, tracks);
                  var initSegment = track.initSegment;
                  if (initSegment !== null && initSegment !== void 0 && initSegment.byteLength) {
                    var segment = {
                      type: "audio",
                      frag: frag,
                      part: null,
                      chunkMeta: chunkMeta,
                      parent: frag.type,
                      data: initSegment
                    };
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.BUFFER_APPENDING, segment);
                  }
                  // trigger handler right now
                  this.tick();
                };
                _proto.loadFragment = function loadFragment(frag, trackDetails, targetBufferTime) {
                  // only load if fragment is not loaded or if in audio switch
                  var fragState = (this || _global).fragmentTracker.getState(frag);
                  (this || _global).fragCurrent = frag;

                  // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
                  if ((this || _global).audioSwitch || fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_4__.FragmentState.NOT_LOADED || fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_4__.FragmentState.PARTIAL) {
                    if (frag.sn === "initSegment") {
                      this._loadInitSegment(frag);
                    } else if (trackDetails.live && !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).initPTS[frag.cc])) {
                      this.log("Waiting for video PTS in continuity counter " + frag.cc + " of live stream before loading audio fragment " + frag.sn + " of level " + (this || _global).trackId);
                      (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_INIT_PTS;
                    } else {
                      (this || _global).startFragRequested = true;
                      _BaseStreamController.prototype.loadFragment.call(this || _global, frag, trackDetails, targetBufferTime);
                    }
                  }
                };
                _proto.completeAudioSwitch = function completeAudioSwitch() {
                  var hls = (this || _global).hls,
                    media = (this || _global).media,
                    trackId = (this || _global).trackId;
                  if (media) {
                    this.log("Switching audio track : flushing all audio");
                    _BaseStreamController.prototype.flushMainBuffer.call(this || _global, 0, Number.POSITIVE_INFINITY, "audio");
                  }
                  (this || _global).audioSwitch = false;
                  hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.AUDIO_TRACK_SWITCHED, {
                    id: trackId
                  });
                };
                return AudioStreamController;
              }(_base_stream_controller__WEBPACK_IMPORTED_MODULE_1__["default"]);
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = AudioStreamController;

              /***/
            },

            /***/"./src/controller/audio-track-controller.ts":
            /*!**************************************************!*\
              !*** ./src/controller/audio-track-controller.ts ***!
              \**************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _base_playlist_controller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./base-playlist-controller */"./src/controller/base-playlist-controller.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var AudioTrackController = /*#__PURE__*/function (_BasePlaylistControll) {
                _inheritsLoose(AudioTrackController, _BasePlaylistControll);
                function AudioTrackController(hls) {
                  var _this;
                  _this = _BasePlaylistControll.call(this || _global, hls, "[audio-track-controller]") || this || _global;
                  _this.tracks = [];
                  _this.groupId = null;
                  _this.tracksInGroup = [];
                  _this.trackId = -1;
                  _this.trackName = "";
                  _this.selectDefaultTrack = true;
                  _this.registerListeners();
                  return _this;
                }
                var _proto = AudioTrackController.prototype;
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_SWITCHING, (this || _global).onLevelSwitching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.AUDIO_TRACK_LOADED, (this || _global).onAudioTrackLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_SWITCHING, (this || _global).onLevelSwitching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.AUDIO_TRACK_LOADED, (this || _global).onAudioTrackLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  (this || _global).tracks.length = 0;
                  (this || _global).tracksInGroup.length = 0;
                  _BasePlaylistControll.prototype.destroy.call(this || _global);
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).tracks = [];
                  (this || _global).groupId = null;
                  (this || _global).tracksInGroup = [];
                  (this || _global).trackId = -1;
                  (this || _global).trackName = "";
                  (this || _global).selectDefaultTrack = true;
                };
                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  (this || _global).tracks = data.audioTracks || [];
                };
                _proto.onAudioTrackLoaded = function onAudioTrackLoaded(event, data) {
                  var id = data.id,
                    details = data.details;
                  var currentTrack = (this || _global).tracksInGroup[id];
                  if (!currentTrack) {
                    this.warn("Invalid audio track id " + id);
                    return;
                  }
                  var curDetails = currentTrack.details;
                  currentTrack.details = data.details;
                  this.log("audioTrack " + id + " loaded [" + details.startSN + "-" + details.endSN + "]");
                  if (id === (this || _global).trackId) {
                    (this || _global).retryCount = 0;
                    this.playlistLoaded(id, data, curDetails);
                  }
                };
                _proto.onLevelLoading = function onLevelLoading(event, data) {
                  this.switchLevel(data.level);
                };
                _proto.onLevelSwitching = function onLevelSwitching(event, data) {
                  this.switchLevel(data.level);
                };
                _proto.switchLevel = function switchLevel(levelIndex) {
                  var levelInfo = (this || _global).hls.levels[levelIndex];
                  if (!(levelInfo !== null && levelInfo !== void 0 && levelInfo.audioGroupIds)) {
                    return;
                  }
                  var audioGroupId = levelInfo.audioGroupIds[levelInfo.urlId];
                  if ((this || _global).groupId !== audioGroupId) {
                    (this || _global).groupId = audioGroupId;
                    var audioTracks = (this || _global).tracks.filter(function (track) {
                      return !audioGroupId || track.groupId === audioGroupId;
                    });

                    // Disable selectDefaultTrack if there are no default tracks
                    if ((this || _global).selectDefaultTrack && !audioTracks.some(function (track) {
                      return track.default;
                    })) {
                      (this || _global).selectDefaultTrack = false;
                    }
                    (this || _global).tracksInGroup = audioTracks;
                    var audioTracksUpdated = {
                      audioTracks: audioTracks
                    };
                    this.log("Updating audio tracks, " + audioTracks.length + " track(s) found in \"" + audioGroupId + "\" group-id");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
                    this.selectInitialTrack();
                  }
                };
                _proto.onError = function onError(event, data) {
                  _BasePlaylistControll.prototype.onError.call(this || _global, event, data);
                  if (data.fatal || !data.context) {
                    return;
                  }
                  if (data.context.type === _types_loader__WEBPACK_IMPORTED_MODULE_3__.PlaylistContextType.AUDIO_TRACK && data.context.id === (this || _global).trackId && data.context.groupId === (this || _global).groupId) {
                    this.retryLoadingOrFail(data);
                  }
                };
                _proto.setAudioTrack = function setAudioTrack(newId) {
                  var tracks = (this || _global).tracksInGroup;

                  // check if level idx is valid
                  if (newId < 0 || newId >= tracks.length) {
                    this.warn("Invalid id passed to audio-track controller");
                    return;
                  }

                  // stopping live reloading timer if any
                  this.clearTimer();
                  var lastTrack = tracks[(this || _global).trackId];
                  this.log("Now switching to audio-track index " + newId);
                  var track = tracks[newId];
                  var id = track.id,
                    _track$groupId = track.groupId,
                    groupId = _track$groupId === void 0 ? "" : _track$groupId,
                    name = track.name,
                    type = track.type,
                    url = track.url;
                  (this || _global).trackId = newId;
                  (this || _global).trackName = name;
                  (this || _global).selectDefaultTrack = false;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.AUDIO_TRACK_SWITCHING, {
                    id: id,
                    groupId: groupId,
                    name: name,
                    type: type,
                    url: url
                  });
                  // Do not reload track unless live
                  if (track.details && !track.details.live) {
                    return;
                  }
                  var hlsUrlParameters = this.switchParams(track.url, lastTrack === null || lastTrack === void 0 ? void 0 : lastTrack.details);
                  this.loadPlaylist(hlsUrlParameters);
                };
                _proto.selectInitialTrack = function selectInitialTrack() {
                  var audioTracks = (this || _global).tracksInGroup;
                  console.assert(audioTracks.length, "Initial audio track should be selected when tracks are known");
                  var currentAudioTrackName = (this || _global).trackName;
                  var trackId = this.findTrackId(currentAudioTrackName) || this.findTrackId();
                  if (trackId !== -1) {
                    this.setAudioTrack(trackId);
                  } else {
                    this.warn("No track found for running audio group-ID: " + (this || _global).groupId);
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.AUDIO_TRACK_LOAD_ERROR,
                      fatal: true
                    });
                  }
                };
                _proto.findTrackId = function findTrackId(name) {
                  var audioTracks = (this || _global).tracksInGroup;
                  for (var i = 0; i < audioTracks.length; i++) {
                    var track = audioTracks[i];
                    if (!(this || _global).selectDefaultTrack || track.default) {
                      if (!name || name === track.name) {
                        return track.id;
                      }
                    }
                  }
                  return -1;
                };
                _proto.loadPlaylist = function loadPlaylist(hlsUrlParameters) {
                  var audioTrack = (this || _global).tracksInGroup[(this || _global).trackId];
                  if (this.shouldLoadTrack(audioTrack)) {
                    var id = audioTrack.id;
                    var groupId = audioTrack.groupId;
                    var url = audioTrack.url;
                    if (hlsUrlParameters) {
                      try {
                        url = hlsUrlParameters.addDirectives(url);
                      } catch (error) {
                        this.warn("Could not construct new URL with HLS Delivery Directives: " + error);
                      }
                    }
                    // track not retrieved yet, or live playlist we need to (re)load it
                    this.log("loading audio-track playlist for id: " + id);
                    this.clearTimer();
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.AUDIO_TRACK_LOADING, {
                      url: url,
                      id: id,
                      groupId: groupId,
                      deliveryDirectives: hlsUrlParameters || null
                    });
                  }
                };
                _createClass(AudioTrackController, [{
                  key: "audioTracks",
                  get: function get() {
                    return (this || _global).tracksInGroup;
                  }
                }, {
                  key: "audioTrack",
                  get: function get() {
                    return (this || _global).trackId;
                  },
                  set: function set(newId) {
                    // If audio track is selected from API then don't choose from the manifest default track
                    (this || _global).selectDefaultTrack = false;
                    this.setAudioTrack(newId);
                  }
                }]);
                return AudioTrackController;
              }(_base_playlist_controller__WEBPACK_IMPORTED_MODULE_2__["default"]);
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = AudioTrackController;

              /***/
            },

            /***/"./src/controller/base-playlist-controller.ts":
            /*!****************************************************!*\
              !*** ./src/controller/base-playlist-controller.ts ***!
              \****************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */BasePlaylistController
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _types_level__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../types/level */"./src/types/level.ts");
              /* harmony import */
              var _level_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./level-helper */"./src/controller/level-helper.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              var BasePlaylistController = /*#__PURE__*/function () {
                function BasePlaylistController(hls, logPrefix) {
                  (this || _global).hls = void 0;
                  (this || _global).timer = -1;
                  (this || _global).canLoad = false;
                  (this || _global).retryCount = 0;
                  (this || _global).log = void 0;
                  (this || _global).warn = void 0;
                  (this || _global).log = _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log.bind(_utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger, logPrefix + ":");
                  (this || _global).warn = _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn.bind(_utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger, logPrefix + ":");
                  (this || _global).hls = hls;
                }
                var _proto = BasePlaylistController.prototype;
                _proto.destroy = function destroy() {
                  this.clearTimer();
                  // @ts-ignore
                  (this || _global).hls = (this || _global).log = (this || _global).warn = null;
                };
                _proto.onError = function onError(event, data) {
                  if (data.fatal && data.type === _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorTypes.NETWORK_ERROR) {
                    this.clearTimer();
                  }
                };
                _proto.clearTimer = function clearTimer() {
                  clearTimeout((this || _global).timer);
                  (this || _global).timer = -1;
                };
                _proto.startLoad = function startLoad() {
                  (this || _global).canLoad = true;
                  (this || _global).retryCount = 0;
                  this.loadPlaylist();
                };
                _proto.stopLoad = function stopLoad() {
                  (this || _global).canLoad = false;
                  this.clearTimer();
                };
                _proto.switchParams = function switchParams(playlistUri, previous) {
                  var renditionReports = previous === null || previous === void 0 ? void 0 : previous.renditionReports;
                  if (renditionReports) {
                    for (var i = 0; i < renditionReports.length; i++) {
                      var attr = renditionReports[i];
                      var uri = "" + attr.URI;
                      if (uri === playlistUri.slice(-uri.length)) {
                        var msn = parseInt(attr["LAST-MSN"]);
                        var part = parseInt(attr["LAST-PART"]);
                        if (previous && (this || _global).hls.config.lowLatencyMode) {
                          var currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
                          if (part !== undefined && currentGoal > previous.partTarget) {
                            part += 1;
                          }
                        }
                        if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(msn)) {
                          return new _types_level__WEBPACK_IMPORTED_MODULE_1__.HlsUrlParameters(msn, (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(part) ? part : undefined, _types_level__WEBPACK_IMPORTED_MODULE_1__.HlsSkip.No);
                        }
                      }
                    }
                  }
                };
                _proto.loadPlaylist = function loadPlaylist(hlsUrlParameters) {};
                _proto.shouldLoadTrack = function shouldLoadTrack(track) {
                  return (this || _global).canLoad && track && !!track.url && (!track.details || track.details.live);
                };
                _proto.playlistLoaded = function playlistLoaded(index, data, previousDetails) {
                  var _this = this || _global;
                  var details = data.details,
                    stats = data.stats;

                  // Set last updated date-time
                  var elapsed = stats.loading.end ? Math.max(0, self.performance.now() - stats.loading.end) : 0;
                  details.advancedDateTime = Date.now() - elapsed;

                  // if current playlist is a live playlist, arm a timer to reload it
                  if (details.live || previousDetails !== null && previousDetails !== void 0 && previousDetails.live) {
                    details.reloaded(previousDetails);
                    if (previousDetails) {
                      this.log("live playlist " + index + " " + (details.advanced ? "REFRESHED " + details.lastPartSn + "-" + details.lastPartIndex : "MISSED"));
                    }
                    // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
                    if (previousDetails && details.fragments.length > 0) {
                      (0, _level_helper__WEBPACK_IMPORTED_MODULE_2__.mergeDetails)(previousDetails, details);
                    }
                    if (!(this || _global).canLoad || !details.live) {
                      return;
                    }
                    var deliveryDirectives;
                    var msn = undefined;
                    var part = undefined;
                    if (details.canBlockReload && details.endSN && details.advanced) {
                      // Load level with LL-HLS delivery directives
                      var lowLatencyMode = (this || _global).hls.config.lowLatencyMode;
                      var lastPartSn = details.lastPartSn;
                      var endSn = details.endSN;
                      var lastPartIndex = details.lastPartIndex;
                      var hasParts = lastPartIndex !== -1;
                      var lastPart = lastPartSn === endSn;
                      // When low latency mode is disabled, we'll skip part requests once the last part index is found
                      var nextSnStartIndex = lowLatencyMode ? 0 : lastPartIndex;
                      if (hasParts) {
                        msn = lastPart ? endSn + 1 : lastPartSn;
                        part = lastPart ? nextSnStartIndex : lastPartIndex + 1;
                      } else {
                        msn = endSn + 1;
                      }
                      // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
                      // Update directives to obtain the Playlist that has the estimated additional duration of media
                      var lastAdvanced = details.age;
                      var cdnAge = lastAdvanced + details.ageHeader;
                      var currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
                      if (currentGoal > 0) {
                        if (previousDetails && currentGoal > previousDetails.tuneInGoal) {
                          // If we attempted to get the next or latest playlist update, but currentGoal increased,
                          // then we either can't catchup, or the "age" header cannot be trusted.
                          this.warn("CDN Tune-in goal increased from: " + previousDetails.tuneInGoal + " to: " + currentGoal + " with playlist age: " + details.age);
                          currentGoal = 0;
                        } else {
                          var segments = Math.floor(currentGoal / details.targetduration);
                          msn += segments;
                          if (part !== undefined) {
                            var parts = Math.round(currentGoal % details.targetduration / details.partTarget);
                            part += parts;
                          }
                          this.log("CDN Tune-in age: " + details.ageHeader + "s last advanced " + lastAdvanced.toFixed(2) + "s goal: " + currentGoal + " skip sn " + segments + " to part " + part);
                        }
                        details.tuneInGoal = currentGoal;
                      }
                      deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                      if (lowLatencyMode || !lastPart) {
                        this.loadPlaylist(deliveryDirectives);
                        return;
                      }
                    } else {
                      deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                    }
                    var reloadInterval = (0, _level_helper__WEBPACK_IMPORTED_MODULE_2__.computeReloadInterval)(details, stats);
                    if (msn !== undefined && details.canBlockReload) {
                      reloadInterval -= details.partTarget || 1;
                    }
                    this.log("reload live playlist " + index + " in " + Math.round(reloadInterval) + " ms");
                    (this || _global).timer = self.setTimeout(function () {
                      return _this.loadPlaylist(deliveryDirectives);
                    }, reloadInterval);
                  } else {
                    this.clearTimer();
                  }
                };
                _proto.getDeliveryDirectives = function getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
                  var skip = (0, _types_level__WEBPACK_IMPORTED_MODULE_1__.getSkipValue)(details, msn);
                  if (previousDeliveryDirectives !== null && previousDeliveryDirectives !== void 0 && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
                    msn = previousDeliveryDirectives.msn;
                    part = previousDeliveryDirectives.part;
                    skip = _types_level__WEBPACK_IMPORTED_MODULE_1__.HlsSkip.No;
                  }
                  return new _types_level__WEBPACK_IMPORTED_MODULE_1__.HlsUrlParameters(msn, part, skip);
                };
                _proto.retryLoadingOrFail = function retryLoadingOrFail(errorEvent) {
                  var _this2 = this || _global;
                  var config = (this || _global).hls.config;
                  var retry = (this || _global).retryCount < config.levelLoadingMaxRetry;
                  if (retry) {
                    var _errorEvent$context;
                    (this || _global).retryCount++;
                    if (errorEvent.details.indexOf("LoadTimeOut") > -1 && (_errorEvent$context = errorEvent.context) !== null && _errorEvent$context !== void 0 && _errorEvent$context.deliveryDirectives) {
                      // The LL-HLS request already timed out so retry immediately
                      this.warn("retry playlist loading #" + (this || _global).retryCount + " after \"" + errorEvent.details + "\"");
                      this.loadPlaylist();
                    } else {
                      // exponential backoff capped to max retry timeout
                      var delay = Math.min(Math.pow(2, (this || _global).retryCount) * config.levelLoadingRetryDelay, config.levelLoadingMaxRetryTimeout);
                      // Schedule level/track reload
                      (this || _global).timer = self.setTimeout(function () {
                        return _this2.loadPlaylist();
                      }, delay);
                      this.warn("retry playlist loading #" + (this || _global).retryCount + " in " + delay + " ms after \"" + errorEvent.details + "\"");
                    }
                  } else {
                    this.warn("cannot recover from error \"" + errorEvent.details + "\"");
                    // stopping live reloading timer if any
                    this.clearTimer();
                    // switch error to fatal
                    errorEvent.fatal = true;
                  }
                  return retry;
                };
                return BasePlaylistController;
              }();

              /***/
            },

            /***/"./src/controller/base-stream-controller.ts":
            /*!**************************************************!*\
              !*** ./src/controller/base-stream-controller.ts ***!
              \**************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"State": () => /* binding */State,
                /* harmony export */"default": () => /* binding */BaseStreamController
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _task_loop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../task-loop */"./src/task-loop.ts");
              /* harmony import */
              var _fragment_tracker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./fragment-tracker */"./src/controller/fragment-tracker.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _types_transmuxer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../types/transmuxer */"./src/types/transmuxer.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _utils_discontinuities__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ../utils/discontinuities */"./src/utils/discontinuities.ts");
              /* harmony import */
              var _fragment_finders__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__( /*! ./fragment-finders */"./src/controller/fragment-finders.ts");
              /* harmony import */
              var _level_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__( /*! ./level-helper */"./src/controller/level-helper.ts");
              /* harmony import */
              var _loader_fragment_loader__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__( /*! ../loader/fragment-loader */"./src/loader/fragment-loader.ts");
              /* harmony import */
              var _crypt_decrypter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__( /*! ../crypt/decrypter */"./src/crypt/decrypter.ts");
              /* harmony import */
              var _utils_time_ranges__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__( /*! ../utils/time-ranges */"./src/utils/time-ranges.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _assertThisInitialized(self) {
                if (self === void 0) {
                  throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var State = {
                STOPPED: "STOPPED",
                IDLE: "IDLE",
                KEY_LOADING: "KEY_LOADING",
                FRAG_LOADING: "FRAG_LOADING",
                FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
                WAITING_TRACK: "WAITING_TRACK",
                PARSING: "PARSING",
                PARSED: "PARSED",
                ENDED: "ENDED",
                ERROR: "ERROR",
                WAITING_INIT_PTS: "WAITING_INIT_PTS",
                WAITING_LEVEL: "WAITING_LEVEL"
              };
              var BaseStreamController = /*#__PURE__*/function (_TaskLoop) {
                _inheritsLoose(BaseStreamController, _TaskLoop);
                function BaseStreamController(hls, fragmentTracker, logPrefix) {
                  var _this;
                  _this = _TaskLoop.call(this || _global) || this || _global;
                  _this.hls = void 0;
                  _this.fragPrevious = null;
                  _this.fragCurrent = null;
                  _this.fragmentTracker = void 0;
                  _this.transmuxer = null;
                  _this._state = State.STOPPED;
                  _this.media = null;
                  _this.mediaBuffer = null;
                  _this.config = void 0;
                  _this.bitrateTest = false;
                  _this.lastCurrentTime = 0;
                  _this.nextLoadPosition = 0;
                  _this.startPosition = 0;
                  _this.loadedmetadata = false;
                  _this.fragLoadError = 0;
                  _this.retryDate = 0;
                  _this.levels = null;
                  _this.fragmentLoader = void 0;
                  _this.levelLastLoaded = null;
                  _this.startFragRequested = false;
                  _this.decrypter = void 0;
                  _this.initPTS = [];
                  _this.onvseeking = null;
                  _this.onvended = null;
                  _this.logPrefix = "";
                  _this.log = void 0;
                  _this.warn = void 0;
                  _this.logPrefix = logPrefix;
                  _this.log = _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.log.bind(_utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger, logPrefix + ":");
                  _this.warn = _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.warn.bind(_utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger, logPrefix + ":");
                  _this.hls = hls;
                  _this.fragmentLoader = new _loader_fragment_loader__WEBPACK_IMPORTED_MODULE_12__["default"](hls.config);
                  _this.fragmentTracker = fragmentTracker;
                  _this.config = hls.config;
                  _this.decrypter = new _crypt_decrypter__WEBPACK_IMPORTED_MODULE_13__["default"](hls, hls.config);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_5__.Events.KEY_LOADED, _this.onKeyLoaded, _assertThisInitialized(_this));
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_5__.Events.LEVEL_SWITCHING, _this.onLevelSwitching, _assertThisInitialized(_this));
                  return _this;
                }
                var _proto = BaseStreamController.prototype;
                _proto.doTick = function doTick() {
                  this.onTickEnd();
                };
                _proto.onTickEnd = function onTickEnd() {}

                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                ;

                _proto.startLoad = function startLoad(startPosition) {};
                _proto.stopLoad = function stopLoad() {
                  (this || _global).fragmentLoader.abort();
                  var frag = (this || _global).fragCurrent;
                  if (frag) {
                    (this || _global).fragmentTracker.removeFragment(frag);
                  }
                  this.resetTransmuxer();
                  (this || _global).fragCurrent = null;
                  (this || _global).fragPrevious = null;
                  this.clearInterval();
                  this.clearNextTick();
                  (this || _global).state = State.STOPPED;
                };
                _proto._streamEnded = function _streamEnded(bufferInfo, levelDetails) {
                  var fragCurrent = (this || _global).fragCurrent,
                    fragmentTracker = (this || _global).fragmentTracker;
                  // we just got done loading the final fragment and there is no other buffered range after ...
                  // rationale is that in case there are any buffered ranges after, it means that there are unbuffered portion in between
                  // so we should not switch to ENDED in that case, to be able to buffer them
                  if (!levelDetails.live && fragCurrent && (this || _global).media &&
                  // NOTE: Because of the way parts are currently parsed/represented in the playlist, we can end up
                  // in situations where the current fragment is actually greater than levelDetails.endSN. While
                  // this feels like the "wrong place" to account for that, this is a narrower/safer change than
                  // updating e.g. M3U8Parser::parseLevelPlaylist().
                  fragCurrent.sn >= levelDetails.endSN && !bufferInfo.nextStart) {
                    var partList = levelDetails.partList;
                    // Since the last part isn't guaranteed to correspond to fragCurrent for ll-hls, check instead if the last part is buffered.
                    if (partList !== null && partList !== void 0 && partList.length) {
                      var lastPart = partList[partList.length - 1];

                      // Checking the midpoint of the part for potential margin of error and related issues.
                      // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
                      // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
                      // part mismatches for independent audio and video playlists/segments.
                      var lastPartBuffered = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.isBuffered((this || _global).media, lastPart.start + lastPart.duration / 2);
                      return lastPartBuffered;
                    }
                    var fragState = fragmentTracker.getState(fragCurrent);
                    return fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_2__.FragmentState.PARTIAL || fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_2__.FragmentState.OK;
                  }
                  return false;
                };
                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  var media = (this || _global).media = (this || _global).mediaBuffer = data.media;
                  (this || _global).onvseeking = (this || _global).onMediaSeeking.bind(this || _global);
                  (this || _global).onvended = (this || _global).onMediaEnded.bind(this || _global);
                  media.addEventListener("seeking", (this || _global).onvseeking);
                  media.addEventListener("ended", (this || _global).onvended);
                  var config = (this || _global).config;
                  if ((this || _global).levels && config.autoStartLoad && (this || _global).state === State.STOPPED) {
                    this.startLoad(config.startPosition);
                  }
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  var media = (this || _global).media;
                  if (media !== null && media !== void 0 && media.ended) {
                    this.log("MSE detaching and video ended, reset startPosition");
                    (this || _global).startPosition = (this || _global).lastCurrentTime = 0;
                  }

                  // remove video listeners
                  if (media && (this || _global).onvseeking && (this || _global).onvended) {
                    media.removeEventListener("seeking", (this || _global).onvseeking);
                    media.removeEventListener("ended", (this || _global).onvended);
                    (this || _global).onvseeking = (this || _global).onvended = null;
                  }
                  (this || _global).media = (this || _global).mediaBuffer = null;
                  (this || _global).loadedmetadata = false;
                  (this || _global).fragmentTracker.removeAllFragments();
                  this.stopLoad();
                };
                _proto.onMediaSeeking = function onMediaSeeking() {
                  var config = (this || _global).config,
                    fragCurrent = (this || _global).fragCurrent,
                    media = (this || _global).media,
                    mediaBuffer = (this || _global).mediaBuffer,
                    state = (this || _global).state;
                  var currentTime = media ? media.currentTime : 0;
                  var bufferInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
                  this.log("media seeking to " + ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(currentTime) ? currentTime.toFixed(3) : currentTime) + ", state: " + state);
                  if (state === State.ENDED) {
                    this.resetLoadingState();
                  } else if (fragCurrent) {
                    // Seeking while frag load is in progress
                    var tolerance = config.maxFragLookUpTolerance;
                    var fragStartOffset = fragCurrent.start - tolerance;
                    var fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
                    // if seeking out of buffered range or into new one
                    if (!bufferInfo.len || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
                      var pastFragment = currentTime > fragEndOffset;
                      // if the seek position is outside the current fragment range
                      if (currentTime < fragStartOffset || pastFragment) {
                        if (pastFragment && fragCurrent.loader) {
                          this.log("seeking outside of buffer while fragment load in progress, cancel fragment load");
                          fragCurrent.loader.abort();
                        }
                        this.resetLoadingState();
                      }
                    }
                  }
                  if (media) {
                    (this || _global).lastCurrentTime = currentTime;
                  }

                  // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
                  if (!(this || _global).loadedmetadata && !bufferInfo.len) {
                    (this || _global).nextLoadPosition = (this || _global).startPosition = currentTime;
                  }

                  // Async tick to speed up processing
                  this.tickImmediate();
                };
                _proto.onMediaEnded = function onMediaEnded() {
                  // reset startPosition and lastCurrentTime to restart playback @ stream beginning
                  (this || _global).startPosition = (this || _global).lastCurrentTime = 0;
                };
                _proto.onKeyLoaded = function onKeyLoaded(event, data) {
                  if ((this || _global).state !== State.KEY_LOADING || data.frag !== (this || _global).fragCurrent || !(this || _global).levels) {
                    return;
                  }
                  (this || _global).state = State.IDLE;
                  var levelDetails = (this || _global).levels[data.frag.level].details;
                  if (levelDetails) {
                    this.loadFragment(data.frag, levelDetails, data.frag.start);
                  }
                };
                _proto.onLevelSwitching = function onLevelSwitching(event, data) {
                  (this || _global).fragLoadError = 0;
                };
                _proto.onHandlerDestroying = function onHandlerDestroying() {
                  this.stopLoad();
                  _TaskLoop.prototype.onHandlerDestroying.call(this || _global);
                };
                _proto.onHandlerDestroyed = function onHandlerDestroyed() {
                  (this || _global).state = State.STOPPED;
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_5__.Events.KEY_LOADED, (this || _global).onKeyLoaded, this || _global);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_5__.Events.LEVEL_SWITCHING, (this || _global).onLevelSwitching, this || _global);
                  if ((this || _global).fragmentLoader) {
                    (this || _global).fragmentLoader.destroy();
                  }
                  if ((this || _global).decrypter) {
                    (this || _global).decrypter.destroy();
                  }
                  (this || _global).hls = (this || _global).log = (this || _global).warn = (this || _global).decrypter = (this || _global).fragmentLoader = (this || _global).fragmentTracker = null;
                  _TaskLoop.prototype.onHandlerDestroyed.call(this || _global);
                };
                _proto.loadKey = function loadKey(frag, details) {
                  this.log("Loading key for " + frag.sn + " of [" + details.startSN + "-" + details.endSN + "], " + ((this || _global).logPrefix === "[stream-controller]" ? "level" : "track") + " " + frag.level);
                  (this || _global).state = State.KEY_LOADING;
                  (this || _global).fragCurrent = frag;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.KEY_LOADING, {
                    frag: frag
                  });
                };
                _proto.loadFragment = function loadFragment(frag, levelDetails, targetBufferTime) {
                  this._loadFragForPlayback(frag, levelDetails, targetBufferTime);
                };
                _proto._loadFragForPlayback = function _loadFragForPlayback(frag, levelDetails, targetBufferTime) {
                  var _this2 = this || _global;
                  var progressCallback = function progressCallback(data) {
                    if (_this2.fragContextChanged(frag)) {
                      _this2.warn("Fragment " + frag.sn + (data.part ? " p: " + data.part.index : "") + " of level " + frag.level + " was dropped during download.");
                      _this2.fragmentTracker.removeFragment(frag);
                      return;
                    }
                    frag.stats.chunkCount++;
                    _this2._handleFragmentLoadProgress(data);
                  };
                  this._doFragLoad(frag, levelDetails, targetBufferTime, progressCallback).then(function (data) {
                    if (!data) {
                      // if we're here we probably needed to backtrack or are waiting for more parts
                      return;
                    }
                    _this2.fragLoadError = 0;
                    var state = _this2.state;
                    if (_this2.fragContextChanged(frag)) {
                      if (state === State.FRAG_LOADING || !_this2.fragCurrent && state === State.PARSING) {
                        _this2.fragmentTracker.removeFragment(frag);
                        _this2.state = State.IDLE;
                      }
                      return;
                    }
                    if ("payload" in data) {
                      _this2.log("Loaded fragment " + frag.sn + " of level " + frag.level);
                      _this2.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_LOADED, data);
                    }

                    // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
                    _this2._handleFragmentLoadComplete(data);
                  }).catch(function (reason) {
                    if (_this2.state === State.STOPPED || _this2.state === State.ERROR) {
                      return;
                    }
                    _this2.warn(reason);
                    _this2.resetFragmentLoading(frag);
                  });
                };
                _proto.flushMainBuffer = function flushMainBuffer(startOffset, endOffset, type) {
                  if (type === void 0) {
                    type = null;
                  }
                  if (!(startOffset - endOffset)) {
                    return;
                  }
                  // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
                  // passing a null type flushes both buffers
                  var flushScope = {
                    startOffset: startOffset,
                    endOffset: endOffset,
                    type: type
                  };
                  // Reset load errors on flush
                  (this || _global).fragLoadError = 0;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.BUFFER_FLUSHING, flushScope);
                };
                _proto._loadInitSegment = function _loadInitSegment(frag) {
                  var _this3 = this || _global;
                  this._doFragLoad(frag).then(function (data) {
                    if (!data || _this3.fragContextChanged(frag) || !_this3.levels) {
                      throw new Error("init load aborted");
                    }
                    return data;
                  }).then(function (data) {
                    var hls = _this3.hls;
                    var payload = data.payload;
                    var decryptData = frag.decryptdata;

                    // check to see if the payload needs to be decrypted
                    if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === "AES-128") {
                      var startTime = self.performance.now();
                      // decrypt the subtitles
                      return _this3.decrypter.webCryptoDecrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).then(function (decryptedData) {
                        var endTime = self.performance.now();
                        hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_DECRYPTED, {
                          frag: frag,
                          payload: decryptedData,
                          stats: {
                            tstart: startTime,
                            tdecrypt: endTime
                          }
                        });
                        data.payload = decryptedData;
                        return data;
                      });
                    }
                    return data;
                  }).then(function (data) {
                    var fragCurrent = _this3.fragCurrent,
                      hls = _this3.hls,
                      levels = _this3.levels;
                    if (!levels) {
                      throw new Error("init load aborted, missing levels");
                    }
                    var details = levels[frag.level].details;
                    console.assert(details, "Level details are defined when init segment is loaded");
                    var stats = frag.stats;
                    _this3.state = State.IDLE;
                    _this3.fragLoadError = 0;
                    frag.data = new Uint8Array(data.payload);
                    stats.parsing.start = stats.buffering.start = self.performance.now();
                    stats.parsing.end = stats.buffering.end = self.performance.now();

                    // Silence FRAG_BUFFERED event if fragCurrent is null
                    if (data.frag === fragCurrent) {
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_BUFFERED, {
                        stats: stats,
                        frag: fragCurrent,
                        part: null,
                        id: frag.type
                      });
                    }
                    _this3.tick();
                  }).catch(function (reason) {
                    if (_this3.state === State.STOPPED || _this3.state === State.ERROR) {
                      return;
                    }
                    _this3.warn(reason);
                    _this3.resetFragmentLoading(frag);
                  });
                };
                _proto.fragContextChanged = function fragContextChanged(frag) {
                  var fragCurrent = (this || _global).fragCurrent;
                  return !frag || !fragCurrent || frag.level !== fragCurrent.level || frag.sn !== fragCurrent.sn || frag.urlId !== fragCurrent.urlId;
                };
                _proto.fragBufferedComplete = function fragBufferedComplete(frag, part) {
                  var _this$fragCurrent, _this$fragPrevious;
                  var media = (this || _global).mediaBuffer ? (this || _global).mediaBuffer : (this || _global).media;
                  this.log("Buffered " + frag.type + " sn: " + frag.sn + (part ? " part: " + part.index : "") + " of " + ((this || _global).logPrefix === "[stream-controller]" ? "level" : "track") + " " + frag.level + " " + (media ? _utils_time_ranges__WEBPACK_IMPORTED_MODULE_14__["default"].toString(_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.getBuffered(media)) : "(detached)"));
                  (this || _global).state = State.IDLE;
                  if (!media) {
                    return;
                  }
                  if (!(this || _global).loadedmetadata && frag.type == _types_loader__WEBPACK_IMPORTED_MODULE_15__.PlaylistLevelType.MAIN && media.buffered.length && ((_this$fragCurrent = (this || _global).fragCurrent) === null || _this$fragCurrent === void 0 ? void 0 : _this$fragCurrent.sn) === ((_this$fragPrevious = (this || _global).fragPrevious) === null || _this$fragPrevious === void 0 ? void 0 : _this$fragPrevious.sn)) {
                    (this || _global).loadedmetadata = true;
                    this.seekToStartPos();
                  }
                  this.tick();
                };
                _proto.seekToStartPos = function seekToStartPos() {};
                _proto._handleFragmentLoadComplete = function _handleFragmentLoadComplete(fragLoadedEndData) {
                  var transmuxer = (this || _global).transmuxer;
                  if (!transmuxer) {
                    return;
                  }
                  var frag = fragLoadedEndData.frag,
                    part = fragLoadedEndData.part,
                    partsLoaded = fragLoadedEndData.partsLoaded;
                  // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
                  var complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some(function (fragLoaded) {
                    return !fragLoaded;
                  });
                  var chunkMeta = new _types_transmuxer__WEBPACK_IMPORTED_MODULE_7__.ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
                  transmuxer.flush(chunkMeta);
                }

                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                ;

                _proto._handleFragmentLoadProgress = function _handleFragmentLoadProgress(frag) {};
                _proto._doFragLoad = function _doFragLoad(frag, details, targetBufferTime, progressCallback) {
                  var _this4 = this || _global;
                  if (targetBufferTime === void 0) {
                    targetBufferTime = null;
                  }
                  if (!(this || _global).levels) {
                    throw new Error("frag load aborted, missing levels");
                  }
                  targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
                  if ((this || _global).config.lowLatencyMode && details) {
                    var partList = details.partList;
                    if (partList && progressCallback) {
                      if (targetBufferTime > frag.end && details.fragmentHint) {
                        frag = details.fragmentHint;
                      }
                      var partIndex = this.getNextPart(partList, frag, targetBufferTime);
                      if (partIndex > -1) {
                        var part = partList[partIndex];
                        this.log("Loading part sn: " + frag.sn + " p: " + part.index + " cc: " + frag.cc + " of playlist [" + details.startSN + "-" + details.endSN + "] parts [0-" + partIndex + "-" + (partList.length - 1) + "] " + ((this || _global).logPrefix === "[stream-controller]" ? "level" : "track") + ": " + frag.level + ", target: " + parseFloat(targetBufferTime.toFixed(3)));
                        (this || _global).nextLoadPosition = part.start + part.duration;
                        (this || _global).state = State.FRAG_LOADING;
                        (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_LOADING, {
                          frag: frag,
                          part: partList[partIndex],
                          targetBufferTime: targetBufferTime
                        });
                        return this.doFragPartsLoad(frag, partList, partIndex, progressCallback).catch(function (error) {
                          return _this4.handleFragLoadError(error);
                        });
                      } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) {
                        // Fragment hint has no parts
                        return Promise.resolve(null);
                      }
                    }
                  }
                  this.log("Loading fragment " + frag.sn + " cc: " + frag.cc + " " + (details ? "of [" + details.startSN + "-" + details.endSN + "] " : "") + ((this || _global).logPrefix === "[stream-controller]" ? "level" : "track") + ": " + frag.level + ", target: " + parseFloat(targetBufferTime.toFixed(3)));
                  // Don't update nextLoadPosition for fragments which are not buffered
                  if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.sn) && !(this || _global).bitrateTest) {
                    (this || _global).nextLoadPosition = frag.start + frag.duration;
                  }
                  (this || _global).state = State.FRAG_LOADING;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_LOADING, {
                    frag: frag,
                    targetBufferTime: targetBufferTime
                  });
                  return (this || _global).fragmentLoader.load(frag, progressCallback).catch(function (error) {
                    return _this4.handleFragLoadError(error);
                  });
                };
                _proto.doFragPartsLoad = function doFragPartsLoad(frag, partList, partIndex, progressCallback) {
                  var _this5 = this || _global;
                  return new Promise(function (resolve, reject) {
                    var partsLoaded = [];
                    var loadPartIndex = function loadPartIndex(index) {
                      var part = partList[index];
                      _this5.fragmentLoader.loadPart(frag, part, progressCallback).then(function (partLoadedData) {
                        partsLoaded[part.index] = partLoadedData;
                        var loadedPart = partLoadedData.part;
                        _this5.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_LOADED, partLoadedData);
                        var nextPart = partList[index + 1];
                        if (nextPart && nextPart.fragment === frag) {
                          loadPartIndex(index + 1);
                        } else {
                          return resolve({
                            frag: frag,
                            part: loadedPart,
                            partsLoaded: partsLoaded
                          });
                        }
                      }).catch(reject);
                    };
                    loadPartIndex(partIndex);
                  });
                };
                _proto.handleFragLoadError = function handleFragLoadError(_ref) {
                  var data = _ref.data;
                  if (data && data.details === _errors__WEBPACK_IMPORTED_MODULE_6__.ErrorDetails.INTERNAL_ABORTED) {
                    this.handleFragLoadAborted(data.frag, data.part);
                  } else {
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.ERROR, data);
                  }
                  return null;
                };
                _proto._handleTransmuxerFlush = function _handleTransmuxerFlush(chunkMeta) {
                  var context = this.getCurrentContext(chunkMeta);
                  if (!context || (this || _global).state !== State.PARSING) {
                    if (!(this || _global).fragCurrent) {
                      (this || _global).state = State.IDLE;
                    }
                    return;
                  }
                  var frag = context.frag,
                    part = context.part,
                    level = context.level;
                  var now = self.performance.now();
                  frag.stats.parsing.end = now;
                  if (part) {
                    part.stats.parsing.end = now;
                  }
                  this.updateLevelTiming(frag, part, level, chunkMeta.partial);
                };
                _proto.getCurrentContext = function getCurrentContext(chunkMeta) {
                  var levels = (this || _global).levels;
                  var levelIndex = chunkMeta.level,
                    sn = chunkMeta.sn,
                    partIndex = chunkMeta.part;
                  if (!levels || !levels[levelIndex]) {
                    this.warn("Levels object was unset while buffering fragment " + sn + " of level " + levelIndex + ". The current chunk will not be buffered.");
                    return null;
                  }
                  var level = levels[levelIndex];
                  var part = partIndex > -1 ? (0, _level_helper__WEBPACK_IMPORTED_MODULE_11__.getPartWith)(level, sn, partIndex) : null;
                  var frag = part ? part.fragment : (0, _level_helper__WEBPACK_IMPORTED_MODULE_11__.getFragmentWithSN)(level, sn, (this || _global).fragCurrent);
                  if (!frag) {
                    return null;
                  }
                  return {
                    frag: frag,
                    part: part,
                    level: level
                  };
                };
                _proto.bufferFragmentData = function bufferFragmentData(data, frag, part, chunkMeta) {
                  if (!data || (this || _global).state !== State.PARSING) {
                    return;
                  }
                  var data1 = data.data1,
                    data2 = data.data2;
                  var buffer = data1;
                  if (data1 && data2) {
                    // Combine the moof + mdat so that we buffer with a single append
                    buffer = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_8__.appendUint8Array)(data1, data2);
                  }
                  if (!buffer || !buffer.length) {
                    return;
                  }
                  var segment = {
                    type: data.type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    parent: frag.type,
                    data: buffer
                  };
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.BUFFER_APPENDING, segment);
                  if (data.dropped && data.independent && !part) {
                    // Clear buffer so that we reload previous segments sequentially if required
                    this.flushBufferGap(frag);
                  }
                };
                _proto.flushBufferGap = function flushBufferGap(frag) {
                  var media = (this || _global).media;
                  if (!media) {
                    return;
                  }
                  // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
                  if (!_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.isBuffered(media, media.currentTime)) {
                    this.flushMainBuffer(0, frag.start);
                    return;
                  }
                  // Remove back-buffer without interrupting playback to allow back tracking
                  var currentTime = media.currentTime;
                  var bufferInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.bufferInfo(media, currentTime, 0);
                  var fragDuration = frag.duration;
                  var segmentFraction = Math.min((this || _global).config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
                  var start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
                  if (frag.start - start > segmentFraction) {
                    this.flushMainBuffer(start, frag.start);
                  }
                };
                _proto.getFwdBufferInfo = function getFwdBufferInfo(bufferable, type) {
                  var config = (this || _global).config;
                  var pos = this.getLoadPosition();
                  if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(pos)) {
                    return null;
                  }
                  var bufferInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.bufferInfo(bufferable, pos, config.maxBufferHole);
                  // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
                  if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
                    var bufferedFragAtPos = (this || _global).fragmentTracker.getBufferedFrag(pos, type);
                    if (bufferedFragAtPos && bufferInfo.nextStart < bufferedFragAtPos.end) {
                      return _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.bufferInfo(bufferable, pos, Math.max(bufferInfo.nextStart, config.maxBufferHole));
                    }
                  }
                  return bufferInfo;
                };
                _proto.getMaxBufferLength = function getMaxBufferLength(levelBitrate) {
                  var config = (this || _global).config;
                  var maxBufLen;
                  if (levelBitrate) {
                    maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
                  } else {
                    maxBufLen = config.maxBufferLength;
                  }
                  return Math.min(maxBufLen, config.maxMaxBufferLength);
                };
                _proto.reduceMaxBufferLength = function reduceMaxBufferLength(threshold) {
                  var config = (this || _global).config;
                  var minLength = threshold || config.maxBufferLength;
                  if (config.maxMaxBufferLength >= minLength) {
                    // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
                    config.maxMaxBufferLength /= 2;
                    this.warn("Reduce max buffer length to " + config.maxMaxBufferLength + "s");
                    return true;
                  }
                  return false;
                };
                _proto.getNextFragment = function getNextFragment(pos, levelDetails) {
                  var fragments = levelDetails.fragments;
                  var fragLen = fragments.length;
                  if (!fragLen) {
                    return null;
                  }

                  // find fragment index, contiguous with end of buffer position
                  var config = (this || _global).config;
                  var start = fragments[0].start;
                  var frag;
                  if (levelDetails.live) {
                    var initialLiveManifestSize = config.initialLiveManifestSize;
                    if (fragLen < initialLiveManifestSize) {
                      this.warn("Not enough fragments to start playback (have: " + fragLen + ", need: " + initialLiveManifestSize + ")");
                      return null;
                    }
                    // The real fragment start times for a live stream are only known after the PTS range for that level is known.
                    // In order to discover the range, we load the best matching fragment for that level and demux it.
                    // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
                    // we get the fragment matching that start time
                    if (!levelDetails.PTSKnown && !(this || _global).startFragRequested && (this || _global).startPosition === -1) {
                      frag = this.getInitialLiveFragment(levelDetails, fragments);
                      (this || _global).startPosition = frag ? (this || _global).hls.liveSyncPosition || frag.start : pos;
                    }
                  } else if (pos <= start) {
                    // VoD playlist: if loadPosition before start of playlist, load first fragment
                    frag = fragments[0];
                  }

                  // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
                  if (!frag) {
                    var end = config.lowLatencyMode ? levelDetails.partEnd : levelDetails.fragmentEnd;
                    frag = this.getFragmentAtPosition(pos, end, levelDetails);
                  }
                  return this.mapToInitFragWhenRequired(frag);
                };
                _proto.mapToInitFragWhenRequired = function mapToInitFragWhenRequired(frag) {
                  // If an initSegment is present, it must be buffered first
                  if (frag !== null && frag !== void 0 && frag.initSegment && !(frag !== null && frag !== void 0 && frag.initSegment.data) && !(this || _global).bitrateTest) {
                    return frag.initSegment;
                  }
                  return frag;
                };
                _proto.getNextPart = function getNextPart(partList, frag, targetBufferTime) {
                  var nextPart = -1;
                  var contiguous = false;
                  var independentAttrOmitted = true;
                  for (var i = 0, len = partList.length; i < len; i++) {
                    var part = partList[i];
                    independentAttrOmitted = independentAttrOmitted && !part.independent;
                    if (nextPart > -1 && targetBufferTime < part.start) {
                      break;
                    }
                    var loaded = part.loaded;
                    if (!loaded && (contiguous || part.independent || independentAttrOmitted) && part.fragment === frag) {
                      nextPart = i;
                    }
                    contiguous = loaded;
                  }
                  return nextPart;
                };
                _proto.loadedEndOfParts = function loadedEndOfParts(partList, targetBufferTime) {
                  var lastPart = partList[partList.length - 1];
                  return lastPart && targetBufferTime > lastPart.start && lastPart.loaded;
                }

                /*
                 This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
                 "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
                 start and end times for each fragment in the playlist (after which this method will not need to be called).
                */;
                _proto.getInitialLiveFragment = function getInitialLiveFragment(levelDetails, fragments) {
                  var fragPrevious = (this || _global).fragPrevious;
                  var frag = null;
                  if (fragPrevious) {
                    if (levelDetails.hasProgramDateTime) {
                      // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
                      this.log("Live playlist, switching playlist, load frag with same PDT: " + fragPrevious.programDateTime);
                      frag = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_10__.findFragmentByPDT)(fragments, fragPrevious.endProgramDateTime, (this || _global).config.maxFragLookUpTolerance);
                    }
                    if (!frag) {
                      // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
                      var targetSN = fragPrevious.sn + 1;
                      if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                        var fragNext = fragments[targetSN - levelDetails.startSN];
                        // Ensure that we're staying within the continuity range, since PTS resets upon a new range
                        if (fragPrevious.cc === fragNext.cc) {
                          frag = fragNext;
                          this.log("Live playlist, switching playlist, load frag with next SN: " + frag.sn);
                        }
                      }
                      // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
                      // will have the wrong start times
                      if (!frag) {
                        frag = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_10__.findFragWithCC)(fragments, fragPrevious.cc);
                        if (frag) {
                          this.log("Live playlist, switching playlist, load frag with same CC: " + frag.sn);
                        }
                      }
                    }
                  } else {
                    // Find a new start fragment when fragPrevious is null
                    var liveStart = (this || _global).hls.liveSyncPosition;
                    if (liveStart !== null) {
                      frag = this.getFragmentAtPosition(liveStart, (this || _global).bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
                    }
                  }
                  return frag;
                }

                /*
                This method finds the best matching fragment given the provided position.
                 */;
                _proto.getFragmentAtPosition = function getFragmentAtPosition(bufferEnd, end, levelDetails) {
                  var config = (this || _global).config;
                  var fragPrevious = (this || _global).fragPrevious;
                  var fragments = levelDetails.fragments,
                    endSN = levelDetails.endSN;
                  var fragmentHint = levelDetails.fragmentHint;
                  var tolerance = config.maxFragLookUpTolerance;
                  var loadingParts = !!(config.lowLatencyMode && levelDetails.partList && fragmentHint);
                  if (loadingParts && fragmentHint && !(this || _global).bitrateTest) {
                    // Include incomplete fragment with parts at end
                    fragments = fragments.concat(fragmentHint);
                    endSN = fragmentHint.sn;
                  }
                  var frag;
                  if (bufferEnd < end) {
                    var lookupTolerance = bufferEnd > end - tolerance ? 0 : tolerance;
                    // Remove the tolerance if it would put the bufferEnd past the actual end of stream
                    // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
                    frag = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_10__.findFragmentByPTS)(fragPrevious, fragments, bufferEnd, lookupTolerance);
                  } else {
                    // reach end of playlist
                    frag = fragments[fragments.length - 1];
                  }
                  if (frag) {
                    var curSNIdx = frag.sn - levelDetails.startSN;
                    // Move fragPrevious forward to support forcing the next fragment to load
                    // when the buffer catches up to a previously buffered range.
                    if ((this || _global).fragmentTracker.getState(frag) === _fragment_tracker__WEBPACK_IMPORTED_MODULE_2__.FragmentState.OK) {
                      fragPrevious = frag;
                    }
                    if (fragPrevious && frag.sn === fragPrevious.sn && !loadingParts) {
                      // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
                      // non-uniform fragment durations
                      var sameLevel = fragPrevious && frag.level === fragPrevious.level;
                      if (sameLevel) {
                        var nextFrag = fragments[curSNIdx + 1];
                        if (frag.sn < endSN && (this || _global).fragmentTracker.getState(nextFrag) !== _fragment_tracker__WEBPACK_IMPORTED_MODULE_2__.FragmentState.OK) {
                          this.log("SN " + frag.sn + " just loaded, load next one: " + nextFrag.sn);
                          frag = nextFrag;
                        } else {
                          frag = null;
                        }
                      }
                    }
                  }
                  return frag;
                };
                _proto.synchronizeToLiveEdge = function synchronizeToLiveEdge(levelDetails) {
                  var config = (this || _global).config,
                    media = (this || _global).media;
                  if (!media) {
                    return;
                  }
                  var liveSyncPosition = (this || _global).hls.liveSyncPosition;
                  var currentTime = media.currentTime;
                  var start = levelDetails.fragments[0].start;
                  var end = levelDetails.edge;
                  var withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
                  // Continue if we can seek forward to sync position or if current time is outside of sliding window
                  if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
                    // Continue if buffer is starving or if current time is behind max latency
                    var maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
                    if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
                      if (!(this || _global).loadedmetadata) {
                        (this || _global).nextLoadPosition = liveSyncPosition;
                      }
                      // Only seek if ready and there is not a significant forward buffer available for playback
                      if (media.readyState) {
                        this.warn("Playback: " + currentTime.toFixed(3) + " is located too far from the end of live sliding playlist: " + end + ", reset currentTime to : " + liveSyncPosition.toFixed(3));
                        media.currentTime = liveSyncPosition;
                      }
                    }
                  }
                };
                _proto.alignPlaylists = function alignPlaylists(details, previousDetails) {
                  var levels = (this || _global).levels,
                    levelLastLoaded = (this || _global).levelLastLoaded,
                    fragPrevious = (this || _global).fragPrevious;
                  var lastLevel = levelLastLoaded !== null ? levels[levelLastLoaded] : null;

                  // FIXME: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
                  //  this could all go in level-helper mergeDetails()
                  var length = details.fragments.length;
                  if (!length) {
                    this.warn("No fragments in live playlist");
                    return 0;
                  }
                  var slidingStart = details.fragments[0].start;
                  var firstLevelLoad = !previousDetails;
                  var aligned = details.alignedSliding && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(slidingStart);
                  if (firstLevelLoad || !aligned && !slidingStart) {
                    (0, _utils_discontinuities__WEBPACK_IMPORTED_MODULE_9__.alignStream)(fragPrevious, lastLevel, details);
                    var alignedSlidingStart = details.fragments[0].start;
                    this.log("Live playlist sliding: " + alignedSlidingStart.toFixed(2) + " start-sn: " + (previousDetails ? previousDetails.startSN : "na") + "->" + details.startSN + " prev-sn: " + (fragPrevious ? fragPrevious.sn : "na") + " fragments: " + length);
                    return alignedSlidingStart;
                  }
                  return slidingStart;
                };
                _proto.waitForCdnTuneIn = function waitForCdnTuneIn(details) {
                  // Wait for Low-Latency CDN Tune-in to get an updated playlist
                  var advancePartLimit = 3;
                  return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
                };
                _proto.setStartPosition = function setStartPosition(details, sliding) {
                  // compute start position if set to -1. use it straight away if value is defined
                  var startPosition = (this || _global).startPosition;
                  if (startPosition < sliding) {
                    startPosition = -1;
                  }
                  if (startPosition === -1 || (this || _global).lastCurrentTime === -1) {
                    // first, check if start time offset has been set in playlist, if yes, use this value
                    var startTimeOffset = details.startTimeOffset;
                    if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(startTimeOffset)) {
                      startPosition = sliding + startTimeOffset;
                      if (startTimeOffset < 0) {
                        startPosition += details.totalduration;
                      }
                      startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
                      this.log("Start time offset " + startTimeOffset + " found in playlist, adjust startPosition to " + startPosition);
                      (this || _global).startPosition = startPosition;
                    } else if (details.live) {
                      // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
                      // not been specified via the config or an as an argument to startLoad (#3736).
                      startPosition = (this || _global).hls.liveSyncPosition || sliding;
                    } else {
                      (this || _global).startPosition = startPosition = 0;
                    }
                    (this || _global).lastCurrentTime = startPosition;
                  }
                  (this || _global).nextLoadPosition = startPosition;
                };
                _proto.getLoadPosition = function getLoadPosition() {
                  var media = (this || _global).media;
                  // if we have not yet loaded any fragment, start loading from start position
                  var pos = 0;
                  if ((this || _global).loadedmetadata && media) {
                    pos = media.currentTime;
                  } else if ((this || _global).nextLoadPosition) {
                    pos = (this || _global).nextLoadPosition;
                  }
                  return pos;
                };
                _proto.handleFragLoadAborted = function handleFragLoadAborted(frag, part) {
                  if ((this || _global).transmuxer && frag.sn !== "initSegment" && frag.stats.aborted) {
                    this.warn("Fragment " + frag.sn + (part ? " part" + part.index : "") + " of level " + frag.level + " was aborted");
                    this.resetFragmentLoading(frag);
                  }
                };
                _proto.resetFragmentLoading = function resetFragmentLoading(frag) {
                  if (!(this || _global).fragCurrent || !this.fragContextChanged(frag) && (this || _global).state !== State.FRAG_LOADING_WAITING_RETRY) {
                    (this || _global).state = State.IDLE;
                  }
                };
                _proto.onFragmentOrKeyLoadError = function onFragmentOrKeyLoadError(filterType, data) {
                  if (data.fatal) {
                    return;
                  }
                  var frag = data.frag;
                  // Handle frag error related to caller's filterType
                  if (!frag || frag.type !== filterType) {
                    return;
                  }
                  var fragCurrent = (this || _global).fragCurrent;
                  console.assert(fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level && frag.urlId === fragCurrent.urlId, "Frag load error must match current frag to retry");
                  var config = (this || _global).config;
                  // keep retrying until the limit will be reached
                  if ((this || _global).fragLoadError + 1 <= config.fragLoadingMaxRetry) {
                    if (!(this || _global).loadedmetadata) {
                      (this || _global).startFragRequested = false;
                      (this || _global).nextLoadPosition = (this || _global).startPosition;
                    }
                    // exponential backoff capped to config.fragLoadingMaxRetryTimeout
                    var delay = Math.min(Math.pow(2, (this || _global).fragLoadError) * config.fragLoadingRetryDelay, config.fragLoadingMaxRetryTimeout);
                    this.warn("Fragment " + frag.sn + " of " + filterType + " " + frag.level + " failed to load, retrying in " + delay + "ms");
                    (this || _global).retryDate = self.performance.now() + delay;
                    (this || _global).fragLoadError++;
                    (this || _global).state = State.FRAG_LOADING_WAITING_RETRY;
                  } else if (data.levelRetry) {
                    if (filterType === _types_loader__WEBPACK_IMPORTED_MODULE_15__.PlaylistLevelType.AUDIO) {
                      // Reset current fragment since audio track audio is essential and may not have a fail-over track
                      (this || _global).fragCurrent = null;
                    }
                    // Fragment errors that result in a level switch or redundant fail-over
                    // should reset the stream controller state to idle
                    (this || _global).fragLoadError = 0;
                    (this || _global).state = State.IDLE;
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.error(data.details + " reaches max retry, redispatch as fatal ...");
                    // switch error to fatal
                    data.fatal = true;
                    (this || _global).hls.stopLoad();
                    (this || _global).state = State.ERROR;
                  }
                };
                _proto.afterBufferFlushed = function afterBufferFlushed(media, bufferType, playlistType) {
                  if (!media) {
                    return;
                  }
                  // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
                  // (so that we will check against video.buffered ranges in case of alt audio track)
                  var bufferedTimeRanges = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_3__.BufferHelper.getBuffered(media);
                  (this || _global).fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
                  if ((this || _global).state === State.ENDED) {
                    this.resetLoadingState();
                  }
                };
                _proto.resetLoadingState = function resetLoadingState() {
                  (this || _global).fragCurrent = null;
                  (this || _global).fragPrevious = null;
                  (this || _global).state = State.IDLE;
                };
                _proto.resetStartWhenNotLoaded = function resetStartWhenNotLoaded(level) {
                  // if loadedmetadata is not set, it means that first frag request failed
                  // in that case, reset startFragRequested flag
                  if (!(this || _global).loadedmetadata) {
                    (this || _global).startFragRequested = false;
                    var details = (this || _global).levels ? (this || _global).levels[level].details : null;
                    if (details !== null && details !== void 0 && details.live) {
                      // Update the start position and return to IDLE to recover live start
                      (this || _global).startPosition = -1;
                      this.setStartPosition(details, 0);
                      this.resetLoadingState();
                    } else {
                      (this || _global).nextLoadPosition = (this || _global).startPosition;
                    }
                  }
                };
                _proto.updateLevelTiming = function updateLevelTiming(frag, part, level, partial) {
                  var _this6 = this || _global;
                  var details = level.details;
                  console.assert(!!details, "level.details must be defined");
                  var parsed = Object.keys(frag.elementaryStreams).reduce(function (result, type) {
                    var info = frag.elementaryStreams[type];
                    if (info) {
                      var parsedDuration = info.endPTS - info.startPTS;
                      if (parsedDuration <= 0) {
                        // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
                        // The new transmuxer will be configured with a time offset matching the next fragment start,
                        // preventing the timeline from shifting.
                        _this6.warn("Could not parse fragment " + frag.sn + " " + type + " duration reliably (" + parsedDuration + ")");
                        return result || false;
                      }
                      var drift = partial ? 0 : (0, _level_helper__WEBPACK_IMPORTED_MODULE_11__.updateFragPTSDTS)(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS);
                      _this6.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.LEVEL_PTS_UPDATED, {
                        details: details,
                        level: level,
                        drift: drift,
                        type: type,
                        frag: frag,
                        start: info.startPTS,
                        end: info.endPTS
                      });
                      return true;
                    }
                    return result;
                  }, false);
                  if (!parsed) {
                    this.warn("Found no media in fragment " + frag.sn + " of level " + level.id + " resetting transmuxer to fallback to playlist timing");
                    this.resetTransmuxer();
                  }
                  (this || _global).state = State.PARSED;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_5__.Events.FRAG_PARSED, {
                    frag: frag,
                    part: part
                  });
                };
                _proto.resetTransmuxer = function resetTransmuxer() {
                  if ((this || _global).transmuxer) {
                    (this || _global).transmuxer.destroy();
                    (this || _global).transmuxer = null;
                  }
                };
                _createClass(BaseStreamController, [{
                  key: "state",
                  get: function get() {
                    return (this || _global)._state;
                  },
                  set: function set(nextState) {
                    var previousState = (this || _global)._state;
                    if (previousState !== nextState) {
                      (this || _global)._state = nextState;
                      this.log(previousState + "->" + nextState);
                    }
                  }
                }]);
                return BaseStreamController;
              }(_task_loop__WEBPACK_IMPORTED_MODULE_1__["default"]);

              /***/
            },

            /***/"./src/controller/buffer-controller.ts":
            /*!*********************************************!*\
              !*** ./src/controller/buffer-controller.ts ***!
              \*********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */BufferController
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/mediasource-helper */"./src/utils/mediasource-helper.ts");
              /* harmony import */
              var _loader_fragment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../loader/fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _buffer_operation_queue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ./buffer-operation-queue */"./src/controller/buffer-operation-queue.ts");
              var MediaSource = (0, _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_5__.getMediaSource)();
              var VIDEO_CODEC_PROFILE_REPACE = /([ha]vc.)(?:\.[^.,]+)+/;
              var BufferController = /*#__PURE__*/function () {
                // The level details used to determine duration, target-duration and live

                // cache the self generated object url to detect hijack of video tag

                // A queue of buffer operations which require the SourceBuffer to not be updating upon execution

                // References to event listeners for each SourceBuffer, so that they can be referenced for event removal

                // The number of BUFFER_CODEC events received before any sourceBuffers are created

                // The total number of BUFFER_CODEC events received

                // A reference to the attached media element

                // A reference to the active media source

                // counters

                function BufferController(_hls) {
                  var _this = this || _global;
                  (this || _global).details = null;
                  (this || _global)._objectUrl = null;
                  (this || _global).operationQueue = void 0;
                  (this || _global).listeners = void 0;
                  (this || _global).hls = void 0;
                  (this || _global).bufferCodecEventsExpected = 0;
                  (this || _global)._bufferCodecEventsTotal = 0;
                  (this || _global).media = null;
                  (this || _global).mediaSource = null;
                  (this || _global).appendError = 0;
                  (this || _global).tracks = {};
                  (this || _global).pendingTracks = {};
                  (this || _global).sourceBuffer = void 0;
                  (this || _global)._onMediaSourceOpen = function () {
                    var hls = _this.hls,
                      media = _this.media,
                      mediaSource = _this.mediaSource;
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Media source opened");
                    if (media) {
                      _this.updateMediaElementDuration();
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHED, {
                        media: media
                      });
                    }
                    if (mediaSource) {
                      // once received, don't listen anymore to sourceopen event
                      mediaSource.removeEventListener("sourceopen", _this._onMediaSourceOpen);
                    }
                    _this.checkPendingTracks();
                  };
                  (this || _global)._onMediaSourceClose = function () {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Media source closed");
                  };
                  (this || _global)._onMediaSourceEnded = function () {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Media source ended");
                  };
                  (this || _global).hls = _hls;
                  this._initSourceBuffer();
                  this.registerListeners();
                }
                var _proto = BufferController.prototype;
                _proto.hasSourceTypes = function hasSourceTypes() {
                  return this.getSourceBufferTypes().length > 0 || Object.keys((this || _global).pendingTracks).length > 0;
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  (this || _global).details = null;
                };
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_RESET, (this || _global).onBufferReset, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_APPENDING, (this || _global).onBufferAppending, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_CODECS, (this || _global).onBufferCodecs, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_EOS, (this || _global).onBufferEos, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSED, (this || _global).onFragParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_CHANGED, (this || _global).onFragChanged, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_RESET, (this || _global).onBufferReset, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_APPENDING, (this || _global).onBufferAppending, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_CODECS, (this || _global).onBufferCodecs, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_EOS, (this || _global).onBufferEos, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSED, (this || _global).onFragParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_CHANGED, (this || _global).onFragChanged, this || _global);
                };
                _proto._initSourceBuffer = function _initSourceBuffer() {
                  (this || _global).sourceBuffer = {};
                  (this || _global).operationQueue = new _buffer_operation_queue__WEBPACK_IMPORTED_MODULE_7__["default"]((this || _global).sourceBuffer);
                  (this || _global).listeners = {
                    audio: [],
                    video: [],
                    audiovideo: []
                  };
                };
                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
                  // sourcebuffers will be created all at once when the expected nb of tracks will be reached
                  // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
                  // it will contain the expected nb of source buffers, no need to compute it
                  var codecEvents = 2;
                  if (data.audio && !data.video || !data.altAudio) {
                    codecEvents = 1;
                  }
                  (this || _global).bufferCodecEventsExpected = (this || _global)._bufferCodecEventsTotal = codecEvents;
                  (this || _global).details = null;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log((this || _global).bufferCodecEventsExpected + " bufferCodec event(s) expected");
                };
                _proto.onMediaAttaching = function onMediaAttaching(event, data) {
                  var media = (this || _global).media = data.media;
                  if (media && MediaSource) {
                    var ms = (this || _global).mediaSource = new MediaSource();
                    // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
                    ms.addEventListener("sourceopen", (this || _global)._onMediaSourceOpen);
                    ms.addEventListener("sourceended", (this || _global)._onMediaSourceEnded);
                    ms.addEventListener("sourceclose", (this || _global)._onMediaSourceClose);
                    // link video and media Source
                    media.src = self.URL.createObjectURL(ms);
                    // cache the locally generated object url
                    (this || _global)._objectUrl = media.src;
                  }
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  var media = (this || _global).media,
                    mediaSource = (this || _global).mediaSource,
                    _objectUrl = (this || _global)._objectUrl;
                  if (mediaSource) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: media source detaching");
                    if (mediaSource.readyState === "open") {
                      try {
                        // endOfStream could trigger exception if any sourcebuffer is in updating state
                        // we don't really care about checking sourcebuffer state here,
                        // as we are anyway detaching the MediaSource
                        // let's just avoid this exception to propagate
                        mediaSource.endOfStream();
                      } catch (err) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: onMediaDetaching: " + err.message + " while calling endOfStream");
                      }
                    }
                    // Clean up the SourceBuffers by invoking onBufferReset
                    this.onBufferReset();
                    mediaSource.removeEventListener("sourceopen", (this || _global)._onMediaSourceOpen);
                    mediaSource.removeEventListener("sourceended", (this || _global)._onMediaSourceEnded);
                    mediaSource.removeEventListener("sourceclose", (this || _global)._onMediaSourceClose);

                    // Detach properly the MediaSource from the HTMLMediaElement as
                    // suggested in https://github.com/w3c/media-source/issues/53.
                    if (media) {
                      if (_objectUrl) {
                        self.URL.revokeObjectURL(_objectUrl);
                      }

                      // clean up video tag src only if it's our own url. some external libraries might
                      // hijack the video tag and change its 'src' without destroying the Hls instance first
                      if (media.src === _objectUrl) {
                        media.removeAttribute("src");
                        media.load();
                      } else {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: media.src was changed by a third party - skip cleanup");
                      }
                    }
                    (this || _global).mediaSource = null;
                    (this || _global).media = null;
                    (this || _global)._objectUrl = null;
                    (this || _global).bufferCodecEventsExpected = (this || _global)._bufferCodecEventsTotal;
                    (this || _global).pendingTracks = {};
                    (this || _global).tracks = {};
                  }
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHED, undefined);
                };
                _proto.onBufferReset = function onBufferReset() {
                  var _this2 = this || _global;
                  this.getSourceBufferTypes().forEach(function (type) {
                    var sb = _this2.sourceBuffer[type];
                    try {
                      if (sb) {
                        _this2.removeBufferListeners(type);
                        if (_this2.mediaSource) {
                          _this2.mediaSource.removeSourceBuffer(sb);
                        }
                        // Synchronously remove the SB from the map before the next call in order to prevent an async function from
                        // accessing it
                        _this2.sourceBuffer[type] = undefined;
                      }
                    } catch (err) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: Failed to reset the " + type + " buffer", err);
                    }
                  });
                  this._initSourceBuffer();
                };
                _proto.onBufferCodecs = function onBufferCodecs(event, data) {
                  var _this3 = this || _global;
                  var sourceBufferCount = this.getSourceBufferTypes().length;
                  Object.keys(data).forEach(function (trackName) {
                    if (sourceBufferCount) {
                      // check if SourceBuffer codec needs to change
                      var track = _this3.tracks[trackName];
                      if (track && typeof track.buffer.changeType === "function") {
                        var _data$trackName = data[trackName],
                          id = _data$trackName.id,
                          codec = _data$trackName.codec,
                          levelCodec = _data$trackName.levelCodec,
                          container = _data$trackName.container,
                          metadata = _data$trackName.metadata;
                        var currentCodec = (track.levelCodec || track.codec).replace(VIDEO_CODEC_PROFILE_REPACE, "$1");
                        var nextCodec = (levelCodec || codec).replace(VIDEO_CODEC_PROFILE_REPACE, "$1");
                        if (currentCodec !== nextCodec) {
                          var mimeType = container + ";codecs=" + (levelCodec || codec);
                          _this3.appendChangeType(trackName, mimeType);
                          _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: switching codec " + currentCodec + " to " + nextCodec);
                          _this3.tracks[trackName] = {
                            buffer: track.buffer,
                            codec: codec,
                            container: container,
                            levelCodec: levelCodec,
                            metadata: metadata,
                            id: id
                          };
                        }
                      }
                    } else {
                      // if source buffer(s) not created yet, appended buffer tracks in this.pendingTracks
                      _this3.pendingTracks[trackName] = data[trackName];
                    }
                  });

                  // if sourcebuffers already created, do nothing ...
                  if (sourceBufferCount) {
                    return;
                  }
                  (this || _global).bufferCodecEventsExpected = Math.max((this || _global).bufferCodecEventsExpected - 1, 0);
                  if ((this || _global).mediaSource && (this || _global).mediaSource.readyState === "open") {
                    this.checkPendingTracks();
                  }
                };
                _proto.appendChangeType = function appendChangeType(type, mimeType) {
                  var _this4 = this || _global;
                  var operationQueue = (this || _global).operationQueue;
                  var operation = {
                    execute: function execute() {
                      var sb = _this4.sourceBuffer[type];
                      if (sb) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: changing " + type + " sourceBuffer type to " + mimeType);
                        sb.changeType(mimeType);
                      }
                      operationQueue.shiftAndExecuteNext(type);
                    },
                    onStart: function onStart() {},
                    onComplete: function onComplete() {},
                    onError: function onError(e) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: Failed to change " + type + " SourceBuffer type", e);
                    }
                  };
                  operationQueue.append(operation, type);
                };
                _proto.onBufferAppending = function onBufferAppending(event, eventData) {
                  var _this5 = this || _global;
                  var hls = (this || _global).hls,
                    operationQueue = (this || _global).operationQueue,
                    tracks = (this || _global).tracks;
                  var data = eventData.data,
                    type = eventData.type,
                    frag = eventData.frag,
                    part = eventData.part,
                    chunkMeta = eventData.chunkMeta;
                  var chunkStats = chunkMeta.buffering[type];
                  var bufferAppendingStart = self.performance.now();
                  chunkStats.start = bufferAppendingStart;
                  var fragBuffering = frag.stats.buffering;
                  var partBuffering = part ? part.stats.buffering : null;
                  if (fragBuffering.start === 0) {
                    fragBuffering.start = bufferAppendingStart;
                  }
                  if (partBuffering && partBuffering.start === 0) {
                    partBuffering.start = bufferAppendingStart;
                  }

                  // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
                  // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
                  // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
                  // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
                  // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
                  var audioTrack = tracks.audio;
                  var checkTimestampOffset = type === "audio" && chunkMeta.id === 1 && (audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.container) === "audio/mpeg";
                  var operation = {
                    execute: function execute() {
                      chunkStats.executeStart = self.performance.now();
                      if (checkTimestampOffset) {
                        var sb = _this5.sourceBuffer[type];
                        if (sb) {
                          var delta = frag.start - sb.timestampOffset;
                          if (Math.abs(delta) >= 0.1) {
                            _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Updating audio SourceBuffer timestampOffset to " + frag.start + " (delta: " + delta + ") sn: " + frag.sn + ")");
                            sb.timestampOffset = frag.start;
                          }
                        }
                      }
                      _this5.appendExecutor(data, type);
                    },
                    onStart: function onStart() {
                      // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
                    },
                    onComplete: function onComplete() {
                      // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
                      var end = self.performance.now();
                      chunkStats.executeEnd = chunkStats.end = end;
                      if (fragBuffering.first === 0) {
                        fragBuffering.first = end;
                      }
                      if (partBuffering && partBuffering.first === 0) {
                        partBuffering.first = end;
                      }
                      var sourceBuffer = _this5.sourceBuffer;
                      var timeRanges = {};
                      for (var _type in sourceBuffer) {
                        timeRanges[_type] = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.getBuffered(sourceBuffer[_type]);
                      }
                      _this5.appendError = 0;
                      _this5.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_APPENDED, {
                        type: type,
                        frag: frag,
                        part: part,
                        chunkMeta: chunkMeta,
                        parent: frag.type,
                        timeRanges: timeRanges
                      });
                    },
                    onError: function onError(err) {
                      // in case any error occured while appending, put back segment in segments table
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("[buffer-controller]: Error encountered while trying to append to the " + type + " SourceBuffer", err);
                      var event = {
                        type: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorTypes.MEDIA_ERROR,
                        parent: frag.type,
                        details: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_APPEND_ERROR,
                        err: err,
                        fatal: false
                      };
                      if (err.code === DOMException.QUOTA_EXCEEDED_ERR) {
                        // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                        // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                        event.details = _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_FULL_ERROR;
                      } else {
                        _this5.appendError++;
                        event.details = _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_APPEND_ERROR;
                        /* with UHD content, we could get loop of quota exceeded error until
                          browser is able to evict some data from sourcebuffer. Retrying can help recover.
                        */
                        if (_this5.appendError > hls.config.appendErrorMaxRetry) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("[buffer-controller]: Failed " + hls.config.appendErrorMaxRetry + " times to append segment in sourceBuffer");
                          event.fatal = true;
                          hls.stopLoad();
                        }
                      }
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, event);
                    }
                  };
                  operationQueue.append(operation, type);
                };
                _proto.onBufferFlushing = function onBufferFlushing(event, data) {
                  var _this6 = this || _global;
                  var operationQueue = (this || _global).operationQueue;
                  var flushOperation = function flushOperation(type) {
                    return {
                      execute: _this6.removeExecutor.bind(_this6, type, data.startOffset, data.endOffset),
                      onStart: function onStart() {
                        // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                      },
                      onComplete: function onComplete() {
                        // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                        _this6.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHED, {
                          type: type
                        });
                      },
                      onError: function onError(e) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: Failed to remove from " + type + " SourceBuffer", e);
                      }
                    };
                  };
                  if (data.type) {
                    operationQueue.append(flushOperation(data.type), data.type);
                  } else {
                    this.getSourceBufferTypes().forEach(function (type) {
                      operationQueue.append(flushOperation(type), type);
                    });
                  }
                };
                _proto.onFragParsed = function onFragParsed(event, data) {
                  var _this7 = this || _global;
                  var frag = data.frag,
                    part = data.part;
                  var buffersAppendedTo = [];
                  var elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
                  if (elementaryStreams[_loader_fragment__WEBPACK_IMPORTED_MODULE_6__.ElementaryStreamTypes.AUDIOVIDEO]) {
                    buffersAppendedTo.push("audiovideo");
                  } else {
                    if (elementaryStreams[_loader_fragment__WEBPACK_IMPORTED_MODULE_6__.ElementaryStreamTypes.AUDIO]) {
                      buffersAppendedTo.push("audio");
                    }
                    if (elementaryStreams[_loader_fragment__WEBPACK_IMPORTED_MODULE_6__.ElementaryStreamTypes.VIDEO]) {
                      buffersAppendedTo.push("video");
                    }
                  }
                  var onUnblocked = function onUnblocked() {
                    var now = self.performance.now();
                    frag.stats.buffering.end = now;
                    if (part) {
                      part.stats.buffering.end = now;
                    }
                    var stats = part ? part.stats : frag.stats;
                    _this7.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_BUFFERED, {
                      frag: frag,
                      part: part,
                      stats: stats,
                      id: frag.type
                    });
                  };
                  if (buffersAppendedTo.length === 0) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Fragments must have at least one ElementaryStreamType set. type: " + frag.type + " level: " + frag.level + " sn: " + frag.sn);
                  }
                  this.blockBuffers(onUnblocked, buffersAppendedTo);
                };
                _proto.onFragChanged = function onFragChanged(event, data) {
                  this.flushBackBuffer();
                }

                // on BUFFER_EOS mark matching sourcebuffer(s) as ended and trigger checkEos()
                // an undefined data.type will mark all buffers as EOS.
                ;

                _proto.onBufferEos = function onBufferEos(event, data) {
                  var _this8 = this || _global;
                  var ended = this.getSourceBufferTypes().reduce(function (acc, type) {
                    var sb = _this8.sourceBuffer[type];
                    if (!data.type || data.type === type) {
                      if (sb && !sb.ended) {
                        sb.ended = true;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: " + type + " sourceBuffer now EOS");
                      }
                    }
                    return acc && !!(!sb || sb.ended);
                  }, true);
                  if (ended) {
                    this.blockBuffers(function () {
                      var mediaSource = _this8.mediaSource;
                      if (!mediaSource || mediaSource.readyState !== "open") {
                        return;
                      }
                      // Allow this to throw and be caught by the enqueueing function
                      mediaSource.endOfStream();
                    });
                  }
                };
                _proto.onLevelUpdated = function onLevelUpdated(event, _ref) {
                  var details = _ref.details;
                  if (!details.fragments.length) {
                    return;
                  }
                  (this || _global).details = details;
                  if (this.getSourceBufferTypes().length) {
                    this.blockBuffers((this || _global).updateMediaElementDuration.bind(this || _global));
                  } else {
                    this.updateMediaElementDuration();
                  }
                };
                _proto.flushBackBuffer = function flushBackBuffer() {
                  var hls = (this || _global).hls,
                    details = (this || _global).details,
                    media = (this || _global).media,
                    sourceBuffer = (this || _global).sourceBuffer;
                  if (!media || details === null) {
                    return;
                  }
                  var sourceBufferTypes = this.getSourceBufferTypes();
                  if (!sourceBufferTypes.length) {
                    return;
                  }

                  // Support for deprecated liveBackBufferLength
                  var backBufferLength = details.live && hls.config.liveBackBufferLength !== null ? hls.config.liveBackBufferLength : hls.config.backBufferLength;
                  if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(backBufferLength) || backBufferLength < 0) {
                    return;
                  }
                  var currentTime = media.currentTime;
                  var targetDuration = details.levelTargetDuration;
                  var maxBackBufferLength = Math.max(backBufferLength, targetDuration);
                  var targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
                  sourceBufferTypes.forEach(function (type) {
                    var sb = sourceBuffer[type];
                    if (sb) {
                      var buffered = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.getBuffered(sb);
                      // when target buffer start exceeds actual buffer start
                      if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                        hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BACK_BUFFER_REACHED, {
                          bufferEnd: targetBackBufferPosition
                        });

                        // Support for deprecated event:
                        if (details.live) {
                          hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LIVE_BACK_BUFFER_REACHED, {
                            bufferEnd: targetBackBufferPosition
                          });
                        }
                        hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, {
                          startOffset: 0,
                          endOffset: targetBackBufferPosition,
                          type: type
                        });
                      }
                    }
                  });
                }

                /**
                 * Update Media Source duration to current level duration or override to Infinity if configuration parameter
                 * 'liveDurationInfinity` is set to `true`
                 * More details: https://github.com/video-dev/hls.js/issues/355
                 */;
                _proto.updateMediaElementDuration = function updateMediaElementDuration() {
                  if (!(this || _global).details || !(this || _global).media || !(this || _global).mediaSource || (this || _global).mediaSource.readyState !== "open") {
                    return;
                  }
                  var details = (this || _global).details,
                    hls = (this || _global).hls,
                    media = (this || _global).media,
                    mediaSource = (this || _global).mediaSource;
                  var levelDuration = details.fragments[0].start + details.totalduration;
                  var mediaDuration = media.duration;
                  var msDuration = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(mediaSource.duration) ? mediaSource.duration : 0;
                  if (details.live && hls.config.liveDurationInfinity) {
                    // Override duration to Infinity
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Media Source duration is set to Infinity");
                    mediaSource.duration = Infinity;
                    this.updateSeekableRange(details);
                  } else if (levelDuration > msDuration && levelDuration > mediaDuration || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(mediaDuration)) {
                    // levelDuration was the last value we set.
                    // not using mediaSource.duration as the browser may tweak this value
                    // only update Media Source duration if its value increase, this is to avoid
                    // flushing already buffered portion when switching between quality level
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Updating Media Source duration to " + levelDuration.toFixed(3));
                    mediaSource.duration = levelDuration;
                  }
                };
                _proto.updateSeekableRange = function updateSeekableRange(levelDetails) {
                  var mediaSource = (this || _global).mediaSource;
                  var fragments = levelDetails.fragments;
                  var len = fragments.length;
                  if (len && levelDetails.live && mediaSource !== null && mediaSource !== void 0 && mediaSource.setLiveSeekableRange) {
                    var start = Math.max(0, fragments[0].start);
                    var end = Math.max(start, start + levelDetails.totalduration);
                    mediaSource.setLiveSeekableRange(start, end);
                  }
                };
                _proto.checkPendingTracks = function checkPendingTracks() {
                  var bufferCodecEventsExpected = (this || _global).bufferCodecEventsExpected,
                    operationQueue = (this || _global).operationQueue,
                    pendingTracks = (this || _global).pendingTracks;

                  // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
                  // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
                  // data has been appended to existing ones.
                  // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
                  var pendingTracksCount = Object.keys(pendingTracks).length;
                  if (pendingTracksCount && !bufferCodecEventsExpected || pendingTracksCount === 2) {
                    // ok, let's create them now !
                    this.createSourceBuffers(pendingTracks);
                    (this || _global).pendingTracks = {};
                    // append any pending segments now !
                    var buffers = this.getSourceBufferTypes();
                    if (buffers.length === 0) {
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                        type: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorTypes.MEDIA_ERROR,
                        details: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                        fatal: true,
                        reason: "could not create source buffer for media codec(s)"
                      });
                      return;
                    }
                    buffers.forEach(function (type) {
                      operationQueue.executeNext(type);
                    });
                  }
                };
                _proto.createSourceBuffers = function createSourceBuffers(tracks) {
                  var sourceBuffer = (this || _global).sourceBuffer,
                    mediaSource = (this || _global).mediaSource;
                  if (!mediaSource) {
                    throw Error("createSourceBuffers called when mediaSource was null");
                  }
                  var tracksCreated = 0;
                  for (var trackName in tracks) {
                    if (!sourceBuffer[trackName]) {
                      var track = tracks[trackName];
                      if (!track) {
                        throw Error("source buffer exists for track " + trackName + ", however track does not");
                      }
                      // use levelCodec as first priority
                      var codec = track.levelCodec || track.codec;
                      var mimeType = track.container + ";codecs=" + codec;
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: creating sourceBuffer(" + mimeType + ")");
                      try {
                        var sb = sourceBuffer[trackName] = mediaSource.addSourceBuffer(mimeType);
                        var sbName = trackName;
                        this.addBufferListener(sbName, "updatestart", (this || _global)._onSBUpdateStart);
                        this.addBufferListener(sbName, "updateend", (this || _global)._onSBUpdateEnd);
                        this.addBufferListener(sbName, "error", (this || _global)._onSBUpdateError);
                        (this || _global).tracks[trackName] = {
                          buffer: sb,
                          codec: codec,
                          container: track.container,
                          levelCodec: track.levelCodec,
                          metadata: track.metadata,
                          id: track.id
                        };
                        tracksCreated++;
                      } catch (err) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("[buffer-controller]: error while trying to add sourceBuffer: " + err.message);
                        (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                          type: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorTypes.MEDIA_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_ADD_CODEC_ERROR,
                          fatal: false,
                          error: err,
                          mimeType: mimeType
                        });
                      }
                    }
                  }
                  if (tracksCreated) {
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_CREATED, {
                      tracks: (this || _global).tracks
                    });
                  }
                }

                // Keep as arrow functions so that we can directly reference these functions directly as event listeners
                ;

                _proto._onSBUpdateStart = function _onSBUpdateStart(type) {
                  var operationQueue = (this || _global).operationQueue;
                  var operation = operationQueue.current(type);
                  operation.onStart();
                };
                _proto._onSBUpdateEnd = function _onSBUpdateEnd(type) {
                  var operationQueue = (this || _global).operationQueue;
                  var operation = operationQueue.current(type);
                  operation.onComplete();
                  operationQueue.shiftAndExecuteNext(type);
                };
                _proto._onSBUpdateError = function _onSBUpdateError(type, event) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("[buffer-controller]: " + type + " SourceBuffer error", event);
                  // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
                  // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                    type: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorTypes.MEDIA_ERROR,
                    details: _errors__WEBPACK_IMPORTED_MODULE_3__.ErrorDetails.BUFFER_APPENDING_ERROR,
                    fatal: false
                  });
                  // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
                  var operation = (this || _global).operationQueue.current(type);
                  if (operation) {
                    operation.onError(event);
                  }
                }

                // This method must result in an updateend event; if remove is not called, _onSBUpdateEnd must be called manually
                ;

                _proto.removeExecutor = function removeExecutor(type, startOffset, endOffset) {
                  var media = (this || _global).media,
                    mediaSource = (this || _global).mediaSource,
                    operationQueue = (this || _global).operationQueue,
                    sourceBuffer = (this || _global).sourceBuffer;
                  var sb = sourceBuffer[type];
                  if (!media || !mediaSource || !sb) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: Attempting to remove from the " + type + " SourceBuffer, but it does not exist");
                    operationQueue.shiftAndExecuteNext(type);
                    return;
                  }
                  var mediaDuration = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(media.duration) ? media.duration : Infinity;
                  var msDuration = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(mediaSource.duration) ? mediaSource.duration : Infinity;
                  var removeStart = Math.max(0, startOffset);
                  var removeEnd = Math.min(endOffset, mediaDuration, msDuration);
                  if (removeEnd > removeStart) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Removing [" + removeStart + "," + removeEnd + "] from the " + type + " SourceBuffer");
                    console.assert(!sb.updating, type + " sourceBuffer must not be updating");
                    sb.remove(removeStart, removeEnd);
                  } else {
                    // Cycle the queue
                    operationQueue.shiftAndExecuteNext(type);
                  }
                }

                // This method must result in an updateend event; if append is not called, _onSBUpdateEnd must be called manually
                ;

                _proto.appendExecutor = function appendExecutor(data, type) {
                  var operationQueue = (this || _global).operationQueue,
                    sourceBuffer = (this || _global).sourceBuffer;
                  var sb = sourceBuffer[type];
                  if (!sb) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[buffer-controller]: Attempting to append to the " + type + " SourceBuffer, but it does not exist");
                    operationQueue.shiftAndExecuteNext(type);
                    return;
                  }
                  sb.ended = false;
                  console.assert(!sb.updating, type + " sourceBuffer must not be updating");
                  sb.appendBuffer(data);
                }

                // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
                // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
                // upon completion, since we already do it here
                ;

                _proto.blockBuffers = function blockBuffers(onUnblocked, buffers) {
                  var _this9 = this || _global;
                  if (buffers === void 0) {
                    buffers = this.getSourceBufferTypes();
                  }
                  if (!buffers.length) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("[buffer-controller]: Blocking operation requested, but no SourceBuffers exist");
                    Promise.resolve().then(onUnblocked);
                    return;
                  }
                  var operationQueue = (this || _global).operationQueue;

                  // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
                  var blockingOperations = buffers.map(function (type) {
                    return operationQueue.appendBlocker(type);
                  });
                  Promise.all(blockingOperations).then(function () {
                    // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
                    onUnblocked();
                    buffers.forEach(function (type) {
                      var sb = _this9.sourceBuffer[type];
                      // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
                      // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
                      // While this is a workaround, it's probably useful to have around
                      if (!sb || !sb.updating) {
                        operationQueue.shiftAndExecuteNext(type);
                      }
                    });
                  });
                };
                _proto.getSourceBufferTypes = function getSourceBufferTypes() {
                  return Object.keys((this || _global).sourceBuffer);
                };
                _proto.addBufferListener = function addBufferListener(type, event, fn) {
                  var buffer = (this || _global).sourceBuffer[type];
                  if (!buffer) {
                    return;
                  }
                  var listener = fn.bind(this || _global, type);
                  (this || _global).listeners[type].push({
                    event: event,
                    listener: listener
                  });
                  buffer.addEventListener(event, listener);
                };
                _proto.removeBufferListeners = function removeBufferListeners(type) {
                  var buffer = (this || _global).sourceBuffer[type];
                  if (!buffer) {
                    return;
                  }
                  (this || _global).listeners[type].forEach(function (l) {
                    buffer.removeEventListener(l.event, l.listener);
                  });
                };
                return BufferController;
              }();

              /***/
            },

            /***/"./src/controller/buffer-operation-queue.ts":
            /*!**************************************************!*\
              !*** ./src/controller/buffer-operation-queue.ts ***!
              \**************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */BufferOperationQueue
                /* harmony export */
              });
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var BufferOperationQueue = /*#__PURE__*/function () {
                function BufferOperationQueue(sourceBufferReference) {
                  (this || _global).buffers = void 0;
                  (this || _global).queues = {
                    video: [],
                    audio: [],
                    audiovideo: []
                  };
                  (this || _global).buffers = sourceBufferReference;
                }
                var _proto = BufferOperationQueue.prototype;
                _proto.append = function append(operation, type) {
                  var queue = (this || _global).queues[type];
                  queue.push(operation);
                  if (queue.length === 1 && (this || _global).buffers[type]) {
                    this.executeNext(type);
                  }
                };
                _proto.insertAbort = function insertAbort(operation, type) {
                  var queue = (this || _global).queues[type];
                  queue.unshift(operation);
                  this.executeNext(type);
                };
                _proto.appendBlocker = function appendBlocker(type) {
                  var execute;
                  var promise = new Promise(function (resolve) {
                    execute = resolve;
                  });
                  var operation = {
                    execute: execute,
                    onStart: function onStart() {},
                    onComplete: function onComplete() {},
                    onError: function onError() {}
                  };
                  this.append(operation, type);
                  return promise;
                };
                _proto.executeNext = function executeNext(type) {
                  var buffers = (this || _global).buffers,
                    queues = (this || _global).queues;
                  var sb = buffers[type];
                  var queue = queues[type];
                  if (queue.length) {
                    var operation = queue[0];
                    try {
                      // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
                      // which do not end with this event must call _onSBUpdateEnd manually
                      operation.execute();
                    } catch (e) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.warn("[buffer-operation-queue]: Unhandled exception executing the current operation");
                      operation.onError(e);

                      // Only shift the current operation off, otherwise the updateend handler will do this for us
                      if (!sb || !sb.updating) {
                        queue.shift();
                        this.executeNext(type);
                      }
                    }
                  }
                };
                _proto.shiftAndExecuteNext = function shiftAndExecuteNext(type) {
                  (this || _global).queues[type].shift();
                  this.executeNext(type);
                };
                _proto.current = function current(type) {
                  return (this || _global).queues[type][0];
                };
                return BufferOperationQueue;
              }();

              /***/
            },

            /***/"./src/controller/cap-level-controller.ts":
            /*!************************************************!*\
              !*** ./src/controller/cap-level-controller.ts ***!
              \************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              /*
               * cap stream level to media size dimension controller
               */

              var CapLevelController = /*#__PURE__*/function () {
                function CapLevelController(hls) {
                  (this || _global).autoLevelCapping = void 0;
                  (this || _global).firstLevel = void 0;
                  (this || _global).media = void 0;
                  (this || _global).restrictedLevels = void 0;
                  (this || _global).timer = void 0;
                  (this || _global).hls = void 0;
                  (this || _global).streamController = void 0;
                  (this || _global).clientRect = void 0;
                  (this || _global).hls = hls;
                  (this || _global).autoLevelCapping = Number.POSITIVE_INFINITY;
                  (this || _global).firstLevel = -1;
                  (this || _global).media = null;
                  (this || _global).restrictedLevels = [];
                  (this || _global).timer = undefined;
                  (this || _global).clientRect = null;
                  this.registerListeners();
                }
                var _proto = CapLevelController.prototype;
                _proto.setStreamController = function setStreamController(streamController) {
                  (this || _global).streamController = streamController;
                };
                _proto.destroy = function destroy() {
                  this.unregisterListener();
                  if ((this || _global).hls.config.capLevelToPlayerSize) {
                    this.stopCapping();
                  }
                  (this || _global).media = null;
                  (this || _global).clientRect = null;
                  // @ts-ignore
                  (this || _global).hls = (this || _global).streamController = null;
                };
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FPS_DROP_LEVEL_CAPPING, (this || _global).onFpsDropLevelCapping, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_CODECS, (this || _global).onBufferCodecs, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                };
                _proto.unregisterListener = function unregisterListener() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FPS_DROP_LEVEL_CAPPING, (this || _global).onFpsDropLevelCapping, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_CODECS, (this || _global).onBufferCodecs, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                };
                _proto.onFpsDropLevelCapping = function onFpsDropLevelCapping(event, data) {
                  // Don't add a restricted level more than once
                  if (CapLevelController.isLevelAllowed(data.droppedLevel, (this || _global).restrictedLevels)) {
                    (this || _global).restrictedLevels.push(data.droppedLevel);
                  }
                };
                _proto.onMediaAttaching = function onMediaAttaching(event, data) {
                  (this || _global).media = data.media instanceof HTMLVideoElement ? data.media : null;
                };
                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  var hls = (this || _global).hls;
                  (this || _global).restrictedLevels = [];
                  (this || _global).firstLevel = data.firstLevel;
                  if (hls.config.capLevelToPlayerSize && data.video) {
                    // Start capping immediately if the manifest has signaled video codecs
                    this.startCapping();
                  }
                }

                // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
                // to the first level
                ;

                _proto.onBufferCodecs = function onBufferCodecs(event, data) {
                  var hls = (this || _global).hls;
                  if (hls.config.capLevelToPlayerSize && data.video) {
                    // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
                    this.startCapping();
                  }
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  this.stopCapping();
                };
                _proto.detectPlayerSize = function detectPlayerSize() {
                  if ((this || _global).media && (this || _global).mediaHeight > 0 && (this || _global).mediaWidth > 0) {
                    var levels = (this || _global).hls.levels;
                    if (levels.length) {
                      var hls = (this || _global).hls;
                      hls.autoLevelCapping = this.getMaxLevel(levels.length - 1);
                      if (hls.autoLevelCapping > (this || _global).autoLevelCapping && (this || _global).streamController) {
                        // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                        // usually happen when the user go to the fullscreen mode.
                        (this || _global).streamController.nextLevelSwitch();
                      }
                      (this || _global).autoLevelCapping = hls.autoLevelCapping;
                    }
                  }
                }

                /*
                 * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
                 */;
                _proto.getMaxLevel = function getMaxLevel(capLevelIndex) {
                  var _this = this || _global;
                  var levels = (this || _global).hls.levels;
                  if (!levels.length) {
                    return -1;
                  }
                  var validLevels = levels.filter(function (level, index) {
                    return CapLevelController.isLevelAllowed(index, _this.restrictedLevels) && index <= capLevelIndex;
                  });
                  (this || _global).clientRect = null;
                  return CapLevelController.getMaxLevelByMediaSize(validLevels, (this || _global).mediaWidth, (this || _global).mediaHeight);
                };
                _proto.startCapping = function startCapping() {
                  if ((this || _global).timer) {
                    // Don't reset capping if started twice; this can happen if the manifest signals a video codec
                    return;
                  }
                  (this || _global).autoLevelCapping = Number.POSITIVE_INFINITY;
                  (this || _global).hls.firstLevel = this.getMaxLevel((this || _global).firstLevel);
                  self.clearInterval((this || _global).timer);
                  (this || _global).timer = self.setInterval((this || _global).detectPlayerSize.bind(this || _global), 1000);
                  this.detectPlayerSize();
                };
                _proto.stopCapping = function stopCapping() {
                  (this || _global).restrictedLevels = [];
                  (this || _global).firstLevel = -1;
                  (this || _global).autoLevelCapping = Number.POSITIVE_INFINITY;
                  if ((this || _global).timer) {
                    self.clearInterval((this || _global).timer);
                    (this || _global).timer = undefined;
                  }
                };
                _proto.getDimensions = function getDimensions() {
                  if ((this || _global).clientRect) {
                    return (this || _global).clientRect;
                  }
                  var media = (this || _global).media;
                  var boundsRect = {
                    width: 0,
                    height: 0
                  };
                  if (media) {
                    var clientRect = media.getBoundingClientRect();
                    boundsRect.width = clientRect.width;
                    boundsRect.height = clientRect.height;
                    if (!boundsRect.width && !boundsRect.height) {
                      // When the media element has no width or height (equivalent to not being in the DOM),
                      // then use its width and height attributes (media.width, media.height)
                      boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
                      boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
                    }
                  }
                  (this || _global).clientRect = boundsRect;
                  return boundsRect;
                };
                CapLevelController.isLevelAllowed = function isLevelAllowed(level, restrictedLevels) {
                  if (restrictedLevels === void 0) {
                    restrictedLevels = [];
                  }
                  return restrictedLevels.indexOf(level) === -1;
                };
                CapLevelController.getMaxLevelByMediaSize = function getMaxLevelByMediaSize(levels, width, height) {
                  if (!levels || !levels.length) {
                    return -1;
                  }

                  // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
                  // to determine whether we've chosen the greatest bandwidth for the media's dimensions
                  var atGreatestBandwidth = function atGreatestBandwidth(curLevel, nextLevel) {
                    if (!nextLevel) {
                      return true;
                    }
                    return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
                  };

                  // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
                  // the max level
                  var maxLevelIndex = levels.length - 1;
                  for (var i = 0; i < levels.length; i += 1) {
                    var level = levels[i];
                    if ((level.width >= width || level.height >= height) && atGreatestBandwidth(level, levels[i + 1])) {
                      maxLevelIndex = i;
                      break;
                    }
                  }
                  return maxLevelIndex;
                };
                _createClass(CapLevelController, [{
                  key: "mediaWidth",
                  get: function get() {
                    return this.getDimensions().width * (this || _global).contentScaleFactor;
                  }
                }, {
                  key: "mediaHeight",
                  get: function get() {
                    return this.getDimensions().height * (this || _global).contentScaleFactor;
                  }
                }, {
                  key: "contentScaleFactor",
                  get: function get() {
                    var pixelRatio = 1;
                    if (!(this || _global).hls.config.ignoreDevicePixelRatio) {
                      try {
                        pixelRatio = self.devicePixelRatio;
                      } catch (e) {
                        /* no-op */
                      }
                    }
                    return pixelRatio;
                  }
                }]);
                return CapLevelController;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = CapLevelController;

              /***/
            },

            /***/"./src/controller/cmcd-controller.ts":
            /*!*******************************************!*\
              !*** ./src/controller/cmcd-controller.ts ***!
              \*******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */CMCDController
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _types_cmcd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../types/cmcd */"./src/types/cmcd.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _createForOfIteratorHelperLoose(o, allowArrayLike) {
                var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
                if (it) return (it = it.call(o)).next.bind(it);
                if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
                  if (it) o = it;
                  var i = 0;
                  return function () {
                    if (i >= o.length) return {
                      done: true
                    };
                    return {
                      done: false,
                      value: o[i++]
                    };
                  };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }
              function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
              }
              function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) {
                  arr2[i] = arr[i];
                }
                return arr2;
              }
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }

              /**
               * Controller to deal with Common Media Client Data (CMCD)
               * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
               */
              var CMCDController = /*#__PURE__*/function () {
                // eslint-disable-line no-restricted-globals
                // eslint-disable-line no-restricted-globals

                function CMCDController(hls) {
                  var _this = this || _global;
                  (this || _global).hls = void 0;
                  (this || _global).config = void 0;
                  (this || _global).media = void 0;
                  (this || _global).sid = void 0;
                  (this || _global).cid = void 0;
                  (this || _global).useHeaders = false;
                  (this || _global).initialized = false;
                  (this || _global).starved = false;
                  (this || _global).buffering = true;
                  (this || _global).audioBuffer = void 0;
                  (this || _global).videoBuffer = void 0;
                  (this || _global).onWaiting = function () {
                    if (_this.initialized) {
                      _this.starved = true;
                    }
                    _this.buffering = true;
                  };
                  (this || _global).onPlaying = function () {
                    if (!_this.initialized) {
                      _this.initialized = true;
                    }
                    _this.buffering = false;
                  };
                  (this || _global).applyPlaylistData = function (context) {
                    try {
                      _this.apply(context, {
                        ot: _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.MANIFEST,
                        su: !_this.initialized
                      });
                    } catch (error) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Could not generate manifest CMCD data.", error);
                    }
                  };
                  (this || _global).applyFragmentData = function (context) {
                    try {
                      var fragment = context.frag;
                      var level = _this.hls.levels[fragment.level];
                      var ot = _this.getObjectType(fragment);
                      var data = {
                        d: fragment.duration * 1000,
                        ot: ot
                      };
                      if (ot === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.VIDEO || ot === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.AUDIO || ot == _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.MUXED) {
                        data.br = level.bitrate / 1000;
                        data.tb = _this.getTopBandwidth(ot) / 1000;
                        data.bl = _this.getBufferLength(ot);
                      }
                      _this.apply(context, data);
                    } catch (error) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Could not generate segment CMCD data.", error);
                    }
                  };
                  (this || _global).hls = hls;
                  var config = (this || _global).config = hls.config;
                  var cmcd = config.cmcd;
                  if (cmcd != null) {
                    config.pLoader = this.createPlaylistLoader();
                    config.fLoader = this.createFragmentLoader();
                    (this || _global).sid = cmcd.sessionId || CMCDController.uuid();
                    (this || _global).cid = cmcd.contentId;
                    (this || _global).useHeaders = cmcd.useHeaders === true;
                    this.registerListeners();
                  }
                }
                var _proto = CMCDController.prototype;
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHED, (this || _global).onMediaDetached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHED, (this || _global).onMediaDetached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                  this.onMediaDetached();
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();

                  // @ts-ignore
                  (this || _global).hls = (this || _global).config = (this || _global).audioBuffer = (this || _global).videoBuffer = null;
                };
                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  (this || _global).media = data.media;
                  (this || _global).media.addEventListener("waiting", (this || _global).onWaiting);
                  (this || _global).media.addEventListener("playing", (this || _global).onPlaying);
                };
                _proto.onMediaDetached = function onMediaDetached() {
                  if (!(this || _global).media) {
                    return;
                  }
                  (this || _global).media.removeEventListener("waiting", (this || _global).onWaiting);
                  (this || _global).media.removeEventListener("playing", (this || _global).onPlaying);

                  // @ts-ignore
                  (this || _global).media = null;
                };
                _proto.onBufferCreated = function onBufferCreated(event, data) {
                  var _data$tracks$audio, _data$tracks$video;
                  (this || _global).audioBuffer = (_data$tracks$audio = data.tracks.audio) === null || _data$tracks$audio === void 0 ? void 0 : _data$tracks$audio.buffer;
                  (this || _global).videoBuffer = (_data$tracks$video = data.tracks.video) === null || _data$tracks$video === void 0 ? void 0 : _data$tracks$video.buffer;
                };
                /**
                 * Create baseline CMCD data
                 */
                _proto.createData = function createData() {
                  var _this$media;
                  return {
                    v: _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDVersion,
                    sf: _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDStreamingFormat.HLS,
                    sid: (this || _global).sid,
                    cid: (this || _global).cid,
                    pr: (_this$media = (this || _global).media) === null || _this$media === void 0 ? void 0 : _this$media.playbackRate,
                    mtp: (this || _global).hls.bandwidthEstimate / 1000
                  };
                }

                /**
                 * Apply CMCD data to a request.
                 */;
                _proto.apply = function apply(context, data) {
                  if (data === void 0) {
                    data = {};
                  }
                  // apply baseline data
                  _extends(data, this.createData());
                  var isVideo = data.ot === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.INIT || data.ot === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.VIDEO || data.ot === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.MUXED;
                  if ((this || _global).starved && isVideo) {
                    data.bs = true;
                    data.su = true;
                    (this || _global).starved = false;
                  }
                  if (data.su == null) {
                    data.su = (this || _global).buffering;
                  }

                  // TODO: Implement rtp, nrr, nor, dl

                  if ((this || _global).useHeaders) {
                    var headers = CMCDController.toHeaders(data);
                    if (!Object.keys(headers).length) {
                      return;
                    }
                    if (!context.headers) {
                      context.headers = {};
                    }
                    _extends(context.headers, headers);
                  } else {
                    var query = CMCDController.toQuery(data);
                    if (!query) {
                      return;
                    }
                    context.url = CMCDController.appendQueryToUri(context.url, query);
                  }
                }

                /**
                 * Apply CMCD data to a manifest request.
                 */;
                /**
                 * The CMCD object type.
                 */
                _proto.getObjectType = function getObjectType(fragment) {
                  var type = fragment.type;
                  if (type === "subtitle") {
                    return _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.TIMED_TEXT;
                  }
                  if (fragment.sn === "initSegment") {
                    return _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.INIT;
                  }
                  if (type === "audio") {
                    return _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.AUDIO;
                  }
                  if (type === "main") {
                    if (!(this || _global).hls.audioTracks.length) {
                      return _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.MUXED;
                    }
                    return _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.VIDEO;
                  }
                  return undefined;
                }

                /**
                 * Get the highest bitrate.
                 */;
                _proto.getTopBandwidth = function getTopBandwidth(type) {
                  var bitrate = 0;
                  var levels;
                  var hls = (this || _global).hls;
                  if (type === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.AUDIO) {
                    levels = hls.audioTracks;
                  } else {
                    var max = hls.maxAutoLevel;
                    var len = max > -1 ? max + 1 : hls.levels.length;
                    levels = hls.levels.slice(0, len);
                  }
                  for (var _iterator = _createForOfIteratorHelperLoose(levels), _step; !(_step = _iterator()).done;) {
                    var level = _step.value;
                    if (level.bitrate > bitrate) {
                      bitrate = level.bitrate;
                    }
                  }
                  return bitrate > 0 ? bitrate : NaN;
                }

                /**
                 * Get the buffer length for a media type in milliseconds
                 */;
                _proto.getBufferLength = function getBufferLength(type) {
                  var media = (this || _global).hls.media;
                  var buffer = type === _types_cmcd__WEBPACK_IMPORTED_MODULE_1__.CMCDObjectType.AUDIO ? (this || _global).audioBuffer : (this || _global).videoBuffer;
                  if (!buffer || !media) {
                    return NaN;
                  }
                  var info = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_2__.BufferHelper.bufferInfo(buffer, media.currentTime, (this || _global).config.maxBufferHole);
                  return info.len * 1000;
                }

                /**
                 * Create a playlist loader
                 */;
                _proto.createPlaylistLoader = function createPlaylistLoader() {
                  var pLoader = (this || _global).config.pLoader;
                  var apply = (this || _global).applyPlaylistData;
                  var Ctor = pLoader || (this || _global).config.loader;
                  return /*#__PURE__*/function () {
                    function CmcdPlaylistLoader(config) {
                      (this || _global).loader = void 0;
                      (this || _global).loader = new Ctor(config);
                    }
                    var _proto2 = CmcdPlaylistLoader.prototype;
                    _proto2.destroy = function destroy() {
                      (this || _global).loader.destroy();
                    };
                    _proto2.abort = function abort() {
                      (this || _global).loader.abort();
                    };
                    _proto2.load = function load(context, config, callbacks) {
                      apply(context);
                      (this || _global).loader.load(context, config, callbacks);
                    };
                    _createClass(CmcdPlaylistLoader, [{
                      key: "stats",
                      get: function get() {
                        return (this || _global).loader.stats;
                      }
                    }, {
                      key: "context",
                      get: function get() {
                        return (this || _global).loader.context;
                      }
                    }]);
                    return CmcdPlaylistLoader;
                  }();
                }

                /**
                 * Create a playlist loader
                 */;
                _proto.createFragmentLoader = function createFragmentLoader() {
                  var fLoader = (this || _global).config.fLoader;
                  var apply = (this || _global).applyFragmentData;
                  var Ctor = fLoader || (this || _global).config.loader;
                  return /*#__PURE__*/function () {
                    function CmcdFragmentLoader(config) {
                      (this || _global).loader = void 0;
                      (this || _global).loader = new Ctor(config);
                    }
                    var _proto3 = CmcdFragmentLoader.prototype;
                    _proto3.destroy = function destroy() {
                      (this || _global).loader.destroy();
                    };
                    _proto3.abort = function abort() {
                      (this || _global).loader.abort();
                    };
                    _proto3.load = function load(context, config, callbacks) {
                      apply(context);
                      (this || _global).loader.load(context, config, callbacks);
                    };
                    _createClass(CmcdFragmentLoader, [{
                      key: "stats",
                      get: function get() {
                        return (this || _global).loader.stats;
                      }
                    }, {
                      key: "context",
                      get: function get() {
                        return (this || _global).loader.context;
                      }
                    }]);
                    return CmcdFragmentLoader;
                  }();
                }

                /**
                 * Generate a random v4 UUI
                 *
                 * @returns {string}
                 */;
                CMCDController.uuid = function uuid() {
                  var url = URL.createObjectURL(new Blob());
                  var uuid = url.toString();
                  URL.revokeObjectURL(url);
                  return uuid.slice(uuid.lastIndexOf("/") + 1);
                }

                /**
                 * Serialize a CMCD data object according to the rules defined in the
                 * section 3.2 of
                 * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
                 */;
                CMCDController.serialize = function serialize(data) {
                  var results = [];
                  var isValid = function isValid(value) {
                    return !Number.isNaN(value) && value != null && value !== "" && value !== false;
                  };
                  var toRounded = function toRounded(value) {
                    return Math.round(value);
                  };
                  var toHundred = function toHundred(value) {
                    return toRounded(value / 100) * 100;
                  };
                  var toUrlSafe = function toUrlSafe(value) {
                    return encodeURIComponent(value);
                  };
                  var formatters = {
                    br: toRounded,
                    d: toRounded,
                    bl: toHundred,
                    dl: toHundred,
                    mtp: toHundred,
                    nor: toUrlSafe,
                    rtp: toHundred,
                    tb: toRounded
                  };
                  var keys = Object.keys(data || {}).sort();
                  for (var _iterator2 = _createForOfIteratorHelperLoose(keys), _step2; !(_step2 = _iterator2()).done;) {
                    var key = _step2.value;
                    var value = data[key];

                    // ignore invalid values
                    if (!isValid(value)) {
                      continue;
                    }

                    // Version should only be reported if not equal to 1.
                    if (key === "v" && value === 1) {
                      continue;
                    }

                    // Playback rate should only be sent if not equal to 1.
                    if (key == "pr" && value === 1) {
                      continue;
                    }

                    // Certain values require special formatting
                    var formatter = formatters[key];
                    if (formatter) {
                      value = formatter(value);
                    }

                    // Serialize the key/value pair
                    var type = typeof value;
                    var result = void 0;
                    if (key === "ot" || key === "sf" || key === "st") {
                      result = key + "=" + value;
                    } else if (type === "boolean") {
                      result = key;
                    } else if (type === "number") {
                      result = key + "=" + value;
                    } else {
                      result = key + "=" + JSON.stringify(value);
                    }
                    results.push(result);
                  }
                  return results.join(",");
                }

                /**
                 * Convert a CMCD data object to request headers according to the rules
                 * defined in the section 2.1 and 3.2 of
                 * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
                 */;
                CMCDController.toHeaders = function toHeaders(data) {
                  var keys = Object.keys(data);
                  var headers = {};
                  var headerNames = ["Object", "Request", "Session", "Status"];
                  var headerGroups = [{}, {}, {}, {}];
                  var headerMap = {
                    br: 0,
                    d: 0,
                    ot: 0,
                    tb: 0,
                    bl: 1,
                    dl: 1,
                    mtp: 1,
                    nor: 1,
                    nrr: 1,
                    su: 1,
                    cid: 2,
                    pr: 2,
                    sf: 2,
                    sid: 2,
                    st: 2,
                    v: 2,
                    bs: 3,
                    rtp: 3
                  };
                  for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
                    var key = _keys[_i];
                    // Unmapped fields are mapped to the Request header
                    var index = headerMap[key] != null ? headerMap[key] : 1;
                    headerGroups[index][key] = data[key];
                  }
                  for (var i = 0; i < headerGroups.length; i++) {
                    var value = CMCDController.serialize(headerGroups[i]);
                    if (value) {
                      headers["CMCD-" + headerNames[i]] = value;
                    }
                  }
                  return headers;
                }

                /**
                 * Convert a CMCD data object to query args according to the rules
                 * defined in the section 2.2 and 3.2 of
                 * [CTA-5004](https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf).
                 */;
                CMCDController.toQuery = function toQuery(data) {
                  return "CMCD=" + encodeURIComponent(CMCDController.serialize(data));
                }

                /**
                 * Append query args to a uri.
                 */;
                CMCDController.appendQueryToUri = function appendQueryToUri(uri, query) {
                  if (!query) {
                    return uri;
                  }
                  var separator = uri.includes("?") ? "&" : "?";
                  return "" + uri + separator + query;
                };
                return CMCDController;
              }();

              /***/
            },

            /***/"./src/controller/eme-controller.ts":
            /*!******************************************!*\
              !*** ./src/controller/eme-controller.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/mediakeys-helper */"./src/utils/mediakeys-helper.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              /**
               * @author Stephan Hesse <disparat@gmail.com> | <tchakabam@gmail.com>
               *
               * DRM support for Hls.js
               */

              var MAX_LICENSE_REQUEST_FAILURES = 3;

              /**
               * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
               * @param {Array<string>} audioCodecs List of required audio codecs to support
               * @param {Array<string>} videoCodecs List of required video codecs to support
               * @param {object} drmSystemOptions Optional parameters/requirements for the key-system
               * @returns {Array<MediaSystemConfiguration>} An array of supported configurations
               */

              var createWidevineMediaKeySystemConfigurations = function createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs, drmSystemOptions) {
                /* jshint ignore:line */
                var baseConfig = {
                  // initDataTypes: ['keyids', 'mp4'],
                  // label: "",
                  // persistentState: "not-allowed", // or "required" ?
                  // distinctiveIdentifier: "not-allowed", // or "required" ?
                  // sessionTypes: ['temporary'],
                  audioCapabilities: [],
                  // { contentType: 'audio/mp4; codecs="mp4a.40.2"' }
                  videoCapabilities: [] // { contentType: 'video/mp4; codecs="avc1.42E01E"' }
                };

                audioCodecs.forEach(function (codec) {
                  baseConfig.audioCapabilities.push({
                    contentType: "audio/mp4; codecs=\"" + codec + "\"",
                    robustness: drmSystemOptions.audioRobustness || ""
                  });
                });
                videoCodecs.forEach(function (codec) {
                  baseConfig.videoCapabilities.push({
                    contentType: "video/mp4; codecs=\"" + codec + "\"",
                    robustness: drmSystemOptions.videoRobustness || ""
                  });
                });
                return [baseConfig];
              };

              /**
               * The idea here is to handle key-system (and their respective platforms) specific configuration differences
               * in order to work with the local requestMediaKeySystemAccess method.
               *
               * We can also rule-out platform-related key-system support at this point by throwing an error.
               *
               * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
               * @param {Array<string>} audioCodecs List of required audio codecs to support
               * @param {Array<string>} videoCodecs List of required video codecs to support
               * @throws will throw an error if a unknown key system is passed
               * @returns {Array<MediaSystemConfiguration>} A non-empty Array of MediaKeySystemConfiguration objects
               */
              var getSupportedMediaKeySystemConfigurations = function getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
                switch (keySystem) {
                  case _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_3__.KeySystems.WIDEVINE:
                    return createWidevineMediaKeySystemConfigurations(audioCodecs, videoCodecs, drmSystemOptions);
                  default:
                    throw new Error("Unknown key-system: " + keySystem);
                }
              };
              /**
               * Controller to deal with encrypted media extensions (EME)
               * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
               *
               * @class
               * @constructor
               */
              var EMEController = /*#__PURE__*/function () {
                /**
                 * @constructs
                 * @param {Hls} hls Our Hls.js instance
                 */
                function EMEController(hls) {
                  (this || _global).hls = void 0;
                  (this || _global)._widevineLicenseUrl = void 0;
                  (this || _global)._licenseXhrSetup = void 0;
                  (this || _global)._licenseResponseCallback = void 0;
                  (this || _global)._emeEnabled = void 0;
                  (this || _global)._requestMediaKeySystemAccess = void 0;
                  (this || _global)._drmSystemOptions = void 0;
                  (this || _global)._config = void 0;
                  (this || _global)._mediaKeysList = [];
                  (this || _global)._media = null;
                  (this || _global)._hasSetMediaKeys = false;
                  (this || _global)._requestLicenseFailureCount = 0;
                  (this || _global).mediaKeysPromise = null;
                  (this || _global)._onMediaEncrypted = (this || _global).onMediaEncrypted.bind(this || _global);
                  (this || _global).hls = hls;
                  (this || _global)._config = hls.config;
                  (this || _global)._widevineLicenseUrl = (this || _global)._config.widevineLicenseUrl;
                  (this || _global)._licenseXhrSetup = (this || _global)._config.licenseXhrSetup;
                  (this || _global)._licenseResponseCallback = (this || _global)._config.licenseResponseCallback;
                  (this || _global)._emeEnabled = (this || _global)._config.emeEnabled;
                  (this || _global)._requestMediaKeySystemAccess = (this || _global)._config.requestMediaKeySystemAccessFunc;
                  (this || _global)._drmSystemOptions = (this || _global)._config.drmSystemOptions;
                  this._registerListeners();
                }
                var _proto = EMEController.prototype;
                _proto.destroy = function destroy() {
                  this._unregisterListeners();
                  // @ts-ignore
                  (this || _global).hls = (this || _global)._onMediaEncrypted = null;
                  (this || _global)._requestMediaKeySystemAccess = null;
                };
                _proto._registerListeners = function _registerListeners() {
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHED, (this || _global).onMediaDetached, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHED, (this || _global).onMediaDetached, this || _global);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                }

                /**
                 * @param {string} keySystem Identifier for the key-system, see `KeySystems` enum
                 * @returns {string} License server URL for key-system (if any configured, otherwise causes error)
                 * @throws if a unsupported keysystem is passed
                 */;
                _proto.getLicenseServerUrl = function getLicenseServerUrl(keySystem) {
                  switch (keySystem) {
                    case _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_3__.KeySystems.WIDEVINE:
                      if (!(this || _global)._widevineLicenseUrl) {
                        break;
                      }
                      return (this || _global)._widevineLicenseUrl;
                  }
                  throw new Error("no license server URL configured for key-system \"" + keySystem + "\"");
                }

                /**
                 * Requests access object and adds it to our list upon success
                 * @private
                 * @param {string} keySystem System ID (see `KeySystems`)
                 * @param {Array<string>} audioCodecs List of required audio codecs to support
                 * @param {Array<string>} videoCodecs List of required video codecs to support
                 * @throws When a unsupported KeySystem is passed
                 */;
                _proto._attemptKeySystemAccess = function _attemptKeySystemAccess(keySystem, audioCodecs, videoCodecs) {
                  var _this = this || _global;
                  // This can throw, but is caught in event handler callpath
                  var mediaKeySystemConfigs = getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, (this || _global)._drmSystemOptions);
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Requesting encrypted media key-system access");

                  // expecting interface like window.navigator.requestMediaKeySystemAccess
                  var keySystemAccessPromise = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
                  (this || _global).mediaKeysPromise = keySystemAccessPromise.then(function (mediaKeySystemAccess) {
                    return _this._onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess);
                  });
                  keySystemAccessPromise.catch(function (err) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Failed to obtain key-system \"" + keySystem + "\" access:", err);
                  });
                };
                /**
                 * Handles obtaining access to a key-system
                 * @private
                 * @param {string} keySystem
                 * @param {MediaKeySystemAccess} mediaKeySystemAccess https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemAccess
                 */
                _proto._onMediaKeySystemAccessObtained = function _onMediaKeySystemAccessObtained(keySystem, mediaKeySystemAccess) {
                  var _this2 = this || _global;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Access for key-system \"" + keySystem + "\" obtained");
                  var mediaKeysListItem = {
                    mediaKeysSessionInitialized: false,
                    mediaKeySystemAccess: mediaKeySystemAccess,
                    mediaKeySystemDomain: keySystem
                  };
                  (this || _global)._mediaKeysList.push(mediaKeysListItem);
                  var mediaKeysPromise = Promise.resolve().then(function () {
                    return mediaKeySystemAccess.createMediaKeys();
                  }).then(function (mediaKeys) {
                    mediaKeysListItem.mediaKeys = mediaKeys;
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Media-keys created for key-system \"" + keySystem + "\"");
                    _this2._onMediaKeysCreated();
                    return mediaKeys;
                  });
                  mediaKeysPromise.catch(function (err) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Failed to create media-keys:", err);
                  });
                  return mediaKeysPromise;
                }

                /**
                 * Handles key-creation (represents access to CDM). We are going to create key-sessions upon this
                 * for all existing keys where no session exists yet.
                 *
                 * @private
                 */;
                _proto._onMediaKeysCreated = function _onMediaKeysCreated() {
                  var _this3 = this || _global;
                  // check for all key-list items if a session exists, otherwise, create one
                  (this || _global)._mediaKeysList.forEach(function (mediaKeysListItem) {
                    if (!mediaKeysListItem.mediaKeysSession) {
                      // mediaKeys is definitely initialized here
                      mediaKeysListItem.mediaKeysSession = mediaKeysListItem.mediaKeys.createSession();
                      _this3._onNewMediaKeySession(mediaKeysListItem.mediaKeysSession);
                    }
                  });
                }

                /**
                 * @private
                 * @param {*} keySession
                 */;
                _proto._onNewMediaKeySession = function _onNewMediaKeySession(keySession) {
                  var _this4 = this || _global;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("New key-system session " + keySession.sessionId);
                  keySession.addEventListener("message", function (event) {
                    _this4._onKeySessionMessage(keySession, event.message);
                  }, false);
                }

                /**
                 * @private
                 * @param {MediaKeySession} keySession
                 * @param {ArrayBuffer} message
                 */;
                _proto._onKeySessionMessage = function _onKeySessionMessage(keySession, message) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Got EME message event, creating license request");
                  this._requestLicense(message, function (data) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Received license data (length: " + (data ? data.byteLength : data) + "), updating key-session");
                    keySession.update(data).catch(function (err) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Updating key-session failed: " + err);
                    });
                  });
                }

                /**
                 * @private
                 * @param e {MediaEncryptedEvent}
                 */;
                _proto.onMediaEncrypted = function onMediaEncrypted(e) {
                  var _this5 = this || _global;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Media is encrypted using \"" + e.initDataType + "\" init data type");
                  if (!(this || _global).mediaKeysPromise) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been requested");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                      fatal: true
                    });
                    return;
                  }
                  var finallySetKeyAndStartSession = function finallySetKeyAndStartSession(mediaKeys) {
                    if (!_this5._media) {
                      return;
                    }
                    _this5._attemptSetMediaKeys(mediaKeys);
                    _this5._generateRequestWithPreferredKeySession(e.initDataType, e.initData);
                  };

                  // Could use `Promise.finally` but some Promise polyfills are missing it
                  (this || _global).mediaKeysPromise.then(finallySetKeyAndStartSession).catch(finallySetKeyAndStartSession);
                }

                /**
                 * @private
                 */;
                _proto._attemptSetMediaKeys = function _attemptSetMediaKeys(mediaKeys) {
                  if (!(this || _global)._media) {
                    throw new Error("Attempted to set mediaKeys without first attaching a media element");
                  }
                  if (!(this || _global)._hasSetMediaKeys) {
                    // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
                    var keysListItem = (this || _global)._mediaKeysList[0];
                    if (!keysListItem || !keysListItem.mediaKeys) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Fatal: Media is encrypted but no CDM access or no keys have been obtained yet");
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                        type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                        details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_KEYS,
                        fatal: true
                      });
                      return;
                    }
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Setting keys for encrypted media");
                    (this || _global)._media.setMediaKeys(keysListItem.mediaKeys);
                    (this || _global)._hasSetMediaKeys = true;
                  }
                }

                /**
                 * @private
                 */;
                _proto._generateRequestWithPreferredKeySession = function _generateRequestWithPreferredKeySession(initDataType, initData) {
                  var _this6 = this || _global;
                  // FIXME: see if we can/want/need-to really to deal with several potential key-sessions?
                  var keysListItem = (this || _global)._mediaKeysList[0];
                  if (!keysListItem) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Fatal: Media is encrypted but not any key-system access has been obtained yet");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: true
                    });
                    return;
                  }
                  if (keysListItem.mediaKeysSessionInitialized) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Key-Session already initialized but requested again");
                    return;
                  }
                  var keySession = keysListItem.mediaKeysSession;
                  if (!keySession) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Fatal: Media is encrypted but no key-session existing");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: true
                    });
                    return;
                  }

                  // initData is null if the media is not CORS-same-origin
                  if (!initData) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Fatal: initData required for generating a key session is null");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_INIT_DATA,
                      fatal: true
                    });
                    return;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Generating key-session request for \"" + initDataType + "\" init data type");
                  keysListItem.mediaKeysSessionInitialized = true;
                  keySession.generateRequest(initDataType, initData).then(function () {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.debug("Key-session generation succeeded");
                  }).catch(function (err) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Error generating key-session request:", err);
                    _this6.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_SESSION,
                      fatal: false
                    });
                  });
                }

                /**
                 * @private
                 * @param {string} url License server URL
                 * @param {ArrayBuffer} keyMessage Message data issued by key-system
                 * @param {function} callback Called when XHR has succeeded
                 * @returns {XMLHttpRequest} Unsent (but opened state) XHR object
                 * @throws if XMLHttpRequest construction failed
                 */;
                _proto._createLicenseXhr = function _createLicenseXhr(url, keyMessage, callback) {
                  var xhr = new XMLHttpRequest();
                  xhr.responseType = "arraybuffer";
                  xhr.onreadystatechange = (this || _global)._onLicenseRequestReadyStageChange.bind(this || _global, xhr, url, keyMessage, callback);
                  var licenseXhrSetup = (this || _global)._licenseXhrSetup;
                  if (licenseXhrSetup) {
                    try {
                      licenseXhrSetup.call((this || _global).hls, xhr, url);
                      licenseXhrSetup = undefined;
                    } catch (e) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error(e);
                    }
                  }
                  try {
                    // if licenseXhrSetup did not yet call open, let's do it now
                    if (!xhr.readyState) {
                      xhr.open("POST", url, true);
                    }
                    if (licenseXhrSetup) {
                      licenseXhrSetup.call((this || _global).hls, xhr, url);
                    }
                  } catch (e) {
                    // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
                    throw new Error("issue setting up KeySystem license XHR " + e);
                  }
                  return xhr;
                }

                /**
                 * @private
                 * @param {XMLHttpRequest} xhr
                 * @param {string} url License server URL
                 * @param {ArrayBuffer} keyMessage Message data issued by key-system
                 * @param {function} callback Called when XHR has succeeded
                 */;
                _proto._onLicenseRequestReadyStageChange = function _onLicenseRequestReadyStageChange(xhr, url, keyMessage, callback) {
                  switch (xhr.readyState) {
                    case 4:
                      if (xhr.status === 200) {
                        (this || _global)._requestLicenseFailureCount = 0;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("License request succeeded");
                        var _data = xhr.response;
                        var licenseResponseCallback = (this || _global)._licenseResponseCallback;
                        if (licenseResponseCallback) {
                          try {
                            _data = licenseResponseCallback.call((this || _global).hls, xhr, url);
                          } catch (e) {
                            _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error(e);
                          }
                        }
                        callback(_data);
                      } else {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("License Request XHR failed (" + url + "). Status: " + xhr.status + " (" + xhr.statusText + ")");
                        (this || _global)._requestLicenseFailureCount++;
                        if ((this || _global)._requestLicenseFailureCount > MAX_LICENSE_REQUEST_FAILURES) {
                          (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                            type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                            details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            fatal: true
                          });
                          return;
                        }
                        var attemptsLeft = MAX_LICENSE_REQUEST_FAILURES - (this || _global)._requestLicenseFailureCount + 1;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Retrying license request, " + attemptsLeft + " attempts left");
                        this._requestLicense(keyMessage, callback);
                      }
                      break;
                  }
                }

                /**
                 * @private
                 * @param {MediaKeysListItem} keysListItem
                 * @param {ArrayBuffer} keyMessage
                 * @returns {ArrayBuffer} Challenge data posted to license server
                 * @throws if KeySystem is unsupported
                 */;
                _proto._generateLicenseRequestChallenge = function _generateLicenseRequestChallenge(keysListItem, keyMessage) {
                  switch (keysListItem.mediaKeySystemDomain) {
                    // case KeySystems.PLAYREADY:
                    // from https://github.com/MicrosoftEdge/Demos/blob/master/eme/scripts/demo.js
                    /*
                    if (this.licenseType !== this.LICENSE_TYPE_WIDEVINE) {
                      // For PlayReady CDMs, we need to dig the Challenge out of the XML.
                      var keyMessageXml = new DOMParser().parseFromString(String.fromCharCode.apply(null, new Uint16Array(keyMessage)), 'application/xml');
                      if (keyMessageXml.getElementsByTagName('Challenge')[0]) {
                          challenge = atob(keyMessageXml.getElementsByTagName('Challenge')[0].childNodes[0].nodeValue);
                      } else {
                          throw 'Cannot find <Challenge> in key message';
                      }
                      var headerNames = keyMessageXml.getElementsByTagName('name');
                      var headerValues = keyMessageXml.getElementsByTagName('value');
                      if (headerNames.length !== headerValues.length) {
                          throw 'Mismatched header <name>/<value> pair in key message';
                      }
                      for (var i = 0; i < headerNames.length; i++) {
                          xhr.setRequestHeader(headerNames[i].childNodes[0].nodeValue, headerValues[i].childNodes[0].nodeValue);
                      }
                    }
                    break;
                    */
                    case _utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_3__.KeySystems.WIDEVINE:
                      // For Widevine CDMs, the challenge is the keyMessage.
                      return keyMessage;
                  }
                  throw new Error("unsupported key-system: " + keysListItem.mediaKeySystemDomain);
                }

                /**
                 * @private
                 * @param keyMessage
                 * @param callback
                 */;
                _proto._requestLicense = function _requestLicense(keyMessage, callback) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Requesting content license for key-system");
                  var keysListItem = (this || _global)._mediaKeysList[0];
                  if (!keysListItem) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Fatal error: Media is encrypted but no key-system access has been obtained yet");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_NO_ACCESS,
                      fatal: true
                    });
                    return;
                  }
                  try {
                    var _url = this.getLicenseServerUrl(keysListItem.mediaKeySystemDomain);
                    var _xhr = this._createLicenseXhr(_url, keyMessage, callback);
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("Sending license request to URL: " + _url);
                    var challenge = this._generateLicenseRequestChallenge(keysListItem, keyMessage);
                    _xhr.send(challenge);
                  } catch (e) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("Failure requesting DRM license: " + e);
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.KEY_SYSTEM_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                      fatal: true
                    });
                  }
                };
                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  if (!(this || _global)._emeEnabled) {
                    return;
                  }
                  var media = data.media;

                  // keep reference of media
                  (this || _global)._media = media;
                  media.addEventListener("encrypted", (this || _global)._onMediaEncrypted);
                };
                _proto.onMediaDetached = function onMediaDetached() {
                  var media = (this || _global)._media;
                  var mediaKeysList = (this || _global)._mediaKeysList;
                  if (!media) {
                    return;
                  }
                  media.removeEventListener("encrypted", (this || _global)._onMediaEncrypted);
                  (this || _global)._media = null;
                  (this || _global)._mediaKeysList = [];
                  // Close all sessions and remove media keys from the video element.
                  Promise.all(mediaKeysList.map(function (mediaKeysListItem) {
                    if (mediaKeysListItem.mediaKeysSession) {
                      return mediaKeysListItem.mediaKeysSession.close().catch(function () {
                        // Ignore errors when closing the sessions. Closing a session that
                        // generated no key requests will throw an error.
                      });
                    }
                  })).then(function () {
                    return media.setMediaKeys(null);
                  }).catch(function () {
                    // Ignore any failures while removing media keys from the video element.
                  });
                };
                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  if (!(this || _global)._emeEnabled) {
                    return;
                  }
                  var audioCodecs = data.levels.map(function (level) {
                    return level.audioCodec;
                  }).filter(function (audioCodec) {
                    return !!audioCodec;
                  });
                  var videoCodecs = data.levels.map(function (level) {
                    return level.videoCodec;
                  }).filter(function (videoCodec) {
                    return !!videoCodec;
                  });
                  this._attemptKeySystemAccess(_utils_mediakeys_helper__WEBPACK_IMPORTED_MODULE_3__.KeySystems.WIDEVINE, audioCodecs, videoCodecs);
                };
                _createClass(EMEController, [{
                  key: "requestMediaKeySystemAccess",
                  get: function get() {
                    if (!(this || _global)._requestMediaKeySystemAccess) {
                      throw new Error("No requestMediaKeySystemAccess function configured");
                    }
                    return (this || _global)._requestMediaKeySystemAccess;
                  }
                }]);
                return EMEController;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = EMEController;

              /***/
            },

            /***/"./src/controller/fps-controller.ts":
            /*!******************************************!*\
              !*** ./src/controller/fps-controller.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var FPSController = /*#__PURE__*/function () {
                // stream controller must be provided as a dependency!

                function FPSController(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).isVideoPlaybackQualityAvailable = false;
                  (this || _global).timer = void 0;
                  (this || _global).media = null;
                  (this || _global).lastTime = void 0;
                  (this || _global).lastDroppedFrames = 0;
                  (this || _global).lastDecodedFrames = 0;
                  (this || _global).streamController = void 0;
                  (this || _global).hls = hls;
                  this.registerListeners();
                }
                var _proto = FPSController.prototype;
                _proto.setStreamController = function setStreamController(streamController) {
                  (this || _global).streamController = streamController;
                };
                _proto.registerListeners = function registerListeners() {
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching);
                };
                _proto.destroy = function destroy() {
                  if ((this || _global).timer) {
                    clearInterval((this || _global).timer);
                  }
                  this.unregisterListeners();
                  (this || _global).isVideoPlaybackQualityAvailable = false;
                  (this || _global).media = null;
                };
                _proto.onMediaAttaching = function onMediaAttaching(event, data) {
                  var config = (this || _global).hls.config;
                  if (config.capLevelOnFPSDrop) {
                    var media = data.media instanceof self.HTMLVideoElement ? data.media : null;
                    (this || _global).media = media;
                    if (media && typeof media.getVideoPlaybackQuality === "function") {
                      (this || _global).isVideoPlaybackQualityAvailable = true;
                    }
                    self.clearInterval((this || _global).timer);
                    (this || _global).timer = self.setInterval((this || _global).checkFPSInterval.bind(this || _global), config.fpsDroppedMonitoringPeriod);
                  }
                };
                _proto.checkFPS = function checkFPS(video, decodedFrames, droppedFrames) {
                  var currentTime = performance.now();
                  if (decodedFrames) {
                    if ((this || _global).lastTime) {
                      var currentPeriod = currentTime - (this || _global).lastTime;
                      var currentDropped = droppedFrames - (this || _global).lastDroppedFrames;
                      var currentDecoded = decodedFrames - (this || _global).lastDecodedFrames;
                      var droppedFPS = 1000 * currentDropped / currentPeriod;
                      var hls = (this || _global).hls;
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FPS_DROP, {
                        currentDropped: currentDropped,
                        currentDecoded: currentDecoded,
                        totalDroppedFrames: droppedFrames
                      });
                      if (droppedFPS > 0) {
                        // logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                        if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                          var currentLevel = hls.currentLevel;
                          _utils_logger__WEBPACK_IMPORTED_MODULE_1__.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + currentLevel);
                          if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FPS_DROP_LEVEL_CAPPING, {
                              level: currentLevel,
                              droppedLevel: hls.currentLevel
                            });
                            hls.autoLevelCapping = currentLevel;
                            (this || _global).streamController.nextLevelSwitch();
                          }
                        }
                      }
                    }
                    (this || _global).lastTime = currentTime;
                    (this || _global).lastDroppedFrames = droppedFrames;
                    (this || _global).lastDecodedFrames = decodedFrames;
                  }
                };
                _proto.checkFPSInterval = function checkFPSInterval() {
                  var video = (this || _global).media;
                  if (video) {
                    if ((this || _global).isVideoPlaybackQualityAvailable) {
                      var videoPlaybackQuality = video.getVideoPlaybackQuality();
                      this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
                    } else {
                      // HTMLVideoElement doesn't include the webkit types
                      this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
                    }
                  }
                };
                return FPSController;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = FPSController;

              /***/
            },

            /***/"./src/controller/fragment-finders.ts":
            /*!********************************************!*\
              !*** ./src/controller/fragment-finders.ts ***!
              \********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"findFragWithCC": () => /* binding */findFragWithCC,
                /* harmony export */"findFragmentByPDT": () => /* binding */findFragmentByPDT,
                /* harmony export */"findFragmentByPTS": () => /* binding */findFragmentByPTS,
                /* harmony export */"fragmentWithinToleranceTest": () => /* binding */fragmentWithinToleranceTest,
                /* harmony export */"pdtWithinToleranceTest": () => /* binding */pdtWithinToleranceTest
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _utils_binary_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/binary-search */"./src/utils/binary-search.ts");

              /**
               * Returns first fragment whose endPdt value exceeds the given PDT.
               * @param {Array<Fragment>} fragments - The array of candidate fragments
               * @param {number|null} [PDTValue = null] - The PDT value which must be exceeded
               * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start/end can be within in order to be considered contiguous
               * @returns {*|null} fragment - The best matching fragment
               */
              function findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
                if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(PDTValue)) {
                  return null;
                }

                // if less than start
                var startPDT = fragments[0].programDateTime;
                if (PDTValue < (startPDT || 0)) {
                  return null;
                }
                var endPDT = fragments[fragments.length - 1].endProgramDateTime;
                if (PDTValue >= (endPDT || 0)) {
                  return null;
                }
                maxFragLookUpTolerance = maxFragLookUpTolerance || 0;
                for (var seg = 0; seg < fragments.length; ++seg) {
                  var frag = fragments[seg];
                  if (pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) {
                    return frag;
                  }
                }
                return null;
              }

              /**
               * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
               * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
               * breaking any traps which would cause the same fragment to be continuously selected within a small range.
               * @param {*} fragPrevious - The last frag successfully appended
               * @param {Array} fragments - The array of candidate fragments
               * @param {number} [bufferEnd = 0] - The end of the contiguous buffered range the playhead is currently within
               * @param {number} maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
               * @returns {*} foundFrag - The best matching fragment
               */
              function findFragmentByPTS(fragPrevious, fragments, bufferEnd, maxFragLookUpTolerance) {
                if (bufferEnd === void 0) {
                  bufferEnd = 0;
                }
                if (maxFragLookUpTolerance === void 0) {
                  maxFragLookUpTolerance = 0;
                }
                var fragNext = null;
                if (fragPrevious) {
                  fragNext = fragments[fragPrevious.sn - fragments[0].sn + 1] || null;
                } else if (bufferEnd === 0 && fragments[0].start === 0) {
                  fragNext = fragments[0];
                }
                // Prefer the next fragment if it's within tolerance
                if (fragNext && fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0) {
                  return fragNext;
                }
                // We might be seeking past the tolerance so find the best match
                var foundFragment = _utils_binary_search__WEBPACK_IMPORTED_MODULE_1__["default"].search(fragments, fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
                if (foundFragment) {
                  return foundFragment;
                }
                // If no match was found return the next fragment after fragPrevious, or null
                return fragNext;
              }

              /**
               * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
               * @param {*} candidate - The fragment to test
               * @param {number} [bufferEnd = 0] - The end of the current buffered range the playhead is currently within
               * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
               * @returns {number} - 0 if it matches, 1 if too low, -1 if too high
               */
              function fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, candidate) {
                if (bufferEnd === void 0) {
                  bufferEnd = 0;
                }
                if (maxFragLookUpTolerance === void 0) {
                  maxFragLookUpTolerance = 0;
                }
                // offset should be within fragment boundary - config.maxFragLookUpTolerance
                // this is to cope with situations like
                // bufferEnd = 9.991
                // frag[Ø] : [0,10]
                // frag[1] : [10,20]
                // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
                //              frag start               frag start+duration
                //                  |-----------------------------|
                //              <--->                         <--->
                //  ...--------><-----------------------------><---------....
                // previous frag         matching fragment         next frag
                //  return -1             return 0                 return 1
                // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
                // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
                var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
                if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) {
                  return 1;
                } else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) {
                  // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
                  return -1;
                }
                return 0;
              }

              /**
               * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
               * This function tests the candidate's program date time values, as represented in Unix time
               * @param {*} candidate - The fragment to test
               * @param {number} [pdtBufferEnd = 0] - The Unix time representing the end of the current buffered range
               * @param {number} [maxFragLookUpTolerance = 0] - The amount of time that a fragment's start can be within in order to be considered contiguous
               * @returns {boolean} True if contiguous, false otherwise
               */
              function pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
                var candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;

                // endProgramDateTime can be null, default to zero
                var endProgramDateTime = candidate.endProgramDateTime || 0;
                return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
              }
              function findFragWithCC(fragments, cc) {
                return _utils_binary_search__WEBPACK_IMPORTED_MODULE_1__["default"].search(fragments, function (candidate) {
                  if (candidate.cc < cc) {
                    return 1;
                  } else if (candidate.cc > cc) {
                    return -1;
                  } else {
                    return 0;
                  }
                });
              }

              /***/
            },

            /***/"./src/controller/fragment-tracker.ts":
            /*!********************************************!*\
              !*** ./src/controller/fragment-tracker.ts ***!
              \********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"FragmentState": () => /* binding */FragmentState,
                /* harmony export */"FragmentTracker": () => /* binding */FragmentTracker
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              var FragmentState;
              (function (FragmentState) {
                FragmentState["NOT_LOADED"] = "NOT_LOADED";
                FragmentState["APPENDING"] = "APPENDING";
                FragmentState["PARTIAL"] = "PARTIAL";
                FragmentState["OK"] = "OK";
              })(FragmentState || (FragmentState = {}));
              var FragmentTracker = /*#__PURE__*/function () {
                function FragmentTracker(hls) {
                  (this || _global).activeFragment = null;
                  (this || _global).activeParts = null;
                  (this || _global).fragments = Object.create(null);
                  (this || _global).timeRanges = Object.create(null);
                  (this || _global).bufferPadding = 0.2;
                  (this || _global).hls = void 0;
                  (this || _global).hls = hls;
                  this._registerListeners();
                }
                var _proto = FragmentTracker.prototype;
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_APPENDED, (this || _global).onBufferAppended, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_APPENDED, (this || _global).onBufferAppended, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                };
                _proto.destroy = function destroy() {
                  this._unregisterListeners();
                  // @ts-ignore
                  (this || _global).fragments = (this || _global).timeRanges = null;
                }

                /**
                 * Return a Fragment with an appended range that matches the position and levelType.
                 * If not found any Fragment, return null
                 */;
                _proto.getAppendedFrag = function getAppendedFrag(position, levelType) {
                  if (levelType === _types_loader__WEBPACK_IMPORTED_MODULE_1__.PlaylistLevelType.MAIN) {
                    var activeFragment = (this || _global).activeFragment,
                      activeParts = (this || _global).activeParts;
                    if (!activeFragment) {
                      return null;
                    }
                    if (activeParts) {
                      for (var i = activeParts.length; i--;) {
                        var activePart = activeParts[i];
                        var appendedPTS = activePart ? activePart.end : activeFragment.appendedPTS;
                        if (activePart.start <= position && appendedPTS !== undefined && position <= appendedPTS) {
                          // 9 is a magic number. remove parts from lookup after a match but keep some short seeks back.
                          if (i > 9) {
                            (this || _global).activeParts = activeParts.slice(i - 9);
                          }
                          return activePart;
                        }
                      }
                    } else if (activeFragment.start <= position && activeFragment.appendedPTS !== undefined && position <= activeFragment.appendedPTS) {
                      return activeFragment;
                    }
                  }
                  return this.getBufferedFrag(position, levelType);
                }

                /**
                 * Return a buffered Fragment that matches the position and levelType.
                 * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
                 * If not found any Fragment, return null
                 */;
                _proto.getBufferedFrag = function getBufferedFrag(position, levelType) {
                  var fragments = (this || _global).fragments;
                  var keys = Object.keys(fragments);
                  for (var i = keys.length; i--;) {
                    var fragmentEntity = fragments[keys[i]];
                    if ((fragmentEntity === null || fragmentEntity === void 0 ? void 0 : fragmentEntity.body.type) === levelType && fragmentEntity.buffered) {
                      var frag = fragmentEntity.body;
                      if (frag.start <= position && position <= frag.end) {
                        return frag;
                      }
                    }
                  }
                  return null;
                }

                /**
                 * Partial fragments effected by coded frame eviction will be removed
                 * The browser will unload parts of the buffer to free up memory for new buffer data
                 * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
                 */;
                _proto.detectEvictedFragments = function detectEvictedFragments(elementaryStream, timeRange, playlistType) {
                  var _this = this || _global;
                  // Check if any flagged fragments have been unloaded
                  Object.keys((this || _global).fragments).forEach(function (key) {
                    var fragmentEntity = _this.fragments[key];
                    if (!fragmentEntity) {
                      return;
                    }
                    if (!fragmentEntity.buffered) {
                      if (fragmentEntity.body.type === playlistType) {
                        _this.removeFragment(fragmentEntity.body);
                      }
                      return;
                    }
                    var esData = fragmentEntity.range[elementaryStream];
                    if (!esData) {
                      return;
                    }
                    esData.time.some(function (time) {
                      var isNotBuffered = !_this.isTimeBuffered(time.startPTS, time.endPTS, timeRange);
                      if (isNotBuffered) {
                        // Unregister partial fragment as it needs to load again to be reused
                        _this.removeFragment(fragmentEntity.body);
                      }
                      return isNotBuffered;
                    });
                  });
                }

                /**
                 * Checks if the fragment passed in is loaded in the buffer properly
                 * Partially loaded fragments will be registered as a partial fragment
                 */;
                _proto.detectPartialFragments = function detectPartialFragments(data) {
                  var _this2 = this || _global;
                  var timeRanges = (this || _global).timeRanges;
                  var frag = data.frag,
                    part = data.part;
                  if (!timeRanges || frag.sn === "initSegment") {
                    return;
                  }
                  var fragKey = getFragmentKey(frag);
                  var fragmentEntity = (this || _global).fragments[fragKey];
                  if (!fragmentEntity) {
                    return;
                  }
                  Object.keys(timeRanges).forEach(function (elementaryStream) {
                    var streamInfo = frag.elementaryStreams[elementaryStream];
                    if (!streamInfo) {
                      return;
                    }
                    var timeRange = timeRanges[elementaryStream];
                    var partial = part !== null || streamInfo.partial === true;
                    fragmentEntity.range[elementaryStream] = _this2.getBufferedTimes(frag, part, partial, timeRange);
                  });
                  fragmentEntity.loaded = null;
                  if (Object.keys(fragmentEntity.range).length) {
                    fragmentEntity.buffered = true;
                  } else {
                    // remove fragment if nothing was appended
                    this.removeFragment(fragmentEntity.body);
                  }
                };
                _proto.fragBuffered = function fragBuffered(frag) {
                  var fragKey = getFragmentKey(frag);
                  var fragmentEntity = (this || _global).fragments[fragKey];
                  if (fragmentEntity) {
                    fragmentEntity.loaded = null;
                    fragmentEntity.buffered = true;
                  }
                };
                _proto.getBufferedTimes = function getBufferedTimes(fragment, part, partial, timeRange) {
                  var buffered = {
                    time: [],
                    partial: partial
                  };
                  var startPTS = part ? part.start : fragment.start;
                  var endPTS = part ? part.end : fragment.end;
                  var minEndPTS = fragment.minEndPTS || endPTS;
                  var maxStartPTS = fragment.maxStartPTS || startPTS;
                  for (var i = 0; i < timeRange.length; i++) {
                    var startTime = timeRange.start(i) - (this || _global).bufferPadding;
                    var endTime = timeRange.end(i) + (this || _global).bufferPadding;
                    if (maxStartPTS >= startTime && minEndPTS <= endTime) {
                      // Fragment is entirely contained in buffer
                      // No need to check the other timeRange times since it's completely playable
                      buffered.time.push({
                        startPTS: Math.max(startPTS, timeRange.start(i)),
                        endPTS: Math.min(endPTS, timeRange.end(i))
                      });
                      break;
                    } else if (startPTS < endTime && endPTS > startTime) {
                      buffered.partial = true;
                      // Check for intersection with buffer
                      // Get playable sections of the fragment
                      buffered.time.push({
                        startPTS: Math.max(startPTS, timeRange.start(i)),
                        endPTS: Math.min(endPTS, timeRange.end(i))
                      });
                    } else if (endPTS <= startTime) {
                      // No need to check the rest of the timeRange as it is in order
                      break;
                    }
                  }
                  return buffered;
                }

                /**
                 * Gets the partial fragment for a certain time
                 */;
                _proto.getPartialFragment = function getPartialFragment(time) {
                  var bestFragment = null;
                  var timePadding;
                  var startTime;
                  var endTime;
                  var bestOverlap = 0;
                  var bufferPadding = (this || _global).bufferPadding,
                    fragments = (this || _global).fragments;
                  Object.keys(fragments).forEach(function (key) {
                    var fragmentEntity = fragments[key];
                    if (!fragmentEntity) {
                      return;
                    }
                    if (isPartial(fragmentEntity)) {
                      startTime = fragmentEntity.body.start - bufferPadding;
                      endTime = fragmentEntity.body.end + bufferPadding;
                      if (time >= startTime && time <= endTime) {
                        // Use the fragment that has the most padding from start and end time
                        timePadding = Math.min(time - startTime, endTime - time);
                        if (bestOverlap <= timePadding) {
                          bestFragment = fragmentEntity.body;
                          bestOverlap = timePadding;
                        }
                      }
                    }
                  });
                  return bestFragment;
                };
                _proto.getState = function getState(fragment) {
                  var fragKey = getFragmentKey(fragment);
                  var fragmentEntity = (this || _global).fragments[fragKey];
                  if (fragmentEntity) {
                    if (!fragmentEntity.buffered) {
                      return FragmentState.APPENDING;
                    } else if (isPartial(fragmentEntity)) {
                      return FragmentState.PARTIAL;
                    } else {
                      return FragmentState.OK;
                    }
                  }
                  return FragmentState.NOT_LOADED;
                };
                _proto.isTimeBuffered = function isTimeBuffered(startPTS, endPTS, timeRange) {
                  var startTime;
                  var endTime;
                  for (var i = 0; i < timeRange.length; i++) {
                    startTime = timeRange.start(i) - (this || _global).bufferPadding;
                    endTime = timeRange.end(i) + (this || _global).bufferPadding;
                    if (startPTS >= startTime && endPTS <= endTime) {
                      return true;
                    }
                    if (endPTS <= startTime) {
                      // No need to check the rest of the timeRange as it is in order
                      return false;
                    }
                  }
                  return false;
                };
                _proto.onFragLoaded = function onFragLoaded(event, data) {
                  var frag = data.frag,
                    part = data.part;
                  // don't track initsegment (for which sn is not a number)
                  // don't track frags used for bitrateTest, they're irrelevant.
                  // don't track parts for memory efficiency
                  if (frag.sn === "initSegment" || frag.bitrateTest || part) {
                    return;
                  }
                  var fragKey = getFragmentKey(frag);
                  (this || _global).fragments[fragKey] = {
                    body: frag,
                    loaded: data,
                    buffered: false,
                    range: Object.create(null)
                  };
                };
                _proto.onBufferAppended = function onBufferAppended(event, data) {
                  var _this3 = this || _global;
                  var frag = data.frag,
                    part = data.part,
                    timeRanges = data.timeRanges;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_1__.PlaylistLevelType.MAIN) {
                    (this || _global).activeFragment = frag;
                    if (part) {
                      var activeParts = (this || _global).activeParts;
                      if (!activeParts) {
                        (this || _global).activeParts = activeParts = [];
                      }
                      activeParts.push(part);
                    } else {
                      (this || _global).activeParts = null;
                    }
                  }
                  // Store the latest timeRanges loaded in the buffer
                  (this || _global).timeRanges = timeRanges;
                  Object.keys(timeRanges).forEach(function (elementaryStream) {
                    var timeRange = timeRanges[elementaryStream];
                    _this3.detectEvictedFragments(elementaryStream, timeRange);
                    if (!part) {
                      for (var i = 0; i < timeRange.length; i++) {
                        frag.appendedPTS = Math.max(timeRange.end(i), frag.appendedPTS || 0);
                      }
                    }
                  });
                };
                _proto.onFragBuffered = function onFragBuffered(event, data) {
                  this.detectPartialFragments(data);
                };
                _proto.hasFragment = function hasFragment(fragment) {
                  var fragKey = getFragmentKey(fragment);
                  return !!(this || _global).fragments[fragKey];
                };
                _proto.removeFragmentsInRange = function removeFragmentsInRange(start, end, playlistType) {
                  var _this4 = this || _global;
                  Object.keys((this || _global).fragments).forEach(function (key) {
                    var fragmentEntity = _this4.fragments[key];
                    if (!fragmentEntity) {
                      return;
                    }
                    if (fragmentEntity.buffered) {
                      var frag = fragmentEntity.body;
                      if (frag.type === playlistType && frag.start < end && frag.end > start) {
                        _this4.removeFragment(frag);
                      }
                    }
                  });
                };
                _proto.removeFragment = function removeFragment(fragment) {
                  var fragKey = getFragmentKey(fragment);
                  fragment.stats.loaded = 0;
                  fragment.clearElementaryStreamInfo();
                  delete (this || _global).fragments[fragKey];
                };
                _proto.removeAllFragments = function removeAllFragments() {
                  (this || _global).fragments = Object.create(null);
                  (this || _global).activeFragment = null;
                  (this || _global).activeParts = null;
                };
                return FragmentTracker;
              }();
              function isPartial(fragmentEntity) {
                var _fragmentEntity$range, _fragmentEntity$range2;
                return fragmentEntity.buffered && (((_fragmentEntity$range = fragmentEntity.range.video) === null || _fragmentEntity$range === void 0 ? void 0 : _fragmentEntity$range.partial) || ((_fragmentEntity$range2 = fragmentEntity.range.audio) === null || _fragmentEntity$range2 === void 0 ? void 0 : _fragmentEntity$range2.partial));
              }
              function getFragmentKey(fragment) {
                return fragment.type + "_" + fragment.level + "_" + fragment.urlId + "_" + fragment.sn;
              }

              /***/
            },

            /***/"./src/controller/gap-controller.ts":
            /*!******************************************!*\
              !*** ./src/controller/gap-controller.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"MAX_START_GAP_JUMP": () => /* binding */MAX_START_GAP_JUMP,
                /* harmony export */"SKIP_BUFFER_HOLE_STEP_SECONDS": () => /* binding */SKIP_BUFFER_HOLE_STEP_SECONDS,
                /* harmony export */"SKIP_BUFFER_RANGE_START": () => /* binding */SKIP_BUFFER_RANGE_START,
                /* harmony export */"STALL_MINIMUM_DURATION_MS": () => /* binding */STALL_MINIMUM_DURATION_MS,
                /* harmony export */"default": () => /* binding */GapController
                /* harmony export */
              });
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var STALL_MINIMUM_DURATION_MS = 250;
              var MAX_START_GAP_JUMP = 2;
              var SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
              var SKIP_BUFFER_RANGE_START = 0.05;
              var GapController = /*#__PURE__*/function () {
                function GapController(config, media, fragmentTracker, hls) {
                  (this || _global).config = void 0;
                  (this || _global).media = null;
                  (this || _global).fragmentTracker = void 0;
                  (this || _global).hls = void 0;
                  (this || _global).nudgeRetry = 0;
                  (this || _global).stallReported = false;
                  (this || _global).stalled = null;
                  (this || _global).moved = false;
                  (this || _global).seeking = false;
                  (this || _global).config = config;
                  (this || _global).media = media;
                  (this || _global).fragmentTracker = fragmentTracker;
                  (this || _global).hls = hls;
                }
                var _proto = GapController.prototype;
                _proto.destroy = function destroy() {
                  (this || _global).media = null;
                  // @ts-ignore
                  (this || _global).hls = (this || _global).fragmentTracker = null;
                }

                /**
                 * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
                 * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
                 *
                 * @param {number} lastCurrentTime Previously read playhead position
                 */;
                _proto.poll = function poll(lastCurrentTime, activeFrag) {
                  var config = (this || _global).config,
                    media = (this || _global).media,
                    stalled = (this || _global).stalled;
                  if (media === null) {
                    return;
                  }
                  var currentTime = media.currentTime,
                    seeking = media.seeking;
                  var seeked = (this || _global).seeking && !seeking;
                  var beginSeek = !(this || _global).seeking && seeking;
                  (this || _global).seeking = seeking;

                  // The playhead is moving, no-op
                  if (currentTime !== lastCurrentTime) {
                    (this || _global).moved = true;
                    if (stalled !== null) {
                      // The playhead is now moving, but was previously stalled
                      if ((this || _global).stallReported) {
                        var _stalledDuration = self.performance.now() - stalled;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("playback not stuck anymore @" + currentTime + ", after " + Math.round(_stalledDuration) + "ms");
                        (this || _global).stallReported = false;
                      }
                      (this || _global).stalled = null;
                      (this || _global).nudgeRetry = 0;
                    }
                    return;
                  }

                  // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
                  if (beginSeek || seeked) {
                    (this || _global).stalled = null;
                  }

                  // The playhead should not be moving
                  if (media.paused && !seeking || media.ended || media.playbackRate === 0 || !_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_0__.BufferHelper.getBuffered(media).length) {
                    return;
                  }
                  var bufferInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_0__.BufferHelper.bufferInfo(media, currentTime, 0);
                  var isBuffered = bufferInfo.len > 0;
                  var nextStart = bufferInfo.nextStart || 0;

                  // There is no playable buffer (seeked, waiting for buffer)
                  if (!isBuffered && !nextStart) {
                    return;
                  }
                  if (seeking) {
                    // Waiting for seeking in a buffered range to complete
                    var hasEnoughBuffer = bufferInfo.len > MAX_START_GAP_JUMP;
                    // Next buffered range is too far ahead to jump to while still seeking
                    var noBufferGap = !nextStart || activeFrag && activeFrag.start <= currentTime || nextStart - currentTime > MAX_START_GAP_JUMP && !(this || _global).fragmentTracker.getPartialFragment(currentTime);
                    if (hasEnoughBuffer || noBufferGap) {
                      return;
                    }
                    // Reset moved state when seeking to a point in or before a gap
                    (this || _global).moved = false;
                  }

                  // Skip start gaps if we haven't played, but the last poll detected the start of a stall
                  // The addition poll gives the browser a chance to jump the gap for us
                  if (!(this || _global).moved && (this || _global).stalled !== null) {
                    var _level$details;
                    // Jump start gaps within jump threshold
                    var startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;

                    // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
                    // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
                    // that begins over 1 target duration after the video start position.
                    var level = (this || _global).hls.levels ? (this || _global).hls.levels[(this || _global).hls.currentLevel] : null;
                    var isLive = level === null || level === void 0 ? void 0 : (_level$details = level.details) === null || _level$details === void 0 ? void 0 : _level$details.live;
                    var maxStartGapJump = isLive ? level.details.targetduration * 2 : MAX_START_GAP_JUMP;
                    if (startJump > 0 && startJump <= maxStartGapJump) {
                      this._trySkipBufferHole(null);
                      return;
                    }
                  }

                  // Start tracking stall time
                  var tnow = self.performance.now();
                  if (stalled === null) {
                    (this || _global).stalled = tnow;
                    return;
                  }
                  var stalledDuration = tnow - stalled;
                  if (!seeking && stalledDuration >= STALL_MINIMUM_DURATION_MS) {
                    // Report stalling after trying to fix
                    this._reportStall(bufferInfo);
                    if (!(this || _global).media) {
                      return;
                    }
                  }
                  var bufferedWithHoles = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_0__.BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
                  this._tryFixBufferStall(bufferedWithHoles, stalledDuration);
                }

                /**
                 * Detects and attempts to fix known buffer stalling issues.
                 * @param bufferInfo - The properties of the current buffer.
                 * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
                 * @private
                 */;
                _proto._tryFixBufferStall = function _tryFixBufferStall(bufferInfo, stalledDurationMs) {
                  var config = (this || _global).config,
                    fragmentTracker = (this || _global).fragmentTracker,
                    media = (this || _global).media;
                  if (media === null) {
                    return;
                  }
                  var currentTime = media.currentTime;
                  var partial = fragmentTracker.getPartialFragment(currentTime);
                  if (partial) {
                    // Try to skip over the buffer hole caused by a partial fragment
                    // This method isn't limited by the size of the gap between buffered ranges
                    var targetTime = this._trySkipBufferHole(partial);
                    // we return here in this case, meaning
                    // the branch below only executes when we don't handle a partial fragment
                    if (targetTime || !(this || _global).media) {
                      return;
                    }
                  }

                  // if we haven't had to skip over a buffer hole of a partial fragment
                  // we may just have to "nudge" the playlist as the browser decoding/rendering engine
                  // needs to cross some sort of threshold covering all source-buffers content
                  // to start playing properly.
                  if (bufferInfo.len > config.maxBufferHole && stalledDurationMs > config.highBufferWatchdogPeriod * 1000) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Trying to nudge playhead over buffer-hole");
                    // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
                    // We only try to jump the hole if it's under the configured size
                    // Reset stalled so to rearm watchdog timer
                    (this || _global).stalled = null;
                    this._tryNudgeBuffer();
                  }
                }

                /**
                 * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
                 * @param bufferLen - The playhead distance from the end of the current buffer segment.
                 * @private
                 */;
                _proto._reportStall = function _reportStall(bufferInfo) {
                  var hls = (this || _global).hls,
                    media = (this || _global).media,
                    stallReported = (this || _global).stallReported;
                  if (!stallReported && media) {
                    // Report stalled error once
                    (this || _global).stallReported = true;
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Playback stalling at @" + media.currentTime + " due to low buffer (" + JSON.stringify(bufferInfo) + ")");
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.BUFFER_STALLED_ERROR,
                      fatal: false,
                      buffer: bufferInfo.len
                    });
                  }
                }

                /**
                 * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
                 * @param partial - The partial fragment found at the current time (where playback is stalling).
                 * @private
                 */;
                _proto._trySkipBufferHole = function _trySkipBufferHole(partial) {
                  var config = (this || _global).config,
                    hls = (this || _global).hls,
                    media = (this || _global).media;
                  if (media === null) {
                    return 0;
                  }
                  var currentTime = media.currentTime;
                  var lastEndTime = 0;
                  // Check if currentTime is between unbuffered regions of partial fragments
                  var buffered = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_0__.BufferHelper.getBuffered(media);
                  for (var i = 0; i < buffered.length; i++) {
                    var startTime = buffered.start(i);
                    if (currentTime + config.maxBufferHole >= lastEndTime && currentTime < startTime) {
                      var targetTime = Math.max(startTime + SKIP_BUFFER_RANGE_START, media.currentTime + SKIP_BUFFER_HOLE_STEP_SECONDS);
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("skipping hole, adjusting currentTime from " + currentTime + " to " + targetTime);
                      (this || _global).moved = true;
                      (this || _global).stalled = null;
                      media.currentTime = targetTime;
                      if (partial) {
                        hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, {
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.BUFFER_SEEK_OVER_HOLE,
                          fatal: false,
                          reason: "fragment loaded with buffer holes, seeking from " + currentTime + " to " + targetTime,
                          frag: partial
                        });
                      }
                      return targetTime;
                    }
                    lastEndTime = buffered.end(i);
                  }
                  return 0;
                }

                /**
                 * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
                 * @private
                 */;
                _proto._tryNudgeBuffer = function _tryNudgeBuffer() {
                  var config = (this || _global).config,
                    hls = (this || _global).hls,
                    media = (this || _global).media,
                    nudgeRetry = (this || _global).nudgeRetry;
                  if (media === null) {
                    return;
                  }
                  var currentTime = media.currentTime;
                  (this || _global).nudgeRetry++;
                  if (nudgeRetry < config.nudgeMaxRetry) {
                    var targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
                    // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Nudging 'currentTime' from " + currentTime + " to " + targetTime);
                    media.currentTime = targetTime;
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.BUFFER_NUDGE_ON_STALL,
                      fatal: false
                    });
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.error("Playhead still not moving while enough data buffered @" + currentTime + " after " + config.nudgeMaxRetry + " nudges");
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.BUFFER_STALLED_ERROR,
                      fatal: true
                    });
                  }
                };
                return GapController;
              }();

              /***/
            },

            /***/"./src/controller/id3-track-controller.ts":
            /*!************************************************!*\
              !*** ./src/controller/id3-track-controller.ts ***!
              \************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/texttrack-utils */"./src/utils/texttrack-utils.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              /* harmony import */
              var _loader_date_range__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../loader/date-range */"./src/loader/date-range.ts");
              /* harmony import */
              var _types_demuxer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../types/demuxer */"./src/types/demuxer.ts");
              var MIN_CUE_DURATION = 0.25;
              function getCueClass() {
                // Attempt to recreate Safari functionality by creating
                // WebKitDataCue objects when available and store the decoded
                // ID3 data in the value property of the cue
                return self.WebKitDataCue || self.VTTCue || self.TextTrackCue;
              }

              // VTTCue latest draft allows an infinite duration, fallback
              // to MAX_VALUE if necessary
              var MAX_CUE_ENDTIME = function () {
                var Cue = getCueClass();
                try {
                  new Cue(0, Number.POSITIVE_INFINITY, "");
                } catch (e) {
                  return Number.MAX_VALUE;
                }
                return Number.POSITIVE_INFINITY;
              }();
              function dateRangeDateToTimelineSeconds(date, offset) {
                return date.getTime() / 1000 - offset;
              }
              function hexToArrayBuffer(str) {
                return Uint8Array.from(str.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
              }
              var ID3TrackController = /*#__PURE__*/function () {
                function ID3TrackController(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).id3Track = null;
                  (this || _global).media = null;
                  (this || _global).dateRangeCuesAppended = {};
                  (this || _global).hls = hls;
                  this._registerListeners();
                }
                var _proto = ID3TrackController.prototype;
                _proto.destroy = function destroy() {
                  this._unregisterListeners();
                  (this || _global).id3Track = null;
                  (this || _global).media = null;
                  (this || _global).dateRangeCuesAppended = {};
                  // @ts-ignore
                  (this || _global).hls = null;
                };
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSING_METADATA, (this || _global).onFragParsingMetadata, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSING_METADATA, (this || _global).onFragParsingMetadata, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated, this || _global);
                }

                // Add ID3 metatadata text track.
                ;

                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  (this || _global).media = data.media;
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  if (!(this || _global).id3Track) {
                    return;
                  }
                  (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_2__.clearCurrentCues)((this || _global).id3Track);
                  (this || _global).id3Track = null;
                  (this || _global).media = null;
                  (this || _global).dateRangeCuesAppended = {};
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).dateRangeCuesAppended = {};
                };
                _proto.createTrack = function createTrack(media) {
                  var track = this.getID3Track(media.textTracks);
                  track.mode = "hidden";
                  return track;
                };
                _proto.getID3Track = function getID3Track(textTracks) {
                  if (!(this || _global).media) {
                    return;
                  }
                  for (var i = 0; i < textTracks.length; i++) {
                    var textTrack = textTracks[i];
                    if (textTrack.kind === "metadata" && textTrack.label === "id3") {
                      // send 'addtrack' when reusing the textTrack for metadata,
                      // same as what we do for captions
                      (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_2__.sendAddTrackEvent)(textTrack, (this || _global).media);
                      return textTrack;
                    }
                  }
                  return (this || _global).media.addTextTrack("metadata", "id3");
                };
                _proto.onFragParsingMetadata = function onFragParsingMetadata(event, data) {
                  if (!(this || _global).media) {
                    return;
                  }
                  var _this$hls$config = (this || _global).hls.config,
                    enableEmsgMetadataCues = _this$hls$config.enableEmsgMetadataCues,
                    enableID3MetadataCues = _this$hls$config.enableID3MetadataCues;
                  if (!enableEmsgMetadataCues && !enableID3MetadataCues) {
                    return;
                  }
                  data.frag;
                  var samples = data.samples;
                  data.details;

                  // create track dynamically
                  if (!(this || _global).id3Track) {
                    (this || _global).id3Track = this.createTrack((this || _global).media);
                  }
                  var Cue = getCueClass();
                  for (var i = 0; i < samples.length; i++) {
                    var type = samples[i].type;
                    if (type === _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) {
                      continue;
                    }
                    var frames = _demux_id3__WEBPACK_IMPORTED_MODULE_3__.getID3Frames(samples[i].data);
                    if (frames) {
                      var startTime = samples[i].pts;
                      var endTime = startTime + samples[i].duration;
                      if (endTime > MAX_CUE_ENDTIME) {
                        endTime = MAX_CUE_ENDTIME;
                      }
                      var timeDiff = endTime - startTime;
                      if (timeDiff <= 0) {
                        endTime = startTime + MIN_CUE_DURATION;
                      }
                      for (var j = 0; j < frames.length; j++) {
                        var frame = frames[j];
                        // Safari doesn't put the timestamp frame in the TextTrack
                        if (!_demux_id3__WEBPACK_IMPORTED_MODULE_3__.isTimeStampFrame(frame)) {
                          // add a bounds to any unbounded cues
                          this.updateId3CueEnds(startTime);
                          var cue = new Cue(startTime, endTime, "");
                          cue.value = frame;
                          if (type) {
                            cue.type = type;
                          }
                          (this || _global).id3Track.addCue(cue);
                        }
                      }
                    }
                  }
                };
                _proto.updateId3CueEnds = function updateId3CueEnds(startTime) {
                  var _this$id3Track;
                  var cues = (_this$id3Track = (this || _global).id3Track) === null || _this$id3Track === void 0 ? void 0 : _this$id3Track.cues;
                  if (cues) {
                    for (var i = cues.length; i--;) {
                      var cue = cues[i];
                      if (cue.startTime < startTime && cue.endTime === MAX_CUE_ENDTIME) {
                        cue.endTime = startTime;
                      }
                    }
                  }
                };
                _proto.onBufferFlushing = function onBufferFlushing(event, _ref) {
                  var startOffset = _ref.startOffset,
                    endOffset = _ref.endOffset,
                    type = _ref.type;
                  var id3Track = (this || _global).id3Track,
                    hls = (this || _global).hls;
                  if (!hls) {
                    return;
                  }
                  var _hls$config = hls.config,
                    enableEmsgMetadataCues = _hls$config.enableEmsgMetadataCues,
                    enableID3MetadataCues = _hls$config.enableID3MetadataCues;
                  if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
                    var predicate;
                    if (type === "audio") {
                      predicate = function predicate(cue) {
                        return cue.type === _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.audioId3 && enableID3MetadataCues;
                      };
                    } else if (type === "video") {
                      predicate = function predicate(cue) {
                        return cue.type === _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.emsg && enableEmsgMetadataCues;
                      };
                    } else {
                      predicate = function predicate(cue) {
                        return cue.type === _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.audioId3 && enableID3MetadataCues || cue.type === _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.emsg && enableEmsgMetadataCues;
                      };
                    }
                    (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_2__.removeCuesInRange)(id3Track, startOffset, endOffset, predicate);
                  }
                };
                _proto.onLevelUpdated = function onLevelUpdated(event, _ref2) {
                  var _this = this || _global;
                  var details = _ref2.details;
                  if (!(this || _global).media || !details.hasProgramDateTime || !(this || _global).hls.config.enableDateRangeMetadataCues) {
                    return;
                  }
                  var dateRangeCuesAppended = (this || _global).dateRangeCuesAppended,
                    id3Track = (this || _global).id3Track;
                  var dateRanges = details.dateRanges;
                  var ids = Object.keys(dateRanges);
                  // Remove cues from track not found in details.dateRanges
                  if (id3Track) {
                    var idsToRemove = Object.keys(dateRangeCuesAppended).filter(function (id) {
                      return !ids.includes(id);
                    });
                    var _loop = function _loop(i) {
                      var id = idsToRemove[i];
                      Object.keys(dateRangeCuesAppended[id].cues).forEach(function (key) {
                        id3Track.removeCue(dateRangeCuesAppended[id].cues[key]);
                      });
                      delete dateRangeCuesAppended[id];
                    };
                    for (var i = idsToRemove.length; i--;) {
                      _loop(i);
                    }
                  }
                  // Exit if the playlist does not have Date Ranges or does not have Program Date Time
                  var lastFragment = details.fragments[details.fragments.length - 1];
                  if (ids.length === 0 || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(lastFragment === null || lastFragment === void 0 ? void 0 : lastFragment.programDateTime)) {
                    return;
                  }
                  if (!(this || _global).id3Track) {
                    (this || _global).id3Track = this.createTrack((this || _global).media);
                  }
                  var dateTimeOffset = lastFragment.programDateTime / 1000 - lastFragment.start;
                  var Cue = getCueClass();
                  var _loop2 = function _loop2(_i) {
                    var id = ids[_i];
                    var dateRange = dateRanges[id];
                    var appendedDateRangeCues = dateRangeCuesAppended[id];
                    var cues = (appendedDateRangeCues === null || appendedDateRangeCues === void 0 ? void 0 : appendedDateRangeCues.cues) || {};
                    var durationKnown = (appendedDateRangeCues === null || appendedDateRangeCues === void 0 ? void 0 : appendedDateRangeCues.durationKnown) || false;
                    var startTime = dateRangeDateToTimelineSeconds(dateRange.startDate, dateTimeOffset);
                    var endTime = MAX_CUE_ENDTIME;
                    var endDate = dateRange.endDate;
                    if (endDate) {
                      endTime = dateRangeDateToTimelineSeconds(endDate, dateTimeOffset);
                      durationKnown = true;
                    } else if (dateRange.endOnNext && !durationKnown) {
                      var nextDateRangeWithSameClass = ids.reduce(function (filterMapArray, id) {
                        var candidate = dateRanges[id];
                        if (candidate.class === dateRange.class && candidate.id !== id && candidate.startDate > dateRange.startDate) {
                          filterMapArray.push(candidate);
                        }
                        return filterMapArray;
                      }, []).sort(function (a, b) {
                        return a.startDate.getTime() - b.startDate.getTime();
                      })[0];
                      if (nextDateRangeWithSameClass) {
                        endTime = dateRangeDateToTimelineSeconds(nextDateRangeWithSameClass.startDate, dateTimeOffset);
                        durationKnown = true;
                      }
                    }
                    var attributes = Object.keys(dateRange.attr);
                    for (var j = 0; j < attributes.length; j++) {
                      var key = attributes[j];
                      if (key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.ID || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.CLASS || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.START_DATE || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.DURATION || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.END_DATE || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.END_ON_NEXT) {
                        continue;
                      }
                      var cue = cues[key];
                      if (cue) {
                        if (durationKnown && !appendedDateRangeCues.durationKnown) {
                          cue.endTime = endTime;
                        }
                      } else {
                        var data = dateRange.attr[key];
                        cue = new Cue(startTime, endTime, "");
                        if (key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.SCTE35_OUT || key === _loader_date_range__WEBPACK_IMPORTED_MODULE_4__.DateRangeAttribute.SCTE35_IN) {
                          data = hexToArrayBuffer(data);
                        }
                        cue.value = {
                          key: key,
                          data: data
                        };
                        cue.type = _types_demuxer__WEBPACK_IMPORTED_MODULE_5__.MetadataSchema.dateRange;
                        _this.id3Track.addCue(cue);
                        cues[key] = cue;
                      }
                    }
                    dateRangeCuesAppended[id] = {
                      cues: cues,
                      dateRange: dateRange,
                      durationKnown: durationKnown
                    };
                  };
                  for (var _i = 0; _i < ids.length; _i++) {
                    _loop2(_i);
                  }
                };
                return ID3TrackController;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = ID3TrackController;

              /***/
            },

            /***/"./src/controller/latency-controller.ts":
            /*!**********************************************!*\
              !*** ./src/controller/latency-controller.ts ***!
              \**********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */LatencyController
                /* harmony export */
              });
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var LatencyController = /*#__PURE__*/function () {
                function LatencyController(hls) {
                  var _this = this || _global;
                  (this || _global).hls = void 0;
                  (this || _global).config = void 0;
                  (this || _global).media = null;
                  (this || _global).levelDetails = null;
                  (this || _global).currentTime = 0;
                  (this || _global).stallCount = 0;
                  (this || _global)._latency = null;
                  (this || _global).timeupdateHandler = function () {
                    return _this.timeupdate();
                  };
                  (this || _global).hls = hls;
                  (this || _global).config = hls.config;
                  this.registerListeners();
                }
                var _proto = LatencyController.prototype;
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  this.onMediaDetaching();
                  (this || _global).levelDetails = null;
                  // @ts-ignore
                  (this || _global).hls = (this || _global).timeupdateHandler = null;
                };
                _proto.registerListeners = function registerListeners() {
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated, this || _global);
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_UPDATED, (this || _global).onLevelUpdated);
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, (this || _global).onError);
                };
                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  (this || _global).media = data.media;
                  (this || _global).media.addEventListener("timeupdate", (this || _global).timeupdateHandler);
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  if ((this || _global).media) {
                    (this || _global).media.removeEventListener("timeupdate", (this || _global).timeupdateHandler);
                    (this || _global).media = null;
                  }
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).levelDetails = null;
                  (this || _global)._latency = null;
                  (this || _global).stallCount = 0;
                };
                _proto.onLevelUpdated = function onLevelUpdated(event, _ref) {
                  var details = _ref.details;
                  (this || _global).levelDetails = details;
                  if (details.advanced) {
                    this.timeupdate();
                  }
                  if (!details.live && (this || _global).media) {
                    (this || _global).media.removeEventListener("timeupdate", (this || _global).timeupdateHandler);
                  }
                };
                _proto.onError = function onError(event, data) {
                  if (data.details !== _errors__WEBPACK_IMPORTED_MODULE_0__.ErrorDetails.BUFFER_STALLED_ERROR) {
                    return;
                  }
                  (this || _global).stallCount++;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("[playback-rate-controller]: Stall detected, adjusting target latency");
                };
                _proto.timeupdate = function timeupdate() {
                  var media = (this || _global).media,
                    levelDetails = (this || _global).levelDetails;
                  if (!media || !levelDetails) {
                    return;
                  }
                  (this || _global).currentTime = media.currentTime;
                  var latency = this.computeLatency();
                  if (latency === null) {
                    return;
                  }
                  (this || _global)._latency = latency;

                  // Adapt playbackRate to meet target latency in low-latency mode
                  var _this$config = (this || _global).config,
                    lowLatencyMode = _this$config.lowLatencyMode,
                    maxLiveSyncPlaybackRate = _this$config.maxLiveSyncPlaybackRate;
                  if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1) {
                    return;
                  }
                  var targetLatency = (this || _global).targetLatency;
                  if (targetLatency === null) {
                    return;
                  }
                  var distanceFromTarget = latency - targetLatency;
                  // Only adjust playbackRate when within one target duration of targetLatency
                  // and more than one second from under-buffering.
                  // Playback further than one target duration from target can be considered DVR playback.
                  var liveMinLatencyDuration = Math.min((this || _global).maxLatency, targetLatency + levelDetails.targetduration);
                  var inLiveRange = distanceFromTarget < liveMinLatencyDuration;
                  if (levelDetails.live && inLiveRange && distanceFromTarget > 0.05 && (this || _global).forwardBufferLength > 1) {
                    var max = Math.min(2, Math.max(1, maxLiveSyncPlaybackRate));
                    var rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - (this || _global).edgeStalled)) * 20) / 20;
                    media.playbackRate = Math.min(max, Math.max(1, rate));
                  } else if (media.playbackRate !== 1 && media.playbackRate !== 0) {
                    media.playbackRate = 1;
                  }
                };
                _proto.estimateLiveEdge = function estimateLiveEdge() {
                  var levelDetails = (this || _global).levelDetails;
                  if (levelDetails === null) {
                    return null;
                  }
                  return levelDetails.edge + levelDetails.age;
                };
                _proto.computeLatency = function computeLatency() {
                  var liveEdge = this.estimateLiveEdge();
                  if (liveEdge === null) {
                    return null;
                  }
                  return liveEdge - (this || _global).currentTime;
                };
                _createClass(LatencyController, [{
                  key: "latency",
                  get: function get() {
                    return (this || _global)._latency || 0;
                  }
                }, {
                  key: "maxLatency",
                  get: function get() {
                    var config = (this || _global).config,
                      levelDetails = (this || _global).levelDetails;
                    if (config.liveMaxLatencyDuration !== undefined) {
                      return config.liveMaxLatencyDuration;
                    }
                    return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
                  }
                }, {
                  key: "targetLatency",
                  get: function get() {
                    var levelDetails = (this || _global).levelDetails;
                    if (levelDetails === null) {
                      return null;
                    }
                    var holdBack = levelDetails.holdBack,
                      partHoldBack = levelDetails.partHoldBack,
                      targetduration = levelDetails.targetduration;
                    var _this$config2 = (this || _global).config,
                      liveSyncDuration = _this$config2.liveSyncDuration,
                      liveSyncDurationCount = _this$config2.liveSyncDurationCount,
                      lowLatencyMode = _this$config2.lowLatencyMode;
                    var userConfig = (this || _global).hls.userConfig;
                    var targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
                    if (userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) {
                      targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
                    }
                    var maxLiveSyncOnStallIncrease = targetduration;
                    var liveSyncOnStallIncrease = 1;
                    return targetLatency + Math.min((this || _global).stallCount * liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
                  }
                }, {
                  key: "liveSyncPosition",
                  get: function get() {
                    var liveEdge = this.estimateLiveEdge();
                    var targetLatency = (this || _global).targetLatency;
                    var levelDetails = (this || _global).levelDetails;
                    if (liveEdge === null || targetLatency === null || levelDetails === null) {
                      return null;
                    }
                    var edge = levelDetails.edge;
                    var syncPosition = liveEdge - targetLatency - (this || _global).edgeStalled;
                    var min = edge - levelDetails.totalduration;
                    var max = edge - ((this || _global).config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
                    return Math.min(Math.max(min, syncPosition), max);
                  }
                }, {
                  key: "drift",
                  get: function get() {
                    var levelDetails = (this || _global).levelDetails;
                    if (levelDetails === null) {
                      return 1;
                    }
                    return levelDetails.drift;
                  }
                }, {
                  key: "edgeStalled",
                  get: function get() {
                    var levelDetails = (this || _global).levelDetails;
                    if (levelDetails === null) {
                      return 0;
                    }
                    var maxLevelUpdateAge = ((this || _global).config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
                    return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
                  }
                }, {
                  key: "forwardBufferLength",
                  get: function get() {
                    var media = (this || _global).media,
                      levelDetails = (this || _global).levelDetails;
                    if (!media || !levelDetails) {
                      return 0;
                    }
                    var bufferedRanges = media.buffered.length;
                    return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - (this || _global).currentTime;
                  }
                }]);
                return LatencyController;
              }();

              /***/
            },

            /***/"./src/controller/level-controller.ts":
            /*!********************************************!*\
              !*** ./src/controller/level-controller.ts ***!
              \********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */LevelController
                /* harmony export */
              });
              /* harmony import */
              var _types_level__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../types/level */"./src/types/level.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_codecs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/codecs */"./src/utils/codecs.ts");
              /* harmony import */
              var _level_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./level-helper */"./src/controller/level-helper.ts");
              /* harmony import */
              var _base_playlist_controller__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./base-playlist-controller */"./src/controller/base-playlist-controller.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              /*
               * Level Controller
               */

              var chromeOrFirefox = /chrome|firefox/.test(navigator.userAgent.toLowerCase());
              var LevelController = /*#__PURE__*/function (_BasePlaylistControll) {
                _inheritsLoose(LevelController, _BasePlaylistControll);
                function LevelController(hls) {
                  var _this;
                  _this = _BasePlaylistControll.call(this || _global, hls, "[level-controller]") || this || _global;
                  _this._levels = [];
                  _this._firstLevel = -1;
                  _this._startLevel = void 0;
                  _this.currentLevelIndex = -1;
                  _this.manualLevelIndex = -1;
                  _this.onParsedComplete = void 0;
                  _this._registerListeners();
                  return _this;
                }
                var _proto = LevelController.prototype;
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, (this || _global).onManifestLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.AUDIO_TRACK_SWITCHED, (this || _global).onAudioTrackSwitched, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, (this || _global).onManifestLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.AUDIO_TRACK_SWITCHED, (this || _global).onAudioTrackSwitched, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.destroy = function destroy() {
                  this._unregisterListeners();
                  (this || _global).manualLevelIndex = -1;
                  (this || _global)._levels.length = 0;
                  _BasePlaylistControll.prototype.destroy.call(this || _global);
                };
                _proto.startLoad = function startLoad() {
                  var levels = (this || _global)._levels;

                  // clean up live level details to force reload them, and reset load errors
                  levels.forEach(function (level) {
                    level.loadError = 0;
                  });
                  _BasePlaylistControll.prototype.startLoad.call(this || _global);
                };
                _proto.onManifestLoaded = function onManifestLoaded(event, data) {
                  var levels = [];
                  var audioTracks = [];
                  var subtitleTracks = [];
                  var bitrateStart;
                  var levelSet = {};
                  var levelFromSet;
                  var resolutionFound = false;
                  var videoCodecFound = false;
                  var audioCodecFound = false;

                  // regroup redundant levels together
                  data.levels.forEach(function (levelParsed) {
                    var attributes = levelParsed.attrs;
                    resolutionFound = resolutionFound || !!(levelParsed.width && levelParsed.height);
                    videoCodecFound = videoCodecFound || !!levelParsed.videoCodec;
                    audioCodecFound = audioCodecFound || !!levelParsed.audioCodec;

                    // erase audio codec info if browser does not support mp4a.40.34.
                    // demuxer will autodetect codec and fallback to mpeg/audio
                    if (chromeOrFirefox && levelParsed.audioCodec && levelParsed.audioCodec.indexOf("mp4a.40.34") !== -1) {
                      levelParsed.audioCodec = undefined;
                    }
                    var levelKey = levelParsed.bitrate + "-" + levelParsed.attrs.RESOLUTION + "-" + levelParsed.attrs.CODECS;
                    levelFromSet = levelSet[levelKey];
                    if (!levelFromSet) {
                      levelFromSet = new _types_level__WEBPACK_IMPORTED_MODULE_0__.Level(levelParsed);
                      levelSet[levelKey] = levelFromSet;
                      levels.push(levelFromSet);
                    } else {
                      levelFromSet.url.push(levelParsed.url);
                    }
                    if (attributes) {
                      if (attributes.AUDIO) {
                        (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.addGroupId)(levelFromSet, "audio", attributes.AUDIO);
                      }
                      if (attributes.SUBTITLES) {
                        (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.addGroupId)(levelFromSet, "text", attributes.SUBTITLES);
                      }
                    }
                  });

                  // remove audio-only level if we also have levels with video codecs or RESOLUTION signalled
                  if ((resolutionFound || videoCodecFound) && audioCodecFound) {
                    levels = levels.filter(function (_ref) {
                      var videoCodec = _ref.videoCodec,
                        width = _ref.width,
                        height = _ref.height;
                      return !!videoCodec || !!(width && height);
                    });
                  }

                  // only keep levels with supported audio/video codecs
                  levels = levels.filter(function (_ref2) {
                    var audioCodec = _ref2.audioCodec,
                      videoCodec = _ref2.videoCodec;
                    return (!audioCodec || (0, _utils_codecs__WEBPACK_IMPORTED_MODULE_3__.isCodecSupportedInMp4)(audioCodec, "audio")) && (!videoCodec || (0, _utils_codecs__WEBPACK_IMPORTED_MODULE_3__.isCodecSupportedInMp4)(videoCodec, "video"));
                  });
                  if (data.audioTracks) {
                    audioTracks = data.audioTracks.filter(function (track) {
                      return !track.audioCodec || (0, _utils_codecs__WEBPACK_IMPORTED_MODULE_3__.isCodecSupportedInMp4)(track.audioCodec, "audio");
                    });
                    // Assign ids after filtering as array indices by group-id
                    (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.assignTrackIdsByGroup)(audioTracks);
                  }
                  if (data.subtitles) {
                    subtitleTracks = data.subtitles;
                    (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.assignTrackIdsByGroup)(subtitleTracks);
                  }
                  if (levels.length > 0) {
                    // start bitrate is the first bitrate of the manifest
                    bitrateStart = levels[0].bitrate;
                    // sort level on bitrate
                    levels.sort(function (a, b) {
                      return a.bitrate - b.bitrate;
                    });
                    (this || _global)._levels = levels;
                    // find index of first level in sorted levels
                    for (var i = 0; i < levels.length; i++) {
                      if (levels[i].bitrate === bitrateStart) {
                        (this || _global)._firstLevel = i;
                        this.log("manifest loaded, " + levels.length + " level(s) found, first bitrate: " + bitrateStart);
                        break;
                      }
                    }

                    // Audio is only alternate if manifest include a URI along with the audio group tag,
                    // and this is not an audio-only stream where levels contain audio-only
                    var audioOnly = audioCodecFound && !videoCodecFound;
                    var edata = {
                      levels: levels,
                      audioTracks: audioTracks,
                      subtitleTracks: subtitleTracks,
                      firstLevel: (this || _global)._firstLevel,
                      stats: data.stats,
                      audio: audioCodecFound,
                      video: videoCodecFound,
                      altAudio: !audioOnly && audioTracks.some(function (t) {
                        return !!t.url;
                      })
                    };
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_PARSED, edata);

                    // Initiate loading after all controllers have received MANIFEST_PARSED
                    if ((this || _global).hls.config.autoStartLoad || (this || _global).hls.forceStartLoad) {
                      (this || _global).hls.startLoad((this || _global).hls.config.startPosition);
                    }
                  } else {
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                      fatal: true,
                      url: data.url,
                      reason: "no level with compatible codecs found in manifest"
                    });
                  }
                };
                _proto.onError = function onError(event, data) {
                  var _data$level;
                  _BasePlaylistControll.prototype.onError.call(this || _global, event, data);
                  if (data.fatal) {
                    return;
                  }

                  // Switch to redundant level when track fails to load
                  var context = data.context;
                  var level = (this || _global)._levels[(this || _global).currentLevelIndex];
                  if (context && (context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK && level.audioGroupIds && context.groupId === level.audioGroupIds[level.urlId] || context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK && level.textGroupIds && context.groupId === level.textGroupIds[level.urlId])) {
                    this.redundantFailover((this || _global).currentLevelIndex);
                    return;
                  }
                  var levelError = false;
                  var levelSwitch = true;
                  var levelIndex;

                  // try to recover not fatal errors
                  switch (data.details) {
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.FRAG_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.KEY_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.KEY_LOAD_TIMEOUT:
                      if (data.frag) {
                        // Share fragment error count accross media options (main, audio, subs)
                        // This allows for level based rendition switching when media option assets fail
                        var variantLevelIndex = data.frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN ? data.frag.level : (this || _global).currentLevelIndex;
                        var _level = (this || _global)._levels[variantLevelIndex];
                        // Set levelIndex when we're out of fragment retries
                        if (_level) {
                          _level.fragmentError++;
                          if (_level.fragmentError > (this || _global).hls.config.fragLoadingMaxRetry) {
                            levelIndex = variantLevelIndex;
                          }
                        } else {
                          levelIndex = variantLevelIndex;
                        }
                      }
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                      // Do not perform level switch if an error occurred using delivery directives
                      // Attempt to reload level without directives first
                      if (context) {
                        if (context.deliveryDirectives) {
                          levelSwitch = false;
                        }
                        levelIndex = context.level;
                      }
                      levelError = true;
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.REMUX_ALLOC_ERROR:
                      levelIndex = (_data$level = data.level) != null ? _data$level : (this || _global).currentLevelIndex;
                      levelError = true;
                      break;
                  }
                  if (levelIndex !== undefined) {
                    this.recoverLevel(data, levelIndex, levelError, levelSwitch);
                  }
                }

                /**
                 * Switch to a redundant stream if any available.
                 * If redundant stream is not available, emergency switch down if ABR mode is enabled.
                 */;
                _proto.recoverLevel = function recoverLevel(errorEvent, levelIndex, levelError, levelSwitch) {
                  var errorDetails = errorEvent.details;
                  var level = (this || _global)._levels[levelIndex];
                  level.loadError++;
                  if (levelError) {
                    var retrying = this.retryLoadingOrFail(errorEvent);
                    if (retrying) {
                      // boolean used to inform stream controller not to switch back to IDLE on non fatal error
                      errorEvent.levelRetry = true;
                    } else {
                      (this || _global).currentLevelIndex = -1;
                      return;
                    }
                  }
                  if (levelSwitch) {
                    var redundantLevels = level.url.length;
                    // Try redundant fail-over until level.loadError reaches redundantLevels
                    if (redundantLevels > 1 && level.loadError < redundantLevels) {
                      errorEvent.levelRetry = true;
                      this.redundantFailover(levelIndex);
                    } else if ((this || _global).manualLevelIndex === -1) {
                      // Search for next level to retry
                      var nextLevel = -1;
                      var levels = (this || _global)._levels;
                      for (var i = levels.length; i--;) {
                        var candidate = (i + (this || _global).currentLevelIndex) % levels.length;
                        if (candidate !== (this || _global).currentLevelIndex && levels[candidate].loadError === 0) {
                          nextLevel = candidate;
                          break;
                        }
                      }
                      if (nextLevel > -1 && (this || _global).currentLevelIndex !== nextLevel) {
                        this.warn(errorDetails + ": switch to " + nextLevel);
                        errorEvent.levelRetry = true;
                        (this || _global).hls.nextAutoLevel = nextLevel;
                      }
                    }
                  }
                };
                _proto.redundantFailover = function redundantFailover(levelIndex) {
                  var level = (this || _global)._levels[levelIndex];
                  var redundantLevels = level.url.length;
                  if (redundantLevels > 1) {
                    // Update the url id of all levels so that we stay on the same set of variants when level switching
                    var newUrlId = (level.urlId + 1) % redundantLevels;
                    this.warn("Switching to redundant URL-id " + newUrlId);
                    (this || _global)._levels.forEach(function (level) {
                      level.urlId = newUrlId;
                    });
                    (this || _global).level = levelIndex;
                  }
                }

                // reset errors on the successful load of a fragment
                ;

                _proto.onFragLoaded = function onFragLoaded(event, _ref3) {
                  var frag = _ref3.frag;
                  if (frag !== undefined && frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN) {
                    var level = (this || _global)._levels[frag.level];
                    if (level !== undefined) {
                      level.fragmentError = 0;
                      level.loadError = 0;
                    }
                  }
                };
                _proto.onLevelLoaded = function onLevelLoaded(event, data) {
                  var _data$deliveryDirecti2;
                  var level = data.level,
                    details = data.details;
                  var curLevel = (this || _global)._levels[level];
                  if (!curLevel) {
                    var _data$deliveryDirecti;
                    this.warn("Invalid level index " + level);
                    if ((_data$deliveryDirecti = data.deliveryDirectives) !== null && _data$deliveryDirecti !== void 0 && _data$deliveryDirecti.skip) {
                      details.deltaUpdateFailed = true;
                    }
                    return;
                  }

                  // only process level loaded events matching with expected level
                  if (level === (this || _global).currentLevelIndex) {
                    // reset level load error counter on successful level loaded only if there is no issues with fragments
                    if (curLevel.fragmentError === 0) {
                      curLevel.loadError = 0;
                      (this || _global).retryCount = 0;
                    }
                    this.playlistLoaded(level, data, curLevel.details);
                  } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) !== null && _data$deliveryDirecti2 !== void 0 && _data$deliveryDirecti2.skip) {
                    // received a delta playlist update that cannot be merged
                    details.deltaUpdateFailed = true;
                  }
                };
                _proto.onAudioTrackSwitched = function onAudioTrackSwitched(event, data) {
                  var currentLevel = (this || _global).hls.levels[(this || _global).currentLevelIndex];
                  if (!currentLevel) {
                    return;
                  }
                  if (currentLevel.audioGroupIds) {
                    var urlId = -1;
                    var audioGroupId = (this || _global).hls.audioTracks[data.id].groupId;
                    for (var i = 0; i < currentLevel.audioGroupIds.length; i++) {
                      if (currentLevel.audioGroupIds[i] === audioGroupId) {
                        urlId = i;
                        break;
                      }
                    }
                    if (urlId !== currentLevel.urlId) {
                      currentLevel.urlId = urlId;
                      this.startLoad();
                    }
                  }
                };
                _proto.loadPlaylist = function loadPlaylist(hlsUrlParameters) {
                  var level = (this || _global).currentLevelIndex;
                  var currentLevel = (this || _global)._levels[level];
                  if ((this || _global).canLoad && currentLevel && currentLevel.url.length > 0) {
                    var id = currentLevel.urlId;
                    var url = currentLevel.url[id];
                    if (hlsUrlParameters) {
                      try {
                        url = hlsUrlParameters.addDirectives(url);
                      } catch (error) {
                        this.warn("Could not construct new URL with HLS Delivery Directives: " + error);
                      }
                    }
                    this.log("Attempt loading level index " + level + (hlsUrlParameters ? " at sn " + hlsUrlParameters.msn + " part " + hlsUrlParameters.part : "") + " with URL-id " + id + " " + url);

                    // console.log('Current audio track group ID:', this.hls.audioTracks[this.hls.audioTrack].groupId);
                    // console.log('New video quality level audio group id:', levelObject.attrs.AUDIO, level);
                    this.clearTimer();
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADING, {
                      url: url,
                      level: level,
                      id: id,
                      deliveryDirectives: hlsUrlParameters || null
                    });
                  }
                };
                _proto.removeLevel = function removeLevel(levelIndex, urlId) {
                  var filterLevelAndGroupByIdIndex = function filterLevelAndGroupByIdIndex(url, id) {
                    return id !== urlId;
                  };
                  var levels = (this || _global)._levels.filter(function (level, index) {
                    if (index !== levelIndex) {
                      return true;
                    }
                    if (level.url.length > 1 && urlId !== undefined) {
                      level.url = level.url.filter(filterLevelAndGroupByIdIndex);
                      if (level.audioGroupIds) {
                        level.audioGroupIds = level.audioGroupIds.filter(filterLevelAndGroupByIdIndex);
                      }
                      if (level.textGroupIds) {
                        level.textGroupIds = level.textGroupIds.filter(filterLevelAndGroupByIdIndex);
                      }
                      level.urlId = 0;
                      return true;
                    }
                    return false;
                  }).map(function (level, index) {
                    var details = level.details;
                    if (details !== null && details !== void 0 && details.fragments) {
                      details.fragments.forEach(function (fragment) {
                        fragment.level = index;
                      });
                    }
                    return level;
                  });
                  (this || _global)._levels = levels;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVELS_UPDATED, {
                    levels: levels
                  });
                };
                _createClass(LevelController, [{
                  key: "levels",
                  get: function get() {
                    if ((this || _global)._levels.length === 0) {
                      return null;
                    }
                    return (this || _global)._levels;
                  }
                }, {
                  key: "level",
                  get: function get() {
                    return (this || _global).currentLevelIndex;
                  },
                  set: function set(newLevel) {
                    var _levels$newLevel;
                    var levels = (this || _global)._levels;
                    if (levels.length === 0) {
                      return;
                    }
                    if ((this || _global).currentLevelIndex === newLevel && (_levels$newLevel = levels[newLevel]) !== null && _levels$newLevel !== void 0 && _levels$newLevel.details) {
                      return;
                    }
                    // check if level idx is valid
                    if (newLevel < 0 || newLevel >= levels.length) {
                      // invalid level id given, trigger error
                      var fatal = newLevel < 0;
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                        type: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorTypes.OTHER_ERROR,
                        details: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_SWITCH_ERROR,
                        level: newLevel,
                        fatal: fatal,
                        reason: "invalid level idx"
                      });
                      if (fatal) {
                        return;
                      }
                      newLevel = Math.min(newLevel, levels.length - 1);
                    }

                    // stopping live reloading timer if any
                    this.clearTimer();
                    var lastLevelIndex = (this || _global).currentLevelIndex;
                    var lastLevel = levels[lastLevelIndex];
                    var level = levels[newLevel];
                    this.log("switching to level " + newLevel + " from " + lastLevelIndex);
                    (this || _global).currentLevelIndex = newLevel;
                    var levelSwitchingData = _extends({}, level, {
                      level: newLevel,
                      maxBitrate: level.maxBitrate,
                      uri: level.uri,
                      urlId: level.urlId
                    });
                    // @ts-ignore
                    delete levelSwitchingData._urlId;
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_SWITCHING, levelSwitchingData);
                    // check if we need to load playlist for this level
                    var levelDetails = level.details;
                    if (!levelDetails || levelDetails.live) {
                      // level not retrieved yet, or live playlist we need to (re)load it
                      var hlsUrlParameters = this.switchParams(level.uri, lastLevel === null || lastLevel === void 0 ? void 0 : lastLevel.details);
                      this.loadPlaylist(hlsUrlParameters);
                    }
                  }
                }, {
                  key: "manualLevel",
                  get: function get() {
                    return (this || _global).manualLevelIndex;
                  },
                  set: function set(newLevel) {
                    (this || _global).manualLevelIndex = newLevel;
                    if ((this || _global)._startLevel === undefined) {
                      (this || _global)._startLevel = newLevel;
                    }
                    if (newLevel !== -1) {
                      (this || _global).level = newLevel;
                    }
                  }
                }, {
                  key: "firstLevel",
                  get: function get() {
                    return (this || _global)._firstLevel;
                  },
                  set: function set(newLevel) {
                    (this || _global)._firstLevel = newLevel;
                  }
                }, {
                  key: "startLevel",
                  get: function get() {
                    // hls.startLevel takes precedence over config.startLevel
                    // if none of these values are defined, fallback on this._firstLevel (first quality level appearing in variant manifest)
                    if ((this || _global)._startLevel === undefined) {
                      var configStartLevel = (this || _global).hls.config.startLevel;
                      if (configStartLevel !== undefined) {
                        return configStartLevel;
                      } else {
                        return (this || _global)._firstLevel;
                      }
                    } else {
                      return (this || _global)._startLevel;
                    }
                  },
                  set: function set(newLevel) {
                    (this || _global)._startLevel = newLevel;
                  }
                }, {
                  key: "nextLoadLevel",
                  get: function get() {
                    if ((this || _global).manualLevelIndex !== -1) {
                      return (this || _global).manualLevelIndex;
                    } else {
                      return (this || _global).hls.nextAutoLevel;
                    }
                  },
                  set: function set(nextLevel) {
                    (this || _global).level = nextLevel;
                    if ((this || _global).manualLevelIndex === -1) {
                      (this || _global).hls.nextAutoLevel = nextLevel;
                    }
                  }
                }]);
                return LevelController;
              }(_base_playlist_controller__WEBPACK_IMPORTED_MODULE_5__["default"]);

              /***/
            },

            /***/"./src/controller/level-helper.ts":
            /*!****************************************!*\
              !*** ./src/controller/level-helper.ts ***!
              \****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"addGroupId": () => /* binding */addGroupId,
                /* harmony export */"addSliding": () => /* binding */addSliding,
                /* harmony export */"adjustSliding": () => /* binding */adjustSliding,
                /* harmony export */"assignTrackIdsByGroup": () => /* binding */assignTrackIdsByGroup,
                /* harmony export */"computeReloadInterval": () => /* binding */computeReloadInterval,
                /* harmony export */"getFragmentWithSN": () => /* binding */getFragmentWithSN,
                /* harmony export */"getPartWith": () => /* binding */getPartWith,
                /* harmony export */"mapFragmentIntersection": () => /* binding */mapFragmentIntersection,
                /* harmony export */"mapPartIntersection": () => /* binding */mapPartIntersection,
                /* harmony export */"mergeDetails": () => /* binding */mergeDetails,
                /* harmony export */"updateFragPTSDTS": () => /* binding */updateFragPTSDTS,
                /* harmony export */"updatePTS": () => /* binding */updatePTS
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _loader_date_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../loader/date-range */"./src/loader/date-range.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              /**
               * @module LevelHelper
               * Providing methods dealing with playlist sliding and drift
               * */

              function addGroupId(level, type, id) {
                switch (type) {
                  case "audio":
                    if (!level.audioGroupIds) {
                      level.audioGroupIds = [];
                    }
                    level.audioGroupIds.push(id);
                    break;
                  case "text":
                    if (!level.textGroupIds) {
                      level.textGroupIds = [];
                    }
                    level.textGroupIds.push(id);
                    break;
                }
              }
              function assignTrackIdsByGroup(tracks) {
                var groups = {};
                tracks.forEach(function (track) {
                  var groupId = track.groupId || "";
                  track.id = groups[groupId] = groups[groupId] || 0;
                  groups[groupId]++;
                });
              }
              function updatePTS(fragments, fromIdx, toIdx) {
                var fragFrom = fragments[fromIdx];
                var fragTo = fragments[toIdx];
                updateFromToPTS(fragFrom, fragTo);
              }
              function updateFromToPTS(fragFrom, fragTo) {
                var fragToPTS = fragTo.startPTS;
                // if we know startPTS[toIdx]
                if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(fragToPTS)) {
                  // update fragment duration.
                  // it helps to fix drifts between playlist reported duration and fragment real duration
                  var duration = 0;
                  var frag;
                  if (fragTo.sn > fragFrom.sn) {
                    duration = fragToPTS - fragFrom.start;
                    frag = fragFrom;
                  } else {
                    duration = fragFrom.start - fragToPTS;
                    frag = fragTo;
                  }
                  // TODO? Drift can go either way, or the playlist could be completely accurate
                  // console.assert(duration > 0,
                  //   `duration of ${duration} computed for frag ${frag.sn}, level ${frag.level}, there should be some duration drift between playlist and fragment!`);
                  if (frag.duration !== duration) {
                    frag.duration = duration;
                  }
                  // we dont know startPTS[toIdx]
                } else if (fragTo.sn > fragFrom.sn) {
                  var contiguous = fragFrom.cc === fragTo.cc;
                  // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
                  if (contiguous && fragFrom.minEndPTS) {
                    fragTo.start = fragFrom.start + (fragFrom.minEndPTS - fragFrom.start);
                  } else {
                    fragTo.start = fragFrom.start + fragFrom.duration;
                  }
                } else {
                  fragTo.start = Math.max(fragFrom.start - fragTo.duration, 0);
                }
              }
              function updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS) {
                var parsedMediaDuration = endPTS - startPTS;
                if (parsedMediaDuration <= 0) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_1__.logger.warn("Fragment should have a positive duration", frag);
                  endPTS = startPTS + frag.duration;
                  endDTS = startDTS + frag.duration;
                }
                var maxStartPTS = startPTS;
                var minEndPTS = endPTS;
                var fragStartPts = frag.startPTS;
                var fragEndPts = frag.endPTS;
                if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(fragStartPts)) {
                  // delta PTS between audio and video
                  var deltaPTS = Math.abs(fragStartPts - startPTS);
                  if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.deltaPTS)) {
                    frag.deltaPTS = deltaPTS;
                  } else {
                    frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
                  }
                  maxStartPTS = Math.max(startPTS, fragStartPts);
                  startPTS = Math.min(startPTS, fragStartPts);
                  startDTS = Math.min(startDTS, frag.startDTS);
                  minEndPTS = Math.min(endPTS, fragEndPts);
                  endPTS = Math.max(endPTS, fragEndPts);
                  endDTS = Math.max(endDTS, frag.endDTS);
                }
                frag.duration = endPTS - startPTS;
                var drift = startPTS - frag.start;
                frag.appendedPTS = endPTS;
                frag.start = frag.startPTS = startPTS;
                frag.maxStartPTS = maxStartPTS;
                frag.startDTS = startDTS;
                frag.endPTS = endPTS;
                frag.minEndPTS = minEndPTS;
                frag.endDTS = endDTS;
                var sn = frag.sn; // 'initSegment'
                // exit if sn out of range
                if (!details || sn < details.startSN || sn > details.endSN) {
                  return 0;
                }
                var i;
                var fragIdx = sn - details.startSN;
                var fragments = details.fragments;
                // update frag reference in fragments array
                // rationale is that fragments array might not contain this frag object.
                // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
                // if we don't update frag, we won't be able to propagate PTS info on the playlist
                // resulting in invalid sliding computation
                fragments[fragIdx] = frag;
                // adjust fragment PTS/duration from seqnum-1 to frag 0
                for (i = fragIdx; i > 0; i--) {
                  updateFromToPTS(fragments[i], fragments[i - 1]);
                }

                // adjust fragment PTS/duration from seqnum to last frag
                for (i = fragIdx; i < fragments.length - 1; i++) {
                  updateFromToPTS(fragments[i], fragments[i + 1]);
                }
                if (details.fragmentHint) {
                  updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
                }
                details.PTSKnown = details.alignedSliding = true;
                return drift;
              }
              function mergeDetails(oldDetails, newDetails) {
                // Track the last initSegment processed. Initialize it to the last one on the timeline.
                var currentInitSegment = null;
                var oldFragments = oldDetails.fragments;
                for (var i = oldFragments.length - 1; i >= 0; i--) {
                  var oldInit = oldFragments[i].initSegment;
                  if (oldInit) {
                    currentInitSegment = oldInit;
                    break;
                  }
                }
                if (oldDetails.fragmentHint) {
                  // prevent PTS and duration from being adjusted on the next hint
                  delete oldDetails.fragmentHint.endPTS;
                }
                // check if old/new playlists have fragments in common
                // loop through overlapping SN and update startPTS , cc, and duration if any found
                var ccOffset = 0;
                var PTSFrag;
                mapFragmentIntersection(oldDetails, newDetails, function (oldFrag, newFrag) {
                  if (oldFrag.relurl) {
                    // Do not compare CC if the old fragment has no url. This is a level.fragmentHint used by LL-HLS parts.
                    // It maybe be off by 1 if it was created before any parts or discontinuity tags were appended to the end
                    // of the playlist.
                    ccOffset = oldFrag.cc - newFrag.cc;
                  }
                  if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(oldFrag.startPTS) && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(oldFrag.endPTS)) {
                    newFrag.start = newFrag.startPTS = oldFrag.startPTS;
                    newFrag.startDTS = oldFrag.startDTS;
                    newFrag.appendedPTS = oldFrag.appendedPTS;
                    newFrag.maxStartPTS = oldFrag.maxStartPTS;
                    newFrag.endPTS = oldFrag.endPTS;
                    newFrag.endDTS = oldFrag.endDTS;
                    newFrag.minEndPTS = oldFrag.minEndPTS;
                    newFrag.duration = oldFrag.endPTS - oldFrag.startPTS;
                    if (newFrag.duration) {
                      PTSFrag = newFrag;
                    }

                    // PTS is known when any segment has startPTS and endPTS
                    newDetails.PTSKnown = newDetails.alignedSliding = true;
                  }
                  newFrag.elementaryStreams = oldFrag.elementaryStreams;
                  newFrag.loader = oldFrag.loader;
                  newFrag.stats = oldFrag.stats;
                  newFrag.urlId = oldFrag.urlId;
                  if (oldFrag.initSegment) {
                    newFrag.initSegment = oldFrag.initSegment;
                    currentInitSegment = oldFrag.initSegment;
                  }
                });
                if (currentInitSegment) {
                  var fragmentsToCheck = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
                  fragmentsToCheck.forEach(function (frag) {
                    var _currentInitSegment;
                    if (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) === null || _currentInitSegment === void 0 ? void 0 : _currentInitSegment.relurl)) {
                      frag.initSegment = currentInitSegment;
                    }
                  });
                }
                if (newDetails.skippedSegments) {
                  newDetails.deltaUpdateFailed = newDetails.fragments.some(function (frag) {
                    return !frag;
                  });
                  if (newDetails.deltaUpdateFailed) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_1__.logger.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
                    for (var _i = newDetails.skippedSegments; _i--;) {
                      newDetails.fragments.shift();
                    }
                    newDetails.startSN = newDetails.fragments[0].sn;
                    newDetails.startCC = newDetails.fragments[0].cc;
                  } else if (newDetails.canSkipDateRanges) {
                    newDetails.dateRanges = mergeDateRanges(oldDetails.dateRanges, newDetails.dateRanges, newDetails.recentlyRemovedDateranges);
                  }
                }
                var newFragments = newDetails.fragments;
                if (ccOffset) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_1__.logger.warn("discontinuity sliding from playlist, take drift into account");
                  for (var _i2 = 0; _i2 < newFragments.length; _i2++) {
                    newFragments[_i2].cc += ccOffset;
                  }
                }
                if (newDetails.skippedSegments) {
                  newDetails.startCC = newDetails.fragments[0].cc;
                }

                // Merge parts
                mapPartIntersection(oldDetails.partList, newDetails.partList, function (oldPart, newPart) {
                  newPart.elementaryStreams = oldPart.elementaryStreams;
                  newPart.stats = oldPart.stats;
                });

                // if at least one fragment contains PTS info, recompute PTS information for all fragments
                if (PTSFrag) {
                  updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS);
                } else {
                  // ensure that delta is within oldFragments range
                  // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
                  // in that case we also need to adjust start offset of all fragments
                  adjustSliding(oldDetails, newDetails);
                }
                if (newFragments.length) {
                  newDetails.totalduration = newDetails.edge - newFragments[0].start;
                }
                newDetails.driftStartTime = oldDetails.driftStartTime;
                newDetails.driftStart = oldDetails.driftStart;
                var advancedDateTime = newDetails.advancedDateTime;
                if (newDetails.advanced && advancedDateTime) {
                  var edge = newDetails.edge;
                  if (!newDetails.driftStart) {
                    newDetails.driftStartTime = advancedDateTime;
                    newDetails.driftStart = edge;
                  }
                  newDetails.driftEndTime = advancedDateTime;
                  newDetails.driftEnd = edge;
                } else {
                  newDetails.driftEndTime = oldDetails.driftEndTime;
                  newDetails.driftEnd = oldDetails.driftEnd;
                  newDetails.advancedDateTime = oldDetails.advancedDateTime;
                }
              }
              function mergeDateRanges(oldDateRanges, deltaDateRanges, recentlyRemovedDateranges) {
                var dateRanges = _extends({}, oldDateRanges);
                if (recentlyRemovedDateranges) {
                  recentlyRemovedDateranges.forEach(function (id) {
                    delete dateRanges[id];
                  });
                }
                Object.keys(deltaDateRanges).forEach(function (id) {
                  var dateRange = new _loader_date_range__WEBPACK_IMPORTED_MODULE_2__.DateRange(deltaDateRanges[id].attr, dateRanges[id]);
                  if (dateRange.isValid) {
                    dateRanges[id] = dateRange;
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_1__.logger.warn("Ignoring invalid Playlist Delta Update DATERANGE tag: \"" + JSON.stringify(deltaDateRanges[id].attr) + "\"");
                  }
                });
                return dateRanges;
              }
              function mapPartIntersection(oldParts, newParts, intersectionFn) {
                if (oldParts && newParts) {
                  var delta = 0;
                  for (var i = 0, len = oldParts.length; i <= len; i++) {
                    var _oldPart = oldParts[i];
                    var _newPart = newParts[i + delta];
                    if (_oldPart && _newPart && _oldPart.index === _newPart.index && _oldPart.fragment.sn === _newPart.fragment.sn) {
                      intersectionFn(_oldPart, _newPart);
                    } else {
                      delta--;
                    }
                  }
                }
              }
              function mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
                var skippedSegments = newDetails.skippedSegments;
                var start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
                var end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
                var delta = newDetails.startSN - oldDetails.startSN;
                var newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
                var oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
                for (var i = start; i <= end; i++) {
                  var _oldFrag = oldFrags[delta + i];
                  var _newFrag = newFrags[i];
                  if (skippedSegments && !_newFrag && i < skippedSegments) {
                    // Fill in skipped segments in delta playlist
                    _newFrag = newDetails.fragments[i] = _oldFrag;
                  }
                  if (_oldFrag && _newFrag) {
                    intersectionFn(_oldFrag, _newFrag);
                  }
                }
              }
              function adjustSliding(oldDetails, newDetails) {
                var delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
                var oldFragments = oldDetails.fragments;
                if (delta < 0 || delta >= oldFragments.length) {
                  return;
                }
                addSliding(newDetails, oldFragments[delta].start);
              }
              function addSliding(details, start) {
                if (start) {
                  var fragments = details.fragments;
                  for (var i = details.skippedSegments; i < fragments.length; i++) {
                    fragments[i].start += start;
                  }
                  if (details.fragmentHint) {
                    details.fragmentHint.start += start;
                  }
                }
              }
              function computeReloadInterval(newDetails, stats) {
                var reloadInterval = 1000 * newDetails.levelTargetDuration;
                var reloadIntervalAfterMiss = reloadInterval / 2;
                var timeSinceLastModified = newDetails.age;
                var useLastModified = timeSinceLastModified > 0 && timeSinceLastModified < reloadInterval * 3;
                var roundTrip = stats.loading.end - stats.loading.start;
                var estimatedTimeUntilUpdate;
                var availabilityDelay = newDetails.availabilityDelay;
                // let estimate = 'average';

                if (newDetails.updated === false) {
                  if (useLastModified) {
                    // estimate = 'miss round trip';
                    // We should have had a hit so try again in the time it takes to get a response,
                    // but no less than 1/3 second.
                    var minRetry = 333 * newDetails.misses;
                    estimatedTimeUntilUpdate = Math.max(Math.min(reloadIntervalAfterMiss, roundTrip * 2), minRetry);
                    newDetails.availabilityDelay = (newDetails.availabilityDelay || 0) + estimatedTimeUntilUpdate;
                  } else {
                    // estimate = 'miss half average';
                    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
                    // changed then it MUST wait for a period of one-half the target
                    // duration before retrying.
                    estimatedTimeUntilUpdate = reloadIntervalAfterMiss;
                  }
                } else if (useLastModified) {
                  // estimate = 'next modified date';
                  // Get the closest we've been to timeSinceLastModified on update
                  availabilityDelay = Math.min(availabilityDelay || reloadInterval / 2, timeSinceLastModified);
                  newDetails.availabilityDelay = availabilityDelay;
                  estimatedTimeUntilUpdate = availabilityDelay + reloadInterval - timeSinceLastModified;
                } else {
                  estimatedTimeUntilUpdate = reloadInterval - roundTrip;
                }

                // console.log(`[computeReloadInterval] live reload ${newDetails.updated ? 'REFRESHED' : 'MISSED'}`,
                //   '\n  method', estimate,
                //   '\n  estimated time until update =>', estimatedTimeUntilUpdate,
                //   '\n  average target duration', reloadInterval,
                //   '\n  time since modified', timeSinceLastModified,
                //   '\n  time round trip', roundTrip,
                //   '\n  availability delay', availabilityDelay);

                return Math.round(estimatedTimeUntilUpdate);
              }
              function getFragmentWithSN(level, sn, fragCurrent) {
                if (!level || !level.details) {
                  return null;
                }
                var levelDetails = level.details;
                var fragment = levelDetails.fragments[sn - levelDetails.startSN];
                if (fragment) {
                  return fragment;
                }
                fragment = levelDetails.fragmentHint;
                if (fragment && fragment.sn === sn) {
                  return fragment;
                }
                if (sn < levelDetails.startSN && fragCurrent && fragCurrent.sn === sn) {
                  return fragCurrent;
                }
                return null;
              }
              function getPartWith(level, sn, partIndex) {
                if (!level || !level.details) {
                  return null;
                }
                var partList = level.details.partList;
                if (partList) {
                  for (var i = partList.length; i--;) {
                    var part = partList[i];
                    if (part.index === partIndex && part.fragment.sn === sn) {
                      return part;
                    }
                  }
                }
                return null;
              }

              /***/
            },

            /***/"./src/controller/stream-controller.ts":
            /*!*********************************************!*\
              !*** ./src/controller/stream-controller.ts ***!
              \*********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */StreamController
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./base-stream-controller */"./src/controller/base-stream-controller.ts");
              /* harmony import */
              var _is_supported__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../is-supported */"./src/is-supported.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./fragment-tracker */"./src/controller/fragment-tracker.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _loader_fragment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../loader/fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _demux_transmuxer_interface__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../demux/transmuxer-interface */"./src/demux/transmuxer-interface.ts");
              /* harmony import */
              var _types_transmuxer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ../types/transmuxer */"./src/types/transmuxer.ts");
              /* harmony import */
              var _gap_controller__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__( /*! ./gap-controller */"./src/controller/gap-controller.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var TICK_INTERVAL = 100; // how often to tick in ms
              var StreamController = /*#__PURE__*/function (_BaseStreamController) {
                _inheritsLoose(StreamController, _BaseStreamController);
                function StreamController(hls, fragmentTracker) {
                  var _this;
                  _this = _BaseStreamController.call(this || _global, hls, fragmentTracker, "[stream-controller]") || this || _global;
                  _this.audioCodecSwap = false;
                  _this.gapController = null;
                  _this.level = -1;
                  _this._forceStartLoad = false;
                  _this.altAudio = false;
                  _this.audioOnly = false;
                  _this.fragPlaying = null;
                  _this.onvplaying = null;
                  _this.onvseeked = null;
                  _this.fragLastKbps = 0;
                  _this.couldBacktrack = false;
                  _this.backtrackFragment = null;
                  _this.audioCodecSwitch = false;
                  _this.videoBuffer = null;
                  _this._registerListeners();
                  return _this;
                }
                var _proto = StreamController.prototype;
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_LOAD_EMERGENCY_ABORTED, (this || _global).onFragLoadEmergencyAborted, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.AUDIO_TRACK_SWITCHING, (this || _global).onAudioTrackSwitching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.AUDIO_TRACK_SWITCHED, (this || _global).onAudioTrackSwitched, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_FLUSHED, (this || _global).onBufferFlushed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVELS_UPDATED, (this || _global).onLevelsUpdated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_LOAD_EMERGENCY_ABORTED, (this || _global).onFragLoadEmergencyAborted, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.AUDIO_TRACK_SWITCHING, (this || _global).onAudioTrackSwitching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.AUDIO_TRACK_SWITCHED, (this || _global).onAudioTrackSwitched, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_CREATED, (this || _global).onBufferCreated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_FLUSHED, (this || _global).onBufferFlushed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVELS_UPDATED, (this || _global).onLevelsUpdated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                };
                _proto.onHandlerDestroying = function onHandlerDestroying() {
                  this._unregisterListeners();
                  this.onMediaDetaching();
                };
                _proto.startLoad = function startLoad(startPosition) {
                  if ((this || _global).levels) {
                    var lastCurrentTime = (this || _global).lastCurrentTime,
                      hls = (this || _global).hls;
                    this.stopLoad();
                    this.setInterval(TICK_INTERVAL);
                    (this || _global).level = -1;
                    (this || _global).fragLoadError = 0;
                    if (!(this || _global).startFragRequested) {
                      // determine load level
                      var startLevel = hls.startLevel;
                      if (startLevel === -1) {
                        if (hls.config.testBandwidth && (this || _global).levels.length > 1) {
                          // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                          startLevel = 0;
                          (this || _global).bitrateTest = true;
                        } else {
                          startLevel = hls.nextAutoLevel;
                        }
                      }
                      // set new level to playlist loader : this will trigger start level load
                      // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                      (this || _global).level = hls.nextLoadLevel = startLevel;
                      (this || _global).loadedmetadata = false;
                    }
                    // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
                    if (lastCurrentTime > 0 && startPosition === -1) {
                      this.log("Override startPosition with lastCurrentTime @" + lastCurrentTime.toFixed(3));
                      startPosition = lastCurrentTime;
                    }
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                    (this || _global).nextLoadPosition = (this || _global).startPosition = (this || _global).lastCurrentTime = startPosition;
                    this.tick();
                  } else {
                    (this || _global)._forceStartLoad = true;
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.STOPPED;
                  }
                };
                _proto.stopLoad = function stopLoad() {
                  (this || _global)._forceStartLoad = false;
                  _BaseStreamController.prototype.stopLoad.call(this || _global);
                };
                _proto.doTick = function doTick() {
                  switch ((this || _global).state) {
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE:
                      this.doTickIdle();
                      break;
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL:
                      {
                        var _levels$level;
                        var levels = (this || _global).levels,
                          level = (this || _global).level;
                        var details = levels === null || levels === void 0 ? void 0 : (_levels$level = levels[level]) === null || _levels$level === void 0 ? void 0 : _levels$level.details;
                        if (details && (!details.live || (this || _global).levelLastLoaded === (this || _global).level)) {
                          if (this.waitForCdnTuneIn(details)) {
                            break;
                          }
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                          break;
                        }
                        break;
                      }
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING_WAITING_RETRY:
                      {
                        var _this$media;
                        var now = self.performance.now();
                        var retryDate = (this || _global).retryDate;
                        // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
                        if (!retryDate || now >= retryDate || (_this$media = (this || _global).media) !== null && _this$media !== void 0 && _this$media.seeking) {
                          this.log("retryDate reached, switch back to IDLE state");
                          this.resetStartWhenNotLoaded((this || _global).level);
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                        }
                      }
                      break;
                  }
                  // check buffer
                  // check/update current fragment
                  this.onTickEnd();
                };
                _proto.onTickEnd = function onTickEnd() {
                  _BaseStreamController.prototype.onTickEnd.call(this || _global);
                  this.checkBuffer();
                  this.checkFragmentChanged();
                };
                _proto.doTickIdle = function doTickIdle() {
                  var _frag$decryptdata, _frag$decryptdata2;
                  var hls = (this || _global).hls,
                    levelLastLoaded = (this || _global).levelLastLoaded,
                    levels = (this || _global).levels,
                    media = (this || _global).media;
                  var config = hls.config,
                    level = hls.nextLoadLevel;

                  // if start level not parsed yet OR
                  // if video not attached AND start fragment already requested OR start frag prefetch not enabled
                  // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
                  if (levelLastLoaded === null || !media && ((this || _global).startFragRequested || !config.startFragPrefetch)) {
                    return;
                  }

                  // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
                  if ((this || _global).altAudio && (this || _global).audioOnly) {
                    return;
                  }
                  if (!levels || !levels[level]) {
                    return;
                  }
                  var levelInfo = levels[level];

                  // if buffer length is less than maxBufLen try to load a new fragment
                  // set next load level : this will trigger a playlist load if needed
                  (this || _global).level = hls.nextLoadLevel = level;
                  var levelDetails = levelInfo.details;
                  // if level info not retrieved yet, switch state and wait for level retrieval
                  // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
                  // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
                  if (!levelDetails || (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL || levelDetails.live && (this || _global).levelLastLoaded !== level) {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL;
                    return;
                  }
                  var bufferInfo = this.getMainFwdBufferInfo();
                  if (bufferInfo === null) {
                    return;
                  }
                  var bufferLen = bufferInfo.len;

                  // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
                  var maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);

                  // Stay idle if we are still with buffer margins
                  if (bufferLen >= maxBufLen) {
                    return;
                  }
                  if (this._streamEnded(bufferInfo, levelDetails)) {
                    var data = {};
                    if ((this || _global).altAudio) {
                      data.type = "video";
                    }
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_EOS, data);
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ENDED;
                    return;
                  }
                  if ((this || _global).backtrackFragment && (this || _global).backtrackFragment.start > bufferInfo.end) {
                    (this || _global).backtrackFragment = null;
                  }
                  var targetBufferTime = (this || _global).backtrackFragment ? (this || _global).backtrackFragment.start : bufferInfo.end;
                  var frag = this.getNextFragment(targetBufferTime, levelDetails);
                  // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
                  if ((this || _global).couldBacktrack && !(this || _global).fragPrevious && frag && frag.sn !== "initSegment" && (this || _global).fragmentTracker.getState(frag) !== _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__.FragmentState.OK) {
                    var _this$backtrackFragme;
                    var backtrackSn = ((_this$backtrackFragme = (this || _global).backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
                    var fragIdx = backtrackSn - levelDetails.startSN;
                    var backtrackFrag = levelDetails.fragments[fragIdx - 1];
                    if (backtrackFrag && frag.cc === backtrackFrag.cc) {
                      frag = backtrackFrag;
                      (this || _global).fragmentTracker.removeFragment(backtrackFrag);
                    }
                  } else if ((this || _global).backtrackFragment && bufferInfo.len) {
                    (this || _global).backtrackFragment = null;
                  }
                  // Avoid loop loading by using nextLoadPosition set for backtracking
                  if (frag && (this || _global).fragmentTracker.getState(frag) === _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__.FragmentState.OK && (this || _global).nextLoadPosition > targetBufferTime) {
                    // Cleanup the fragment tracker before trying to find the next unbuffered fragment
                    var type = (this || _global).audioOnly && !(this || _global).altAudio ? _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO : _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.VIDEO;
                    if (media) {
                      this.afterBufferFlushed(media, type, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                    }
                    frag = this.getNextFragment((this || _global).nextLoadPosition, levelDetails);
                  }
                  if (!frag) {
                    return;
                  }
                  if (frag.initSegment && !frag.initSegment.data && !(this || _global).bitrateTest) {
                    frag = frag.initSegment;
                  }

                  // We want to load the key if we're dealing with an identity key, because we will decrypt
                  // this content using the key we fetch. Other keys will be handled by the DRM CDM via EME.
                  if (((_frag$decryptdata = frag.decryptdata) === null || _frag$decryptdata === void 0 ? void 0 : _frag$decryptdata.keyFormat) === "identity" && !((_frag$decryptdata2 = frag.decryptdata) !== null && _frag$decryptdata2 !== void 0 && _frag$decryptdata2.key)) {
                    this.loadKey(frag, levelDetails);
                  } else {
                    this.loadFragment(frag, levelDetails, targetBufferTime);
                  }
                };
                _proto.loadFragment = function loadFragment(frag, levelDetails, targetBufferTime) {
                  var _this$media2;
                  // Check if fragment is not loaded
                  var fragState = (this || _global).fragmentTracker.getState(frag);
                  (this || _global).fragCurrent = frag;
                  if (fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__.FragmentState.NOT_LOADED) {
                    if (frag.sn === "initSegment") {
                      this._loadInitSegment(frag);
                    } else if ((this || _global).bitrateTest) {
                      this.log("Fragment " + frag.sn + " of level " + frag.level + " is being downloaded to test bitrate and will not be buffered");
                      this._loadBitrateTestFrag(frag);
                    } else {
                      (this || _global).startFragRequested = true;
                      _BaseStreamController.prototype.loadFragment.call(this || _global, frag, levelDetails, targetBufferTime);
                    }
                  } else if (fragState === _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__.FragmentState.APPENDING) {
                    // Lower the buffer size and try again
                    if (this.reduceMaxBufferLength(frag.duration)) {
                      (this || _global).fragmentTracker.removeFragment(frag);
                    }
                  } else if (((_this$media2 = (this || _global).media) === null || _this$media2 === void 0 ? void 0 : _this$media2.buffered.length) === 0) {
                    // Stop gap for bad tracker / buffer flush behavior
                    (this || _global).fragmentTracker.removeAllFragments();
                  }
                };
                _proto.getAppendedFrag = function getAppendedFrag(position) {
                  var fragOrPart = (this || _global).fragmentTracker.getAppendedFrag(position, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                  if (fragOrPart && "fragment" in fragOrPart) {
                    return fragOrPart.fragment;
                  }
                  return fragOrPart;
                };
                _proto.getBufferedFrag = function getBufferedFrag(position) {
                  return (this || _global).fragmentTracker.getBufferedFrag(position, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                };
                _proto.followingBufferedFrag = function followingBufferedFrag(frag) {
                  if (frag) {
                    // try to get range of next fragment (500ms after this range)
                    return this.getBufferedFrag(frag.end + 0.5);
                  }
                  return null;
                }

                /*
                  on immediate level switch :
                   - pause playback if playing
                   - cancel any pending load request
                   - and trigger a buffer flush
                */;
                _proto.immediateLevelSwitch = function immediateLevelSwitch() {
                  this.abortCurrentFrag();
                  this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                }

                /**
                 * try to switch ASAP without breaking video playback:
                 * in order to ensure smooth but quick level switching,
                 * we need to find the next flushable buffer range
                 * we should take into account new segment fetch time
                 */;
                _proto.nextLevelSwitch = function nextLevelSwitch() {
                  var levels = (this || _global).levels,
                    media = (this || _global).media;
                  // ensure that media is defined and that metadata are available (to retrieve currentTime)
                  if (media !== null && media !== void 0 && media.readyState) {
                    var fetchdelay;
                    var fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
                    if (fragPlayingCurrent && fragPlayingCurrent.start > 1) {
                      // flush buffer preceding current fragment (flush until current fragment start offset)
                      // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
                      this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
                    }
                    if (!media.paused && levels) {
                      // add a safety delay of 1s
                      var nextLevelId = (this || _global).hls.nextLoadLevel;
                      var nextLevel = levels[nextLevelId];
                      var fragLastKbps = (this || _global).fragLastKbps;
                      if (fragLastKbps && (this || _global).fragCurrent) {
                        fetchdelay = (this || _global).fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
                      } else {
                        fetchdelay = 0;
                      }
                    } else {
                      fetchdelay = 0;
                    }
                    // this.log('fetchdelay:'+fetchdelay);
                    // find buffer range that will be reached once new fragment will be fetched
                    var bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
                    if (bufferedFrag) {
                      // we can flush buffer range following this one without stalling playback
                      var nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
                      if (nextBufferedFrag) {
                        // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                        this.abortCurrentFrag();
                        // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
                        var maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
                        var fragDuration = nextBufferedFrag.duration;
                        var startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - (this || _global).config.maxFragLookUpTolerance, fragDuration * 0.5), fragDuration * 0.75));
                        this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
                      }
                    }
                  }
                };
                _proto.abortCurrentFrag = function abortCurrentFrag() {
                  var fragCurrent = (this || _global).fragCurrent;
                  (this || _global).fragCurrent = null;
                  (this || _global).backtrackFragment = null;
                  if (fragCurrent !== null && fragCurrent !== void 0 && fragCurrent.loader) {
                    fragCurrent.loader.abort();
                  }
                  switch ((this || _global).state) {
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.KEY_LOADING:
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING:
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING_WAITING_RETRY:
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING:
                    case _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSED:
                      (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                      break;
                  }
                  (this || _global).nextLoadPosition = this.getLoadPosition();
                };
                _proto.flushMainBuffer = function flushMainBuffer(startOffset, endOffset) {
                  _BaseStreamController.prototype.flushMainBuffer.call(this || _global, startOffset, endOffset, (this || _global).altAudio ? "video" : null);
                };
                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  _BaseStreamController.prototype.onMediaAttached.call(this || _global, event, data);
                  var media = data.media;
                  (this || _global).onvplaying = (this || _global).onMediaPlaying.bind(this || _global);
                  (this || _global).onvseeked = (this || _global).onMediaSeeked.bind(this || _global);
                  media.addEventListener("playing", (this || _global).onvplaying);
                  media.addEventListener("seeked", (this || _global).onvseeked);
                  (this || _global).gapController = new _gap_controller__WEBPACK_IMPORTED_MODULE_10__["default"]((this || _global).config, media, (this || _global).fragmentTracker, (this || _global).hls);
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  var media = (this || _global).media;
                  if (media && (this || _global).onvplaying && (this || _global).onvseeked) {
                    media.removeEventListener("playing", (this || _global).onvplaying);
                    media.removeEventListener("seeked", (this || _global).onvseeked);
                    (this || _global).onvplaying = (this || _global).onvseeked = null;
                    (this || _global).videoBuffer = null;
                  }
                  (this || _global).fragPlaying = null;
                  if ((this || _global).gapController) {
                    (this || _global).gapController.destroy();
                    (this || _global).gapController = null;
                  }
                  _BaseStreamController.prototype.onMediaDetaching.call(this || _global);
                };
                _proto.onMediaPlaying = function onMediaPlaying() {
                  // tick to speed up FRAG_CHANGED triggering
                  this.tick();
                };
                _proto.onMediaSeeked = function onMediaSeeked() {
                  var media = (this || _global).media;
                  var currentTime = media ? media.currentTime : null;
                  if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(currentTime)) {
                    this.log("Media seeked to " + currentTime.toFixed(3));
                  }

                  // tick to speed up FRAG_CHANGED triggering
                  this.tick();
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  // reset buffer on manifest loading
                  this.log("Trigger BUFFER_RESET");
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_RESET, undefined);
                  (this || _global).fragmentTracker.removeAllFragments();
                  (this || _global).couldBacktrack = false;
                  (this || _global).startPosition = (this || _global).lastCurrentTime = 0;
                  (this || _global).fragPlaying = null;
                  (this || _global).backtrackFragment = null;
                };
                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  var aac = false;
                  var heaac = false;
                  var codec;
                  data.levels.forEach(function (level) {
                    // detect if we have different kind of audio codecs used amongst playlists
                    codec = level.audioCodec;
                    if (codec) {
                      if (codec.indexOf("mp4a.40.2") !== -1) {
                        aac = true;
                      }
                      if (codec.indexOf("mp4a.40.5") !== -1) {
                        heaac = true;
                      }
                    }
                  });
                  (this || _global).audioCodecSwitch = aac && heaac && !(0, _is_supported__WEBPACK_IMPORTED_MODULE_2__.changeTypeSupported)();
                  if ((this || _global).audioCodecSwitch) {
                    this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC");
                  }
                  (this || _global).levels = data.levels;
                  (this || _global).startFragRequested = false;
                };
                _proto.onLevelLoading = function onLevelLoading(event, data) {
                  var levels = (this || _global).levels;
                  if (!levels || (this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE) {
                    return;
                  }
                  var level = levels[data.level];
                  if (!level.details || level.details.live && (this || _global).levelLastLoaded !== data.level || this.waitForCdnTuneIn(level.details)) {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL;
                  }
                };
                _proto.onLevelLoaded = function onLevelLoaded(event, data) {
                  var _curLevel$details;
                  var levels = (this || _global).levels;
                  var newLevelId = data.level;
                  var newDetails = data.details;
                  var duration = newDetails.totalduration;
                  if (!levels) {
                    this.warn("Levels were reset while loading level " + newLevelId);
                    return;
                  }
                  this.log("Level " + newLevelId + " loaded [" + newDetails.startSN + "," + newDetails.endSN + "], cc [" + newDetails.startCC + ", " + newDetails.endCC + "] duration:" + duration);
                  var fragCurrent = (this || _global).fragCurrent;
                  if (fragCurrent && ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING || (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.FRAG_LOADING_WAITING_RETRY)) {
                    if (fragCurrent.level !== data.level && fragCurrent.loader) {
                      (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                      (this || _global).backtrackFragment = null;
                      fragCurrent.loader.abort();
                    }
                  }
                  var curLevel = levels[newLevelId];
                  var sliding = 0;
                  if (newDetails.live || (_curLevel$details = curLevel.details) !== null && _curLevel$details !== void 0 && _curLevel$details.live) {
                    if (!newDetails.fragments[0]) {
                      newDetails.deltaUpdateFailed = true;
                    }
                    if (newDetails.deltaUpdateFailed) {
                      return;
                    }
                    sliding = this.alignPlaylists(newDetails, curLevel.details);
                  }
                  // override level info
                  curLevel.details = newDetails;
                  (this || _global).levelLastLoaded = newLevelId;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVEL_UPDATED, {
                    details: newDetails,
                    level: newLevelId
                  });

                  // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
                  if ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL) {
                    if (this.waitForCdnTuneIn(newDetails)) {
                      // Wait for Low-Latency CDN Tune-in
                      return;
                    }
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  }
                  if (!(this || _global).startFragRequested) {
                    this.setStartPosition(newDetails, sliding);
                  } else if (newDetails.live) {
                    this.synchronizeToLiveEdge(newDetails);
                  }

                  // trigger handler right now
                  this.tick();
                };
                _proto._handleFragmentLoadProgress = function _handleFragmentLoadProgress(data) {
                  var _frag$initSegment;
                  var frag = data.frag,
                    part = data.part,
                    payload = data.payload;
                  var levels = (this || _global).levels;
                  if (!levels) {
                    this.warn("Levels were reset while fragment load was in progress. Fragment " + frag.sn + " of level " + frag.level + " will not be buffered");
                    return;
                  }
                  var currentLevel = levels[frag.level];
                  var details = currentLevel.details;
                  if (!details) {
                    this.warn("Dropping fragment " + frag.sn + " of level " + frag.level + " after level details were reset");
                    return;
                  }
                  var videoCodec = currentLevel.videoCodec;

                  // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
                  var accurateTimeOffset = details.PTSKnown || !details.live;
                  var initSegmentData = (_frag$initSegment = frag.initSegment) === null || _frag$initSegment === void 0 ? void 0 : _frag$initSegment.data;
                  var audioCodec = this._getAudioCodec(currentLevel);

                  // transmux the MPEG-TS data to ISO-BMFF segments
                  // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
                  var transmuxer = (this || _global).transmuxer = (this || _global).transmuxer || new _demux_transmuxer_interface__WEBPACK_IMPORTED_MODULE_8__["default"]((this || _global).hls, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN, (this || _global)._handleTransmuxComplete.bind(this || _global), (this || _global)._handleTransmuxerFlush.bind(this || _global));
                  var partIndex = part ? part.index : -1;
                  var partial = partIndex !== -1;
                  var chunkMeta = new _types_transmuxer__WEBPACK_IMPORTED_MODULE_9__.ChunkMetadata(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
                  var initPTS = (this || _global).initPTS[frag.cc];
                  transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
                };
                _proto.onAudioTrackSwitching = function onAudioTrackSwitching(event, data) {
                  // if any URL found on new audio track, it is an alternate audio track
                  var fromAltAudio = (this || _global).altAudio;
                  var altAudio = !!data.url;
                  var trackId = data.id;
                  // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
                  // don't do anything if we switch to alt audio: audio stream controller is handling it.
                  // we will just have to change buffer scheduling on audioTrackSwitched
                  if (!altAudio) {
                    if ((this || _global).mediaBuffer !== (this || _global).media) {
                      this.log("Switching on main audio, use media.buffered to schedule main fragment loading");
                      (this || _global).mediaBuffer = (this || _global).media;
                      var fragCurrent = (this || _global).fragCurrent;
                      // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                      if (fragCurrent !== null && fragCurrent !== void 0 && fragCurrent.loader) {
                        this.log("Switching to main audio track, cancel main fragment load");
                        fragCurrent.loader.abort();
                      }
                      // destroy transmuxer to force init segment generation (following audio switch)
                      this.resetTransmuxer();
                      // switch to IDLE state to load new fragment
                      this.resetLoadingState();
                    } else if ((this || _global).audioOnly) {
                      // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
                      this.resetTransmuxer();
                    }
                    var hls = (this || _global).hls;
                    // If switching from alt to main audio, flush all audio and trigger track switched
                    if (fromAltAudio) {
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: Number.POSITIVE_INFINITY,
                        type: "audio"
                      });
                    }
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.AUDIO_TRACK_SWITCHED, {
                      id: trackId
                    });
                  }
                };
                _proto.onAudioTrackSwitched = function onAudioTrackSwitched(event, data) {
                  var trackId = data.id;
                  var altAudio = !!(this || _global).hls.audioTracks[trackId].url;
                  if (altAudio) {
                    var videoBuffer = (this || _global).videoBuffer;
                    // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
                    if (videoBuffer && (this || _global).mediaBuffer !== videoBuffer) {
                      this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading");
                      (this || _global).mediaBuffer = videoBuffer;
                    }
                  }
                  (this || _global).altAudio = altAudio;
                  this.tick();
                };
                _proto.onBufferCreated = function onBufferCreated(event, data) {
                  var tracks = data.tracks;
                  var mediaTrack;
                  var name;
                  var alternate = false;
                  for (var type in tracks) {
                    var track = tracks[type];
                    if (track.id === "main") {
                      name = type;
                      mediaTrack = track;
                      // keep video source buffer reference
                      if (type === "video") {
                        var videoTrack = tracks[type];
                        if (videoTrack) {
                          (this || _global).videoBuffer = videoTrack.buffer;
                        }
                      }
                    } else {
                      alternate = true;
                    }
                  }
                  if (alternate && mediaTrack) {
                    this.log("Alternate track found, use " + name + ".buffered to schedule main fragment loading");
                    (this || _global).mediaBuffer = mediaTrack.buffer;
                  } else {
                    (this || _global).mediaBuffer = (this || _global).media;
                  }
                };
                _proto.onFragBuffered = function onFragBuffered(event, data) {
                  var frag = data.frag,
                    part = data.part;
                  if (frag && frag.type !== _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN) {
                    return;
                  }
                  if (this.fragContextChanged(frag)) {
                    // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
                    // Avoid setting state back to IDLE, since that will interfere with a level switch
                    this.warn("Fragment " + frag.sn + (part ? " p: " + part.index : "") + " of level " + frag.level + " finished buffering, but was aborted. state: " + (this || _global).state);
                    if ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSED) {
                      (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                    }
                    return;
                  }
                  var stats = part ? part.stats : frag.stats;
                  (this || _global).fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
                  if (frag.sn !== "initSegment") {
                    (this || _global).fragPrevious = frag;
                  }
                  this.fragBufferedComplete(frag, part);
                };
                _proto.onError = function onError(event, data) {
                  switch (data.details) {
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.FRAG_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.FRAG_LOAD_TIMEOUT:
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.KEY_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.KEY_LOAD_TIMEOUT:
                      this.onFragmentOrKeyLoadError(_types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN, data);
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.LEVEL_LOAD_ERROR:
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                      if ((this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ERROR) {
                        if (data.fatal) {
                          // if fatal error, stop processing
                          this.warn("" + data.details);
                          (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.ERROR;
                        } else {
                          // in case of non fatal error while loading level, if level controller is not retrying to load level , switch back to IDLE
                          if (!data.levelRetry && (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.WAITING_LEVEL) {
                            (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                          }
                        }
                      }
                      break;
                    case _errors__WEBPACK_IMPORTED_MODULE_11__.ErrorDetails.BUFFER_FULL_ERROR:
                      // if in appending state
                      if (data.parent === "main" && ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING || (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSED)) {
                        var flushBuffer = true;
                        var bufferedInfo = this.getFwdBufferInfo((this || _global).media, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                        // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
                        // reduce max buf len if current position is buffered
                        if (bufferedInfo && bufferedInfo.len > 0.5) {
                          flushBuffer = !this.reduceMaxBufferLength(bufferedInfo.len);
                        }
                        if (flushBuffer) {
                          // current position is not buffered, but browser is still complaining about buffer full error
                          // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
                          // in that case flush the whole buffer to recover
                          this.warn("buffer full error also media.currentTime is not buffered, flush main");
                          // flush main buffer
                          this.immediateLevelSwitch();
                        }
                        this.resetLoadingState();
                      }
                      break;
                  }
                }

                // Checks the health of the buffer and attempts to resolve playback stalls.
                ;

                _proto.checkBuffer = function checkBuffer() {
                  var media = (this || _global).media,
                    gapController = (this || _global).gapController;
                  if (!media || !gapController || !media.readyState) {
                    // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
                    return;
                  }
                  if ((this || _global).loadedmetadata || !_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.getBuffered(media).length) {
                    // Resolve gaps using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
                    var activeFrag = (this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE ? (this || _global).fragCurrent : null;
                    gapController.poll((this || _global).lastCurrentTime, activeFrag);
                  }
                  (this || _global).lastCurrentTime = media.currentTime;
                };
                _proto.onFragLoadEmergencyAborted = function onFragLoadEmergencyAborted() {
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                  // if loadedmetadata is not set, it means that we are emergency switch down on first frag
                  // in that case, reset startFragRequested flag
                  if (!(this || _global).loadedmetadata) {
                    (this || _global).startFragRequested = false;
                    (this || _global).nextLoadPosition = (this || _global).startPosition;
                  }
                  this.tickImmediate();
                };
                _proto.onBufferFlushed = function onBufferFlushed(event, _ref) {
                  var type = _ref.type;
                  if (type !== _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO || (this || _global).audioOnly && !(this || _global).altAudio) {
                    var media = (type === _loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.VIDEO ? (this || _global).videoBuffer : (this || _global).mediaBuffer) || (this || _global).media;
                    this.afterBufferFlushed(media, type, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                  }
                };
                _proto.onLevelsUpdated = function onLevelsUpdated(event, data) {
                  (this || _global).levels = data.levels;
                };
                _proto.swapAudioCodec = function swapAudioCodec() {
                  (this || _global).audioCodecSwap = !(this || _global).audioCodecSwap;
                }

                /**
                 * Seeks to the set startPosition if not equal to the mediaElement's current time.
                 */;
                _proto.seekToStartPos = function seekToStartPos() {
                  var media = (this || _global).media;
                  if (!media) {
                    return;
                  }
                  var currentTime = media.currentTime;
                  var startPosition = (this || _global).startPosition;
                  // only adjust currentTime if different from startPosition or if startPosition not buffered
                  // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
                  if (startPosition >= 0 && currentTime < startPosition) {
                    if (media.seeking) {
                      this.log("could not seek to " + startPosition + ", already seeking at " + currentTime);
                      return;
                    }
                    var buffered = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.getBuffered(media);
                    var bufferStart = buffered.length ? buffered.start(0) : 0;
                    var delta = bufferStart - startPosition;
                    if (delta > 0 && (delta < (this || _global).config.maxBufferHole || delta < (this || _global).config.maxFragLookUpTolerance)) {
                      this.log("adjusting start position by " + delta + " to match buffer start");
                      startPosition += delta;
                      (this || _global).startPosition = startPosition;
                    }
                    this.log("seek to target start position " + startPosition + " from current time " + currentTime);
                    media.currentTime = startPosition;
                  }
                };
                _proto._getAudioCodec = function _getAudioCodec(currentLevel) {
                  var audioCodec = (this || _global).config.defaultAudioCodec || currentLevel.audioCodec;
                  if ((this || _global).audioCodecSwap && audioCodec) {
                    this.log("Swapping audio codec");
                    if (audioCodec.indexOf("mp4a.40.5") !== -1) {
                      audioCodec = "mp4a.40.2";
                    } else {
                      audioCodec = "mp4a.40.5";
                    }
                  }
                  return audioCodec;
                };
                _proto._loadBitrateTestFrag = function _loadBitrateTestFrag(frag) {
                  var _this2 = this || _global;
                  frag.bitrateTest = true;
                  this._doFragLoad(frag).then(function (data) {
                    var hls = _this2.hls;
                    if (!data || hls.nextLoadLevel || _this2.fragContextChanged(frag)) {
                      return;
                    }
                    _this2.fragLoadError = 0;
                    _this2.state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                    _this2.startFragRequested = false;
                    _this2.bitrateTest = false;
                    var stats = frag.stats;
                    // Bitrate tests fragments are neither parsed nor buffered
                    stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_LOADED, data);
                    frag.bitrateTest = false;
                  });
                };
                _proto._handleTransmuxComplete = function _handleTransmuxComplete(transmuxResult) {
                  var _id3$samples;
                  var id = "main";
                  var hls = (this || _global).hls;
                  var remuxResult = transmuxResult.remuxResult,
                    chunkMeta = transmuxResult.chunkMeta;
                  var context = this.getCurrentContext(chunkMeta);
                  if (!context) {
                    this.warn("The loading context changed while buffering fragment " + chunkMeta.sn + " of level " + chunkMeta.level + ". This chunk will not be buffered.");
                    this.resetStartWhenNotLoaded(chunkMeta.level);
                    return;
                  }
                  var frag = context.frag,
                    part = context.part,
                    level = context.level;
                  var video = remuxResult.video,
                    text = remuxResult.text,
                    id3 = remuxResult.id3,
                    initSegment = remuxResult.initSegment;
                  var details = level.details;
                  // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
                  var audio = (this || _global).altAudio ? undefined : remuxResult.audio;

                  // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
                  // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
                  if (this.fragContextChanged(frag)) {
                    return;
                  }
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING;
                  if (initSegment) {
                    if (initSegment.tracks) {
                      this._bufferInitSegment(level, initSegment.tracks, frag, chunkMeta);
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_PARSING_INIT_SEGMENT, {
                        frag: frag,
                        id: id,
                        tracks: initSegment.tracks
                      });
                    }

                    // This would be nice if Number.isFinite acted as a typeguard, but it doesn't. See: https://github.com/Microsoft/TypeScript/issues/10038
                    var initPTS = initSegment.initPTS;
                    var timescale = initSegment.timescale;
                    if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(initPTS)) {
                      (this || _global).initPTS[frag.cc] = initPTS;
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.INIT_PTS_FOUND, {
                        frag: frag,
                        id: id,
                        initPTS: initPTS,
                        timescale: timescale
                      });
                    }
                  }

                  // Avoid buffering if backtracking this fragment
                  if (video && remuxResult.independent !== false) {
                    if (details) {
                      var startPTS = video.startPTS,
                        endPTS = video.endPTS,
                        startDTS = video.startDTS,
                        endDTS = video.endDTS;
                      if (part) {
                        part.elementaryStreams[video.type] = {
                          startPTS: startPTS,
                          endPTS: endPTS,
                          startDTS: startDTS,
                          endDTS: endDTS
                        };
                      } else {
                        if (video.firstKeyFrame && video.independent) {
                          (this || _global).couldBacktrack = true;
                        }
                        if (video.dropped && video.independent) {
                          // Backtrack if dropped frames create a gap after currentTime

                          var bufferInfo = this.getMainFwdBufferInfo();
                          var targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + (this || _global).config.maxBufferHole;
                          var startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
                          if (targetBufferTime < startTime - (this || _global).config.maxBufferHole) {
                            this.backtrack(frag);
                            return;
                          }
                          // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
                          frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
                        }
                      }
                      frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
                      if ((this || _global).backtrackFragment) {
                        (this || _global).backtrackFragment = frag;
                      }
                      this.bufferFragmentData(video, frag, part, chunkMeta);
                    }
                  } else if (remuxResult.independent === false) {
                    this.backtrack(frag);
                    return;
                  }
                  if (audio) {
                    var _startPTS = audio.startPTS,
                      _endPTS = audio.endPTS,
                      _startDTS = audio.startDTS,
                      _endDTS = audio.endDTS;
                    if (part) {
                      part.elementaryStreams[_loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO] = {
                        startPTS: _startPTS,
                        endPTS: _endPTS,
                        startDTS: _startDTS,
                        endDTS: _endDTS
                      };
                    }
                    frag.setElementaryStreamInfo(_loader_fragment__WEBPACK_IMPORTED_MODULE_7__.ElementaryStreamTypes.AUDIO, _startPTS, _endPTS, _startDTS, _endDTS);
                    this.bufferFragmentData(audio, frag, part, chunkMeta);
                  }
                  if (details && id3 !== null && id3 !== void 0 && (_id3$samples = id3.samples) !== null && _id3$samples !== void 0 && _id3$samples.length) {
                    var emittedID3 = {
                      id: id,
                      frag: frag,
                      details: details,
                      samples: id3.samples
                    };
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_PARSING_METADATA, emittedID3);
                  }
                  if (details && text) {
                    var emittedText = {
                      id: id,
                      frag: frag,
                      details: details,
                      samples: text.samples
                    };
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_PARSING_USERDATA, emittedText);
                  }
                };
                _proto._bufferInitSegment = function _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
                  var _this3 = this || _global;
                  if ((this || _global).state !== _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.PARSING) {
                    return;
                  }
                  (this || _global).audioOnly = !!tracks.audio && !tracks.video;

                  // if audio track is expected to come from audio stream controller, discard any coming from main
                  if ((this || _global).altAudio && !(this || _global).audioOnly) {
                    delete tracks.audio;
                  }
                  // include levelCodec in audio and video tracks
                  var audio = tracks.audio,
                    video = tracks.video,
                    audiovideo = tracks.audiovideo;
                  if (audio) {
                    var audioCodec = currentLevel.audioCodec;
                    var ua = navigator.userAgent.toLowerCase();
                    if ((this || _global).audioCodecSwitch) {
                      if (audioCodec) {
                        if (audioCodec.indexOf("mp4a.40.5") !== -1) {
                          audioCodec = "mp4a.40.2";
                        } else {
                          audioCodec = "mp4a.40.5";
                        }
                      }
                      // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
                      // force HE-AAC, as it seems that most browsers prefers it.
                      // don't force HE-AAC if mono stream, or in Firefox
                      if (audio.metadata.channelCount !== 1 && ua.indexOf("firefox") === -1) {
                        audioCodec = "mp4a.40.5";
                      }
                    }
                    // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
                    if (ua.indexOf("android") !== -1 && audio.container !== "audio/mpeg") {
                      // Exclude mpeg audio
                      audioCodec = "mp4a.40.2";
                      this.log("Android: force audio codec to " + audioCodec);
                    }
                    if (currentLevel.audioCodec && currentLevel.audioCodec !== audioCodec) {
                      this.log("Swapping manifest audio codec \"" + currentLevel.audioCodec + "\" for \"" + audioCodec + "\"");
                    }
                    audio.levelCodec = audioCodec;
                    audio.id = "main";
                    this.log("Init audio buffer, container:" + audio.container + ", codecs[selected/level/parsed]=[" + (audioCodec || "") + "/" + (currentLevel.audioCodec || "") + "/" + audio.codec + "]");
                  }
                  if (video) {
                    video.levelCodec = currentLevel.videoCodec;
                    video.id = "main";
                    this.log("Init video buffer, container:" + video.container + ", codecs[level/parsed]=[" + (currentLevel.videoCodec || "") + "/" + video.codec + "]");
                  }
                  if (audiovideo) {
                    this.log("Init audiovideo buffer, container:" + audiovideo.container + ", codecs[level/parsed]=[" + (currentLevel.attrs.CODECS || "") + "/" + audiovideo.codec + "]");
                  }
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_CODECS, tracks);
                  // loop through tracks that are going to be provided to bufferController
                  Object.keys(tracks).forEach(function (trackName) {
                    var track = tracks[trackName];
                    var initSegment = track.initSegment;
                    if (initSegment !== null && initSegment !== void 0 && initSegment.byteLength) {
                      _this3.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.BUFFER_APPENDING, {
                        type: trackName,
                        data: initSegment,
                        frag: frag,
                        part: null,
                        chunkMeta: chunkMeta,
                        parent: frag.type
                      });
                    }
                  });
                  // trigger handler right now
                  this.tick();
                };
                _proto.getMainFwdBufferInfo = function getMainFwdBufferInfo() {
                  return this.getFwdBufferInfo((this || _global).mediaBuffer ? (this || _global).mediaBuffer : (this || _global).media, _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN);
                };
                _proto.backtrack = function backtrack(frag) {
                  (this || _global).couldBacktrack = true;
                  // Causes findFragments to backtrack through fragments to find the keyframe
                  (this || _global).backtrackFragment = frag;
                  this.resetTransmuxer();
                  this.flushBufferGap(frag);
                  (this || _global).fragmentTracker.removeFragment(frag);
                  (this || _global).fragPrevious = null;
                  (this || _global).nextLoadPosition = frag.start;
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_1__.State.IDLE;
                };
                _proto.checkFragmentChanged = function checkFragmentChanged() {
                  var video = (this || _global).media;
                  var fragPlayingCurrent = null;
                  if (video && video.readyState > 1 && video.seeking === false) {
                    var currentTime = video.currentTime;
                    /* if video element is in seeked state, currentTime can only increase.
                      (assuming that playback rate is positive ...)
                      As sometimes currentTime jumps back to zero after a
                      media decode error, check this, to avoid seeking back to
                      wrong position after a media decode error
                    */

                    if (_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.isBuffered(video, currentTime)) {
                      fragPlayingCurrent = this.getAppendedFrag(currentTime);
                    } else if (_utils_buffer_helper__WEBPACK_IMPORTED_MODULE_4__.BufferHelper.isBuffered(video, currentTime + 0.1)) {
                      /* ensure that FRAG_CHANGED event is triggered at startup,
                        when first video frame is displayed and playback is paused.
                        add a tolerance of 100ms, in case current position is not buffered,
                        check if current pos+100ms is buffered and use that buffer range
                        for FRAG_CHANGED event reporting */
                      fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
                    }
                    if (fragPlayingCurrent) {
                      (this || _global).backtrackFragment = null;
                      var fragPlaying = (this || _global).fragPlaying;
                      var fragCurrentLevel = fragPlayingCurrent.level;
                      if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel || fragPlayingCurrent.urlId !== fragPlaying.urlId) {
                        (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.FRAG_CHANGED, {
                          frag: fragPlayingCurrent
                        });
                        if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) {
                          (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_3__.Events.LEVEL_SWITCHED, {
                            level: fragCurrentLevel
                          });
                        }
                        (this || _global).fragPlaying = fragPlayingCurrent;
                      }
                    }
                  }
                };
                _createClass(StreamController, [{
                  key: "nextLevel",
                  get: function get() {
                    var frag = (this || _global).nextBufferedFrag;
                    if (frag) {
                      return frag.level;
                    }
                    return -1;
                  }
                }, {
                  key: "currentFrag",
                  get: function get() {
                    var media = (this || _global).media;
                    if (media) {
                      return (this || _global).fragPlaying || this.getAppendedFrag(media.currentTime);
                    }
                    return null;
                  }
                }, {
                  key: "currentProgramDateTime",
                  get: function get() {
                    var media = (this || _global).media;
                    if (media) {
                      var currentTime = media.currentTime;
                      var frag = (this || _global).currentFrag;
                      if (frag && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(currentTime) && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.programDateTime)) {
                        var epocMs = frag.programDateTime + (currentTime - frag.start) * 1000;
                        return new Date(epocMs);
                      }
                    }
                    return null;
                  }
                }, {
                  key: "currentLevel",
                  get: function get() {
                    var frag = (this || _global).currentFrag;
                    if (frag) {
                      return frag.level;
                    }
                    return -1;
                  }
                }, {
                  key: "nextBufferedFrag",
                  get: function get() {
                    var frag = (this || _global).currentFrag;
                    if (frag) {
                      return this.followingBufferedFrag(frag);
                    }
                    return null;
                  }
                }, {
                  key: "forceStartLoad",
                  get: function get() {
                    return (this || _global)._forceStartLoad;
                  }
                }]);
                return StreamController;
              }(_base_stream_controller__WEBPACK_IMPORTED_MODULE_1__["default"]);

              /***/
            },

            /***/"./src/controller/subtitle-stream-controller.ts":
            /*!******************************************************!*\
              !*** ./src/controller/subtitle-stream-controller.ts ***!
              \******************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"SubtitleStreamController": () => /* binding */SubtitleStreamController
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/buffer-helper */"./src/utils/buffer-helper.ts");
              /* harmony import */
              var _fragment_finders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./fragment-finders */"./src/controller/fragment-finders.ts");
              /* harmony import */
              var _utils_discontinuities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/discontinuities */"./src/utils/discontinuities.ts");
              /* harmony import */
              var _level_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./level-helper */"./src/controller/level-helper.ts");
              /* harmony import */
              var _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./fragment-tracker */"./src/controller/fragment-tracker.ts");
              /* harmony import */
              var _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ./base-stream-controller */"./src/controller/base-stream-controller.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _types_level__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../types/level */"./src/types/level.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var TICK_INTERVAL = 500; // how often to tick in ms

              var SubtitleStreamController = /*#__PURE__*/function (_BaseStreamController) {
                _inheritsLoose(SubtitleStreamController, _BaseStreamController);
                function SubtitleStreamController(hls, fragmentTracker) {
                  var _this;
                  _this = _BaseStreamController.call(this || _global, hls, fragmentTracker, "[subtitle-stream-controller]") || this || _global;
                  _this.levels = [];
                  _this.currentTrackId = -1;
                  _this.tracksBuffered = [];
                  _this.mainDetails = null;
                  _this._registerListeners();
                  return _this;
                }
                var _proto = SubtitleStreamController.prototype;
                _proto.onHandlerDestroying = function onHandlerDestroying() {
                  this._unregisterListeners();
                  (this || _global).mainDetails = null;
                };
                _proto._registerListeners = function _registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACKS_UPDATED, (this || _global).onSubtitleTracksUpdated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_SWITCH, (this || _global).onSubtitleTrackSwitch, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_LOADED, (this || _global).onSubtitleTrackLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_FRAG_PROCESSED, (this || _global).onSubtitleFragProcessed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                };
                _proto._unregisterListeners = function _unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADED, (this || _global).onLevelLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACKS_UPDATED, (this || _global).onSubtitleTracksUpdated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_SWITCH, (this || _global).onSubtitleTrackSwitch, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_LOADED, (this || _global).onSubtitleTrackLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_FRAG_PROCESSED, (this || _global).onSubtitleFragProcessed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_BUFFERED, (this || _global).onFragBuffered, this || _global);
                };
                _proto.startLoad = function startLoad(startPosition) {
                  this.stopLoad();
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE;
                  this.setInterval(TICK_INTERVAL);
                  (this || _global).nextLoadPosition = (this || _global).startPosition = (this || _global).lastCurrentTime = startPosition;
                  this.tick();
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).mainDetails = null;
                  (this || _global).fragmentTracker.removeAllFragments();
                };
                _proto.onLevelLoaded = function onLevelLoaded(event, data) {
                  (this || _global).mainDetails = data.details;
                };
                _proto.onSubtitleFragProcessed = function onSubtitleFragProcessed(event, data) {
                  var frag = data.frag,
                    success = data.success;
                  (this || _global).fragPrevious = frag;
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE;
                  if (!success) {
                    return;
                  }
                  var buffered = (this || _global).tracksBuffered[(this || _global).currentTrackId];
                  if (!buffered) {
                    return;
                  }

                  // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
                  // so we can re-use the logic used to detect how much has been buffered
                  var timeRange;
                  var fragStart = frag.start;
                  for (var i = 0; i < buffered.length; i++) {
                    if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
                      timeRange = buffered[i];
                      break;
                    }
                  }
                  var fragEnd = frag.start + frag.duration;
                  if (timeRange) {
                    timeRange.end = fragEnd;
                  } else {
                    timeRange = {
                      start: fragStart,
                      end: fragEnd
                    };
                    buffered.push(timeRange);
                  }
                  (this || _global).fragmentTracker.fragBuffered(frag);
                };
                _proto.onBufferFlushing = function onBufferFlushing(event, data) {
                  var startOffset = data.startOffset,
                    endOffset = data.endOffset;
                  if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
                    var currentTrackId = (this || _global).currentTrackId,
                      levels = (this || _global).levels;
                    if (!levels.length || !levels[currentTrackId] || !levels[currentTrackId].details) {
                      return;
                    }
                    var trackDetails = levels[currentTrackId].details;
                    var targetDuration = trackDetails.targetduration;
                    var endOffsetSubtitles = endOffset - targetDuration;
                    if (endOffsetSubtitles <= 0) {
                      return;
                    }
                    data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
                    (this || _global).tracksBuffered.forEach(function (buffered) {
                      for (var i = 0; i < buffered.length;) {
                        if (buffered[i].end <= endOffsetSubtitles) {
                          buffered.shift();
                          continue;
                        } else if (buffered[i].start < endOffsetSubtitles) {
                          buffered[i].start = endOffsetSubtitles;
                        } else {
                          break;
                        }
                        i++;
                      }
                    });
                    (this || _global).fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, _types_loader__WEBPACK_IMPORTED_MODULE_7__.PlaylistLevelType.SUBTITLE);
                  }
                };
                _proto.onFragBuffered = function onFragBuffered(event, data) {
                  if (!(this || _global).loadedmetadata && data.frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_7__.PlaylistLevelType.MAIN) {
                    var _this$media;
                    if ((_this$media = (this || _global).media) !== null && _this$media !== void 0 && _this$media.buffered.length) {
                      (this || _global).loadedmetadata = true;
                    }
                  }
                }

                // If something goes wrong, proceed to next frag, if we were processing one.
                ;

                _proto.onError = function onError(event, data) {
                  var _this$fragCurrent;
                  var frag = data.frag;
                  // don't handle error not related to subtitle fragment
                  if (!frag || frag.type !== _types_loader__WEBPACK_IMPORTED_MODULE_7__.PlaylistLevelType.SUBTITLE) {
                    return;
                  }
                  if ((_this$fragCurrent = (this || _global).fragCurrent) !== null && _this$fragCurrent !== void 0 && _this$fragCurrent.loader) {
                    (this || _global).fragCurrent.loader.abort();
                  }
                  (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE;
                }

                // Got all new subtitle levels.
                ;

                _proto.onSubtitleTracksUpdated = function onSubtitleTracksUpdated(event, _ref) {
                  var _this2 = this || _global;
                  var subtitleTracks = _ref.subtitleTracks;
                  (this || _global).tracksBuffered = [];
                  (this || _global).levels = subtitleTracks.map(function (mediaPlaylist) {
                    return new _types_level__WEBPACK_IMPORTED_MODULE_8__.Level(mediaPlaylist);
                  });
                  (this || _global).fragmentTracker.removeAllFragments();
                  (this || _global).fragPrevious = null;
                  (this || _global).levels.forEach(function (level) {
                    _this2.tracksBuffered[level.id] = [];
                  });
                  (this || _global).mediaBuffer = null;
                };
                _proto.onSubtitleTrackSwitch = function onSubtitleTrackSwitch(event, data) {
                  (this || _global).currentTrackId = data.id;
                  if (!(this || _global).levels.length || (this || _global).currentTrackId === -1) {
                    this.clearInterval();
                    return;
                  }

                  // Check if track has the necessary details to load fragments
                  var currentTrack = (this || _global).levels[(this || _global).currentTrackId];
                  if (currentTrack !== null && currentTrack !== void 0 && currentTrack.details) {
                    (this || _global).mediaBuffer = (this || _global).mediaBufferTimeRanges;
                  } else {
                    (this || _global).mediaBuffer = null;
                  }
                  if (currentTrack) {
                    this.setInterval(TICK_INTERVAL);
                  }
                }

                // Got a new set of subtitle fragments.
                ;

                _proto.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(event, data) {
                  var _track$details;
                  var newDetails = data.details,
                    trackId = data.id;
                  var currentTrackId = (this || _global).currentTrackId,
                    levels = (this || _global).levels;
                  if (!levels.length) {
                    return;
                  }
                  var track = levels[currentTrackId];
                  if (trackId >= levels.length || trackId !== currentTrackId || !track) {
                    return;
                  }
                  (this || _global).mediaBuffer = (this || _global).mediaBufferTimeRanges;
                  var sliding = 0;
                  if (newDetails.live || (_track$details = track.details) !== null && _track$details !== void 0 && _track$details.live) {
                    var mainDetails = (this || _global).mainDetails;
                    if (newDetails.deltaUpdateFailed || !mainDetails) {
                      return;
                    }
                    var mainSlidingStartFragment = mainDetails.fragments[0];
                    if (!track.details) {
                      if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                        (0, _utils_discontinuities__WEBPACK_IMPORTED_MODULE_3__.alignMediaPlaylistByPDT)(newDetails, mainDetails);
                        sliding = newDetails.fragments[0].start;
                      } else if (mainSlidingStartFragment) {
                        // line up live playlist with main so that fragments in range are loaded
                        sliding = mainSlidingStartFragment.start;
                        (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.addSliding)(newDetails, sliding);
                      }
                    } else {
                      sliding = this.alignPlaylists(newDetails, track.details);
                      if (sliding === 0 && mainSlidingStartFragment) {
                        // realign with main when there is no overlap with last refresh
                        sliding = mainSlidingStartFragment.start;
                        (0, _level_helper__WEBPACK_IMPORTED_MODULE_4__.addSliding)(newDetails, sliding);
                      }
                    }
                  }
                  track.details = newDetails;
                  (this || _global).levelLastLoaded = trackId;
                  if (!(this || _global).startFragRequested && ((this || _global).mainDetails || !newDetails.live)) {
                    this.setStartPosition(track.details, sliding);
                  }

                  // trigger handler right now
                  this.tick();

                  // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
                  if (newDetails.live && !(this || _global).fragCurrent && (this || _global).media && (this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE) {
                    var foundFrag = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_2__.findFragmentByPTS)(null, newDetails.fragments, (this || _global).media.currentTime, 0);
                    if (!foundFrag) {
                      this.warn("Subtitle playlist not aligned with playback");
                      track.details = undefined;
                    }
                  }
                };
                _proto._handleFragmentLoadComplete = function _handleFragmentLoadComplete(fragLoadedData) {
                  var frag = fragLoadedData.frag,
                    payload = fragLoadedData.payload;
                  var decryptData = frag.decryptdata;
                  var hls = (this || _global).hls;
                  if (this.fragContextChanged(frag)) {
                    return;
                  }
                  // check to see if the payload needs to be decrypted
                  if (payload && payload.byteLength > 0 && decryptData && decryptData.key && decryptData.iv && decryptData.method === "AES-128") {
                    var startTime = performance.now();
                    // decrypt the subtitles
                    (this || _global).decrypter.webCryptoDecrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer).then(function (decryptedData) {
                      var endTime = performance.now();
                      hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.FRAG_DECRYPTED, {
                        frag: frag,
                        payload: decryptedData,
                        stats: {
                          tstart: startTime,
                          tdecrypt: endTime
                        }
                      });
                    });
                  }
                };
                _proto.doTick = function doTick() {
                  if (!(this || _global).media) {
                    (this || _global).state = _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE;
                    return;
                  }
                  if ((this || _global).state === _base_stream_controller__WEBPACK_IMPORTED_MODULE_6__.State.IDLE) {
                    var currentTrackId = (this || _global).currentTrackId,
                      levels = (this || _global).levels;
                    if (!levels.length || !levels[currentTrackId] || !levels[currentTrackId].details) {
                      return;
                    }

                    // Expand range of subs loaded by one target-duration in either direction to make up for misaligned playlists
                    var trackDetails = levels[currentTrackId].details;
                    var targetDuration = trackDetails.targetduration;
                    var config = (this || _global).config;
                    var currentTime = this.getLoadPosition();
                    var bufferedInfo = _utils_buffer_helper__WEBPACK_IMPORTED_MODULE_1__.BufferHelper.bufferedInfo((this || _global).tracksBuffered[(this || _global).currentTrackId] || [], currentTime - targetDuration, config.maxBufferHole);
                    var targetBufferTime = bufferedInfo.end,
                      bufferLen = bufferedInfo.len;
                    var mainBufferInfo = this.getFwdBufferInfo((this || _global).media, _types_loader__WEBPACK_IMPORTED_MODULE_7__.PlaylistLevelType.MAIN);
                    var maxBufLen = this.getMaxBufferLength(mainBufferInfo === null || mainBufferInfo === void 0 ? void 0 : mainBufferInfo.len) + targetDuration;
                    if (bufferLen > maxBufLen) {
                      return;
                    }
                    console.assert(trackDetails, "Subtitle track details are defined on idle subtitle stream controller tick");
                    var fragments = trackDetails.fragments;
                    var fragLen = fragments.length;
                    var end = trackDetails.edge;
                    var foundFrag;
                    var fragPrevious = (this || _global).fragPrevious;
                    if (targetBufferTime < end) {
                      var maxFragLookUpTolerance = config.maxFragLookUpTolerance;
                      foundFrag = (0, _fragment_finders__WEBPACK_IMPORTED_MODULE_2__.findFragmentByPTS)(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), maxFragLookUpTolerance);
                      if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) {
                        foundFrag = fragments[0];
                      }
                    } else {
                      foundFrag = fragments[fragLen - 1];
                    }
                    foundFrag = this.mapToInitFragWhenRequired(foundFrag);
                    if (!foundFrag) {
                      return;
                    }

                    // only load if fragment is not loaded
                    if ((this || _global).fragmentTracker.getState(foundFrag) !== _fragment_tracker__WEBPACK_IMPORTED_MODULE_5__.FragmentState.NOT_LOADED) {
                      return;
                    }
                    if (foundFrag.encrypted) {
                      this.loadKey(foundFrag, trackDetails);
                    } else {
                      this.loadFragment(foundFrag, trackDetails, targetBufferTime);
                    }
                  }
                };
                _proto.getMaxBufferLength = function getMaxBufferLength(mainBufferLength) {
                  var maxConfigBuffer = _BaseStreamController.prototype.getMaxBufferLength.call(this || _global);
                  if (!mainBufferLength) {
                    return maxConfigBuffer;
                  }
                  return Math.max(maxConfigBuffer, mainBufferLength);
                };
                _proto.loadFragment = function loadFragment(frag, levelDetails, targetBufferTime) {
                  (this || _global).fragCurrent = frag;
                  if (frag.sn === "initSegment") {
                    this._loadInitSegment(frag);
                  } else {
                    (this || _global).startFragRequested = true;
                    _BaseStreamController.prototype.loadFragment.call(this || _global, frag, levelDetails, targetBufferTime);
                  }
                };
                _createClass(SubtitleStreamController, [{
                  key: "mediaBufferTimeRanges",
                  get: function get() {
                    return new BufferableInstance((this || _global).tracksBuffered[(this || _global).currentTrackId] || []);
                  }
                }]);
                return SubtitleStreamController;
              }(_base_stream_controller__WEBPACK_IMPORTED_MODULE_6__["default"]);
              var BufferableInstance = function BufferableInstance(timeranges) {
                (this || _global).buffered = void 0;
                var getRange = function getRange(name, index, length) {
                  index = index >>> 0;
                  if (index > length - 1) {
                    throw new DOMException("Failed to execute '" + name + "' on 'TimeRanges': The index provided (" + index + ") is greater than the maximum bound (" + length + ")");
                  }
                  return timeranges[index][name];
                };
                (this || _global).buffered = {
                  get length() {
                    return timeranges.length;
                  },
                  end: function end(index) {
                    return getRange("end", index, timeranges.length);
                  },
                  start: function start(index) {
                    return getRange("start", index, timeranges.length);
                  }
                };
              };

              /***/
            },

            /***/"./src/controller/subtitle-track-controller.ts":
            /*!*****************************************************!*\
              !*** ./src/controller/subtitle-track-controller.ts ***!
              \*****************************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/texttrack-utils */"./src/utils/texttrack-utils.ts");
              /* harmony import */
              var _base_playlist_controller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./base-playlist-controller */"./src/controller/base-playlist-controller.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              var SubtitleTrackController = /*#__PURE__*/function (_BasePlaylistControll) {
                _inheritsLoose(SubtitleTrackController, _BasePlaylistControll);
                function SubtitleTrackController(hls) {
                  var _this;
                  _this = _BasePlaylistControll.call(this || _global, hls, "[subtitle-track-controller]") || this || _global;
                  _this.media = null;
                  _this.tracks = [];
                  _this.groupId = null;
                  _this.tracksInGroup = [];
                  _this.trackId = -1;
                  _this.selectDefaultTrack = true;
                  _this.queuedDefaultTrack = -1;
                  _this.trackChangeListener = function () {
                    return _this.onTextTracksChanged();
                  };
                  _this.asyncPollTrackChange = function () {
                    return _this.pollTrackChange(0);
                  };
                  _this.useTextTrackPolling = false;
                  _this.subtitlePollingInterval = -1;
                  _this._subtitleDisplay = true;
                  _this.registerListeners();
                  return _this;
                }
                var _proto = SubtitleTrackController.prototype;
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  (this || _global).tracks.length = 0;
                  (this || _global).tracksInGroup.length = 0;
                  (this || _global).trackChangeListener = (this || _global).asyncPollTrackChange = null;
                  _BasePlaylistControll.prototype.destroy.call(this || _global);
                };
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_SWITCHING, (this || _global).onLevelSwitching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_LOADED, (this || _global).onSubtitleTrackLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_ATTACHED, (this || _global).onMediaAttached, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.MANIFEST_PARSED, (this || _global).onManifestParsed, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.LEVEL_SWITCHING, (this || _global).onLevelSwitching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_LOADED, (this || _global).onSubtitleTrackLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, (this || _global).onError, this || _global);
                }

                // Listen for subtitle track change, then extract the current track ID.
                ;

                _proto.onMediaAttached = function onMediaAttached(event, data) {
                  (this || _global).media = data.media;
                  if (!(this || _global).media) {
                    return;
                  }
                  if ((this || _global).queuedDefaultTrack > -1) {
                    (this || _global).subtitleTrack = (this || _global).queuedDefaultTrack;
                    (this || _global).queuedDefaultTrack = -1;
                  }
                  (this || _global).useTextTrackPolling = !((this || _global).media.textTracks && "onchange" in (this || _global).media.textTracks);
                  if ((this || _global).useTextTrackPolling) {
                    this.pollTrackChange(500);
                  } else {
                    (this || _global).media.textTracks.addEventListener("change", (this || _global).asyncPollTrackChange);
                  }
                };
                _proto.pollTrackChange = function pollTrackChange(timeout) {
                  self.clearInterval((this || _global).subtitlePollingInterval);
                  (this || _global).subtitlePollingInterval = self.setInterval((this || _global).trackChangeListener, timeout);
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  if (!(this || _global).media) {
                    return;
                  }
                  self.clearInterval((this || _global).subtitlePollingInterval);
                  if (!(this || _global).useTextTrackPolling) {
                    (this || _global).media.textTracks.removeEventListener("change", (this || _global).asyncPollTrackChange);
                  }
                  if ((this || _global).trackId > -1) {
                    (this || _global).queuedDefaultTrack = (this || _global).trackId;
                  }
                  var textTracks = filterSubtitleTracks((this || _global).media.textTracks);
                  // Clear loaded cues on media detachment from tracks
                  textTracks.forEach(function (track) {
                    (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_1__.clearCurrentCues)(track);
                  });
                  // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
                  (this || _global).subtitleTrack = -1;
                  (this || _global).media = null;
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).tracks = [];
                  (this || _global).groupId = null;
                  (this || _global).tracksInGroup = [];
                  (this || _global).trackId = -1;
                  (this || _global).selectDefaultTrack = true;
                }

                // Fired whenever a new manifest is loaded.
                ;

                _proto.onManifestParsed = function onManifestParsed(event, data) {
                  (this || _global).tracks = data.subtitleTracks;
                };
                _proto.onSubtitleTrackLoaded = function onSubtitleTrackLoaded(event, data) {
                  var id = data.id,
                    details = data.details;
                  var trackId = (this || _global).trackId;
                  var currentTrack = (this || _global).tracksInGroup[trackId];
                  if (!currentTrack) {
                    this.warn("Invalid subtitle track id " + id);
                    return;
                  }
                  var curDetails = currentTrack.details;
                  currentTrack.details = data.details;
                  this.log("subtitle track " + id + " loaded [" + details.startSN + "-" + details.endSN + "]");
                  if (id === (this || _global).trackId) {
                    (this || _global).retryCount = 0;
                    this.playlistLoaded(id, data, curDetails);
                  }
                };
                _proto.onLevelLoading = function onLevelLoading(event, data) {
                  this.switchLevel(data.level);
                };
                _proto.onLevelSwitching = function onLevelSwitching(event, data) {
                  this.switchLevel(data.level);
                };
                _proto.switchLevel = function switchLevel(levelIndex) {
                  var levelInfo = (this || _global).hls.levels[levelIndex];
                  if (!(levelInfo !== null && levelInfo !== void 0 && levelInfo.textGroupIds)) {
                    return;
                  }
                  var textGroupId = levelInfo.textGroupIds[levelInfo.urlId];
                  if ((this || _global).groupId !== textGroupId) {
                    var lastTrack = (this || _global).tracksInGroup ? (this || _global).tracksInGroup[(this || _global).trackId] : undefined;
                    var subtitleTracks = (this || _global).tracks.filter(function (track) {
                      return !textGroupId || track.groupId === textGroupId;
                    });
                    (this || _global).tracksInGroup = subtitleTracks;
                    var initialTrackId = this.findTrackId(lastTrack === null || lastTrack === void 0 ? void 0 : lastTrack.name) || this.findTrackId();
                    (this || _global).groupId = textGroupId;
                    var subtitleTracksUpdated = {
                      subtitleTracks: subtitleTracks
                    };
                    this.log("Updating subtitle tracks, " + subtitleTracks.length + " track(s) found in \"" + textGroupId + "\" group-id");
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
                    if (initialTrackId !== -1) {
                      this.setSubtitleTrack(initialTrackId, lastTrack);
                    }
                  }
                };
                _proto.findTrackId = function findTrackId(name) {
                  var textTracks = (this || _global).tracksInGroup;
                  for (var i = 0; i < textTracks.length; i++) {
                    var track = textTracks[i];
                    if (!(this || _global).selectDefaultTrack || track.default) {
                      if (!name || name === track.name) {
                        return track.id;
                      }
                    }
                  }
                  return -1;
                };
                _proto.onError = function onError(event, data) {
                  _BasePlaylistControll.prototype.onError.call(this || _global, event, data);
                  if (data.fatal || !data.context) {
                    return;
                  }
                  if (data.context.type === _types_loader__WEBPACK_IMPORTED_MODULE_3__.PlaylistContextType.SUBTITLE_TRACK && data.context.id === (this || _global).trackId && data.context.groupId === (this || _global).groupId) {
                    this.retryLoadingOrFail(data);
                  }
                }

                /** get alternate subtitle tracks list from playlist **/;
                _proto.loadPlaylist = function loadPlaylist(hlsUrlParameters) {
                  var currentTrack = (this || _global).tracksInGroup[(this || _global).trackId];
                  if (this.shouldLoadTrack(currentTrack)) {
                    var id = currentTrack.id;
                    var groupId = currentTrack.groupId;
                    var url = currentTrack.url;
                    if (hlsUrlParameters) {
                      try {
                        url = hlsUrlParameters.addDirectives(url);
                      } catch (error) {
                        this.warn("Could not construct new URL with HLS Delivery Directives: " + error);
                      }
                    }
                    this.log("Loading subtitle playlist for id " + id);
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_LOADING, {
                      url: url,
                      id: id,
                      groupId: groupId,
                      deliveryDirectives: hlsUrlParameters || null
                    });
                  }
                }

                /**
                 * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
                 * This operates on the DOM textTracks.
                 * A value of -1 will disable all subtitle tracks.
                 */;
                _proto.toggleTrackModes = function toggleTrackModes(newId) {
                  var _this2 = this || _global;
                  var media = (this || _global).media,
                    trackId = (this || _global).trackId;
                  if (!media) {
                    return;
                  }
                  var textTracks = filterSubtitleTracks(media.textTracks);
                  var groupTracks = textTracks.filter(function (track) {
                    return track.groupId === _this2.groupId;
                  });
                  if (newId === -1) {
                    [].slice.call(textTracks).forEach(function (track) {
                      track.mode = "disabled";
                    });
                  } else {
                    var oldTrack = groupTracks[trackId];
                    if (oldTrack) {
                      oldTrack.mode = "disabled";
                    }
                  }
                  var nextTrack = groupTracks[newId];
                  if (nextTrack) {
                    nextTrack.mode = (this || _global).subtitleDisplay ? "showing" : "hidden";
                  }
                }

                /**
                 * This method is responsible for validating the subtitle index and periodically reloading if live.
                 * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
                 */;
                _proto.setSubtitleTrack = function setSubtitleTrack(newId, lastTrack) {
                  var _tracks$newId;
                  var tracks = (this || _global).tracksInGroup;

                  // setting this.subtitleTrack will trigger internal logic
                  // if media has not been attached yet, it will fail
                  // we keep a reference to the default track id
                  // and we'll set subtitleTrack when onMediaAttached is triggered
                  if (!(this || _global).media) {
                    (this || _global).queuedDefaultTrack = newId;
                    return;
                  }
                  if ((this || _global).trackId !== newId) {
                    this.toggleTrackModes(newId);
                  }

                  // exit if track id as already set or invalid
                  if ((this || _global).trackId === newId && (newId === -1 || (_tracks$newId = tracks[newId]) !== null && _tracks$newId !== void 0 && _tracks$newId.details) || newId < -1 || newId >= tracks.length) {
                    return;
                  }

                  // stopping live reloading timer if any
                  this.clearTimer();
                  var track = tracks[newId];
                  this.log("Switching to subtitle track " + newId);
                  (this || _global).trackId = newId;
                  if (track) {
                    var id = track.id,
                      _track$groupId = track.groupId,
                      groupId = _track$groupId === void 0 ? "" : _track$groupId,
                      name = track.name,
                      type = track.type,
                      url = track.url;
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_SWITCH, {
                      id: id,
                      groupId: groupId,
                      name: name,
                      type: type,
                      url: url
                    });
                    var hlsUrlParameters = this.switchParams(track.url, lastTrack === null || lastTrack === void 0 ? void 0 : lastTrack.details);
                    this.loadPlaylist(hlsUrlParameters);
                  } else {
                    // switch to -1
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.SUBTITLE_TRACK_SWITCH, {
                      id: newId
                    });
                  }
                };
                _proto.onTextTracksChanged = function onTextTracksChanged() {
                  if (!(this || _global).useTextTrackPolling) {
                    self.clearInterval((this || _global).subtitlePollingInterval);
                  }
                  // Media is undefined when switching streams via loadSource()
                  if (!(this || _global).media || !(this || _global).hls.config.renderTextTracksNatively) {
                    return;
                  }
                  var trackId = -1;
                  var tracks = filterSubtitleTracks((this || _global).media.textTracks);
                  for (var id = 0; id < tracks.length; id++) {
                    if (tracks[id].mode === "hidden") {
                      // Do not break in case there is a following track with showing.
                      trackId = id;
                    } else if (tracks[id].mode === "showing") {
                      trackId = id;
                      break;
                    }
                  }

                  // Setting current subtitleTrack will invoke code.
                  if ((this || _global).subtitleTrack !== trackId) {
                    (this || _global).subtitleTrack = trackId;
                  }
                };
                _createClass(SubtitleTrackController, [{
                  key: "subtitleDisplay",
                  get: function get() {
                    return (this || _global)._subtitleDisplay;
                  },
                  set: function set(value) {
                    (this || _global)._subtitleDisplay = value;
                    if ((this || _global).trackId > -1) {
                      this.toggleTrackModes((this || _global).trackId);
                    }
                  }
                }, {
                  key: "subtitleTracks",
                  get: function get() {
                    return (this || _global).tracksInGroup;
                  }

                  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
                }, {
                  key: "subtitleTrack",
                  get: function get() {
                    return (this || _global).trackId;
                  },
                  set: function set(newId) {
                    (this || _global).selectDefaultTrack = false;
                    var lastTrack = (this || _global).tracksInGroup ? (this || _global).tracksInGroup[(this || _global).trackId] : undefined;
                    this.setSubtitleTrack(newId, lastTrack);
                  }
                }]);
                return SubtitleTrackController;
              }(_base_playlist_controller__WEBPACK_IMPORTED_MODULE_2__["default"]);
              function filterSubtitleTracks(textTrackList) {
                var tracks = [];
                for (var i = 0; i < textTrackList.length; i++) {
                  var track = textTrackList[i];
                  // Edge adds a track without a label; we don't want to use it
                  if (track.kind === "subtitles" && track.label) {
                    tracks.push(textTrackList[i]);
                  }
                }
                return tracks;
              }
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = SubtitleTrackController;

              /***/
            },

            /***/"./src/controller/timeline-controller.ts":
            /*!***********************************************!*\
              !*** ./src/controller/timeline-controller.ts ***!
              \***********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"TimelineController": () => /* binding */TimelineController
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_cea_608_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/cea-608-parser */"./src/utils/cea-608-parser.ts");
              /* harmony import */
              var _utils_output_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/output-filter */"./src/utils/output-filter.ts");
              /* harmony import */
              var _utils_webvtt_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/webvtt-parser */"./src/utils/webvtt-parser.ts");
              /* harmony import */
              var _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/texttrack-utils */"./src/utils/texttrack-utils.ts");
              /* harmony import */
              var _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../utils/imsc1-ttml-parser */"./src/utils/imsc1-ttml-parser.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var TimelineController = /*#__PURE__*/function () {
                function TimelineController(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).media = null;
                  (this || _global).config = void 0;
                  (this || _global).enabled = true;
                  (this || _global).Cues = void 0;
                  (this || _global).textTracks = [];
                  (this || _global).tracks = [];
                  (this || _global).initPTS = [];
                  (this || _global).timescale = [];
                  (this || _global).unparsedVttFrags = [];
                  (this || _global).captionsTracks = {};
                  (this || _global).nonNativeCaptionsTracks = {};
                  (this || _global).cea608Parser1 = void 0;
                  (this || _global).cea608Parser2 = void 0;
                  (this || _global).lastSn = -1;
                  (this || _global).lastPartIndex = -1;
                  (this || _global).prevCC = -1;
                  (this || _global).vttCCs = newVTTCCs();
                  (this || _global).captionsProperties = void 0;
                  (this || _global).hls = hls;
                  (this || _global).config = hls.config;
                  (this || _global).Cues = hls.config.cueHandler;
                  (this || _global).captionsProperties = {
                    textTrack1: {
                      label: (this || _global).config.captionsTextTrack1Label,
                      languageCode: (this || _global).config.captionsTextTrack1LanguageCode
                    },
                    textTrack2: {
                      label: (this || _global).config.captionsTextTrack2Label,
                      languageCode: (this || _global).config.captionsTextTrack2LanguageCode
                    },
                    textTrack3: {
                      label: (this || _global).config.captionsTextTrack3Label,
                      languageCode: (this || _global).config.captionsTextTrack3LanguageCode
                    },
                    textTrack4: {
                      label: (this || _global).config.captionsTextTrack4Label,
                      languageCode: (this || _global).config.captionsTextTrack4LanguageCode
                    }
                  };
                  if ((this || _global).config.enableCEA708Captions) {
                    var channel1 = new _utils_output_filter__WEBPACK_IMPORTED_MODULE_3__["default"](this || _global, "textTrack1");
                    var channel2 = new _utils_output_filter__WEBPACK_IMPORTED_MODULE_3__["default"](this || _global, "textTrack2");
                    var channel3 = new _utils_output_filter__WEBPACK_IMPORTED_MODULE_3__["default"](this || _global, "textTrack3");
                    var channel4 = new _utils_output_filter__WEBPACK_IMPORTED_MODULE_3__["default"](this || _global, "textTrack4");
                    (this || _global).cea608Parser1 = new _utils_cea_608_parser__WEBPACK_IMPORTED_MODULE_2__["default"](1, channel1, channel2);
                    (this || _global).cea608Parser2 = new _utils_cea_608_parser__WEBPACK_IMPORTED_MODULE_2__["default"](3, channel3, channel4);
                  }
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, (this || _global).onManifestLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACKS_UPDATED, (this || _global).onSubtitleTracksUpdated, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADING, (this || _global).onFragLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSING_USERDATA, (this || _global).onFragParsingUserdata, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_DECRYPTED, (this || _global).onFragDecrypted, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.INIT_PTS_FOUND, (this || _global).onInitPtsFound, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACKS_CLEARED, (this || _global).onSubtitleTracksCleared, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                }
                var _proto = TimelineController.prototype;
                _proto.destroy = function destroy() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_ATTACHING, (this || _global).onMediaAttaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MEDIA_DETACHING, (this || _global).onMediaDetaching, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, (this || _global).onManifestLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACKS_UPDATED, (this || _global).onSubtitleTracksUpdated, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADING, (this || _global).onFragLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, (this || _global).onFragLoaded, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_PARSING_USERDATA, (this || _global).onFragParsingUserdata, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_DECRYPTED, (this || _global).onFragDecrypted, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.INIT_PTS_FOUND, (this || _global).onInitPtsFound, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACKS_CLEARED, (this || _global).onSubtitleTracksCleared, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.BUFFER_FLUSHING, (this || _global).onBufferFlushing, this || _global);
                  // @ts-ignore
                  (this || _global).hls = (this || _global).config = (this || _global).cea608Parser1 = (this || _global).cea608Parser2 = null;
                };
                _proto.addCues = function addCues(trackName, startTime, endTime, screen, cueRanges) {
                  // skip cues which overlap more than 50% with previously parsed time ranges
                  var merged = false;
                  for (var i = cueRanges.length; i--;) {
                    var cueRange = cueRanges[i];
                    var overlap = intersection(cueRange[0], cueRange[1], startTime, endTime);
                    if (overlap >= 0) {
                      cueRange[0] = Math.min(cueRange[0], startTime);
                      cueRange[1] = Math.max(cueRange[1], endTime);
                      merged = true;
                      if (overlap / (endTime - startTime) > 0.5) {
                        return;
                      }
                    }
                  }
                  if (!merged) {
                    cueRanges.push([startTime, endTime]);
                  }
                  if ((this || _global).config.renderTextTracksNatively) {
                    var track = (this || _global).captionsTracks[trackName];
                    (this || _global).Cues.newCue(track, startTime, endTime, screen);
                  } else {
                    var cues = (this || _global).Cues.newCue(null, startTime, endTime, screen);
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.CUES_PARSED, {
                      type: "captions",
                      cues: cues,
                      track: trackName
                    });
                  }
                }

                // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
                ;

                _proto.onInitPtsFound = function onInitPtsFound(event, _ref) {
                  var _this = this || _global;
                  var frag = _ref.frag,
                    id = _ref.id,
                    initPTS = _ref.initPTS,
                    timescale = _ref.timescale;
                  var unparsedVttFrags = (this || _global).unparsedVttFrags;
                  if (id === "main") {
                    (this || _global).initPTS[frag.cc] = initPTS;
                    (this || _global).timescale[frag.cc] = timescale;
                  }

                  // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
                  // Parse any unparsed fragments upon receiving the initial PTS.
                  if (unparsedVttFrags.length) {
                    (this || _global).unparsedVttFrags = [];
                    unparsedVttFrags.forEach(function (frag) {
                      _this.onFragLoaded(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, frag);
                    });
                  }
                };
                _proto.getExistingTrack = function getExistingTrack(trackName) {
                  var media = (this || _global).media;
                  if (media) {
                    for (var i = 0; i < media.textTracks.length; i++) {
                      var textTrack = media.textTracks[i];
                      if (textTrack[trackName]) {
                        return textTrack;
                      }
                    }
                  }
                  return null;
                };
                _proto.createCaptionsTrack = function createCaptionsTrack(trackName) {
                  if ((this || _global).config.renderTextTracksNatively) {
                    this.createNativeTrack(trackName);
                  } else {
                    this.createNonNativeTrack(trackName);
                  }
                };
                _proto.createNativeTrack = function createNativeTrack(trackName) {
                  if ((this || _global).captionsTracks[trackName]) {
                    return;
                  }
                  var captionsProperties = (this || _global).captionsProperties,
                    captionsTracks = (this || _global).captionsTracks,
                    media = (this || _global).media;
                  var _captionsProperties$t = captionsProperties[trackName],
                    label = _captionsProperties$t.label,
                    languageCode = _captionsProperties$t.languageCode;
                  // Enable reuse of existing text track.
                  var existingTrack = this.getExistingTrack(trackName);
                  if (!existingTrack) {
                    var textTrack = this.createTextTrack("captions", label, languageCode);
                    if (textTrack) {
                      // Set a special property on the track so we know it's managed by Hls.js
                      textTrack[trackName] = true;
                      captionsTracks[trackName] = textTrack;
                    }
                  } else {
                    captionsTracks[trackName] = existingTrack;
                    (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.clearCurrentCues)(captionsTracks[trackName]);
                    (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.sendAddTrackEvent)(captionsTracks[trackName], media);
                  }
                };
                _proto.createNonNativeTrack = function createNonNativeTrack(trackName) {
                  if ((this || _global).nonNativeCaptionsTracks[trackName]) {
                    return;
                  }
                  // Create a list of a single track for the provider to consume
                  var trackProperties = (this || _global).captionsProperties[trackName];
                  if (!trackProperties) {
                    return;
                  }
                  var label = trackProperties.label;
                  var track = {
                    _id: trackName,
                    label: label,
                    kind: "captions",
                    default: trackProperties.media ? !!trackProperties.media.default : false,
                    closedCaptions: trackProperties.media
                  };
                  (this || _global).nonNativeCaptionsTracks[trackName] = track;
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                    tracks: [track]
                  });
                };
                _proto.createTextTrack = function createTextTrack(kind, label, lang) {
                  var media = (this || _global).media;
                  if (!media) {
                    return;
                  }
                  return media.addTextTrack(kind, label, lang);
                };
                _proto.onMediaAttaching = function onMediaAttaching(event, data) {
                  (this || _global).media = data.media;
                  this._cleanTracks();
                };
                _proto.onMediaDetaching = function onMediaDetaching() {
                  var captionsTracks = (this || _global).captionsTracks;
                  Object.keys(captionsTracks).forEach(function (trackName) {
                    (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.clearCurrentCues)(captionsTracks[trackName]);
                    delete captionsTracks[trackName];
                  });
                  (this || _global).nonNativeCaptionsTracks = {};
                };
                _proto.onManifestLoading = function onManifestLoading() {
                  (this || _global).lastSn = -1; // Detect discontinuity in fragment parsing
                  (this || _global).lastPartIndex = -1;
                  (this || _global).prevCC = -1;
                  (this || _global).vttCCs = newVTTCCs(); // Detect discontinuity in subtitle manifests
                  this._cleanTracks();
                  (this || _global).tracks = [];
                  (this || _global).captionsTracks = {};
                  (this || _global).nonNativeCaptionsTracks = {};
                  (this || _global).textTracks = [];
                  (this || _global).unparsedVttFrags = (this || _global).unparsedVttFrags || [];
                  (this || _global).initPTS = [];
                  (this || _global).timescale = [];
                  if ((this || _global).cea608Parser1 && (this || _global).cea608Parser2) {
                    (this || _global).cea608Parser1.reset();
                    (this || _global).cea608Parser2.reset();
                  }
                };
                _proto._cleanTracks = function _cleanTracks() {
                  // clear outdated subtitles
                  var media = (this || _global).media;
                  if (!media) {
                    return;
                  }
                  var textTracks = media.textTracks;
                  if (textTracks) {
                    for (var i = 0; i < textTracks.length; i++) {
                      (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.clearCurrentCues)(textTracks[i]);
                    }
                  }
                };
                _proto.onSubtitleTracksUpdated = function onSubtitleTracksUpdated(event, data) {
                  var _this2 = this || _global;
                  (this || _global).textTracks = [];
                  var tracks = data.subtitleTracks || [];
                  var hasIMSC1 = tracks.some(function (track) {
                    return track.textCodec === _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__.IMSC1_CODEC;
                  });
                  if ((this || _global).config.enableWebVTT || hasIMSC1 && (this || _global).config.enableIMSC1) {
                    var sameTracks = (this || _global).tracks && tracks && (this || _global).tracks.length === tracks.length;
                    (this || _global).tracks = tracks || [];
                    if ((this || _global).config.renderTextTracksNatively) {
                      var inUseTracks = (this || _global).media ? (this || _global).media.textTracks : [];
                      (this || _global).tracks.forEach(function (track, index) {
                        var textTrack;
                        if (index < inUseTracks.length) {
                          var inUseTrack = null;
                          for (var i = 0; i < inUseTracks.length; i++) {
                            if (canReuseVttTextTrack(inUseTracks[i], track)) {
                              inUseTrack = inUseTracks[i];
                              break;
                            }
                          }

                          // Reuse tracks with the same label, but do not reuse 608/708 tracks
                          if (inUseTrack) {
                            textTrack = inUseTrack;
                          }
                        }
                        if (textTrack) {
                          (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.clearCurrentCues)(textTrack);
                        } else {
                          var textTrackKind = _this2._captionsOrSubtitlesFromCharacteristics(track);
                          textTrack = _this2.createTextTrack(textTrackKind, track.name, track.lang);
                          if (textTrack) {
                            textTrack.mode = "disabled";
                          }
                        }
                        if (textTrack) {
                          textTrack.groupId = track.groupId;
                          _this2.textTracks.push(textTrack);
                        }
                      });
                    } else if (!sameTracks && (this || _global).tracks && (this || _global).tracks.length) {
                      // Create a list of tracks for the provider to consume
                      var tracksList = (this || _global).tracks.map(function (track) {
                        return {
                          label: track.name,
                          kind: track.type.toLowerCase(),
                          default: track.default,
                          subtitleTrack: track
                        };
                      });
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.NON_NATIVE_TEXT_TRACKS_FOUND, {
                        tracks: tracksList
                      });
                    }
                  }
                };
                _proto._captionsOrSubtitlesFromCharacteristics = function _captionsOrSubtitlesFromCharacteristics(track) {
                  var _track$attrs;
                  if ((_track$attrs = track.attrs) !== null && _track$attrs !== void 0 && _track$attrs.CHARACTERISTICS) {
                    var transcribesSpokenDialog = /transcribes-spoken-dialog/gi.test(track.attrs.CHARACTERISTICS);
                    var describesMusicAndSound = /describes-music-and-sound/gi.test(track.attrs.CHARACTERISTICS);
                    if (transcribesSpokenDialog && describesMusicAndSound) {
                      return "captions";
                    }
                  }
                  return "subtitles";
                };
                _proto.onManifestLoaded = function onManifestLoaded(event, data) {
                  var _this3 = this || _global;
                  if ((this || _global).config.enableCEA708Captions && data.captions) {
                    data.captions.forEach(function (captionsTrack) {
                      var instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
                      if (!instreamIdMatch) {
                        return;
                      }
                      var trackName = "textTrack" + instreamIdMatch[1];
                      var trackProperties = _this3.captionsProperties[trackName];
                      if (!trackProperties) {
                        return;
                      }
                      trackProperties.label = captionsTrack.name;
                      if (captionsTrack.lang) {
                        // optional attribute
                        trackProperties.languageCode = captionsTrack.lang;
                      }
                      trackProperties.media = captionsTrack;
                    });
                  }
                };
                _proto.closedCaptionsForLevel = function closedCaptionsForLevel(frag) {
                  var level = (this || _global).hls.levels[frag.level];
                  return level === null || level === void 0 ? void 0 : level.attrs["CLOSED-CAPTIONS"];
                };
                _proto.onFragLoading = function onFragLoading(event, data) {
                  var cea608Parser1 = (this || _global).cea608Parser1,
                    cea608Parser2 = (this || _global).cea608Parser2,
                    lastSn = (this || _global).lastSn,
                    lastPartIndex = (this || _global).lastPartIndex;
                  if (!(this || _global).enabled || !(cea608Parser1 && cea608Parser2)) {
                    return;
                  }
                  // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
                  if (data.frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_8__.PlaylistLevelType.MAIN) {
                    var _data$part$index, _data$part;
                    var sn = data.frag.sn;
                    var partIndex = (_data$part$index = data === null || data === void 0 ? void 0 : (_data$part = data.part) === null || _data$part === void 0 ? void 0 : _data$part.index) != null ? _data$part$index : -1;
                    if (!(sn === lastSn + 1 || sn === lastSn && partIndex === lastPartIndex + 1)) {
                      cea608Parser1.reset();
                      cea608Parser2.reset();
                    }
                    (this || _global).lastSn = sn;
                    (this || _global).lastPartIndex = partIndex;
                  }
                };
                _proto.onFragLoaded = function onFragLoaded(event, data) {
                  var frag = data.frag,
                    payload = data.payload;
                  var initPTS = (this || _global).initPTS,
                    unparsedVttFrags = (this || _global).unparsedVttFrags;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_8__.PlaylistLevelType.SUBTITLE) {
                    // If fragment is subtitle type, parse as WebVTT.
                    if (payload.byteLength) {
                      // We need an initial synchronisation PTS. Store fragments as long as none has arrived.
                      if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(initPTS[frag.cc])) {
                        unparsedVttFrags.push(data);
                        if (initPTS.length) {
                          // finish unsuccessfully, otherwise the subtitle-stream-controller could be blocked from loading new frags.
                          (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                            success: false,
                            frag: frag,
                            error: new Error("Missing initial subtitle PTS")
                          });
                        }
                        return;
                      }
                      var decryptData = frag.decryptdata;
                      // fragment after decryption has a stats object
                      var decrypted = ("stats" in data);
                      // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                      if (decryptData == null || decryptData.key == null || decryptData.method !== "AES-128" || decrypted) {
                        var trackPlaylistMedia = (this || _global).tracks[frag.level];
                        var vttCCs = (this || _global).vttCCs;
                        if (!vttCCs[frag.cc]) {
                          vttCCs[frag.cc] = {
                            start: frag.start,
                            prevCC: (this || _global).prevCC,
                            new: true
                          };
                          (this || _global).prevCC = frag.cc;
                        }
                        if (trackPlaylistMedia && trackPlaylistMedia.textCodec === _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__.IMSC1_CODEC) {
                          this._parseIMSC1(frag, payload);
                        } else {
                          this._parseVTTs(frag, payload, vttCCs);
                        }
                      }
                    } else {
                      // In case there is no payload, finish unsuccessfully.
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                        success: false,
                        frag: frag,
                        error: new Error("Empty subtitle payload")
                      });
                    }
                  }
                };
                _proto._parseIMSC1 = function _parseIMSC1(frag, payload) {
                  var _this4 = this || _global;
                  var hls = (this || _global).hls;
                  (0, _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__.parseIMSC1)(payload, (this || _global).initPTS[frag.cc], (this || _global).timescale[frag.cc], function (cues) {
                    _this4._appendCues(cues, frag.level);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: true,
                      frag: frag
                    });
                  }, function (error) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("Failed to parse IMSC1: " + error);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: false,
                      frag: frag,
                      error: error
                    });
                  });
                };
                _proto._parseVTTs = function _parseVTTs(frag, payload, vttCCs) {
                  var _frag$initSegment,
                    _this5 = this || _global;
                  var hls = (this || _global).hls;
                  // Parse the WebVTT file contents.
                  var payloadWebVTT = (_frag$initSegment = frag.initSegment) !== null && _frag$initSegment !== void 0 && _frag$initSegment.data ? (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_7__.appendUint8Array)(frag.initSegment.data, new Uint8Array(payload)) : payload;
                  (0, _utils_webvtt_parser__WEBPACK_IMPORTED_MODULE_4__.parseWebVTT)(payloadWebVTT, (this || _global).initPTS[frag.cc], (this || _global).timescale[frag.cc], vttCCs, frag.cc, frag.start, function (cues) {
                    _this5._appendCues(cues, frag.level);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: true,
                      frag: frag
                    });
                  }, function (error) {
                    _this5._fallbackToIMSC1(frag, payload);
                    // Something went wrong while parsing. Trigger event with success false.
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("Failed to parse VTT cue: " + error);
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_FRAG_PROCESSED, {
                      success: false,
                      frag: frag,
                      error: error
                    });
                  });
                };
                _proto._fallbackToIMSC1 = function _fallbackToIMSC1(frag, payload) {
                  var _this6 = this || _global;
                  // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
                  var trackPlaylistMedia = (this || _global).tracks[frag.level];
                  if (!trackPlaylistMedia.textCodec) {
                    (0, _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__.parseIMSC1)(payload, (this || _global).initPTS[frag.cc], (this || _global).timescale[frag.cc], function () {
                      trackPlaylistMedia.textCodec = _utils_imsc1_ttml_parser__WEBPACK_IMPORTED_MODULE_6__.IMSC1_CODEC;
                      _this6._parseIMSC1(frag, payload);
                    }, function () {
                      trackPlaylistMedia.textCodec = "wvtt";
                    });
                  }
                };
                _proto._appendCues = function _appendCues(cues, fragLevel) {
                  var hls = (this || _global).hls;
                  if ((this || _global).config.renderTextTracksNatively) {
                    var textTrack = (this || _global).textTracks[fragLevel];
                    // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
                    // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
                    // and trying to access getCueById method of cues will throw an exception
                    // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
                    if (!textTrack || textTrack.mode === "disabled") {
                      return;
                    }
                    cues.forEach(function (cue) {
                      return (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.addCueToTrack)(textTrack, cue);
                    });
                  } else {
                    var currentTrack = (this || _global).tracks[fragLevel];
                    if (!currentTrack) {
                      return;
                    }
                    var track = currentTrack.default ? "default" : "subtitles" + fragLevel;
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.CUES_PARSED, {
                      type: "subtitles",
                      cues: cues,
                      track: track
                    });
                  }
                };
                _proto.onFragDecrypted = function onFragDecrypted(event, data) {
                  var frag = data.frag;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_8__.PlaylistLevelType.SUBTITLE) {
                    if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).initPTS[frag.cc])) {
                      (this || _global).unparsedVttFrags.push(data);
                      return;
                    }
                    this.onFragLoaded(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_LOADED, data);
                  }
                };
                _proto.onSubtitleTracksCleared = function onSubtitleTracksCleared() {
                  (this || _global).tracks = [];
                  (this || _global).captionsTracks = {};
                };
                _proto.onFragParsingUserdata = function onFragParsingUserdata(event, data) {
                  var cea608Parser1 = (this || _global).cea608Parser1,
                    cea608Parser2 = (this || _global).cea608Parser2;
                  if (!(this || _global).enabled || !(cea608Parser1 && cea608Parser2)) {
                    return;
                  }
                  var frag = data.frag,
                    samples = data.samples;
                  if (frag.type === _types_loader__WEBPACK_IMPORTED_MODULE_8__.PlaylistLevelType.MAIN && this.closedCaptionsForLevel(frag) === "NONE") {
                    return;
                  }
                  // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
                  // It will create the proper timestamps based on the PTS value
                  for (var i = 0; i < samples.length; i++) {
                    var ccBytes = samples[i].bytes;
                    if (ccBytes) {
                      var ccdatas = this.extractCea608Data(ccBytes);
                      cea608Parser1.addData(samples[i].pts, ccdatas[0]);
                      cea608Parser2.addData(samples[i].pts, ccdatas[1]);
                    }
                  }
                };
                _proto.onBufferFlushing = function onBufferFlushing(event, _ref2) {
                  var startOffset = _ref2.startOffset,
                    endOffset = _ref2.endOffset,
                    endOffsetSubtitles = _ref2.endOffsetSubtitles,
                    type = _ref2.type;
                  var media = (this || _global).media;
                  if (!media || media.currentTime < endOffset) {
                    return;
                  }
                  // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
                  // Forward cues are never removed because we can loose streamed 608 content from recent fragments
                  if (!type || type === "video") {
                    var captionsTracks = (this || _global).captionsTracks;
                    Object.keys(captionsTracks).forEach(function (trackName) {
                      return (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.removeCuesInRange)(captionsTracks[trackName], startOffset, endOffset);
                    });
                  }
                  if ((this || _global).config.renderTextTracksNatively) {
                    // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
                    if (startOffset === 0 && endOffsetSubtitles !== undefined) {
                      var textTracks = (this || _global).textTracks;
                      Object.keys(textTracks).forEach(function (trackName) {
                        return (0, _utils_texttrack_utils__WEBPACK_IMPORTED_MODULE_5__.removeCuesInRange)(textTracks[trackName], startOffset, endOffsetSubtitles);
                      });
                    }
                  }
                };
                _proto.extractCea608Data = function extractCea608Data(byteArray) {
                  var actualCCBytes = [[], []];
                  var count = byteArray[0] & 31;
                  var position = 2;
                  for (var j = 0; j < count; j++) {
                    var tmpByte = byteArray[position++];
                    var ccbyte1 = 127 & byteArray[position++];
                    var ccbyte2 = 127 & byteArray[position++];
                    if (ccbyte1 === 0 && ccbyte2 === 0) {
                      continue;
                    }
                    var ccValid = (4 & tmpByte) !== 0; // Support all four channels
                    if (ccValid) {
                      var ccType = 3 & tmpByte;
                      if (0 /* CEA608 field1*/ === ccType || 1 /* CEA608 field2*/ === ccType) {
                        // Exclude CEA708 CC data.
                        actualCCBytes[ccType].push(ccbyte1);
                        actualCCBytes[ccType].push(ccbyte2);
                      }
                    }
                  }
                  return actualCCBytes;
                };
                return TimelineController;
              }();
              function canReuseVttTextTrack(inUseTrack, manifestTrack) {
                return inUseTrack && inUseTrack.label === manifestTrack.name && !(inUseTrack.textTrack1 || inUseTrack.textTrack2);
              }
              function intersection(x1, x2, y1, y2) {
                return Math.min(x2, y2) - Math.max(x1, y1);
              }
              function newVTTCCs() {
                return {
                  ccOffset: 0,
                  presentationOffset: 0,
                  0: {
                    start: 0,
                    prevCC: -1,
                    new: true
                  }
                };
              }

              /***/
            },

            /***/"./src/crypt/aes-crypto.ts":
            /*!*********************************!*\
              !*** ./src/crypt/aes-crypto.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */AESCrypto
                /* harmony export */
              });
              var AESCrypto = /*#__PURE__*/function () {
                function AESCrypto(subtle, iv) {
                  (this || _global).subtle = void 0;
                  (this || _global).aesIV = void 0;
                  (this || _global).subtle = subtle;
                  (this || _global).aesIV = iv;
                }
                var _proto = AESCrypto.prototype;
                _proto.decrypt = function decrypt(data, key) {
                  return (this || _global).subtle.decrypt({
                    name: "AES-CBC",
                    iv: (this || _global).aesIV
                  }, key, data);
                };
                return AESCrypto;
              }();

              /***/
            },

            /***/"./src/crypt/aes-decryptor.ts":
            /*!************************************!*\
              !*** ./src/crypt/aes-decryptor.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */AESDecryptor,
                /* harmony export */"removePadding": () => /* binding */removePadding
                /* harmony export */
              });
              /* harmony import */
              var _utils_typed_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/typed-array */"./src/utils/typed-array.ts");

              // PKCS7
              function removePadding(array) {
                var outputBytes = array.byteLength;
                var paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
                if (paddingBytes) {
                  return (0, _utils_typed_array__WEBPACK_IMPORTED_MODULE_0__.sliceUint8)(array, 0, outputBytes - paddingBytes);
                }
                return array;
              }
              var AESDecryptor = /*#__PURE__*/function () {
                function AESDecryptor() {
                  (this || _global).rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
                  (this || _global).subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
                  (this || _global).invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)];
                  (this || _global).sBox = new Uint32Array(256);
                  (this || _global).invSBox = new Uint32Array(256);
                  (this || _global).key = new Uint32Array(0);
                  (this || _global).ksRows = 0;
                  (this || _global).keySize = 0;
                  (this || _global).keySchedule = void 0;
                  (this || _global).invKeySchedule = void 0;
                  this.initTable();
                }

                // Using view.getUint32() also swaps the byte order.
                var _proto = AESDecryptor.prototype;
                _proto.uint8ArrayToUint32Array_ = function uint8ArrayToUint32Array_(arrayBuffer) {
                  var view = new DataView(arrayBuffer);
                  var newArray = new Uint32Array(4);
                  for (var i = 0; i < 4; i++) {
                    newArray[i] = view.getUint32(i * 4);
                  }
                  return newArray;
                };
                _proto.initTable = function initTable() {
                  var sBox = (this || _global).sBox;
                  var invSBox = (this || _global).invSBox;
                  var subMix = (this || _global).subMix;
                  var subMix0 = subMix[0];
                  var subMix1 = subMix[1];
                  var subMix2 = subMix[2];
                  var subMix3 = subMix[3];
                  var invSubMix = (this || _global).invSubMix;
                  var invSubMix0 = invSubMix[0];
                  var invSubMix1 = invSubMix[1];
                  var invSubMix2 = invSubMix[2];
                  var invSubMix3 = invSubMix[3];
                  var d = new Uint32Array(256);
                  var x = 0;
                  var xi = 0;
                  var i = 0;
                  for (i = 0; i < 256; i++) {
                    if (i < 128) {
                      d[i] = i << 1;
                    } else {
                      d[i] = i << 1 ^ 283;
                    }
                  }
                  for (i = 0; i < 256; i++) {
                    var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                    sx = sx >>> 8 ^ sx & 255 ^ 99;
                    sBox[x] = sx;
                    invSBox[sx] = x;

                    // Compute multiplication
                    var x2 = d[x];
                    var x4 = d[x2];
                    var x8 = d[x4];

                    // Compute sub/invSub bytes, mix columns tables
                    var t = d[sx] * 257 ^ sx * 16843008;
                    subMix0[x] = t << 24 | t >>> 8;
                    subMix1[x] = t << 16 | t >>> 16;
                    subMix2[x] = t << 8 | t >>> 24;
                    subMix3[x] = t;

                    // Compute inv sub bytes, inv mix columns tables
                    t = x8 * 16843009 ^ x4 * 65537 ^ x2 * 257 ^ x * 16843008;
                    invSubMix0[sx] = t << 24 | t >>> 8;
                    invSubMix1[sx] = t << 16 | t >>> 16;
                    invSubMix2[sx] = t << 8 | t >>> 24;
                    invSubMix3[sx] = t;

                    // Compute next counter
                    if (!x) {
                      x = xi = 1;
                    } else {
                      x = x2 ^ d[d[d[x8 ^ x2]]];
                      xi ^= d[d[xi]];
                    }
                  }
                };
                _proto.expandKey = function expandKey(keyBuffer) {
                  // convert keyBuffer to Uint32Array
                  var key = this.uint8ArrayToUint32Array_(keyBuffer);
                  var sameKey = true;
                  var offset = 0;
                  while (offset < key.length && sameKey) {
                    sameKey = key[offset] === (this || _global).key[offset];
                    offset++;
                  }
                  if (sameKey) {
                    return;
                  }
                  (this || _global).key = key;
                  var keySize = (this || _global).keySize = key.length;
                  if (keySize !== 4 && keySize !== 6 && keySize !== 8) {
                    throw new Error("Invalid aes key size=" + keySize);
                  }
                  var ksRows = (this || _global).ksRows = (keySize + 6 + 1) * 4;
                  var ksRow;
                  var invKsRow;
                  var keySchedule = (this || _global).keySchedule = new Uint32Array(ksRows);
                  var invKeySchedule = (this || _global).invKeySchedule = new Uint32Array(ksRows);
                  var sbox = (this || _global).sBox;
                  var rcon = (this || _global).rcon;
                  var invSubMix = (this || _global).invSubMix;
                  var invSubMix0 = invSubMix[0];
                  var invSubMix1 = invSubMix[1];
                  var invSubMix2 = invSubMix[2];
                  var invSubMix3 = invSubMix[3];
                  var prev;
                  var t;
                  for (ksRow = 0; ksRow < ksRows; ksRow++) {
                    if (ksRow < keySize) {
                      prev = keySchedule[ksRow] = key[ksRow];
                      continue;
                    }
                    t = prev;
                    if (ksRow % keySize === 0) {
                      // Rot word
                      t = t << 8 | t >>> 24;

                      // Sub word
                      t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 255] << 16 | sbox[t >>> 8 & 255] << 8 | sbox[t & 255];

                      // Mix Rcon
                      t ^= rcon[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize === 4) {
                      // Sub word
                      t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 255] << 16 | sbox[t >>> 8 & 255] << 8 | sbox[t & 255];
                    }
                    keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
                  }
                  for (invKsRow = 0; invKsRow < ksRows; invKsRow++) {
                    ksRow = ksRows - invKsRow;
                    if (invKsRow & 3) {
                      t = keySchedule[ksRow];
                    } else {
                      t = keySchedule[ksRow - 4];
                    }
                    if (invKsRow < 4 || ksRow <= 4) {
                      invKeySchedule[invKsRow] = t;
                    } else {
                      invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 255]] ^ invSubMix2[sbox[t >>> 8 & 255]] ^ invSubMix3[sbox[t & 255]];
                    }
                    invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
                  }
                }

                // Adding this as a method greatly improves performance.
                ;

                _proto.networkToHostOrderSwap = function networkToHostOrderSwap(word) {
                  return word << 24 | (word & 65280) << 8 | (word & 16711680) >> 8 | word >>> 24;
                };
                _proto.decrypt = function decrypt(inputArrayBuffer, offset, aesIV) {
                  var nRounds = (this || _global).keySize + 6;
                  var invKeySchedule = (this || _global).invKeySchedule;
                  var invSBOX = (this || _global).invSBox;
                  var invSubMix = (this || _global).invSubMix;
                  var invSubMix0 = invSubMix[0];
                  var invSubMix1 = invSubMix[1];
                  var invSubMix2 = invSubMix[2];
                  var invSubMix3 = invSubMix[3];
                  var initVector = this.uint8ArrayToUint32Array_(aesIV);
                  var initVector0 = initVector[0];
                  var initVector1 = initVector[1];
                  var initVector2 = initVector[2];
                  var initVector3 = initVector[3];
                  var inputInt32 = new Int32Array(inputArrayBuffer);
                  var outputInt32 = new Int32Array(inputInt32.length);
                  var t0, t1, t2, t3;
                  var s0, s1, s2, s3;
                  var inputWords0, inputWords1, inputWords2, inputWords3;
                  var ksRow, i;
                  var swapWord = (this || _global).networkToHostOrderSwap;
                  while (offset < inputInt32.length) {
                    inputWords0 = swapWord(inputInt32[offset]);
                    inputWords1 = swapWord(inputInt32[offset + 1]);
                    inputWords2 = swapWord(inputInt32[offset + 2]);
                    inputWords3 = swapWord(inputInt32[offset + 3]);
                    s0 = inputWords0 ^ invKeySchedule[0];
                    s1 = inputWords3 ^ invKeySchedule[1];
                    s2 = inputWords2 ^ invKeySchedule[2];
                    s3 = inputWords1 ^ invKeySchedule[3];
                    ksRow = 4;

                    // Iterate through the rounds of decryption
                    for (i = 1; i < nRounds; i++) {
                      t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 255] ^ invSubMix2[s2 >> 8 & 255] ^ invSubMix3[s3 & 255] ^ invKeySchedule[ksRow];
                      t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 255] ^ invSubMix2[s3 >> 8 & 255] ^ invSubMix3[s0 & 255] ^ invKeySchedule[ksRow + 1];
                      t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 255] ^ invSubMix2[s0 >> 8 & 255] ^ invSubMix3[s1 & 255] ^ invKeySchedule[ksRow + 2];
                      t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 255] ^ invSubMix2[s1 >> 8 & 255] ^ invSubMix3[s2 & 255] ^ invKeySchedule[ksRow + 3];
                      // Update state
                      s0 = t0;
                      s1 = t1;
                      s2 = t2;
                      s3 = t3;
                      ksRow = ksRow + 4;
                    }

                    // Shift rows, sub bytes, add round key
                    t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 255] << 16 ^ invSBOX[s2 >> 8 & 255] << 8 ^ invSBOX[s3 & 255] ^ invKeySchedule[ksRow];
                    t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 255] << 16 ^ invSBOX[s3 >> 8 & 255] << 8 ^ invSBOX[s0 & 255] ^ invKeySchedule[ksRow + 1];
                    t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 255] << 16 ^ invSBOX[s0 >> 8 & 255] << 8 ^ invSBOX[s1 & 255] ^ invKeySchedule[ksRow + 2];
                    t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 255] << 16 ^ invSBOX[s1 >> 8 & 255] << 8 ^ invSBOX[s2 & 255] ^ invKeySchedule[ksRow + 3];

                    // Write
                    outputInt32[offset] = swapWord(t0 ^ initVector0);
                    outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
                    outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
                    outputInt32[offset + 3] = swapWord(t1 ^ initVector3);

                    // reset initVector to last 4 unsigned int
                    initVector0 = inputWords0;
                    initVector1 = inputWords1;
                    initVector2 = inputWords2;
                    initVector3 = inputWords3;
                    offset = offset + 4;
                  }
                  return outputInt32.buffer;
                };
                return AESDecryptor;
              }();

              /***/
            },

            /***/"./src/crypt/decrypter.ts":
            /*!********************************!*\
              !*** ./src/crypt/decrypter.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */Decrypter
                /* harmony export */
              });
              /* harmony import */
              var _aes_crypto__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./aes-crypto */"./src/crypt/aes-crypto.ts");
              /* harmony import */
              var _fast_aes_key__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./fast-aes-key */"./src/crypt/fast-aes-key.ts");
              /* harmony import */
              var _aes_decryptor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./aes-decryptor */"./src/crypt/aes-decryptor.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/typed-array */"./src/utils/typed-array.ts");
              var CHUNK_SIZE = 16; // 16 bytes, 128 bits
              var Decrypter = /*#__PURE__*/function () {
                function Decrypter(observer, config, _temp) {
                  var _ref = _temp === void 0 ? {} : _temp,
                    _ref$removePKCS7Paddi = _ref.removePKCS7Padding,
                    removePKCS7Padding = _ref$removePKCS7Paddi === void 0 ? true : _ref$removePKCS7Paddi;
                  (this || _global).logEnabled = true;
                  (this || _global).observer = void 0;
                  (this || _global).config = void 0;
                  (this || _global).removePKCS7Padding = void 0;
                  (this || _global).subtle = null;
                  (this || _global).softwareDecrypter = null;
                  (this || _global).key = null;
                  (this || _global).fastAesKey = null;
                  (this || _global).remainderData = null;
                  (this || _global).currentIV = null;
                  (this || _global).currentResult = null;
                  (this || _global).observer = observer;
                  (this || _global).config = config;
                  (this || _global).removePKCS7Padding = removePKCS7Padding;
                  // built in decryptor expects PKCS7 padding
                  if (removePKCS7Padding) {
                    try {
                      var browserCrypto = self.crypto;
                      if (browserCrypto) {
                        (this || _global).subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
                      }
                    } catch (e) {
                      /* no-op */
                    }
                  }
                  if ((this || _global).subtle === null) {
                    (this || _global).config.enableSoftwareAES = true;
                  }
                }
                var _proto = Decrypter.prototype;
                _proto.destroy = function destroy() {
                  // @ts-ignore
                  (this || _global).observer = null;
                };
                _proto.isSync = function isSync() {
                  return (this || _global).config.enableSoftwareAES;
                };
                _proto.flush = function flush() {
                  var currentResult = (this || _global).currentResult;
                  if (!currentResult) {
                    this.reset();
                    return;
                  }
                  var data = new Uint8Array(currentResult);
                  this.reset();
                  if ((this || _global).removePKCS7Padding) {
                    return (0, _aes_decryptor__WEBPACK_IMPORTED_MODULE_2__.removePadding)(data);
                  }
                  return data;
                };
                _proto.reset = function reset() {
                  (this || _global).currentResult = null;
                  (this || _global).currentIV = null;
                  (this || _global).remainderData = null;
                  if ((this || _global).softwareDecrypter) {
                    (this || _global).softwareDecrypter = null;
                  }
                };
                _proto.decrypt = function decrypt(data, key, iv, callback) {
                  if ((this || _global).config.enableSoftwareAES) {
                    this.softwareDecrypt(new Uint8Array(data), key, iv);
                    var decryptResult = this.flush();
                    if (decryptResult) {
                      callback(decryptResult.buffer);
                    }
                  } else {
                    this.webCryptoDecrypt(new Uint8Array(data), key, iv).then(callback);
                  }
                };
                _proto.softwareDecrypt = function softwareDecrypt(data, key, iv) {
                  var currentIV = (this || _global).currentIV,
                    currentResult = (this || _global).currentResult,
                    remainderData = (this || _global).remainderData;
                  this.logOnce("JS AES decrypt");
                  // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
                  // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
                  // the end on flush(), but by that time we have already received all bytes for the segment.
                  // Progressive decryption does not work with WebCrypto

                  if (remainderData) {
                    data = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.appendUint8Array)(remainderData, data);
                    (this || _global).remainderData = null;
                  }

                  // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
                  var currentChunk = this.getValidChunk(data);
                  if (!currentChunk.length) {
                    return null;
                  }
                  if (currentIV) {
                    iv = currentIV;
                  }
                  var softwareDecrypter = (this || _global).softwareDecrypter;
                  if (!softwareDecrypter) {
                    softwareDecrypter = (this || _global).softwareDecrypter = new _aes_decryptor__WEBPACK_IMPORTED_MODULE_2__["default"]();
                  }
                  softwareDecrypter.expandKey(key);
                  var result = currentResult;
                  (this || _global).currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
                  (this || _global).currentIV = (0, _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__.sliceUint8)(currentChunk, -16).buffer;
                  if (!result) {
                    return null;
                  }
                  return result;
                };
                _proto.webCryptoDecrypt = function webCryptoDecrypt(data, key, iv) {
                  var _this = this || _global;
                  var subtle = (this || _global).subtle;
                  if ((this || _global).key !== key || !(this || _global).fastAesKey) {
                    (this || _global).key = key;
                    (this || _global).fastAesKey = new _fast_aes_key__WEBPACK_IMPORTED_MODULE_1__["default"](subtle, key);
                  }
                  return (this || _global).fastAesKey.expandKey().then(function (aesKey) {
                    // decrypt using web crypto
                    if (!subtle) {
                      return Promise.reject(new Error("web crypto not initialized"));
                    }
                    var crypto = new _aes_crypto__WEBPACK_IMPORTED_MODULE_0__["default"](subtle, iv);
                    return crypto.decrypt(data.buffer, aesKey);
                  }).catch(function (err) {
                    return _this.onWebCryptoError(err, data, key, iv);
                  });
                };
                _proto.onWebCryptoError = function onWebCryptoError(err, data, key, iv) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("[decrypter.ts]: WebCrypto Error, disable WebCrypto API:", err);
                  (this || _global).config.enableSoftwareAES = true;
                  (this || _global).logEnabled = true;
                  return this.softwareDecrypt(data, key, iv);
                };
                _proto.getValidChunk = function getValidChunk(data) {
                  var currentChunk = data;
                  var splitPoint = data.length - data.length % CHUNK_SIZE;
                  if (splitPoint !== data.length) {
                    currentChunk = (0, _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__.sliceUint8)(data, 0, splitPoint);
                    (this || _global).remainderData = (0, _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__.sliceUint8)(data, splitPoint);
                  }
                  return currentChunk;
                };
                _proto.logOnce = function logOnce(msg) {
                  if (!(this || _global).logEnabled) {
                    return;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log("[decrypter.ts]: " + msg);
                  (this || _global).logEnabled = false;
                };
                return Decrypter;
              }();

              /***/
            },

            /***/"./src/crypt/fast-aes-key.ts":
            /*!***********************************!*\
              !*** ./src/crypt/fast-aes-key.ts ***!
              \***********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */FastAESKey
                /* harmony export */
              });
              var FastAESKey = /*#__PURE__*/function () {
                function FastAESKey(subtle, key) {
                  (this || _global).subtle = void 0;
                  (this || _global).key = void 0;
                  (this || _global).subtle = subtle;
                  (this || _global).key = key;
                }
                var _proto = FastAESKey.prototype;
                _proto.expandKey = function expandKey() {
                  return (this || _global).subtle.importKey("raw", (this || _global).key, {
                    name: "AES-CBC"
                  }, false, ["encrypt", "decrypt"]);
                };
                return FastAESKey;
              }();

              /***/
            },

            /***/"./src/demux/aacdemuxer.ts":
            /*!*********************************!*\
              !*** ./src/demux/aacdemuxer.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _base_audio_demuxer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./base-audio-demuxer */"./src/demux/base-audio-demuxer.ts");
              /* harmony import */
              var _adts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./adts */"./src/demux/adts.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              /**
               * AAC demuxer
               */

              var AACDemuxer = /*#__PURE__*/function (_BaseAudioDemuxer) {
                _inheritsLoose(AACDemuxer, _BaseAudioDemuxer);
                function AACDemuxer(observer, config) {
                  var _this;
                  _this = _BaseAudioDemuxer.call(this || _global) || this || _global;
                  _this.observer = void 0;
                  _this.config = void 0;
                  _this.observer = observer;
                  _this.config = config;
                  return _this;
                }
                var _proto = AACDemuxer.prototype;
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
                  _BaseAudioDemuxer.prototype.resetInitSegment.call(this || _global, initSegment, audioCodec, videoCodec, trackDuration);
                  (this || _global)._audioTrack = {
                    container: "audio/adts",
                    type: "audio",
                    id: 2,
                    pid: -1,
                    sequenceNumber: 0,
                    segmentCodec: "aac",
                    samples: [],
                    manifestCodec: audioCodec,
                    duration: trackDuration,
                    inputTimeScale: 90000,
                    dropped: 0
                  };
                }

                // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
                ;

                AACDemuxer.probe = function probe(data) {
                  if (!data) {
                    return false;
                  }

                  // Check for the ADTS sync word
                  // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
                  // Layer bits (position 14 and 15) in header should be always 0 for ADTS
                  // More info https://wiki.multimedia.cx/index.php?title=ADTS
                  var id3Data = _demux_id3__WEBPACK_IMPORTED_MODULE_3__.getID3Data(data, 0) || [];
                  var offset = id3Data.length;
                  for (var length = data.length; offset < length; offset++) {
                    if (_adts__WEBPACK_IMPORTED_MODULE_1__.probe(data, offset)) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("ADTS sync word found !");
                      return true;
                    }
                  }
                  return false;
                };
                _proto.canParse = function canParse(data, offset) {
                  return _adts__WEBPACK_IMPORTED_MODULE_1__.canParse(data, offset);
                };
                _proto.appendFrame = function appendFrame(track, data, offset) {
                  _adts__WEBPACK_IMPORTED_MODULE_1__.initTrackConfig(track, (this || _global).observer, data, offset, track.manifestCodec);
                  var frame = _adts__WEBPACK_IMPORTED_MODULE_1__.appendFrame(track, data, offset, (this || _global).basePTS, (this || _global).frameIndex);
                  if (frame && frame.missing === 0) {
                    return frame;
                  }
                };
                return AACDemuxer;
              }(_base_audio_demuxer__WEBPACK_IMPORTED_MODULE_0__["default"]);
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = AACDemuxer;

              /***/
            },

            /***/"./src/demux/adts.ts":
            /*!***************************!*\
              !*** ./src/demux/adts.ts ***!
              \***************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"appendFrame": () => /* binding */appendFrame,
                /* harmony export */"canGetFrameLength": () => /* binding */canGetFrameLength,
                /* harmony export */"canParse": () => /* binding */canParse,
                /* harmony export */"getAudioConfig": () => /* binding */getAudioConfig,
                /* harmony export */"getFrameDuration": () => /* binding */getFrameDuration,
                /* harmony export */"getFullFrameLength": () => /* binding */getFullFrameLength,
                /* harmony export */"getHeaderLength": () => /* binding */getHeaderLength,
                /* harmony export */"initTrackConfig": () => /* binding */initTrackConfig,
                /* harmony export */"isHeader": () => /* binding */isHeader,
                /* harmony export */"isHeaderPattern": () => /* binding */isHeaderPattern,
                /* harmony export */"parseFrameHeader": () => /* binding */parseFrameHeader,
                /* harmony export */"probe": () => /* binding */probe
                /* harmony export */
              });
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /**
               * ADTS parser helper
               * @link https://wiki.multimedia.cx/index.php?title=ADTS
               */

              function getAudioConfig(observer, data, offset, audioCodec) {
                var adtsObjectType;
                var adtsExtensionSamplingIndex;
                var adtsChannelConfig;
                var config;
                var userAgent = navigator.userAgent.toLowerCase();
                var manifestCodec = audioCodec;
                var adtsSamplingRates = [96000, 88200, 64000, 48000, 44100, 32000, 24000, 22050, 16000, 12000, 11025, 8000, 7350];
                // byte 2
                adtsObjectType = ((data[offset + 2] & 192) >>> 6) + 1;
                var adtsSamplingIndex = (data[offset + 2] & 60) >>> 2;
                if (adtsSamplingIndex > adtsSamplingRates.length - 1) {
                  observer.trigger(_events__WEBPACK_IMPORTED_MODULE_2__.Events.ERROR, {
                    type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                    details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_PARSING_ERROR,
                    fatal: true,
                    reason: "invalid ADTS sampling index:" + adtsSamplingIndex
                  });
                  return;
                }
                adtsChannelConfig = (data[offset + 2] & 1) << 2;
                // byte 3
                adtsChannelConfig |= (data[offset + 3] & 192) >>> 6;
                _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.log("manifest codec:" + audioCodec + ", ADTS type:" + adtsObjectType + ", samplingIndex:" + adtsSamplingIndex);
                // firefox: freq less than 24kHz = AAC SBR (HE-AAC)
                if (/firefox/i.test(userAgent)) {
                  if (adtsSamplingIndex >= 6) {
                    adtsObjectType = 5;
                    config = new Array(4);
                    // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
                    // there is a factor 2 between frame sample rate and output sample rate
                    // multiply frequency by 2 (see table below, equivalent to substract 3)
                    adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
                  } else {
                    adtsObjectType = 2;
                    config = new Array(2);
                    adtsExtensionSamplingIndex = adtsSamplingIndex;
                  }
                  // Android : always use AAC
                } else if (userAgent.indexOf("android") !== -1) {
                  adtsObjectType = 2;
                  config = new Array(2);
                  adtsExtensionSamplingIndex = adtsSamplingIndex;
                } else {
                  /*  for other browsers (Chrome/Vivaldi/Opera ...)
                      always force audio type to be HE-AAC SBR, as some browsers do not support audio codec switch properly (like Chrome ...)
                  */
                  adtsObjectType = 5;
                  config = new Array(4);
                  // if (manifest codec is HE-AAC or HE-AACv2) OR (manifest codec not specified AND frequency less than 24kHz)
                  if (audioCodec && (audioCodec.indexOf("mp4a.40.29") !== -1 || audioCodec.indexOf("mp4a.40.5") !== -1) || !audioCodec && adtsSamplingIndex >= 6) {
                    // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
                    // there is a factor 2 between frame sample rate and output sample rate
                    // multiply frequency by 2 (see table below, equivalent to substract 3)
                    adtsExtensionSamplingIndex = adtsSamplingIndex - 3;
                  } else {
                    // if (manifest codec is AAC) AND (frequency less than 24kHz AND nb channel is 1) OR (manifest codec not specified and mono audio)
                    // Chrome fails to play back with low frequency AAC LC mono when initialized with HE-AAC.  This is not a problem with stereo.
                    if (audioCodec && audioCodec.indexOf("mp4a.40.2") !== -1 && (adtsSamplingIndex >= 6 && adtsChannelConfig === 1 || /vivaldi/i.test(userAgent)) || !audioCodec && adtsChannelConfig === 1) {
                      adtsObjectType = 2;
                      config = new Array(2);
                    }
                    adtsExtensionSamplingIndex = adtsSamplingIndex;
                  }
                }
                /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
                    ISO 14496-3 (AAC).pdf - Table 1.13 — Syntax of AudioSpecificConfig()
                  Audio Profile / Audio Object Type
                  0: Null
                  1: AAC Main
                  2: AAC LC (Low Complexity)
                  3: AAC SSR (Scalable Sample Rate)
                  4: AAC LTP (Long Term Prediction)
                  5: SBR (Spectral Band Replication)
                  6: AAC Scalable
                 sampling freq
                  0: 96000 Hz
                  1: 88200 Hz
                  2: 64000 Hz
                  3: 48000 Hz
                  4: 44100 Hz
                  5: 32000 Hz
                  6: 24000 Hz
                  7: 22050 Hz
                  8: 16000 Hz
                  9: 12000 Hz
                  10: 11025 Hz
                  11: 8000 Hz
                  12: 7350 Hz
                  13: Reserved
                  14: Reserved
                  15: frequency is written explictly
                  Channel Configurations
                  These are the channel configurations:
                  0: Defined in AOT Specifc Config
                  1: 1 channel: front-center
                  2: 2 channels: front-left, front-right
                */
                // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
                config[0] = adtsObjectType << 3;
                // samplingFrequencyIndex
                config[0] |= (adtsSamplingIndex & 14) >> 1;
                config[1] |= (adtsSamplingIndex & 1) << 7;
                // channelConfiguration
                config[1] |= adtsChannelConfig << 3;
                if (adtsObjectType === 5) {
                  // adtsExtensionSamplingIndex
                  config[1] |= (adtsExtensionSamplingIndex & 14) >> 1;
                  config[2] = (adtsExtensionSamplingIndex & 1) << 7;
                  // adtsObjectType (force to 2, chrome is checking that object type is less than 5 ???
                  //    https://chromium.googlesource.com/chromium/src.git/+/master/media/formats/mp4/aac.cc
                  config[2] |= 2 << 2;
                  config[3] = 0;
                }
                return {
                  config: config,
                  samplerate: adtsSamplingRates[adtsSamplingIndex],
                  channelCount: adtsChannelConfig,
                  codec: "mp4a.40." + adtsObjectType,
                  manifestCodec: manifestCodec
                };
              }
              function isHeaderPattern(data, offset) {
                return data[offset] === 255 && (data[offset + 1] & 246) === 240;
              }
              function getHeaderLength(data, offset) {
                return data[offset + 1] & 1 ? 7 : 9;
              }
              function getFullFrameLength(data, offset) {
                return (data[offset + 3] & 3) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 224) >>> 5;
              }
              function canGetFrameLength(data, offset) {
                return offset + 5 < data.length;
              }
              function isHeader(data, offset) {
                // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
                // Layer bits (position 14 and 15) in header should be always 0 for ADTS
                // More info https://wiki.multimedia.cx/index.php?title=ADTS
                return offset + 1 < data.length && isHeaderPattern(data, offset);
              }
              function canParse(data, offset) {
                return canGetFrameLength(data, offset) && isHeaderPattern(data, offset) && getFullFrameLength(data, offset) <= data.length - offset;
              }
              function probe(data, offset) {
                // same as isHeader but we also check that ADTS frame follows last ADTS frame
                // or end of data is reached
                if (isHeader(data, offset)) {
                  // ADTS header Length
                  var headerLength = getHeaderLength(data, offset);
                  if (offset + headerLength >= data.length) {
                    return false;
                  }
                  // ADTS frame Length
                  var frameLength = getFullFrameLength(data, offset);
                  if (frameLength <= headerLength) {
                    return false;
                  }
                  var newOffset = offset + frameLength;
                  return newOffset === data.length || isHeader(data, newOffset);
                }
                return false;
              }
              function initTrackConfig(track, observer, data, offset, audioCodec) {
                if (!track.samplerate) {
                  var config = getAudioConfig(observer, data, offset, audioCodec);
                  if (!config) {
                    return;
                  }
                  track.config = config.config;
                  track.samplerate = config.samplerate;
                  track.channelCount = config.channelCount;
                  track.codec = config.codec;
                  track.manifestCodec = config.manifestCodec;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.log("parsed codec:" + track.codec + ", rate:" + config.samplerate + ", channels:" + config.channelCount);
                }
              }
              function getFrameDuration(samplerate) {
                return 1024 * 90000 / samplerate;
              }
              function parseFrameHeader(data, offset) {
                // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
                var headerLength = getHeaderLength(data, offset);
                if (offset + headerLength <= data.length) {
                  // retrieve frame size
                  var frameLength = getFullFrameLength(data, offset) - headerLength;
                  if (frameLength > 0) {
                    // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
                    return {
                      headerLength: headerLength,
                      frameLength: frameLength
                    };
                  }
                }
              }
              function appendFrame(track, data, offset, pts, frameIndex) {
                var frameDuration = getFrameDuration(track.samplerate);
                var stamp = pts + frameIndex * frameDuration;
                var header = parseFrameHeader(data, offset);
                var unit;
                if (header) {
                  var frameLength = header.frameLength,
                    headerLength = header.headerLength;
                  var _length = headerLength + frameLength;
                  var missing = Math.max(0, offset + _length - data.length);
                  // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
                  if (missing) {
                    unit = new Uint8Array(_length - headerLength);
                    unit.set(data.subarray(offset + headerLength, data.length), 0);
                  } else {
                    unit = data.subarray(offset + headerLength, offset + _length);
                  }
                  var _sample = {
                    unit: unit,
                    pts: stamp
                  };
                  if (!missing) {
                    track.samples.push(_sample);
                  }
                  return {
                    sample: _sample,
                    length: _length,
                    missing: missing
                  };
                }
                // overflow incomplete header
                var length = data.length - offset;
                unit = new Uint8Array(length);
                unit.set(data.subarray(offset, data.length), 0);
                var sample = {
                  unit: unit,
                  pts: stamp
                };
                return {
                  sample: sample,
                  length: length,
                  missing: -1
                };
              }

              /***/
            },

            /***/"./src/demux/base-audio-demuxer.ts":
            /*!*****************************************!*\
              !*** ./src/demux/base-audio-demuxer.ts ***!
              \*****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__,
                /* harmony export */"initPTSFn": () => /* binding */initPTSFn
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              /* harmony import */
              var _types_demuxer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../types/demuxer */"./src/types/demuxer.ts");
              /* harmony import */
              var _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./dummy-demuxed-track */"./src/demux/dummy-demuxed-track.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/typed-array */"./src/utils/typed-array.ts");
              var BaseAudioDemuxer = /*#__PURE__*/function () {
                function BaseAudioDemuxer() {
                  (this || _global)._audioTrack = void 0;
                  (this || _global)._id3Track = void 0;
                  (this || _global).frameIndex = 0;
                  (this || _global).cachedData = null;
                  (this || _global).basePTS = null;
                  (this || _global).initPTS = null;
                  (this || _global).lastPTS = null;
                }
                var _proto = BaseAudioDemuxer.prototype;
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
                  (this || _global)._id3Track = {
                    type: "id3",
                    id: 3,
                    pid: -1,
                    inputTimeScale: 90000,
                    sequenceNumber: 0,
                    samples: [],
                    dropped: 0
                  };
                };
                _proto.resetTimeStamp = function resetTimeStamp(deaultTimestamp) {
                  (this || _global).initPTS = deaultTimestamp;
                  this.resetContiguity();
                };
                _proto.resetContiguity = function resetContiguity() {
                  (this || _global).basePTS = null;
                  (this || _global).lastPTS = null;
                  (this || _global).frameIndex = 0;
                };
                _proto.canParse = function canParse(data, offset) {
                  return false;
                };
                _proto.appendFrame = function appendFrame(track, data, offset) {}

                // feed incoming data to the front of the parsing pipeline
                ;

                _proto.demux = function demux(data, timeOffset) {
                  if ((this || _global).cachedData) {
                    data = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.appendUint8Array)((this || _global).cachedData, data);
                    (this || _global).cachedData = null;
                  }
                  var id3Data = _demux_id3__WEBPACK_IMPORTED_MODULE_1__.getID3Data(data, 0);
                  var offset = id3Data ? id3Data.length : 0;
                  var lastDataIndex;
                  var track = (this || _global)._audioTrack;
                  var id3Track = (this || _global)._id3Track;
                  var timestamp = id3Data ? _demux_id3__WEBPACK_IMPORTED_MODULE_1__.getTimeStamp(id3Data) : undefined;
                  var length = data.length;
                  if ((this || _global).basePTS === null || (this || _global).frameIndex === 0 && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(timestamp)) {
                    (this || _global).basePTS = initPTSFn(timestamp, timeOffset, (this || _global).initPTS);
                    (this || _global).lastPTS = (this || _global).basePTS;
                  }
                  if ((this || _global).lastPTS === null) {
                    (this || _global).lastPTS = (this || _global).basePTS;
                  }

                  // more expressive than alternative: id3Data?.length
                  if (id3Data && id3Data.length > 0) {
                    id3Track.samples.push({
                      pts: (this || _global).lastPTS,
                      dts: (this || _global).lastPTS,
                      data: id3Data,
                      type: _types_demuxer__WEBPACK_IMPORTED_MODULE_2__.MetadataSchema.audioId3,
                      duration: Number.POSITIVE_INFINITY
                    });
                  }
                  while (offset < length) {
                    if (this.canParse(data, offset)) {
                      var frame = this.appendFrame(track, data, offset);
                      if (frame) {
                        (this || _global).frameIndex++;
                        (this || _global).lastPTS = frame.sample.pts;
                        offset += frame.length;
                        lastDataIndex = offset;
                      } else {
                        offset = length;
                      }
                    } else if (_demux_id3__WEBPACK_IMPORTED_MODULE_1__.canParse(data, offset)) {
                      // after a ID3.canParse, a call to ID3.getID3Data *should* always returns some data
                      id3Data = _demux_id3__WEBPACK_IMPORTED_MODULE_1__.getID3Data(data, offset);
                      id3Track.samples.push({
                        pts: (this || _global).lastPTS,
                        dts: (this || _global).lastPTS,
                        data: id3Data,
                        type: _types_demuxer__WEBPACK_IMPORTED_MODULE_2__.MetadataSchema.audioId3,
                        duration: Number.POSITIVE_INFINITY
                      });
                      offset += id3Data.length;
                      lastDataIndex = offset;
                    } else {
                      offset++;
                    }
                    if (offset === length && lastDataIndex !== length) {
                      var partialData = (0, _utils_typed_array__WEBPACK_IMPORTED_MODULE_5__.sliceUint8)(data, lastDataIndex);
                      if ((this || _global).cachedData) {
                        (this || _global).cachedData = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.appendUint8Array)((this || _global).cachedData, partialData);
                      } else {
                        (this || _global).cachedData = partialData;
                      }
                    }
                  }
                  return {
                    audioTrack: track,
                    videoTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)(),
                    id3Track: id3Track,
                    textTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)()
                  };
                };
                _proto.demuxSampleAes = function demuxSampleAes(data, keyData, timeOffset) {
                  return Promise.reject(new Error("[" + (this || _global) + "] This demuxer does not support Sample-AES decryption"));
                };
                _proto.flush = function flush(timeOffset) {
                  // Parse cache in case of remaining frames.
                  var cachedData = (this || _global).cachedData;
                  if (cachedData) {
                    (this || _global).cachedData = null;
                    this.demux(cachedData, 0);
                  }
                  return {
                    audioTrack: (this || _global)._audioTrack,
                    videoTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)(),
                    id3Track: (this || _global)._id3Track,
                    textTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)()
                  };
                };
                _proto.destroy = function destroy() {};
                return BaseAudioDemuxer;
              }();
              /**
               * Initialize PTS
               * <p>
               *    use timestamp unless it is undefined, NaN or Infinity
               * </p>
               */
              var initPTSFn = function initPTSFn(timestamp, timeOffset, initPTS) {
                if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(timestamp)) {
                  return timestamp * 90;
                }
                return timeOffset * 90000 + (initPTS || 0);
              };
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = BaseAudioDemuxer;

              /***/
            },

            /***/"./src/demux/chunk-cache.ts":
            /*!**********************************!*\
              !*** ./src/demux/chunk-cache.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */ChunkCache
                /* harmony export */
              });
              var ChunkCache = /*#__PURE__*/function () {
                function ChunkCache() {
                  (this || _global).chunks = [];
                  (this || _global).dataLength = 0;
                }
                var _proto = ChunkCache.prototype;
                _proto.push = function push(chunk) {
                  (this || _global).chunks.push(chunk);
                  (this || _global).dataLength += chunk.length;
                };
                _proto.flush = function flush() {
                  var chunks = (this || _global).chunks,
                    dataLength = (this || _global).dataLength;
                  var result;
                  if (!chunks.length) {
                    return new Uint8Array(0);
                  } else if (chunks.length === 1) {
                    result = chunks[0];
                  } else {
                    result = concatUint8Arrays(chunks, dataLength);
                  }
                  this.reset();
                  return result;
                };
                _proto.reset = function reset() {
                  (this || _global).chunks.length = 0;
                  (this || _global).dataLength = 0;
                };
                return ChunkCache;
              }();
              function concatUint8Arrays(chunks, dataLength) {
                var result = new Uint8Array(dataLength);
                var offset = 0;
                for (var i = 0; i < chunks.length; i++) {
                  var chunk = chunks[i];
                  result.set(chunk, offset);
                  offset += chunk.length;
                }
                return result;
              }

              /***/
            },

            /***/"./src/demux/dummy-demuxed-track.ts":
            /*!******************************************!*\
              !*** ./src/demux/dummy-demuxed-track.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"dummyTrack": () => /* binding */dummyTrack
                /* harmony export */
              });
              function dummyTrack(type, inputTimeScale) {
                if (type === void 0) {
                  type = "";
                }
                if (inputTimeScale === void 0) {
                  inputTimeScale = 90000;
                }
                return {
                  type: type,
                  id: -1,
                  pid: -1,
                  inputTimeScale: inputTimeScale,
                  sequenceNumber: -1,
                  samples: [],
                  dropped: 0
                };
              }

              /***/
            },

            /***/"./src/demux/exp-golomb.ts":
            /*!*********************************!*\
              !*** ./src/demux/exp-golomb.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /**
               * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
               */

              var ExpGolomb = /*#__PURE__*/function () {
                function ExpGolomb(data) {
                  (this || _global).data = void 0;
                  (this || _global).bytesAvailable = void 0;
                  (this || _global).word = void 0;
                  (this || _global).bitsAvailable = void 0;
                  (this || _global).data = data;
                  // the number of bytes left to examine in this.data
                  (this || _global).bytesAvailable = data.byteLength;
                  // the current word being examined
                  (this || _global).word = 0; // :uint
                  // the number of bits left to examine in the current word
                  (this || _global).bitsAvailable = 0; // :uint
                }

                // ():void
                var _proto = ExpGolomb.prototype;
                _proto.loadWord = function loadWord() {
                  var data = (this || _global).data;
                  var bytesAvailable = (this || _global).bytesAvailable;
                  var position = data.byteLength - bytesAvailable;
                  var workingBytes = new Uint8Array(4);
                  var availableBytes = Math.min(4, bytesAvailable);
                  if (availableBytes === 0) {
                    throw new Error("no bytes available");
                  }
                  workingBytes.set(data.subarray(position, position + availableBytes));
                  (this || _global).word = new DataView(workingBytes.buffer).getUint32(0);
                  // track the amount of this.data that has been processed
                  (this || _global).bitsAvailable = availableBytes * 8;
                  (this || _global).bytesAvailable -= availableBytes;
                }

                // (count:int):void
                ;

                _proto.skipBits = function skipBits(count) {
                  var skipBytes; // :int
                  if ((this || _global).bitsAvailable > count) {
                    (this || _global).word <<= count;
                    (this || _global).bitsAvailable -= count;
                  } else {
                    count -= (this || _global).bitsAvailable;
                    skipBytes = count >> 3;
                    count -= skipBytes >> 3;
                    (this || _global).bytesAvailable -= skipBytes;
                    this.loadWord();
                    (this || _global).word <<= count;
                    (this || _global).bitsAvailable -= count;
                  }
                }

                // (size:int):uint
                ;

                _proto.readBits = function readBits(size) {
                  var bits = Math.min((this || _global).bitsAvailable, size); // :uint
                  var valu = (this || _global).word >>> 32 - bits; // :uint
                  if (size > 32) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.error("Cannot read more than 32 bits at a time");
                  }
                  (this || _global).bitsAvailable -= bits;
                  if ((this || _global).bitsAvailable > 0) {
                    (this || _global).word <<= bits;
                  } else if ((this || _global).bytesAvailable > 0) {
                    this.loadWord();
                  }
                  bits = size - bits;
                  if (bits > 0 && (this || _global).bitsAvailable) {
                    return valu << bits | this.readBits(bits);
                  } else {
                    return valu;
                  }
                }

                // ():uint
                ;

                _proto.skipLZ = function skipLZ() {
                  var leadingZeroCount; // :uint
                  for (leadingZeroCount = 0; leadingZeroCount < (this || _global).bitsAvailable; ++leadingZeroCount) {
                    if (((this || _global).word & 2147483648 >>> leadingZeroCount) !== 0) {
                      // the first bit of working word is 1
                      (this || _global).word <<= leadingZeroCount;
                      (this || _global).bitsAvailable -= leadingZeroCount;
                      return leadingZeroCount;
                    }
                  }
                  // we exhausted word and still have not found a 1
                  this.loadWord();
                  return leadingZeroCount + this.skipLZ();
                }

                // ():void
                ;

                _proto.skipUEG = function skipUEG() {
                  this.skipBits(1 + this.skipLZ());
                }

                // ():void
                ;

                _proto.skipEG = function skipEG() {
                  this.skipBits(1 + this.skipLZ());
                }

                // ():uint
                ;

                _proto.readUEG = function readUEG() {
                  var clz = this.skipLZ(); // :uint
                  return this.readBits(clz + 1) - 1;
                }

                // ():int
                ;

                _proto.readEG = function readEG() {
                  var valu = this.readUEG(); // :int
                  if (1 & valu) {
                    // the number is odd if the low order bit is set
                    return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
                  } else {
                    return -1 * (valu >>> 1); // divide by two then make it negative
                  }
                }

                // Some convenience functions
                // :Boolean
                ;

                _proto.readBoolean = function readBoolean() {
                  return this.readBits(1) === 1;
                }

                // ():int
                ;

                _proto.readUByte = function readUByte() {
                  return this.readBits(8);
                }

                // ():int
                ;

                _proto.readUShort = function readUShort() {
                  return this.readBits(16);
                }

                // ():int
                ;

                _proto.readUInt = function readUInt() {
                  return this.readBits(32);
                }

                /**
                 * Advance the ExpGolomb decoder past a scaling list. The scaling
                 * list is optionally transmitted as part of a sequence parameter
                 * set and is not relevant to transmuxing.
                 * @param count the number of entries in this scaling list
                 * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
                 */;
                _proto.skipScalingList = function skipScalingList(count) {
                  var lastScale = 8;
                  var nextScale = 8;
                  var deltaScale;
                  for (var j = 0; j < count; j++) {
                    if (nextScale !== 0) {
                      deltaScale = this.readEG();
                      nextScale = (lastScale + deltaScale + 256) % 256;
                    }
                    lastScale = nextScale === 0 ? lastScale : nextScale;
                  }
                }

                /**
                 * Read a sequence parameter set and return some interesting video
                 * properties. A sequence parameter set is the H264 metadata that
                 * describes the properties of upcoming video frames.
                 * @param data {Uint8Array} the bytes of a sequence parameter set
                 * @return {object} an object with configuration parsed from the
                 * sequence parameter set, including the dimensions of the
                 * associated video frames.
                 */;
                _proto.readSPS = function readSPS() {
                  var frameCropLeftOffset = 0;
                  var frameCropRightOffset = 0;
                  var frameCropTopOffset = 0;
                  var frameCropBottomOffset = 0;
                  var numRefFramesInPicOrderCntCycle;
                  var scalingListCount;
                  var i;
                  var readUByte = (this || _global).readUByte.bind(this || _global);
                  var readBits = (this || _global).readBits.bind(this || _global);
                  var readUEG = (this || _global).readUEG.bind(this || _global);
                  var readBoolean = (this || _global).readBoolean.bind(this || _global);
                  var skipBits = (this || _global).skipBits.bind(this || _global);
                  var skipEG = (this || _global).skipEG.bind(this || _global);
                  var skipUEG = (this || _global).skipUEG.bind(this || _global);
                  var skipScalingList = (this || _global).skipScalingList.bind(this || _global);
                  readUByte();
                  var profileIdc = readUByte(); // profile_idc
                  readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
                  skipBits(3); // reserved_zero_3bits u(3),
                  readUByte(); // level_idc u(8)
                  skipUEG(); // seq_parameter_set_id
                  // some profiles have more optional data we don't need
                  if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
                    var chromaFormatIdc = readUEG();
                    if (chromaFormatIdc === 3) {
                      skipBits(1);
                    } // separate_colour_plane_flag

                    skipUEG(); // bit_depth_luma_minus8
                    skipUEG(); // bit_depth_chroma_minus8
                    skipBits(1); // qpprime_y_zero_transform_bypass_flag
                    if (readBoolean()) {
                      // seq_scaling_matrix_present_flag
                      scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                      for (i = 0; i < scalingListCount; i++) {
                        if (readBoolean()) {
                          // seq_scaling_list_present_flag[ i ]
                          if (i < 6) {
                            skipScalingList(16);
                          } else {
                            skipScalingList(64);
                          }
                        }
                      }
                    }
                  }
                  skipUEG(); // log2_max_frame_num_minus4
                  var picOrderCntType = readUEG();
                  if (picOrderCntType === 0) {
                    readUEG(); // log2_max_pic_order_cnt_lsb_minus4
                  } else if (picOrderCntType === 1) {
                    skipBits(1); // delta_pic_order_always_zero_flag
                    skipEG(); // offset_for_non_ref_pic
                    skipEG(); // offset_for_top_to_bottom_field
                    numRefFramesInPicOrderCntCycle = readUEG();
                    for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
                      skipEG();
                    } // offset_for_ref_frame[ i ]
                  }

                  skipUEG(); // max_num_ref_frames
                  skipBits(1); // gaps_in_frame_num_value_allowed_flag
                  var picWidthInMbsMinus1 = readUEG();
                  var picHeightInMapUnitsMinus1 = readUEG();
                  var frameMbsOnlyFlag = readBits(1);
                  if (frameMbsOnlyFlag === 0) {
                    skipBits(1);
                  } // mb_adaptive_frame_field_flag

                  skipBits(1); // direct_8x8_inference_flag
                  if (readBoolean()) {
                    // frame_cropping_flag
                    frameCropLeftOffset = readUEG();
                    frameCropRightOffset = readUEG();
                    frameCropTopOffset = readUEG();
                    frameCropBottomOffset = readUEG();
                  }
                  var pixelRatio = [1, 1];
                  if (readBoolean()) {
                    // vui_parameters_present_flag
                    if (readBoolean()) {
                      // aspect_ratio_info_present_flag
                      var aspectRatioIdc = readUByte();
                      switch (aspectRatioIdc) {
                        case 1:
                          pixelRatio = [1, 1];
                          break;
                        case 2:
                          pixelRatio = [12, 11];
                          break;
                        case 3:
                          pixelRatio = [10, 11];
                          break;
                        case 4:
                          pixelRatio = [16, 11];
                          break;
                        case 5:
                          pixelRatio = [40, 33];
                          break;
                        case 6:
                          pixelRatio = [24, 11];
                          break;
                        case 7:
                          pixelRatio = [20, 11];
                          break;
                        case 8:
                          pixelRatio = [32, 11];
                          break;
                        case 9:
                          pixelRatio = [80, 33];
                          break;
                        case 10:
                          pixelRatio = [18, 11];
                          break;
                        case 11:
                          pixelRatio = [15, 11];
                          break;
                        case 12:
                          pixelRatio = [64, 33];
                          break;
                        case 13:
                          pixelRatio = [160, 99];
                          break;
                        case 14:
                          pixelRatio = [4, 3];
                          break;
                        case 15:
                          pixelRatio = [3, 2];
                          break;
                        case 16:
                          pixelRatio = [2, 1];
                          break;
                        case 255:
                          {
                            pixelRatio = [readUByte() << 8 | readUByte(), readUByte() << 8 | readUByte()];
                            break;
                          }
                      }
                    }
                  }
                  return {
                    width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
                    height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
                    pixelRatio: pixelRatio
                  };
                };
                _proto.readSliceType = function readSliceType() {
                  // skip NALu type
                  this.readUByte();
                  // discard first_mb_in_slice
                  this.readUEG();
                  // return slice_type
                  return this.readUEG();
                };
                return ExpGolomb;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = ExpGolomb;

              /***/
            },

            /***/"./src/demux/id3.ts":
            /*!**************************!*\
              !*** ./src/demux/id3.ts ***!
              \**************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"canParse": () => /* binding */canParse,
                /* harmony export */"decodeFrame": () => /* binding */decodeFrame,
                /* harmony export */"getID3Data": () => /* binding */getID3Data,
                /* harmony export */"getID3Frames": () => /* binding */getID3Frames,
                /* harmony export */"getTimeStamp": () => /* binding */getTimeStamp,
                /* harmony export */"isFooter": () => /* binding */isFooter,
                /* harmony export */"isHeader": () => /* binding */isHeader,
                /* harmony export */"isTimeStampFrame": () => /* binding */isTimeStampFrame,
                /* harmony export */"testables": () => /* binding */testables,
                /* harmony export */"utf8ArrayToStr": () => /* binding */utf8ArrayToStr
                /* harmony export */
              });
              // breaking up those two types in order to clarify what is happening in the decoding path.

              /**
               * Returns true if an ID3 header can be found at offset in data
               * @param {Uint8Array} data - The data to search in
               * @param {number} offset - The offset at which to start searching
               * @return {boolean} - True if an ID3 header is found
               */
              var isHeader = function isHeader(data, offset) {
                /*
                 * http://id3.org/id3v2.3.0
                 * [0]     = 'I'
                 * [1]     = 'D'
                 * [2]     = '3'
                 * [3,4]   = {Version}
                 * [5]     = {Flags}
                 * [6-9]   = {ID3 Size}
                 *
                 * An ID3v2 tag can be detected with the following pattern:
                 *  $49 44 33 yy yy xx zz zz zz zz
                 * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
                 */
                if (offset + 10 <= data.length) {
                  // look for 'ID3' identifier
                  if (data[offset] === 73 && data[offset + 1] === 68 && data[offset + 2] === 51) {
                    // check version is within range
                    if (data[offset + 3] < 255 && data[offset + 4] < 255) {
                      // check size is within range
                      if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) {
                        return true;
                      }
                    }
                  }
                }
                return false;
              };

              /**
               * Returns true if an ID3 footer can be found at offset in data
               * @param {Uint8Array} data - The data to search in
               * @param {number} offset - The offset at which to start searching
               * @return {boolean} - True if an ID3 footer is found
               */
              var isFooter = function isFooter(data, offset) {
                /*
                 * The footer is a copy of the header, but with a different identifier
                 */
                if (offset + 10 <= data.length) {
                  // look for '3DI' identifier
                  if (data[offset] === 51 && data[offset + 1] === 68 && data[offset + 2] === 73) {
                    // check version is within range
                    if (data[offset + 3] < 255 && data[offset + 4] < 255) {
                      // check size is within range
                      if (data[offset + 6] < 128 && data[offset + 7] < 128 && data[offset + 8] < 128 && data[offset + 9] < 128) {
                        return true;
                      }
                    }
                  }
                }
                return false;
              };

              /**
               * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
               * @param {Uint8Array} data - The data to search in
               * @param {number} offset - The offset at which to start searching
               * @return {Uint8Array | undefined} - The block of data containing any ID3 tags found
               * or *undefined* if no header is found at the starting offset
               */
              var getID3Data = function getID3Data(data, offset) {
                var front = offset;
                var length = 0;
                while (isHeader(data, offset)) {
                  // ID3 header is 10 bytes
                  length += 10;
                  var size = readSize(data, offset + 6);
                  length += size;
                  if (isFooter(data, offset + 10)) {
                    // ID3 footer is 10 bytes
                    length += 10;
                  }
                  offset += length;
                }
                if (length > 0) {
                  return data.subarray(front, front + length);
                }
                return undefined;
              };
              var readSize = function readSize(data, offset) {
                var size = 0;
                size = (data[offset] & 127) << 21;
                size |= (data[offset + 1] & 127) << 14;
                size |= (data[offset + 2] & 127) << 7;
                size |= data[offset + 3] & 127;
                return size;
              };
              var canParse = function canParse(data, offset) {
                return isHeader(data, offset) && readSize(data, offset + 6) + 10 <= data.length - offset;
              };

              /**
               * Searches for the Elementary Stream timestamp found in the ID3 data chunk
               * @param {Uint8Array} data - Block of data containing one or more ID3 tags
               * @return {number | undefined} - The timestamp
               */
              var getTimeStamp = function getTimeStamp(data) {
                var frames = getID3Frames(data);
                for (var i = 0; i < frames.length; i++) {
                  var frame = frames[i];
                  if (isTimeStampFrame(frame)) {
                    return readTimeStamp(frame);
                  }
                }
                return undefined;
              };

              /**
               * Returns true if the ID3 frame is an Elementary Stream timestamp frame
               * @param {ID3 frame} frame
               */
              var isTimeStampFrame = function isTimeStampFrame(frame) {
                return frame && frame.key === "PRIV" && frame.info === "com.apple.streaming.transportStreamTimestamp";
              };
              var getFrameData = function getFrameData(data) {
                /*
                Frame ID       $xx xx xx xx (four characters)
                Size           $xx xx xx xx
                Flags          $xx xx
                */
                var type = String.fromCharCode(data[0], data[1], data[2], data[3]);
                var size = readSize(data, 4);

                // skip frame id, size, and flags
                var offset = 10;
                return {
                  type: type,
                  size: size,
                  data: data.subarray(offset, offset + size)
                };
              };

              /**
               * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
               * @param {Uint8Array} id3Data - The ID3 data containing one or more ID3 tags
               * @return {ID3.Frame[]} - Array of ID3 frame objects
               */
              var getID3Frames = function getID3Frames(id3Data) {
                var offset = 0;
                var frames = [];
                while (isHeader(id3Data, offset)) {
                  var size = readSize(id3Data, offset + 6);
                  // skip past ID3 header
                  offset += 10;
                  var end = offset + size;
                  // loop through frames in the ID3 tag
                  while (offset + 8 < end) {
                    var frameData = getFrameData(id3Data.subarray(offset));
                    var frame = decodeFrame(frameData);
                    if (frame) {
                      frames.push(frame);
                    }

                    // skip frame header and frame data
                    offset += frameData.size + 10;
                  }
                  if (isFooter(id3Data, offset)) {
                    offset += 10;
                  }
                }
                return frames;
              };
              var decodeFrame = function decodeFrame(frame) {
                if (frame.type === "PRIV") {
                  return decodePrivFrame(frame);
                } else if (frame.type[0] === "W") {
                  return decodeURLFrame(frame);
                }
                return decodeTextFrame(frame);
              };
              var decodePrivFrame = function decodePrivFrame(frame) {
                /*
                Format: <text string>\0<binary data>
                */
                if (frame.size < 2) {
                  return undefined;
                }
                var owner = utf8ArrayToStr(frame.data, true);
                var privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
                return {
                  key: frame.type,
                  info: owner,
                  data: privateData.buffer
                };
              };
              var decodeTextFrame = function decodeTextFrame(frame) {
                if (frame.size < 2) {
                  return undefined;
                }
                if (frame.type === "TXXX") {
                  /*
                  Format:
                  [0]   = {Text Encoding}
                  [1-?] = {Description}\0{Value}
                  */
                  var index = 1;
                  var description = utf8ArrayToStr(frame.data.subarray(index), true);
                  index += description.length + 1;
                  var value = utf8ArrayToStr(frame.data.subarray(index));
                  return {
                    key: frame.type,
                    info: description,
                    data: value
                  };
                }
                /*
                Format:
                [0]   = {Text Encoding}
                [1-?] = {Value}
                */
                var text = utf8ArrayToStr(frame.data.subarray(1));
                return {
                  key: frame.type,
                  data: text
                };
              };
              var decodeURLFrame = function decodeURLFrame(frame) {
                if (frame.type === "WXXX") {
                  /*
                  Format:
                  [0]   = {Text Encoding}
                  [1-?] = {Description}\0{URL}
                  */
                  if (frame.size < 2) {
                    return undefined;
                  }
                  var index = 1;
                  var description = utf8ArrayToStr(frame.data.subarray(index), true);
                  index += description.length + 1;
                  var value = utf8ArrayToStr(frame.data.subarray(index));
                  return {
                    key: frame.type,
                    info: description,
                    data: value
                  };
                }
                /*
                Format:
                [0-?] = {URL}
                */
                var url = utf8ArrayToStr(frame.data);
                return {
                  key: frame.type,
                  data: url
                };
              };
              var readTimeStamp = function readTimeStamp(timeStampFrame) {
                if (timeStampFrame.data.byteLength === 8) {
                  var data = new Uint8Array(timeStampFrame.data);
                  // timestamp is 33 bit expressed as a big-endian eight-octet number,
                  // with the upper 31 bits set to zero.
                  var pts33Bit = data[3] & 1;
                  var timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
                  timestamp /= 45;
                  if (pts33Bit) {
                    timestamp += 47721858.84;
                  } // 2^32 / 90

                  return Math.round(timestamp);
                }
                return undefined;
              };

              // http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
              // http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
              /* utf.js - UTF-8 <=> UTF-16 convertion
               *
               * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
               * Version: 1.0
               * LastModified: Dec 25 1999
               * This library is free.  You can redistribute it and/or modify it.
               */
              var utf8ArrayToStr = function utf8ArrayToStr(array, exitOnNull) {
                if (exitOnNull === void 0) {
                  exitOnNull = false;
                }
                var decoder = getTextDecoder();
                if (decoder) {
                  var decoded = decoder.decode(array);
                  if (exitOnNull) {
                    // grab up to the first null
                    var idx = decoded.indexOf("\0");
                    return idx !== -1 ? decoded.substring(0, idx) : decoded;
                  }

                  // remove any null characters
                  return decoded.replace(/\0/g, "");
                }
                var len = array.length;
                var c;
                var char2;
                var char3;
                var out = "";
                var i = 0;
                while (i < len) {
                  c = array[i++];
                  if (c === 0 && exitOnNull) {
                    return out;
                  } else if (c === 0 || c === 3) {
                    // If the character is 3 (END_OF_TEXT) or 0 (NULL) then skip it
                    continue;
                  }
                  switch (c >> 4) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                      // 0xxxxxxx
                      out += String.fromCharCode(c);
                      break;
                    case 12:
                    case 13:
                      // 110x xxxx   10xx xxxx
                      char2 = array[i++];
                      out += String.fromCharCode((c & 31) << 6 | char2 & 63);
                      break;
                    case 14:
                      // 1110 xxxx  10xx xxxx  10xx xxxx
                      char2 = array[i++];
                      char3 = array[i++];
                      out += String.fromCharCode((c & 15) << 12 | (char2 & 63) << 6 | (char3 & 63) << 0);
                      break;
                  }
                }
                return out;
              };
              var testables = {
                decodeTextFrame: decodeTextFrame
              };
              var decoder;
              function getTextDecoder() {
                if (!decoder && typeof self.TextDecoder !== "undefined") {
                  decoder = new self.TextDecoder("utf-8");
                }
                return decoder;
              }

              /***/
            },

            /***/"./src/demux/mp3demuxer.ts":
            /*!*********************************!*\
              !*** ./src/demux/mp3demuxer.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _base_audio_demuxer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./base-audio-demuxer */"./src/demux/base-audio-demuxer.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _mpegaudio__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./mpegaudio */"./src/demux/mpegaudio.ts");
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              /**
               * MP3 demuxer
               */

              var MP3Demuxer = /*#__PURE__*/function (_BaseAudioDemuxer) {
                _inheritsLoose(MP3Demuxer, _BaseAudioDemuxer);
                function MP3Demuxer() {
                  return _BaseAudioDemuxer.apply(this || _global, arguments) || this || _global;
                }
                var _proto = MP3Demuxer.prototype;
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
                  _BaseAudioDemuxer.prototype.resetInitSegment.call(this || _global, initSegment, audioCodec, videoCodec, trackDuration);
                  (this || _global)._audioTrack = {
                    container: "audio/mpeg",
                    type: "audio",
                    id: 2,
                    pid: -1,
                    sequenceNumber: 0,
                    segmentCodec: "mp3",
                    samples: [],
                    manifestCodec: audioCodec,
                    duration: trackDuration,
                    inputTimeScale: 90000,
                    dropped: 0
                  };
                };
                MP3Demuxer.probe = function probe(data) {
                  if (!data) {
                    return false;
                  }

                  // check if data contains ID3 timestamp and MPEG sync word
                  // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
                  // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
                  // More info http://www.mp3-tech.org/programmer/frame_header.html
                  var id3Data = _demux_id3__WEBPACK_IMPORTED_MODULE_1__.getID3Data(data, 0) || [];
                  var offset = id3Data.length;
                  for (var length = data.length; offset < length; offset++) {
                    if (_mpegaudio__WEBPACK_IMPORTED_MODULE_3__.probe(data, offset)) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.log("MPEG Audio sync word found !");
                      return true;
                    }
                  }
                  return false;
                };
                _proto.canParse = function canParse(data, offset) {
                  return _mpegaudio__WEBPACK_IMPORTED_MODULE_3__.canParse(data, offset);
                };
                _proto.appendFrame = function appendFrame(track, data, offset) {
                  if ((this || _global).basePTS === null) {
                    return;
                  }
                  return _mpegaudio__WEBPACK_IMPORTED_MODULE_3__.appendFrame(track, data, offset, (this || _global).basePTS, (this || _global).frameIndex);
                };
                return MP3Demuxer;
              }(_base_audio_demuxer__WEBPACK_IMPORTED_MODULE_0__["default"]);
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = MP3Demuxer;

              /***/
            },

            /***/"./src/demux/mp4demuxer.ts":
            /*!*********************************!*\
              !*** ./src/demux/mp4demuxer.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _types_demuxer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../types/demuxer */"./src/types/demuxer.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./dummy-demuxed-track */"./src/demux/dummy-demuxed-track.ts");

              /**
               * MP4 demuxer
               */

              var emsgSchemePattern = /\/emsg[-/]ID3/i;
              var MP4Demuxer = /*#__PURE__*/function () {
                function MP4Demuxer(observer, config) {
                  (this || _global).remainderData = null;
                  (this || _global).timeOffset = 0;
                  (this || _global).config = void 0;
                  (this || _global).videoTrack = void 0;
                  (this || _global).audioTrack = void 0;
                  (this || _global).id3Track = void 0;
                  (this || _global).txtTrack = void 0;
                  (this || _global).config = config;
                }
                var _proto = MP4Demuxer.prototype;
                _proto.resetTimeStamp = function resetTimeStamp() {};
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
                  var initData = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.parseInitSegment)(initSegment);
                  var videoTrack = (this || _global).videoTrack = (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)("video", 1);
                  var audioTrack = (this || _global).audioTrack = (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)("audio", 1);
                  var captionTrack = (this || _global).txtTrack = (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)("text", 1);
                  (this || _global).id3Track = (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)("id3", 1);
                  (this || _global).timeOffset = 0;
                  if (initData.video) {
                    var _initData$video = initData.video,
                      id = _initData$video.id,
                      timescale = _initData$video.timescale,
                      codec = _initData$video.codec;
                    videoTrack.id = id;
                    videoTrack.timescale = captionTrack.timescale = timescale;
                    videoTrack.codec = codec;
                  }
                  if (initData.audio) {
                    var _initData$audio = initData.audio,
                      _id = _initData$audio.id,
                      _timescale = _initData$audio.timescale,
                      _codec = _initData$audio.codec;
                    audioTrack.id = _id;
                    audioTrack.timescale = _timescale;
                    audioTrack.codec = _codec;
                  }
                  captionTrack.id = _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.RemuxerTrackIdConfig.text;
                  videoTrack.sampleDuration = 0;
                  videoTrack.duration = audioTrack.duration = trackDuration;
                };
                _proto.resetContiguity = function resetContiguity() {};
                MP4Demuxer.probe = function probe(data) {
                  // ensure we find a moof box in the first 16 kB
                  data = data.length > 16384 ? data.subarray(0, 16384) : data;
                  return (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.findBox)(data, ["moof"]).length > 0;
                };
                _proto.demux = function demux(data, timeOffset) {
                  (this || _global).timeOffset = timeOffset;
                  // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
                  var videoSamples = data;
                  var videoTrack = (this || _global).videoTrack;
                  var textTrack = (this || _global).txtTrack;
                  if ((this || _global).config.progressive) {
                    // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
                    // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
                    // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
                    if ((this || _global).remainderData) {
                      videoSamples = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.appendUint8Array)((this || _global).remainderData, data);
                    }
                    var segmentedData = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.segmentValidRange)(videoSamples);
                    (this || _global).remainderData = segmentedData.remainder;
                    videoTrack.samples = segmentedData.valid || new Uint8Array();
                  } else {
                    videoTrack.samples = videoSamples;
                  }
                  var id3Track = this.extractID3Track(videoTrack, timeOffset);
                  textTrack.samples = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.parseSamples)(timeOffset, videoTrack);
                  return {
                    videoTrack: videoTrack,
                    audioTrack: (this || _global).audioTrack,
                    id3Track: id3Track,
                    textTrack: (this || _global).txtTrack
                  };
                };
                _proto.flush = function flush() {
                  var timeOffset = (this || _global).timeOffset;
                  var videoTrack = (this || _global).videoTrack;
                  var textTrack = (this || _global).txtTrack;
                  videoTrack.samples = (this || _global).remainderData || new Uint8Array();
                  (this || _global).remainderData = null;
                  var id3Track = this.extractID3Track(videoTrack, (this || _global).timeOffset);
                  textTrack.samples = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.parseSamples)(timeOffset, videoTrack);
                  return {
                    videoTrack: videoTrack,
                    audioTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)(),
                    id3Track: id3Track,
                    textTrack: (0, _dummy_demuxed_track__WEBPACK_IMPORTED_MODULE_3__.dummyTrack)()
                  };
                };
                _proto.extractID3Track = function extractID3Track(videoTrack, timeOffset) {
                  var id3Track = (this || _global).id3Track;
                  if (videoTrack.samples.length) {
                    var emsgs = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.findBox)(videoTrack.samples, ["emsg"]);
                    if (emsgs) {
                      emsgs.forEach(function (data) {
                        var emsgInfo = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.parseEmsg)(data);
                        if (emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
                          var pts = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
                          var duration = emsgInfo.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
                          // Safari takes anything <= 0.001 seconds and maps it to Infinity
                          if (duration <= 0.001) {
                            duration = Number.POSITIVE_INFINITY;
                          }
                          var payload = emsgInfo.payload;
                          id3Track.samples.push({
                            data: payload,
                            len: payload.byteLength,
                            dts: pts,
                            pts: pts,
                            type: _types_demuxer__WEBPACK_IMPORTED_MODULE_1__.MetadataSchema.emsg,
                            duration: duration
                          });
                        }
                      });
                    }
                  }
                  return id3Track;
                };
                _proto.demuxSampleAes = function demuxSampleAes(data, keyData, timeOffset) {
                  return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
                };
                _proto.destroy = function destroy() {};
                return MP4Demuxer;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = MP4Demuxer;

              /***/
            },

            /***/"./src/demux/mpegaudio.ts":
            /*!********************************!*\
              !*** ./src/demux/mpegaudio.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"appendFrame": () => /* binding */appendFrame,
                /* harmony export */"canParse": () => /* binding */canParse,
                /* harmony export */"isHeader": () => /* binding */isHeader,
                /* harmony export */"isHeaderPattern": () => /* binding */isHeaderPattern,
                /* harmony export */"parseHeader": () => /* binding */parseHeader,
                /* harmony export */"probe": () => /* binding */probe
                /* harmony export */
              });
              /**
               *  MPEG parser helper
               */

              var chromeVersion = null;
              var BitratesMap = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160];
              var SamplingRateMap = [44100, 48000, 32000, 22050, 24000, 16000, 11025, 12000, 8000];
              var SamplesCoefficients = [
              // MPEG 2.5
              [0,
              // Reserved
              72,
              // Layer3
              144,
              // Layer2
              12 // Layer1
              ],
              // Reserved
              [0,
              // Reserved
              0,
              // Layer3
              0,
              // Layer2
              0 // Layer1
              ],
              // MPEG 2
              [0,
              // Reserved
              72,
              // Layer3
              144,
              // Layer2
              12 // Layer1
              ],
              // MPEG 1
              [0,
              // Reserved
              144,
              // Layer3
              144,
              // Layer2
              12 // Layer1
              ]];

              var BytesInSlot = [0,
              // Reserved
              1,
              // Layer3
              1,
              // Layer2
              4 // Layer1
              ];

              function appendFrame(track, data, offset, pts, frameIndex) {
                // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
                if (offset + 24 > data.length) {
                  return;
                }
                var header = parseHeader(data, offset);
                if (header && offset + header.frameLength <= data.length) {
                  var frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
                  var stamp = pts + frameIndex * frameDuration;
                  var sample = {
                    unit: data.subarray(offset, offset + header.frameLength),
                    pts: stamp,
                    dts: stamp
                  };
                  track.config = [];
                  track.channelCount = header.channelCount;
                  track.samplerate = header.sampleRate;
                  track.samples.push(sample);
                  return {
                    sample: sample,
                    length: header.frameLength,
                    missing: 0
                  };
                }
              }
              function parseHeader(data, offset) {
                var mpegVersion = data[offset + 1] >> 3 & 3;
                var mpegLayer = data[offset + 1] >> 1 & 3;
                var bitRateIndex = data[offset + 2] >> 4 & 15;
                var sampleRateIndex = data[offset + 2] >> 2 & 3;
                if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
                  var paddingBit = data[offset + 2] >> 1 & 1;
                  var channelMode = data[offset + 3] >> 6;
                  var columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
                  var bitRate = BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
                  var columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
                  var sampleRate = SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
                  var channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
                  var sampleCoefficient = SamplesCoefficients[mpegVersion][mpegLayer];
                  var bytesInSlot = BytesInSlot[mpegLayer];
                  var samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
                  var frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
                  if (chromeVersion === null) {
                    var userAgent = navigator.userAgent || "";
                    var result = userAgent.match(/Chrome\/(\d+)/i);
                    chromeVersion = result ? parseInt(result[1]) : 0;
                  }
                  var needChromeFix = !!chromeVersion && chromeVersion <= 87;
                  if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) {
                    // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
                    data[offset + 3] = data[offset + 3] | 128;
                  }
                  return {
                    sampleRate: sampleRate,
                    channelCount: channelCount,
                    frameLength: frameLength,
                    samplesPerFrame: samplesPerFrame
                  };
                }
              }
              function isHeaderPattern(data, offset) {
                return data[offset] === 255 && (data[offset + 1] & 224) === 224 && (data[offset + 1] & 6) !== 0;
              }
              function isHeader(data, offset) {
                // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
                // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
                // More info http://www.mp3-tech.org/programmer/frame_header.html
                return offset + 1 < data.length && isHeaderPattern(data, offset);
              }
              function canParse(data, offset) {
                var headerSize = 4;
                return isHeaderPattern(data, offset) && headerSize <= data.length - offset;
              }
              function probe(data, offset) {
                // same as isHeader but we also check that MPEG frame follows last MPEG frame
                // or end of data is reached
                if (offset + 1 < data.length && isHeaderPattern(data, offset)) {
                  // MPEG header Length
                  var headerLength = 4;
                  // MPEG frame Length
                  var header = parseHeader(data, offset);
                  var frameLength = headerLength;
                  if (header !== null && header !== void 0 && header.frameLength) {
                    frameLength = header.frameLength;
                  }
                  var newOffset = offset + frameLength;
                  return newOffset === data.length || isHeader(data, newOffset);
                }
                return false;
              }

              /***/
            },

            /***/"./src/demux/sample-aes.ts":
            /*!*********************************!*\
              !*** ./src/demux/sample-aes.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _crypt_decrypter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../crypt/decrypter */"./src/crypt/decrypter.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /**
               * SAMPLE-AES decrypter
               */

              var SampleAesDecrypter = /*#__PURE__*/function () {
                function SampleAesDecrypter(observer, config, keyData) {
                  (this || _global).keyData = void 0;
                  (this || _global).decrypter = void 0;
                  (this || _global).keyData = keyData;
                  (this || _global).decrypter = new _crypt_decrypter__WEBPACK_IMPORTED_MODULE_0__["default"](observer, config, {
                    removePKCS7Padding: false
                  });
                }
                var _proto = SampleAesDecrypter.prototype;
                _proto.decryptBuffer = function decryptBuffer(encryptedData, callback) {
                  (this || _global).decrypter.decrypt(encryptedData, (this || _global).keyData.key.buffer, (this || _global).keyData.iv.buffer, callback);
                }

                // AAC - encrypt all full 16 bytes blocks starting from offset 16
                ;

                _proto.decryptAacSample = function decryptAacSample(samples, sampleIndex, callback, sync) {
                  var curUnit = samples[sampleIndex].unit;
                  if (curUnit.length <= 16) {
                    // No encrypted portion in this sample (first 16 bytes is not
                    // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
                    return;
                  }
                  var encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
                  var encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
                  var localthis = this || _global;
                  this.decryptBuffer(encryptedBuffer, function (decryptedBuffer) {
                    var decryptedData = new Uint8Array(decryptedBuffer);
                    curUnit.set(decryptedData, 16);
                    if (!sync) {
                      localthis.decryptAacSamples(samples, sampleIndex + 1, callback);
                    }
                  });
                };
                _proto.decryptAacSamples = function decryptAacSamples(samples, sampleIndex, callback) {
                  for (;; sampleIndex++) {
                    if (sampleIndex >= samples.length) {
                      callback();
                      return;
                    }
                    if (samples[sampleIndex].unit.length < 32) {
                      continue;
                    }
                    var sync = (this || _global).decrypter.isSync();
                    this.decryptAacSample(samples, sampleIndex, callback, sync);
                    if (!sync) {
                      return;
                    }
                  }
                }

                // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
                ;

                _proto.getAvcEncryptedData = function getAvcEncryptedData(decodedData) {
                  var encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
                  var encryptedData = new Int8Array(encryptedDataLen);
                  var outputPos = 0;
                  for (var inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16) {
                    encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
                  }
                  return encryptedData;
                };
                _proto.getAvcDecryptedUnit = function getAvcDecryptedUnit(decodedData, decryptedData) {
                  var uint8DecryptedData = new Uint8Array(decryptedData);
                  var inputPos = 0;
                  for (var outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16) {
                    decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
                  }
                  return decodedData;
                };
                _proto.decryptAvcSample = function decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync) {
                  var decodedData = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_1__.discardEPB)(curUnit.data);
                  var encryptedData = this.getAvcEncryptedData(decodedData);
                  var localthis = this || _global;
                  this.decryptBuffer(encryptedData.buffer, function (decryptedBuffer) {
                    curUnit.data = localthis.getAvcDecryptedUnit(decodedData, decryptedBuffer);
                    if (!sync) {
                      localthis.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
                    }
                  });
                };
                _proto.decryptAvcSamples = function decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
                  if (samples instanceof Uint8Array) {
                    throw new Error("Cannot decrypt samples of type Uint8Array");
                  }
                  for (;; sampleIndex++, unitIndex = 0) {
                    if (sampleIndex >= samples.length) {
                      callback();
                      return;
                    }
                    var curUnits = samples[sampleIndex].units;
                    for (;; unitIndex++) {
                      if (unitIndex >= curUnits.length) {
                        break;
                      }
                      var curUnit = curUnits[unitIndex];
                      if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) {
                        continue;
                      }
                      var sync = (this || _global).decrypter.isSync();
                      this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit, sync);
                      if (!sync) {
                        return;
                      }
                    }
                  }
                };
                return SampleAesDecrypter;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = SampleAesDecrypter;

              /***/
            },

            /***/"./src/demux/transmuxer-interface.ts":
            /*!*******************************************!*\
              !*** ./src/demux/transmuxer-interface.ts ***!
              \*******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */TransmuxerInterface
                /* harmony export */
              });
              /* harmony import */
              var _webworkify_webpack__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./webworkify-webpack */"./src/demux/webworkify-webpack.js");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../demux/transmuxer */"./src/demux/transmuxer.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/mediasource-helper */"./src/utils/mediasource-helper.ts");
              /* harmony import */
              var eventemitter3__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! eventemitter3 */"./node_modules/eventemitter3/index.js");
              var MediaSource = (0, _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_5__.getMediaSource)() || {
                isTypeSupported: function isTypeSupported() {
                  return false;
                }
              };
              var TransmuxerInterface = /*#__PURE__*/function () {
                function TransmuxerInterface(hls, id, onTransmuxComplete, onFlush) {
                  var _this = this || _global;
                  (this || _global).hls = void 0;
                  (this || _global).id = void 0;
                  (this || _global).observer = void 0;
                  (this || _global).frag = null;
                  (this || _global).part = null;
                  (this || _global).useWorker = void 0;
                  (this || _global).worker = void 0;
                  (this || _global).onwmsg = void 0;
                  (this || _global).transmuxer = null;
                  (this || _global).onTransmuxComplete = void 0;
                  (this || _global).onFlush = void 0;
                  var config = hls.config;
                  (this || _global).hls = hls;
                  (this || _global).id = id;
                  (this || _global).useWorker = !!config.enableWorker;
                  (this || _global).onTransmuxComplete = onTransmuxComplete;
                  (this || _global).onFlush = onFlush;
                  var forwardMessage = function forwardMessage(ev, data) {
                    data = data || {};
                    data.frag = _this.frag;
                    data.id = _this.id;
                    _this.hls.trigger(ev, data);
                  };

                  // forward events to main thread
                  (this || _global).observer = new eventemitter3__WEBPACK_IMPORTED_MODULE_6__.EventEmitter();
                  (this || _global).observer.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_DECRYPTED, forwardMessage);
                  (this || _global).observer.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, forwardMessage);
                  var typeSupported = {
                    mp4: MediaSource.isTypeSupported("video/mp4"),
                    mpeg: MediaSource.isTypeSupported("audio/mpeg"),
                    mp3: MediaSource.isTypeSupported("audio/mp4; codecs=\"mp3\"")
                  };
                  // navigator.vendor is not always available in Web Worker
                  // refer to https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/navigator
                  var vendor = navigator.vendor;
                  if ((this || _global).useWorker && typeof Worker !== "undefined") {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log("demuxing in webworker");
                    var worker;
                    try {
                      worker = (this || _global).worker = (0, _webworkify_webpack__WEBPACK_IMPORTED_MODULE_0__["default"])( /*require.resolve*/ /*! ../demux/transmuxer-worker.ts */"./src/demux/transmuxer-worker.ts");
                      (this || _global).onwmsg = (this || _global).onWorkerMessage.bind(this || _global);
                      worker.addEventListener("message", (this || _global).onwmsg);
                      worker.onerror = function (event) {
                        _this.useWorker = false;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Exception in webworker, fallback to inline");
                        _this.hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                          type: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorTypes.OTHER_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorDetails.INTERNAL_EXCEPTION,
                          fatal: false,
                          event: "demuxerWorker",
                          error: new Error(event.message + "  (" + event.filename + ":" + event.lineno + ")")
                        });
                      };
                      worker.postMessage({
                        cmd: "init",
                        typeSupported: typeSupported,
                        vendor: vendor,
                        id: id,
                        config: JSON.stringify(config)
                      });
                    } catch (err) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Error in worker:", err);
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.error("Error while initializing DemuxerWorker, fallback to inline");
                      if (worker) {
                        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                        self.URL.revokeObjectURL(worker.objectURL);
                      }
                      (this || _global).transmuxer = new _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__["default"]((this || _global).observer, typeSupported, config, vendor, id);
                      (this || _global).worker = null;
                    }
                  } else {
                    (this || _global).transmuxer = new _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__["default"]((this || _global).observer, typeSupported, config, vendor, id);
                  }
                }
                var _proto = TransmuxerInterface.prototype;
                _proto.destroy = function destroy() {
                  var w = (this || _global).worker;
                  if (w) {
                    w.removeEventListener("message", (this || _global).onwmsg);
                    w.terminate();
                    (this || _global).worker = null;
                    (this || _global).onwmsg = undefined;
                  } else {
                    var transmuxer = (this || _global).transmuxer;
                    if (transmuxer) {
                      transmuxer.destroy();
                      (this || _global).transmuxer = null;
                    }
                  }
                  var observer = (this || _global).observer;
                  if (observer) {
                    observer.removeAllListeners();
                  }
                  (this || _global).frag = null;
                  // @ts-ignore
                  (this || _global).observer = null;
                  // @ts-ignore
                  (this || _global).hls = null;
                };
                _proto.push = function push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
                  var _frag$initSegment,
                    _lastFrag$initSegment,
                    _this2 = this || _global;
                  chunkMeta.transmuxing.start = self.performance.now();
                  var transmuxer = (this || _global).transmuxer,
                    worker = (this || _global).worker;
                  var timeOffset = part ? part.start : frag.start;
                  var decryptdata = frag.decryptdata;
                  var lastFrag = (this || _global).frag;
                  var discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
                  var trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
                  var snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
                  var partDiff = (this || _global).part ? chunkMeta.part - (this || _global).part.index : -1;
                  var progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag === null || lastFrag === void 0 ? void 0 : lastFrag.stats.chunkCount);
                  var contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
                  var now = self.performance.now();
                  if (trackSwitch || snDiff || frag.stats.parsing.start === 0) {
                    frag.stats.parsing.start = now;
                  }
                  if (part && (partDiff || !contiguous)) {
                    part.stats.parsing.start = now;
                  }
                  var initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) === null || _frag$initSegment === void 0 ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) === null || _lastFrag$initSegment === void 0 ? void 0 : _lastFrag$initSegment.url));
                  var state = new _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__.TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
                  if (!contiguous || discontinuity || initSegmentChange) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log("[transmuxer-interface, " + frag.type + "]: Starting new transmux session for sn: " + chunkMeta.sn + " p: " + chunkMeta.part + " level: " + chunkMeta.level + " id: " + chunkMeta.id + "\n        discontinuity: " + discontinuity + "\n        trackSwitch: " + trackSwitch + "\n        contiguous: " + contiguous + "\n        accurateTimeOffset: " + accurateTimeOffset + "\n        timeOffset: " + timeOffset + "\n        initSegmentChange: " + initSegmentChange);
                    var config = new _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__.TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
                    this.configureTransmuxer(config);
                  }
                  (this || _global).frag = frag;
                  (this || _global).part = part;

                  // Frags with sn of 'initSegment' are not transmuxed
                  if (worker) {
                    // post fragment payload as transferable objects for ArrayBuffer (no copy)
                    worker.postMessage({
                      cmd: "demux",
                      data: data,
                      decryptdata: decryptdata,
                      chunkMeta: chunkMeta,
                      state: state
                    }, data instanceof ArrayBuffer ? [data] : []);
                  } else if (transmuxer) {
                    var _transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
                    if ((0, _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__.isPromise)(_transmuxResult)) {
                      _transmuxResult.then(function (data) {
                        _this2.handleTransmuxComplete(data);
                      });
                    } else {
                      this.handleTransmuxComplete(_transmuxResult);
                    }
                  }
                };
                _proto.flush = function flush(chunkMeta) {
                  var _this3 = this || _global;
                  chunkMeta.transmuxing.start = self.performance.now();
                  var transmuxer = (this || _global).transmuxer,
                    worker = (this || _global).worker;
                  if (worker) {
                    worker.postMessage({
                      cmd: "flush",
                      chunkMeta: chunkMeta
                    });
                  } else if (transmuxer) {
                    var _transmuxResult2 = transmuxer.flush(chunkMeta);
                    if ((0, _demux_transmuxer__WEBPACK_IMPORTED_MODULE_2__.isPromise)(_transmuxResult2)) {
                      _transmuxResult2.then(function (data) {
                        _this3.handleFlushResult(data, chunkMeta);
                      });
                    } else {
                      this.handleFlushResult(_transmuxResult2, chunkMeta);
                    }
                  }
                };
                _proto.handleFlushResult = function handleFlushResult(results, chunkMeta) {
                  var _this4 = this || _global;
                  results.forEach(function (result) {
                    _this4.handleTransmuxComplete(result);
                  });
                  this.onFlush(chunkMeta);
                };
                _proto.onWorkerMessage = function onWorkerMessage(ev) {
                  var data = ev.data;
                  var hls = (this || _global).hls;
                  switch (data.event) {
                    case "init":
                      {
                        // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                        self.URL.revokeObjectURL((this || _global).worker.objectURL);
                        break;
                      }
                    case "transmuxComplete":
                      {
                        this.handleTransmuxComplete(data.data);
                        break;
                      }
                    case "flush":
                      {
                        this.onFlush(data.data);
                        break;
                      }

                    // pass logs from the worker thread to the main logger
                    case "workerLog":
                      if (_utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger[data.data.logType]) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger[data.data.logType](data.data.message);
                      }
                      break;
                    default:
                      {
                        data.data = data.data || {};
                        data.data.frag = (this || _global).frag;
                        data.data.id = (this || _global).id;
                        hls.trigger(data.event, data.data);
                        break;
                      }
                  }
                };
                _proto.configureTransmuxer = function configureTransmuxer(config) {
                  var worker = (this || _global).worker,
                    transmuxer = (this || _global).transmuxer;
                  if (worker) {
                    worker.postMessage({
                      cmd: "configure",
                      config: config
                    });
                  } else if (transmuxer) {
                    transmuxer.configure(config);
                  }
                };
                _proto.handleTransmuxComplete = function handleTransmuxComplete(result) {
                  result.chunkMeta.transmuxing.end = self.performance.now();
                  this.onTransmuxComplete(result);
                };
                return TransmuxerInterface;
              }();

              /***/
            },

            /***/"./src/demux/transmuxer-worker.ts":
            /*!****************************************!*\
              !*** ./src/demux/transmuxer-worker.ts ***!
              \****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */TransmuxerWorker
                /* harmony export */
              });
              /* harmony import */
              var _demux_transmuxer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../demux/transmuxer */"./src/demux/transmuxer.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var eventemitter3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! eventemitter3 */"./node_modules/eventemitter3/index.js");
              function TransmuxerWorker(self) {
                var observer = new eventemitter3__WEBPACK_IMPORTED_MODULE_3__.EventEmitter();
                var forwardMessage = function forwardMessage(ev, data) {
                  self.postMessage({
                    event: ev,
                    data: data
                  });
                };

                // forward events to main thread
                observer.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.FRAG_DECRYPTED, forwardMessage);
                observer.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, forwardMessage);

                // forward logger events to main thread
                var forwardWorkerLogs = function forwardWorkerLogs() {
                  var _loop = function _loop(logFn) {
                    var func = function func(message) {
                      forwardMessage("workerLog", {
                        logType: logFn,
                        message: message
                      });
                    };
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger[logFn] = func;
                  };
                  for (var logFn in _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger) {
                    _loop(logFn);
                  }
                };
                self.addEventListener("message", function (ev) {
                  var data = ev.data;
                  switch (data.cmd) {
                    case "init":
                      {
                        var config = JSON.parse(data.config);
                        self.transmuxer = new _demux_transmuxer__WEBPACK_IMPORTED_MODULE_0__["default"](observer, data.typeSupported, config, data.vendor, data.id);
                        (0, _utils_logger__WEBPACK_IMPORTED_MODULE_2__.enableLogs)(config.debug, data.id);
                        forwardWorkerLogs();
                        forwardMessage("init", null);
                        break;
                      }
                    case "configure":
                      {
                        self.transmuxer.configure(data.config);
                        break;
                      }
                    case "demux":
                      {
                        var transmuxResult = self.transmuxer.push(data.data, data.decryptdata, data.chunkMeta, data.state);
                        if ((0, _demux_transmuxer__WEBPACK_IMPORTED_MODULE_0__.isPromise)(transmuxResult)) {
                          transmuxResult.then(function (data) {
                            emitTransmuxComplete(self, data);
                          });
                        } else {
                          emitTransmuxComplete(self, transmuxResult);
                        }
                        break;
                      }
                    case "flush":
                      {
                        var id = data.chunkMeta;
                        var _transmuxResult = self.transmuxer.flush(id);
                        if ((0, _demux_transmuxer__WEBPACK_IMPORTED_MODULE_0__.isPromise)(_transmuxResult)) {
                          _transmuxResult.then(function (results) {
                            handleFlushResult(self, results, id);
                          });
                        } else {
                          handleFlushResult(self, _transmuxResult, id);
                        }
                        break;
                      }
                  }
                });
              }
              function emitTransmuxComplete(self, transmuxResult) {
                if (isEmptyResult(transmuxResult.remuxResult)) {
                  return false;
                }
                var transferable = [];
                var _transmuxResult$remux = transmuxResult.remuxResult,
                  audio = _transmuxResult$remux.audio,
                  video = _transmuxResult$remux.video;
                if (audio) {
                  addToTransferable(transferable, audio);
                }
                if (video) {
                  addToTransferable(transferable, video);
                }
                self.postMessage({
                  event: "transmuxComplete",
                  data: transmuxResult
                }, transferable);
                return true;
              }

              // Converts data to a transferable object https://developers.google.com/web/updates/2011/12/Transferable-Objects-Lightning-Fast)
              // in order to minimize message passing overhead
              function addToTransferable(transferable, track) {
                if (track.data1) {
                  transferable.push(track.data1.buffer);
                }
                if (track.data2) {
                  transferable.push(track.data2.buffer);
                }
              }
              function handleFlushResult(self, results, chunkMeta) {
                var parsed = results.reduce(function (parsed, result) {
                  return emitTransmuxComplete(self, result) || parsed;
                }, false);
                if (!parsed) {
                  // Emit at least one "transmuxComplete" message even if media is not found to update stream-controller state to PARSING
                  self.postMessage({
                    event: "transmuxComplete",
                    data: results[0]
                  });
                }
                self.postMessage({
                  event: "flush",
                  data: chunkMeta
                });
              }
              function isEmptyResult(remuxResult) {
                return !remuxResult.audio && !remuxResult.video && !remuxResult.text && !remuxResult.id3 && !remuxResult.initSegment;
              }

              /***/
            },

            /***/"./src/demux/transmuxer.ts":
            /*!*********************************!*\
              !*** ./src/demux/transmuxer.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"TransmuxConfig": () => /* binding */TransmuxConfig,
                /* harmony export */"TransmuxState": () => /* binding */TransmuxState,
                /* harmony export */"default": () => /* binding */Transmuxer,
                /* harmony export */"isPromise": () => /* binding */isPromise
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _crypt_decrypter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../crypt/decrypter */"./src/crypt/decrypter.ts");
              /* harmony import */
              var _demux_aacdemuxer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../demux/aacdemuxer */"./src/demux/aacdemuxer.ts");
              /* harmony import */
              var _demux_mp4demuxer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../demux/mp4demuxer */"./src/demux/mp4demuxer.ts");
              /* harmony import */
              var _demux_tsdemuxer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../demux/tsdemuxer */"./src/demux/tsdemuxer.ts");
              /* harmony import */
              var _demux_mp3demuxer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../demux/mp3demuxer */"./src/demux/mp3demuxer.ts");
              /* harmony import */
              var _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../remux/mp4-remuxer */"./src/remux/mp4-remuxer.ts");
              /* harmony import */
              var _remux_passthrough_remuxer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../remux/passthrough-remuxer */"./src/remux/passthrough-remuxer.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var now;
              // performance.now() not available on WebWorker, at least on Safari Desktop
              try {
                now = self.performance.now.bind(self.performance);
              } catch (err) {
                _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.debug("Unable to use Performance API on this environment");
                now = self.Date.now;
              }
              var muxConfig = [{
                demux: _demux_tsdemuxer__WEBPACK_IMPORTED_MODULE_5__["default"],
                remux: _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_7__["default"]
              }, {
                demux: _demux_mp4demuxer__WEBPACK_IMPORTED_MODULE_4__["default"],
                remux: _remux_passthrough_remuxer__WEBPACK_IMPORTED_MODULE_8__["default"]
              }, {
                demux: _demux_aacdemuxer__WEBPACK_IMPORTED_MODULE_3__["default"],
                remux: _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_7__["default"]
              }, {
                demux: _demux_mp3demuxer__WEBPACK_IMPORTED_MODULE_6__["default"],
                remux: _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_7__["default"]
              }];
              var Transmuxer = /*#__PURE__*/function () {
                function Transmuxer(observer, typeSupported, config, vendor, id) {
                  (this || _global).observer = void 0;
                  (this || _global).typeSupported = void 0;
                  (this || _global).config = void 0;
                  (this || _global).vendor = void 0;
                  (this || _global).id = void 0;
                  (this || _global).demuxer = void 0;
                  (this || _global).remuxer = void 0;
                  (this || _global).decrypter = void 0;
                  (this || _global).probe = void 0;
                  (this || _global).decryptionPromise = null;
                  (this || _global).transmuxConfig = void 0;
                  (this || _global).currentTransmuxState = void 0;
                  (this || _global).observer = observer;
                  (this || _global).typeSupported = typeSupported;
                  (this || _global).config = config;
                  (this || _global).vendor = vendor;
                  (this || _global).id = id;
                }
                var _proto = Transmuxer.prototype;
                _proto.configure = function configure(transmuxConfig) {
                  (this || _global).transmuxConfig = transmuxConfig;
                  if ((this || _global).decrypter) {
                    (this || _global).decrypter.reset();
                  }
                };
                _proto.push = function push(data, decryptdata, chunkMeta, state) {
                  var _this = this || _global;
                  var stats = chunkMeta.transmuxing;
                  stats.executeStart = now();
                  var uintData = new Uint8Array(data);
                  var config = (this || _global).config,
                    currentTransmuxState = (this || _global).currentTransmuxState,
                    transmuxConfig = (this || _global).transmuxConfig;
                  if (state) {
                    (this || _global).currentTransmuxState = state;
                  }
                  var _ref = state || currentTransmuxState,
                    contiguous = _ref.contiguous,
                    discontinuity = _ref.discontinuity,
                    trackSwitch = _ref.trackSwitch,
                    accurateTimeOffset = _ref.accurateTimeOffset,
                    timeOffset = _ref.timeOffset,
                    initSegmentChange = _ref.initSegmentChange;
                  var audioCodec = transmuxConfig.audioCodec,
                    videoCodec = transmuxConfig.videoCodec,
                    defaultInitPts = transmuxConfig.defaultInitPts,
                    duration = transmuxConfig.duration,
                    initSegmentData = transmuxConfig.initSegmentData;

                  // Reset muxers before probing to ensure that their state is clean, even if flushing occurs before a successful probe
                  if (discontinuity || trackSwitch || initSegmentChange) {
                    this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration);
                  }
                  if (discontinuity || initSegmentChange) {
                    this.resetInitialTimestamp(defaultInitPts);
                  }
                  if (!contiguous) {
                    this.resetContiguity();
                  }
                  var keyData = getEncryptionType(uintData, decryptdata);
                  if (keyData && keyData.method === "AES-128") {
                    var decrypter = this.getDecrypter();
                    // Software decryption is synchronous; webCrypto is not
                    if (config.enableSoftwareAES) {
                      // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
                      // data is handled in the flush() call
                      var decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer);
                      if (!decryptedData) {
                        stats.executeEnd = now();
                        return emptyResult(chunkMeta);
                      }
                      uintData = new Uint8Array(decryptedData);
                    } else {
                      (this || _global).decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer).then(function (decryptedData) {
                        // Calling push here is important; if flush() is called while this is still resolving, this ensures that
                        // the decrypted data has been transmuxed
                        var result = _this.push(decryptedData, null, chunkMeta);
                        _this.decryptionPromise = null;
                        return result;
                      });
                      return (this || _global).decryptionPromise;
                    }
                  }
                  if (this.needsProbing(uintData, discontinuity, trackSwitch)) {
                    this.configureTransmuxer(uintData, transmuxConfig);
                  }
                  var result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
                  var currentState = (this || _global).currentTransmuxState;
                  currentState.contiguous = true;
                  currentState.discontinuity = false;
                  currentState.trackSwitch = false;
                  stats.executeEnd = now();
                  return result;
                }

                // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
                ;

                _proto.flush = function flush(chunkMeta) {
                  var _this2 = this || _global;
                  var stats = chunkMeta.transmuxing;
                  stats.executeStart = now();
                  var decrypter = (this || _global).decrypter,
                    currentTransmuxState = (this || _global).currentTransmuxState,
                    decryptionPromise = (this || _global).decryptionPromise;
                  if (decryptionPromise) {
                    // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
                    // only flushing is required for async decryption
                    return decryptionPromise.then(function () {
                      return _this2.flush(chunkMeta);
                    });
                  }
                  var transmuxResults = [];
                  var timeOffset = currentTransmuxState.timeOffset;
                  if (decrypter) {
                    // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
                    // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
                    // or for progressive downloads with small segments)
                    var decryptedData = decrypter.flush();
                    if (decryptedData) {
                      // Push always returns a TransmuxerResult if decryptdata is null
                      transmuxResults.push(this.push(decryptedData, null, chunkMeta));
                    }
                  }
                  var demuxer = (this || _global).demuxer,
                    remuxer = (this || _global).remuxer;
                  if (!demuxer || !remuxer) {
                    // If probing failed, then Hls.js has been given content its not able to handle
                    (this || _global).observer.emit(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, _events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_PARSING_ERROR,
                      fatal: true,
                      reason: "no demux matching with content found"
                    });
                    stats.executeEnd = now();
                    return [emptyResult(chunkMeta)];
                  }
                  var demuxResultOrPromise = demuxer.flush(timeOffset);
                  if (isPromise(demuxResultOrPromise)) {
                    // Decrypt final SAMPLE-AES samples
                    return demuxResultOrPromise.then(function (demuxResult) {
                      _this2.flushRemux(transmuxResults, demuxResult, chunkMeta);
                      return transmuxResults;
                    });
                  }
                  this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
                  return transmuxResults;
                };
                _proto.flushRemux = function flushRemux(transmuxResults, demuxResult, chunkMeta) {
                  var audioTrack = demuxResult.audioTrack,
                    videoTrack = demuxResult.videoTrack,
                    id3Track = demuxResult.id3Track,
                    textTrack = demuxResult.textTrack;
                  var _this$currentTransmux = (this || _global).currentTransmuxState,
                    accurateTimeOffset = _this$currentTransmux.accurateTimeOffset,
                    timeOffset = _this$currentTransmux.timeOffset;
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("[transmuxer.ts]: Flushed fragment " + chunkMeta.sn + (chunkMeta.part > -1 ? " p: " + chunkMeta.part : "") + " of level " + chunkMeta.level);
                  var remuxResult = (this || _global).remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, (this || _global).id);
                  transmuxResults.push({
                    remuxResult: remuxResult,
                    chunkMeta: chunkMeta
                  });
                  chunkMeta.transmuxing.executeEnd = now();
                };
                _proto.resetInitialTimestamp = function resetInitialTimestamp(defaultInitPts) {
                  var demuxer = (this || _global).demuxer,
                    remuxer = (this || _global).remuxer;
                  if (!demuxer || !remuxer) {
                    return;
                  }
                  demuxer.resetTimeStamp(defaultInitPts);
                  remuxer.resetTimeStamp(defaultInitPts);
                };
                _proto.resetContiguity = function resetContiguity() {
                  var demuxer = (this || _global).demuxer,
                    remuxer = (this || _global).remuxer;
                  if (!demuxer || !remuxer) {
                    return;
                  }
                  demuxer.resetContiguity();
                  remuxer.resetNextTimestamp();
                };
                _proto.resetInitSegment = function resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration) {
                  var demuxer = (this || _global).demuxer,
                    remuxer = (this || _global).remuxer;
                  if (!demuxer || !remuxer) {
                    return;
                  }
                  demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
                  remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec);
                };
                _proto.destroy = function destroy() {
                  if ((this || _global).demuxer) {
                    (this || _global).demuxer.destroy();
                    (this || _global).demuxer = undefined;
                  }
                  if ((this || _global).remuxer) {
                    (this || _global).remuxer.destroy();
                    (this || _global).remuxer = undefined;
                  }
                };
                _proto.transmux = function transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
                  var result;
                  if (keyData && keyData.method === "SAMPLE-AES") {
                    result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
                  } else {
                    result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
                  }
                  return result;
                };
                _proto.transmuxUnencrypted = function transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
                  var _demux = (this || _global).demuxer.demux(data, timeOffset, false, !(this || _global).config.progressive),
                    audioTrack = _demux.audioTrack,
                    videoTrack = _demux.videoTrack,
                    id3Track = _demux.id3Track,
                    textTrack = _demux.textTrack;
                  var remuxResult = (this || _global).remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, (this || _global).id);
                  return {
                    remuxResult: remuxResult,
                    chunkMeta: chunkMeta
                  };
                };
                _proto.transmuxSampleAes = function transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
                  var _this3 = this || _global;
                  return (this || _global).demuxer.demuxSampleAes(data, decryptData, timeOffset).then(function (demuxResult) {
                    var remuxResult = _this3.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, _this3.id);
                    return {
                      remuxResult: remuxResult,
                      chunkMeta: chunkMeta
                    };
                  });
                };
                _proto.configureTransmuxer = function configureTransmuxer(data, transmuxConfig) {
                  var config = (this || _global).config,
                    observer = (this || _global).observer,
                    typeSupported = (this || _global).typeSupported,
                    vendor = (this || _global).vendor;
                  var audioCodec = transmuxConfig.audioCodec,
                    defaultInitPts = transmuxConfig.defaultInitPts,
                    duration = transmuxConfig.duration,
                    initSegmentData = transmuxConfig.initSegmentData,
                    videoCodec = transmuxConfig.videoCodec;
                  // probe for content type
                  var mux;
                  for (var i = 0, len = muxConfig.length; i < len; i++) {
                    if (muxConfig[i].demux.probe(data)) {
                      mux = muxConfig[i];
                      break;
                    }
                  }
                  if (!mux) {
                    // If probing previous configs fail, use mp4 passthrough
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.warn("Failed to find demuxer by probing frag, treating as mp4 passthrough");
                    mux = {
                      demux: _demux_mp4demuxer__WEBPACK_IMPORTED_MODULE_4__["default"],
                      remux: _remux_passthrough_remuxer__WEBPACK_IMPORTED_MODULE_8__["default"]
                    };
                  }
                  // so let's check that current remuxer and demuxer are still valid
                  var demuxer = (this || _global).demuxer;
                  var remuxer = (this || _global).remuxer;
                  var Remuxer = mux.remux;
                  var Demuxer = mux.demux;
                  if (!remuxer || !(remuxer instanceof Remuxer)) {
                    (this || _global).remuxer = new Remuxer(observer, config, typeSupported, vendor);
                  }
                  if (!demuxer || !(demuxer instanceof Demuxer)) {
                    (this || _global).demuxer = new Demuxer(observer, config, typeSupported);
                    (this || _global).probe = Demuxer.probe;
                  }
                  // Ensure that muxers are always initialized with an initSegment
                  this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration);
                  this.resetInitialTimestamp(defaultInitPts);
                };
                _proto.needsProbing = function needsProbing(data, discontinuity, trackSwitch) {
                  // in case of continuity change, or track switch
                  // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
                  return !(this || _global).demuxer || !(this || _global).remuxer || discontinuity || trackSwitch;
                };
                _proto.getDecrypter = function getDecrypter() {
                  var decrypter = (this || _global).decrypter;
                  if (!decrypter) {
                    decrypter = (this || _global).decrypter = new _crypt_decrypter__WEBPACK_IMPORTED_MODULE_2__["default"]((this || _global).observer, (this || _global).config);
                  }
                  return decrypter;
                };
                return Transmuxer;
              }();
              function getEncryptionType(data, decryptData) {
                var encryptionType = null;
                if (data.byteLength > 0 && decryptData != null && decryptData.key != null && decryptData.iv !== null && decryptData.method != null) {
                  encryptionType = decryptData;
                }
                return encryptionType;
              }
              var emptyResult = function emptyResult(chunkMeta) {
                return {
                  remuxResult: {},
                  chunkMeta: chunkMeta
                };
              };
              function isPromise(p) {
                return "then" in p && p.then instanceof Function;
              }
              var TransmuxConfig = function TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts) {
                (this || _global).audioCodec = void 0;
                (this || _global).videoCodec = void 0;
                (this || _global).initSegmentData = void 0;
                (this || _global).duration = void 0;
                (this || _global).defaultInitPts = void 0;
                (this || _global).audioCodec = audioCodec;
                (this || _global).videoCodec = videoCodec;
                (this || _global).initSegmentData = initSegmentData;
                (this || _global).duration = duration;
                (this || _global).defaultInitPts = defaultInitPts;
              };
              var TransmuxState = function TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange) {
                (this || _global).discontinuity = void 0;
                (this || _global).contiguous = void 0;
                (this || _global).accurateTimeOffset = void 0;
                (this || _global).trackSwitch = void 0;
                (this || _global).timeOffset = void 0;
                (this || _global).initSegmentChange = void 0;
                (this || _global).discontinuity = discontinuity;
                (this || _global).contiguous = contiguous;
                (this || _global).accurateTimeOffset = accurateTimeOffset;
                (this || _global).trackSwitch = trackSwitch;
                (this || _global).timeOffset = timeOffset;
                (this || _global).initSegmentChange = initSegmentChange;
              };

              /***/
            },

            /***/"./src/demux/tsdemuxer.ts":
            /*!********************************!*\
              !*** ./src/demux/tsdemuxer.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _adts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./adts */"./src/demux/adts.ts");
              /* harmony import */
              var _mpegaudio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./mpegaudio */"./src/demux/mpegaudio.ts");
              /* harmony import */
              var _exp_golomb__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./exp-golomb */"./src/demux/exp-golomb.ts");
              /* harmony import */
              var _sample_aes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./sample-aes */"./src/demux/sample-aes.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _types_demuxer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../types/demuxer */"./src/types/demuxer.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              /**
               * highly optimized TS demuxer:
               * parse PAT, PMT
               * extract PES packet from audio and video PIDs
               * extract AVC/H264 NAL units and AAC/ADTS samples from PES packet
               * trigger the remuxer upon parsing completion
               * it also tries to workaround as best as it can audio codec switch (HE-AAC to AAC and vice versa), without having to restart the MediaSource.
               * it also controls the remuxing process :
               * upon discontinuity or level switch detection, it will also notifies the remuxer so that it can reset its state.
               */

              var PACKET_LENGTH = 188;
              var TSDemuxer = /*#__PURE__*/function () {
                function TSDemuxer(observer, config, typeSupported) {
                  (this || _global).observer = void 0;
                  (this || _global).config = void 0;
                  (this || _global).typeSupported = void 0;
                  (this || _global).sampleAes = null;
                  (this || _global).pmtParsed = false;
                  (this || _global).audioCodec = void 0;
                  (this || _global).videoCodec = void 0;
                  (this || _global)._duration = 0;
                  (this || _global)._pmtId = -1;
                  (this || _global)._avcTrack = void 0;
                  (this || _global)._audioTrack = void 0;
                  (this || _global)._id3Track = void 0;
                  (this || _global)._txtTrack = void 0;
                  (this || _global).aacOverFlow = null;
                  (this || _global).avcSample = null;
                  (this || _global).remainderData = null;
                  (this || _global).observer = observer;
                  (this || _global).config = config;
                  (this || _global).typeSupported = typeSupported;
                }
                TSDemuxer.probe = function probe(data) {
                  var syncOffset = TSDemuxer.syncOffset(data);
                  if (syncOffset > 0) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("MPEG2-TS detected but first sync word found @ offset " + syncOffset);
                  }
                  return syncOffset !== -1;
                };
                TSDemuxer.syncOffset = function syncOffset(data) {
                  var scanwindow = Math.min(PACKET_LENGTH * 5, data.length - PACKET_LENGTH * 2) + 1;
                  var i = 0;
                  while (i < scanwindow) {
                    // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
                    if (data[i] === 71 && data[i + PACKET_LENGTH] === 71) {
                      return i;
                    }
                    i++;
                  }
                  return -1;
                }

                /**
                 * Creates a track model internal to demuxer used to drive remuxing input
                 *
                 * @param type 'audio' | 'video' | 'id3' | 'text'
                 * @param duration
                 * @return TSDemuxer's internal track model
                 */;
                TSDemuxer.createTrack = function createTrack(type, duration) {
                  return {
                    container: type === "video" || type === "audio" ? "video/mp2t" : undefined,
                    type: type,
                    id: _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_5__.RemuxerTrackIdConfig[type],
                    pid: -1,
                    inputTimeScale: 90000,
                    sequenceNumber: 0,
                    samples: [],
                    dropped: 0,
                    duration: type === "audio" ? duration : undefined
                  };
                }

                /**
                 * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
                 * Resets all internal track instances of the demuxer.
                 */;
                var _proto = TSDemuxer.prototype;
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
                  (this || _global).pmtParsed = false;
                  (this || _global)._pmtId = -1;
                  (this || _global)._avcTrack = TSDemuxer.createTrack("video");
                  (this || _global)._audioTrack = TSDemuxer.createTrack("audio", trackDuration);
                  (this || _global)._id3Track = TSDemuxer.createTrack("id3");
                  (this || _global)._txtTrack = TSDemuxer.createTrack("text");
                  (this || _global)._audioTrack.segmentCodec = "aac";

                  // flush any partial content
                  (this || _global).aacOverFlow = null;
                  (this || _global).avcSample = null;
                  (this || _global).remainderData = null;
                  (this || _global).audioCodec = audioCodec;
                  (this || _global).videoCodec = videoCodec;
                  (this || _global)._duration = trackDuration;
                };
                _proto.resetTimeStamp = function resetTimeStamp() {};
                _proto.resetContiguity = function resetContiguity() {
                  var _audioTrack = (this || _global)._audioTrack,
                    _avcTrack = (this || _global)._avcTrack,
                    _id3Track = (this || _global)._id3Track;
                  if (_audioTrack) {
                    _audioTrack.pesData = null;
                  }
                  if (_avcTrack) {
                    _avcTrack.pesData = null;
                  }
                  if (_id3Track) {
                    _id3Track.pesData = null;
                  }
                  (this || _global).aacOverFlow = null;
                  (this || _global).avcSample = null;
                  (this || _global).remainderData = null;
                };
                _proto.demux = function demux(data, timeOffset, isSampleAes, flush) {
                  if (isSampleAes === void 0) {
                    isSampleAes = false;
                  }
                  if (flush === void 0) {
                    flush = false;
                  }
                  if (!isSampleAes) {
                    (this || _global).sampleAes = null;
                  }
                  var pes;
                  var videoTrack = (this || _global)._avcTrack;
                  var audioTrack = (this || _global)._audioTrack;
                  var id3Track = (this || _global)._id3Track;
                  var textTrack = (this || _global)._txtTrack;
                  var avcId = videoTrack.pid;
                  var avcData = videoTrack.pesData;
                  var audioId = audioTrack.pid;
                  var id3Id = id3Track.pid;
                  var audioData = audioTrack.pesData;
                  var id3Data = id3Track.pesData;
                  var unknownPID = null;
                  var pmtParsed = (this || _global).pmtParsed;
                  var pmtId = (this || _global)._pmtId;
                  var len = data.length;
                  if ((this || _global).remainderData) {
                    data = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_5__.appendUint8Array)((this || _global).remainderData, data);
                    len = data.length;
                    (this || _global).remainderData = null;
                  }
                  if (len < PACKET_LENGTH && !flush) {
                    (this || _global).remainderData = data;
                    return {
                      audioTrack: audioTrack,
                      videoTrack: videoTrack,
                      id3Track: id3Track,
                      textTrack: textTrack
                    };
                  }
                  var syncOffset = Math.max(0, TSDemuxer.syncOffset(data));
                  len -= (len - syncOffset) % PACKET_LENGTH;
                  if (len < data.byteLength && !flush) {
                    (this || _global).remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
                  }

                  // loop through TS packets
                  var tsPacketErrors = 0;
                  for (var start = syncOffset; start < len; start += PACKET_LENGTH) {
                    if (data[start] === 71) {
                      var stt = !!(data[start + 1] & 64);
                      // pid is a 13-bit field starting at the last bit of TS[1]
                      var pid = ((data[start + 1] & 31) << 8) + data[start + 2];
                      var atf = (data[start + 3] & 48) >> 4;

                      // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
                      var offset = void 0;
                      if (atf > 1) {
                        offset = start + 5 + data[start + 4];
                        // continue if there is only adaptation field
                        if (offset === start + PACKET_LENGTH) {
                          continue;
                        }
                      } else {
                        offset = start + 4;
                      }
                      switch (pid) {
                        case avcId:
                          if (stt) {
                            if (avcData && (pes = parsePES(avcData))) {
                              this.parseAVCPES(videoTrack, textTrack, pes, false);
                            }
                            avcData = {
                              data: [],
                              size: 0
                            };
                          }
                          if (avcData) {
                            avcData.data.push(data.subarray(offset, start + PACKET_LENGTH));
                            avcData.size += start + PACKET_LENGTH - offset;
                          }
                          break;
                        case audioId:
                          if (stt) {
                            if (audioData && (pes = parsePES(audioData))) {
                              switch (audioTrack.segmentCodec) {
                                case "aac":
                                  this.parseAACPES(audioTrack, pes);
                                  break;
                                case "mp3":
                                  this.parseMPEGPES(audioTrack, pes);
                                  break;
                              }
                            }
                            audioData = {
                              data: [],
                              size: 0
                            };
                          }
                          if (audioData) {
                            audioData.data.push(data.subarray(offset, start + PACKET_LENGTH));
                            audioData.size += start + PACKET_LENGTH - offset;
                          }
                          break;
                        case id3Id:
                          if (stt) {
                            if (id3Data && (pes = parsePES(id3Data))) {
                              this.parseID3PES(id3Track, pes);
                            }
                            id3Data = {
                              data: [],
                              size: 0
                            };
                          }
                          if (id3Data) {
                            id3Data.data.push(data.subarray(offset, start + PACKET_LENGTH));
                            id3Data.size += start + PACKET_LENGTH - offset;
                          }
                          break;
                        case 0:
                          if (stt) {
                            offset += data[offset] + 1;
                          }
                          pmtId = (this || _global)._pmtId = parsePAT(data, offset);
                          break;
                        case pmtId:
                          {
                            if (stt) {
                              offset += data[offset] + 1;
                            }
                            var parsedPIDs = parsePMT(data, offset, (this || _global).typeSupported, isSampleAes);

                            // only update track id if track PID found while parsing PMT
                            // this is to avoid resetting the PID to -1 in case
                            // track PID transiently disappears from the stream
                            // this could happen in case of transient missing audio samples for example
                            // NOTE this is only the PID of the track as found in TS,
                            // but we are not using this for MP4 track IDs.
                            avcId = parsedPIDs.avc;
                            if (avcId > 0) {
                              videoTrack.pid = avcId;
                            }
                            audioId = parsedPIDs.audio;
                            if (audioId > 0) {
                              audioTrack.pid = audioId;
                              audioTrack.segmentCodec = parsedPIDs.segmentCodec;
                            }
                            id3Id = parsedPIDs.id3;
                            if (id3Id > 0) {
                              id3Track.pid = id3Id;
                            }
                            if (unknownPID !== null && !pmtParsed) {
                              _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log("unknown PID '" + unknownPID + "' in TS found");
                              unknownPID = null;
                              // we set it to -188, the += 188 in the for loop will reset start to 0
                              start = syncOffset - 188;
                            }
                            pmtParsed = (this || _global).pmtParsed = true;
                            break;
                          }
                        case 17:
                        case 8191:
                          break;
                        default:
                          unknownPID = pid;
                          break;
                      }
                    } else {
                      tsPacketErrors++;
                    }
                  }
                  if (tsPacketErrors > 0) {
                    (this || _global).observer.emit(_events__WEBPACK_IMPORTED_MODULE_4__.Events.ERROR, _events__WEBPACK_IMPORTED_MODULE_4__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_7__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_7__.ErrorDetails.FRAG_PARSING_ERROR,
                      fatal: false,
                      reason: "Found " + tsPacketErrors + " TS packet/s that do not start with 0x47"
                    });
                  }
                  videoTrack.pesData = avcData;
                  audioTrack.pesData = audioData;
                  id3Track.pesData = id3Data;
                  var demuxResult = {
                    audioTrack: audioTrack,
                    videoTrack: videoTrack,
                    id3Track: id3Track,
                    textTrack: textTrack
                  };
                  if (flush) {
                    this.extractRemainingSamples(demuxResult);
                  }
                  return demuxResult;
                };
                _proto.flush = function flush() {
                  var remainderData = (this || _global).remainderData;
                  (this || _global).remainderData = null;
                  var result;
                  if (remainderData) {
                    result = this.demux(remainderData, -1, false, true);
                  } else {
                    result = {
                      videoTrack: (this || _global)._avcTrack,
                      audioTrack: (this || _global)._audioTrack,
                      id3Track: (this || _global)._id3Track,
                      textTrack: (this || _global)._txtTrack
                    };
                  }
                  this.extractRemainingSamples(result);
                  if ((this || _global).sampleAes) {
                    return this.decrypt(result, (this || _global).sampleAes);
                  }
                  return result;
                };
                _proto.extractRemainingSamples = function extractRemainingSamples(demuxResult) {
                  var audioTrack = demuxResult.audioTrack,
                    videoTrack = demuxResult.videoTrack,
                    id3Track = demuxResult.id3Track,
                    textTrack = demuxResult.textTrack;
                  var avcData = videoTrack.pesData;
                  var audioData = audioTrack.pesData;
                  var id3Data = id3Track.pesData;
                  // try to parse last PES packets
                  var pes;
                  if (avcData && (pes = parsePES(avcData))) {
                    this.parseAVCPES(videoTrack, textTrack, pes, true);
                    videoTrack.pesData = null;
                  } else {
                    // either avcData null or PES truncated, keep it for next frag parsing
                    videoTrack.pesData = avcData;
                  }
                  if (audioData && (pes = parsePES(audioData))) {
                    switch (audioTrack.segmentCodec) {
                      case "aac":
                        this.parseAACPES(audioTrack, pes);
                        break;
                      case "mp3":
                        this.parseMPEGPES(audioTrack, pes);
                        break;
                    }
                    audioTrack.pesData = null;
                  } else {
                    if (audioData !== null && audioData !== void 0 && audioData.size) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log("last AAC PES packet truncated,might overlap between fragments");
                    }

                    // either audioData null or PES truncated, keep it for next frag parsing
                    audioTrack.pesData = audioData;
                  }
                  if (id3Data && (pes = parsePES(id3Data))) {
                    this.parseID3PES(id3Track, pes);
                    id3Track.pesData = null;
                  } else {
                    // either id3Data null or PES truncated, keep it for next frag parsing
                    id3Track.pesData = id3Data;
                  }
                };
                _proto.demuxSampleAes = function demuxSampleAes(data, keyData, timeOffset) {
                  var demuxResult = this.demux(data, timeOffset, true, !(this || _global).config.progressive);
                  var sampleAes = (this || _global).sampleAes = new _sample_aes__WEBPACK_IMPORTED_MODULE_3__["default"]((this || _global).observer, (this || _global).config, keyData);
                  return this.decrypt(demuxResult, sampleAes);
                };
                _proto.decrypt = function decrypt(demuxResult, sampleAes) {
                  return new Promise(function (resolve) {
                    var audioTrack = demuxResult.audioTrack,
                      videoTrack = demuxResult.videoTrack;
                    if (audioTrack.samples && audioTrack.segmentCodec === "aac") {
                      sampleAes.decryptAacSamples(audioTrack.samples, 0, function () {
                        if (videoTrack.samples) {
                          sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
                            resolve(demuxResult);
                          });
                        } else {
                          resolve(demuxResult);
                        }
                      });
                    } else if (videoTrack.samples) {
                      sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, function () {
                        resolve(demuxResult);
                      });
                    }
                  });
                };
                _proto.destroy = function destroy() {
                  (this || _global)._duration = 0;
                };
                _proto.parseAVCPES = function parseAVCPES(track, textTrack, pes, last) {
                  var _this = this || _global;
                  var units = this.parseAVCNALu(track, pes.data);
                  var avcSample = (this || _global).avcSample;
                  var push;
                  var spsfound = false;
                  // free pes.data to save up some memory
                  pes.data = null;

                  // if new NAL units found and last sample still there, let's push ...
                  // this helps parsing streams with missing AUD (only do this if AUD never found)
                  if (avcSample && units.length && !track.audFound) {
                    pushAccessUnit(avcSample, track);
                    avcSample = (this || _global).avcSample = createAVCSample(false, pes.pts, pes.dts, "");
                  }
                  units.forEach(function (unit) {
                    switch (unit.type) {
                      // NDR
                      case 1:
                        {
                          push = true;
                          if (!avcSample) {
                            avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, "");
                          }
                          avcSample.frame = true;
                          var data = unit.data;
                          // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                          if (spsfound && data.length > 4) {
                            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                            var sliceType = new _exp_golomb__WEBPACK_IMPORTED_MODULE_2__["default"](data).readSliceType();
                            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                            // if (sliceType === 2 || sliceType === 7) {
                            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) {
                              avcSample.key = true;
                            }
                          }
                          break;
                          // IDR
                        }

                      case 5:
                        push = true;
                        // handle PES not starting with AUD
                        if (!avcSample) {
                          avcSample = _this.avcSample = createAVCSample(true, pes.pts, pes.dts, "");
                        }
                        avcSample.key = true;
                        avcSample.frame = true;
                        break;
                      // SEI
                      case 6:
                        {
                          push = true;
                          (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_5__.parseSEIMessageFromNALu)(unit.data, 1, pes.pts, textTrack.samples);
                          break;
                          // SPS
                        }

                      case 7:
                        push = true;
                        spsfound = true;
                        if (!track.sps) {
                          var expGolombDecoder = new _exp_golomb__WEBPACK_IMPORTED_MODULE_2__["default"](unit.data);
                          var config = expGolombDecoder.readSPS();
                          track.width = config.width;
                          track.height = config.height;
                          track.pixelRatio = config.pixelRatio;
                          // TODO: `track.sps` is defined as a `number[]`, but we're setting it to a `Uint8Array[]`.
                          track.sps = [unit.data];
                          track.duration = _this._duration;
                          var codecarray = unit.data.subarray(1, 4);
                          var codecstring = "avc1.";
                          for (var i = 0; i < 3; i++) {
                            var h = codecarray[i].toString(16);
                            if (h.length < 2) {
                              h = "0" + h;
                            }
                            codecstring += h;
                          }
                          track.codec = codecstring;
                        }
                        break;
                      // PPS
                      case 8:
                        push = true;
                        if (!track.pps) {
                          // TODO: `track.pss` is defined as a `number[]`, but we're setting it to a `Uint8Array[]`.
                          track.pps = [unit.data];
                        }
                        break;
                      // AUD
                      case 9:
                        push = false;
                        track.audFound = true;
                        if (avcSample) {
                          pushAccessUnit(avcSample, track);
                        }
                        avcSample = _this.avcSample = createAVCSample(false, pes.pts, pes.dts, "");
                        break;
                      // Filler Data
                      case 12:
                        push = true;
                        break;
                      default:
                        push = false;
                        if (avcSample) {
                          avcSample.debug += "unknown NAL " + unit.type + " ";
                        }
                        break;
                    }
                    if (avcSample && push) {
                      var _units = avcSample.units;
                      _units.push(unit);
                    }
                  });
                  // if last PES packet, push samples
                  if (last && avcSample) {
                    pushAccessUnit(avcSample, track);
                    (this || _global).avcSample = null;
                  }
                };
                _proto.getLastNalUnit = function getLastNalUnit(samples) {
                  var _avcSample;
                  var avcSample = (this || _global).avcSample;
                  var lastUnit;
                  // try to fallback to previous sample if current one is empty
                  if (!avcSample || avcSample.units.length === 0) {
                    avcSample = samples[samples.length - 1];
                  }
                  if ((_avcSample = avcSample) !== null && _avcSample !== void 0 && _avcSample.units) {
                    var units = avcSample.units;
                    lastUnit = units[units.length - 1];
                  }
                  return lastUnit;
                };
                _proto.parseAVCNALu = function parseAVCNALu(track, array) {
                  var len = array.byteLength;
                  var state = track.naluState || 0;
                  var lastState = state;
                  var units = [];
                  var i = 0;
                  var value;
                  var overflow;
                  var unitType;
                  var lastUnitStart = -1;
                  var lastUnitType = 0;
                  // logger.log('PES:' + Hex.hexDump(array));

                  if (state === -1) {
                    // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
                    lastUnitStart = 0;
                    // NALu type is value read from offset 0
                    lastUnitType = array[0] & 31;
                    state = 0;
                    i = 1;
                  }
                  while (i < len) {
                    value = array[i++];
                    // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
                    if (!state) {
                      state = value ? 0 : 1;
                      continue;
                    }
                    if (state === 1) {
                      state = value ? 0 : 2;
                      continue;
                    }
                    // here we have state either equal to 2 or 3
                    if (!value) {
                      state = 3;
                    } else if (value === 1) {
                      if (lastUnitStart >= 0) {
                        var unit = {
                          data: array.subarray(lastUnitStart, i - state - 1),
                          type: lastUnitType
                        };
                        // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                        units.push(unit);
                      } else {
                        // lastUnitStart is undefined => this is the first start code found in this PES packet
                        // first check if start code delimiter is overlapping between 2 PES packets,
                        // ie it started in last packet (lastState not zero)
                        // and ended at the beginning of this PES packet (i <= 4 - lastState)
                        var lastUnit = this.getLastNalUnit(track.samples);
                        if (lastUnit) {
                          if (lastState && i <= 4 - lastState) {
                            // start delimiter overlapping between PES packets
                            // strip start delimiter bytes from the end of last NAL unit
                            // check if lastUnit had a state different from zero
                            if (lastUnit.state) {
                              // strip last bytes
                              lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                            }
                          }
                          // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                          overflow = i - state - 1;
                          if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            var tmp = new Uint8Array(lastUnit.data.byteLength + overflow);
                            tmp.set(lastUnit.data, 0);
                            tmp.set(array.subarray(0, overflow), lastUnit.data.byteLength);
                            lastUnit.data = tmp;
                            lastUnit.state = 0;
                          }
                        }
                      }
                      // check if we can read unit type
                      if (i < len) {
                        unitType = array[i] & 31;
                        // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                        lastUnitStart = i;
                        lastUnitType = unitType;
                        state = 0;
                      } else {
                        // not enough byte to read unit type. let's read it on next PES parsing
                        state = -1;
                      }
                    } else {
                      state = 0;
                    }
                  }
                  if (lastUnitStart >= 0 && state >= 0) {
                    var _unit = {
                      data: array.subarray(lastUnitStart, len),
                      type: lastUnitType,
                      state: state
                    };
                    units.push(_unit);
                    // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
                  }
                  // no NALu found
                  if (units.length === 0) {
                    // append pes.data to previous NAL unit
                    var _lastUnit = this.getLastNalUnit(track.samples);
                    if (_lastUnit) {
                      var _tmp = new Uint8Array(_lastUnit.data.byteLength + array.byteLength);
                      _tmp.set(_lastUnit.data, 0);
                      _tmp.set(array, _lastUnit.data.byteLength);
                      _lastUnit.data = _tmp;
                    }
                  }
                  track.naluState = state;
                  return units;
                };
                _proto.parseAACPES = function parseAACPES(track, pes) {
                  var startOffset = 0;
                  var aacOverFlow = (this || _global).aacOverFlow;
                  var data = pes.data;
                  if (aacOverFlow) {
                    (this || _global).aacOverFlow = null;
                    var frameMissingBytes = aacOverFlow.missing;
                    var sampleLength = aacOverFlow.sample.unit.byteLength;
                    // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
                    if (frameMissingBytes === -1) {
                      var tmp = new Uint8Array(sampleLength + data.byteLength);
                      tmp.set(aacOverFlow.sample.unit, 0);
                      tmp.set(data, sampleLength);
                      data = tmp;
                    } else {
                      var frameOverflowBytes = sampleLength - frameMissingBytes;
                      aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
                      track.samples.push(aacOverFlow.sample);
                      startOffset = aacOverFlow.missing;
                    }
                  }
                  // look for ADTS header (0xFFFx)
                  var offset;
                  var len;
                  for (offset = startOffset, len = data.length; offset < len - 1; offset++) {
                    if (_adts__WEBPACK_IMPORTED_MODULE_0__.isHeader(data, offset)) {
                      break;
                    }
                  }
                  // if ADTS header does not start straight from the beginning of the PES payload, raise an error
                  if (offset !== startOffset) {
                    var reason;
                    var fatal;
                    if (offset < len - 1) {
                      reason = "AAC PES did not start with ADTS header,offset:" + offset;
                      fatal = false;
                    } else {
                      reason = "no ADTS header found in AAC PES";
                      fatal = true;
                    }
                    _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("parsing error:" + reason);
                    (this || _global).observer.emit(_events__WEBPACK_IMPORTED_MODULE_4__.Events.ERROR, _events__WEBPACK_IMPORTED_MODULE_4__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_7__.ErrorTypes.MEDIA_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_7__.ErrorDetails.FRAG_PARSING_ERROR,
                      fatal: fatal,
                      reason: reason
                    });
                    if (fatal) {
                      return;
                    }
                  }
                  _adts__WEBPACK_IMPORTED_MODULE_0__.initTrackConfig(track, (this || _global).observer, data, offset, (this || _global).audioCodec);
                  var pts;
                  if (pes.pts !== undefined) {
                    pts = pes.pts;
                  } else if (aacOverFlow) {
                    // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
                    // first sample PTS should be equal to last sample PTS + frameDuration
                    var frameDuration = _adts__WEBPACK_IMPORTED_MODULE_0__.getFrameDuration(track.samplerate);
                    pts = aacOverFlow.sample.pts + frameDuration;
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
                    return;
                  }

                  // scan for aac samples
                  var frameIndex = 0;
                  var frame;
                  while (offset < len) {
                    frame = _adts__WEBPACK_IMPORTED_MODULE_0__.appendFrame(track, data, offset, pts, frameIndex);
                    offset += frame.length;
                    if (!frame.missing) {
                      frameIndex++;
                      for (; offset < len - 1; offset++) {
                        if (_adts__WEBPACK_IMPORTED_MODULE_0__.isHeader(data, offset)) {
                          break;
                        }
                      }
                    } else {
                      (this || _global).aacOverFlow = frame;
                      break;
                    }
                  }
                };
                _proto.parseMPEGPES = function parseMPEGPES(track, pes) {
                  var data = pes.data;
                  var length = data.length;
                  var frameIndex = 0;
                  var offset = 0;
                  var pts = pes.pts;
                  if (pts === undefined) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
                    return;
                  }
                  while (offset < length) {
                    if (_mpegaudio__WEBPACK_IMPORTED_MODULE_1__.isHeader(data, offset)) {
                      var frame = _mpegaudio__WEBPACK_IMPORTED_MODULE_1__.appendFrame(track, data, offset, pts, frameIndex);
                      if (frame) {
                        offset += frame.length;
                        frameIndex++;
                      } else {
                        // logger.log('Unable to parse Mpeg audio frame');
                        break;
                      }
                    } else {
                      // nothing found, keep looking
                      offset++;
                    }
                  }
                };
                _proto.parseID3PES = function parseID3PES(id3Track, pes) {
                  if (pes.pts === undefined) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
                    return;
                  }
                  var id3Sample = _extends({}, pes, {
                    type: (this || _global)._avcTrack ? _types_demuxer__WEBPACK_IMPORTED_MODULE_8__.MetadataSchema.emsg : _types_demuxer__WEBPACK_IMPORTED_MODULE_8__.MetadataSchema.audioId3,
                    duration: Number.POSITIVE_INFINITY
                  });
                  id3Track.samples.push(id3Sample);
                };
                return TSDemuxer;
              }();
              function createAVCSample(key, pts, dts, debug) {
                return {
                  key: key,
                  frame: false,
                  pts: pts,
                  dts: dts,
                  units: [],
                  debug: debug,
                  length: 0
                };
              }
              function parsePAT(data, offset) {
                // skip the PSI header and parse the first PMT entry
                return (data[offset + 10] & 31) << 8 | data[offset + 11];
                // logger.log('PMT PID:'  + this._pmtId);
              }

              function parsePMT(data, offset, typeSupported, isSampleAes) {
                var result = {
                  audio: -1,
                  avc: -1,
                  id3: -1,
                  segmentCodec: "aac"
                };
                var sectionLength = (data[offset + 1] & 15) << 8 | data[offset + 2];
                var tableEnd = offset + 3 + sectionLength - 4;
                // to determine where the table is, we have to figure out how
                // long the program info descriptors are
                var programInfoLength = (data[offset + 10] & 15) << 8 | data[offset + 11];
                // advance the offset to the first entry in the mapping table
                offset += 12 + programInfoLength;
                while (offset < tableEnd) {
                  var pid = (data[offset + 1] & 31) << 8 | data[offset + 2];
                  switch (data[offset]) {
                    case 207:
                      // SAMPLE-AES AAC
                      if (!isSampleAes) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log("ADTS AAC with AES-128-CBC frame encryption found in unencrypted stream");
                        break;
                      }
                    /* falls through */
                    case 15:
                      // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                      // logger.log('AAC PID:'  + pid);
                      if (result.audio === -1) {
                        result.audio = pid;
                      }
                      break;

                    // Packetized metadata (ID3)
                    case 21:
                      // logger.log('ID3 PID:'  + pid);
                      if (result.id3 === -1) {
                        result.id3 = pid;
                      }
                      break;
                    case 219:
                      // SAMPLE-AES AVC
                      if (!isSampleAes) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log("H.264 with AES-128-CBC slice encryption found in unencrypted stream");
                        break;
                      }
                    /* falls through */
                    case 27:
                      // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                      // logger.log('AVC PID:'  + pid);
                      if (result.avc === -1) {
                        result.avc = pid;
                      }
                      break;

                    // ISO/IEC 11172-3 (MPEG-1 audio)
                    // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
                    case 3:
                    case 4:
                      // logger.log('MPEG PID:'  + pid);
                      if (typeSupported.mpeg !== true && typeSupported.mp3 !== true) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log("MPEG audio found, not supported in this browser");
                      } else if (result.audio === -1) {
                        result.audio = pid;
                        result.segmentCodec = "mp3";
                      }
                      break;
                    case 36:
                      _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn("Unsupported HEVC stream type found");
                      break;
                  }
                  // move to the next table entry
                  // skip past the elementary stream descriptors, if present
                  offset += ((data[offset + 3] & 15) << 8 | data[offset + 4]) + 5;
                }
                return result;
              }
              function parsePES(stream) {
                var i = 0;
                var frag;
                var pesLen;
                var pesHdrLen;
                var pesPts;
                var pesDts;
                var data = stream.data;
                // safety check
                if (!stream || stream.size === 0) {
                  return null;
                }

                // we might need up to 19 bytes to read PES header
                // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
                // usually only one merge is needed (and this is rare ...)
                while (data[0].length < 19 && data.length > 1) {
                  var newData = new Uint8Array(data[0].length + data[1].length);
                  newData.set(data[0]);
                  newData.set(data[1], data[0].length);
                  data[0] = newData;
                  data.splice(1, 1);
                }
                // retrieve PTS/DTS from first fragment
                frag = data[0];
                var pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
                if (pesPrefix === 1) {
                  pesLen = (frag[4] << 8) + frag[5];
                  // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
                  // minus 6 : PES header size
                  if (pesLen && pesLen > stream.size - 6) {
                    return null;
                  }
                  var pesFlags = frag[7];
                  if (pesFlags & 192) {
                    /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
                        as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
                        as Bitwise operators treat their operands as a sequence of 32 bits */
                    pesPts = (frag[9] & 14) * 536870912 +
                    // 1 << 29
                    (frag[10] & 255) * 4194304 +
                    // 1 << 22
                    (frag[11] & 254) * 16384 +
                    // 1 << 14
                    (frag[12] & 255) * 128 +
                    // 1 << 7
                    (frag[13] & 254) / 2;
                    if (pesFlags & 64) {
                      pesDts = (frag[14] & 14) * 536870912 +
                      // 1 << 29
                      (frag[15] & 255) * 4194304 +
                      // 1 << 22
                      (frag[16] & 254) * 16384 +
                      // 1 << 14
                      (frag[17] & 255) * 128 +
                      // 1 << 7
                      (frag[18] & 254) / 2;
                      if (pesPts - pesDts > 60 * 90000) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.warn(Math.round((pesPts - pesDts) / 90000) + "s delta between PTS and DTS, align them");
                        pesPts = pesDts;
                      }
                    } else {
                      pesDts = pesPts;
                    }
                  }
                  pesHdrLen = frag[8];
                  // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
                  var payloadStartOffset = pesHdrLen + 9;
                  if (stream.size <= payloadStartOffset) {
                    return null;
                  }
                  stream.size -= payloadStartOffset;
                  // reassemble PES packet
                  var pesData = new Uint8Array(stream.size);
                  for (var j = 0, dataLen = data.length; j < dataLen; j++) {
                    frag = data[j];
                    var len = frag.byteLength;
                    if (payloadStartOffset) {
                      if (payloadStartOffset > len) {
                        // trim full frag if PES header bigger than frag
                        payloadStartOffset -= len;
                        continue;
                      } else {
                        // trim partial frag if PES header smaller than frag
                        frag = frag.subarray(payloadStartOffset);
                        len -= payloadStartOffset;
                        payloadStartOffset = 0;
                      }
                    }
                    pesData.set(frag, i);
                    i += len;
                  }
                  if (pesLen) {
                    // payload size : remove PES header + PES extension
                    pesLen -= pesHdrLen + 3;
                  }
                  return {
                    data: pesData,
                    pts: pesPts,
                    dts: pesDts,
                    len: pesLen
                  };
                }
                return null;
              }
              function pushAccessUnit(avcSample, avcTrack) {
                if (avcSample.units.length && avcSample.frame) {
                  // if sample does not have PTS/DTS, patch with last sample PTS/DTS
                  if (avcSample.pts === undefined) {
                    var samples = avcTrack.samples;
                    var nbSamples = samples.length;
                    if (nbSamples) {
                      var lastSample = samples[nbSamples - 1];
                      avcSample.pts = lastSample.pts;
                      avcSample.dts = lastSample.dts;
                    } else {
                      // dropping samples, no timestamp found
                      avcTrack.dropped++;
                      return;
                    }
                  }
                  avcTrack.samples.push(avcSample);
                }
                if (avcSample.debug.length) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_6__.logger.log(avcSample.pts + "/" + avcSample.dts + ":" + avcSample.debug);
                }
              }
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = TSDemuxer;

              /***/
            },

            /***/"./src/demux/webworkify-webpack.js":
            /*!*****************************************!*\
              !*** ./src/demux/webworkify-webpack.js ***!
              \*****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* export default binding */__WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /*
               * Fork of webworkify-webpack with support for Webpack 5
               * https://github.com/wupeng-engineer/webworkify-webpack/blob/db0de7/index.js
              */

              var webpackBootstrapFunc = function webpackBootstrapFunc() {
                // webpackBootstrap
                /******/
                var __webpack_modules__ = ENTRY_MODULE;
                /************************************************************************/
                /******/ // The module cache
                /******/
                var __webpack_module_cache__ = {};
                /******/
                /******/ // The require function
                /******/
                var __nested_webpack_require_497__ = function __webpack_require__(moduleId) {
                  /******/ // Check if module is in cache
                  /******/var cachedModule = __webpack_module_cache__[moduleId];
                  /******/
                  if (cachedModule !== undefined) {
                    /******/return cachedModule.exports;
                    /******/
                  }
                  /******/ // Create a new module (and put it into the cache)
                  /******/
                  var module = __webpack_module_cache__[moduleId] = {
                    /******/ // no module.id needed
                    /******/ // no module.loaded needed
                    /******/exports: {}
                    /******/
                  };
                  /******/
                  /******/ // Execute the module function
                  /******/
                  __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                  /******/
                  /******/ // Return the exports of the module
                  /******/
                  return module.exports;
                  /******/
                };
                /******/
                /******/ // expose the modules object (__webpack_modules__)
                /******/
                __nested_webpack_require_497__.m = __webpack_modules__;
                /******/
                /************************************************************************/
                /******/ /* webpack/runtime/compat get default export */
                /******/
                (function () {
                  /******/ // getDefaultExport function for compatibility with non-harmony modules
                  /******/__nested_webpack_require_497__.n = function (module) {
                    /******/var getter = module && module.__esModule ? /******/function () {
                      return module["default"];
                    } : /******/function () {
                      return module;
                    };
                    /******/
                    __nested_webpack_require_497__.d(getter, {
                      a: getter
                    });
                    /******/
                    return getter;
                    /******/
                  };
                  /******/
                })();
                /******/
                /******/ /* webpack/runtime/define property getters */
                /******/
                (function () {
                  /******/ // define getter functions for harmony exports
                  /******/__nested_webpack_require_497__.d = function (exports, definition) {
                    /******/for (var key in definition) {
                      /******/if (__nested_webpack_require_497__.o(definition, key) && !__nested_webpack_require_497__.o(exports, key)) {
                        /******/Object.defineProperty(exports, key, {
                          enumerable: true,
                          get: definition[key]
                        });
                        /******/
                      }
                      /******/
                    }
                    /******/
                  };
                  /******/
                })();
                /******/
                /******/ /* webpack/runtime/hasOwnProperty shorthand */
                /******/
                (function () {
                  /******/__nested_webpack_require_497__.o = function (obj, prop) {
                    return Object.prototype.hasOwnProperty.call(obj, prop);
                  };
                  /******/
                })();
                /******/
                /******/ /* webpack/runtime/make namespace object */
                /******/
                (function () {
                  /******/ // define __esModule on exports
                  /******/__nested_webpack_require_497__.r = function (exports) {
                    /******/if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                      /******/Object.defineProperty(exports, Symbol.toStringTag, {
                        value: "Module"
                      });
                      /******/
                    }
                    /******/
                    Object.defineProperty(exports, "__esModule", {
                      value: true
                    });
                    /******/
                  };
                  /******/
                })();
                /******/
                /************************************************************************/
                /******/
                /******/ // module factories are used so entry inlining is disabled
                /******/ // startup
                /******/ // Load entry module and return exports
                /******/
                var result = __nested_webpack_require_497__(ENTRY_MODULE);
                /******/
                return result.default || result;
              };
              var webpackBootstrapFuncArr = webpackBootstrapFunc.toString().split("ENTRY_MODULE");
              var moduleNameReqExp = "[\\.|\\-|\\+|\\w|/|@]+";
              var dependencyRegExp = "\\(\\s*(/\\*.*?\\*/)?\\s*.*?(" + moduleNameReqExp + ").*?\\)";
              function quoteRegExp(str) {
                return (str + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
              }
              function isNumeric(n) {
                return !isNaN(1 * n);
              }
              function getModuleDependencies(sources, module, queueName) {
                var retval = {};
                retval[queueName] = [];
                var fnString = module.toString().replace(/^"[^"]+"/, "function");
                var wrapperSignature = fnString.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/) || fnString.match(/^\(\w+,\s*\w+,\s*(\w+)\)\s?\=\s?\>/);
                if (!wrapperSignature) return retval;
                var webpackRequireName = wrapperSignature[1];
                var re = new RegExp("(\\\\n|\\W)" + quoteRegExp(webpackRequireName) + dependencyRegExp, "g");
                var match;
                while (match = re.exec(fnString)) {
                  if (match[3] === "dll-reference") continue;
                  retval[queueName].push(match[3]);
                }
                re = new RegExp("\\(" + quoteRegExp(webpackRequireName) + "\\(\"(dll-reference\\s(" + moduleNameReqExp + "))\"\\)\\)" + dependencyRegExp, "g");
                while (match = re.exec(fnString)) {
                  if (!sources[match[2]]) {
                    retval[queueName].push(match[1]);
                    sources[match[2]] = __webpack_require__(match[1]).m;
                  }
                  retval[match[2]] = retval[match[2]] || [];
                  retval[match[2]].push(match[4]);
                }
                var keys = Object.keys(retval);
                for (var i = 0; i < keys.length; i++) {
                  for (var j = 0; j < retval[keys[i]].length; j++) {
                    if (isNumeric(retval[keys[i]][j])) {
                      retval[keys[i]][j] = 1 * retval[keys[i]][j];
                    }
                  }
                }
                return retval;
              }
              function hasValuesInQueues(queues) {
                var keys = Object.keys(queues);
                return keys.reduce(function (hasValues, key) {
                  return hasValues || queues[key].length > 0;
                }, false);
              }
              function getRequiredModules(sources, moduleId) {
                var modulesQueue = {
                  main: [moduleId]
                };
                var requiredModules = {
                  main: []
                };
                var seenModules = {
                  main: {}
                };
                while (hasValuesInQueues(modulesQueue)) {
                  var queues = Object.keys(modulesQueue);
                  for (var i = 0; i < queues.length; i++) {
                    var queueName = queues[i];
                    var queue = modulesQueue[queueName];
                    var moduleToCheck = queue.pop();
                    seenModules[queueName] = seenModules[queueName] || {};
                    if (seenModules[queueName][moduleToCheck] || !sources[queueName][moduleToCheck]) continue;
                    seenModules[queueName][moduleToCheck] = true;
                    requiredModules[queueName] = requiredModules[queueName] || [];
                    requiredModules[queueName].push(moduleToCheck);
                    var newModules = getModuleDependencies(sources, sources[queueName][moduleToCheck], queueName);
                    var newModulesKeys = Object.keys(newModules);
                    for (var j = 0; j < newModulesKeys.length; j++) {
                      modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]] || [];
                      modulesQueue[newModulesKeys[j]] = modulesQueue[newModulesKeys[j]].concat(newModules[newModulesKeys[j]]);
                    }
                  }
                }
                return requiredModules;
              }
              function getWebpackString(requiredModules, sources, entryModule, key) {
                var moduleString = requiredModules[key].map(function (id) {
                  return "\"" + id + "\": " + sources[key][id].toString().replace(/^"[^"]+"/, "function");
                }).join(",");
                return webpackBootstrapFuncArr[0] + "{" + moduleString + "}" + webpackBootstrapFuncArr[1] + "\"" + entryModule + "\"" + webpackBootstrapFuncArr[2];
              }
              /* harmony default export */
              function __WEBPACK_DEFAULT_EXPORT__(moduleId, options) {
                options = options || {};
                var sources = {
                  main: __webpack_require__.m
                };
                var requiredModules = options.all ? {
                  main: Object.keys(sources.main)
                } : getRequiredModules(sources, moduleId);
                var src = "";
                Object.keys(requiredModules).filter(function (m) {
                  return m !== "main";
                }).forEach(function (module) {
                  var entryModule = 0;
                  while (requiredModules[module][entryModule]) {
                    entryModule++;
                  }
                  requiredModules[module].push(entryModule);
                  sources[module][entryModule] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })";
                  src = src + ("var " + module + " = (" + getWebpackString(requiredModules, sources, entryModule, modules) + ")();\n");
                });
                src = src + ("new ((" + getWebpackString(requiredModules, sources, moduleId, "main") + ")())(self);");
                var blob = new window.Blob([src], {
                  type: "text/javascript"
                });
                var URL = window.URL || window.webkitURL || window.mozURL || window.msURL;
                var workerUrl = URL.createObjectURL(blob);
                var worker = new window.Worker(workerUrl);
                worker.objectURL = workerUrl;
                return worker;
              }

              /***/
            },

            /***/"./src/errors.ts":
            /*!***********************!*\
              !*** ./src/errors.ts ***!
              \***********************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"ErrorDetails": () => /* binding */ErrorDetails,
                /* harmony export */"ErrorTypes": () => /* binding */ErrorTypes
                /* harmony export */
              });
              var ErrorTypes;

              /**
               * @enum {ErrorDetails}
               * @typedef {string} ErrorDetail
               */
              (function (ErrorTypes) {
                ErrorTypes["NETWORK_ERROR"] = "networkError";
                ErrorTypes["MEDIA_ERROR"] = "mediaError";
                ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
                ErrorTypes["MUX_ERROR"] = "muxError";
                ErrorTypes["OTHER_ERROR"] = "otherError";
              })(ErrorTypes || (ErrorTypes = {}));
              var ErrorDetails;
              (function (ErrorDetails) {
                ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
                ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
                ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
                ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
                ErrorDetails["KEY_SYSTEM_NO_INIT_DATA"] = "keySystemNoInitData";
                ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
                ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
                ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
                ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
                ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
                ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
                ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
                ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
                ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
                ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
                ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
                ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
                ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
                ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
                ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
                ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
                ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
                ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
                ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
                ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
                ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
                ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
                ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
                ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
                ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
                ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
                ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
                ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
                ErrorDetails["INTERNAL_ABORTED"] = "aborted";
                ErrorDetails["UNKNOWN"] = "unknown";
              })(ErrorDetails || (ErrorDetails = {}));

              /***/
            },

            /***/"./src/events.ts":
            /*!***********************!*\
              !*** ./src/events.ts ***!
              \***********************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"Events": () => /* binding */Events
                /* harmony export */
              });
              /**
               * @readonly
               * @enum {string}
               */
              var Events;
              (function (Events) {
                Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
                Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
                Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
                Events["MEDIA_DETACHED"] = "hlsMediaDetached";
                Events["BUFFER_RESET"] = "hlsBufferReset";
                Events["BUFFER_CODECS"] = "hlsBufferCodecs";
                Events["BUFFER_CREATED"] = "hlsBufferCreated";
                Events["BUFFER_APPENDING"] = "hlsBufferAppending";
                Events["BUFFER_APPENDED"] = "hlsBufferAppended";
                Events["BUFFER_EOS"] = "hlsBufferEos";
                Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
                Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
                Events["MANIFEST_LOADING"] = "hlsManifestLoading";
                Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
                Events["MANIFEST_PARSED"] = "hlsManifestParsed";
                Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
                Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
                Events["LEVEL_LOADING"] = "hlsLevelLoading";
                Events["LEVEL_LOADED"] = "hlsLevelLoaded";
                Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
                Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
                Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
                Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
                Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
                Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
                Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
                Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
                Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
                Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
                Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
                Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
                Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
                Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
                Events["CUES_PARSED"] = "hlsCuesParsed";
                Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
                Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
                Events["FRAG_LOADING"] = "hlsFragLoading";
                Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
                Events["FRAG_LOADED"] = "hlsFragLoaded";
                Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
                Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
                Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
                Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
                Events["FRAG_PARSED"] = "hlsFragParsed";
                Events["FRAG_BUFFERED"] = "hlsFragBuffered";
                Events["FRAG_CHANGED"] = "hlsFragChanged";
                Events["FPS_DROP"] = "hlsFpsDrop";
                Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
                Events["ERROR"] = "hlsError";
                Events["DESTROYING"] = "hlsDestroying";
                Events["KEY_LOADING"] = "hlsKeyLoading";
                Events["KEY_LOADED"] = "hlsKeyLoaded";
                Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
                Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
              })(Events || (Events = {}));

              /***/
            },

            /***/"./src/hls.ts":
            /*!********************!*\
              !*** ./src/hls.ts ***!
              \********************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */Hls
                /* harmony export */
              });
              /* harmony import */
              var url_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! url-toolkit */"./node_modules/url-toolkit/src/url-toolkit.js");
              /* harmony import */
              var _loader_playlist_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./loader/playlist-loader */"./src/loader/playlist-loader.ts");
              /* harmony import */
              var _loader_key_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./loader/key-loader */"./src/loader/key-loader.ts");
              /* harmony import */
              var _controller_id3_track_controller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./controller/id3-track-controller */"./src/controller/id3-track-controller.ts");
              /* harmony import */
              var _controller_latency_controller__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./controller/latency-controller */"./src/controller/latency-controller.ts");
              /* harmony import */
              var _controller_level_controller__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./controller/level-controller */"./src/controller/level-controller.ts");
              /* harmony import */
              var _controller_fragment_tracker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ./controller/fragment-tracker */"./src/controller/fragment-tracker.ts");
              /* harmony import */
              var _controller_stream_controller__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ./controller/stream-controller */"./src/controller/stream-controller.ts");
              /* harmony import */
              var _is_supported__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ./is-supported */"./src/is-supported.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__( /*! ./utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__( /*! ./config */"./src/config.ts");
              /* harmony import */
              var eventemitter3__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__( /*! eventemitter3 */"./node_modules/eventemitter3/index.js");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__( /*! ./events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__( /*! ./errors */"./src/errors.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }

              /**
               * @module Hls
               * @class
               * @constructor
               */
              var Hls = /*#__PURE__*/function () {
                Hls.isSupported = function isSupported() {
                  return (0, _is_supported__WEBPACK_IMPORTED_MODULE_8__.isSupported)();
                };
                /**
                 * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
                 *
                 * @constructs Hls
                 * @param {HlsConfig} config
                 */
                function Hls(userConfig) {
                  if (userConfig === void 0) {
                    userConfig = {};
                  }
                  (this || _global).config = void 0;
                  (this || _global).userConfig = void 0;
                  (this || _global).coreComponents = void 0;
                  (this || _global).networkControllers = void 0;
                  (this || _global)._emitter = new eventemitter3__WEBPACK_IMPORTED_MODULE_11__.EventEmitter();
                  (this || _global)._autoLevelCapping = void 0;
                  (this || _global).abrController = void 0;
                  (this || _global).bufferController = void 0;
                  (this || _global).capLevelController = void 0;
                  (this || _global).latencyController = void 0;
                  (this || _global).levelController = void 0;
                  (this || _global).streamController = void 0;
                  (this || _global).audioTrackController = void 0;
                  (this || _global).subtitleTrackController = void 0;
                  (this || _global).emeController = void 0;
                  (this || _global).cmcdController = void 0;
                  (this || _global)._media = null;
                  (this || _global).url = null;
                  var config = (this || _global).config = (0, _config__WEBPACK_IMPORTED_MODULE_10__.mergeConfig)(Hls.DefaultConfig, userConfig);
                  (this || _global).userConfig = userConfig;
                  (0, _utils_logger__WEBPACK_IMPORTED_MODULE_9__.enableLogs)(config.debug, "Hls instance");
                  (this || _global)._autoLevelCapping = -1;
                  if (config.progressive) {
                    (0, _config__WEBPACK_IMPORTED_MODULE_10__.enableStreamingMode)(config);
                  }

                  // core controllers and network loaders
                  var ConfigAbrController = config.abrController,
                    ConfigBufferController = config.bufferController,
                    ConfigCapLevelController = config.capLevelController,
                    ConfigFpsController = config.fpsController;
                  var abrController = (this || _global).abrController = new ConfigAbrController(this || _global);
                  var bufferController = (this || _global).bufferController = new ConfigBufferController(this || _global);
                  var capLevelController = (this || _global).capLevelController = new ConfigCapLevelController(this || _global);
                  var fpsController = new ConfigFpsController(this || _global);
                  var playListLoader = new _loader_playlist_loader__WEBPACK_IMPORTED_MODULE_1__["default"](this || _global);
                  var keyLoader = new _loader_key_loader__WEBPACK_IMPORTED_MODULE_2__["default"](this || _global);
                  var id3TrackController = new _controller_id3_track_controller__WEBPACK_IMPORTED_MODULE_3__["default"](this || _global);

                  // network controllers
                  var levelController = (this || _global).levelController = new _controller_level_controller__WEBPACK_IMPORTED_MODULE_5__["default"](this || _global);
                  // FragmentTracker must be defined before StreamController because the order of event handling is important
                  var fragmentTracker = new _controller_fragment_tracker__WEBPACK_IMPORTED_MODULE_6__.FragmentTracker(this || _global);
                  var streamController = (this || _global).streamController = new _controller_stream_controller__WEBPACK_IMPORTED_MODULE_7__["default"](this || _global, fragmentTracker);

                  // Cap level controller uses streamController to flush the buffer
                  capLevelController.setStreamController(streamController);
                  // fpsController uses streamController to switch when frames are being dropped
                  fpsController.setStreamController(streamController);
                  var networkControllers = [playListLoader, keyLoader, levelController, streamController];
                  (this || _global).networkControllers = networkControllers;
                  var coreComponents = [abrController, bufferController, capLevelController, fpsController, id3TrackController, fragmentTracker];
                  (this || _global).audioTrackController = this.createController(config.audioTrackController, null, networkControllers);
                  this.createController(config.audioStreamController, fragmentTracker, networkControllers);
                  // subtitleTrackController must be defined before  because the order of event handling is important
                  (this || _global).subtitleTrackController = this.createController(config.subtitleTrackController, null, networkControllers);
                  this.createController(config.subtitleStreamController, fragmentTracker, networkControllers);
                  this.createController(config.timelineController, null, coreComponents);
                  (this || _global).emeController = this.createController(config.emeController, null, coreComponents);
                  (this || _global).cmcdController = this.createController(config.cmcdController, null, coreComponents);
                  (this || _global).latencyController = this.createController(_controller_latency_controller__WEBPACK_IMPORTED_MODULE_4__["default"], null, coreComponents);
                  (this || _global).coreComponents = coreComponents;
                }
                var _proto = Hls.prototype;
                _proto.createController = function createController(ControllerClass, fragmentTracker, components) {
                  if (ControllerClass) {
                    var controllerInstance = fragmentTracker ? new ControllerClass(this || _global, fragmentTracker) : new ControllerClass(this || _global);
                    if (components) {
                      components.push(controllerInstance);
                    }
                    return controllerInstance;
                  }
                  return null;
                }

                // Delegate the EventEmitter through the public API of Hls.js
                ;

                _proto.on = function on(event, listener, context) {
                  if (context === void 0) {
                    context = this || _global;
                  }
                  (this || _global)._emitter.on(event, listener, context);
                };
                _proto.once = function once(event, listener, context) {
                  if (context === void 0) {
                    context = this || _global;
                  }
                  (this || _global)._emitter.once(event, listener, context);
                };
                _proto.removeAllListeners = function removeAllListeners(event) {
                  (this || _global)._emitter.removeAllListeners(event);
                };
                _proto.off = function off(event, listener, context, once) {
                  if (context === void 0) {
                    context = this || _global;
                  }
                  (this || _global)._emitter.off(event, listener, context, once);
                };
                _proto.listeners = function listeners(event) {
                  return (this || _global)._emitter.listeners(event);
                };
                _proto.emit = function emit(event, name, eventObject) {
                  return (this || _global)._emitter.emit(event, name, eventObject);
                };
                _proto.trigger = function trigger(event, eventObject) {
                  if ((this || _global).config.debug) {
                    return this.emit(event, event, eventObject);
                  } else {
                    try {
                      return this.emit(event, event, eventObject);
                    } catch (e) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.error("An internal error happened while handling event " + event + ". Error message: \"" + e.message + "\". Here is a stacktrace:", e);
                      this.trigger(_events__WEBPACK_IMPORTED_MODULE_12__.Events.ERROR, {
                        type: _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorTypes.OTHER_ERROR,
                        details: _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails.INTERNAL_EXCEPTION,
                        fatal: false,
                        event: event,
                        error: e
                      });
                    }
                  }
                  return false;
                };
                _proto.listenerCount = function listenerCount(event) {
                  return (this || _global)._emitter.listenerCount(event);
                }

                /**
                 * Dispose of the instance
                 */;
                _proto.destroy = function destroy() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("destroy");
                  this.trigger(_events__WEBPACK_IMPORTED_MODULE_12__.Events.DESTROYING, undefined);
                  this.detachMedia();
                  this.removeAllListeners();
                  (this || _global)._autoLevelCapping = -1;
                  (this || _global).url = null;
                  (this || _global).networkControllers.forEach(function (component) {
                    return component.destroy();
                  });
                  (this || _global).networkControllers.length = 0;
                  (this || _global).coreComponents.forEach(function (component) {
                    return component.destroy();
                  });
                  (this || _global).coreComponents.length = 0;
                }

                /**
                 * Attaches Hls.js to a media element
                 * @param {HTMLMediaElement} media
                 */;
                _proto.attachMedia = function attachMedia(media) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("attachMedia");
                  (this || _global)._media = media;
                  this.trigger(_events__WEBPACK_IMPORTED_MODULE_12__.Events.MEDIA_ATTACHING, {
                    media: media
                  });
                }

                /**
                 * Detach Hls.js from the media
                 */;
                _proto.detachMedia = function detachMedia() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("detachMedia");
                  this.trigger(_events__WEBPACK_IMPORTED_MODULE_12__.Events.MEDIA_DETACHING, undefined);
                  (this || _global)._media = null;
                }

                /**
                 * Set the source URL. Can be relative or absolute.
                 * @param {string} url
                 */;
                _proto.loadSource = function loadSource(url) {
                  this.stopLoad();
                  var media = (this || _global).media;
                  var loadedSource = (this || _global).url;
                  var loadingSource = (this || _global).url = url_toolkit__WEBPACK_IMPORTED_MODULE_0__.buildAbsoluteURL(self.location.href, url, {
                    alwaysNormalize: true
                  });
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("loadSource:" + loadingSource);
                  if (media && loadedSource && loadedSource !== loadingSource && (this || _global).bufferController.hasSourceTypes()) {
                    this.detachMedia();
                    this.attachMedia(media);
                  }
                  // when attaching to a source URL, trigger a playlist load
                  this.trigger(_events__WEBPACK_IMPORTED_MODULE_12__.Events.MANIFEST_LOADING, {
                    url: url
                  });
                }

                /**
                 * Start loading data from the stream source.
                 * Depending on default config, client starts loading automatically when a source is set.
                 *
                 * @param {number} startPosition Set the start position to stream from
                 * @default -1 None (from earliest point)
                 */;
                _proto.startLoad = function startLoad(startPosition) {
                  if (startPosition === void 0) {
                    startPosition = -1;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("startLoad(" + startPosition + ")");
                  (this || _global).networkControllers.forEach(function (controller) {
                    controller.startLoad(startPosition);
                  });
                }

                /**
                 * Stop loading of any stream data.
                 */;
                _proto.stopLoad = function stopLoad() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("stopLoad");
                  (this || _global).networkControllers.forEach(function (controller) {
                    controller.stopLoad();
                  });
                }

                /**
                 * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
                 */;
                _proto.swapAudioCodec = function swapAudioCodec() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("swapAudioCodec");
                  (this || _global).streamController.swapAudioCodec();
                }

                /**
                 * When the media-element fails, this allows to detach and then re-attach it
                 * as one call (convenience method).
                 *
                 * Automatic recovery of media-errors by this process is configurable.
                 */;
                _proto.recoverMediaError = function recoverMediaError() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("recoverMediaError");
                  var media = (this || _global)._media;
                  this.detachMedia();
                  if (media) {
                    this.attachMedia(media);
                  }
                };
                _proto.removeLevel = function removeLevel(levelIndex, urlId) {
                  if (urlId === void 0) {
                    urlId = 0;
                  }
                  (this || _global).levelController.removeLevel(levelIndex, urlId);
                }

                /**
                 * @type {Level[]}
                 */;
                _createClass(Hls, [{
                  key: "levels",
                  get: function get() {
                    var levels = (this || _global).levelController.levels;
                    return levels ? levels : [];
                  }

                  /**
                   * Index of quality level currently played
                   * @type {number}
                   */
                }, {
                  key: "currentLevel",
                  get: function get() {
                    return (this || _global).streamController.currentLevel;
                  }

                  /**
                   * Set quality level index immediately .
                   * This will flush the current buffer to replace the quality asap.
                   * That means playback will interrupt at least shortly to re-buffer and re-sync eventually.
                   * @type {number} -1 for automatic level selection
                   */,
                  set: function set(newLevel) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set currentLevel:" + newLevel);
                    (this || _global).loadLevel = newLevel;
                    (this || _global).abrController.clearTimer();
                    (this || _global).streamController.immediateLevelSwitch();
                  }

                  /**
                   * Index of next quality level loaded as scheduled by stream controller.
                   * @type {number}
                   */
                }, {
                  key: "nextLevel",
                  get: function get() {
                    return (this || _global).streamController.nextLevel;
                  }

                  /**
                   * Set quality level index for next loaded data.
                   * This will switch the video quality asap, without interrupting playback.
                   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
                   * @type {number} -1 for automatic level selection
                   */,
                  set: function set(newLevel) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set nextLevel:" + newLevel);
                    (this || _global).levelController.manualLevel = newLevel;
                    (this || _global).streamController.nextLevelSwitch();
                  }

                  /**
                   * Return the quality level of the currently or last (of none is loaded currently) segment
                   * @type {number}
                   */
                }, {
                  key: "loadLevel",
                  get: function get() {
                    return (this || _global).levelController.level;
                  }

                  /**
                   * Set quality level index for next loaded data in a conservative way.
                   * This will switch the quality without flushing, but interrupt current loading.
                   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
                   * @type {number} newLevel -1 for automatic level selection
                   */,
                  set: function set(newLevel) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set loadLevel:" + newLevel);
                    (this || _global).levelController.manualLevel = newLevel;
                  }

                  /**
                   * get next quality level loaded
                   * @type {number}
                   */
                }, {
                  key: "nextLoadLevel",
                  get: function get() {
                    return (this || _global).levelController.nextLoadLevel;
                  }

                  /**
                   * Set quality level of next loaded segment in a fully "non-destructive" way.
                   * Same as `loadLevel` but will wait for next switch (until current loading is done).
                   * @type {number} level
                   */,
                  set: function set(level) {
                    (this || _global).levelController.nextLoadLevel = level;
                  }

                  /**
                   * Return "first level": like a default level, if not set,
                   * falls back to index of first level referenced in manifest
                   * @type {number}
                   */
                }, {
                  key: "firstLevel",
                  get: function get() {
                    return Math.max((this || _global).levelController.firstLevel, (this || _global).minAutoLevel);
                  }

                  /**
                   * Sets "first-level", see getter.
                   * @type {number}
                   */,
                  set: function set(newLevel) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set firstLevel:" + newLevel);
                    (this || _global).levelController.firstLevel = newLevel;
                  }

                  /**
                   * Return start level (level of first fragment that will be played back)
                   * if not overrided by user, first level appearing in manifest will be used as start level
                   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
                   * (determined from download of first segment)
                   * @type {number}
                   */
                }, {
                  key: "startLevel",
                  get: function get() {
                    return (this || _global).levelController.startLevel;
                  }

                  /**
                   * set  start level (level of first fragment that will be played back)
                   * if not overrided by user, first level appearing in manifest will be used as start level
                   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
                   * (determined from download of first segment)
                   * @type {number} newLevel
                   */,
                  set: function set(newLevel) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set startLevel:" + newLevel);
                    // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
                    if (newLevel !== -1) {
                      newLevel = Math.max(newLevel, (this || _global).minAutoLevel);
                    }
                    (this || _global).levelController.startLevel = newLevel;
                  }

                  /**
                   * Get the current setting for capLevelToPlayerSize
                   *
                   * @type {boolean}
                   */
                }, {
                  key: "capLevelToPlayerSize",
                  get: function get() {
                    return (this || _global).config.capLevelToPlayerSize;
                  }

                  /**
                   * set  dynamically set capLevelToPlayerSize against (`CapLevelController`)
                   *
                   * @type {boolean}
                   */,
                  set: function set(shouldStartCapping) {
                    var newCapLevelToPlayerSize = !!shouldStartCapping;
                    if (newCapLevelToPlayerSize !== (this || _global).config.capLevelToPlayerSize) {
                      if (newCapLevelToPlayerSize) {
                        (this || _global).capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
                      } else {
                        (this || _global).capLevelController.stopCapping();
                        (this || _global).autoLevelCapping = -1;
                        (this || _global).streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
                      }

                      (this || _global).config.capLevelToPlayerSize = newCapLevelToPlayerSize;
                    }
                  }

                  /**
                   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
                   * @type {number}
                   */
                }, {
                  key: "autoLevelCapping",
                  get: function get() {
                    return (this || _global)._autoLevelCapping;
                  }

                  /**
                   * get bandwidth estimate
                   * @type {number}
                   */,
                  set:
                  /**
                   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
                   * @type {number}
                   */
                  function set(newLevel) {
                    if ((this || _global)._autoLevelCapping !== newLevel) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_9__.logger.log("set autoLevelCapping:" + newLevel);
                      (this || _global)._autoLevelCapping = newLevel;
                    }
                  }

                  /**
                   * True when automatic level selection enabled
                   * @type {boolean}
                   */
                }, {
                  key: "bandwidthEstimate",
                  get: function get() {
                    var bwEstimator = (this || _global).abrController.bwEstimator;
                    if (!bwEstimator) {
                      return NaN;
                    }
                    return bwEstimator.getEstimate();
                  }
                }, {
                  key: "autoLevelEnabled",
                  get: function get() {
                    return (this || _global).levelController.manualLevel === -1;
                  }

                  /**
                   * Level set manually (if any)
                   * @type {number}
                   */
                }, {
                  key: "manualLevel",
                  get: function get() {
                    return (this || _global).levelController.manualLevel;
                  }

                  /**
                   * min level selectable in auto mode according to config.minAutoBitrate
                   * @type {number}
                   */
                }, {
                  key: "minAutoLevel",
                  get: function get() {
                    var levels = (this || _global).levels,
                      minAutoBitrate = (this || _global).config.minAutoBitrate;
                    if (!levels) return 0;
                    var len = levels.length;
                    for (var i = 0; i < len; i++) {
                      if (levels[i].maxBitrate >= minAutoBitrate) {
                        return i;
                      }
                    }
                    return 0;
                  }

                  /**
                   * max level selectable in auto mode according to autoLevelCapping
                   * @type {number}
                   */
                }, {
                  key: "maxAutoLevel",
                  get: function get() {
                    var levels = (this || _global).levels,
                      autoLevelCapping = (this || _global).autoLevelCapping;
                    var maxAutoLevel;
                    if (autoLevelCapping === -1 && levels && levels.length) {
                      maxAutoLevel = levels.length - 1;
                    } else {
                      maxAutoLevel = autoLevelCapping;
                    }
                    return maxAutoLevel;
                  }

                  /**
                   * next automatically selected quality level
                   * @type {number}
                   */
                }, {
                  key: "nextAutoLevel",
                  get: function get() {
                    // ensure next auto level is between  min and max auto level
                    return Math.min(Math.max((this || _global).abrController.nextAutoLevel, (this || _global).minAutoLevel), (this || _global).maxAutoLevel);
                  }

                  /**
                   * this setter is used to force next auto level.
                   * this is useful to force a switch down in auto mode:
                   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
                   * forced value is valid for one fragment. upon successful frag loading at forced level,
                   * this value will be resetted to -1 by ABR controller.
                   * @type {number}
                   */,
                  set: function set(nextLevel) {
                    (this || _global).abrController.nextAutoLevel = Math.max((this || _global).minAutoLevel, nextLevel);
                  }

                  /**
                   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
                   * @type {Date}
                   */
                }, {
                  key: "playingDate",
                  get: function get() {
                    return (this || _global).streamController.currentProgramDateTime;
                  }
                }, {
                  key: "mainForwardBufferInfo",
                  get: function get() {
                    return (this || _global).streamController.getMainFwdBufferInfo();
                  }

                  /**
                   * @type {AudioTrack[]}
                   */
                }, {
                  key: "audioTracks",
                  get: function get() {
                    var audioTrackController = (this || _global).audioTrackController;
                    return audioTrackController ? audioTrackController.audioTracks : [];
                  }

                  /**
                   * index of the selected audio track (index in audio track lists)
                   * @type {number}
                   */
                }, {
                  key: "audioTrack",
                  get: function get() {
                    var audioTrackController = (this || _global).audioTrackController;
                    return audioTrackController ? audioTrackController.audioTrack : -1;
                  }

                  /**
                   * selects an audio track, based on its index in audio track lists
                   * @type {number}
                   */,
                  set: function set(audioTrackId) {
                    var audioTrackController = (this || _global).audioTrackController;
                    if (audioTrackController) {
                      audioTrackController.audioTrack = audioTrackId;
                    }
                  }

                  /**
                   * get alternate subtitle tracks list from playlist
                   * @type {MediaPlaylist[]}
                   */
                }, {
                  key: "subtitleTracks",
                  get: function get() {
                    var subtitleTrackController = (this || _global).subtitleTrackController;
                    return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
                  }

                  /**
                   * index of the selected subtitle track (index in subtitle track lists)
                   * @type {number}
                   */
                }, {
                  key: "subtitleTrack",
                  get: function get() {
                    var subtitleTrackController = (this || _global).subtitleTrackController;
                    return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
                  },
                  set:
                  /**
                   * select an subtitle track, based on its index in subtitle track lists
                   * @type {number}
                   */
                  function set(subtitleTrackId) {
                    var subtitleTrackController = (this || _global).subtitleTrackController;
                    if (subtitleTrackController) {
                      subtitleTrackController.subtitleTrack = subtitleTrackId;
                    }
                  }

                  /**
                   * @type {boolean}
                   */
                }, {
                  key: "media",
                  get: function get() {
                    return (this || _global)._media;
                  }
                }, {
                  key: "subtitleDisplay",
                  get: function get() {
                    var subtitleTrackController = (this || _global).subtitleTrackController;
                    return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
                  }

                  /**
                   * Enable/disable subtitle display rendering
                   * @type {boolean}
                   */,
                  set: function set(value) {
                    var subtitleTrackController = (this || _global).subtitleTrackController;
                    if (subtitleTrackController) {
                      subtitleTrackController.subtitleDisplay = value;
                    }
                  }

                  /**
                   * get mode for Low-Latency HLS loading
                   * @type {boolean}
                   */
                }, {
                  key: "lowLatencyMode",
                  get: function get() {
                    return (this || _global).config.lowLatencyMode;
                  }

                  /**
                   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
                   * @type {boolean}
                   */,
                  set: function set(mode) {
                    (this || _global).config.lowLatencyMode = mode;
                  }

                  /**
                   * position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
                   * @type {number}
                   */
                }, {
                  key: "liveSyncPosition",
                  get: function get() {
                    return (this || _global).latencyController.liveSyncPosition;
                  }

                  /**
                   * estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
                   * returns 0 before first playlist is loaded
                   * @type {number}
                   */
                }, {
                  key: "latency",
                  get: function get() {
                    return (this || _global).latencyController.latency;
                  }

                  /**
                   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
                   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
                   * returns 0 before first playlist is loaded
                   * @type {number}
                   */
                }, {
                  key: "maxLatency",
                  get: function get() {
                    return (this || _global).latencyController.maxLatency;
                  }

                  /**
                   * target distance from the edge as calculated by the latency controller
                   * @type {number}
                   */
                }, {
                  key: "targetLatency",
                  get: function get() {
                    return (this || _global).latencyController.targetLatency;
                  }

                  /**
                   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
                   * @type {number}
                   */
                }, {
                  key: "drift",
                  get: function get() {
                    return (this || _global).latencyController.drift;
                  }

                  /**
                   * set to true when startLoad is called before MANIFEST_PARSED event
                   * @type {boolean}
                   */
                }, {
                  key: "forceStartLoad",
                  get: function get() {
                    return (this || _global).streamController.forceStartLoad;
                  }
                }], [{
                  key: "version",
                  get: function get() {
                    return "1.2.9";
                  }
                }, {
                  key: "Events",
                  get: function get() {
                    return _events__WEBPACK_IMPORTED_MODULE_12__.Events;
                  }
                }, {
                  key: "ErrorTypes",
                  get: function get() {
                    return _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorTypes;
                  }
                }, {
                  key: "ErrorDetails",
                  get: function get() {
                    return _errors__WEBPACK_IMPORTED_MODULE_13__.ErrorDetails;
                  }
                }, {
                  key: "DefaultConfig",
                  get: function get() {
                    if (!Hls.defaultConfig) {
                      return _config__WEBPACK_IMPORTED_MODULE_10__.hlsDefaultConfig;
                    }
                    return Hls.defaultConfig;
                  }

                  /**
                   * @type {HlsConfig}
                   */,
                  set: function set(defaultConfig) {
                    Hls.defaultConfig = defaultConfig;
                  }
                }]);
                return Hls;
              }();
              Hls.defaultConfig = void 0;

              /***/
            },

            /***/"./src/is-supported.ts":
            /*!*****************************!*\
              !*** ./src/is-supported.ts ***!
              \*****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"changeTypeSupported": () => /* binding */changeTypeSupported,
                /* harmony export */"isSupported": () => /* binding */isSupported
                /* harmony export */
              });
              /* harmony import */
              var _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./utils/mediasource-helper */"./src/utils/mediasource-helper.ts");
              function getSourceBuffer() {
                return self.SourceBuffer || self.WebKitSourceBuffer;
              }
              function isSupported() {
                var mediaSource = (0, _utils_mediasource_helper__WEBPACK_IMPORTED_MODULE_0__.getMediaSource)();
                if (!mediaSource) {
                  return false;
                }
                var sourceBuffer = getSourceBuffer();
                var isTypeSupported = mediaSource && typeof mediaSource.isTypeSupported === "function" && mediaSource.isTypeSupported("video/mp4; codecs=\"avc1.42E01E,mp4a.40.2\"");

                // if SourceBuffer is exposed ensure its API is valid
                // safari and old version of Chrome doe not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
                var sourceBufferValidAPI = !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === "function" && typeof sourceBuffer.prototype.remove === "function";
                return !!isTypeSupported && !!sourceBufferValidAPI;
              }
              function changeTypeSupported() {
                var _sourceBuffer$prototy;
                var sourceBuffer = getSourceBuffer();
                return typeof (sourceBuffer === null || sourceBuffer === void 0 ? void 0 : (_sourceBuffer$prototy = sourceBuffer.prototype) === null || _sourceBuffer$prototy === void 0 ? void 0 : _sourceBuffer$prototy.changeType) === "function";
              }

              /***/
            },

            /***/"./src/loader/date-range.ts":
            /*!**********************************!*\
              !*** ./src/loader/date-range.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"DateRange": () => /* binding */DateRange,
                /* harmony export */"DateRangeAttribute": () => /* binding */DateRangeAttribute
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _utils_attr_list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../utils/attr-list */"./src/utils/attr-list.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var DateRangeAttribute;
              (function (DateRangeAttribute) {
                DateRangeAttribute["ID"] = "ID";
                DateRangeAttribute["CLASS"] = "CLASS";
                DateRangeAttribute["START_DATE"] = "START-DATE";
                DateRangeAttribute["DURATION"] = "DURATION";
                DateRangeAttribute["END_DATE"] = "END-DATE";
                DateRangeAttribute["END_ON_NEXT"] = "END-ON-NEXT";
                DateRangeAttribute["PLANNED_DURATION"] = "PLANNED-DURATION";
                DateRangeAttribute["SCTE35_OUT"] = "SCTE35-OUT";
                DateRangeAttribute["SCTE35_IN"] = "SCTE35-IN";
              })(DateRangeAttribute || (DateRangeAttribute = {}));
              var DateRange = /*#__PURE__*/function () {
                function DateRange(dateRangeAttr, dateRangeWithSameId) {
                  (this || _global).attr = void 0;
                  (this || _global)._startDate = void 0;
                  (this || _global)._endDate = void 0;
                  (this || _global)._badValueForSameId = void 0;
                  if (dateRangeWithSameId) {
                    var previousAttr = dateRangeWithSameId.attr;
                    for (var key in previousAttr) {
                      if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("DATERANGE tag attribute: \"" + key + "\" does not match for tags with ID: \"" + dateRangeAttr.ID + "\"");
                        (this || _global)._badValueForSameId = key;
                        break;
                      }
                    }
                    // Merge DateRange tags with the same ID
                    dateRangeAttr = _extends(new _utils_attr_list__WEBPACK_IMPORTED_MODULE_1__.AttrList({}), previousAttr, dateRangeAttr);
                  }
                  (this || _global).attr = dateRangeAttr;
                  (this || _global)._startDate = new Date(dateRangeAttr[DateRangeAttribute.START_DATE]);
                  if (DateRangeAttribute.END_DATE in (this || _global).attr) {
                    var endDate = new Date((this || _global).attr[DateRangeAttribute.END_DATE]);
                    if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(endDate.getTime())) {
                      (this || _global)._endDate = endDate;
                    }
                  }
                }
                _createClass(DateRange, [{
                  key: "id",
                  get: function get() {
                    return (this || _global).attr.ID;
                  }
                }, {
                  key: "class",
                  get: function get() {
                    return (this || _global).attr.CLASS;
                  }
                }, {
                  key: "startDate",
                  get: function get() {
                    return (this || _global)._startDate;
                  }
                }, {
                  key: "endDate",
                  get: function get() {
                    if ((this || _global)._endDate) {
                      return (this || _global)._endDate;
                    }
                    var duration = (this || _global).duration;
                    if (duration !== null) {
                      return new Date((this || _global)._startDate.getTime() + duration * 1000);
                    }
                    return null;
                  }
                }, {
                  key: "duration",
                  get: function get() {
                    if (DateRangeAttribute.DURATION in (this || _global).attr) {
                      var duration = (this || _global).attr.decimalFloatingPoint(DateRangeAttribute.DURATION);
                      if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(duration)) {
                        return duration;
                      }
                    } else if ((this || _global)._endDate) {
                      return ((this || _global)._endDate.getTime() - (this || _global)._startDate.getTime()) / 1000;
                    }
                    return null;
                  }
                }, {
                  key: "plannedDuration",
                  get: function get() {
                    if (DateRangeAttribute.PLANNED_DURATION in (this || _global).attr) {
                      return (this || _global).attr.decimalFloatingPoint(DateRangeAttribute.PLANNED_DURATION);
                    }
                    return null;
                  }
                }, {
                  key: "endOnNext",
                  get: function get() {
                    return (this || _global).attr.bool(DateRangeAttribute.END_ON_NEXT);
                  }
                }, {
                  key: "isValid",
                  get: function get() {
                    return !!(this || _global).id && !(this || _global)._badValueForSameId && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).startDate.getTime()) && ((this || _global).duration === null || (this || _global).duration >= 0) && (!(this || _global).endOnNext || !!(this || _global).class);
                  }
                }]);
                return DateRange;
              }();

              /***/
            },

            /***/"./src/loader/fragment-loader.ts":
            /*!***************************************!*\
              !*** ./src/loader/fragment-loader.ts ***!
              \***************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"LoadError": () => /* binding */LoadError,
                /* harmony export */"default": () => /* binding */FragmentLoader
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _wrapNativeSuper(Class) {
                var _cache = typeof Map === "function" ? new Map() : undefined;
                _wrapNativeSuper = function _wrapNativeSuper(Class) {
                  if (Class === null || !_isNativeFunction(Class)) return Class;
                  if (typeof Class !== "function") {
                    throw new TypeError("Super expression must either be null or a function");
                  }
                  if (typeof _cache !== "undefined") {
                    if (_cache.has(Class)) return _cache.get(Class);
                    _cache.set(Class, Wrapper);
                  }
                  function Wrapper() {
                    return _construct(Class, arguments, _getPrototypeOf(this || _global).constructor);
                  }
                  Wrapper.prototype = Object.create(Class.prototype, {
                    constructor: {
                      value: Wrapper,
                      enumerable: false,
                      writable: true,
                      configurable: true
                    }
                  });
                  return _setPrototypeOf(Wrapper, Class);
                };
                return _wrapNativeSuper(Class);
              }
              function _construct(Parent, args, Class) {
                if (_isNativeReflectConstruct()) {
                  _construct = Reflect.construct.bind();
                } else {
                  _construct = function _construct(Parent, args, Class) {
                    var a = [null];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor();
                    if (Class) _setPrototypeOf(instance, Class.prototype);
                    return instance;
                  };
                }
                return _construct.apply(null, arguments);
              }
              function _isNativeReflectConstruct() {
                if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                if (Reflect.construct.sham) return false;
                if (typeof Proxy === "function") return true;
                try {
                  Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
                  return true;
                } catch (e) {
                  return false;
                }
              }
              function _isNativeFunction(fn) {
                return Function.toString.call(fn).indexOf("[native code]") !== -1;
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                  return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
              }
              var MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb
              var FragmentLoader = /*#__PURE__*/function () {
                function FragmentLoader(config) {
                  (this || _global).config = void 0;
                  (this || _global).loader = null;
                  (this || _global).partLoadTimeout = -1;
                  (this || _global).config = config;
                }
                var _proto = FragmentLoader.prototype;
                _proto.destroy = function destroy() {
                  if ((this || _global).loader) {
                    (this || _global).loader.destroy();
                    (this || _global).loader = null;
                  }
                };
                _proto.abort = function abort() {
                  if ((this || _global).loader) {
                    // Abort the loader for current fragment. Only one may load at any given time
                    (this || _global).loader.abort();
                  }
                };
                _proto.load = function load(frag, _onProgress) {
                  var _this = this || _global;
                  var url = frag.url;
                  if (!url) {
                    return Promise.reject(new LoadError({
                      type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_LOAD_ERROR,
                      fatal: false,
                      frag: frag,
                      networkDetails: null
                    }, "Fragment does not have a " + (url ? "part list" : "url")));
                  }
                  this.abort();
                  var config = (this || _global).config;
                  var FragmentILoader = config.fLoader;
                  var DefaultILoader = config.loader;
                  return new Promise(function (resolve, reject) {
                    if (_this.loader) {
                      _this.loader.destroy();
                    }
                    var loader = _this.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
                    var loaderContext = createLoaderContext(frag);
                    var loaderConfig = {
                      timeout: config.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: 0,
                      maxRetryDelay: config.fragLoadingMaxRetryTimeout,
                      highWaterMark: frag.sn === "initSegment" ? Infinity : MIN_CHUNK_SIZE
                    };
                    // Assign frag stats to the loader's stats reference
                    frag.stats = loader.stats;
                    loader.load(loaderContext, loaderConfig, {
                      onSuccess: function onSuccess(response, stats, context, networkDetails) {
                        _this.resetLoader(frag, loader);
                        resolve({
                          frag: frag,
                          part: null,
                          payload: response.data,
                          networkDetails: networkDetails
                        });
                      },
                      onError: function onError(response, context, networkDetails) {
                        _this.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_LOAD_ERROR,
                          fatal: false,
                          frag: frag,
                          response: response,
                          networkDetails: networkDetails
                        }));
                      },
                      onAbort: function onAbort(stats, context, networkDetails) {
                        _this.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.INTERNAL_ABORTED,
                          fatal: false,
                          frag: frag,
                          networkDetails: networkDetails
                        }));
                      },
                      onTimeout: function onTimeout(response, context, networkDetails) {
                        _this.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_LOAD_TIMEOUT,
                          fatal: false,
                          frag: frag,
                          networkDetails: networkDetails
                        }));
                      },
                      onProgress: function onProgress(stats, context, data, networkDetails) {
                        if (_onProgress) {
                          _onProgress({
                            frag: frag,
                            part: null,
                            payload: data,
                            networkDetails: networkDetails
                          });
                        }
                      }
                    });
                  });
                };
                _proto.loadPart = function loadPart(frag, part, onProgress) {
                  var _this2 = this || _global;
                  this.abort();
                  var config = (this || _global).config;
                  var FragmentILoader = config.fLoader;
                  var DefaultILoader = config.loader;
                  return new Promise(function (resolve, reject) {
                    if (_this2.loader) {
                      _this2.loader.destroy();
                    }
                    var loader = _this2.loader = frag.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
                    var loaderContext = createLoaderContext(frag, part);
                    var loaderConfig = {
                      timeout: config.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: 0,
                      maxRetryDelay: config.fragLoadingMaxRetryTimeout,
                      highWaterMark: MIN_CHUNK_SIZE
                    };
                    // Assign part stats to the loader's stats reference
                    part.stats = loader.stats;
                    loader.load(loaderContext, loaderConfig, {
                      onSuccess: function onSuccess(response, stats, context, networkDetails) {
                        _this2.resetLoader(frag, loader);
                        _this2.updateStatsFromPart(frag, part);
                        var partLoadedData = {
                          frag: frag,
                          part: part,
                          payload: response.data,
                          networkDetails: networkDetails
                        };
                        onProgress(partLoadedData);
                        resolve(partLoadedData);
                      },
                      onError: function onError(response, context, networkDetails) {
                        _this2.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_LOAD_ERROR,
                          fatal: false,
                          frag: frag,
                          part: part,
                          response: response,
                          networkDetails: networkDetails
                        }));
                      },
                      onAbort: function onAbort(stats, context, networkDetails) {
                        frag.stats.aborted = part.stats.aborted;
                        _this2.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.INTERNAL_ABORTED,
                          fatal: false,
                          frag: frag,
                          part: part,
                          networkDetails: networkDetails
                        }));
                      },
                      onTimeout: function onTimeout(response, context, networkDetails) {
                        _this2.resetLoader(frag, loader);
                        reject(new LoadError({
                          type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                          details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.FRAG_LOAD_TIMEOUT,
                          fatal: false,
                          frag: frag,
                          part: part,
                          networkDetails: networkDetails
                        }));
                      }
                    });
                  });
                };
                _proto.updateStatsFromPart = function updateStatsFromPart(frag, part) {
                  var fragStats = frag.stats;
                  var partStats = part.stats;
                  var partTotal = partStats.total;
                  fragStats.loaded += partStats.loaded;
                  if (partTotal) {
                    var estTotalParts = Math.round(frag.duration / part.duration);
                    var estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
                    var estRemainingParts = estTotalParts - estLoadedParts;
                    var estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
                    fragStats.total = fragStats.loaded + estRemainingBytes;
                  } else {
                    fragStats.total = Math.max(fragStats.loaded, fragStats.total);
                  }
                  var fragLoading = fragStats.loading;
                  var partLoading = partStats.loading;
                  if (fragLoading.start) {
                    // add to fragment loader latency
                    fragLoading.first += partLoading.first - partLoading.start;
                  } else {
                    fragLoading.start = partLoading.start;
                    fragLoading.first = partLoading.first;
                  }
                  fragLoading.end = partLoading.end;
                };
                _proto.resetLoader = function resetLoader(frag, loader) {
                  frag.loader = null;
                  if ((this || _global).loader === loader) {
                    self.clearTimeout((this || _global).partLoadTimeout);
                    (this || _global).loader = null;
                  }
                  loader.destroy();
                };
                return FragmentLoader;
              }();
              function createLoaderContext(frag, part) {
                if (part === void 0) {
                  part = null;
                }
                var segment = part || frag;
                var loaderContext = {
                  frag: frag,
                  part: part,
                  responseType: "arraybuffer",
                  url: segment.url,
                  headers: {},
                  rangeStart: 0,
                  rangeEnd: 0
                };
                var start = segment.byteRangeStartOffset;
                var end = segment.byteRangeEndOffset;
                if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(start) && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(end)) {
                  loaderContext.rangeStart = start;
                  loaderContext.rangeEnd = end;
                }
                return loaderContext;
              }
              var LoadError = /*#__PURE__*/function (_Error) {
                _inheritsLoose(LoadError, _Error);
                function LoadError(data) {
                  var _this3;
                  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    params[_key - 1] = arguments[_key];
                  }
                  _this3 = _Error.call.apply(_Error, [this || _global].concat(params)) || this || _global;
                  _this3.data = void 0;
                  _this3.data = data;
                  return _this3;
                }
                return LoadError;
              }( /*#__PURE__*/_wrapNativeSuper(Error));

              /***/
            },

            /***/"./src/loader/fragment.ts":
            /*!********************************!*\
              !*** ./src/loader/fragment.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"BaseSegment": () => /* binding */BaseSegment,
                /* harmony export */"ElementaryStreamTypes": () => /* binding */ElementaryStreamTypes,
                /* harmony export */"Fragment": () => /* binding */Fragment,
                /* harmony export */"Part": () => /* binding */Part
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var url_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! url-toolkit */"./node_modules/url-toolkit/src/url-toolkit.js");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _level_key__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./level-key */"./src/loader/level-key.ts");
              /* harmony import */
              var _load_stats__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./load-stats */"./src/loader/load-stats.ts");
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var ElementaryStreamTypes;
              (function (ElementaryStreamTypes) {
                ElementaryStreamTypes["AUDIO"] = "audio";
                ElementaryStreamTypes["VIDEO"] = "video";
                ElementaryStreamTypes["AUDIOVIDEO"] = "audiovideo";
              })(ElementaryStreamTypes || (ElementaryStreamTypes = {}));
              var BaseSegment = /*#__PURE__*/function () {
                // baseurl is the URL to the playlist

                // relurl is the portion of the URL that comes from inside the playlist.

                // Holds the types of data this fragment supports

                function BaseSegment(baseurl) {
                  var _this$elementaryStrea;
                  (this || _global)._byteRange = null;
                  (this || _global)._url = null;
                  (this || _global).baseurl = void 0;
                  (this || _global).relurl = void 0;
                  (this || _global).elementaryStreams = (_this$elementaryStrea = {}, _this$elementaryStrea[ElementaryStreamTypes.AUDIO] = null, _this$elementaryStrea[ElementaryStreamTypes.VIDEO] = null, _this$elementaryStrea[ElementaryStreamTypes.AUDIOVIDEO] = null, _this$elementaryStrea);
                  (this || _global).baseurl = baseurl;
                }

                // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
                var _proto = BaseSegment.prototype;
                _proto.setByteRange = function setByteRange(value, previous) {
                  var params = value.split("@", 2);
                  var byteRange = [];
                  if (params.length === 1) {
                    byteRange[0] = previous ? previous.byteRangeEndOffset : 0;
                  } else {
                    byteRange[0] = parseInt(params[1]);
                  }
                  byteRange[1] = parseInt(params[0]) + byteRange[0];
                  (this || _global)._byteRange = byteRange;
                };
                _createClass(BaseSegment, [{
                  key: "byteRange",
                  get: function get() {
                    if (!(this || _global)._byteRange) {
                      return [];
                    }
                    return (this || _global)._byteRange;
                  }
                }, {
                  key: "byteRangeStartOffset",
                  get: function get() {
                    return (this || _global).byteRange[0];
                  }
                }, {
                  key: "byteRangeEndOffset",
                  get: function get() {
                    return (this || _global).byteRange[1];
                  }
                }, {
                  key: "url",
                  get: function get() {
                    if (!(this || _global)._url && (this || _global).baseurl && (this || _global).relurl) {
                      (this || _global)._url = (0, url_toolkit__WEBPACK_IMPORTED_MODULE_1__.buildAbsoluteURL)((this || _global).baseurl, (this || _global).relurl, {
                        alwaysNormalize: true
                      });
                    }
                    return (this || _global)._url || "";
                  },
                  set: function set(value) {
                    (this || _global)._url = value;
                  }
                }]);
                return BaseSegment;
              }();
              var Fragment = /*#__PURE__*/function (_BaseSegment) {
                _inheritsLoose(Fragment, _BaseSegment);
                // EXTINF has to be present for a m3u8 to be considered valid

                // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'

                // levelkey is the EXT-X-KEY that applies to this segment for decryption
                // core difference from the private field _decryptdata is the lack of the initialized IV
                // _decryptdata will set the IV for this segment based on the segment number in the fragment

                // A string representing the fragment type

                // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading

                // The level/track index to which the fragment belongs

                // The continuity counter of the fragment

                // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.

                // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.

                // The latest Presentation Time Stamp (PTS) appended to the buffer.

                // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.

                // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.

                // The start time of the fragment, as listed in the manifest. Updated after transmux complete.

                // Set by `updateFragPTSDTS` in level-helper

                // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.

                // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.

                // Load/parse timing information

                // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered

                // #EXTINF  segment title

                // The Media Initialization Section for this segment

                function Fragment(type, baseurl) {
                  var _this;
                  _this = _BaseSegment.call(this || _global, baseurl) || this || _global;
                  _this._decryptdata = null;
                  _this.rawProgramDateTime = null;
                  _this.programDateTime = null;
                  _this.tagList = [];
                  _this.duration = 0;
                  _this.sn = 0;
                  _this.levelkey = void 0;
                  _this.type = void 0;
                  _this.loader = null;
                  _this.level = -1;
                  _this.cc = 0;
                  _this.startPTS = void 0;
                  _this.endPTS = void 0;
                  _this.appendedPTS = void 0;
                  _this.startDTS = void 0;
                  _this.endDTS = void 0;
                  _this.start = 0;
                  _this.deltaPTS = void 0;
                  _this.maxStartPTS = void 0;
                  _this.minEndPTS = void 0;
                  _this.stats = new _load_stats__WEBPACK_IMPORTED_MODULE_4__.LoadStats();
                  _this.urlId = 0;
                  _this.data = void 0;
                  _this.bitrateTest = false;
                  _this.title = null;
                  _this.initSegment = null;
                  _this.type = type;
                  return _this;
                }
                var _proto2 = Fragment.prototype;
                /**
                 * Utility method for parseLevelPlaylist to create an initialization vector for a given segment
                 * @param {number} segmentNumber - segment number to generate IV with
                 * @returns {Uint8Array}
                 */
                _proto2.createInitializationVector = function createInitializationVector(segmentNumber) {
                  var uint8View = new Uint8Array(16);
                  for (var i = 12; i < 16; i++) {
                    uint8View[i] = segmentNumber >> 8 * (15 - i) & 255;
                  }
                  return uint8View;
                }

                /**
                 * Utility method for parseLevelPlaylist to get a fragment's decryption data from the currently parsed encryption key data
                 * @param levelkey - a playlist's encryption info
                 * @param segmentNumber - the fragment's segment number
                 * @returns {LevelKey} - an object to be applied as a fragment's decryptdata
                 */;
                _proto2.setDecryptDataFromLevelKey = function setDecryptDataFromLevelKey(levelkey, segmentNumber) {
                  var decryptdata = levelkey;
                  if ((levelkey === null || levelkey === void 0 ? void 0 : levelkey.method) === "AES-128" && levelkey.uri && !levelkey.iv) {
                    decryptdata = _level_key__WEBPACK_IMPORTED_MODULE_3__.LevelKey.fromURI(levelkey.uri);
                    decryptdata.method = levelkey.method;
                    decryptdata.iv = this.createInitializationVector(segmentNumber);
                    decryptdata.keyFormat = "identity";
                  }
                  return decryptdata;
                };
                _proto2.setElementaryStreamInfo = function setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial) {
                  if (partial === void 0) {
                    partial = false;
                  }
                  var elementaryStreams = (this || _global).elementaryStreams;
                  var info = elementaryStreams[type];
                  if (!info) {
                    elementaryStreams[type] = {
                      startPTS: startPTS,
                      endPTS: endPTS,
                      startDTS: startDTS,
                      endDTS: endDTS,
                      partial: partial
                    };
                    return;
                  }
                  info.startPTS = Math.min(info.startPTS, startPTS);
                  info.endPTS = Math.max(info.endPTS, endPTS);
                  info.startDTS = Math.min(info.startDTS, startDTS);
                  info.endDTS = Math.max(info.endDTS, endDTS);
                };
                _proto2.clearElementaryStreamInfo = function clearElementaryStreamInfo() {
                  var elementaryStreams = (this || _global).elementaryStreams;
                  elementaryStreams[ElementaryStreamTypes.AUDIO] = null;
                  elementaryStreams[ElementaryStreamTypes.VIDEO] = null;
                  elementaryStreams[ElementaryStreamTypes.AUDIOVIDEO] = null;
                };
                _createClass(Fragment, [{
                  key: "decryptdata",
                  get: function get() {
                    if (!(this || _global).levelkey && !(this || _global)._decryptdata) {
                      return null;
                    }
                    if (!(this || _global)._decryptdata && (this || _global).levelkey) {
                      var sn = (this || _global).sn;
                      if (typeof sn !== "number") {
                        // We are fetching decryption data for a initialization segment
                        // If the segment was encrypted with AES-128
                        // It must have an IV defined. We cannot substitute the Segment Number in.
                        if ((this || _global).levelkey && (this || _global).levelkey.method === "AES-128" && !(this || _global).levelkey.iv) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("missing IV for initialization segment with method=\"" + (this || _global).levelkey.method + "\" - compliance issue");
                        }

                        /*
                        Be converted to a Number.
                        'initSegment' will become NaN.
                        NaN, which when converted through ToInt32() -> +0.
                        ---
                        Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
                        */
                        sn = 0;
                      }
                      (this || _global)._decryptdata = this.setDecryptDataFromLevelKey((this || _global).levelkey, sn);
                    }
                    return (this || _global)._decryptdata;
                  }
                }, {
                  key: "end",
                  get: function get() {
                    return (this || _global).start + (this || _global).duration;
                  }
                }, {
                  key: "endProgramDateTime",
                  get: function get() {
                    if ((this || _global).programDateTime === null) {
                      return null;
                    }
                    if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).programDateTime)) {
                      return null;
                    }
                    var duration = !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).duration) ? 0 : (this || _global).duration;
                    return (this || _global).programDateTime + duration * 1000;
                  }
                }, {
                  key: "encrypted",
                  get: function get() {
                    var _this$decryptdata;
                    // At the m3u8-parser level we need to add support for manifest signalled keyformats
                    // when we want the fragment to start reporting that it is encrypted.
                    // Currently, keyFormat will only be set for identity keys
                    if ((_this$decryptdata = (this || _global).decryptdata) !== null && _this$decryptdata !== void 0 && _this$decryptdata.keyFormat && (this || _global).decryptdata.uri) {
                      return true;
                    }
                    return false;
                  }
                }]);
                return Fragment;
              }(BaseSegment);
              var Part = /*#__PURE__*/function (_BaseSegment2) {
                _inheritsLoose(Part, _BaseSegment2);
                function Part(partAttrs, frag, baseurl, index, previous) {
                  var _this2;
                  _this2 = _BaseSegment2.call(this || _global, baseurl) || this || _global;
                  _this2.fragOffset = 0;
                  _this2.duration = 0;
                  _this2.gap = false;
                  _this2.independent = false;
                  _this2.relurl = void 0;
                  _this2.fragment = void 0;
                  _this2.index = void 0;
                  _this2.stats = new _load_stats__WEBPACK_IMPORTED_MODULE_4__.LoadStats();
                  _this2.duration = partAttrs.decimalFloatingPoint("DURATION");
                  _this2.gap = partAttrs.bool("GAP");
                  _this2.independent = partAttrs.bool("INDEPENDENT");
                  _this2.relurl = partAttrs.enumeratedString("URI");
                  _this2.fragment = frag;
                  _this2.index = index;
                  var byteRange = partAttrs.enumeratedString("BYTERANGE");
                  if (byteRange) {
                    _this2.setByteRange(byteRange, previous);
                  }
                  if (previous) {
                    _this2.fragOffset = previous.fragOffset + previous.duration;
                  }
                  return _this2;
                }
                _createClass(Part, [{
                  key: "start",
                  get: function get() {
                    return (this || _global).fragment.start + (this || _global).fragOffset;
                  }
                }, {
                  key: "end",
                  get: function get() {
                    return (this || _global).start + (this || _global).duration;
                  }
                }, {
                  key: "loaded",
                  get: function get() {
                    var elementaryStreams = (this || _global).elementaryStreams;
                    return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
                  }
                }]);
                return Part;
              }(BaseSegment);

              /***/
            },

            /***/"./src/loader/key-loader.ts":
            /*!**********************************!*\
              !*** ./src/loader/key-loader.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */KeyLoader
                /* harmony export */
              });
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /*
               * Decrypt key Loader
               */

              var KeyLoader = /*#__PURE__*/function () {
                function KeyLoader(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).loaders = {};
                  (this || _global).decryptkey = null;
                  (this || _global).decrypturl = null;
                  (this || _global).hls = hls;
                  this.registerListeners();
                }
                var _proto = KeyLoader.prototype;
                _proto.startLoad = function startLoad(startPosition) {};
                _proto.stopLoad = function stopLoad() {
                  this.destroyInternalLoaders();
                };
                _proto.registerListeners = function registerListeners() {
                  (this || _global).hls.on(_events__WEBPACK_IMPORTED_MODULE_0__.Events.KEY_LOADING, (this || _global).onKeyLoading, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  (this || _global).hls.off(_events__WEBPACK_IMPORTED_MODULE_0__.Events.KEY_LOADING, (this || _global).onKeyLoading);
                };
                _proto.destroyInternalLoaders = function destroyInternalLoaders() {
                  for (var loaderName in (this || _global).loaders) {
                    var loader = (this || _global).loaders[loaderName];
                    if (loader) {
                      loader.destroy();
                    }
                  }
                  (this || _global).loaders = {};
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  this.destroyInternalLoaders();
                };
                _proto.onKeyLoading = function onKeyLoading(event, data) {
                  var frag = data.frag;
                  var type = frag.type;
                  var loader = (this || _global).loaders[type];
                  if (!frag.decryptdata) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("Missing decryption data on fragment in onKeyLoading");
                    return;
                  }

                  // Load the key if the uri is different from previous one, or if the decrypt key has not yet been retrieved
                  var uri = frag.decryptdata.uri;
                  if (uri !== (this || _global).decrypturl || (this || _global).decryptkey === null) {
                    var config = (this || _global).hls.config;
                    if (loader) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("abort previous key loader for type:" + type);
                      loader.abort();
                    }
                    if (!uri) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.warn("key uri is falsy");
                      return;
                    }
                    var Loader = config.loader;
                    var fragLoader = frag.loader = (this || _global).loaders[type] = new Loader(config);
                    (this || _global).decrypturl = uri;
                    (this || _global).decryptkey = null;
                    var loaderContext = {
                      url: uri,
                      frag: frag,
                      responseType: "arraybuffer"
                    };

                    // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
                    // key-loader will trigger an error and rely on stream-controller to handle retry logic.
                    // this will also align retry logic with fragment-loader
                    var loaderConfig = {
                      timeout: config.fragLoadingTimeOut,
                      maxRetry: 0,
                      retryDelay: config.fragLoadingRetryDelay,
                      maxRetryDelay: config.fragLoadingMaxRetryTimeout,
                      highWaterMark: 0
                    };
                    var loaderCallbacks = {
                      onSuccess: (this || _global).loadsuccess.bind(this || _global),
                      onError: (this || _global).loaderror.bind(this || _global),
                      onTimeout: (this || _global).loadtimeout.bind(this || _global)
                    };
                    fragLoader.load(loaderContext, loaderConfig, loaderCallbacks);
                  } else if ((this || _global).decryptkey) {
                    // Return the key if it's already been loaded
                    frag.decryptdata.key = (this || _global).decryptkey;
                    (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.KEY_LOADED, {
                      frag: frag
                    });
                  }
                };
                _proto.loadsuccess = function loadsuccess(response, stats, context) {
                  var frag = context.frag;
                  if (!frag.decryptdata) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_2__.logger.error("after key load, decryptdata unset");
                    return;
                  }
                  (this || _global).decryptkey = frag.decryptdata.key = new Uint8Array(response.data);

                  // detach fragment loader on load success
                  frag.loader = null;
                  delete (this || _global).loaders[frag.type];
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.KEY_LOADED, {
                    frag: frag
                  });
                };
                _proto.loaderror = function loaderror(response, context) {
                  var frag = context.frag;
                  var loader = frag.loader;
                  if (loader) {
                    loader.abort();
                  }
                  delete (this || _global).loaders[frag.type];
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                    type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                    details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_LOAD_ERROR,
                    fatal: false,
                    frag: frag,
                    response: response
                  });
                };
                _proto.loadtimeout = function loadtimeout(stats, context) {
                  var frag = context.frag;
                  var loader = frag.loader;
                  if (loader) {
                    loader.abort();
                  }
                  delete (this || _global).loaders[frag.type];
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_0__.Events.ERROR, {
                    type: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorTypes.NETWORK_ERROR,
                    details: _errors__WEBPACK_IMPORTED_MODULE_1__.ErrorDetails.KEY_LOAD_TIMEOUT,
                    fatal: false,
                    frag: frag
                  });
                };
                return KeyLoader;
              }();

              /***/
            },

            /***/"./src/loader/level-details.ts":
            /*!*************************************!*\
              !*** ./src/loader/level-details.ts ***!
              \*************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"LevelDetails": () => /* binding */LevelDetails
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var DEFAULT_TARGET_DURATION = 10;
              var LevelDetails = /*#__PURE__*/function () {
                // Manifest reload synchronization

                function LevelDetails(baseUrl) {
                  (this || _global).PTSKnown = false;
                  (this || _global).alignedSliding = false;
                  (this || _global).averagetargetduration = void 0;
                  (this || _global).endCC = 0;
                  (this || _global).endSN = 0;
                  (this || _global).fragments = void 0;
                  (this || _global).fragmentHint = void 0;
                  (this || _global).partList = null;
                  (this || _global).dateRanges = void 0;
                  (this || _global).live = true;
                  (this || _global).ageHeader = 0;
                  (this || _global).advancedDateTime = void 0;
                  (this || _global).updated = true;
                  (this || _global).advanced = true;
                  (this || _global).availabilityDelay = void 0;
                  (this || _global).misses = 0;
                  (this || _global).needSidxRanges = false;
                  (this || _global).startCC = 0;
                  (this || _global).startSN = 0;
                  (this || _global).startTimeOffset = null;
                  (this || _global).targetduration = 0;
                  (this || _global).totalduration = 0;
                  (this || _global).type = null;
                  (this || _global).url = void 0;
                  (this || _global).m3u8 = "";
                  (this || _global).version = null;
                  (this || _global).canBlockReload = false;
                  (this || _global).canSkipUntil = 0;
                  (this || _global).canSkipDateRanges = false;
                  (this || _global).skippedSegments = 0;
                  (this || _global).recentlyRemovedDateranges = void 0;
                  (this || _global).partHoldBack = 0;
                  (this || _global).holdBack = 0;
                  (this || _global).partTarget = 0;
                  (this || _global).preloadHint = void 0;
                  (this || _global).renditionReports = void 0;
                  (this || _global).tuneInGoal = 0;
                  (this || _global).deltaUpdateFailed = void 0;
                  (this || _global).driftStartTime = 0;
                  (this || _global).driftEndTime = 0;
                  (this || _global).driftStart = 0;
                  (this || _global).driftEnd = 0;
                  (this || _global).fragments = [];
                  (this || _global).dateRanges = {};
                  (this || _global).url = baseUrl;
                }
                var _proto = LevelDetails.prototype;
                _proto.reloaded = function reloaded(previous) {
                  if (!previous) {
                    (this || _global).advanced = true;
                    (this || _global).updated = true;
                    return;
                  }
                  var partSnDiff = (this || _global).lastPartSn - previous.lastPartSn;
                  var partIndexDiff = (this || _global).lastPartIndex - previous.lastPartIndex;
                  (this || _global).updated = (this || _global).endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff;
                  (this || _global).advanced = (this || _global).endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
                  if ((this || _global).updated || (this || _global).advanced) {
                    (this || _global).misses = Math.floor(previous.misses * 0.6);
                  } else {
                    (this || _global).misses = previous.misses + 1;
                  }
                  (this || _global).availabilityDelay = previous.availabilityDelay;
                };
                _createClass(LevelDetails, [{
                  key: "hasProgramDateTime",
                  get: function get() {
                    if ((this || _global).fragments.length) {
                      return (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global).fragments[(this || _global).fragments.length - 1].programDateTime);
                    }
                    return false;
                  }
                }, {
                  key: "levelTargetDuration",
                  get: function get() {
                    return (this || _global).averagetargetduration || (this || _global).targetduration || DEFAULT_TARGET_DURATION;
                  }
                }, {
                  key: "drift",
                  get: function get() {
                    var runTime = (this || _global).driftEndTime - (this || _global).driftStartTime;
                    if (runTime > 0) {
                      var runDuration = (this || _global).driftEnd - (this || _global).driftStart;
                      return runDuration * 1000 / runTime;
                    }
                    return 1;
                  }
                }, {
                  key: "edge",
                  get: function get() {
                    return (this || _global).partEnd || (this || _global).fragmentEnd;
                  }
                }, {
                  key: "partEnd",
                  get: function get() {
                    var _this$partList;
                    if ((_this$partList = (this || _global).partList) !== null && _this$partList !== void 0 && _this$partList.length) {
                      return (this || _global).partList[(this || _global).partList.length - 1].end;
                    }
                    return (this || _global).fragmentEnd;
                  }
                }, {
                  key: "fragmentEnd",
                  get: function get() {
                    var _this$fragments;
                    if ((_this$fragments = (this || _global).fragments) !== null && _this$fragments !== void 0 && _this$fragments.length) {
                      return (this || _global).fragments[(this || _global).fragments.length - 1].end;
                    }
                    return 0;
                  }
                }, {
                  key: "age",
                  get: function get() {
                    if ((this || _global).advancedDateTime) {
                      return Math.max(Date.now() - (this || _global).advancedDateTime, 0) / 1000;
                    }
                    return 0;
                  }
                }, {
                  key: "lastPartIndex",
                  get: function get() {
                    var _this$partList2;
                    if ((_this$partList2 = (this || _global).partList) !== null && _this$partList2 !== void 0 && _this$partList2.length) {
                      return (this || _global).partList[(this || _global).partList.length - 1].index;
                    }
                    return -1;
                  }
                }, {
                  key: "lastPartSn",
                  get: function get() {
                    var _this$partList3;
                    if ((_this$partList3 = (this || _global).partList) !== null && _this$partList3 !== void 0 && _this$partList3.length) {
                      return (this || _global).partList[(this || _global).partList.length - 1].fragment.sn;
                    }
                    return (this || _global).endSN;
                  }
                }]);
                return LevelDetails;
              }();

              /***/
            },

            /***/"./src/loader/level-key.ts":
            /*!*********************************!*\
              !*** ./src/loader/level-key.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"LevelKey": () => /* binding */LevelKey
                /* harmony export */
              });
              /* harmony import */
              var url_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! url-toolkit */"./node_modules/url-toolkit/src/url-toolkit.js");
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var LevelKey = /*#__PURE__*/function () {
                LevelKey.fromURL = function fromURL(baseUrl, relativeUrl) {
                  return new LevelKey(baseUrl, relativeUrl);
                };
                LevelKey.fromURI = function fromURI(uri) {
                  return new LevelKey(uri);
                };
                function LevelKey(absoluteOrBaseURI, relativeURL) {
                  (this || _global)._uri = null;
                  (this || _global).method = null;
                  (this || _global).keyFormat = null;
                  (this || _global).keyFormatVersions = null;
                  (this || _global).keyID = null;
                  (this || _global).key = null;
                  (this || _global).iv = null;
                  if (relativeURL) {
                    (this || _global)._uri = (0, url_toolkit__WEBPACK_IMPORTED_MODULE_0__.buildAbsoluteURL)(absoluteOrBaseURI, relativeURL, {
                      alwaysNormalize: true
                    });
                  } else {
                    (this || _global)._uri = absoluteOrBaseURI;
                  }
                }
                _createClass(LevelKey, [{
                  key: "uri",
                  get: function get() {
                    return (this || _global)._uri;
                  }
                }]);
                return LevelKey;
              }();

              /***/
            },

            /***/"./src/loader/load-stats.ts":
            /*!**********************************!*\
              !*** ./src/loader/load-stats.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"LoadStats": () => /* binding */LoadStats
                /* harmony export */
              });
              var LoadStats = function LoadStats() {
                (this || _global).aborted = false;
                (this || _global).loaded = 0;
                (this || _global).retry = 0;
                (this || _global).total = 0;
                (this || _global).chunkCount = 0;
                (this || _global).bwEstimate = 0;
                (this || _global).loading = {
                  start: 0,
                  first: 0,
                  end: 0
                };
                (this || _global).parsing = {
                  start: 0,
                  end: 0
                };
                (this || _global).buffering = {
                  start: 0,
                  first: 0,
                  end: 0
                };
              };

              /***/
            },

            /***/"./src/loader/m3u8-parser.ts":
            /*!***********************************!*\
              !*** ./src/loader/m3u8-parser.ts ***!
              \***********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */M3U8Parser
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var url_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! url-toolkit */"./node_modules/url-toolkit/src/url-toolkit.js");
              /* harmony import */
              var _date_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./date-range */"./src/loader/date-range.ts");
              /* harmony import */
              var _fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _level_details__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./level-details */"./src/loader/level-details.ts");
              /* harmony import */
              var _level_key__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./level-key */"./src/loader/level-key.ts");
              /* harmony import */
              var _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../utils/attr-list */"./src/utils/attr-list.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _utils_codecs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__( /*! ../utils/codecs */"./src/utils/codecs.ts");

              // https://regex101.com is your friend
              var MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-SESSION-DATA:([^\r\n]*)[\r\n]+/g;
              var MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
              var LEVEL_PLAYLIST_REGEX_FAST = new RegExp([/#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
              // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
              /(?!#) *(\S[\S ]*)/.source,
              // segment URI, group 3 => the URI (note newline is not eaten)
              /#EXT-X-BYTERANGE:*(.+)/.source,
              // next segment's byterange, group 4 => range spec (x@y)
              /#EXT-X-PROGRAM-DATE-TIME:(.+)/.source,
              // next segment's program date/time group 5 => the datetime spec
              /#.*/.source // All other non-segment oriented tags will match with all groups empty
              ].join("|"), "g");
              var LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([/#(EXTM3U)/.source, /#EXT-X-(DATERANGE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|"0.5.0"): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
              var MP4_REGEX_SUFFIX = /\.(mp4|m4s|m4v|m4a)$/i;
              function isMP4Url(url) {
                var _URLToolkit$parseURL$, _URLToolkit$parseURL;
                return MP4_REGEX_SUFFIX.test((_URLToolkit$parseURL$ = (_URLToolkit$parseURL = url_toolkit__WEBPACK_IMPORTED_MODULE_1__.parseURL(url)) === null || _URLToolkit$parseURL === void 0 ? void 0 : _URLToolkit$parseURL.path) != null ? _URLToolkit$parseURL$ : "");
              }
              var M3U8Parser = /*#__PURE__*/function () {
                function M3U8Parser() {}
                M3U8Parser.findGroup = function findGroup(groups, mediaGroupId) {
                  for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    if (group.id === mediaGroupId) {
                      return group;
                    }
                  }
                };
                M3U8Parser.convertAVC1ToAVCOTI = function convertAVC1ToAVCOTI(codec) {
                  // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
                  var avcdata = codec.split(".");
                  if (avcdata.length > 2) {
                    var result = avcdata.shift() + ".";
                    result += parseInt(avcdata.shift()).toString(16);
                    result += ("000" + parseInt(avcdata.shift()).toString(16)).slice(-4);
                    return result;
                  }
                  return codec;
                };
                M3U8Parser.resolve = function resolve(url, baseUrl) {
                  return url_toolkit__WEBPACK_IMPORTED_MODULE_1__.buildAbsoluteURL(baseUrl, url, {
                    alwaysNormalize: true
                  });
                };
                M3U8Parser.parseMasterPlaylist = function parseMasterPlaylist(string, baseurl) {
                  var levels = [];
                  var levelsWithKnownCodecs = [];
                  var sessionData = {};
                  var hasSessionData = false;
                  MASTER_PLAYLIST_REGEX.lastIndex = 0;
                  var result;
                  while ((result = MASTER_PLAYLIST_REGEX.exec(string)) != null) {
                    if (result[1]) {
                      var _level$unknownCodecs;
                      // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
                      var attrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(result[1]);
                      var level = {
                        attrs: attrs,
                        bitrate: attrs.decimalInteger("AVERAGE-BANDWIDTH") || attrs.decimalInteger("BANDWIDTH"),
                        name: attrs.NAME,
                        url: M3U8Parser.resolve(result[2], baseurl)
                      };
                      var resolution = attrs.decimalResolution("RESOLUTION");
                      if (resolution) {
                        level.width = resolution.width;
                        level.height = resolution.height;
                      }
                      setCodecs((attrs.CODECS || "").split(/[ ,]+/).filter(function (c) {
                        return c;
                      }), level);
                      if (level.videoCodec && level.videoCodec.indexOf("avc1") !== -1) {
                        level.videoCodec = M3U8Parser.convertAVC1ToAVCOTI(level.videoCodec);
                      }
                      if (!((_level$unknownCodecs = level.unknownCodecs) !== null && _level$unknownCodecs !== void 0 && _level$unknownCodecs.length)) {
                        levelsWithKnownCodecs.push(level);
                      }
                      levels.push(level);
                    } else if (result[3]) {
                      // '#EXT-X-SESSION-DATA' is found, parse session data in group 3
                      var sessionAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(result[3]);
                      if (sessionAttrs["DATA-ID"]) {
                        hasSessionData = true;
                        sessionData[sessionAttrs["DATA-ID"]] = sessionAttrs;
                      }
                    }
                  }
                  // Filter out levels with unknown codecs if it does not remove all levels
                  var stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < levels.length;
                  return {
                    levels: stripUnknownCodecLevels ? levelsWithKnownCodecs : levels,
                    sessionData: hasSessionData ? sessionData : null
                  };
                };
                M3U8Parser.parseMasterPlaylistMedia = function parseMasterPlaylistMedia(string, baseurl, type, groups) {
                  if (groups === void 0) {
                    groups = [];
                  }
                  var result;
                  var medias = [];
                  var id = 0;
                  MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
                  while ((result = MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null) {
                    var attrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(result[1]);
                    if (attrs.TYPE === type) {
                      var media = {
                        attrs: attrs,
                        bitrate: 0,
                        id: id++,
                        groupId: attrs["GROUP-ID"],
                        instreamId: attrs["INSTREAM-ID"],
                        name: attrs.NAME || attrs.LANGUAGE || "",
                        type: type,
                        default: attrs.bool("DEFAULT"),
                        autoselect: attrs.bool("AUTOSELECT"),
                        forced: attrs.bool("FORCED"),
                        lang: attrs.LANGUAGE,
                        url: attrs.URI ? M3U8Parser.resolve(attrs.URI, baseurl) : ""
                      };
                      if (groups.length) {
                        // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
                        // If we don't find the track signalled, lets use the first audio groups codec we have
                        // Acting as a best guess
                        var groupCodec = M3U8Parser.findGroup(groups, media.groupId) || groups[0];
                        assignCodec(media, groupCodec, "audioCodec");
                        assignCodec(media, groupCodec, "textCodec");
                      }
                      medias.push(media);
                    }
                  }
                  return medias;
                };
                M3U8Parser.parseLevelPlaylist = function parseLevelPlaylist(string, baseurl, id, type, levelUrlId) {
                  var level = new _level_details__WEBPACK_IMPORTED_MODULE_4__.LevelDetails(baseurl);
                  var fragments = level.fragments;
                  // The most recent init segment seen (applies to all subsequent segments)
                  var currentInitSegment = null;
                  var currentSN = 0;
                  var currentPart = 0;
                  var totalduration = 0;
                  var discontinuityCounter = 0;
                  var prevFrag = null;
                  var frag = new _fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment(type, baseurl);
                  var result;
                  var i;
                  var levelkey;
                  var firstPdtIndex = -1;
                  var createNextFrag = false;
                  LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
                  level.m3u8 = string;
                  while ((result = LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null) {
                    if (createNextFrag) {
                      createNextFrag = false;
                      frag = new _fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment(type, baseurl);
                      // setup the next fragment for part loading
                      frag.start = totalduration;
                      frag.sn = currentSN;
                      frag.cc = discontinuityCounter;
                      frag.level = id;
                      if (currentInitSegment) {
                        frag.initSegment = currentInitSegment;
                        frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                        currentInitSegment.rawProgramDateTime = null;
                      }
                    }
                    var duration = result[1];
                    if (duration) {
                      // INF
                      frag.duration = parseFloat(duration);
                      // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                      var title = (" " + result[2]).slice(1);
                      frag.title = title || null;
                      frag.tagList.push(title ? ["INF", duration, title] : ["INF", duration]);
                    } else if (result[3]) {
                      // url
                      if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.duration)) {
                        frag.start = totalduration;
                        if (levelkey) {
                          frag.levelkey = levelkey;
                        }
                        frag.sn = currentSN;
                        frag.level = id;
                        frag.cc = discontinuityCounter;
                        frag.urlId = levelUrlId;
                        fragments.push(frag);
                        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                        frag.relurl = (" " + result[3]).slice(1);
                        assignProgramDateTime(frag, prevFrag);
                        prevFrag = frag;
                        totalduration += frag.duration;
                        currentSN++;
                        currentPart = 0;
                        createNextFrag = true;
                      }
                    } else if (result[4]) {
                      // X-BYTERANGE
                      var data = (" " + result[4]).slice(1);
                      if (prevFrag) {
                        frag.setByteRange(data, prevFrag);
                      } else {
                        frag.setByteRange(data);
                      }
                    } else if (result[5]) {
                      // PROGRAM-DATE-TIME
                      // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                      frag.rawProgramDateTime = (" " + result[5]).slice(1);
                      frag.tagList.push(["PROGRAM-DATE-TIME", frag.rawProgramDateTime]);
                      if (firstPdtIndex === -1) {
                        firstPdtIndex = fragments.length;
                      }
                    } else {
                      result = result[0].match(LEVEL_PLAYLIST_REGEX_SLOW);
                      if (!result) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_7__.logger.warn("No matches on slow regex match for level playlist!");
                        continue;
                      }
                      for (i = 1; i < result.length; i++) {
                        if (typeof result[i] !== "undefined") {
                          break;
                        }
                      }

                      // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                      var tag = (" " + result[i]).slice(1);
                      var value1 = (" " + result[i + 1]).slice(1);
                      var value2 = result[i + 2] ? (" " + result[i + 2]).slice(1) : "";
                      switch (tag) {
                        case "PLAYLIST-TYPE":
                          level.type = value1.toUpperCase();
                          break;
                        case "MEDIA-SEQUENCE":
                          currentSN = level.startSN = parseInt(value1);
                          break;
                        case "SKIP":
                          {
                            var skipAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            var skippedSegments = skipAttrs.decimalInteger("SKIPPED-SEGMENTS");
                            if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(skippedSegments)) {
                              level.skippedSegments = skippedSegments;
                              // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                              for (var _i = skippedSegments; _i--;) {
                                fragments.unshift(null);
                              }
                              currentSN += skippedSegments;
                            }
                            var recentlyRemovedDateranges = skipAttrs.enumeratedString("RECENTLY-REMOVED-DATERANGES");
                            if (recentlyRemovedDateranges) {
                              level.recentlyRemovedDateranges = recentlyRemovedDateranges.split("\t");
                            }
                            break;
                          }
                        case "TARGETDURATION":
                          level.targetduration = parseFloat(value1);
                          break;
                        case "\"0.5.0\"":
                          level.version = parseInt(value1);
                          break;
                        case "EXTM3U":
                          break;
                        case "ENDLIST":
                          level.live = false;
                          break;
                        case "#":
                          if (value1 || value2) {
                            frag.tagList.push(value2 ? [value1, value2] : [value1]);
                          }
                          break;
                        case "DISCONTINUITY":
                          discontinuityCounter++;
                          frag.tagList.push(["DIS"]);
                          break;
                        case "GAP":
                          frag.tagList.push([tag]);
                          break;
                        case "BITRATE":
                          frag.tagList.push([tag, value1]);
                          break;
                        case "DATERANGE":
                          {
                            var dateRangeAttr = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            var dateRange = new _date_range__WEBPACK_IMPORTED_MODULE_2__.DateRange(dateRangeAttr, level.dateRanges[dateRangeAttr.ID]);
                            if (dateRange.isValid || level.skippedSegments) {
                              level.dateRanges[dateRange.id] = dateRange;
                            } else {
                              _utils_logger__WEBPACK_IMPORTED_MODULE_7__.logger.warn("Ignoring invalid DATERANGE tag: \"" + value1 + "\"");
                            }
                            // Add to fragment tag list for backwards compatibility (< v1.2.0)
                            frag.tagList.push(["EXT-X-DATERANGE", value1]);
                            break;
                          }
                        case "DISCONTINUITY-SEQUENCE":
                          discontinuityCounter = parseInt(value1);
                          break;
                        case "KEY":
                          {
                            var _keyAttrs$enumeratedS;
                            // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
                            var keyAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            var decryptmethod = keyAttrs.enumeratedString("METHOD");
                            var decrypturi = keyAttrs.URI;
                            var decryptiv = keyAttrs.hexadecimalInteger("IV");
                            var decryptkeyformatversions = keyAttrs.enumeratedString("KEYFORMATVERSIONS");
                            var decryptkeyid = keyAttrs.enumeratedString("KEYID");
                            // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
                            var decryptkeyformat = (_keyAttrs$enumeratedS = keyAttrs.enumeratedString("KEYFORMAT")) != null ? _keyAttrs$enumeratedS : "identity";
                            var unsupportedKnownKeyformatsInManifest = ["com.apple.streamingkeydelivery", "com.microsoft.playready", "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed",
                            // widevine (v2)
                            "com.widevine" // earlier widevine (v1)
                            ];

                            if (unsupportedKnownKeyformatsInManifest.indexOf(decryptkeyformat) > -1) {
                              _utils_logger__WEBPACK_IMPORTED_MODULE_7__.logger.warn("Keyformat " + decryptkeyformat + " is not supported from the manifest");
                              continue;
                            } else if (decryptkeyformat !== "identity") {
                              // We are supposed to skip keys we don't understand.
                              // As we currently only officially support identity keys
                              // from the manifest we shouldn't save any other key.
                              continue;
                            }

                            // TODO: multiple keys can be defined on a fragment, and we need to support this
                            // for clients that support both playready and widevine
                            if (decryptmethod) {
                              // TODO: need to determine if the level key is actually a relative URL
                              // if it isn't, then we should instead construct the LevelKey using fromURI.
                              levelkey = _level_key__WEBPACK_IMPORTED_MODULE_5__.LevelKey.fromURL(baseurl, decrypturi);
                              if (decrypturi && ["AES-128", "SAMPLE-AES", "SAMPLE-AES-CENC"].indexOf(decryptmethod) >= 0) {
                                levelkey.method = decryptmethod;
                                levelkey.keyFormat = decryptkeyformat;
                                if (decryptkeyid) {
                                  levelkey.keyID = decryptkeyid;
                                }
                                if (decryptkeyformatversions) {
                                  levelkey.keyFormatVersions = decryptkeyformatversions;
                                }

                                // Initialization Vector (IV)
                                levelkey.iv = decryptiv;
                              }
                            }
                            break;
                          }
                        case "START":
                          {
                            var startAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            var startTimeOffset = startAttrs.decimalFloatingPoint("TIME-OFFSET");
                            // TIME-OFFSET can be 0
                            if ((0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(startTimeOffset)) {
                              level.startTimeOffset = startTimeOffset;
                            }
                            break;
                          }
                        case "MAP":
                          {
                            var mapAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            if (frag.duration) {
                              // Initial segment tag is after segment duration tag.
                              //   #EXTINF: 6.0
                              //   #EXT-X-MAP:URI="init.mp4
                              var init = new _fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment(type, baseurl);
                              setInitSegment(init, mapAttrs, id, levelkey);
                              currentInitSegment = init;
                              frag.initSegment = currentInitSegment;
                              if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) {
                                frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                              }
                            } else {
                              // Initial segment tag is before segment duration tag
                              setInitSegment(frag, mapAttrs, id, levelkey);
                              currentInitSegment = frag;
                              createNextFrag = true;
                            }
                            break;
                          }
                        case "SERVER-CONTROL":
                          {
                            var serverControlAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            level.canBlockReload = serverControlAttrs.bool("CAN-BLOCK-RELOAD");
                            level.canSkipUntil = serverControlAttrs.optionalFloat("CAN-SKIP-UNTIL", 0);
                            level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool("CAN-SKIP-DATERANGES");
                            level.partHoldBack = serverControlAttrs.optionalFloat("PART-HOLD-BACK", 0);
                            level.holdBack = serverControlAttrs.optionalFloat("HOLD-BACK", 0);
                            break;
                          }
                        case "PART-INF":
                          {
                            var partInfAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            level.partTarget = partInfAttrs.decimalFloatingPoint("PART-TARGET");
                            break;
                          }
                        case "PART":
                          {
                            var partList = level.partList;
                            if (!partList) {
                              partList = level.partList = [];
                            }
                            var previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
                            var index = currentPart++;
                            var part = new _fragment__WEBPACK_IMPORTED_MODULE_3__.Part(new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1), frag, baseurl, index, previousFragmentPart);
                            partList.push(part);
                            frag.duration += part.duration;
                            break;
                          }
                        case "PRELOAD-HINT":
                          {
                            var preloadHintAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            level.preloadHint = preloadHintAttrs;
                            break;
                          }
                        case "RENDITION-REPORT":
                          {
                            var renditionReportAttrs = new _utils_attr_list__WEBPACK_IMPORTED_MODULE_6__.AttrList(value1);
                            level.renditionReports = level.renditionReports || [];
                            level.renditionReports.push(renditionReportAttrs);
                            break;
                          }
                        default:
                          _utils_logger__WEBPACK_IMPORTED_MODULE_7__.logger.warn("line parsed but not handled: " + result);
                          break;
                      }
                    }
                  }
                  if (prevFrag && !prevFrag.relurl) {
                    fragments.pop();
                    totalduration -= prevFrag.duration;
                    if (level.partList) {
                      level.fragmentHint = prevFrag;
                    }
                  } else if (level.partList) {
                    assignProgramDateTime(frag, prevFrag);
                    frag.cc = discontinuityCounter;
                    level.fragmentHint = frag;
                  }
                  var fragmentLength = fragments.length;
                  var firstFragment = fragments[0];
                  var lastFragment = fragments[fragmentLength - 1];
                  totalduration += level.skippedSegments * level.targetduration;
                  if (totalduration > 0 && fragmentLength && lastFragment) {
                    level.averagetargetduration = totalduration / fragmentLength;
                    var lastSn = lastFragment.sn;
                    level.endSN = lastSn !== "initSegment" ? lastSn : 0;
                    if (firstFragment) {
                      level.startCC = firstFragment.cc;
                      if (!firstFragment.initSegment) {
                        // this is a bit lurky but HLS really has no other way to tell us
                        // if the fragments are TS or MP4, except if we download them :/
                        // but this is to be able to handle SIDX.
                        if (level.fragments.every(function (frag) {
                          return frag.relurl && isMP4Url(frag.relurl);
                        })) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_7__.logger.warn("MP4 fragments found but no init segment (probably no MAP, incomplete M3U8), trying to fetch SIDX");
                          frag = new _fragment__WEBPACK_IMPORTED_MODULE_3__.Fragment(type, baseurl);
                          frag.relurl = lastFragment.relurl;
                          frag.level = id;
                          frag.sn = "initSegment";
                          firstFragment.initSegment = frag;
                          level.needSidxRanges = true;
                        }
                      }
                    }
                  } else {
                    level.endSN = 0;
                    level.startCC = 0;
                  }
                  if (level.fragmentHint) {
                    totalduration += level.fragmentHint.duration;
                  }
                  level.totalduration = totalduration;
                  level.endCC = discontinuityCounter;

                  /**
                   * Backfill any missing PDT values
                   * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
                   * one or more Media Segment URIs, the client SHOULD extrapolate
                   * backward from that tag (using EXTINF durations and/or media
                   * timestamps) to associate dates with those segments."
                   * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
                   * computed.
                   */
                  if (firstPdtIndex > 0) {
                    backfillProgramDateTimes(fragments, firstPdtIndex);
                  }
                  return level;
                };
                return M3U8Parser;
              }();
              function setCodecs(codecs, level) {
                ["video", "audio", "text"].forEach(function (type) {
                  var filtered = codecs.filter(function (codec) {
                    return (0, _utils_codecs__WEBPACK_IMPORTED_MODULE_8__.isCodecType)(codec, type);
                  });
                  if (filtered.length) {
                    var preferred = filtered.filter(function (codec) {
                      return codec.lastIndexOf("avc1", 0) === 0 || codec.lastIndexOf("mp4a", 0) === 0;
                    });
                    level[type + "Codec"] = preferred.length > 0 ? preferred[0] : filtered[0];

                    // remove from list
                    codecs = codecs.filter(function (codec) {
                      return filtered.indexOf(codec) === -1;
                    });
                  }
                });
                level.unknownCodecs = codecs;
              }
              function assignCodec(media, groupItem, codecProperty) {
                var codecValue = groupItem[codecProperty];
                if (codecValue) {
                  media[codecProperty] = codecValue;
                }
              }
              function backfillProgramDateTimes(fragments, firstPdtIndex) {
                var fragPrev = fragments[firstPdtIndex];
                for (var i = firstPdtIndex; i--;) {
                  var frag = fragments[i];
                  // Exit on delta-playlist skipped segments
                  if (!frag) {
                    return;
                  }
                  frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
                  fragPrev = frag;
                }
              }
              function assignProgramDateTime(frag, prevFrag) {
                if (frag.rawProgramDateTime) {
                  frag.programDateTime = Date.parse(frag.rawProgramDateTime);
                } else if (prevFrag !== null && prevFrag !== void 0 && prevFrag.programDateTime) {
                  frag.programDateTime = prevFrag.endProgramDateTime;
                }
                if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(frag.programDateTime)) {
                  frag.programDateTime = null;
                  frag.rawProgramDateTime = null;
                }
              }
              function setInitSegment(frag, mapAttrs, id, levelkey) {
                frag.relurl = mapAttrs.URI;
                if (mapAttrs.BYTERANGE) {
                  frag.setByteRange(mapAttrs.BYTERANGE);
                }
                frag.level = id;
                frag.sn = "initSegment";
                if (levelkey) {
                  frag.levelkey = levelkey;
                }
                frag.initSegment = null;
              }

              /***/
            },

            /***/"./src/loader/playlist-loader.ts":
            /*!***************************************!*\
              !*** ./src/loader/playlist-loader.ts ***!
              \***************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./m3u8-parser */"./src/loader/m3u8-parser.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _utils_attr_list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../utils/attr-list */"./src/utils/attr-list.ts");

              /**
               * PlaylistLoader - delegate for media manifest/playlist loading tasks. Takes care of parsing media to internal data-models.
               *
               * Once loaded, dispatches events with parsed data-models of manifest/levels/audio/subtitle tracks.
               *
               * Uses loader(s) set in config to do actual internal loading of resource tasks.
               *
               * @module
               *
               */

              function mapContextToLevelType(context) {
                var type = context.type;
                switch (type) {
                  case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK:
                    return _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO;
                  case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK:
                    return _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.SUBTITLE;
                  default:
                    return _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.MAIN;
                }
              }
              function getResponseUrl(response, context) {
                var url = response.url;
                // responseURL not supported on some browsers (it is used to detect URL redirection)
                // data-uri mode also not supported (but no need to detect redirection)
                if (url === undefined || url.indexOf("data:") === 0) {
                  // fallback to initial URL
                  url = context.url;
                }
                return url;
              }
              var PlaylistLoader = /*#__PURE__*/function () {
                function PlaylistLoader(hls) {
                  (this || _global).hls = void 0;
                  (this || _global).loaders = Object.create(null);
                  (this || _global).hls = hls;
                  this.registerListeners();
                }
                var _proto = PlaylistLoader.prototype;
                _proto.startLoad = function startLoad(startPosition) {};
                _proto.stopLoad = function stopLoad() {
                  this.destroyInternalLoaders();
                };
                _proto.registerListeners = function registerListeners() {
                  var hls = (this || _global).hls;
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.AUDIO_TRACK_LOADING, (this || _global).onAudioTrackLoading, this || _global);
                  hls.on(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACK_LOADING, (this || _global).onSubtitleTrackLoading, this || _global);
                };
                _proto.unregisterListeners = function unregisterListeners() {
                  var hls = (this || _global).hls;
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADING, (this || _global).onManifestLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADING, (this || _global).onLevelLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.AUDIO_TRACK_LOADING, (this || _global).onAudioTrackLoading, this || _global);
                  hls.off(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACK_LOADING, (this || _global).onSubtitleTrackLoading, this || _global);
                }

                /**
                 * Returns defaults or configured loader-type overloads (pLoader and loader config params)
                 */;
                _proto.createInternalLoader = function createInternalLoader(context) {
                  var config = (this || _global).hls.config;
                  var PLoader = config.pLoader;
                  var Loader = config.loader;
                  var InternalLoader = PLoader || Loader;
                  var loader = new InternalLoader(config);
                  context.loader = loader;
                  (this || _global).loaders[context.type] = loader;
                  return loader;
                };
                _proto.getInternalLoader = function getInternalLoader(context) {
                  return (this || _global).loaders[context.type];
                };
                _proto.resetInternalLoader = function resetInternalLoader(contextType) {
                  if ((this || _global).loaders[contextType]) {
                    delete (this || _global).loaders[contextType];
                  }
                }

                /**
                 * Call `destroy` on all internal loader instances mapped (one per context type)
                 */;
                _proto.destroyInternalLoaders = function destroyInternalLoaders() {
                  for (var contextType in (this || _global).loaders) {
                    var loader = (this || _global).loaders[contextType];
                    if (loader) {
                      loader.destroy();
                    }
                    this.resetInternalLoader(contextType);
                  }
                };
                _proto.destroy = function destroy() {
                  this.unregisterListeners();
                  this.destroyInternalLoaders();
                };
                _proto.onManifestLoading = function onManifestLoading(event, data) {
                  var url = data.url;
                  this.load({
                    id: null,
                    groupId: null,
                    level: 0,
                    responseType: "text",
                    type: _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST,
                    url: url,
                    deliveryDirectives: null
                  });
                };
                _proto.onLevelLoading = function onLevelLoading(event, data) {
                  var id = data.id,
                    level = data.level,
                    url = data.url,
                    deliveryDirectives = data.deliveryDirectives;
                  this.load({
                    id: id,
                    groupId: null,
                    level: level,
                    responseType: "text",
                    type: _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.LEVEL,
                    url: url,
                    deliveryDirectives: deliveryDirectives
                  });
                };
                _proto.onAudioTrackLoading = function onAudioTrackLoading(event, data) {
                  var id = data.id,
                    groupId = data.groupId,
                    url = data.url,
                    deliveryDirectives = data.deliveryDirectives;
                  this.load({
                    id: id,
                    groupId: groupId,
                    level: null,
                    responseType: "text",
                    type: _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK,
                    url: url,
                    deliveryDirectives: deliveryDirectives
                  });
                };
                _proto.onSubtitleTrackLoading = function onSubtitleTrackLoading(event, data) {
                  var id = data.id,
                    groupId = data.groupId,
                    url = data.url,
                    deliveryDirectives = data.deliveryDirectives;
                  this.load({
                    id: id,
                    groupId: groupId,
                    level: null,
                    responseType: "text",
                    type: _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK,
                    url: url,
                    deliveryDirectives: deliveryDirectives
                  });
                };
                _proto.load = function load(context) {
                  var _context$deliveryDire;
                  var config = (this || _global).hls.config;

                  // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);

                  // Check if a loader for this context already exists
                  var loader = this.getInternalLoader(context);
                  if (loader) {
                    var loaderContext = loader.context;
                    if (loaderContext && loaderContext.url === context.url) {
                      // same URL can't overlap
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.trace("[playlist-loader]: playlist request ongoing");
                      return;
                    }
                    _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log("[playlist-loader]: aborting previous loader for type: " + context.type);
                    loader.abort();
                  }
                  var maxRetry;
                  var timeout;
                  var retryDelay;
                  var maxRetryDelay;

                  // apply different configs for retries depending on
                  // context (manifest, level, audio/subs playlist)
                  switch (context.type) {
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST:
                      maxRetry = config.manifestLoadingMaxRetry;
                      timeout = config.manifestLoadingTimeOut;
                      retryDelay = config.manifestLoadingRetryDelay;
                      maxRetryDelay = config.manifestLoadingMaxRetryTimeout;
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.LEVEL:
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK:
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK:
                      // Manage retries in Level/Track Controller
                      maxRetry = 0;
                      timeout = config.levelLoadingTimeOut;
                      break;
                    default:
                      maxRetry = config.levelLoadingMaxRetry;
                      timeout = config.levelLoadingTimeOut;
                      retryDelay = config.levelLoadingRetryDelay;
                      maxRetryDelay = config.levelLoadingMaxRetryTimeout;
                      break;
                  }
                  loader = this.createInternalLoader(context);

                  // Override level/track timeout for LL-HLS requests
                  // (the default of 10000ms is counter productive to blocking playlist reload requests)
                  if ((_context$deliveryDire = context.deliveryDirectives) !== null && _context$deliveryDire !== void 0 && _context$deliveryDire.part) {
                    var levelDetails;
                    if (context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.LEVEL && context.level !== null) {
                      levelDetails = (this || _global).hls.levels[context.level].details;
                    } else if (context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK && context.id !== null) {
                      levelDetails = (this || _global).hls.audioTracks[context.id].details;
                    } else if (context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK && context.id !== null) {
                      levelDetails = (this || _global).hls.subtitleTracks[context.id].details;
                    }
                    if (levelDetails) {
                      var partTarget = levelDetails.partTarget;
                      var targetDuration = levelDetails.targetduration;
                      if (partTarget && targetDuration) {
                        timeout = Math.min(Math.max(partTarget * 3, targetDuration * 0.8) * 1000, timeout);
                      }
                    }
                  }
                  var loaderConfig = {
                    timeout: timeout,
                    maxRetry: maxRetry,
                    retryDelay: retryDelay,
                    maxRetryDelay: maxRetryDelay,
                    highWaterMark: 0
                  };
                  var loaderCallbacks = {
                    onSuccess: (this || _global).loadsuccess.bind(this || _global),
                    onError: (this || _global).loaderror.bind(this || _global),
                    onTimeout: (this || _global).loadtimeout.bind(this || _global)
                  };

                  // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);

                  loader.load(context, loaderConfig, loaderCallbacks);
                };
                _proto.loadsuccess = function loadsuccess(response, stats, context, networkDetails) {
                  if (networkDetails === void 0) {
                    networkDetails = null;
                  }
                  if (context.isSidxRequest) {
                    this.handleSidxRequest(response, context);
                    this.handlePlaylistLoaded(response, stats, context, networkDetails);
                    return;
                  }
                  this.resetInternalLoader(context.type);
                  var string = response.data;

                  // Validate if it is an M3U8 at all
                  if (string.indexOf("#EXTM3U") !== 0) {
                    this.handleManifestParsingError(response, context, "no EXTM3U delimiter", networkDetails);
                    return;
                  }
                  stats.parsing.start = performance.now();
                  // Check if chunk-list or master. handle empty chunk list case (first EXTINF not signaled, but TARGETDURATION present)
                  if (string.indexOf("#EXTINF:") > 0 || string.indexOf("#EXT-X-TARGETDURATION:") > 0) {
                    this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails);
                  } else {
                    this.handleMasterPlaylist(response, stats, context, networkDetails);
                  }
                };
                _proto.loaderror = function loaderror(response, context, networkDetails) {
                  if (networkDetails === void 0) {
                    networkDetails = null;
                  }
                  this.handleNetworkError(context, networkDetails, false, response);
                };
                _proto.loadtimeout = function loadtimeout(stats, context, networkDetails) {
                  if (networkDetails === void 0) {
                    networkDetails = null;
                  }
                  this.handleNetworkError(context, networkDetails, true);
                };
                _proto.handleMasterPlaylist = function handleMasterPlaylist(response, stats, context, networkDetails) {
                  var hls = (this || _global).hls;
                  var string = response.data;
                  var url = getResponseUrl(response, context);
                  var _M3U8Parser$parseMast = _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__["default"].parseMasterPlaylist(string, url),
                    levels = _M3U8Parser$parseMast.levels,
                    sessionData = _M3U8Parser$parseMast.sessionData;
                  if (!levels.length) {
                    this.handleManifestParsingError(response, context, "no level found in manifest", networkDetails);
                    return;
                  }

                  // multi level playlist, parse level info
                  var audioGroups = levels.map(function (level) {
                    return {
                      id: level.attrs.AUDIO,
                      audioCodec: level.audioCodec
                    };
                  });
                  var subtitleGroups = levels.map(function (level) {
                    return {
                      id: level.attrs.SUBTITLES,
                      textCodec: level.textCodec
                    };
                  });
                  var audioTracks = _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__["default"].parseMasterPlaylistMedia(string, url, "AUDIO", audioGroups);
                  var subtitles = _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__["default"].parseMasterPlaylistMedia(string, url, "SUBTITLES", subtitleGroups);
                  var captions = _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__["default"].parseMasterPlaylistMedia(string, url, "CLOSED-CAPTIONS");
                  if (audioTracks.length) {
                    // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
                    var embeddedAudioFound = audioTracks.some(function (audioTrack) {
                      return !audioTrack.url;
                    });

                    // if no embedded audio track defined, but audio codec signaled in quality level,
                    // we need to signal this main audio track this could happen with playlists with
                    // alt audio rendition in which quality levels (main)
                    // contains both audio+video. but with mixed audio track not signaled
                    if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                      _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one");
                      audioTracks.unshift({
                        type: "main",
                        name: "main",
                        default: false,
                        autoselect: false,
                        forced: false,
                        id: -1,
                        attrs: new _utils_attr_list__WEBPACK_IMPORTED_MODULE_7__.AttrList({}),
                        bitrate: 0,
                        url: ""
                      });
                    }
                  }
                  hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, {
                    levels: levels,
                    audioTracks: audioTracks,
                    subtitles: subtitles,
                    captions: captions,
                    url: url,
                    stats: stats,
                    networkDetails: networkDetails,
                    sessionData: sessionData
                  });
                };
                _proto.handleTrackOrLevelPlaylist = function handleTrackOrLevelPlaylist(response, stats, context, networkDetails) {
                  var hls = (this || _global).hls;
                  var id = context.id,
                    level = context.level,
                    type = context.type;
                  var url = getResponseUrl(response, context);
                  var levelUrlId = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(id) ? id : 0;
                  var levelId = (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(level) ? level : levelUrlId;
                  var levelType = mapContextToLevelType(context);
                  var levelDetails = _m3u8_parser__WEBPACK_IMPORTED_MODULE_5__["default"].parseLevelPlaylist(response.data, url, levelId, levelType, levelUrlId);
                  if (!levelDetails.fragments.length) {
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorTypes.NETWORK_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_EMPTY_ERROR,
                      fatal: false,
                      url: url,
                      reason: "no fragments found in level",
                      level: typeof context.level === "number" ? context.level : undefined
                    });
                    return;
                  }

                  // We have done our first request (Manifest-type) and receive
                  // not a master playlist but a chunk-list (track/level)
                  // We fire the manifest-loaded event anyway with the parsed level-details
                  // by creating a single-level structure for it.
                  if (type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST) {
                    var singleLevel = {
                      attrs: new _utils_attr_list__WEBPACK_IMPORTED_MODULE_7__.AttrList({}),
                      bitrate: 0,
                      details: levelDetails,
                      name: "",
                      url: url
                    };
                    hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.MANIFEST_LOADED, {
                      levels: [singleLevel],
                      audioTracks: [],
                      url: url,
                      stats: stats,
                      networkDetails: networkDetails,
                      sessionData: null
                    });
                  }

                  // save parsing time
                  stats.parsing.end = performance.now();

                  // in case we need SIDX ranges
                  // return early after calling load for
                  // the SIDX box.
                  if (levelDetails.needSidxRanges) {
                    var _levelDetails$fragmen;
                    var sidxUrl = (_levelDetails$fragmen = levelDetails.fragments[0].initSegment) === null || _levelDetails$fragmen === void 0 ? void 0 : _levelDetails$fragmen.url;
                    this.load({
                      url: sidxUrl,
                      isSidxRequest: true,
                      type: type,
                      level: level,
                      levelDetails: levelDetails,
                      id: id,
                      groupId: null,
                      rangeStart: 0,
                      rangeEnd: 2048,
                      responseType: "arraybuffer",
                      deliveryDirectives: null
                    });
                    return;
                  }

                  // extend the context with the new levelDetails property
                  context.levelDetails = levelDetails;
                  this.handlePlaylistLoaded(response, stats, context, networkDetails);
                };
                _proto.handleSidxRequest = function handleSidxRequest(response, context) {
                  var data = new Uint8Array(response.data);
                  var sidxBox = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.findBox)(data, ["sidx"])[0];
                  // if provided fragment does not contain sidx, early return
                  if (!sidxBox) {
                    return;
                  }
                  var sidxInfo = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.parseSegmentIndex)(sidxBox);
                  if (!sidxInfo) {
                    return;
                  }
                  var sidxReferences = sidxInfo.references;
                  var levelDetails = context.levelDetails;
                  sidxReferences.forEach(function (segmentRef, index) {
                    var segRefInfo = segmentRef.info;
                    var frag = levelDetails.fragments[index];
                    if (frag.byteRange.length === 0) {
                      frag.setByteRange(String(1 + segRefInfo.end - segRefInfo.start) + "@" + String(segRefInfo.start));
                    }
                    if (frag.initSegment) {
                      var moovBox = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_4__.findBox)(data, ["moov"])[0];
                      var moovEndOffset = moovBox ? moovBox.length : null;
                      frag.initSegment.setByteRange(String(moovEndOffset) + "@0");
                    }
                  });
                };
                _proto.handleManifestParsingError = function handleManifestParsingError(response, context, reason, networkDetails) {
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, {
                    type: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorTypes.NETWORK_ERROR,
                    details: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.MANIFEST_PARSING_ERROR,
                    fatal: context.type === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST,
                    url: response.url,
                    reason: reason,
                    response: response,
                    context: context,
                    networkDetails: networkDetails
                  });
                };
                _proto.handleNetworkError = function handleNetworkError(context, networkDetails, timeout, response) {
                  if (timeout === void 0) {
                    timeout = false;
                  }
                  _utils_logger__WEBPACK_IMPORTED_MODULE_3__.logger.warn("[playlist-loader]: A network " + (timeout ? "timeout" : "error") + " occurred while loading " + context.type + " level: " + context.level + " id: " + context.id + " group-id: \"" + context.groupId + "\"");
                  var details = _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.UNKNOWN;
                  var fatal = false;
                  var loader = this.getInternalLoader(context);
                  switch (context.type) {
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST:
                      details = timeout ? _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.MANIFEST_LOAD_TIMEOUT : _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.MANIFEST_LOAD_ERROR;
                      fatal = true;
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.LEVEL:
                      details = timeout ? _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_LOAD_TIMEOUT : _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.LEVEL_LOAD_ERROR;
                      fatal = false;
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK:
                      details = timeout ? _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.AUDIO_TRACK_LOAD_TIMEOUT : _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.AUDIO_TRACK_LOAD_ERROR;
                      fatal = false;
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK:
                      details = timeout ? _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.SUBTITLE_TRACK_LOAD_TIMEOUT : _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorDetails.SUBTITLE_LOAD_ERROR;
                      fatal = false;
                      break;
                  }
                  if (loader) {
                    this.resetInternalLoader(context.type);
                  }
                  var errorData = {
                    type: _errors__WEBPACK_IMPORTED_MODULE_2__.ErrorTypes.NETWORK_ERROR,
                    details: details,
                    fatal: fatal,
                    url: context.url,
                    loader: loader,
                    context: context,
                    networkDetails: networkDetails
                  };
                  if (response) {
                    errorData.response = response;
                  }
                  (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.ERROR, errorData);
                };
                _proto.handlePlaylistLoaded = function handlePlaylistLoaded(response, stats, context, networkDetails) {
                  var type = context.type,
                    level = context.level,
                    id = context.id,
                    groupId = context.groupId,
                    loader = context.loader,
                    levelDetails = context.levelDetails,
                    deliveryDirectives = context.deliveryDirectives;
                  if (!(levelDetails !== null && levelDetails !== void 0 && levelDetails.targetduration)) {
                    this.handleManifestParsingError(response, context, "invalid target duration", networkDetails);
                    return;
                  }
                  if (!loader) {
                    return;
                  }
                  if (levelDetails.live) {
                    if (loader.getCacheAge) {
                      levelDetails.ageHeader = loader.getCacheAge() || 0;
                    }
                    if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) {
                      levelDetails.ageHeader = 0;
                    }
                  }
                  switch (type) {
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.MANIFEST:
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.LEVEL:
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.LEVEL_LOADED, {
                        details: levelDetails,
                        level: level || 0,
                        id: id || 0,
                        stats: stats,
                        networkDetails: networkDetails,
                        deliveryDirectives: deliveryDirectives
                      });
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.AUDIO_TRACK:
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.AUDIO_TRACK_LOADED, {
                        details: levelDetails,
                        id: id || 0,
                        groupId: groupId || "",
                        stats: stats,
                        networkDetails: networkDetails,
                        deliveryDirectives: deliveryDirectives
                      });
                      break;
                    case _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistContextType.SUBTITLE_TRACK:
                      (this || _global).hls.trigger(_events__WEBPACK_IMPORTED_MODULE_1__.Events.SUBTITLE_TRACK_LOADED, {
                        details: levelDetails,
                        id: id || 0,
                        groupId: groupId || "",
                        stats: stats,
                        networkDetails: networkDetails,
                        deliveryDirectives: deliveryDirectives
                      });
                      break;
                  }
                };
                return PlaylistLoader;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = PlaylistLoader;

              /***/
            },

            /***/"./src/polyfills/number.ts":
            /*!*********************************!*\
              !*** ./src/polyfills/number.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"MAX_SAFE_INTEGER": () => /* binding */MAX_SAFE_INTEGER,
                /* harmony export */"isFiniteNumber": () => /* binding */isFiniteNumber
                /* harmony export */
              });
              var isFiniteNumber = Number.isFinite || function (value) {
                return typeof value === "number" && isFinite(value);
              };
              var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

              /***/
            },

            /***/"./src/remux/aac-helper.ts":
            /*!*********************************!*\
              !*** ./src/remux/aac-helper.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /**
               *  AAC helper
               */
              var AAC = /*#__PURE__*/function () {
                function AAC() {}
                AAC.getSilentFrame = function getSilentFrame(codec, channelCount) {
                  switch (codec) {
                    case "mp4a.40.2":
                      if (channelCount === 1) {
                        return new Uint8Array([0, 200, 0, 128, 35, 128]);
                      } else if (channelCount === 2) {
                        return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
                      } else if (channelCount === 3) {
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
                      } else if (channelCount === 4) {
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
                      } else if (channelCount === 5) {
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
                      } else if (channelCount === 6) {
                        return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
                      }
                      break;
                    // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
                    default:
                      if (channelCount === 1) {
                        // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                        return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      } else if (channelCount === 2) {
                        // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      } else if (channelCount === 3) {
                        // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                        return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
                      }
                      break;
                  }
                  return undefined;
                };
                return AAC;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = AAC;

              /***/
            },

            /***/"./src/remux/mp4-generator.ts":
            /*!************************************!*\
              !*** ./src/remux/mp4-generator.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /**
               * Generate MP4 Box
               */

              var UINT32_MAX = Math.pow(2, 32) - 1;
              var MP4 = /*#__PURE__*/function () {
                function MP4() {}
                MP4.init = function init() {
                  MP4.types = {
                    avc1: [],
                    // codingname
                    avcC: [],
                    btrt: [],
                    dinf: [],
                    dref: [],
                    esds: [],
                    ftyp: [],
                    hdlr: [],
                    mdat: [],
                    mdhd: [],
                    mdia: [],
                    mfhd: [],
                    minf: [],
                    moof: [],
                    moov: [],
                    mp4a: [],
                    ".mp3": [],
                    mvex: [],
                    mvhd: [],
                    pasp: [],
                    sdtp: [],
                    stbl: [],
                    stco: [],
                    stsc: [],
                    stsd: [],
                    stsz: [],
                    stts: [],
                    tfdt: [],
                    tfhd: [],
                    traf: [],
                    trak: [],
                    trun: [],
                    trex: [],
                    tkhd: [],
                    vmhd: [],
                    smhd: []
                  };
                  var i;
                  for (i in MP4.types) {
                    if (MP4.types.hasOwnProperty(i)) {
                      MP4.types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
                    }
                  }
                  var videoHdlr = new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0,
                  // pre_defined
                  118, 105, 100, 101,
                  // handler_type: 'vide'
                  0, 0, 0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  86, 105, 100, 101, 111, 72, 97, 110, 100, 108, 101, 114, 0 // name: 'VideoHandler'
                  ]);

                  var audioHdlr = new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0,
                  // pre_defined
                  115, 111, 117, 110,
                  // handler_type: 'soun'
                  0, 0, 0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  83, 111, 117, 110, 100, 72, 97, 110, 100, 108, 101, 114, 0 // name: 'SoundHandler'
                  ]);

                  MP4.HDLR_TYPES = {
                    video: videoHdlr,
                    audio: audioHdlr
                  };
                  var dref = new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  0, 0, 0, 1,
                  // entry_count
                  0, 0, 0, 12,
                  // entry_size
                  117, 114, 108, 32,
                  // 'url' type
                  0,
                  // version 0
                  0, 0, 1 // entry_flags
                  ]);

                  var stco = new Uint8Array([0,
                  // version
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0 // entry_count
                  ]);

                  MP4.STTS = MP4.STSC = MP4.STCO = stco;
                  MP4.STSZ = new Uint8Array([0,
                  // version
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0,
                  // sample_size
                  0, 0, 0, 0 // sample_count
                  ]);

                  MP4.VMHD = new Uint8Array([0,
                  // version
                  0, 0, 1,
                  // flags
                  0, 0,
                  // graphicsmode
                  0, 0, 0, 0, 0, 0 // opcolor
                  ]);

                  MP4.SMHD = new Uint8Array([0,
                  // version
                  0, 0, 0,
                  // flags
                  0, 0,
                  // balance
                  0, 0 // reserved
                  ]);

                  MP4.STSD = new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  0, 0, 0, 1]); // entry_count

                  var majorBrand = new Uint8Array([105, 115, 111, 109]); // isom
                  var avc1Brand = new Uint8Array([97, 118, 99, 49]); // avc1
                  var minorVersion = new Uint8Array([0, 0, 0, 1]);
                  MP4.FTYP = MP4.box(MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
                  MP4.DINF = MP4.box(MP4.types.dinf, MP4.box(MP4.types.dref, dref));
                };
                MP4.box = function box(type) {
                  var size = 8;
                  for (var _len = arguments.length, payload = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    payload[_key - 1] = arguments[_key];
                  }
                  var i = payload.length;
                  var len = i;
                  // calculate the total size we need to allocate
                  while (i--) {
                    size += payload[i].byteLength;
                  }
                  var result = new Uint8Array(size);
                  result[0] = size >> 24 & 255;
                  result[1] = size >> 16 & 255;
                  result[2] = size >> 8 & 255;
                  result[3] = size & 255;
                  result.set(type, 4);
                  // copy the payload into the result
                  for (i = 0, size = 8; i < len; i++) {
                    // copy payload[i] array @ offset size
                    result.set(payload[i], size);
                    size += payload[i].byteLength;
                  }
                  return result;
                };
                MP4.hdlr = function hdlr(type) {
                  return MP4.box(MP4.types.hdlr, MP4.HDLR_TYPES[type]);
                };
                MP4.mdat = function mdat(data) {
                  return MP4.box(MP4.types.mdat, data);
                };
                MP4.mdhd = function mdhd(timescale, duration) {
                  duration *= timescale;
                  var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
                  var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                  return MP4.box(MP4.types.mdhd, new Uint8Array([1,
                  // version 1
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0, 0, 0, 0, 2,
                  // creation_time
                  0, 0, 0, 0, 0, 0, 0, 3,
                  // modification_time
                  timescale >> 24 & 255, timescale >> 16 & 255, timescale >> 8 & 255, timescale & 255,
                  // timescale
                  upperWordDuration >> 24, upperWordDuration >> 16 & 255, upperWordDuration >> 8 & 255, upperWordDuration & 255, lowerWordDuration >> 24, lowerWordDuration >> 16 & 255, lowerWordDuration >> 8 & 255, lowerWordDuration & 255, 85, 196,
                  // 'und' language (undetermined)
                  0, 0]));
                };
                MP4.mdia = function mdia(track) {
                  return MP4.box(MP4.types.mdia, MP4.mdhd(track.timescale, track.duration), MP4.hdlr(track.type), MP4.minf(track));
                };
                MP4.mfhd = function mfhd(sequenceNumber) {
                  return MP4.box(MP4.types.mfhd, new Uint8Array([0, 0, 0, 0,
                  // flags
                  sequenceNumber >> 24, sequenceNumber >> 16 & 255, sequenceNumber >> 8 & 255, sequenceNumber & 255 // sequence_number
                  ]));
                };

                MP4.minf = function minf(track) {
                  if (track.type === "audio") {
                    return MP4.box(MP4.types.minf, MP4.box(MP4.types.smhd, MP4.SMHD), MP4.DINF, MP4.stbl(track));
                  } else {
                    return MP4.box(MP4.types.minf, MP4.box(MP4.types.vmhd, MP4.VMHD), MP4.DINF, MP4.stbl(track));
                  }
                };
                MP4.moof = function moof(sn, baseMediaDecodeTime, track) {
                  return MP4.box(MP4.types.moof, MP4.mfhd(sn), MP4.traf(track, baseMediaDecodeTime));
                }

                /**
                 * @param tracks... (optional) {array} the tracks associated with this movie
                 */;
                MP4.moov = function moov(tracks) {
                  var i = tracks.length;
                  var boxes = [];
                  while (i--) {
                    boxes[i] = MP4.trak(tracks[i]);
                  }
                  return MP4.box.apply(null, [MP4.types.moov, MP4.mvhd(tracks[0].timescale, tracks[0].duration)].concat(boxes).concat(MP4.mvex(tracks)));
                };
                MP4.mvex = function mvex(tracks) {
                  var i = tracks.length;
                  var boxes = [];
                  while (i--) {
                    boxes[i] = MP4.trex(tracks[i]);
                  }
                  return MP4.box.apply(null, [MP4.types.mvex].concat(boxes));
                };
                MP4.mvhd = function mvhd(timescale, duration) {
                  duration *= timescale;
                  var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
                  var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                  var bytes = new Uint8Array([1,
                  // version 1
                  0, 0, 0,
                  // flags
                  0, 0, 0, 0, 0, 0, 0, 2,
                  // creation_time
                  0, 0, 0, 0, 0, 0, 0, 3,
                  // modification_time
                  timescale >> 24 & 255, timescale >> 16 & 255, timescale >> 8 & 255, timescale & 255,
                  // timescale
                  upperWordDuration >> 24, upperWordDuration >> 16 & 255, upperWordDuration >> 8 & 255, upperWordDuration & 255, lowerWordDuration >> 24, lowerWordDuration >> 16 & 255, lowerWordDuration >> 8 & 255, lowerWordDuration & 255, 0, 1, 0, 0,
                  // 1.0 rate
                  1, 0,
                  // 1.0 volume
                  0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  0, 0, 0, 0,
                  // reserved
                  0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0,
                  // transformation: unity matrix
                  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  // pre_defined
                  255, 255, 255, 255 // next_track_ID
                  ]);

                  return MP4.box(MP4.types.mvhd, bytes);
                };
                MP4.sdtp = function sdtp(track) {
                  var samples = track.samples || [];
                  var bytes = new Uint8Array(4 + samples.length);
                  var i;
                  var flags;
                  // leave the full box header (4 bytes) all zero
                  // write the sample table
                  for (i = 0; i < samples.length; i++) {
                    flags = samples[i].flags;
                    bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
                  }
                  return MP4.box(MP4.types.sdtp, bytes);
                };
                MP4.stbl = function stbl(track) {
                  return MP4.box(MP4.types.stbl, MP4.stsd(track), MP4.box(MP4.types.stts, MP4.STTS), MP4.box(MP4.types.stsc, MP4.STSC), MP4.box(MP4.types.stsz, MP4.STSZ), MP4.box(MP4.types.stco, MP4.STCO));
                };
                MP4.avc1 = function avc1(track) {
                  var sps = [];
                  var pps = [];
                  var i;
                  var data;
                  var len;
                  // assemble the SPSs

                  for (i = 0; i < track.sps.length; i++) {
                    data = track.sps[i];
                    len = data.byteLength;
                    sps.push(len >>> 8 & 255);
                    sps.push(len & 255);

                    // SPS
                    sps = sps.concat(Array.prototype.slice.call(data));
                  }

                  // assemble the PPSs
                  for (i = 0; i < track.pps.length; i++) {
                    data = track.pps[i];
                    len = data.byteLength;
                    pps.push(len >>> 8 & 255);
                    pps.push(len & 255);
                    pps = pps.concat(Array.prototype.slice.call(data));
                  }
                  var avcc = MP4.box(MP4.types.avcC, new Uint8Array([1,
                  // version
                  sps[3],
                  // profile
                  sps[4],
                  // profile compat
                  sps[5],
                  // level
                  252 | 3,
                  // lengthSizeMinusOne, hard-coded to 4 bytes
                  224 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
                  ].concat(sps).concat([track.pps.length // numOfPictureParameterSets
                  ]).concat(pps))); // "PPS"
                  var width = track.width;
                  var height = track.height;
                  var hSpacing = track.pixelRatio[0];
                  var vSpacing = track.pixelRatio[1];
                  return MP4.box(MP4.types.avc1, new Uint8Array([0, 0, 0,
                  // reserved
                  0, 0, 0,
                  // reserved
                  0, 1,
                  // data_reference_index
                  0, 0,
                  // pre_defined
                  0, 0,
                  // reserved
                  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  // pre_defined
                  width >> 8 & 255, width & 255,
                  // width
                  height >> 8 & 255, height & 255,
                  // height
                  0, 72, 0, 0,
                  // horizresolution
                  0, 72, 0, 0,
                  // vertresolution
                  0, 0, 0, 0,
                  // reserved
                  0, 1,
                  // frame_count
                  18, 100, 97, 105, 108,
                  // dailymotion/hls.js
                  121, 109, 111, 116, 105, 111, 110, 47, 104, 108, 115, 46, 106, 115, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                  // compressorname
                  0, 24,
                  // depth = 24
                  17, 17]),
                  // pre_defined = -1
                  avcc, MP4.box(MP4.types.btrt, new Uint8Array([0, 28, 156, 128,
                  // bufferSizeDB
                  0, 45, 198, 192,
                  // maxBitrate
                  0, 45, 198, 192])),
                  // avgBitrate
                  MP4.box(MP4.types.pasp, new Uint8Array([hSpacing >> 24,
                  // hSpacing
                  hSpacing >> 16 & 255, hSpacing >> 8 & 255, hSpacing & 255, vSpacing >> 24,
                  // vSpacing
                  vSpacing >> 16 & 255, vSpacing >> 8 & 255, vSpacing & 255])));
                };
                MP4.esds = function esds(track) {
                  var configlen = track.config.length;
                  return new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags

                  3,
                  // descriptor_type
                  23 + configlen,
                  // length
                  0, 1,
                  // es_id
                  0,
                  // stream_priority

                  4,
                  // descriptor_type
                  15 + configlen,
                  // length
                  64,
                  // codec : mpeg4_audio
                  21,
                  // stream_type
                  0, 0, 0,
                  // buffer_size
                  0, 0, 0, 0,
                  // maxBitrate
                  0, 0, 0, 0,
                  // avgBitrate

                  5 // descriptor_type
                  ].concat([configlen]).concat(track.config).concat([6, 1, 2])); // GASpecificConfig)); // length + audio config descriptor
                };

                MP4.mp4a = function mp4a(track) {
                  var samplerate = track.samplerate;
                  return MP4.box(MP4.types.mp4a, new Uint8Array([0, 0, 0,
                  // reserved
                  0, 0, 0,
                  // reserved
                  0, 1,
                  // data_reference_index
                  0, 0, 0, 0, 0, 0, 0, 0,
                  // reserved
                  0, track.channelCount,
                  // channelcount
                  0, 16,
                  // sampleSize:16bits
                  0, 0, 0, 0,
                  // reserved2
                  samplerate >> 8 & 255, samplerate & 255,
                  //
                  0, 0]), MP4.box(MP4.types.esds, MP4.esds(track)));
                };
                MP4.mp3 = function mp3(track) {
                  var samplerate = track.samplerate;
                  return MP4.box(MP4.types[".mp3"], new Uint8Array([0, 0, 0,
                  // reserved
                  0, 0, 0,
                  // reserved
                  0, 1,
                  // data_reference_index
                  0, 0, 0, 0, 0, 0, 0, 0,
                  // reserved
                  0, track.channelCount,
                  // channelcount
                  0, 16,
                  // sampleSize:16bits
                  0, 0, 0, 0,
                  // reserved2
                  samplerate >> 8 & 255, samplerate & 255,
                  //
                  0, 0]));
                };
                MP4.stsd = function stsd(track) {
                  if (track.type === "audio") {
                    if (track.segmentCodec === "mp3" && track.codec === "mp3") {
                      return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp3(track));
                    }
                    return MP4.box(MP4.types.stsd, MP4.STSD, MP4.mp4a(track));
                  } else {
                    return MP4.box(MP4.types.stsd, MP4.STSD, MP4.avc1(track));
                  }
                };
                MP4.tkhd = function tkhd(track) {
                  var id = track.id;
                  var duration = track.duration * track.timescale;
                  var width = track.width;
                  var height = track.height;
                  var upperWordDuration = Math.floor(duration / (UINT32_MAX + 1));
                  var lowerWordDuration = Math.floor(duration % (UINT32_MAX + 1));
                  return MP4.box(MP4.types.tkhd, new Uint8Array([1,
                  // version 1
                  0, 0, 7,
                  // flags
                  0, 0, 0, 0, 0, 0, 0, 2,
                  // creation_time
                  0, 0, 0, 0, 0, 0, 0, 3,
                  // modification_time
                  id >> 24 & 255, id >> 16 & 255, id >> 8 & 255, id & 255,
                  // track_ID
                  0, 0, 0, 0,
                  // reserved
                  upperWordDuration >> 24, upperWordDuration >> 16 & 255, upperWordDuration >> 8 & 255, upperWordDuration & 255, lowerWordDuration >> 24, lowerWordDuration >> 16 & 255, lowerWordDuration >> 8 & 255, lowerWordDuration & 255, 0, 0, 0, 0, 0, 0, 0, 0,
                  // reserved
                  0, 0,
                  // layer
                  0, 0,
                  // alternate_group
                  0, 0,
                  // non-audio track volume
                  0, 0,
                  // reserved
                  0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 64, 0, 0, 0,
                  // transformation: unity matrix
                  width >> 8 & 255, width & 255, 0, 0,
                  // width
                  height >> 8 & 255, height & 255, 0, 0 // height
                  ]));
                };

                MP4.traf = function traf(track, baseMediaDecodeTime) {
                  var sampleDependencyTable = MP4.sdtp(track);
                  var id = track.id;
                  var upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
                  var lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                  return MP4.box(MP4.types.traf, MP4.box(MP4.types.tfhd, new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  id >> 24, id >> 16 & 255, id >> 8 & 255, id & 255 // track_ID
                  ])), MP4.box(MP4.types.tfdt, new Uint8Array([1,
                  // version 1
                  0, 0, 0,
                  // flags
                  upperWordBaseMediaDecodeTime >> 24, upperWordBaseMediaDecodeTime >> 16 & 255, upperWordBaseMediaDecodeTime >> 8 & 255, upperWordBaseMediaDecodeTime & 255, lowerWordBaseMediaDecodeTime >> 24, lowerWordBaseMediaDecodeTime >> 16 & 255, lowerWordBaseMediaDecodeTime >> 8 & 255, lowerWordBaseMediaDecodeTime & 255])), MP4.trun(track, sampleDependencyTable.length + 16 +
                  // tfhd
                  20 +
                  // tfdt
                  8 +
                  // traf header
                  16 +
                  // mfhd
                  8 +
                  // moof header
                  8),
                  // mdat header
                  sampleDependencyTable);
                }

                /**
                 * Generate a track box.
                 * @param track {object} a track definition
                 * @return {Uint8Array} the track box
                 */;
                MP4.trak = function trak(track) {
                  track.duration = track.duration || 4294967295;
                  return MP4.box(MP4.types.trak, MP4.tkhd(track), MP4.mdia(track));
                };
                MP4.trex = function trex(track) {
                  var id = track.id;
                  return MP4.box(MP4.types.trex, new Uint8Array([0,
                  // version 0
                  0, 0, 0,
                  // flags
                  id >> 24, id >> 16 & 255, id >> 8 & 255, id & 255,
                  // track_ID
                  0, 0, 0, 1,
                  // default_sample_description_index
                  0, 0, 0, 0,
                  // default_sample_duration
                  0, 0, 0, 0,
                  // default_sample_size
                  0, 1, 0, 1 // default_sample_flags
                  ]));
                };

                MP4.trun = function trun(track, offset) {
                  var samples = track.samples || [];
                  var len = samples.length;
                  var arraylen = 12 + 16 * len;
                  var array = new Uint8Array(arraylen);
                  var i;
                  var sample;
                  var duration;
                  var size;
                  var flags;
                  var cts;
                  offset += 8 + arraylen;
                  array.set([track.type === "video" ? 1 : 0,
                  // version 1 for video with signed-int sample_composition_time_offset
                  0, 15, 1,
                  // flags
                  len >>> 24 & 255, len >>> 16 & 255, len >>> 8 & 255, len & 255,
                  // sample_count
                  offset >>> 24 & 255, offset >>> 16 & 255, offset >>> 8 & 255, offset & 255 // data_offset
                  ], 0);
                  for (i = 0; i < len; i++) {
                    sample = samples[i];
                    duration = sample.duration;
                    size = sample.size;
                    flags = sample.flags;
                    cts = sample.cts;
                    array.set([duration >>> 24 & 255, duration >>> 16 & 255, duration >>> 8 & 255, duration & 255,
                    // sample_duration
                    size >>> 24 & 255, size >>> 16 & 255, size >>> 8 & 255, size & 255,
                    // sample_size
                    flags.isLeading << 2 | flags.dependsOn, flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync, flags.degradPrio & 240 << 8, flags.degradPrio & 15,
                    // sample_flags
                    cts >>> 24 & 255, cts >>> 16 & 255, cts >>> 8 & 255, cts & 255 // sample_composition_time_offset
                    ], 12 + 16 * i);
                  }
                  return MP4.box(MP4.types.trun, array);
                };
                MP4.initSegment = function initSegment(tracks) {
                  if (!MP4.types) {
                    MP4.init();
                  }
                  var movie = MP4.moov(tracks);
                  var result = new Uint8Array(MP4.FTYP.byteLength + movie.byteLength);
                  result.set(MP4.FTYP);
                  result.set(movie, MP4.FTYP.byteLength);
                  return result;
                };
                return MP4;
              }();
              MP4.types = void 0;
              MP4.HDLR_TYPES = void 0;
              MP4.STTS = void 0;
              MP4.STSC = void 0;
              MP4.STCO = void 0;
              MP4.STSZ = void 0;
              MP4.VMHD = void 0;
              MP4.SMHD = void 0;
              MP4.STSD = void 0;
              MP4.FTYP = void 0;
              MP4.DINF = void 0;
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = MP4;

              /***/
            },

            /***/"./src/remux/mp4-remuxer.ts":
            /*!**********************************!*\
              !*** ./src/remux/mp4-remuxer.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */MP4Remuxer,
                /* harmony export */"flushTextTrackMetadataCueSamples": () => /* binding */flushTextTrackMetadataCueSamples,
                /* harmony export */"flushTextTrackUserdataCueSamples": () => /* binding */flushTextTrackUserdataCueSamples,
                /* harmony export */"normalizePts": () => /* binding */normalizePts
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _aac_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./aac-helper */"./src/remux/aac-helper.ts");
              /* harmony import */
              var _mp4_generator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./mp4-generator */"./src/remux/mp4-generator.ts");
              /* harmony import */
              var _events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../events */"./src/events.ts");
              /* harmony import */
              var _errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../errors */"./src/errors.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _types_loader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__( /*! ../types/loader */"./src/types/loader.ts");
              /* harmony import */
              var _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__( /*! ../utils/timescale-conversion */"./src/utils/timescale-conversion.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              var MAX_SILENT_FRAME_DURATION = 10 * 1000; // 10 seconds
              var AAC_SAMPLES_PER_FRAME = 1024;
              var MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
              var chromeVersion = null;
              var safariWebkitVersion = null;
              var MP4Remuxer = /*#__PURE__*/function () {
                function MP4Remuxer(observer, config, typeSupported, vendor) {
                  (this || _global).observer = void 0;
                  (this || _global).config = void 0;
                  (this || _global).typeSupported = void 0;
                  (this || _global).ISGenerated = false;
                  (this || _global)._initPTS = void 0;
                  (this || _global)._initDTS = void 0;
                  (this || _global).nextAvcDts = null;
                  (this || _global).nextAudioPts = null;
                  (this || _global).videoSampleDuration = null;
                  (this || _global).isAudioContiguous = false;
                  (this || _global).isVideoContiguous = false;
                  (this || _global).observer = observer;
                  (this || _global).config = config;
                  (this || _global).typeSupported = typeSupported;
                  (this || _global).ISGenerated = false;
                  if (chromeVersion === null) {
                    var userAgent = navigator.userAgent || "";
                    var result = userAgent.match(/Chrome\/(\d+)/i);
                    chromeVersion = result ? parseInt(result[1]) : 0;
                  }
                  if (safariWebkitVersion === null) {
                    var _result = navigator.userAgent.match(/Safari\/(\d+)/i);
                    safariWebkitVersion = _result ? parseInt(_result[1]) : 0;
                  }
                }
                var _proto = MP4Remuxer.prototype;
                _proto.destroy = function destroy() {};
                _proto.resetTimeStamp = function resetTimeStamp(defaultTimeStamp) {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("[mp4-remuxer]: initPTS & initDTS reset");
                  (this || _global)._initPTS = (this || _global)._initDTS = defaultTimeStamp;
                };
                _proto.resetNextTimestamp = function resetNextTimestamp() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("[mp4-remuxer]: reset next timestamp");
                  (this || _global).isVideoContiguous = false;
                  (this || _global).isAudioContiguous = false;
                };
                _proto.resetInitSegment = function resetInitSegment() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("[mp4-remuxer]: ISGenerated flag reset");
                  (this || _global).ISGenerated = false;
                };
                _proto.getVideoStartPts = function getVideoStartPts(videoSamples) {
                  var rolloverDetected = false;
                  var startPTS = videoSamples.reduce(function (minPTS, sample) {
                    var delta = sample.pts - minPTS;
                    if (delta < -4294967296) {
                      // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
                      rolloverDetected = true;
                      return normalizePts(minPTS, sample.pts);
                    } else if (delta > 0) {
                      return minPTS;
                    } else {
                      return sample.pts;
                    }
                  }, videoSamples[0].pts);
                  if (rolloverDetected) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.debug("PTS rollover detected");
                  }
                  return startPTS;
                };
                _proto.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
                  var video;
                  var audio;
                  var initSegment;
                  var text;
                  var id3;
                  var independent;
                  var audioTimeOffset = timeOffset;
                  var videoTimeOffset = timeOffset;

                  // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
                  // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
                  // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
                  // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
                  // then we can remux one track without waiting for the other.
                  var hasAudio = audioTrack.pid > -1;
                  var hasVideo = videoTrack.pid > -1;
                  var length = videoTrack.samples.length;
                  var enoughAudioSamples = audioTrack.samples.length > 0;
                  var enoughVideoSamples = flush && length > 0 || length > 1;
                  var canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || (this || _global).ISGenerated || flush;
                  if (canRemuxAvc) {
                    if (!(this || _global).ISGenerated) {
                      initSegment = this.generateIS(audioTrack, videoTrack, timeOffset);
                    }
                    var isVideoContiguous = (this || _global).isVideoContiguous;
                    var firstKeyFrameIndex = -1;
                    var firstKeyFramePTS;
                    if (enoughVideoSamples) {
                      firstKeyFrameIndex = findKeyframeIndex(videoTrack.samples);
                      if (!isVideoContiguous && (this || _global).config.forceKeyFrameOnDiscontinuity) {
                        independent = true;
                        if (firstKeyFrameIndex > 0) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: Dropped " + firstKeyFrameIndex + " out of " + length + " video samples due to a missing keyframe");
                          var startPTS = this.getVideoStartPts(videoTrack.samples);
                          videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
                          videoTrack.dropped += firstKeyFrameIndex;
                          videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
                          firstKeyFramePTS = videoTimeOffset;
                        } else if (firstKeyFrameIndex === -1) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: No keyframe found out of " + length + " video samples");
                          independent = false;
                        }
                      }
                    }
                    if ((this || _global).ISGenerated) {
                      if (enoughAudioSamples && enoughVideoSamples) {
                        // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                        // if first audio DTS is not aligned with first video DTS then we need to take that into account
                        // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                        // drift between audio and video streams
                        var _startPTS = this.getVideoStartPts(videoTrack.samples);
                        var tsDelta = normalizePts(audioTrack.samples[0].pts, _startPTS) - _startPTS;
                        var audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
                        audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
                        videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
                      }

                      // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
                      if (enoughAudioSamples) {
                        // if initSegment was generated without audio samples, regenerate it again
                        if (!audioTrack.samplerate) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: regenerate InitSegment as audio detected");
                          initSegment = this.generateIS(audioTrack, videoTrack, timeOffset);
                        }
                        audio = this.remuxAudio(audioTrack, audioTimeOffset, (this || _global).isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === _types_loader__WEBPACK_IMPORTED_MODULE_6__.PlaylistLevelType.AUDIO ? videoTimeOffset : undefined);
                        if (enoughVideoSamples) {
                          var audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
                          // if initSegment was generated without video samples, regenerate it again
                          if (!videoTrack.inputTimeScale) {
                            _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: regenerate InitSegment as video detected");
                            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset);
                          }
                          video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
                        }
                      } else if (enoughVideoSamples) {
                        video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
                      }
                      if (video) {
                        video.firstKeyFrame = firstKeyFrameIndex;
                        video.independent = firstKeyFrameIndex !== -1;
                        video.firstKeyFramePTS = firstKeyFramePTS;
                      }
                    }
                  }

                  // Allow ID3 and text to remux, even if more audio/video samples are required
                  if ((this || _global).ISGenerated) {
                    if (id3Track.samples.length) {
                      id3 = flushTextTrackMetadataCueSamples(id3Track, timeOffset, (this || _global)._initPTS, (this || _global)._initDTS);
                    }
                    if (textTrack.samples.length) {
                      text = flushTextTrackUserdataCueSamples(textTrack, timeOffset, (this || _global)._initPTS);
                    }
                  }
                  return {
                    audio: audio,
                    video: video,
                    initSegment: initSegment,
                    independent: independent,
                    text: text,
                    id3: id3
                  };
                };
                _proto.generateIS = function generateIS(audioTrack, videoTrack, timeOffset) {
                  var audioSamples = audioTrack.samples;
                  var videoSamples = videoTrack.samples;
                  var typeSupported = (this || _global).typeSupported;
                  var tracks = {};
                  var computePTSDTS = !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)((this || _global)._initPTS);
                  var container = "audio/mp4";
                  var initPTS;
                  var initDTS;
                  var timescale;
                  if (computePTSDTS) {
                    initPTS = initDTS = Infinity;
                  }
                  if (audioTrack.config && audioSamples.length) {
                    // let's use audio sampling rate as MP4 time scale.
                    // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
                    // using audio sampling rate here helps having an integer MP4 frame duration
                    // this avoids potential rounding issue and AV sync issue
                    audioTrack.timescale = audioTrack.samplerate;
                    switch (audioTrack.segmentCodec) {
                      case "mp3":
                        if (typeSupported.mpeg) {
                          // Chrome and Safari
                          container = "audio/mpeg";
                          audioTrack.codec = "";
                        } else if (typeSupported.mp3) {
                          // Firefox
                          audioTrack.codec = "mp3";
                        }
                        break;
                    }
                    tracks.audio = {
                      id: "audio",
                      container: container,
                      codec: audioTrack.codec,
                      initSegment: audioTrack.segmentCodec === "mp3" && typeSupported.mpeg ? new Uint8Array(0) : _mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].initSegment([audioTrack]),
                      metadata: {
                        channelCount: audioTrack.channelCount
                      }
                    };
                    if (computePTSDTS) {
                      timescale = audioTrack.inputTimeScale;
                      // remember first PTS of this demuxing context. for audio, PTS = DTS
                      initPTS = initDTS = audioSamples[0].pts - Math.round(timescale * timeOffset);
                    }
                  }
                  if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
                    // let's use input time scale as MP4 video timescale
                    // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
                    videoTrack.timescale = videoTrack.inputTimeScale;
                    tracks.video = {
                      id: "main",
                      container: "video/mp4",
                      codec: videoTrack.codec,
                      initSegment: _mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].initSegment([videoTrack]),
                      metadata: {
                        width: videoTrack.width,
                        height: videoTrack.height
                      }
                    };
                    if (computePTSDTS) {
                      timescale = videoTrack.inputTimeScale;
                      var startPTS = this.getVideoStartPts(videoSamples);
                      var startOffset = Math.round(timescale * timeOffset);
                      initDTS = Math.min(initDTS, normalizePts(videoSamples[0].dts, startPTS) - startOffset);
                      initPTS = Math.min(initPTS, startPTS - startOffset);
                    }
                  }
                  if (Object.keys(tracks).length) {
                    (this || _global).ISGenerated = true;
                    if (computePTSDTS) {
                      (this || _global)._initPTS = initPTS;
                      (this || _global)._initDTS = initDTS;
                    }
                    return {
                      tracks: tracks,
                      initPTS: initPTS,
                      timescale: timescale
                    };
                  }
                };
                _proto.remuxVideo = function remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
                  var timeScale = track.inputTimeScale;
                  var inputSamples = track.samples;
                  var outputSamples = [];
                  var nbSamples = inputSamples.length;
                  var initPTS = (this || _global)._initPTS;
                  var nextAvcDts = (this || _global).nextAvcDts;
                  var offset = 8;
                  var mp4SampleDuration = (this || _global).videoSampleDuration;
                  var firstDTS;
                  var lastDTS;
                  var minPTS = Number.POSITIVE_INFINITY;
                  var maxPTS = Number.NEGATIVE_INFINITY;
                  var sortSamples = false;

                  // if parsed fragment is contiguous with last one, let's use last DTS value as reference
                  if (!contiguous || nextAvcDts === null) {
                    var pts = timeOffset * timeScale;
                    var cts = inputSamples[0].pts - normalizePts(inputSamples[0].dts, inputSamples[0].pts);
                    // if not contiguous, let's use target timeOffset
                    nextAvcDts = pts - cts;
                  }

                  // PTS is coded on 33bits, and can loop from -2^32 to 2^32
                  // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
                  for (var i = 0; i < nbSamples; i++) {
                    var sample = inputSamples[i];
                    sample.pts = normalizePts(sample.pts - initPTS, nextAvcDts);
                    sample.dts = normalizePts(sample.dts - initPTS, nextAvcDts);
                    if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) {
                      sortSamples = true;
                    }
                  }

                  // sort video samples by DTS then PTS then demux id order
                  if (sortSamples) {
                    inputSamples.sort(function (a, b) {
                      var deltadts = a.dts - b.dts;
                      var deltapts = a.pts - b.pts;
                      return deltadts || deltapts;
                    });
                  }

                  // Get first/last DTS
                  firstDTS = inputSamples[0].dts;
                  lastDTS = inputSamples[inputSamples.length - 1].dts;

                  // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
                  // set this constant duration as being the avg delta between consecutive DTS.
                  var inputDuration = lastDTS - firstDTS;
                  var averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;

                  // if fragment are contiguous, detect hole/overlapping between fragments
                  if (contiguous) {
                    // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
                    var delta = firstDTS - nextAvcDts;
                    var foundHole = delta > averageSampleDuration;
                    var foundOverlap = delta < -1;
                    if (foundHole || foundOverlap) {
                      if (foundHole) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("AVC: " + (0, _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__.toMsFromMpegTsClock)(delta, true) + " ms (" + delta + "dts) hole between fragments detected, filling it");
                      } else {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("AVC: " + (0, _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__.toMsFromMpegTsClock)(-delta, true) + " ms (" + delta + "dts) overlapping between fragments detected");
                      }
                      if (!foundOverlap || nextAvcDts > inputSamples[0].pts) {
                        firstDTS = nextAvcDts;
                        var firstPTS = inputSamples[0].pts - delta;
                        inputSamples[0].dts = firstDTS;
                        inputSamples[0].pts = firstPTS;
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("Video: First PTS/DTS adjusted: " + (0, _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__.toMsFromMpegTsClock)(firstPTS, true) + "/" + (0, _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__.toMsFromMpegTsClock)(firstDTS, true) + ", delta: " + (0, _utils_timescale_conversion__WEBPACK_IMPORTED_MODULE_7__.toMsFromMpegTsClock)(delta, true) + " ms");
                      }
                    }
                  }
                  firstDTS = Math.max(0, firstDTS);
                  var nbNalu = 0;
                  var naluLen = 0;
                  for (var _i = 0; _i < nbSamples; _i++) {
                    // compute total/avc sample length and nb of NAL units
                    var _sample = inputSamples[_i];
                    var units = _sample.units;
                    var nbUnits = units.length;
                    var sampleLen = 0;
                    for (var j = 0; j < nbUnits; j++) {
                      sampleLen += units[j].data.length;
                    }
                    naluLen += sampleLen;
                    nbNalu += nbUnits;
                    _sample.length = sampleLen;

                    // ensure sample monotonic DTS
                    _sample.dts = Math.max(_sample.dts, firstDTS);
                    minPTS = Math.min(_sample.pts, minPTS);
                    maxPTS = Math.max(_sample.pts, maxPTS);
                  }
                  lastDTS = inputSamples[nbSamples - 1].dts;

                  /* concatenate the video data and construct the mdat in place
                    (need 8 more bytes to fill length and mpdat type) */
                  var mdatSize = naluLen + 4 * nbNalu + 8;
                  var mdat;
                  try {
                    mdat = new Uint8Array(mdatSize);
                  } catch (err) {
                    (this || _global).observer.emit(_events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, _events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, {
                      type: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorTypes.MUX_ERROR,
                      details: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorDetails.REMUX_ALLOC_ERROR,
                      fatal: false,
                      bytes: mdatSize,
                      reason: "fail allocating video mdat " + mdatSize
                    });
                    return;
                  }
                  var view = new DataView(mdat.buffer);
                  view.setUint32(0, mdatSize);
                  mdat.set(_mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].types.mdat, 4);
                  var stretchedLastFrame = false;
                  var minDtsDelta = Number.POSITIVE_INFINITY;
                  var minPtsDelta = Number.POSITIVE_INFINITY;
                  var maxDtsDelta = Number.NEGATIVE_INFINITY;
                  var maxPtsDelta = Number.NEGATIVE_INFINITY;
                  for (var _i2 = 0; _i2 < nbSamples; _i2++) {
                    var avcSample = inputSamples[_i2];
                    var avcSampleUnits = avcSample.units;
                    var mp4SampleLength = 0;
                    // convert NALU bitstream to MP4 format (prepend NALU with size field)
                    for (var _j = 0, _nbUnits = avcSampleUnits.length; _j < _nbUnits; _j++) {
                      var unit = avcSampleUnits[_j];
                      var unitData = unit.data;
                      var unitDataLen = unit.data.byteLength;
                      view.setUint32(offset, unitDataLen);
                      offset += 4;
                      mdat.set(unitData, offset);
                      offset += unitDataLen;
                      mp4SampleLength += 4 + unitDataLen;
                    }

                    // expected sample duration is the Decoding Timestamp diff of consecutive samples
                    var ptsDelta = void 0;
                    if (_i2 < nbSamples - 1) {
                      mp4SampleDuration = inputSamples[_i2 + 1].dts - avcSample.dts;
                      ptsDelta = inputSamples[_i2 + 1].pts - avcSample.pts;
                    } else {
                      var config = (this || _global).config;
                      var lastFrameDuration = _i2 > 0 ? avcSample.dts - inputSamples[_i2 - 1].dts : averageSampleDuration;
                      ptsDelta = _i2 > 0 ? avcSample.pts - inputSamples[_i2 - 1].pts : averageSampleDuration;
                      if (config.stretchShortVideoTrack && (this || _global).nextAudioPts !== null) {
                        // In some cases, a segment's audio track duration may exceed the video track duration.
                        // Since we've already remuxed audio, and we know how long the audio track is, we look to
                        // see if the delta to the next segment is longer than maxBufferHole.
                        // If so, playback would potentially get stuck, so we artificially inflate
                        // the duration of the last frame to minimize any potential gap between segments.
                        var gapTolerance = Math.floor(config.maxBufferHole * timeScale);
                        var deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : (this || _global).nextAudioPts) - avcSample.pts;
                        if (deltaToFrameEnd > gapTolerance) {
                          // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                          // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                          mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                          if (mp4SampleDuration < 0) {
                            mp4SampleDuration = lastFrameDuration;
                          } else {
                            stretchedLastFrame = true;
                          }
                          _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("[mp4-remuxer]: It is approximately " + deltaToFrameEnd / 90 + " ms to the next segment; using duration " + mp4SampleDuration / 90 + " ms for the last video frame.");
                        } else {
                          mp4SampleDuration = lastFrameDuration;
                        }
                      } else {
                        mp4SampleDuration = lastFrameDuration;
                      }
                    }
                    var compositionTimeOffset = Math.round(avcSample.pts - avcSample.dts);
                    minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
                    maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
                    minPtsDelta = Math.min(minPtsDelta, ptsDelta);
                    maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
                    outputSamples.push(new Mp4Sample(avcSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
                  }
                  if (outputSamples.length) {
                    if (chromeVersion) {
                      if (chromeVersion < 70) {
                        // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
                        // https://code.google.com/p/chromium/issues/detail?id=229412
                        var flags = outputSamples[0].flags;
                        flags.dependsOn = 2;
                        flags.isNonSync = 0;
                      }
                    } else if (safariWebkitVersion) {
                      // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
                      // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
                      if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
                        var dts = firstDTS;
                        for (var _i3 = 0, len = outputSamples.length; _i3 < len; _i3++) {
                          var nextDts = dts + outputSamples[_i3].duration;
                          var _pts = dts + outputSamples[_i3].cts;
                          if (_i3 < len - 1) {
                            var nextPts = nextDts + outputSamples[_i3 + 1].cts;
                            outputSamples[_i3].duration = nextPts - _pts;
                          } else {
                            outputSamples[_i3].duration = _i3 ? outputSamples[_i3 - 1].duration : averageSampleDuration;
                          }
                          outputSamples[_i3].cts = 0;
                          dts = nextDts;
                        }
                      }
                    }
                  }
                  console.assert(mp4SampleDuration !== null, "mp4SampleDuration must be computed");
                  // next AVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
                  mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
                  (this || _global).nextAvcDts = nextAvcDts = lastDTS + mp4SampleDuration;
                  (this || _global).videoSampleDuration = mp4SampleDuration;
                  (this || _global).isVideoContiguous = true;
                  var moof = _mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].moof(track.sequenceNumber++, firstDTS, _extends({}, track, {
                    samples: outputSamples
                  }));
                  var type = "video";
                  var data = {
                    data1: moof,
                    data2: mdat,
                    startPTS: minPTS / timeScale,
                    endPTS: (maxPTS + mp4SampleDuration) / timeScale,
                    startDTS: firstDTS / timeScale,
                    endDTS: nextAvcDts / timeScale,
                    type: type,
                    hasAudio: false,
                    hasVideo: true,
                    nb: outputSamples.length,
                    dropped: track.dropped
                  };
                  track.samples = [];
                  track.dropped = 0;
                  console.assert(mdat.length, "MDAT length must not be zero");
                  return data;
                };
                _proto.remuxAudio = function remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
                  var inputTimeScale = track.inputTimeScale;
                  var mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
                  var scaleFactor = inputTimeScale / mp4timeScale;
                  var mp4SampleDuration = track.segmentCodec === "aac" ? AAC_SAMPLES_PER_FRAME : MPEG_AUDIO_SAMPLE_PER_FRAME;
                  var inputSampleDuration = mp4SampleDuration * scaleFactor;
                  var initPTS = (this || _global)._initPTS;
                  var rawMPEG = track.segmentCodec === "mp3" && (this || _global).typeSupported.mpeg;
                  var outputSamples = [];
                  var alignedWithVideo = videoTimeOffset !== undefined;
                  var inputSamples = track.samples;
                  var offset = rawMPEG ? 0 : 8;
                  var nextAudioPts = (this || _global).nextAudioPts || -1;

                  // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);

                  // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
                  // for sake of clarity:
                  // consecutive fragments are frags with
                  //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
                  //  - less than 20 audio frames distance
                  // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
                  // this helps ensuring audio continuity
                  // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
                  var timeOffsetMpegTS = timeOffset * inputTimeScale;
                  (this || _global).isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioPts > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - nextAudioPts) < 9000 || Math.abs(normalizePts(inputSamples[0].pts - initPTS, timeOffsetMpegTS) - nextAudioPts) < 20 * inputSampleDuration);

                  // compute normalized PTS
                  inputSamples.forEach(function (sample) {
                    sample.pts = normalizePts(sample.pts - initPTS, timeOffsetMpegTS);
                  });
                  if (!contiguous || nextAudioPts < 0) {
                    // filter out sample with negative PTS that are not playable anyway
                    // if we don't remove these negative samples, they will shift all audio samples forward.
                    // leading to audio overlap between current / next fragment
                    inputSamples = inputSamples.filter(function (sample) {
                      return sample.pts >= 0;
                    });

                    // in case all samples have negative PTS, and have been filtered out, return now
                    if (!inputSamples.length) {
                      return;
                    }
                    if (videoTimeOffset === 0) {
                      // Set the start to 0 to match video so that start gaps larger than inputSampleDuration are filled with silence
                      nextAudioPts = 0;
                    } else if (accurateTimeOffset && !alignedWithVideo) {
                      // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
                      nextAudioPts = Math.max(0, timeOffsetMpegTS);
                    } else {
                      // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
                      nextAudioPts = inputSamples[0].pts;
                    }
                  }

                  // If the audio track is missing samples, the frames seem to get "left-shifted" within the
                  // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
                  // In an effort to prevent this from happening, we inject frames here where there are gaps.
                  // When possible, we inject a silent frame; when that's not possible, we duplicate the last
                  // frame.

                  if (track.segmentCodec === "aac") {
                    var maxAudioFramesDrift = (this || _global).config.maxAudioFramesDrift;
                    for (var i = 0, nextPts = nextAudioPts; i < inputSamples.length; i++) {
                      // First, let's see how far off this frame is from where we expect it to be
                      var sample = inputSamples[i];
                      var pts = sample.pts;
                      var delta = pts - nextPts;
                      var duration = Math.abs(1000 * delta / inputTimeScale);

                      // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
                      if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
                        if (i === 0) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("Audio frame @ " + (pts / inputTimeScale).toFixed(3) + "s overlaps nextAudioPts by " + Math.round(1000 * delta / inputTimeScale) + " ms.");
                          (this || _global).nextAudioPts = nextAudioPts = nextPts = pts;
                        }
                      } // eslint-disable-line brace-style

                      // Insert missing frames if:
                      // 1: We're more than maxAudioFramesDrift frame away
                      // 2: Not more than MAX_SILENT_FRAME_DURATION away
                      // 3: currentTime (aka nextPtsNorm) is not 0
                      // 4: remuxing with video (videoTimeOffset !== undefined)
                      else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
                        var missing = Math.round(delta / inputSampleDuration);
                        // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
                        // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
                        nextPts = pts - missing * inputSampleDuration;
                        if (nextPts < 0) {
                          missing--;
                          nextPts += inputSampleDuration;
                        }
                        if (i === 0) {
                          (this || _global).nextAudioPts = nextAudioPts = nextPts;
                        }
                        _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: Injecting " + missing + " audio frame @ " + (nextPts / inputTimeScale).toFixed(3) + "s due to " + Math.round(1000 * delta / inputTimeScale) + " ms gap.");
                        for (var j = 0; j < missing; j++) {
                          var newStamp = Math.max(nextPts, 0);
                          var fillFrame = _aac_helper__WEBPACK_IMPORTED_MODULE_1__["default"].getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                          if (!fillFrame) {
                            _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.log("[mp4-remuxer]: Unable to get silent frame for given audio codec; duplicating last frame instead.");
                            fillFrame = sample.unit.subarray();
                          }
                          inputSamples.splice(i, 0, {
                            unit: fillFrame,
                            pts: newStamp
                          });
                          nextPts += inputSampleDuration;
                          i++;
                        }
                      }
                      sample.pts = nextPts;
                      nextPts += inputSampleDuration;
                    }
                  }
                  var firstPTS = null;
                  var lastPTS = null;
                  var mdat;
                  var mdatSize = 0;
                  var sampleLength = inputSamples.length;
                  while (sampleLength--) {
                    mdatSize += inputSamples[sampleLength].unit.byteLength;
                  }
                  for (var _j2 = 0, _nbSamples = inputSamples.length; _j2 < _nbSamples; _j2++) {
                    var audioSample = inputSamples[_j2];
                    var unit = audioSample.unit;
                    var _pts2 = audioSample.pts;
                    if (lastPTS !== null) {
                      // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
                      // the previous sample
                      var prevSample = outputSamples[_j2 - 1];
                      prevSample.duration = Math.round((_pts2 - lastPTS) / scaleFactor);
                    } else {
                      if (contiguous && track.segmentCodec === "aac") {
                        // set PTS/DTS to expected PTS/DTS
                        _pts2 = nextAudioPts;
                      }
                      // remember first PTS of our audioSamples
                      firstPTS = _pts2;
                      if (mdatSize > 0) {
                        /* concatenate the audio data and construct the mdat in place
                          (need 8 more bytes to fill length and mdat type) */
                        mdatSize += offset;
                        try {
                          mdat = new Uint8Array(mdatSize);
                        } catch (err) {
                          (this || _global).observer.emit(_events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, _events__WEBPACK_IMPORTED_MODULE_3__.Events.ERROR, {
                            type: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorTypes.MUX_ERROR,
                            details: _errors__WEBPACK_IMPORTED_MODULE_4__.ErrorDetails.REMUX_ALLOC_ERROR,
                            fatal: false,
                            bytes: mdatSize,
                            reason: "fail allocating audio mdat " + mdatSize
                          });
                          return;
                        }
                        if (!rawMPEG) {
                          var view = new DataView(mdat.buffer);
                          view.setUint32(0, mdatSize);
                          mdat.set(_mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].types.mdat, 4);
                        }
                      } else {
                        // no audio samples
                        return;
                      }
                    }
                    mdat.set(unit, offset);
                    var unitLen = unit.byteLength;
                    offset += unitLen;
                    // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
                    // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
                    // becomes the PTS diff with the previous sample
                    outputSamples.push(new Mp4Sample(true, mp4SampleDuration, unitLen, 0));
                    lastPTS = _pts2;
                  }

                  // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
                  var nbSamples = outputSamples.length;
                  if (!nbSamples) {
                    return;
                  }

                  // The next audio sample PTS should be equal to last sample PTS + duration
                  var lastSample = outputSamples[outputSamples.length - 1];
                  (this || _global).nextAudioPts = nextAudioPts = lastPTS + scaleFactor * lastSample.duration;

                  // Set the track samples from inputSamples to outputSamples before remuxing
                  var moof = rawMPEG ? new Uint8Array(0) : _mp4_generator__WEBPACK_IMPORTED_MODULE_2__["default"].moof(track.sequenceNumber++, firstPTS / scaleFactor, _extends({}, track, {
                    samples: outputSamples
                  }));

                  // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
                  track.samples = [];
                  var start = firstPTS / inputTimeScale;
                  var end = nextAudioPts / inputTimeScale;
                  var type = "audio";
                  var audioData = {
                    data1: moof,
                    data2: mdat,
                    startPTS: start,
                    endPTS: end,
                    startDTS: start,
                    endDTS: end,
                    type: type,
                    hasAudio: true,
                    hasVideo: false,
                    nb: nbSamples
                  };
                  (this || _global).isAudioContiguous = true;
                  console.assert(mdat.length, "MDAT length must not be zero");
                  return audioData;
                };
                _proto.remuxEmptyAudio = function remuxEmptyAudio(track, timeOffset, contiguous, videoData) {
                  var inputTimeScale = track.inputTimeScale;
                  var mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
                  var scaleFactor = inputTimeScale / mp4timeScale;
                  var nextAudioPts = (this || _global).nextAudioPts;
                  // sync with video's timestamp
                  var startDTS = (nextAudioPts !== null ? nextAudioPts : videoData.startDTS * inputTimeScale) + (this || _global)._initDTS;
                  var endDTS = videoData.endDTS * inputTimeScale + (this || _global)._initDTS;
                  // one sample's duration value
                  var frameDuration = scaleFactor * AAC_SAMPLES_PER_FRAME;
                  // samples count of this segment's duration
                  var nbSamples = Math.ceil((endDTS - startDTS) / frameDuration);
                  // silent frame
                  var silentFrame = _aac_helper__WEBPACK_IMPORTED_MODULE_1__["default"].getSilentFrame(track.manifestCodec || track.codec, track.channelCount);
                  _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.warn("[mp4-remuxer]: remux empty Audio");
                  // Can't remux if we can't generate a silent frame...
                  if (!silentFrame) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_5__.logger.trace("[mp4-remuxer]: Unable to remuxEmptyAudio since we were unable to get a silent frame for given audio codec");
                    return;
                  }
                  var samples = [];
                  for (var i = 0; i < nbSamples; i++) {
                    var stamp = startDTS + i * frameDuration;
                    samples.push({
                      unit: silentFrame,
                      pts: stamp,
                      dts: stamp
                    });
                  }
                  track.samples = samples;
                  return this.remuxAudio(track, timeOffset, contiguous, false);
                };
                return MP4Remuxer;
              }();
              function normalizePts(value, reference) {
                var offset;
                if (reference === null) {
                  return value;
                }
                if (reference < value) {
                  // - 2^33
                  offset = -8589934592;
                } else {
                  // + 2^33
                  offset = 8589934592;
                }
                /* PTS is 33bit (from 0 to 2^33 -1)
                  if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
                  PTS looping occured. fill the gap */
                while (Math.abs(value - reference) > 4294967296) {
                  value += offset;
                }
                return value;
              }
              function findKeyframeIndex(samples) {
                for (var i = 0; i < samples.length; i++) {
                  if (samples[i].key) {
                    return i;
                  }
                }
                return -1;
              }
              function flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
                var length = track.samples.length;
                if (!length) {
                  return;
                }
                var inputTimeScale = track.inputTimeScale;
                for (var index = 0; index < length; index++) {
                  var sample = track.samples[index];
                  // setting id3 pts, dts to relative time
                  // using this._initPTS and this._initDTS to calculate relative time
                  sample.pts = normalizePts(sample.pts - initPTS, timeOffset * inputTimeScale) / inputTimeScale;
                  sample.dts = normalizePts(sample.dts - initDTS, timeOffset * inputTimeScale) / inputTimeScale;
                }
                var samples = track.samples;
                track.samples = [];
                return {
                  samples: samples
                };
              }
              function flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
                var length = track.samples.length;
                if (!length) {
                  return;
                }
                var inputTimeScale = track.inputTimeScale;
                for (var index = 0; index < length; index++) {
                  var sample = track.samples[index];
                  // setting text pts, dts to relative time
                  // using this._initPTS and this._initDTS to calculate relative time
                  sample.pts = normalizePts(sample.pts - initPTS, timeOffset * inputTimeScale) / inputTimeScale;
                }
                track.samples.sort(function (a, b) {
                  return a.pts - b.pts;
                });
                var samples = track.samples;
                track.samples = [];
                return {
                  samples: samples
                };
              }
              var Mp4Sample = function Mp4Sample(isKeyframe, duration, size, cts) {
                (this || _global).size = void 0;
                (this || _global).duration = void 0;
                (this || _global).cts = void 0;
                (this || _global).flags = void 0;
                (this || _global).duration = duration;
                (this || _global).size = size;
                (this || _global).cts = cts;
                (this || _global).flags = new Mp4SampleFlags(isKeyframe);
              };
              var Mp4SampleFlags = function Mp4SampleFlags(isKeyframe) {
                (this || _global).isLeading = 0;
                (this || _global).isDependedOn = 0;
                (this || _global).hasRedundancy = 0;
                (this || _global).degradPrio = 0;
                (this || _global).dependsOn = 1;
                (this || _global).isNonSync = 1;
                (this || _global).dependsOn = isKeyframe ? 2 : 1;
                (this || _global).isNonSync = isKeyframe ? 0 : 1;
              };

              /***/
            },

            /***/"./src/remux/passthrough-remuxer.ts":
            /*!******************************************!*\
              !*** ./src/remux/passthrough-remuxer.ts ***!
              \******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _mp4_remuxer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./mp4-remuxer */"./src/remux/mp4-remuxer.ts");
              /* harmony import */
              var _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../utils/mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _loader_fragment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../loader/fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              var PassThroughRemuxer = /*#__PURE__*/function () {
                function PassThroughRemuxer() {
                  (this || _global).emitInitSegment = false;
                  (this || _global).audioCodec = void 0;
                  (this || _global).videoCodec = void 0;
                  (this || _global).initData = void 0;
                  (this || _global).initPTS = void 0;
                  (this || _global).initTracks = void 0;
                  (this || _global).lastEndTime = null;
                }
                var _proto = PassThroughRemuxer.prototype;
                _proto.destroy = function destroy() {};
                _proto.resetTimeStamp = function resetTimeStamp(defaultInitPTS) {
                  (this || _global).initPTS = defaultInitPTS;
                  (this || _global).lastEndTime = null;
                };
                _proto.resetNextTimestamp = function resetNextTimestamp() {
                  (this || _global).lastEndTime = null;
                };
                _proto.resetInitSegment = function resetInitSegment(initSegment, audioCodec, videoCodec) {
                  (this || _global).audioCodec = audioCodec;
                  (this || _global).videoCodec = videoCodec;
                  this.generateInitSegment(initSegment);
                  (this || _global).emitInitSegment = true;
                };
                _proto.generateInitSegment = function generateInitSegment(initSegment) {
                  var audioCodec = (this || _global).audioCodec,
                    videoCodec = (this || _global).videoCodec;
                  if (!initSegment || !initSegment.byteLength) {
                    (this || _global).initTracks = undefined;
                    (this || _global).initData = undefined;
                    return;
                  }
                  var initData = (this || _global).initData = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.parseInitSegment)(initSegment);

                  // Get codec from initSegment or fallback to default
                  if (!audioCodec) {
                    audioCodec = getParsedTrackCodec(initData.audio, _loader_fragment__WEBPACK_IMPORTED_MODULE_3__.ElementaryStreamTypes.AUDIO);
                  }
                  if (!videoCodec) {
                    videoCodec = getParsedTrackCodec(initData.video, _loader_fragment__WEBPACK_IMPORTED_MODULE_3__.ElementaryStreamTypes.VIDEO);
                  }
                  var tracks = {};
                  if (initData.audio && initData.video) {
                    tracks.audiovideo = {
                      container: "video/mp4",
                      codec: audioCodec + "," + videoCodec,
                      initSegment: initSegment,
                      id: "main"
                    };
                  } else if (initData.audio) {
                    tracks.audio = {
                      container: "audio/mp4",
                      codec: audioCodec,
                      initSegment: initSegment,
                      id: "audio"
                    };
                  } else if (initData.video) {
                    tracks.video = {
                      container: "video/mp4",
                      codec: videoCodec,
                      initSegment: initSegment,
                      id: "main"
                    };
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.warn("[passthrough-remuxer.ts]: initSegment does not contain moov or trak boxes.");
                  }
                  (this || _global).initTracks = tracks;
                };
                _proto.remux = function remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset) {
                  var _this$initPTS;
                  var initPTS = (this || _global).initPTS,
                    lastEndTime = (this || _global).lastEndTime;
                  var result = {
                    audio: undefined,
                    video: undefined,
                    text: textTrack,
                    id3: id3Track,
                    initSegment: undefined
                  };

                  // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
                  // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
                  // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
                  if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(lastEndTime)) {
                    lastEndTime = (this || _global).lastEndTime = timeOffset || 0;
                  }

                  // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
                  // audio or video (or both); adding it to video was an arbitrary choice.
                  var data = videoTrack.samples;
                  if (!data || !data.length) {
                    return result;
                  }
                  var initSegment = {
                    initPTS: undefined,
                    timescale: 1
                  };
                  var initData = (this || _global).initData;
                  if (!initData || !initData.length) {
                    this.generateInitSegment(data);
                    initData = (this || _global).initData;
                  }
                  if (!initData || !initData.length) {
                    // We can't remux if the initSegment could not be generated
                    _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.warn("[passthrough-remuxer.ts]: Failed to generate initSegment.");
                    return result;
                  }
                  if ((this || _global).emitInitSegment) {
                    initSegment.tracks = (this || _global).initTracks;
                    (this || _global).emitInitSegment = false;
                  }
                  var startDTS = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.getStartDTS)(initData, data);
                  if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(initPTS)) {
                    (this || _global).initPTS = initSegment.initPTS = initPTS = startDTS - timeOffset;
                  }
                  var duration = (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.getDuration)(data, initData);
                  var startTime = audioTrack ? startDTS - initPTS : lastEndTime;
                  var endTime = startTime + duration;
                  (0, _utils_mp4_tools__WEBPACK_IMPORTED_MODULE_2__.offsetStartDTS)(initData, data, initPTS);
                  if (duration > 0) {
                    (this || _global).lastEndTime = endTime;
                  } else {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_4__.logger.warn("Duration parsed from mp4 should be greater than zero");
                    this.resetNextTimestamp();
                  }
                  var hasAudio = !!initData.audio;
                  var hasVideo = !!initData.video;
                  var type = "";
                  if (hasAudio) {
                    type += "audio";
                  }
                  if (hasVideo) {
                    type += "video";
                  }
                  var track = {
                    data1: data,
                    startPTS: startTime,
                    startDTS: startTime,
                    endPTS: endTime,
                    endDTS: endTime,
                    type: type,
                    hasAudio: hasAudio,
                    hasVideo: hasVideo,
                    nb: 1,
                    dropped: 0
                  };
                  result.audio = track.type === "audio" ? track : undefined;
                  result.video = track.type !== "audio" ? track : undefined;
                  result.initSegment = initSegment;
                  var initPtsNum = (_this$initPTS = (this || _global).initPTS) != null ? _this$initPTS : 0;
                  result.id3 = (0, _mp4_remuxer__WEBPACK_IMPORTED_MODULE_1__.flushTextTrackMetadataCueSamples)(id3Track, timeOffset, initPtsNum, initPtsNum);
                  if (textTrack.samples.length) {
                    result.text = (0, _mp4_remuxer__WEBPACK_IMPORTED_MODULE_1__.flushTextTrackUserdataCueSamples)(textTrack, timeOffset, initPtsNum);
                  }
                  return result;
                };
                return PassThroughRemuxer;
              }();
              function getParsedTrackCodec(track, type) {
                var parsedCodec = track === null || track === void 0 ? void 0 : track.codec;
                if (parsedCodec && parsedCodec.length > 4) {
                  return parsedCodec;
                }
                // Since mp4-tools cannot parse full codec string (see 'TODO: Parse codec details'... in mp4-tools)
                // Provide defaults based on codec type
                // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
                if (parsedCodec === "hvc1" || parsedCodec === "hev1") {
                  return "hvc1.1.c.L120.90";
                }
                if (parsedCodec === "av01") {
                  return "av01.0.04M.08";
                }
                if (parsedCodec === "avc1" || type === _loader_fragment__WEBPACK_IMPORTED_MODULE_3__.ElementaryStreamTypes.VIDEO) {
                  return "avc1.42e01e";
                }
                return "mp4a.40.5";
              }
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = PassThroughRemuxer;

              /***/
            },

            /***/"./src/task-loop.ts":
            /*!**************************!*\
              !*** ./src/task-loop.ts ***!
              \**************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */TaskLoop
                /* harmony export */
              });
              /**
               * Sub-class specialization of EventHandler base class.
               *
               * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
               * scheduled asynchroneously, avoiding recursive calls in the same tick.
               *
               * The task itself is implemented in `doTick`. It can be requested and called for single execution
               * using the `tick` method.
               *
               * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
               * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
               *
               * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
               * and cancelled with `clearNextTick`.
               *
               * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
               *
               * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
               *
               * Further explanations:
               *
               * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
               * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
               *
               * When the task execution (`tick` method) is called in re-entrant way this is detected and
               * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
               * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
               */
              var TaskLoop = /*#__PURE__*/function () {
                function TaskLoop() {
                  (this || _global)._boundTick = void 0;
                  (this || _global)._tickTimer = null;
                  (this || _global)._tickInterval = null;
                  (this || _global)._tickCallCount = 0;
                  (this || _global)._boundTick = (this || _global).tick.bind(this || _global);
                }
                var _proto = TaskLoop.prototype;
                _proto.destroy = function destroy() {
                  this.onHandlerDestroying();
                  this.onHandlerDestroyed();
                };
                _proto.onHandlerDestroying = function onHandlerDestroying() {
                  // clear all timers before unregistering from event bus
                  this.clearNextTick();
                  this.clearInterval();
                };
                _proto.onHandlerDestroyed = function onHandlerDestroyed() {}

                /**
                 * @returns {boolean}
                 */;
                _proto.hasInterval = function hasInterval() {
                  return !!(this || _global)._tickInterval;
                }

                /**
                 * @returns {boolean}
                 */;
                _proto.hasNextTick = function hasNextTick() {
                  return !!(this || _global)._tickTimer;
                }

                /**
                 * @param {number} millis Interval time (ms)
                 * @returns {boolean} True when interval has been scheduled, false when already scheduled (no effect)
                 */;
                _proto.setInterval = function setInterval(millis) {
                  if (!(this || _global)._tickInterval) {
                    (this || _global)._tickInterval = self.setInterval((this || _global)._boundTick, millis);
                    return true;
                  }
                  return false;
                }

                /**
                 * @returns {boolean} True when interval was cleared, false when none was set (no effect)
                 */;
                _proto.clearInterval = function clearInterval() {
                  if ((this || _global)._tickInterval) {
                    self.clearInterval((this || _global)._tickInterval);
                    (this || _global)._tickInterval = null;
                    return true;
                  }
                  return false;
                }

                /**
                 * @returns {boolean} True when timeout was cleared, false when none was set (no effect)
                 */;
                _proto.clearNextTick = function clearNextTick() {
                  if ((this || _global)._tickTimer) {
                    self.clearTimeout((this || _global)._tickTimer);
                    (this || _global)._tickTimer = null;
                    return true;
                  }
                  return false;
                }

                /**
                 * Will call the subclass doTick implementation in this main loop tick
                 * or in the next one (via setTimeout(,0)) in case it has already been called
                 * in this tick (in case this is a re-entrant call).
                 */;
                _proto.tick = function tick() {
                  (this || _global)._tickCallCount++;
                  if ((this || _global)._tickCallCount === 1) {
                    this.doTick();
                    // re-entrant call to tick from previous doTick call stack
                    // -> schedule a call on the next main loop iteration to process this task processing request
                    if ((this || _global)._tickCallCount > 1) {
                      // make sure only one timer exists at any time at max
                      this.tickImmediate();
                    }
                    (this || _global)._tickCallCount = 0;
                  }
                };
                _proto.tickImmediate = function tickImmediate() {
                  this.clearNextTick();
                  (this || _global)._tickTimer = self.setTimeout((this || _global)._boundTick, 0);
                }

                /**
                 * For subclass to implement task logic
                 * @abstract
                 */;
                _proto.doTick = function doTick() {};
                return TaskLoop;
              }();

              /***/
            },

            /***/"./src/types/cmcd.ts":
            /*!***************************!*\
              !*** ./src/types/cmcd.ts ***!
              \***************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"CMCDObjectType": () => /* binding */CMCDObjectType,
                /* harmony export */"CMCDStreamType": () => /* binding */CMCDStreamType,
                /* harmony export */"CMCDStreamingFormat": () => /* binding */CMCDStreamingFormat,
                /* harmony export */"CMCDVersion": () => /* binding */CMCDVersion
                /* harmony export */
              });
              /**
               * CMCD spec version
               */
              var CMCDVersion = 1;

              /**
               * CMCD Object Type
               */
              var CMCDObjectType;

              /**
               * CMCD Streaming Format
               */
              (function (CMCDObjectType) {
                CMCDObjectType["MANIFEST"] = "m";
                CMCDObjectType["AUDIO"] = "a";
                CMCDObjectType["VIDEO"] = "v";
                CMCDObjectType["MUXED"] = "av";
                CMCDObjectType["INIT"] = "i";
                CMCDObjectType["CAPTION"] = "c";
                CMCDObjectType["TIMED_TEXT"] = "tt";
                CMCDObjectType["KEY"] = "k";
                CMCDObjectType["OTHER"] = "o";
              })(CMCDObjectType || (CMCDObjectType = {}));
              var CMCDStreamingFormat;

              /**
               * CMCD Streaming Type
               */
              (function (CMCDStreamingFormat) {
                CMCDStreamingFormat["DASH"] = "d";
                CMCDStreamingFormat["HLS"] = "h";
                CMCDStreamingFormat["SMOOTH"] = "s";
                CMCDStreamingFormat["OTHER"] = "o";
              })(CMCDStreamingFormat || (CMCDStreamingFormat = {}));
              var CMCDStreamType;

              /**
               * CMCD Headers
               */
              (function (CMCDStreamType) {
                CMCDStreamType["VOD"] = "v";
                CMCDStreamType["LIVE"] = "l";
              })(CMCDStreamType || (CMCDStreamType = {}));

              /***/
            },

            /***/"./src/types/demuxer.ts":
            /*!******************************!*\
              !*** ./src/types/demuxer.ts ***!
              \******************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"MetadataSchema": () => /* binding */MetadataSchema
                /* harmony export */
              });
              var MetadataSchema;
              (function (MetadataSchema) {
                MetadataSchema["audioId3"] = "org.id3";
                MetadataSchema["dateRange"] = "com.apple.quicktime.HLS";
                MetadataSchema["emsg"] = "https://aomedia.org/emsg/ID3";
              })(MetadataSchema || (MetadataSchema = {}));

              /***/
            },

            /***/"./src/types/level.ts":
            /*!****************************!*\
              !*** ./src/types/level.ts ***!
              \****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"HlsSkip": () => /* binding */HlsSkip,
                /* harmony export */"HlsUrlParameters": () => /* binding */HlsUrlParameters,
                /* harmony export */"Level": () => /* binding */Level,
                /* harmony export */"getSkipValue": () => /* binding */getSkipValue
                /* harmony export */
              });
              function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                  var descriptor = props[i];
                  descriptor.enumerable = descriptor.enumerable || false;
                  descriptor.configurable = true;
                  if ("value" in descriptor) descriptor.writable = true;
                  Object.defineProperty(target, descriptor.key, descriptor);
                }
              }
              function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                  writable: false
                });
                return Constructor;
              }
              var HlsSkip;
              (function (HlsSkip) {
                HlsSkip["No"] = "";
                HlsSkip["Yes"] = "YES";
                HlsSkip["v2"] = "v2";
              })(HlsSkip || (HlsSkip = {}));
              function getSkipValue(details, msn) {
                var canSkipUntil = details.canSkipUntil,
                  canSkipDateRanges = details.canSkipDateRanges,
                  endSN = details.endSN;
                var snChangeGoal = msn !== undefined ? msn - endSN : 0;
                if (canSkipUntil && snChangeGoal < canSkipUntil) {
                  if (canSkipDateRanges) {
                    return HlsSkip.v2;
                  }
                  return HlsSkip.Yes;
                }
                return HlsSkip.No;
              }
              var HlsUrlParameters = /*#__PURE__*/function () {
                function HlsUrlParameters(msn, part, skip) {
                  (this || _global).msn = void 0;
                  (this || _global).part = void 0;
                  (this || _global).skip = void 0;
                  (this || _global).msn = msn;
                  (this || _global).part = part;
                  (this || _global).skip = skip;
                }
                var _proto = HlsUrlParameters.prototype;
                _proto.addDirectives = function addDirectives(uri) {
                  var url = new self.URL(uri);
                  if ((this || _global).msn !== undefined) {
                    url.searchParams.set("_HLS_msn", (this || _global).msn.toString());
                  }
                  if ((this || _global).part !== undefined) {
                    url.searchParams.set("_HLS_part", (this || _global).part.toString());
                  }
                  if ((this || _global).skip) {
                    url.searchParams.set("_HLS_skip", (this || _global).skip);
                  }
                  return url.toString();
                };
                return HlsUrlParameters;
              }();
              var Level = /*#__PURE__*/function () {
                function Level(data) {
                  (this || _global).attrs = void 0;
                  (this || _global).audioCodec = void 0;
                  (this || _global).bitrate = void 0;
                  (this || _global).codecSet = void 0;
                  (this || _global).height = void 0;
                  (this || _global).id = void 0;
                  (this || _global).name = void 0;
                  (this || _global).videoCodec = void 0;
                  (this || _global).width = void 0;
                  (this || _global).unknownCodecs = void 0;
                  (this || _global).audioGroupIds = void 0;
                  (this || _global).details = void 0;
                  (this || _global).fragmentError = 0;
                  (this || _global).loadError = 0;
                  (this || _global).loaded = void 0;
                  (this || _global).realBitrate = 0;
                  (this || _global).textGroupIds = void 0;
                  (this || _global).url = void 0;
                  (this || _global)._urlId = 0;
                  (this || _global).url = [data.url];
                  (this || _global).attrs = data.attrs;
                  (this || _global).bitrate = data.bitrate;
                  if (data.details) {
                    (this || _global).details = data.details;
                  }
                  (this || _global).id = data.id || 0;
                  (this || _global).name = data.name;
                  (this || _global).width = data.width || 0;
                  (this || _global).height = data.height || 0;
                  (this || _global).audioCodec = data.audioCodec;
                  (this || _global).videoCodec = data.videoCodec;
                  (this || _global).unknownCodecs = data.unknownCodecs;
                  (this || _global).codecSet = [data.videoCodec, data.audioCodec].filter(function (c) {
                    return c;
                  }).join(",").replace(/\.[^.,]+/g, "");
                }
                _createClass(Level, [{
                  key: "maxBitrate",
                  get: function get() {
                    return Math.max((this || _global).realBitrate, (this || _global).bitrate);
                  }
                }, {
                  key: "uri",
                  get: function get() {
                    return (this || _global).url[(this || _global)._urlId] || "";
                  }
                }, {
                  key: "urlId",
                  get: function get() {
                    return (this || _global)._urlId;
                  },
                  set: function set(value) {
                    var newValue = value % (this || _global).url.length;
                    if ((this || _global)._urlId !== newValue) {
                      (this || _global).details = undefined;
                      (this || _global)._urlId = newValue;
                    }
                  }
                }]);
                return Level;
              }();

              /***/
            },

            /***/"./src/types/loader.ts":
            /*!*****************************!*\
              !*** ./src/types/loader.ts ***!
              \*****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"PlaylistContextType": () => /* binding */PlaylistContextType,
                /* harmony export */"PlaylistLevelType": () => /* binding */PlaylistLevelType
                /* harmony export */
              });
              var PlaylistContextType;
              (function (PlaylistContextType) {
                PlaylistContextType["MANIFEST"] = "manifest";
                PlaylistContextType["LEVEL"] = "level";
                PlaylistContextType["AUDIO_TRACK"] = "audioTrack";
                PlaylistContextType["SUBTITLE_TRACK"] = "subtitleTrack";
              })(PlaylistContextType || (PlaylistContextType = {}));
              var PlaylistLevelType;
              (function (PlaylistLevelType) {
                PlaylistLevelType["MAIN"] = "main";
                PlaylistLevelType["AUDIO"] = "audio";
                PlaylistLevelType["SUBTITLE"] = "subtitle";
              })(PlaylistLevelType || (PlaylistLevelType = {}));

              /***/
            },

            /***/"./src/types/transmuxer.ts":
            /*!*********************************!*\
              !*** ./src/types/transmuxer.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"ChunkMetadata": () => /* binding */ChunkMetadata
                /* harmony export */
              });
              var ChunkMetadata = function ChunkMetadata(level, sn, id, size, part, partial) {
                if (size === void 0) {
                  size = 0;
                }
                if (part === void 0) {
                  part = -1;
                }
                if (partial === void 0) {
                  partial = false;
                }
                (this || _global).level = void 0;
                (this || _global).sn = void 0;
                (this || _global).part = void 0;
                (this || _global).id = void 0;
                (this || _global).size = void 0;
                (this || _global).partial = void 0;
                (this || _global).transmuxing = getNewPerformanceTiming();
                (this || _global).buffering = {
                  audio: getNewPerformanceTiming(),
                  video: getNewPerformanceTiming(),
                  audiovideo: getNewPerformanceTiming()
                };
                (this || _global).level = level;
                (this || _global).sn = sn;
                (this || _global).id = id;
                (this || _global).size = size;
                (this || _global).part = part;
                (this || _global).partial = partial;
              };
              function getNewPerformanceTiming() {
                return {
                  start: 0,
                  executeStart: 0,
                  executeEnd: 0,
                  end: 0
                };
              }

              /***/
            },

            /***/"./src/utils/attr-list.ts":
            /*!********************************!*\
              !*** ./src/utils/attr-list.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"AttrList": () => /* binding */AttrList
                /* harmony export */
              });
              var DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/; // eslint-disable-line no-useless-escape
              var ATTR_LIST_REGEX = /\s*(.+?)\s*=((?:\".*?\")|.*?)(?:,|$)/g; // eslint-disable-line no-useless-escape

              // adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
              var AttrList = /*#__PURE__*/function () {
                function AttrList(attrs) {
                  if (typeof attrs === "string") {
                    attrs = AttrList.parseAttrList(attrs);
                  }
                  for (var attr in attrs) {
                    if (attrs.hasOwnProperty(attr)) {
                      (this || _global)[attr] = attrs[attr];
                    }
                  }
                }
                var _proto = AttrList.prototype;
                _proto.decimalInteger = function decimalInteger(attrName) {
                  var intValue = parseInt((this || _global)[attrName], 10);
                  if (intValue > Number.MAX_SAFE_INTEGER) {
                    return Infinity;
                  }
                  return intValue;
                };
                _proto.hexadecimalInteger = function hexadecimalInteger(attrName) {
                  if ((this || _global)[attrName]) {
                    var stringValue = ((this || _global)[attrName] || "0x").slice(2);
                    stringValue = (stringValue.length & 1 ? "0" : "") + stringValue;
                    var value = new Uint8Array(stringValue.length / 2);
                    for (var i = 0; i < stringValue.length / 2; i++) {
                      value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
                    }
                    return value;
                  } else {
                    return null;
                  }
                };
                _proto.hexadecimalIntegerAsNumber = function hexadecimalIntegerAsNumber(attrName) {
                  var intValue = parseInt((this || _global)[attrName], 16);
                  if (intValue > Number.MAX_SAFE_INTEGER) {
                    return Infinity;
                  }
                  return intValue;
                };
                _proto.decimalFloatingPoint = function decimalFloatingPoint(attrName) {
                  return parseFloat((this || _global)[attrName]);
                };
                _proto.optionalFloat = function optionalFloat(attrName, defaultValue) {
                  var value = (this || _global)[attrName];
                  return value ? parseFloat(value) : defaultValue;
                };
                _proto.enumeratedString = function enumeratedString(attrName) {
                  return (this || _global)[attrName];
                };
                _proto.bool = function bool(attrName) {
                  return (this || _global)[attrName] === "YES";
                };
                _proto.decimalResolution = function decimalResolution(attrName) {
                  var res = DECIMAL_RESOLUTION_REGEX.exec((this || _global)[attrName]);
                  if (res === null) {
                    return undefined;
                  }
                  return {
                    width: parseInt(res[1], 10),
                    height: parseInt(res[2], 10)
                  };
                };
                AttrList.parseAttrList = function parseAttrList(input) {
                  var match;
                  var attrs = {};
                  var quote = "\"";
                  ATTR_LIST_REGEX.lastIndex = 0;
                  while ((match = ATTR_LIST_REGEX.exec(input)) !== null) {
                    var value = match[2];
                    if (value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1) {
                      value = value.slice(1, -1);
                    }
                    attrs[match[1]] = value;
                  }
                  return attrs;
                };
                return AttrList;
              }();

              /***/
            },

            /***/"./src/utils/binary-search.ts":
            /*!************************************!*\
              !*** ./src/utils/binary-search.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              var BinarySearch = {
                /**
                 * Searches for an item in an array which matches a certain condition.
                 * This requires the condition to only match one item in the array,
                 * and for the array to be ordered.
                 *
                 * @param {Array<T>} list The array to search.
                 * @param {BinarySearchComparison<T>} comparisonFn
                 *      Called and provided a candidate item as the first argument.
                 *      Should return:
                 *          > -1 if the item should be located at a lower index than the provided item.
                 *          > 1 if the item should be located at a higher index than the provided item.
                 *          > 0 if the item is the item you're looking for.
                 *
                 * @return {T | null} The object if it is found or null otherwise.
                 */
                search: function search(list, comparisonFn) {
                  var minIndex = 0;
                  var maxIndex = list.length - 1;
                  var currentIndex = null;
                  var currentElement = null;
                  while (minIndex <= maxIndex) {
                    currentIndex = (minIndex + maxIndex) / 2 | 0;
                    currentElement = list[currentIndex];
                    var comparisonResult = comparisonFn(currentElement);
                    if (comparisonResult > 0) {
                      minIndex = currentIndex + 1;
                    } else if (comparisonResult < 0) {
                      maxIndex = currentIndex - 1;
                    } else {
                      return currentElement;
                    }
                  }
                  return null;
                }
              };
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = BinarySearch;

              /***/
            },

            /***/"./src/utils/buffer-helper.ts":
            /*!************************************!*\
              !*** ./src/utils/buffer-helper.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"BufferHelper": () => /* binding */BufferHelper
                /* harmony export */
              });
              /* harmony import */
              var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./logger */"./src/utils/logger.ts");
              /**
               * @module BufferHelper
               *
               * Providing methods dealing with buffer length retrieval for example.
               *
               * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
               *
               * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
               */

              var noopBuffered = {
                length: 0,
                start: function start() {
                  return 0;
                },
                end: function end() {
                  return 0;
                }
              };
              var BufferHelper = /*#__PURE__*/function () {
                function BufferHelper() {}
                /**
                 * Return true if `media`'s buffered include `position`
                 * @param {Bufferable} media
                 * @param {number} position
                 * @returns {boolean}
                 */
                BufferHelper.isBuffered = function isBuffered(media, position) {
                  try {
                    if (media) {
                      var buffered = BufferHelper.getBuffered(media);
                      for (var i = 0; i < buffered.length; i++) {
                        if (position >= buffered.start(i) && position <= buffered.end(i)) {
                          return true;
                        }
                      }
                    }
                  } catch (error) {
                    // this is to catch
                    // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
                    // This SourceBuffer has been removed from the parent media source
                  }
                  return false;
                };
                BufferHelper.bufferInfo = function bufferInfo(media, pos, maxHoleDuration) {
                  try {
                    if (media) {
                      var vbuffered = BufferHelper.getBuffered(media);
                      var buffered = [];
                      var i;
                      for (i = 0; i < vbuffered.length; i++) {
                        buffered.push({
                          start: vbuffered.start(i),
                          end: vbuffered.end(i)
                        });
                      }
                      return this.bufferedInfo(buffered, pos, maxHoleDuration);
                    }
                  } catch (error) {
                    // this is to catch
                    // InvalidStateError: Failed to read the 'buffered' property from 'SourceBuffer':
                    // This SourceBuffer has been removed from the parent media source
                  }
                  return {
                    len: 0,
                    start: pos,
                    end: pos,
                    nextStart: undefined
                  };
                };
                BufferHelper.bufferedInfo = function bufferedInfo(buffered, pos, maxHoleDuration) {
                  pos = Math.max(0, pos);
                  // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
                  buffered.sort(function (a, b) {
                    var diff = a.start - b.start;
                    if (diff) {
                      return diff;
                    } else {
                      return b.end - a.end;
                    }
                  });
                  var buffered2 = [];
                  if (maxHoleDuration) {
                    // there might be some small holes between buffer time range
                    // consider that holes smaller than maxHoleDuration are irrelevant and build another
                    // buffer time range representations that discards those holes
                    for (var i = 0; i < buffered.length; i++) {
                      var buf2len = buffered2.length;
                      if (buf2len) {
                        var buf2end = buffered2[buf2len - 1].end;
                        // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                        if (buffered[i].start - buf2end < maxHoleDuration) {
                          // merge overlapping time ranges
                          // update lastRange.end only if smaller than item.end
                          // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                          // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                          if (buffered[i].end > buf2end) {
                            buffered2[buf2len - 1].end = buffered[i].end;
                          }
                        } else {
                          // big hole
                          buffered2.push(buffered[i]);
                        }
                      } else {
                        // first value
                        buffered2.push(buffered[i]);
                      }
                    }
                  } else {
                    buffered2 = buffered;
                  }
                  var bufferLen = 0;

                  // bufferStartNext can possibly be undefined based on the conditional logic below
                  var bufferStartNext;

                  // bufferStart and bufferEnd are buffer boundaries around current video position
                  var bufferStart = pos;
                  var bufferEnd = pos;
                  for (var _i = 0; _i < buffered2.length; _i++) {
                    var start = buffered2[_i].start;
                    var end = buffered2[_i].end;
                    // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
                    if (pos + maxHoleDuration >= start && pos < end) {
                      // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                      bufferStart = start;
                      bufferEnd = end;
                      bufferLen = bufferEnd - pos;
                    } else if (pos + maxHoleDuration < start) {
                      bufferStartNext = start;
                      break;
                    }
                  }
                  return {
                    len: bufferLen,
                    start: bufferStart || 0,
                    end: bufferEnd || 0,
                    nextStart: bufferStartNext
                  };
                }

                /**
                 * Safe method to get buffered property.
                 * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
                 */;
                BufferHelper.getBuffered = function getBuffered(media) {
                  try {
                    return media.buffered;
                  } catch (e) {
                    _logger__WEBPACK_IMPORTED_MODULE_0__.logger.log("failed to get media.buffered", e);
                    return noopBuffered;
                  }
                };
                return BufferHelper;
              }();

              /***/
            },

            /***/"./src/utils/cea-608-parser.ts":
            /*!*************************************!*\
              !*** ./src/utils/cea-608-parser.ts ***!
              \*************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"CaptionScreen": () => /* binding */CaptionScreen,
                /* harmony export */"Row": () => /* binding */Row,
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");

              /**
               *
               * This code was ported from the dash.js project at:
               *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
               *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
               *
               * The original copyright appears below:
               *
               * The copyright in this software is being made available under the BSD License,
               * included below. This software may be subject to other third party and contributor
               * rights, including patent rights, and no such rights are granted under this license.
               *
               * Copyright (c) 2015-2016, DASH Industry Forum.
               * All rights reserved.
               *
               * Redistribution and use in source and binary forms, with or without modification,
               * are permitted provided that the following conditions are met:
               *  1. Redistributions of source code must retain the above copyright notice, this
               *  list of conditions and the following disclaimer.
               *  * Redistributions in binary form must reproduce the above copyright notice,
               *  this list of conditions and the following disclaimer in the documentation and/or
               *  other materials provided with the distribution.
               *  2. Neither the name of Dash Industry Forum nor the names of its
               *  contributors may be used to endorse or promote products derived from this software
               *  without specific prior written permission.
               *
               *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
               *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
               *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
               *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
               *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
               *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
               *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
               *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
               *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
               *  POSSIBILITY OF SUCH DAMAGE.
               */
              /**
               *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
               */

              var specialCea608CharsCodes = {
                42: 225,
                // lowercase a, acute accent
                92: 233,
                // lowercase e, acute accent
                94: 237,
                // lowercase i, acute accent
                95: 243,
                // lowercase o, acute accent
                96: 250,
                // lowercase u, acute accent
                123: 231,
                // lowercase c with cedilla
                124: 247,
                // division symbol
                125: 209,
                // uppercase N tilde
                126: 241,
                // lowercase n tilde
                127: 9608,
                // Full block
                // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
                // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
                128: 174,
                // Registered symbol (R)
                129: 176,
                // degree sign
                130: 189,
                // 1/2 symbol
                131: 191,
                // Inverted (open) question mark
                132: 8482,
                // Trademark symbol (TM)
                133: 162,
                // Cents symbol
                134: 163,
                // Pounds sterling
                135: 9834,
                // Music 8'th note
                136: 224,
                // lowercase a, grave accent
                137: 32,
                // transparent space (regular)
                138: 232,
                // lowercase e, grave accent
                139: 226,
                // lowercase a, circumflex accent
                140: 234,
                // lowercase e, circumflex accent
                141: 238,
                // lowercase i, circumflex accent
                142: 244,
                // lowercase o, circumflex accent
                143: 251,
                // lowercase u, circumflex accent
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
                144: 193,
                // capital letter A with acute
                145: 201,
                // capital letter E with acute
                146: 211,
                // capital letter O with acute
                147: 218,
                // capital letter U with acute
                148: 220,
                // capital letter U with diaresis
                149: 252,
                // lowercase letter U with diaeresis
                150: 8216,
                // opening single quote
                151: 161,
                // inverted exclamation mark
                152: 42,
                // asterisk
                153: 8217,
                // closing single quote
                154: 9473,
                // box drawings heavy horizontal
                155: 169,
                // copyright sign
                156: 8480,
                // Service mark
                157: 8226,
                // (round) bullet
                158: 8220,
                // Left double quotation mark
                159: 8221,
                // Right double quotation mark
                160: 192,
                // uppercase A, grave accent
                161: 194,
                // uppercase A, circumflex
                162: 199,
                // uppercase C with cedilla
                163: 200,
                // uppercase E, grave accent
                164: 202,
                // uppercase E, circumflex
                165: 203,
                // capital letter E with diaresis
                166: 235,
                // lowercase letter e with diaresis
                167: 206,
                // uppercase I, circumflex
                168: 207,
                // uppercase I, with diaresis
                169: 239,
                // lowercase i, with diaresis
                170: 212,
                // uppercase O, circumflex
                171: 217,
                // uppercase U, grave accent
                172: 249,
                // lowercase u, grave accent
                173: 219,
                // uppercase U, circumflex
                174: 171,
                // left-pointing double angle quotation mark
                175: 187,
                // right-pointing double angle quotation mark
                // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
                // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
                176: 195,
                // Uppercase A, tilde
                177: 227,
                // Lowercase a, tilde
                178: 205,
                // Uppercase I, acute accent
                179: 204,
                // Uppercase I, grave accent
                180: 236,
                // Lowercase i, grave accent
                181: 210,
                // Uppercase O, grave accent
                182: 242,
                // Lowercase o, grave accent
                183: 213,
                // Uppercase O, tilde
                184: 245,
                // Lowercase o, tilde
                185: 123,
                // Open curly brace
                186: 125,
                // Closing curly brace
                187: 92,
                // Backslash
                188: 94,
                // Caret
                189: 95,
                // Underscore
                190: 124,
                // Pipe (vertical line)
                191: 8764,
                // Tilde operator
                192: 196,
                // Uppercase A, umlaut
                193: 228,
                // Lowercase A, umlaut
                194: 214,
                // Uppercase O, umlaut
                195: 246,
                // Lowercase o, umlaut
                196: 223,
                // Esszett (sharp S)
                197: 165,
                // Yen symbol
                198: 164,
                // Generic currency sign
                199: 9475,
                // Box drawings heavy vertical
                200: 197,
                // Uppercase A, ring
                201: 229,
                // Lowercase A, ring
                202: 216,
                // Uppercase O, stroke
                203: 248,
                // Lowercase o, strok
                204: 9487,
                // Box drawings heavy down and right
                205: 9491,
                // Box drawings heavy down and left
                206: 9495,
                // Box drawings heavy up and right
                207: 9499 // Box drawings heavy up and left
              };

              /**
               * Utils
               */
              var getCharForByte = function getCharForByte(_byte) {
                var charCode = _byte;
                if (specialCea608CharsCodes.hasOwnProperty(_byte)) {
                  charCode = specialCea608CharsCodes[_byte];
                }
                return String.fromCharCode(charCode);
              };
              var NR_ROWS = 15;
              var NR_COLS = 100;
              // Tables to look up row from PAC data
              var rowsLowCh1 = {
                17: 1,
                18: 3,
                21: 5,
                22: 7,
                23: 9,
                16: 11,
                19: 12,
                20: 14
              };
              var rowsHighCh1 = {
                17: 2,
                18: 4,
                21: 6,
                22: 8,
                23: 10,
                19: 13,
                20: 15
              };
              var rowsLowCh2 = {
                25: 1,
                26: 3,
                29: 5,
                30: 7,
                31: 9,
                24: 11,
                27: 12,
                28: 14
              };
              var rowsHighCh2 = {
                25: 2,
                26: 4,
                29: 6,
                30: 8,
                31: 10,
                27: 13,
                28: 15
              };
              var backgroundColors = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
              var VerboseLevel;
              (function (VerboseLevel) {
                VerboseLevel[VerboseLevel["ERROR"] = 0] = "ERROR";
                VerboseLevel[VerboseLevel["TEXT"] = 1] = "TEXT";
                VerboseLevel[VerboseLevel["WARNING"] = 2] = "WARNING";
                VerboseLevel[VerboseLevel["INFO"] = 2] = "INFO";
                VerboseLevel[VerboseLevel["DEBUG"] = 3] = "DEBUG";
                VerboseLevel[VerboseLevel["DATA"] = 3] = "DATA";
              })(VerboseLevel || (VerboseLevel = {}));
              var CaptionsLogger = /*#__PURE__*/function () {
                function CaptionsLogger() {
                  (this || _global).time = null;
                  (this || _global).verboseLevel = VerboseLevel.ERROR;
                }
                var _proto = CaptionsLogger.prototype;
                _proto.log = function log(severity, msg) {
                  if ((this || _global).verboseLevel >= severity) {
                    _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.log((this || _global).time + " [" + severity + "] " + msg);
                  }
                };
                return CaptionsLogger;
              }();
              var numArrayToHexArray = function numArrayToHexArray(numArray) {
                var hexArray = [];
                for (var j = 0; j < numArray.length; j++) {
                  hexArray.push(numArray[j].toString(16));
                }
                return hexArray;
              };
              var PenState = /*#__PURE__*/function () {
                function PenState(foreground, underline, italics, background, flash) {
                  (this || _global).foreground = void 0;
                  (this || _global).underline = void 0;
                  (this || _global).italics = void 0;
                  (this || _global).background = void 0;
                  (this || _global).flash = void 0;
                  (this || _global).foreground = foreground || "white";
                  (this || _global).underline = underline || false;
                  (this || _global).italics = italics || false;
                  (this || _global).background = background || "black";
                  (this || _global).flash = flash || false;
                }
                var _proto2 = PenState.prototype;
                _proto2.reset = function reset() {
                  (this || _global).foreground = "white";
                  (this || _global).underline = false;
                  (this || _global).italics = false;
                  (this || _global).background = "black";
                  (this || _global).flash = false;
                };
                _proto2.setStyles = function setStyles(styles) {
                  var attribs = ["foreground", "underline", "italics", "background", "flash"];
                  for (var i = 0; i < attribs.length; i++) {
                    var style = attribs[i];
                    if (styles.hasOwnProperty(style)) {
                      (this || _global)[style] = styles[style];
                    }
                  }
                };
                _proto2.isDefault = function isDefault() {
                  return (this || _global).foreground === "white" && !(this || _global).underline && !(this || _global).italics && (this || _global).background === "black" && !(this || _global).flash;
                };
                _proto2.equals = function equals(other) {
                  return (this || _global).foreground === other.foreground && (this || _global).underline === other.underline && (this || _global).italics === other.italics && (this || _global).background === other.background && (this || _global).flash === other.flash;
                };
                _proto2.copy = function copy(newPenState) {
                  (this || _global).foreground = newPenState.foreground;
                  (this || _global).underline = newPenState.underline;
                  (this || _global).italics = newPenState.italics;
                  (this || _global).background = newPenState.background;
                  (this || _global).flash = newPenState.flash;
                };
                _proto2.toString = function toString() {
                  return "color=" + (this || _global).foreground + ", underline=" + (this || _global).underline + ", italics=" + (this || _global).italics + ", background=" + (this || _global).background + ", flash=" + (this || _global).flash;
                };
                return PenState;
              }();
              /**
               * Unicode character with styling and background.
               * @constructor
               */
              var StyledUnicodeChar = /*#__PURE__*/function () {
                function StyledUnicodeChar(uchar, foreground, underline, italics, background, flash) {
                  (this || _global).uchar = void 0;
                  (this || _global).penState = void 0;
                  (this || _global).uchar = uchar || " "; // unicode character
                  (this || _global).penState = new PenState(foreground, underline, italics, background, flash);
                }
                var _proto3 = StyledUnicodeChar.prototype;
                _proto3.reset = function reset() {
                  (this || _global).uchar = " ";
                  (this || _global).penState.reset();
                };
                _proto3.setChar = function setChar(uchar, newPenState) {
                  (this || _global).uchar = uchar;
                  (this || _global).penState.copy(newPenState);
                };
                _proto3.setPenState = function setPenState(newPenState) {
                  (this || _global).penState.copy(newPenState);
                };
                _proto3.equals = function equals(other) {
                  return (this || _global).uchar === other.uchar && (this || _global).penState.equals(other.penState);
                };
                _proto3.copy = function copy(newChar) {
                  (this || _global).uchar = newChar.uchar;
                  (this || _global).penState.copy(newChar.penState);
                };
                _proto3.isEmpty = function isEmpty() {
                  return (this || _global).uchar === " " && (this || _global).penState.isDefault();
                };
                return StyledUnicodeChar;
              }();
              /**
               * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
               * @constructor
               */
              var Row = /*#__PURE__*/function () {
                function Row(logger) {
                  (this || _global).chars = void 0;
                  (this || _global).pos = void 0;
                  (this || _global).currPenState = void 0;
                  (this || _global).cueStartTime = void 0;
                  (this || _global).logger = void 0;
                  (this || _global).chars = [];
                  for (var i = 0; i < NR_COLS; i++) {
                    (this || _global).chars.push(new StyledUnicodeChar());
                  }
                  (this || _global).logger = logger;
                  (this || _global).pos = 0;
                  (this || _global).currPenState = new PenState();
                }
                var _proto4 = Row.prototype;
                _proto4.equals = function equals(other) {
                  var equal = true;
                  for (var i = 0; i < NR_COLS; i++) {
                    if (!(this || _global).chars[i].equals(other.chars[i])) {
                      equal = false;
                      break;
                    }
                  }
                  return equal;
                };
                _proto4.copy = function copy(other) {
                  for (var i = 0; i < NR_COLS; i++) {
                    (this || _global).chars[i].copy(other.chars[i]);
                  }
                };
                _proto4.isEmpty = function isEmpty() {
                  var empty = true;
                  for (var i = 0; i < NR_COLS; i++) {
                    if (!(this || _global).chars[i].isEmpty()) {
                      empty = false;
                      break;
                    }
                  }
                  return empty;
                }

                /**
                 *  Set the cursor to a valid column.
                 */;
                _proto4.setCursor = function setCursor(absPos) {
                  if ((this || _global).pos !== absPos) {
                    (this || _global).pos = absPos;
                  }
                  if ((this || _global).pos < 0) {
                    (this || _global).logger.log(VerboseLevel.DEBUG, "Negative cursor position " + (this || _global).pos);
                    (this || _global).pos = 0;
                  } else if ((this || _global).pos > NR_COLS) {
                    (this || _global).logger.log(VerboseLevel.DEBUG, "Too large cursor position " + (this || _global).pos);
                    (this || _global).pos = NR_COLS;
                  }
                }

                /**
                 * Move the cursor relative to current position.
                 */;
                _proto4.moveCursor = function moveCursor(relPos) {
                  var newPos = (this || _global).pos + relPos;
                  if (relPos > 1) {
                    for (var i = (this || _global).pos + 1; i < newPos + 1; i++) {
                      (this || _global).chars[i].setPenState((this || _global).currPenState);
                    }
                  }
                  this.setCursor(newPos);
                }

                /**
                 * Backspace, move one step back and clear character.
                 */;
                _proto4.backSpace = function backSpace() {
                  this.moveCursor(-1);
                  (this || _global).chars[(this || _global).pos].setChar(" ", (this || _global).currPenState);
                };
                _proto4.insertChar = function insertChar(_byte2) {
                  if (_byte2 >= 144) {
                    // Extended char
                    this.backSpace();
                  }
                  var _char = getCharForByte(_byte2);
                  if ((this || _global).pos >= NR_COLS) {
                    (this || _global).logger.log(VerboseLevel.ERROR, "Cannot insert " + _byte2.toString(16) + " (" + _char + ") at position " + (this || _global).pos + ". Skipping it!");
                    return;
                  }
                  (this || _global).chars[(this || _global).pos].setChar(_char, (this || _global).currPenState);
                  this.moveCursor(1);
                };
                _proto4.clearFromPos = function clearFromPos(startPos) {
                  var i;
                  for (i = startPos; i < NR_COLS; i++) {
                    (this || _global).chars[i].reset();
                  }
                };
                _proto4.clear = function clear() {
                  this.clearFromPos(0);
                  (this || _global).pos = 0;
                  (this || _global).currPenState.reset();
                };
                _proto4.clearToEndOfRow = function clearToEndOfRow() {
                  this.clearFromPos((this || _global).pos);
                };
                _proto4.getTextString = function getTextString() {
                  var chars = [];
                  var empty = true;
                  for (var i = 0; i < NR_COLS; i++) {
                    var _char2 = (this || _global).chars[i].uchar;
                    if (_char2 !== " ") {
                      empty = false;
                    }
                    chars.push(_char2);
                  }
                  if (empty) {
                    return "";
                  } else {
                    return chars.join("");
                  }
                };
                _proto4.setPenStyles = function setPenStyles(styles) {
                  (this || _global).currPenState.setStyles(styles);
                  var currChar = (this || _global).chars[(this || _global).pos];
                  currChar.setPenState((this || _global).currPenState);
                };
                return Row;
              }();

              /**
               * Keep a CEA-608 screen of 32x15 styled characters
               * @constructor
               */
              var CaptionScreen = /*#__PURE__*/function () {
                function CaptionScreen(logger) {
                  (this || _global).rows = void 0;
                  (this || _global).currRow = void 0;
                  (this || _global).nrRollUpRows = void 0;
                  (this || _global).lastOutputScreen = void 0;
                  (this || _global).logger = void 0;
                  (this || _global).rows = [];
                  for (var i = 0; i < NR_ROWS; i++) {
                    (this || _global).rows.push(new Row(logger));
                  } // Note that we use zero-based numbering (0-14)

                  (this || _global).logger = logger;
                  (this || _global).currRow = NR_ROWS - 1;
                  (this || _global).nrRollUpRows = null;
                  (this || _global).lastOutputScreen = null;
                  this.reset();
                }
                var _proto5 = CaptionScreen.prototype;
                _proto5.reset = function reset() {
                  for (var i = 0; i < NR_ROWS; i++) {
                    (this || _global).rows[i].clear();
                  }
                  (this || _global).currRow = NR_ROWS - 1;
                };
                _proto5.equals = function equals(other) {
                  var equal = true;
                  for (var i = 0; i < NR_ROWS; i++) {
                    if (!(this || _global).rows[i].equals(other.rows[i])) {
                      equal = false;
                      break;
                    }
                  }
                  return equal;
                };
                _proto5.copy = function copy(other) {
                  for (var i = 0; i < NR_ROWS; i++) {
                    (this || _global).rows[i].copy(other.rows[i]);
                  }
                };
                _proto5.isEmpty = function isEmpty() {
                  var empty = true;
                  for (var i = 0; i < NR_ROWS; i++) {
                    if (!(this || _global).rows[i].isEmpty()) {
                      empty = false;
                      break;
                    }
                  }
                  return empty;
                };
                _proto5.backSpace = function backSpace() {
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.backSpace();
                };
                _proto5.clearToEndOfRow = function clearToEndOfRow() {
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.clearToEndOfRow();
                }

                /**
                 * Insert a character (without styling) in the current row.
                 */;
                _proto5.insertChar = function insertChar(_char3) {
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.insertChar(_char3);
                };
                _proto5.setPen = function setPen(styles) {
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.setPenStyles(styles);
                };
                _proto5.moveCursor = function moveCursor(relPos) {
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.moveCursor(relPos);
                };
                _proto5.setCursor = function setCursor(absPos) {
                  (this || _global).logger.log(VerboseLevel.INFO, "setCursor: " + absPos);
                  var row = (this || _global).rows[(this || _global).currRow];
                  row.setCursor(absPos);
                };
                _proto5.setPAC = function setPAC(pacData) {
                  (this || _global).logger.log(VerboseLevel.INFO, "pacData = " + JSON.stringify(pacData));
                  var newRow = pacData.row - 1;
                  if ((this || _global).nrRollUpRows && newRow < (this || _global).nrRollUpRows - 1) {
                    newRow = (this || _global).nrRollUpRows - 1;
                  }

                  // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
                  if ((this || _global).nrRollUpRows && (this || _global).currRow !== newRow) {
                    // clear all rows first
                    for (var i = 0; i < NR_ROWS; i++) {
                      (this || _global).rows[i].clear();
                    }

                    // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
                    // topRowIndex - the start of rows to copy (inclusive index)
                    var topRowIndex = (this || _global).currRow + 1 - (this || _global).nrRollUpRows;
                    // We only copy if the last position was already shown.
                    // We use the cueStartTime value to check this.
                    var lastOutputScreen = (this || _global).lastOutputScreen;
                    if (lastOutputScreen) {
                      var prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                      var time = (this || _global).logger.time;
                      if (prevLineTime && time !== null && prevLineTime < time) {
                        for (var _i = 0; _i < (this || _global).nrRollUpRows; _i++) {
                          (this || _global).rows[newRow - (this || _global).nrRollUpRows + _i + 1].copy(lastOutputScreen.rows[topRowIndex + _i]);
                        }
                      }
                    }
                  }
                  (this || _global).currRow = newRow;
                  var row = (this || _global).rows[(this || _global).currRow];
                  if (pacData.indent !== null) {
                    var indent = pacData.indent;
                    var prevPos = Math.max(indent - 1, 0);
                    row.setCursor(pacData.indent);
                    pacData.color = row.chars[prevPos].penState.foreground;
                  }
                  var styles = {
                    foreground: pacData.color,
                    underline: pacData.underline,
                    italics: pacData.italics,
                    background: "black",
                    flash: false
                  };
                  this.setPen(styles);
                }

                /**
                 * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
                 */;
                _proto5.setBkgData = function setBkgData(bkgData) {
                  (this || _global).logger.log(VerboseLevel.INFO, "bkgData = " + JSON.stringify(bkgData));
                  this.backSpace();
                  this.setPen(bkgData);
                  this.insertChar(32); // Space
                };

                _proto5.setRollUpRows = function setRollUpRows(nrRows) {
                  (this || _global).nrRollUpRows = nrRows;
                };
                _proto5.rollUp = function rollUp() {
                  if ((this || _global).nrRollUpRows === null) {
                    (this || _global).logger.log(VerboseLevel.DEBUG, "roll_up but nrRollUpRows not set yet");
                    return; // Not properly setup
                  }

                  (this || _global).logger.log(VerboseLevel.TEXT, this.getDisplayText());
                  var topRowIndex = (this || _global).currRow + 1 - (this || _global).nrRollUpRows;
                  var topRow = (this || _global).rows.splice(topRowIndex, 1)[0];
                  topRow.clear();
                  (this || _global).rows.splice((this || _global).currRow, 0, topRow);
                  (this || _global).logger.log(VerboseLevel.INFO, "Rolling up");
                  // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
                }

                /**
                 * Get all non-empty rows with as unicode text.
                 */;
                _proto5.getDisplayText = function getDisplayText(asOneRow) {
                  asOneRow = asOneRow || false;
                  var displayText = [];
                  var text = "";
                  var rowNr = -1;
                  for (var i = 0; i < NR_ROWS; i++) {
                    var rowText = (this || _global).rows[i].getTextString();
                    if (rowText) {
                      rowNr = i + 1;
                      if (asOneRow) {
                        displayText.push("Row " + rowNr + ": '" + rowText + "'");
                      } else {
                        displayText.push(rowText.trim());
                      }
                    }
                  }
                  if (displayText.length > 0) {
                    if (asOneRow) {
                      text = "[" + displayText.join(" | ") + "]";
                    } else {
                      text = displayText.join("\n");
                    }
                  }
                  return text;
                };
                _proto5.getTextAndFormat = function getTextAndFormat() {
                  return (this || _global).rows;
                };
                return CaptionScreen;
              }();

              // var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
              var Cea608Channel = /*#__PURE__*/function () {
                function Cea608Channel(channelNumber, outputFilter, logger) {
                  (this || _global).chNr = void 0;
                  (this || _global).outputFilter = void 0;
                  (this || _global).mode = void 0;
                  (this || _global).verbose = void 0;
                  (this || _global).displayedMemory = void 0;
                  (this || _global).nonDisplayedMemory = void 0;
                  (this || _global).lastOutputScreen = void 0;
                  (this || _global).currRollUpRow = void 0;
                  (this || _global).writeScreen = void 0;
                  (this || _global).cueStartTime = void 0;
                  (this || _global).logger = void 0;
                  (this || _global).chNr = channelNumber;
                  (this || _global).outputFilter = outputFilter;
                  (this || _global).mode = null;
                  (this || _global).verbose = 0;
                  (this || _global).displayedMemory = new CaptionScreen(logger);
                  (this || _global).nonDisplayedMemory = new CaptionScreen(logger);
                  (this || _global).lastOutputScreen = new CaptionScreen(logger);
                  (this || _global).currRollUpRow = (this || _global).displayedMemory.rows[NR_ROWS - 1];
                  (this || _global).writeScreen = (this || _global).displayedMemory;
                  (this || _global).mode = null;
                  (this || _global).cueStartTime = null; // Keeps track of where a cue started.
                  (this || _global).logger = logger;
                }
                var _proto6 = Cea608Channel.prototype;
                _proto6.reset = function reset() {
                  (this || _global).mode = null;
                  (this || _global).displayedMemory.reset();
                  (this || _global).nonDisplayedMemory.reset();
                  (this || _global).lastOutputScreen.reset();
                  (this || _global).outputFilter.reset();
                  (this || _global).currRollUpRow = (this || _global).displayedMemory.rows[NR_ROWS - 1];
                  (this || _global).writeScreen = (this || _global).displayedMemory;
                  (this || _global).mode = null;
                  (this || _global).cueStartTime = null;
                };
                _proto6.getHandler = function getHandler() {
                  return (this || _global).outputFilter;
                };
                _proto6.setHandler = function setHandler(newHandler) {
                  (this || _global).outputFilter = newHandler;
                };
                _proto6.setPAC = function setPAC(pacData) {
                  (this || _global).writeScreen.setPAC(pacData);
                };
                _proto6.setBkgData = function setBkgData(bkgData) {
                  (this || _global).writeScreen.setBkgData(bkgData);
                };
                _proto6.setMode = function setMode(newMode) {
                  if (newMode === (this || _global).mode) {
                    return;
                  }
                  (this || _global).mode = newMode;
                  (this || _global).logger.log(VerboseLevel.INFO, "MODE=" + newMode);
                  if ((this || _global).mode === "MODE_POP-ON") {
                    (this || _global).writeScreen = (this || _global).nonDisplayedMemory;
                  } else {
                    (this || _global).writeScreen = (this || _global).displayedMemory;
                    (this || _global).writeScreen.reset();
                  }
                  if ((this || _global).mode !== "MODE_ROLL-UP") {
                    (this || _global).displayedMemory.nrRollUpRows = null;
                    (this || _global).nonDisplayedMemory.nrRollUpRows = null;
                  }
                  (this || _global).mode = newMode;
                };
                _proto6.insertChars = function insertChars(chars) {
                  for (var i = 0; i < chars.length; i++) {
                    (this || _global).writeScreen.insertChar(chars[i]);
                  }
                  var screen = (this || _global).writeScreen === (this || _global).displayedMemory ? "DISP" : "NON_DISP";
                  (this || _global).logger.log(VerboseLevel.INFO, screen + ": " + (this || _global).writeScreen.getDisplayText(true));
                  if ((this || _global).mode === "MODE_PAINT-ON" || (this || _global).mode === "MODE_ROLL-UP") {
                    (this || _global).logger.log(VerboseLevel.TEXT, "DISPLAYED: " + (this || _global).displayedMemory.getDisplayText(true));
                    this.outputDataUpdate();
                  }
                };
                _proto6.ccRCL = function ccRCL() {
                  // Resume Caption Loading (switch mode to Pop On)
                  (this || _global).logger.log(VerboseLevel.INFO, "RCL - Resume Caption Loading");
                  this.setMode("MODE_POP-ON");
                };
                _proto6.ccBS = function ccBS() {
                  // BackSpace
                  (this || _global).logger.log(VerboseLevel.INFO, "BS - BackSpace");
                  if ((this || _global).mode === "MODE_TEXT") {
                    return;
                  }
                  (this || _global).writeScreen.backSpace();
                  if ((this || _global).writeScreen === (this || _global).displayedMemory) {
                    this.outputDataUpdate();
                  }
                };
                _proto6.ccAOF = function ccAOF() {
                  // Reserved (formerly Alarm Off)
                };
                _proto6.ccAON = function ccAON() {
                  // Reserved (formerly Alarm On)
                };
                _proto6.ccDER = function ccDER() {
                  // Delete to End of Row
                  (this || _global).logger.log(VerboseLevel.INFO, "DER- Delete to End of Row");
                  (this || _global).writeScreen.clearToEndOfRow();
                  this.outputDataUpdate();
                };
                _proto6.ccRU = function ccRU(nrRows) {
                  // Roll-Up Captions-2,3,or 4 Rows
                  (this || _global).logger.log(VerboseLevel.INFO, "RU(" + nrRows + ") - Roll Up");
                  (this || _global).writeScreen = (this || _global).displayedMemory;
                  this.setMode("MODE_ROLL-UP");
                  (this || _global).writeScreen.setRollUpRows(nrRows);
                };
                _proto6.ccFON = function ccFON() {
                  // Flash On
                  (this || _global).logger.log(VerboseLevel.INFO, "FON - Flash On");
                  (this || _global).writeScreen.setPen({
                    flash: true
                  });
                };
                _proto6.ccRDC = function ccRDC() {
                  // Resume Direct Captioning (switch mode to PaintOn)
                  (this || _global).logger.log(VerboseLevel.INFO, "RDC - Resume Direct Captioning");
                  this.setMode("MODE_PAINT-ON");
                };
                _proto6.ccTR = function ccTR() {
                  // Text Restart in text mode (not supported, however)
                  (this || _global).logger.log(VerboseLevel.INFO, "TR");
                  this.setMode("MODE_TEXT");
                };
                _proto6.ccRTD = function ccRTD() {
                  // Resume Text Display in Text mode (not supported, however)
                  (this || _global).logger.log(VerboseLevel.INFO, "RTD");
                  this.setMode("MODE_TEXT");
                };
                _proto6.ccEDM = function ccEDM() {
                  // Erase Displayed Memory
                  (this || _global).logger.log(VerboseLevel.INFO, "EDM - Erase Displayed Memory");
                  (this || _global).displayedMemory.reset();
                  this.outputDataUpdate(true);
                };
                _proto6.ccCR = function ccCR() {
                  // Carriage Return
                  (this || _global).logger.log(VerboseLevel.INFO, "CR - Carriage Return");
                  (this || _global).writeScreen.rollUp();
                  this.outputDataUpdate(true);
                };
                _proto6.ccENM = function ccENM() {
                  // Erase Non-Displayed Memory
                  (this || _global).logger.log(VerboseLevel.INFO, "ENM - Erase Non-displayed Memory");
                  (this || _global).nonDisplayedMemory.reset();
                };
                _proto6.ccEOC = function ccEOC() {
                  // End of Caption (Flip Memories)
                  (this || _global).logger.log(VerboseLevel.INFO, "EOC - End Of Caption");
                  if ((this || _global).mode === "MODE_POP-ON") {
                    var tmp = (this || _global).displayedMemory;
                    (this || _global).displayedMemory = (this || _global).nonDisplayedMemory;
                    (this || _global).nonDisplayedMemory = tmp;
                    (this || _global).writeScreen = (this || _global).nonDisplayedMemory;
                    (this || _global).logger.log(VerboseLevel.TEXT, "DISP: " + (this || _global).displayedMemory.getDisplayText());
                  }
                  this.outputDataUpdate(true);
                };
                _proto6.ccTO = function ccTO(nrCols) {
                  // Tab Offset 1,2, or 3 columns
                  (this || _global).logger.log(VerboseLevel.INFO, "TO(" + nrCols + ") - Tab Offset");
                  (this || _global).writeScreen.moveCursor(nrCols);
                };
                _proto6.ccMIDROW = function ccMIDROW(secondByte) {
                  // Parse MIDROW command
                  var styles = {
                    flash: false
                  };
                  styles.underline = secondByte % 2 === 1;
                  styles.italics = secondByte >= 46;
                  if (!styles.italics) {
                    var colorIndex = Math.floor(secondByte / 2) - 16;
                    var colors = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
                    styles.foreground = colors[colorIndex];
                  } else {
                    styles.foreground = "white";
                  }
                  (this || _global).logger.log(VerboseLevel.INFO, "MIDROW: " + JSON.stringify(styles));
                  (this || _global).writeScreen.setPen(styles);
                };
                _proto6.outputDataUpdate = function outputDataUpdate(dispatch) {
                  if (dispatch === void 0) {
                    dispatch = false;
                  }
                  var time = (this || _global).logger.time;
                  if (time === null) {
                    return;
                  }
                  if ((this || _global).outputFilter) {
                    if ((this || _global).cueStartTime === null && !(this || _global).displayedMemory.isEmpty()) {
                      // Start of a new cue
                      (this || _global).cueStartTime = time;
                    } else {
                      if (!(this || _global).displayedMemory.equals((this || _global).lastOutputScreen)) {
                        (this || _global).outputFilter.newCue((this || _global).cueStartTime, time, (this || _global).lastOutputScreen);
                        if (dispatch && (this || _global).outputFilter.dispatchCue) {
                          (this || _global).outputFilter.dispatchCue();
                        }
                        (this || _global).cueStartTime = (this || _global).displayedMemory.isEmpty() ? null : time;
                      }
                    }
                    (this || _global).lastOutputScreen.copy((this || _global).displayedMemory);
                  }
                };
                _proto6.cueSplitAtTime = function cueSplitAtTime(t) {
                  if ((this || _global).outputFilter) {
                    if (!(this || _global).displayedMemory.isEmpty()) {
                      if ((this || _global).outputFilter.newCue) {
                        (this || _global).outputFilter.newCue((this || _global).cueStartTime, t, (this || _global).displayedMemory);
                      }
                      (this || _global).cueStartTime = t;
                    }
                  }
                };
                return Cea608Channel;
              }();
              var Cea608Parser = /*#__PURE__*/function () {
                function Cea608Parser(field, out1, out2) {
                  (this || _global).channels = void 0;
                  (this || _global).currentChannel = 0;
                  (this || _global).cmdHistory = void 0;
                  (this || _global).logger = void 0;
                  var logger = new CaptionsLogger();
                  (this || _global).channels = [null, new Cea608Channel(field, out1, logger), new Cea608Channel(field + 1, out2, logger)];
                  (this || _global).cmdHistory = createCmdHistory();
                  (this || _global).logger = logger;
                }
                var _proto7 = Cea608Parser.prototype;
                _proto7.getHandler = function getHandler(channel) {
                  return (this || _global).channels[channel].getHandler();
                };
                _proto7.setHandler = function setHandler(channel, newHandler) {
                  (this || _global).channels[channel].setHandler(newHandler);
                }

                /**
                 * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
                 */;
                _proto7.addData = function addData(time, byteList) {
                  var cmdFound;
                  var a;
                  var b;
                  var charsFound = false;
                  (this || _global).logger.time = time;
                  for (var i = 0; i < byteList.length; i += 2) {
                    a = byteList[i] & 127;
                    b = byteList[i + 1] & 127;
                    if (a === 0 && b === 0) {
                      continue;
                    } else {
                      (this || _global).logger.log(VerboseLevel.DATA, "[" + numArrayToHexArray([byteList[i], byteList[i + 1]]) + "] -> (" + numArrayToHexArray([a, b]) + ")");
                    }
                    cmdFound = this.parseCmd(a, b);
                    if (!cmdFound) {
                      cmdFound = this.parseMidrow(a, b);
                    }
                    if (!cmdFound) {
                      cmdFound = this.parsePAC(a, b);
                    }
                    if (!cmdFound) {
                      cmdFound = this.parseBackgroundAttributes(a, b);
                    }
                    if (!cmdFound) {
                      charsFound = this.parseChars(a, b);
                      if (charsFound) {
                        var currChNr = (this || _global).currentChannel;
                        if (currChNr && currChNr > 0) {
                          var channel = (this || _global).channels[currChNr];
                          channel.insertChars(charsFound);
                        } else {
                          (this || _global).logger.log(VerboseLevel.WARNING, "No channel found yet. TEXT-MODE?");
                        }
                      }
                    }
                    if (!cmdFound && !charsFound) {
                      (this || _global).logger.log(VerboseLevel.WARNING, "Couldn't parse cleaned data " + numArrayToHexArray([a, b]) + " orig: " + numArrayToHexArray([byteList[i], byteList[i + 1]]));
                    }
                  }
                }

                /**
                 * Parse Command.
                 * @returns {Boolean} Tells if a command was found
                 */;
                _proto7.parseCmd = function parseCmd(a, b) {
                  var cmdHistory = (this || _global).cmdHistory;
                  var cond1 = (a === 20 || a === 28 || a === 21 || a === 29) && b >= 32 && b <= 47;
                  var cond2 = (a === 23 || a === 31) && b >= 33 && b <= 35;
                  if (!(cond1 || cond2)) {
                    return false;
                  }
                  if (hasCmdRepeated(a, b, cmdHistory)) {
                    setLastCmd(null, null, cmdHistory);
                    (this || _global).logger.log(VerboseLevel.DEBUG, "Repeated command (" + numArrayToHexArray([a, b]) + ") is dropped");
                    return true;
                  }
                  var chNr = a === 20 || a === 21 || a === 23 ? 1 : 2;
                  var channel = (this || _global).channels[chNr];
                  if (a === 20 || a === 21 || a === 28 || a === 29) {
                    if (b === 32) {
                      channel.ccRCL();
                    } else if (b === 33) {
                      channel.ccBS();
                    } else if (b === 34) {
                      channel.ccAOF();
                    } else if (b === 35) {
                      channel.ccAON();
                    } else if (b === 36) {
                      channel.ccDER();
                    } else if (b === 37) {
                      channel.ccRU(2);
                    } else if (b === 38) {
                      channel.ccRU(3);
                    } else if (b === 39) {
                      channel.ccRU(4);
                    } else if (b === 40) {
                      channel.ccFON();
                    } else if (b === 41) {
                      channel.ccRDC();
                    } else if (b === 42) {
                      channel.ccTR();
                    } else if (b === 43) {
                      channel.ccRTD();
                    } else if (b === 44) {
                      channel.ccEDM();
                    } else if (b === 45) {
                      channel.ccCR();
                    } else if (b === 46) {
                      channel.ccENM();
                    } else if (b === 47) {
                      channel.ccEOC();
                    }
                  } else {
                    // a == 0x17 || a == 0x1F
                    channel.ccTO(b - 32);
                  }
                  setLastCmd(a, b, cmdHistory);
                  (this || _global).currentChannel = chNr;
                  return true;
                }

                /**
                 * Parse midrow styling command
                 * @returns {Boolean}
                 */;
                _proto7.parseMidrow = function parseMidrow(a, b) {
                  var chNr = 0;
                  if ((a === 17 || a === 25) && b >= 32 && b <= 47) {
                    if (a === 17) {
                      chNr = 1;
                    } else {
                      chNr = 2;
                    }
                    if (chNr !== (this || _global).currentChannel) {
                      (this || _global).logger.log(VerboseLevel.ERROR, "Mismatch channel in midrow parsing");
                      return false;
                    }
                    var channel = (this || _global).channels[chNr];
                    if (!channel) {
                      return false;
                    }
                    channel.ccMIDROW(b);
                    (this || _global).logger.log(VerboseLevel.DEBUG, "MIDROW (" + numArrayToHexArray([a, b]) + ")");
                    return true;
                  }
                  return false;
                }

                /**
                 * Parse Preable Access Codes (Table 53).
                 * @returns {Boolean} Tells if PAC found
                 */;
                _proto7.parsePAC = function parsePAC(a, b) {
                  var row;
                  var cmdHistory = (this || _global).cmdHistory;
                  var case1 = (a >= 17 && a <= 23 || a >= 25 && a <= 31) && b >= 64 && b <= 127;
                  var case2 = (a === 16 || a === 24) && b >= 64 && b <= 95;
                  if (!(case1 || case2)) {
                    return false;
                  }
                  if (hasCmdRepeated(a, b, cmdHistory)) {
                    setLastCmd(null, null, cmdHistory);
                    return true; // Repeated commands are dropped (once)
                  }

                  var chNr = a <= 23 ? 1 : 2;
                  if (b >= 64 && b <= 95) {
                    row = chNr === 1 ? rowsLowCh1[a] : rowsLowCh2[a];
                  } else {
                    // 0x60 <= b <= 0x7F
                    row = chNr === 1 ? rowsHighCh1[a] : rowsHighCh2[a];
                  }
                  var channel = (this || _global).channels[chNr];
                  if (!channel) {
                    return false;
                  }
                  channel.setPAC(this.interpretPAC(row, b));
                  setLastCmd(a, b, cmdHistory);
                  (this || _global).currentChannel = chNr;
                  return true;
                }

                /**
                 * Interpret the second byte of the pac, and return the information.
                 * @returns {Object} pacData with style parameters.
                 */;
                _proto7.interpretPAC = function interpretPAC(row, _byte3) {
                  var pacIndex;
                  var pacData = {
                    color: null,
                    italics: false,
                    indent: null,
                    underline: false,
                    row: row
                  };
                  if (_byte3 > 95) {
                    pacIndex = _byte3 - 96;
                  } else {
                    pacIndex = _byte3 - 64;
                  }
                  pacData.underline = (pacIndex & 1) === 1;
                  if (pacIndex <= 13) {
                    pacData.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(pacIndex / 2)];
                  } else if (pacIndex <= 15) {
                    pacData.italics = true;
                    pacData.color = "white";
                  } else {
                    pacData.indent = Math.floor((pacIndex - 16) / 2) * 4;
                  }
                  return pacData; // Note that row has zero offset. The spec uses 1.
                }

                /**
                 * Parse characters.
                 * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
                 */;
                _proto7.parseChars = function parseChars(a, b) {
                  var channelNr;
                  var charCodes = null;
                  var charCode1 = null;
                  if (a >= 25) {
                    channelNr = 2;
                    charCode1 = a - 8;
                  } else {
                    channelNr = 1;
                    charCode1 = a;
                  }
                  if (charCode1 >= 17 && charCode1 <= 19) {
                    // Special character
                    var oneCode;
                    if (charCode1 === 17) {
                      oneCode = b + 80;
                    } else if (charCode1 === 18) {
                      oneCode = b + 112;
                    } else {
                      oneCode = b + 144;
                    }
                    (this || _global).logger.log(VerboseLevel.INFO, "Special char '" + getCharForByte(oneCode) + "' in channel " + channelNr);
                    charCodes = [oneCode];
                  } else if (a >= 32 && a <= 127) {
                    charCodes = b === 0 ? [a] : [a, b];
                  }
                  if (charCodes) {
                    var hexCodes = numArrayToHexArray(charCodes);
                    (this || _global).logger.log(VerboseLevel.DEBUG, "Char codes =  " + hexCodes.join(","));
                    setLastCmd(a, b, (this || _global).cmdHistory);
                  }
                  return charCodes;
                }

                /**
                 * Parse extended background attributes as well as new foreground color black.
                 * @returns {Boolean} Tells if background attributes are found
                 */;
                _proto7.parseBackgroundAttributes = function parseBackgroundAttributes(a, b) {
                  var case1 = (a === 16 || a === 24) && b >= 32 && b <= 47;
                  var case2 = (a === 23 || a === 31) && b >= 45 && b <= 47;
                  if (!(case1 || case2)) {
                    return false;
                  }
                  var index;
                  var bkgData = {};
                  if (a === 16 || a === 24) {
                    index = Math.floor((b - 32) / 2);
                    bkgData.background = backgroundColors[index];
                    if (b % 2 === 1) {
                      bkgData.background = bkgData.background + "_semi";
                    }
                  } else if (b === 45) {
                    bkgData.background = "transparent";
                  } else {
                    bkgData.foreground = "black";
                    if (b === 47) {
                      bkgData.underline = true;
                    }
                  }
                  var chNr = a <= 23 ? 1 : 2;
                  var channel = (this || _global).channels[chNr];
                  channel.setBkgData(bkgData);
                  setLastCmd(a, b, (this || _global).cmdHistory);
                  return true;
                }

                /**
                 * Reset state of parser and its channels.
                 */;
                _proto7.reset = function reset() {
                  for (var i = 0; i < Object.keys((this || _global).channels).length; i++) {
                    var channel = (this || _global).channels[i];
                    if (channel) {
                      channel.reset();
                    }
                  }
                  (this || _global).cmdHistory = createCmdHistory();
                }

                /**
                 * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
                 */;
                _proto7.cueSplitAtTime = function cueSplitAtTime(t) {
                  for (var i = 0; i < (this || _global).channels.length; i++) {
                    var channel = (this || _global).channels[i];
                    if (channel) {
                      channel.cueSplitAtTime(t);
                    }
                  }
                };
                return Cea608Parser;
              }();
              function setLastCmd(a, b, cmdHistory) {
                cmdHistory.a = a;
                cmdHistory.b = b;
              }
              function hasCmdRepeated(a, b, cmdHistory) {
                return cmdHistory.a === a && cmdHistory.b === b;
              }
              function createCmdHistory() {
                return {
                  a: null,
                  b: null
                };
              }
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = Cea608Parser;

              /***/
            },

            /***/"./src/utils/codecs.ts":
            /*!*****************************!*\
              !*** ./src/utils/codecs.ts ***!
              \*****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"isCodecSupportedInMp4": () => /* binding */isCodecSupportedInMp4,
                /* harmony export */"isCodecType": () => /* binding */isCodecType
                /* harmony export */
              });
              // from http://mp4ra.org/codecs.html
              var sampleEntryCodesISO = {
                audio: {
                  a3ds: true,
                  "ac-3": true,
                  "ac-4": true,
                  alac: true,
                  alaw: true,
                  dra1: true,
                  "dts+": true,
                  "dts-": true,
                  dtsc: true,
                  dtse: true,
                  dtsh: true,
                  "ec-3": true,
                  enca: true,
                  g719: true,
                  g726: true,
                  m4ae: true,
                  mha1: true,
                  mha2: true,
                  mhm1: true,
                  mhm2: true,
                  mlpa: true,
                  mp4a: true,
                  "raw ": true,
                  Opus: true,
                  opus: true,
                  // browsers expect this to be lowercase despite MP4RA says 'Opus'
                  samr: true,
                  sawb: true,
                  sawp: true,
                  sevc: true,
                  sqcp: true,
                  ssmv: true,
                  twos: true,
                  ulaw: true
                },
                video: {
                  avc1: true,
                  avc2: true,
                  avc3: true,
                  avc4: true,
                  avcp: true,
                  av01: true,
                  drac: true,
                  dva1: true,
                  dvav: true,
                  dvh1: true,
                  dvhe: true,
                  encv: true,
                  hev1: true,
                  hvc1: true,
                  mjp2: true,
                  mp4v: true,
                  mvc1: true,
                  mvc2: true,
                  mvc3: true,
                  mvc4: true,
                  resv: true,
                  rv60: true,
                  s263: true,
                  svc1: true,
                  svc2: true,
                  "vc-1": true,
                  vp08: true,
                  vp09: true
                },
                text: {
                  stpp: true,
                  wvtt: true
                }
              };
              function isCodecType(codec, type) {
                var typeCodes = sampleEntryCodesISO[type];
                return !!typeCodes && typeCodes[codec.slice(0, 4)] === true;
              }
              function isCodecSupportedInMp4(codec, type) {
                return MediaSource.isTypeSupported((type || "video") + "/mp4;codecs=\"" + codec + "\"");
              }

              /***/
            },

            /***/"./src/utils/cues.ts":
            /*!***************************!*\
              !*** ./src/utils/cues.ts ***!
              \***************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _vttparser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./vttparser */"./src/utils/vttparser.ts");
              /* harmony import */
              var _webvtt_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./webvtt-parser */"./src/utils/webvtt-parser.ts");
              /* harmony import */
              var _texttrack_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./texttrack-utils */"./src/utils/texttrack-utils.ts");
              var WHITESPACE_CHAR = /\s/;
              var Cues = {
                newCue: function newCue(track, startTime, endTime, captionScreen) {
                  var result = [];
                  var row;
                  // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
                  var cue;
                  var indenting;
                  var indent;
                  var text;
                  var Cue = self.VTTCue || self.TextTrackCue;
                  for (var r = 0; r < captionScreen.rows.length; r++) {
                    row = captionScreen.rows[r];
                    indenting = true;
                    indent = 0;
                    text = "";
                    if (!row.isEmpty()) {
                      for (var c = 0; c < row.chars.length; c++) {
                        if (WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) {
                          indent++;
                        } else {
                          text += row.chars[c].uchar;
                          indenting = false;
                        }
                      }
                      // To be used for cleaning-up orphaned roll-up captions
                      row.cueStartTime = startTime;

                      // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                      if (startTime === endTime) {
                        endTime += 0.0001;
                      }
                      if (indent >= 16) {
                        indent--;
                      } else {
                        indent++;
                      }
                      var cueText = (0, _vttparser__WEBPACK_IMPORTED_MODULE_0__.fixLineBreaks)(text.trim());
                      var id = (0, _webvtt_parser__WEBPACK_IMPORTED_MODULE_1__.generateCueId)(startTime, endTime, cueText);

                      // If this cue already exists in the track do not push it
                      if (!track || !track.cues || !track.cues.getCueById(id)) {
                        cue = new Cue(startTime, endTime, cueText);
                        cue.id = id;
                        cue.line = r + 1;
                        cue.align = "left";
                        // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
                        // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                        // Firefox throws an exception and captions break with out of bounds 0-100 values
                        cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
                        result.push(cue);
                      }
                    }
                  }
                  if (track && result.length) {
                    // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
                    result.sort(function (cueA, cueB) {
                      if (cueA.line === "auto" || cueB.line === "auto") {
                        return 0;
                      }
                      if (cueA.line > 8 && cueB.line > 8) {
                        return cueB.line - cueA.line;
                      }
                      return cueA.line - cueB.line;
                    });
                    result.forEach(function (cue) {
                      return (0, _texttrack_utils__WEBPACK_IMPORTED_MODULE_2__.addCueToTrack)(track, cue);
                    });
                  }
                  return result;
                }
              };
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = Cues;

              /***/
            },

            /***/"./src/utils/discontinuities.ts":
            /*!**************************************!*\
              !*** ./src/utils/discontinuities.ts ***!
              \**************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"adjustSlidingStart": () => /* binding */adjustSlidingStart,
                /* harmony export */"alignMediaPlaylistByPDT": () => /* binding */alignMediaPlaylistByPDT,
                /* harmony export */"alignPDT": () => /* binding */alignPDT,
                /* harmony export */"alignStream": () => /* binding */alignStream,
                /* harmony export */"findDiscontinuousReferenceFrag": () => /* binding */findDiscontinuousReferenceFrag,
                /* harmony export */"findFirstFragWithCC": () => /* binding */findFirstFragWithCC,
                /* harmony export */"shouldAlignOnDiscontinuities": () => /* binding */shouldAlignOnDiscontinuities
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./logger */"./src/utils/logger.ts");
              /* harmony import */
              var _controller_level_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../controller/level-helper */"./src/controller/level-helper.ts");
              function findFirstFragWithCC(fragments, cc) {
                var firstFrag = null;
                for (var i = 0, len = fragments.length; i < len; i++) {
                  var currentFrag = fragments[i];
                  if (currentFrag && currentFrag.cc === cc) {
                    firstFrag = currentFrag;
                    break;
                  }
                }
                return firstFrag;
              }
              function shouldAlignOnDiscontinuities(lastFrag, lastLevel, details) {
                if (lastLevel.details) {
                  if (details.endCC > details.startCC || lastFrag && lastFrag.cc < details.startCC) {
                    return true;
                  }
                }
                return false;
              }

              // Find the first frag in the previous level which matches the CC of the first frag of the new level
              function findDiscontinuousReferenceFrag(prevDetails, curDetails, referenceIndex) {
                var prevFrags = prevDetails.fragments;
                var curFrags = curDetails.fragments;
                if (!curFrags.length || !prevFrags.length) {
                  _logger__WEBPACK_IMPORTED_MODULE_1__.logger.log("No fragments to align");
                  return;
                }
                var prevStartFrag = findFirstFragWithCC(prevFrags, curFrags[0].cc);
                if (!prevStartFrag || prevStartFrag && !prevStartFrag.startPTS) {
                  _logger__WEBPACK_IMPORTED_MODULE_1__.logger.log("No frag in previous level to align on");
                  return;
                }
                return prevStartFrag;
              }
              function adjustFragmentStart(frag, sliding) {
                if (frag) {
                  var start = frag.start + sliding;
                  frag.start = frag.startPTS = start;
                  frag.endPTS = start + frag.duration;
                }
              }
              function adjustSlidingStart(sliding, details) {
                // Update segments
                var fragments = details.fragments;
                for (var i = 0, len = fragments.length; i < len; i++) {
                  adjustFragmentStart(fragments[i], sliding);
                }
                // Update LL-HLS parts at the end of the playlist
                if (details.fragmentHint) {
                  adjustFragmentStart(details.fragmentHint, sliding);
                }
                details.alignedSliding = true;
              }

              /**
               * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
               * contiguous stream with the last fragments.
               * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
               * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
               * and an extra download.
               * @param lastFrag
               * @param lastLevel
               * @param details
               */
              function alignStream(lastFrag, lastLevel, details) {
                if (!lastLevel) {
                  return;
                }
                alignDiscontinuities(lastFrag, details, lastLevel);
                if (!details.alignedSliding && lastLevel.details) {
                  // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
                  // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
                  // discontinuity sequence.
                  alignPDT(details, lastLevel.details);
                }
                if (!details.alignedSliding && lastLevel.details && !details.skippedSegments) {
                  // Try to align on sn so that we pick a better start fragment.
                  // Do not perform this on playlists with delta updates as this is only to align levels on switch
                  // and adjustSliding only adjusts fragments after skippedSegments.
                  (0, _controller_level_helper__WEBPACK_IMPORTED_MODULE_2__.adjustSliding)(lastLevel.details, details);
                }
              }

              /**
               * Computes the PTS if a new level's fragments using the PTS of a fragment in the last level which shares the same
               * discontinuity sequence.
               * @param lastFrag - The last Fragment which shares the same discontinuity sequence
               * @param lastLevel - The details of the last loaded level
               * @param details - The details of the new level
               */
              function alignDiscontinuities(lastFrag, details, lastLevel) {
                if (shouldAlignOnDiscontinuities(lastFrag, lastLevel, details)) {
                  var referenceFrag = findDiscontinuousReferenceFrag(lastLevel.details, details);
                  if (referenceFrag && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(referenceFrag.start)) {
                    _logger__WEBPACK_IMPORTED_MODULE_1__.logger.log("Adjusting PTS using last level due to CC increase within current level " + details.url);
                    adjustSlidingStart(referenceFrag.start, details);
                  }
                }
              }

              /**
               * Computes the PTS of a new level's fragments using the difference in Program Date Time from the last level.
               * @param details - The details of the new level
               * @param lastDetails - The details of the last loaded level
               */
              function alignPDT(details, lastDetails) {
                // This check protects the unsafe "!" usage below for null program date time access.
                if (!lastDetails.fragments.length || !details.hasProgramDateTime || !lastDetails.hasProgramDateTime) {
                  return;
                }
                // if last level sliding is 1000 and its first frag PROGRAM-DATE-TIME is 2017-08-20 1:10:00 AM
                // and if new details first frag PROGRAM DATE-TIME is 2017-08-20 1:10:08 AM
                // then we can deduce that playlist B sliding is 1000+8 = 1008s
                var lastPDT = lastDetails.fragments[0].programDateTime; // hasProgramDateTime check above makes this safe.
                var newPDT = details.fragments[0].programDateTime;
                // date diff is in ms. frag.start is in seconds
                var sliding = (newPDT - lastPDT) / 1000 + lastDetails.fragments[0].start;
                if (sliding && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(sliding)) {
                  _logger__WEBPACK_IMPORTED_MODULE_1__.logger.log("Adjusting PTS using programDateTime delta " + (newPDT - lastPDT) + "ms, sliding:" + sliding.toFixed(3) + " " + details.url + " ");
                  adjustSlidingStart(sliding, details);
                }
              }

              /**
               * Ensures appropriate time-alignment between renditions based on PDT. Unlike `alignPDT`, which adjusts
               * the timeline based on the delta between PDTs of the 0th fragment of two playlists/`LevelDetails`,
               * this function assumes the timelines represented in `refDetails` are accurate, including the PDTs,
               * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
               * times/timelines of `details` accordingly.
               * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
               * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
               * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
               * be consistent across playlists, per the HLS spec.
               * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
               * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
               */
              function alignMediaPlaylistByPDT(details, refDetails) {
                if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) {
                  return;
                }
                var fragments = details.fragments;
                var refFragments = refDetails.fragments;
                if (!fragments.length || !refFragments.length) {
                  return;
                }

                // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
                // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
                // If a fragment of the same discontinuity was not found use the middle fragment of both.
                var middleFrag = Math.round(refFragments.length / 2) - 1;
                var refFrag = refFragments[middleFrag];
                var frag = findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.round(fragments.length / 2) - 1];
                var refPDT = refFrag.programDateTime;
                var targetPDT = frag.programDateTime;
                if (refPDT === null || targetPDT === null) {
                  return;
                }
                var delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
                adjustSlidingStart(delta, details);
              }

              /***/
            },

            /***/"./src/utils/ewma-bandwidth-estimator.ts":
            /*!***********************************************!*\
              !*** ./src/utils/ewma-bandwidth-estimator.ts ***!
              \***********************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _utils_ewma__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/ewma */"./src/utils/ewma.ts");
              /*
               * EWMA Bandwidth Estimator
               *  - heavily inspired from shaka-player
               * Tracks bandwidth samples and estimates available bandwidth.
               * Based on the minimum of two exponentially-weighted moving averages with
               * different half-lives.
               */

              var EwmaBandWidthEstimator = /*#__PURE__*/function () {
                function EwmaBandWidthEstimator(slow, fast, defaultEstimate) {
                  (this || _global).defaultEstimate_ = void 0;
                  (this || _global).minWeight_ = void 0;
                  (this || _global).minDelayMs_ = void 0;
                  (this || _global).slow_ = void 0;
                  (this || _global).fast_ = void 0;
                  (this || _global).defaultEstimate_ = defaultEstimate;
                  (this || _global).minWeight_ = 0.001;
                  (this || _global).minDelayMs_ = 50;
                  (this || _global).slow_ = new _utils_ewma__WEBPACK_IMPORTED_MODULE_0__["default"](slow);
                  (this || _global).fast_ = new _utils_ewma__WEBPACK_IMPORTED_MODULE_0__["default"](fast);
                }
                var _proto = EwmaBandWidthEstimator.prototype;
                _proto.update = function update(slow, fast) {
                  var slow_ = (this || _global).slow_,
                    fast_ = (this || _global).fast_;
                  if ((this || _global).slow_.halfLife !== slow) {
                    (this || _global).slow_ = new _utils_ewma__WEBPACK_IMPORTED_MODULE_0__["default"](slow, slow_.getEstimate(), slow_.getTotalWeight());
                  }
                  if ((this || _global).fast_.halfLife !== fast) {
                    (this || _global).fast_ = new _utils_ewma__WEBPACK_IMPORTED_MODULE_0__["default"](fast, fast_.getEstimate(), fast_.getTotalWeight());
                  }
                };
                _proto.sample = function sample(durationMs, numBytes) {
                  durationMs = Math.max(durationMs, (this || _global).minDelayMs_);
                  var numBits = 8 * numBytes;
                  // weight is duration in seconds
                  var durationS = durationMs / 1000;
                  // value is bandwidth in bits/s
                  var bandwidthInBps = numBits / durationS;
                  (this || _global).fast_.sample(durationS, bandwidthInBps);
                  (this || _global).slow_.sample(durationS, bandwidthInBps);
                };
                _proto.canEstimate = function canEstimate() {
                  var fast = (this || _global).fast_;
                  return fast && fast.getTotalWeight() >= (this || _global).minWeight_;
                };
                _proto.getEstimate = function getEstimate() {
                  if (this.canEstimate()) {
                    // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
                    // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
                    // Take the minimum of these two estimates.  This should have the effect of
                    // adapting down quickly, but up more slowly.
                    return Math.min((this || _global).fast_.getEstimate(), (this || _global).slow_.getEstimate());
                  } else {
                    return (this || _global).defaultEstimate_;
                  }
                };
                _proto.destroy = function destroy() {};
                return EwmaBandWidthEstimator;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = EwmaBandWidthEstimator;

              /***/
            },

            /***/"./src/utils/ewma.ts":
            /*!***************************!*\
              !*** ./src/utils/ewma.ts ***!
              \***************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /*
               * compute an Exponential Weighted moving average
               * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
               *  - heavily inspired from shaka-player
               */
              var EWMA = /*#__PURE__*/function () {
                //  About half of the estimated value will be from the last |halfLife| samples by weight.
                function EWMA(halfLife, estimate, weight) {
                  if (estimate === void 0) {
                    estimate = 0;
                  }
                  if (weight === void 0) {
                    weight = 0;
                  }
                  (this || _global).halfLife = void 0;
                  (this || _global).alpha_ = void 0;
                  (this || _global).estimate_ = void 0;
                  (this || _global).totalWeight_ = void 0;
                  (this || _global).halfLife = halfLife;
                  // Larger values of alpha expire historical data more slowly.
                  (this || _global).alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
                  (this || _global).estimate_ = estimate;
                  (this || _global).totalWeight_ = weight;
                }
                var _proto = EWMA.prototype;
                _proto.sample = function sample(weight, value) {
                  var adjAlpha = Math.pow((this || _global).alpha_, weight);
                  (this || _global).estimate_ = value * (1 - adjAlpha) + adjAlpha * (this || _global).estimate_;
                  (this || _global).totalWeight_ += weight;
                };
                _proto.getTotalWeight = function getTotalWeight() {
                  return (this || _global).totalWeight_;
                };
                _proto.getEstimate = function getEstimate() {
                  if ((this || _global).alpha_) {
                    var zeroFactor = 1 - Math.pow((this || _global).alpha_, (this || _global).totalWeight_);
                    if (zeroFactor) {
                      return (this || _global).estimate_ / zeroFactor;
                    }
                  }
                  return (this || _global).estimate_;
                };
                return EWMA;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = EWMA;

              /***/
            },

            /***/"./src/utils/fetch-loader.ts":
            /*!***********************************!*\
              !*** ./src/utils/fetch-loader.ts ***!
              \***********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__,
                /* harmony export */"fetchSupported": () => /* binding */fetchSupported
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _loader_load_stats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../loader/load-stats */"./src/loader/load-stats.ts");
              /* harmony import */
              var _demux_chunk_cache__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../demux/chunk-cache */"./src/demux/chunk-cache.ts");
              function _inheritsLoose(subClass, superClass) {
                subClass.prototype = Object.create(superClass.prototype);
                subClass.prototype.constructor = subClass;
                _setPrototypeOf(subClass, superClass);
              }
              function _wrapNativeSuper(Class) {
                var _cache = typeof Map === "function" ? new Map() : undefined;
                _wrapNativeSuper = function _wrapNativeSuper(Class) {
                  if (Class === null || !_isNativeFunction(Class)) return Class;
                  if (typeof Class !== "function") {
                    throw new TypeError("Super expression must either be null or a function");
                  }
                  if (typeof _cache !== "undefined") {
                    if (_cache.has(Class)) return _cache.get(Class);
                    _cache.set(Class, Wrapper);
                  }
                  function Wrapper() {
                    return _construct(Class, arguments, _getPrototypeOf(this || _global).constructor);
                  }
                  Wrapper.prototype = Object.create(Class.prototype, {
                    constructor: {
                      value: Wrapper,
                      enumerable: false,
                      writable: true,
                      configurable: true
                    }
                  });
                  return _setPrototypeOf(Wrapper, Class);
                };
                return _wrapNativeSuper(Class);
              }
              function _construct(Parent, args, Class) {
                if (_isNativeReflectConstruct()) {
                  _construct = Reflect.construct.bind();
                } else {
                  _construct = function _construct(Parent, args, Class) {
                    var a = [null];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor();
                    if (Class) _setPrototypeOf(instance, Class.prototype);
                    return instance;
                  };
                }
                return _construct.apply(null, arguments);
              }
              function _isNativeReflectConstruct() {
                if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                if (Reflect.construct.sham) return false;
                if (typeof Proxy === "function") return true;
                try {
                  Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
                  return true;
                } catch (e) {
                  return false;
                }
              }
              function _isNativeFunction(fn) {
                return Function.toString.call(fn).indexOf("[native code]") !== -1;
              }
              function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                  o.__proto__ = p;
                  return o;
                };
                return _setPrototypeOf(o, p);
              }
              function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                  return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
              }
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              function fetchSupported() {
                if (
                // @ts-ignore
                self.fetch && self.AbortController && self.ReadableStream && self.Request) {
                  try {
                    new self.ReadableStream({}); // eslint-disable-line no-new
                    return true;
                  } catch (e) {
                    /* noop */
                  }
                }
                return false;
              }
              var FetchLoader = /*#__PURE__*/function () {
                function FetchLoader(config /* HlsConfig */) {
                  (this || _global).fetchSetup = void 0;
                  (this || _global).requestTimeout = void 0;
                  (this || _global).request = void 0;
                  (this || _global).response = void 0;
                  (this || _global).controller = void 0;
                  (this || _global).context = void 0;
                  (this || _global).config = null;
                  (this || _global).callbacks = null;
                  (this || _global).stats = void 0;
                  (this || _global).loader = null;
                  (this || _global).fetchSetup = config.fetchSetup || getRequest;
                  (this || _global).controller = new self.AbortController();
                  (this || _global).stats = new _loader_load_stats__WEBPACK_IMPORTED_MODULE_1__.LoadStats();
                }
                var _proto = FetchLoader.prototype;
                _proto.destroy = function destroy() {
                  (this || _global).loader = (this || _global).callbacks = null;
                  this.abortInternal();
                };
                _proto.abortInternal = function abortInternal() {
                  var response = (this || _global).response;
                  if (!response || !response.ok) {
                    (this || _global).stats.aborted = true;
                    (this || _global).controller.abort();
                  }
                };
                _proto.abort = function abort() {
                  var _this$callbacks;
                  this.abortInternal();
                  if ((_this$callbacks = (this || _global).callbacks) !== null && _this$callbacks !== void 0 && _this$callbacks.onAbort) {
                    (this || _global).callbacks.onAbort((this || _global).stats, (this || _global).context, (this || _global).response);
                  }
                };
                _proto.load = function load(context, config, callbacks) {
                  var _this = this || _global;
                  var stats = (this || _global).stats;
                  if (stats.loading.start) {
                    throw new Error("Loader can only be used once.");
                  }
                  stats.loading.start = self.performance.now();
                  var initParams = getRequestParameters(context, (this || _global).controller.signal);
                  var onProgress = callbacks.onProgress;
                  var isArrayBuffer = context.responseType === "arraybuffer";
                  var LENGTH = isArrayBuffer ? "byteLength" : "length";
                  (this || _global).context = context;
                  (this || _global).config = config;
                  (this || _global).callbacks = callbacks;
                  (this || _global).request = this.fetchSetup(context, initParams);
                  self.clearTimeout((this || _global).requestTimeout);
                  (this || _global).requestTimeout = self.setTimeout(function () {
                    _this.abortInternal();
                    callbacks.onTimeout(stats, context, _this.response);
                  }, config.timeout);
                  self.fetch((this || _global).request).then(function (response) {
                    _this.response = _this.loader = response;
                    if (!response.ok) {
                      var status = response.status,
                        statusText = response.statusText;
                      throw new FetchError(statusText || "fetch, bad network response", status, response);
                    }
                    stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                    stats.total = parseInt(response.headers.get("Content-Length") || "0");
                    if (onProgress && (0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(config.highWaterMark)) {
                      return _this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
                    }
                    if (isArrayBuffer) {
                      return response.arrayBuffer();
                    }
                    return response.text();
                  }).then(function (responseData) {
                    var response = _this.response;
                    self.clearTimeout(_this.requestTimeout);
                    stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                    var total = responseData[LENGTH];
                    if (total) {
                      stats.loaded = stats.total = total;
                    }
                    var loaderResponse = {
                      url: response.url,
                      data: responseData
                    };
                    if (onProgress && !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(config.highWaterMark)) {
                      onProgress(stats, context, responseData, response);
                    }
                    callbacks.onSuccess(loaderResponse, stats, context, response);
                  }).catch(function (error) {
                    self.clearTimeout(_this.requestTimeout);
                    if (stats.aborted) {
                      return;
                    }
                    // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
                    // when destroying, 'error' itself can be undefined
                    var code = !error ? 0 : error.code || 0;
                    var text = !error ? null : error.message;
                    callbacks.onError({
                      code: code,
                      text: text
                    }, context, error ? error.details : null);
                  });
                };
                _proto.getCacheAge = function getCacheAge() {
                  var result = null;
                  if ((this || _global).response) {
                    var ageHeader = (this || _global).response.headers.get("age");
                    result = ageHeader ? parseFloat(ageHeader) : null;
                  }
                  return result;
                };
                _proto.loadProgressively = function loadProgressively(response, stats, context, highWaterMark, onProgress) {
                  if (highWaterMark === void 0) {
                    highWaterMark = 0;
                  }
                  var chunkCache = new _demux_chunk_cache__WEBPACK_IMPORTED_MODULE_2__["default"]();
                  var reader = response.body.getReader();
                  var pump = function pump() {
                    return reader.read().then(function (data) {
                      if (data.done) {
                        if (chunkCache.dataLength) {
                          onProgress(stats, context, chunkCache.flush(), response);
                        }
                        return Promise.resolve(new ArrayBuffer(0));
                      }
                      var chunk = data.value;
                      var len = chunk.length;
                      stats.loaded += len;
                      if (len < highWaterMark || chunkCache.dataLength) {
                        // The current chunk is too small to to be emitted or the cache already has data
                        // Push it to the cache
                        chunkCache.push(chunk);
                        if (chunkCache.dataLength >= highWaterMark) {
                          // flush in order to join the typed arrays
                          onProgress(stats, context, chunkCache.flush(), response);
                        }
                      } else {
                        // If there's nothing cached already, and the chache is large enough
                        // just emit the progress event
                        onProgress(stats, context, chunk, response);
                      }
                      return pump();
                    }).catch(function () {
                      /* aborted */
                      return Promise.reject();
                    });
                  };
                  return pump();
                };
                return FetchLoader;
              }();
              function getRequestParameters(context, signal) {
                var initParams = {
                  method: "GET",
                  mode: "cors",
                  credentials: "same-origin",
                  signal: signal,
                  headers: new self.Headers(_extends({}, context.headers))
                };
                if (context.rangeEnd) {
                  initParams.headers.set("Range", "bytes=" + context.rangeStart + "-" + String(context.rangeEnd - 1));
                }
                return initParams;
              }
              function getRequest(context, initParams) {
                return new self.Request(context.url, initParams);
              }
              var FetchError = /*#__PURE__*/function (_Error) {
                _inheritsLoose(FetchError, _Error);
                function FetchError(message, code, details) {
                  var _this2;
                  _this2 = _Error.call(this || _global, message) || this || _global;
                  _this2.code = void 0;
                  _this2.details = void 0;
                  _this2.code = code;
                  _this2.details = details;
                  return _this2;
                }
                return FetchError;
              }( /*#__PURE__*/_wrapNativeSuper(Error));
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = FetchLoader;

              /***/
            },

            /***/"./src/utils/imsc1-ttml-parser.ts":
            /*!****************************************!*\
              !*** ./src/utils/imsc1-ttml-parser.ts ***!
              \****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"IMSC1_CODEC": () => /* binding */IMSC1_CODEC,
                /* harmony export */"parseIMSC1": () => /* binding */parseIMSC1
                /* harmony export */
              });
              /* harmony import */
              var _mp4_tools__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./mp4-tools */"./src/utils/mp4-tools.ts");
              /* harmony import */
              var _vttparser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./vttparser */"./src/utils/vttparser.ts");
              /* harmony import */
              var _vttcue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ./vttcue */"./src/utils/vttcue.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              /* harmony import */
              var _timescale_conversion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ./timescale-conversion */"./src/utils/timescale-conversion.ts");
              /* harmony import */
              var _webvtt_parser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__( /*! ./webvtt-parser */"./src/utils/webvtt-parser.ts");
              function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function (target) {
                  for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) {
                      if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                      }
                    }
                  }
                  return target;
                };
                return _extends.apply(this || _global, arguments);
              }
              var IMSC1_CODEC = "stpp.ttml.im1t";

              // Time format: h:m:s:frames(.subframes)
              var HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;

              // Time format: hours, minutes, seconds, milliseconds, frames, ticks
              var TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
              var textAlignToLineAlign = {
                left: "start",
                center: "center",
                right: "end",
                start: "start",
                end: "end"
              };
              function parseIMSC1(payload, initPTS, timescale, callBack, errorCallBack) {
                var results = (0, _mp4_tools__WEBPACK_IMPORTED_MODULE_0__.findBox)(new Uint8Array(payload), ["mdat"]);
                if (results.length === 0) {
                  errorCallBack(new Error("Could not parse IMSC1 mdat"));
                  return;
                }
                var ttmlList = results.map(function (mdat) {
                  return (0, _demux_id3__WEBPACK_IMPORTED_MODULE_3__.utf8ArrayToStr)(mdat);
                });
                var syncTime = (0, _timescale_conversion__WEBPACK_IMPORTED_MODULE_4__.toTimescaleFromScale)(initPTS, 1, timescale);
                try {
                  ttmlList.forEach(function (ttml) {
                    return callBack(parseTTML(ttml, syncTime));
                  });
                } catch (error) {
                  errorCallBack(error);
                }
              }
              function parseTTML(ttml, syncTime) {
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(ttml, "text/xml");
                var tt = xmlDoc.getElementsByTagName("tt")[0];
                if (!tt) {
                  throw new Error("Invalid ttml");
                }
                var defaultRateInfo = {
                  frameRate: 30,
                  subFrameRate: 1,
                  frameRateMultiplier: 0,
                  tickRate: 0
                };
                var rateInfo = Object.keys(defaultRateInfo).reduce(function (result, key) {
                  result[key] = tt.getAttribute("ttp:" + key) || defaultRateInfo[key];
                  return result;
                }, {});
                var trim = tt.getAttribute("xml:space") !== "preserve";
                var styleElements = collectionToDictionary(getElementCollection(tt, "styling", "style"));
                var regionElements = collectionToDictionary(getElementCollection(tt, "layout", "region"));
                var cueElements = getElementCollection(tt, "body", "[begin]");
                return [].map.call(cueElements, function (cueElement) {
                  var cueText = getTextContent(cueElement, trim);
                  if (!cueText || !cueElement.hasAttribute("begin")) {
                    return null;
                  }
                  var startTime = parseTtmlTime(cueElement.getAttribute("begin"), rateInfo);
                  var duration = parseTtmlTime(cueElement.getAttribute("dur"), rateInfo);
                  var endTime = parseTtmlTime(cueElement.getAttribute("end"), rateInfo);
                  if (startTime === null) {
                    throw timestampParsingError(cueElement);
                  }
                  if (endTime === null) {
                    if (duration === null) {
                      throw timestampParsingError(cueElement);
                    }
                    endTime = startTime + duration;
                  }
                  var cue = new _vttcue__WEBPACK_IMPORTED_MODULE_2__["default"](startTime - syncTime, endTime - syncTime, cueText);
                  cue.id = (0, _webvtt_parser__WEBPACK_IMPORTED_MODULE_5__.generateCueId)(cue.startTime, cue.endTime, cue.text);
                  var region = regionElements[cueElement.getAttribute("region")];
                  var style = styleElements[cueElement.getAttribute("style")];

                  // TODO: Add regions to track and cue (origin and extend)
                  // These values are hard-coded (for now) to simulate region settings in the demo
                  cue.position = 10;
                  cue.size = 80;

                  // Apply styles to cue
                  var styles = getTtmlStyles(region, style, styleElements);
                  var textAlign = styles.textAlign;
                  if (textAlign) {
                    // cue.positionAlign not settable in FF~2016
                    var lineAlign = textAlignToLineAlign[textAlign];
                    if (lineAlign) {
                      cue.lineAlign = lineAlign;
                    }
                    cue.align = textAlign;
                  }
                  _extends(cue, styles);
                  return cue;
                }).filter(function (cue) {
                  return cue !== null;
                });
              }
              function getElementCollection(fromElement, parentName, childName) {
                var parent = fromElement.getElementsByTagName(parentName)[0];
                if (parent) {
                  return [].slice.call(parent.querySelectorAll(childName));
                }
                return [];
              }
              function collectionToDictionary(elementsWithId) {
                return elementsWithId.reduce(function (dict, element) {
                  var id = element.getAttribute("xml:id");
                  if (id) {
                    dict[id] = element;
                  }
                  return dict;
                }, {});
              }
              function getTextContent(element, trim) {
                return [].slice.call(element.childNodes).reduce(function (str, node, i) {
                  var _node$childNodes;
                  if (node.nodeName === "br" && i) {
                    return str + "\n";
                  }
                  if ((_node$childNodes = node.childNodes) !== null && _node$childNodes !== void 0 && _node$childNodes.length) {
                    return getTextContent(node, trim);
                  } else if (trim) {
                    return str + node.textContent.trim().replace(/\s+/g, " ");
                  }
                  return str + node.textContent;
                }, "");
              }
              function getTtmlStyles(region, style, styleElements) {
                var ttsNs = "http://www.w3.org/ns/ttml#styling";
                var regionStyle = null;
                var styleAttributes = ["displayAlign", "textAlign", "color", "backgroundColor", "fontSize", "fontFamily"
                // 'fontWeight',
                // 'lineHeight',
                // 'wrapOption',
                // 'fontStyle',
                // 'direction',
                // 'writingMode'
                ];

                var regionStyleName = region !== null && region !== void 0 && region.hasAttribute("style") ? region.getAttribute("style") : null;
                if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) {
                  regionStyle = styleElements[regionStyleName];
                }
                return styleAttributes.reduce(function (styles, name) {
                  var value = getAttributeNS(style, ttsNs, name) || getAttributeNS(region, ttsNs, name) || getAttributeNS(regionStyle, ttsNs, name);
                  if (value) {
                    styles[name] = value;
                  }
                  return styles;
                }, {});
              }
              function getAttributeNS(element, ns, name) {
                if (!element) {
                  return null;
                }
                return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
              }
              function timestampParsingError(node) {
                return new Error("Could not parse ttml timestamp " + node);
              }
              function parseTtmlTime(timeAttributeValue, rateInfo) {
                if (!timeAttributeValue) {
                  return null;
                }
                var seconds = (0, _vttparser__WEBPACK_IMPORTED_MODULE_1__.parseTimeStamp)(timeAttributeValue);
                if (seconds === null) {
                  if (HMSF_REGEX.test(timeAttributeValue)) {
                    seconds = parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
                  } else if (TIME_UNIT_REGEX.test(timeAttributeValue)) {
                    seconds = parseTimeUnits(timeAttributeValue, rateInfo);
                  }
                }
                return seconds;
              }
              function parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
                var m = HMSF_REGEX.exec(timeAttributeValue);
                var frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
                return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
              }
              function parseTimeUnits(timeAttributeValue, rateInfo) {
                var m = TIME_UNIT_REGEX.exec(timeAttributeValue);
                var value = Number(m[1]);
                var unit = m[2];
                switch (unit) {
                  case "h":
                    return value * 3600;
                  case "m":
                    return value * 60;
                  case "ms":
                    return value * 1000;
                  case "f":
                    return value / rateInfo.frameRate;
                  case "t":
                    return value / rateInfo.tickRate;
                }
                return value;
              }

              /***/
            },

            /***/"./src/utils/logger.ts":
            /*!*****************************!*\
              !*** ./src/utils/logger.ts ***!
              \*****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"enableLogs": () => /* binding */enableLogs,
                /* harmony export */"logger": () => /* binding */logger
                /* harmony export */
              });
              var noop = function noop() {};
              var fakeLogger = {
                trace: noop,
                debug: noop,
                log: noop,
                warn: noop,
                info: noop,
                error: noop
              };
              var exportedLogger = fakeLogger;

              // let lastCallTime;
              // function formatMsgWithTimeInfo(type, msg) {
              //   const now = Date.now();
              //   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
              //   lastCallTime = now;
              //   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
              //   return msg;
              // }

              function consolePrintFn(type) {
                var func = self.console[type];
                if (func) {
                  return func.bind(self.console, "[" + type + "] >");
                }
                return noop;
              }
              function exportLoggerFunctions(debugConfig) {
                for (var _len = arguments.length, functions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  functions[_key - 1] = arguments[_key];
                }
                functions.forEach(function (type) {
                  exportedLogger[type] = debugConfig[type] ? debugConfig[type].bind(debugConfig) : consolePrintFn(type);
                });
              }
              function enableLogs(debugConfig, id) {
                // check that console is available
                if (self.console && debugConfig === true || typeof debugConfig === "object") {
                  exportLoggerFunctions(debugConfig,
                  // Remove out from list here to hard-disable a log-level
                  // 'trace',
                  "debug", "log", "info", "warn", "error");
                  // Some browsers don't allow to use bind on console object anyway
                  // fallback to default if needed
                  try {
                    exportedLogger.log("Debug logs enabled for \"" + id + "\"");
                  } catch (e) {
                    exportedLogger = fakeLogger;
                  }
                } else {
                  exportedLogger = fakeLogger;
                }
              }
              var logger = exportedLogger;

              /***/
            },

            /***/"./src/utils/mediakeys-helper.ts":
            /*!***************************************!*\
              !*** ./src/utils/mediakeys-helper.ts ***!
              \***************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"KeySystems": () => /* binding */KeySystems,
                /* harmony export */"requestMediaKeySystemAccess": () => /* binding */requestMediaKeySystemAccess
                /* harmony export */
              });
              /**
               * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
               */
              var KeySystems;
              (function (KeySystems) {
                KeySystems["WIDEVINE"] = "com.widevine.alpha";
                KeySystems["PLAYREADY"] = "com.microsoft.playready";
              })(KeySystems || (KeySystems = {}));
              var requestMediaKeySystemAccess = function () {
                if (typeof self !== "undefined" && self.navigator && self.navigator.requestMediaKeySystemAccess) {
                  return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
                } else {
                  return null;
                }
              }();

              /***/
            },

            /***/"./src/utils/mediasource-helper.ts":
            /*!*****************************************!*\
              !*** ./src/utils/mediasource-helper.ts ***!
              \*****************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"getMediaSource": () => /* binding */getMediaSource
                /* harmony export */
              });
              /**
               * MediaSource helper
               */

              function getMediaSource() {
                return self.MediaSource || self.WebKitMediaSource;
              }

              /***/
            },

            /***/"./src/utils/mp4-tools.ts":
            /*!********************************!*\
              !*** ./src/utils/mp4-tools.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"RemuxerTrackIdConfig": () => /* binding */RemuxerTrackIdConfig,
                /* harmony export */"appendUint8Array": () => /* binding */appendUint8Array,
                /* harmony export */"bin2str": () => /* binding */bin2str,
                /* harmony export */"computeRawDurationFromSamples": () => /* binding */computeRawDurationFromSamples,
                /* harmony export */"discardEPB": () => /* binding */discardEPB,
                /* harmony export */"findBox": () => /* binding */findBox,
                /* harmony export */"getDuration": () => /* binding */getDuration,
                /* harmony export */"getStartDTS": () => /* binding */getStartDTS,
                /* harmony export */"offsetStartDTS": () => /* binding */offsetStartDTS,
                /* harmony export */"parseEmsg": () => /* binding */parseEmsg,
                /* harmony export */"parseInitSegment": () => /* binding */parseInitSegment,
                /* harmony export */"parseSEIMessageFromNALu": () => /* binding */parseSEIMessageFromNALu,
                /* harmony export */"parseSamples": () => /* binding */parseSamples,
                /* harmony export */"parseSegmentIndex": () => /* binding */parseSegmentIndex,
                /* harmony export */"readSint32": () => /* binding */readSint32,
                /* harmony export */"readUint16": () => /* binding */readUint16,
                /* harmony export */"readUint32": () => /* binding */readUint32,
                /* harmony export */"segmentValidRange": () => /* binding */segmentValidRange,
                /* harmony export */"writeUint32": () => /* binding */writeUint32
                /* harmony export */
              });
              /* harmony import */
              var _typed_array__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./typed-array */"./src/utils/typed-array.ts");
              /* harmony import */
              var _loader_fragment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../loader/fragment */"./src/loader/fragment.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              var UINT32_MAX = Math.pow(2, 32) - 1;
              var push = [].push;

              // We are using fixed track IDs for driving the MP4 remuxer
              // instead of following the TS PIDs.
              // There is no reason not to do this and some browsers/SourceBuffer-demuxers
              // may not like if there are TrackID "switches"
              // See https://github.com/video-dev/hls.js/issues/1331
              // Here we are mapping our internal track types to constant MP4 track IDs
              // With MSE currently one can only have one track of each, and we are muxing
              // whatever video/audio rendition in them.
              var RemuxerTrackIdConfig = {
                video: 1,
                audio: 2,
                id3: 3,
                text: 4
              };
              function bin2str(data) {
                return String.fromCharCode.apply(null, data);
              }
              function readUint16(buffer, offset) {
                var val = buffer[offset] << 8 | buffer[offset + 1];
                return val < 0 ? 65536 + val : val;
              }
              function readUint32(buffer, offset) {
                var val = readSint32(buffer, offset);
                return val < 0 ? 4294967296 + val : val;
              }
              function readSint32(buffer, offset) {
                return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
              }
              function writeUint32(buffer, offset, value) {
                buffer[offset] = value >> 24;
                buffer[offset + 1] = value >> 16 & 255;
                buffer[offset + 2] = value >> 8 & 255;
                buffer[offset + 3] = value & 255;
              }

              // Find the data for a box specified by its path
              function findBox(data, path) {
                var results = [];
                if (!path.length) {
                  // short-circuit the search for empty paths
                  return results;
                }
                var end = data.byteLength;
                for (var i = 0; i < end;) {
                  var size = readUint32(data, i);
                  var type = bin2str(data.subarray(i + 4, i + 8));
                  var endbox = size > 1 ? i + size : end;
                  if (type === path[0]) {
                    if (path.length === 1) {
                      // this is the end of the path and we've found the box we were
                      // looking for
                      results.push(data.subarray(i + 8, endbox));
                    } else {
                      // recursively search for the next box along the path
                      var subresults = findBox(data.subarray(i + 8, endbox), path.slice(1));
                      if (subresults.length) {
                        push.apply(results, subresults);
                      }
                    }
                  }
                  i = endbox;
                }

                // we've finished searching all of data
                return results;
              }
              function parseSegmentIndex(sidx) {
                var references = [];
                var version = sidx[0];

                // set initial offset, we skip the reference ID (not needed)
                var index = 8;
                var timescale = readUint32(sidx, index);
                index += 4;

                // TODO: parse earliestPresentationTime and firstOffset
                // usually zero in our case
                var earliestPresentationTime = 0;
                var firstOffset = 0;
                if (version === 0) {
                  index += 8;
                } else {
                  index += 16;
                }

                // skip reserved
                index += 2;
                var startByte = sidx.length + firstOffset;
                var referencesCount = readUint16(sidx, index);
                index += 2;
                for (var i = 0; i < referencesCount; i++) {
                  var referenceIndex = index;
                  var referenceInfo = readUint32(sidx, referenceIndex);
                  referenceIndex += 4;
                  var referenceSize = referenceInfo & 2147483647;
                  var referenceType = (referenceInfo & 2147483648) >>> 31;
                  if (referenceType === 1) {
                    // eslint-disable-next-line no-console
                    console.warn("SIDX has hierarchical references (not supported)");
                    return null;
                  }
                  var subsegmentDuration = readUint32(sidx, referenceIndex);
                  referenceIndex += 4;
                  references.push({
                    referenceSize: referenceSize,
                    subsegmentDuration: subsegmentDuration,
                    // unscaled
                    info: {
                      duration: subsegmentDuration / timescale,
                      start: startByte,
                      end: startByte + referenceSize - 1
                    }
                  });
                  startByte += referenceSize;

                  // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
                  // for |sapDelta|.
                  referenceIndex += 4;

                  // skip to next ref
                  index = referenceIndex;
                }
                return {
                  earliestPresentationTime: earliestPresentationTime,
                  timescale: timescale,
                  version: version,
                  referencesCount: referencesCount,
                  references: references
                };
              }

              /**
               * Parses an MP4 initialization segment and extracts stream type and
               * timescale values for any declared tracks. Timescale values indicate the
               * number of clock ticks per second to assume for time-based values
               * elsewhere in the MP4.
               *
               * To determine the start time of an MP4, you need two pieces of
               * information: the timescale unit and the earliest base media decode
               * time. Multiple timescales can be specified within an MP4 but the
               * base media decode time is always expressed in the timescale from
               * the media header box for the track:
               * ```
               * moov > trak > mdia > mdhd.timescale
               * moov > trak > mdia > hdlr
               * ```
               * @param initSegment {Uint8Array} the bytes of the init segment
               * @return {InitData} a hash of track type to timescale values or null if
               * the init segment is malformed.
               */

              function parseInitSegment(initSegment) {
                var result = [];
                var traks = findBox(initSegment, ["moov", "trak"]);
                for (var i = 0; i < traks.length; i++) {
                  var trak = traks[i];
                  var tkhd = findBox(trak, ["tkhd"])[0];
                  if (tkhd) {
                    var version = tkhd[0];
                    var _index = version === 0 ? 12 : 20;
                    var trackId = readUint32(tkhd, _index);
                    var mdhd = findBox(trak, ["mdia", "mdhd"])[0];
                    if (mdhd) {
                      version = mdhd[0];
                      _index = version === 0 ? 12 : 20;
                      var timescale = readUint32(mdhd, _index);
                      var hdlr = findBox(trak, ["mdia", "hdlr"])[0];
                      if (hdlr) {
                        var hdlrType = bin2str(hdlr.subarray(8, 12));
                        var type = {
                          soun: _loader_fragment__WEBPACK_IMPORTED_MODULE_1__.ElementaryStreamTypes.AUDIO,
                          vide: _loader_fragment__WEBPACK_IMPORTED_MODULE_1__.ElementaryStreamTypes.VIDEO
                        }[hdlrType];
                        if (type) {
                          // Parse codec details
                          var stsd = findBox(trak, ["mdia", "minf", "stbl", "stsd"])[0];
                          var codec = void 0;
                          if (stsd) {
                            codec = bin2str(stsd.subarray(12, 16));
                            // TODO: Parse codec details to be able to build MIME type.
                            // stsd.start += 8;
                            // const codecBox = findBox(stsd, [codec])[0];
                            // if (codecBox) {
                            //   TODO: Codec parsing support for avc1, mp4a, hevc, av01...
                            // }
                          }

                          result[trackId] = {
                            timescale: timescale,
                            type: type
                          };
                          result[type] = {
                            timescale: timescale,
                            id: trackId,
                            codec: codec
                          };
                        }
                      }
                    }
                  }
                }
                var trex = findBox(initSegment, ["moov", "mvex", "trex"]);
                trex.forEach(function (trex) {
                  var trackId = readUint32(trex, 4);
                  var track = result[trackId];
                  if (track) {
                    track.default = {
                      duration: readUint32(trex, 12),
                      flags: readUint32(trex, 20)
                    };
                  }
                });
                return result;
              }

              /**
               * Determine the base media decode start time, in seconds, for an MP4
               * fragment. If multiple fragments are specified, the earliest time is
               * returned.
               *
               * The base media decode time can be parsed from track fragment
               * metadata:
               * ```
               * moof > traf > tfdt.baseMediaDecodeTime
               * ```
               * It requires the timescale value from the mdhd to interpret.
               *
               * @param initData {InitData} a hash of track type to timescale values
               * @param fmp4 {Uint8Array} the bytes of the mp4 fragment
               * @return {number} the earliest base media decode start time for the
               * fragment, in seconds
               */
              function getStartDTS(initData, fmp4) {
                // we need info from two children of each track fragment box
                return findBox(fmp4, ["moof", "traf"]).reduce(function (result, traf) {
                  var tfdt = findBox(traf, ["tfdt"])[0];
                  var version = tfdt[0];
                  var start = findBox(traf, ["tfhd"]).reduce(function (result, tfhd) {
                    // get the track id from the tfhd
                    var id = readUint32(tfhd, 4);
                    var track = initData[id];
                    if (track) {
                      var baseTime = readUint32(tfdt, 4);
                      if (version === 1) {
                        baseTime *= Math.pow(2, 32);
                        baseTime += readUint32(tfdt, 8);
                      }
                      // assume a 90kHz clock if no timescale was specified
                      var scale = track.timescale || 90000;
                      // convert base time to seconds
                      var startTime = baseTime / scale;
                      if (isFinite(startTime) && (result === null || startTime < result)) {
                        return startTime;
                      }
                    }
                    return result;
                  }, null);
                  if (start !== null && isFinite(start) && (result === null || start < result)) {
                    return start;
                  }
                  return result;
                }, null) || 0;
              }

              /*
                For Reference:
                aligned(8) class TrackFragmentHeaderBox
                         extends FullBox(‘tfhd’, 0, tf_flags){
                   unsigned int(32)  track_ID;
                   // all the following are optional fields
                   unsigned int(64)  base_data_offset;
                   unsigned int(32)  sample_description_index;
                   unsigned int(32)  default_sample_duration;
                   unsigned int(32)  default_sample_size;
                   unsigned int(32)  default_sample_flags
                }
               */
              function getDuration(data, initData) {
                var rawDuration = 0;
                var videoDuration = 0;
                var audioDuration = 0;
                var trafs = findBox(data, ["moof", "traf"]);
                for (var i = 0; i < trafs.length; i++) {
                  var traf = trafs[i];
                  // There is only one tfhd & trun per traf
                  // This is true for CMAF style content, and we should perhaps check the ftyp
                  // and only look for a single trun then, but for ISOBMFF we should check
                  // for multiple track runs.
                  var tfhd = findBox(traf, ["tfhd"])[0];
                  // get the track id from the tfhd
                  var id = readUint32(tfhd, 4);
                  var track = initData[id];
                  if (!track) {
                    continue;
                  }
                  var trackDefault = track.default;
                  var tfhdFlags = readUint32(tfhd, 0) | (trackDefault === null || trackDefault === void 0 ? void 0 : trackDefault.flags);
                  var sampleDuration = trackDefault === null || trackDefault === void 0 ? void 0 : trackDefault.duration;
                  if (tfhdFlags & 8) {
                    // 0x000008 indicates the presence of the default_sample_duration field
                    if (tfhdFlags & 2) {
                      // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
                      // If present, the default_sample_duration exists at byte offset 12
                      sampleDuration = readUint32(tfhd, 12);
                    } else {
                      // Otherwise, the duration is at byte offset 8
                      sampleDuration = readUint32(tfhd, 8);
                    }
                  }
                  // assume a 90kHz clock if no timescale was specified
                  var timescale = track.timescale || 90000;
                  var truns = findBox(traf, ["trun"]);
                  for (var j = 0; j < truns.length; j++) {
                    rawDuration = computeRawDurationFromSamples(truns[j]);
                    if (!rawDuration && sampleDuration) {
                      var sampleCount = readUint32(truns[j], 4);
                      rawDuration = sampleDuration * sampleCount;
                    }
                    if (track.type === _loader_fragment__WEBPACK_IMPORTED_MODULE_1__.ElementaryStreamTypes.VIDEO) {
                      videoDuration += rawDuration / timescale;
                    } else if (track.type === _loader_fragment__WEBPACK_IMPORTED_MODULE_1__.ElementaryStreamTypes.AUDIO) {
                      audioDuration += rawDuration / timescale;
                    }
                  }
                }
                if (videoDuration === 0 && audioDuration === 0) {
                  // If duration samples are not available in the traf use sidx subsegment_duration
                  var sidxDuration = 0;
                  var sidxs = findBox(data, ["sidx"]);
                  for (var _i = 0; _i < sidxs.length; _i++) {
                    var sidx = parseSegmentIndex(sidxs[_i]);
                    if (sidx !== null && sidx !== void 0 && sidx.references) {
                      sidxDuration += sidx.references.reduce(function (dur, ref) {
                        return dur + ref.info.duration || 0;
                      }, 0);
                    }
                  }
                  return sidxDuration;
                }
                if (videoDuration) {
                  return videoDuration;
                }
                return audioDuration;
              }

              /*
                For Reference:
                aligned(8) class TrackRunBox
                         extends FullBox(‘trun’, version, tr_flags) {
                   unsigned int(32)  sample_count;
                   // the following are optional fields
                   signed int(32) data_offset;
                   unsigned int(32)  first_sample_flags;
                   // all fields in the following array are optional
                   {
                      unsigned int(32)  sample_duration;
                      unsigned int(32)  sample_size;
                      unsigned int(32)  sample_flags
                      if (version == 0)
                         { unsigned int(32)
                      else
                         { signed int(32)
                   }[ sample_count ]
                }
               */
              function computeRawDurationFromSamples(trun) {
                var flags = readUint32(trun, 0);
                // Flags are at offset 0, non-optional sample_count is at offset 4. Therefore we start 8 bytes in.
                // Each field is an int32, which is 4 bytes
                var offset = 8;
                // data-offset-present flag
                if (flags & 1) {
                  offset += 4;
                }
                // first-sample-flags-present flag
                if (flags & 4) {
                  offset += 4;
                }
                var duration = 0;
                var sampleCount = readUint32(trun, 4);
                for (var i = 0; i < sampleCount; i++) {
                  // sample-duration-present flag
                  if (flags & 256) {
                    var sampleDuration = readUint32(trun, offset);
                    duration += sampleDuration;
                    offset += 4;
                  }
                  // sample-size-present flag
                  if (flags & 512) {
                    offset += 4;
                  }
                  // sample-flags-present flag
                  if (flags & 1024) {
                    offset += 4;
                  }
                  // sample-composition-time-offsets-present flag
                  if (flags & 2048) {
                    offset += 4;
                  }
                }
                return duration;
              }
              function offsetStartDTS(initData, fmp4, timeOffset) {
                findBox(fmp4, ["moof", "traf"]).forEach(function (traf) {
                  findBox(traf, ["tfhd"]).forEach(function (tfhd) {
                    // get the track id from the tfhd
                    var id = readUint32(tfhd, 4);
                    var track = initData[id];
                    if (!track) {
                      return;
                    }
                    // assume a 90kHz clock if no timescale was specified
                    var timescale = track.timescale || 90000;
                    // get the base media decode time from the tfdt
                    findBox(traf, ["tfdt"]).forEach(function (tfdt) {
                      var version = tfdt[0];
                      var baseMediaDecodeTime = readUint32(tfdt, 4);
                      if (version === 0) {
                        baseMediaDecodeTime -= timeOffset * timescale;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        writeUint32(tfdt, 4, baseMediaDecodeTime);
                      } else {
                        baseMediaDecodeTime *= Math.pow(2, 32);
                        baseMediaDecodeTime += readUint32(tfdt, 8);
                        baseMediaDecodeTime -= timeOffset * timescale;
                        baseMediaDecodeTime = Math.max(baseMediaDecodeTime, 0);
                        var upper = Math.floor(baseMediaDecodeTime / (UINT32_MAX + 1));
                        var lower = Math.floor(baseMediaDecodeTime % (UINT32_MAX + 1));
                        writeUint32(tfdt, 4, upper);
                        writeUint32(tfdt, 8, lower);
                      }
                    });
                  });
                });
              }

              // TODO: Check if the last moof+mdat pair is part of the valid range
              function segmentValidRange(data) {
                var segmentedRange = {
                  valid: null,
                  remainder: null
                };
                var moofs = findBox(data, ["moof"]);
                if (!moofs) {
                  return segmentedRange;
                } else if (moofs.length < 2) {
                  segmentedRange.remainder = data;
                  return segmentedRange;
                }
                var last = moofs[moofs.length - 1];
                // Offset by 8 bytes; findBox offsets the start by as much
                segmentedRange.valid = (0, _typed_array__WEBPACK_IMPORTED_MODULE_0__.sliceUint8)(data, 0, last.byteOffset - 8);
                segmentedRange.remainder = (0, _typed_array__WEBPACK_IMPORTED_MODULE_0__.sliceUint8)(data, last.byteOffset - 8);
                return segmentedRange;
              }
              function appendUint8Array(data1, data2) {
                var temp = new Uint8Array(data1.length + data2.length);
                temp.set(data1);
                temp.set(data2, data1.length);
                return temp;
              }
              function parseSamples(timeOffset, track) {
                var seiSamples = [];
                var videoData = track.samples;
                var timescale = track.timescale;
                var trackId = track.id;
                var isHEVCFlavor = false;
                var moofs = findBox(videoData, ["moof"]);
                moofs.map(function (moof) {
                  var moofOffset = moof.byteOffset - 8;
                  var trafs = findBox(moof, ["traf"]);
                  trafs.map(function (traf) {
                    // get the base media decode time from the tfdt
                    var baseTime = findBox(traf, ["tfdt"]).map(function (tfdt) {
                      var version = tfdt[0];
                      var result = readUint32(tfdt, 4);
                      if (version === 1) {
                        result *= Math.pow(2, 32);
                        result += readUint32(tfdt, 8);
                      }
                      return result / timescale;
                    })[0];
                    if (baseTime !== undefined) {
                      timeOffset = baseTime;
                    }
                    return findBox(traf, ["tfhd"]).map(function (tfhd) {
                      var id = readUint32(tfhd, 4);
                      var tfhdFlags = readUint32(tfhd, 0) & 16777215;
                      var baseDataOffsetPresent = (tfhdFlags & 1) !== 0;
                      var sampleDescriptionIndexPresent = (tfhdFlags & 2) !== 0;
                      var defaultSampleDurationPresent = (tfhdFlags & 8) !== 0;
                      var defaultSampleDuration = 0;
                      var defaultSampleSizePresent = (tfhdFlags & 16) !== 0;
                      var defaultSampleSize = 0;
                      var defaultSampleFlagsPresent = (tfhdFlags & 32) !== 0;
                      var tfhdOffset = 8;
                      if (id === trackId) {
                        if (baseDataOffsetPresent) {
                          tfhdOffset += 8;
                        }
                        if (sampleDescriptionIndexPresent) {
                          tfhdOffset += 4;
                        }
                        if (defaultSampleDurationPresent) {
                          defaultSampleDuration = readUint32(tfhd, tfhdOffset);
                          tfhdOffset += 4;
                        }
                        if (defaultSampleSizePresent) {
                          defaultSampleSize = readUint32(tfhd, tfhdOffset);
                          tfhdOffset += 4;
                        }
                        if (defaultSampleFlagsPresent) {
                          tfhdOffset += 4;
                        }
                        if (track.type === "video") {
                          isHEVCFlavor = isHEVC(track.codec);
                        }
                        findBox(traf, ["trun"]).map(function (trun) {
                          var version = trun[0];
                          var flags = readUint32(trun, 0) & 16777215;
                          var dataOffsetPresent = (flags & 1) !== 0;
                          var dataOffset = 0;
                          var firstSampleFlagsPresent = (flags & 4) !== 0;
                          var sampleDurationPresent = (flags & 256) !== 0;
                          var sampleDuration = 0;
                          var sampleSizePresent = (flags & 512) !== 0;
                          var sampleSize = 0;
                          var sampleFlagsPresent = (flags & 1024) !== 0;
                          var sampleCompositionOffsetsPresent = (flags & 2048) !== 0;
                          var compositionOffset = 0;
                          var sampleCount = readUint32(trun, 4);
                          var trunOffset = 8; // past version, flags, and sample count

                          if (dataOffsetPresent) {
                            dataOffset = readUint32(trun, trunOffset);
                            trunOffset += 4;
                          }
                          if (firstSampleFlagsPresent) {
                            trunOffset += 4;
                          }
                          var sampleOffset = dataOffset + moofOffset;
                          for (var ix = 0; ix < sampleCount; ix++) {
                            if (sampleDurationPresent) {
                              sampleDuration = readUint32(trun, trunOffset);
                              trunOffset += 4;
                            } else {
                              sampleDuration = defaultSampleDuration;
                            }
                            if (sampleSizePresent) {
                              sampleSize = readUint32(trun, trunOffset);
                              trunOffset += 4;
                            } else {
                              sampleSize = defaultSampleSize;
                            }
                            if (sampleFlagsPresent) {
                              trunOffset += 4;
                            }
                            if (sampleCompositionOffsetsPresent) {
                              if (version === 0) {
                                compositionOffset = readUint32(trun, trunOffset);
                              } else {
                                compositionOffset = readSint32(trun, trunOffset);
                              }
                              trunOffset += 4;
                            }
                            if (track.type === _loader_fragment__WEBPACK_IMPORTED_MODULE_1__.ElementaryStreamTypes.VIDEO) {
                              var naluTotalSize = 0;
                              while (naluTotalSize < sampleSize) {
                                var naluSize = readUint32(videoData, sampleOffset);
                                sampleOffset += 4;
                                if (isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                                  var data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                                  parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                                }
                                sampleOffset += naluSize;
                                naluTotalSize += naluSize + 4;
                              }
                            }
                            timeOffset += sampleDuration / timescale;
                          }
                        });
                      }
                    });
                  });
                });
                return seiSamples;
              }
              function isHEVC(codec) {
                if (!codec) {
                  return false;
                }
                var delimit = codec.indexOf(".");
                var baseCodec = delimit < 0 ? codec : codec.substring(0, delimit);
                return baseCodec === "hvc1" || baseCodec === "hev1" ||
                // Dolby Vision
                baseCodec === "dvh1" || baseCodec === "dvhe";
              }
              function isSEIMessage(isHEVCFlavor, naluHeader) {
                if (isHEVCFlavor) {
                  var naluType = naluHeader >> 1 & 63;
                  return naluType === 39 || naluType === 40;
                } else {
                  var _naluType = naluHeader & 31;
                  return _naluType === 6;
                }
              }
              function parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
                var data = discardEPB(unescapedData);
                var seiPtr = 0;
                // skip nal header
                seiPtr += headerSize;
                var payloadType = 0;
                var payloadSize = 0;
                var endOfCaptions = false;
                var b = 0;
                while (seiPtr < data.length) {
                  payloadType = 0;
                  do {
                    if (seiPtr >= data.length) {
                      break;
                    }
                    b = data[seiPtr++];
                    payloadType += b;
                  } while (b === 255);

                  // Parse payload size.
                  payloadSize = 0;
                  do {
                    if (seiPtr >= data.length) {
                      break;
                    }
                    b = data[seiPtr++];
                    payloadSize += b;
                  } while (b === 255);
                  var leftOver = data.length - seiPtr;
                  if (!endOfCaptions && payloadType === 4 && seiPtr < data.length) {
                    endOfCaptions = true;
                    var countryCode = data[seiPtr++];
                    if (countryCode === 181) {
                      var providerCode = readUint16(data, seiPtr);
                      seiPtr += 2;
                      if (providerCode === 49) {
                        var userStructure = readUint32(data, seiPtr);
                        seiPtr += 4;
                        if (userStructure === 1195456820) {
                          var userDataType = data[seiPtr++];

                          // Raw CEA-608 bytes wrapped in CEA-708 packet
                          if (userDataType === 3) {
                            var firstByte = data[seiPtr++];
                            var totalCCs = 31 & firstByte;
                            var enabled = 64 & firstByte;
                            var totalBytes = enabled ? 2 + totalCCs * 3 : 0;
                            var byteArray = new Uint8Array(totalBytes);
                            if (enabled) {
                              byteArray[0] = firstByte;
                              for (var i = 1; i < totalBytes; i++) {
                                byteArray[i] = data[seiPtr++];
                              }
                            }
                            samples.push({
                              type: userDataType,
                              payloadType: payloadType,
                              pts: pts,
                              bytes: byteArray
                            });
                          }
                        }
                      }
                    }
                  } else if (payloadType === 5 && payloadSize < leftOver) {
                    endOfCaptions = true;
                    if (payloadSize > 16) {
                      var uuidStrArray = [];
                      for (var _i2 = 0; _i2 < 16; _i2++) {
                        var _b = data[seiPtr++].toString(16);
                        uuidStrArray.push(_b.length == 1 ? "0" + _b : _b);
                        if (_i2 === 3 || _i2 === 5 || _i2 === 7 || _i2 === 9) {
                          uuidStrArray.push("-");
                        }
                      }
                      var length = payloadSize - 16;
                      var userDataBytes = new Uint8Array(length);
                      for (var _i3 = 0; _i3 < length; _i3++) {
                        userDataBytes[_i3] = data[seiPtr++];
                      }
                      samples.push({
                        payloadType: payloadType,
                        pts: pts,
                        uuid: uuidStrArray.join(""),
                        userData: (0, _demux_id3__WEBPACK_IMPORTED_MODULE_2__.utf8ArrayToStr)(userDataBytes),
                        userDataBytes: userDataBytes
                      });
                    }
                  } else if (payloadSize < leftOver) {
                    seiPtr += payloadSize;
                  } else if (payloadSize > leftOver) {
                    break;
                  }
                }
              }

              /**
               * remove Emulation Prevention bytes from a RBSP
               */
              function discardEPB(data) {
                var length = data.byteLength;
                var EPBPositions = [];
                var i = 1;

                // Find all `Emulation Prevention Bytes`
                while (i < length - 2) {
                  if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 3) {
                    EPBPositions.push(i + 2);
                    i += 2;
                  } else {
                    i++;
                  }
                }

                // If no Emulation Prevention Bytes were found just return the original
                // array
                if (EPBPositions.length === 0) {
                  return data;
                }

                // Create a new array to hold the NAL unit data
                var newLength = length - EPBPositions.length;
                var newData = new Uint8Array(newLength);
                var sourceIndex = 0;
                for (i = 0; i < newLength; sourceIndex++, i++) {
                  if (sourceIndex === EPBPositions[0]) {
                    // Skip this byte
                    sourceIndex++;
                    // Remove this position index
                    EPBPositions.shift();
                  }
                  newData[i] = data[sourceIndex];
                }
                return newData;
              }
              function parseEmsg(data) {
                var version = data[0];
                var schemeIdUri = "";
                var value = "";
                var timeScale = 0;
                var presentationTimeDelta = 0;
                var presentationTime = 0;
                var eventDuration = 0;
                var id = 0;
                var offset = 0;
                if (version === 0) {
                  while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
                    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
                    offset += 1;
                  }
                  schemeIdUri += bin2str(data.subarray(offset, offset + 1));
                  offset += 1;
                  while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
                    value += bin2str(data.subarray(offset, offset + 1));
                    offset += 1;
                  }
                  value += bin2str(data.subarray(offset, offset + 1));
                  offset += 1;
                  timeScale = readUint32(data, 12);
                  presentationTimeDelta = readUint32(data, 16);
                  eventDuration = readUint32(data, 20);
                  id = readUint32(data, 24);
                  offset = 28;
                } else if (version === 1) {
                  offset += 4;
                  timeScale = readUint32(data, offset);
                  offset += 4;
                  var leftPresentationTime = readUint32(data, offset);
                  offset += 4;
                  var rightPresentationTime = readUint32(data, offset);
                  offset += 4;
                  presentationTime = Math.pow(2, 32) * leftPresentationTime + rightPresentationTime;
                  if (!Number.isSafeInteger(presentationTime)) {
                    presentationTime = Number.MAX_SAFE_INTEGER;
                    // eslint-disable-next-line no-console
                    console.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box");
                  }
                  eventDuration = readUint32(data, offset);
                  offset += 4;
                  id = readUint32(data, offset);
                  offset += 4;
                  while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
                    schemeIdUri += bin2str(data.subarray(offset, offset + 1));
                    offset += 1;
                  }
                  schemeIdUri += bin2str(data.subarray(offset, offset + 1));
                  offset += 1;
                  while (bin2str(data.subarray(offset, offset + 1)) !== "\0") {
                    value += bin2str(data.subarray(offset, offset + 1));
                    offset += 1;
                  }
                  value += bin2str(data.subarray(offset, offset + 1));
                  offset += 1;
                }
                var payload = data.subarray(offset, data.byteLength);
                return {
                  schemeIdUri: schemeIdUri,
                  value: value,
                  timeScale: timeScale,
                  presentationTime: presentationTime,
                  presentationTimeDelta: presentationTimeDelta,
                  eventDuration: eventDuration,
                  id: id,
                  payload: payload
                };
              }

              /***/
            },

            /***/"./src/utils/output-filter.ts":
            /*!************************************!*\
              !*** ./src/utils/output-filter.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => /* binding */OutputFilter
                /* harmony export */
              });
              var OutputFilter = /*#__PURE__*/function () {
                function OutputFilter(timelineController, trackName) {
                  (this || _global).timelineController = void 0;
                  (this || _global).cueRanges = [];
                  (this || _global).trackName = void 0;
                  (this || _global).startTime = null;
                  (this || _global).endTime = null;
                  (this || _global).screen = null;
                  (this || _global).timelineController = timelineController;
                  (this || _global).trackName = trackName;
                }
                var _proto = OutputFilter.prototype;
                _proto.dispatchCue = function dispatchCue() {
                  if ((this || _global).startTime === null) {
                    return;
                  }
                  (this || _global).timelineController.addCues((this || _global).trackName, (this || _global).startTime, (this || _global).endTime, (this || _global).screen, (this || _global).cueRanges);
                  (this || _global).startTime = null;
                };
                _proto.newCue = function newCue(startTime, endTime, screen) {
                  if ((this || _global).startTime === null || (this || _global).startTime > startTime) {
                    (this || _global).startTime = startTime;
                  }
                  (this || _global).endTime = endTime;
                  (this || _global).screen = screen;
                  (this || _global).timelineController.createCaptionsTrack((this || _global).trackName);
                };
                _proto.reset = function reset() {
                  (this || _global).cueRanges = [];
                  (this || _global).startTime = null;
                };
                return OutputFilter;
              }();

              /***/
            },

            /***/"./src/utils/texttrack-utils.ts":
            /*!**************************************!*\
              !*** ./src/utils/texttrack-utils.ts ***!
              \**************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"addCueToTrack": () => /* binding */addCueToTrack,
                /* harmony export */"clearCurrentCues": () => /* binding */clearCurrentCues,
                /* harmony export */"getCuesInRange": () => /* binding */getCuesInRange,
                /* harmony export */"removeCuesInRange": () => /* binding */removeCuesInRange,
                /* harmony export */"sendAddTrackEvent": () => /* binding */sendAddTrackEvent
                /* harmony export */
              });
              /* harmony import */
              var _logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./logger */"./src/utils/logger.ts");
              function sendAddTrackEvent(track, videoEl) {
                var event;
                try {
                  event = new Event("addtrack");
                } catch (err) {
                  // for IE11
                  event = document.createEvent("Event");
                  event.initEvent("addtrack", false, false);
                }
                event.track = track;
                videoEl.dispatchEvent(event);
              }
              function addCueToTrack(track, cue) {
                // Sometimes there are cue overlaps on segmented vtts so the same
                // cue can appear more than once in different vtt files.
                // This avoid showing duplicated cues with same timecode and text.
                var mode = track.mode;
                if (mode === "disabled") {
                  track.mode = "hidden";
                }
                if (track.cues && !track.cues.getCueById(cue.id)) {
                  try {
                    track.addCue(cue);
                    if (!track.cues.getCueById(cue.id)) {
                      throw new Error("addCue is failed for: " + cue);
                    }
                  } catch (err) {
                    _logger__WEBPACK_IMPORTED_MODULE_0__.logger.debug("[texttrack-utils]: " + err);
                    var textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
                    textTrackCue.id = cue.id;
                    track.addCue(textTrackCue);
                  }
                }
                if (mode === "disabled") {
                  track.mode = mode;
                }
              }
              function clearCurrentCues(track) {
                // When track.mode is disabled, track.cues will be null.
                // To guarantee the removal of cues, we need to temporarily
                // change the mode to hidden
                var mode = track.mode;
                if (mode === "disabled") {
                  track.mode = "hidden";
                }
                if (track.cues) {
                  for (var i = track.cues.length; i--;) {
                    track.removeCue(track.cues[i]);
                  }
                }
                if (mode === "disabled") {
                  track.mode = mode;
                }
              }
              function removeCuesInRange(track, start, end, predicate) {
                var mode = track.mode;
                if (mode === "disabled") {
                  track.mode = "hidden";
                }
                if (track.cues && track.cues.length > 0) {
                  var cues = getCuesInRange(track.cues, start, end);
                  for (var i = 0; i < cues.length; i++) {
                    if (!predicate || predicate(cues[i])) {
                      track.removeCue(cues[i]);
                    }
                  }
                }
                if (mode === "disabled") {
                  track.mode = mode;
                }
              }

              // Find first cue starting after given time.
              // Modified version of binary search O(log(n)).
              function getFirstCueIndexAfterTime(cues, time) {
                // If first cue starts after time, start there
                if (time < cues[0].startTime) {
                  return 0;
                }
                // If the last cue ends before time there is no overlap
                var len = cues.length - 1;
                if (time > cues[len].endTime) {
                  return -1;
                }
                var left = 0;
                var right = len;
                while (left <= right) {
                  var mid = Math.floor((right + left) / 2);
                  if (time < cues[mid].startTime) {
                    right = mid - 1;
                  } else if (time > cues[mid].startTime && left < len) {
                    left = mid + 1;
                  } else {
                    // If it's not lower or higher, it must be equal.
                    return mid;
                  }
                }
                // At this point, left and right have swapped.
                // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
                return cues[left].startTime - time < time - cues[right].startTime ? left : right;
              }
              function getCuesInRange(cues, start, end) {
                var cuesFound = [];
                var firstCueInRange = getFirstCueIndexAfterTime(cues, start);
                if (firstCueInRange > -1) {
                  for (var i = firstCueInRange, len = cues.length; i < len; i++) {
                    var _cue = cues[i];
                    if (_cue.startTime >= start && _cue.endTime <= end) {
                      cuesFound.push(_cue);
                    } else if (_cue.startTime > end) {
                      return cuesFound;
                    }
                  }
                }
                return cuesFound;
              }

              /***/
            },

            /***/"./src/utils/time-ranges.ts":
            /*!**********************************!*\
              !*** ./src/utils/time-ranges.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /**
               *  TimeRanges to string helper
               */

              var TimeRanges = {
                toString: function toString(r) {
                  var log = "";
                  var len = r.length;
                  for (var i = 0; i < len; i++) {
                    log += "[" + r.start(i).toFixed(3) + "," + r.end(i).toFixed(3) + "]";
                  }
                  return log;
                }
              };
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = TimeRanges;

              /***/
            },

            /***/"./src/utils/timescale-conversion.ts":
            /*!*******************************************!*\
              !*** ./src/utils/timescale-conversion.ts ***!
              \*******************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"toMpegTsClockFromTimescale": () => /* binding */toMpegTsClockFromTimescale,
                /* harmony export */"toMsFromMpegTsClock": () => /* binding */toMsFromMpegTsClock,
                /* harmony export */"toTimescaleFromBase": () => /* binding */toTimescaleFromBase,
                /* harmony export */"toTimescaleFromScale": () => /* binding */toTimescaleFromScale
                /* harmony export */
              });
              var MPEG_TS_CLOCK_FREQ_HZ = 90000;
              function toTimescaleFromBase(value, destScale, srcBase, round) {
                if (srcBase === void 0) {
                  srcBase = 1;
                }
                if (round === void 0) {
                  round = false;
                }
                var result = value * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
                return round ? Math.round(result) : result;
              }
              function toTimescaleFromScale(value, destScale, srcScale, round) {
                if (srcScale === void 0) {
                  srcScale = 1;
                }
                if (round === void 0) {
                  round = false;
                }
                return toTimescaleFromBase(value, destScale, 1 / srcScale, round);
              }
              function toMsFromMpegTsClock(value, round) {
                if (round === void 0) {
                  round = false;
                }
                return toTimescaleFromBase(value, 1000, 1 / MPEG_TS_CLOCK_FREQ_HZ, round);
              }
              function toMpegTsClockFromTimescale(value, srcScale) {
                if (srcScale === void 0) {
                  srcScale = 1;
                }
                return toTimescaleFromBase(value, MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
              }

              /***/
            },

            /***/"./src/utils/typed-array.ts":
            /*!**********************************!*\
              !*** ./src/utils/typed-array.ts ***!
              \**********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"sliceUint8": () => /* binding */sliceUint8
                /* harmony export */
              });
              function sliceUint8(array, start, end) {
                // @ts-expect-error This polyfills IE11 usage of Uint8Array slice.
                // It always exists in the TypeScript definition so fails, but it fails at runtime on IE11.
                return Uint8Array.prototype.slice ? array.slice(start, end) : new Uint8Array(Array.prototype.slice.call(array, start, end));
              }

              /***/
            },

            /***/"./src/utils/vttcue.ts":
            /*!*****************************!*\
              !*** ./src/utils/vttcue.ts ***!
              \*****************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /**
               * Copyright 2013 vtt.js Contributors
               *
               * Licensed under the Apache License, Version 2.0 (the 'License');
               * you may not use this file except in compliance with the License.
               * You may obtain a copy of the License at
               *
               *   http://www.apache.org/licenses/LICENSE-2.0
               *
               * Unless required by applicable law or agreed to in writing, software
               * distributed under the License is distributed on an 'AS IS' BASIS,
               * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
               * See the License for the specific language governing permissions and
               * limitations under the License.
               */

              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = function () {
                if (typeof self !== "undefined" && self.VTTCue) {
                  return self.VTTCue;
                }
                var AllowedDirections = ["", "lr", "rl"];
                var AllowedAlignments = ["start", "middle", "end", "left", "right"];
                function isAllowedValue(allowed, value) {
                  if (typeof value !== "string") {
                    return false;
                  }
                  // necessary for assuring the generic conforms to the Array interface
                  if (!Array.isArray(allowed)) {
                    return false;
                  }
                  // reset the type so that the next narrowing works well
                  var lcValue = value.toLowerCase();
                  // use the allow list to narrow the type to a specific subset of strings
                  if (~allowed.indexOf(lcValue)) {
                    return lcValue;
                  }
                  return false;
                }
                function findDirectionSetting(value) {
                  return isAllowedValue(AllowedDirections, value);
                }
                function findAlignSetting(value) {
                  return isAllowedValue(AllowedAlignments, value);
                }
                function extend(obj) {
                  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    rest[_key - 1] = arguments[_key];
                  }
                  var i = 1;
                  for (; i < arguments.length; i++) {
                    var cobj = arguments[i];
                    for (var p in cobj) {
                      obj[p] = cobj[p];
                    }
                  }
                  return obj;
                }
                function VTTCue(startTime, endTime, text) {
                  var cue = this || _global;
                  var baseObj = {
                    enumerable: true
                  };
                  /**
                   * Shim implementation specific properties. These properties are not in
                   * the spec.
                   */

                  // Lets us know when the VTTCue's data has changed in such a way that we need
                  // to recompute its display state. This lets us compute its display state
                  // lazily.
                  cue.hasBeenReset = false;

                  /**
                   * VTTCue and TextTrackCue properties
                   * http://dev.w3.org/html5/webvtt/#vttcue-interface
                   */

                  var _id = "";
                  var _pauseOnExit = false;
                  var _startTime = startTime;
                  var _endTime = endTime;
                  var _text = text;
                  var _region = null;
                  var _vertical = "";
                  var _snapToLines = true;
                  var _line = "auto";
                  var _lineAlign = "start";
                  var _position = 50;
                  var _positionAlign = "middle";
                  var _size = 50;
                  var _align = "middle";
                  Object.defineProperty(cue, "id", extend({}, baseObj, {
                    get: function get() {
                      return _id;
                    },
                    set: function set(value) {
                      _id = "" + value;
                    }
                  }));
                  Object.defineProperty(cue, "pauseOnExit", extend({}, baseObj, {
                    get: function get() {
                      return _pauseOnExit;
                    },
                    set: function set(value) {
                      _pauseOnExit = !!value;
                    }
                  }));
                  Object.defineProperty(cue, "startTime", extend({}, baseObj, {
                    get: function get() {
                      return _startTime;
                    },
                    set: function set(value) {
                      if (typeof value !== "number") {
                        throw new TypeError("Start time must be set to a number.");
                      }
                      _startTime = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "endTime", extend({}, baseObj, {
                    get: function get() {
                      return _endTime;
                    },
                    set: function set(value) {
                      if (typeof value !== "number") {
                        throw new TypeError("End time must be set to a number.");
                      }
                      _endTime = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "text", extend({}, baseObj, {
                    get: function get() {
                      return _text;
                    },
                    set: function set(value) {
                      _text = "" + value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));

                  // todo: implement VTTRegion polyfill?
                  Object.defineProperty(cue, "region", extend({}, baseObj, {
                    get: function get() {
                      return _region;
                    },
                    set: function set(value) {
                      _region = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "vertical", extend({}, baseObj, {
                    get: function get() {
                      return _vertical;
                    },
                    set: function set(value) {
                      var setting = findDirectionSetting(value);
                      // Have to check for false because the setting an be an empty string.
                      if (setting === false) {
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      }
                      _vertical = setting;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "snapToLines", extend({}, baseObj, {
                    get: function get() {
                      return _snapToLines;
                    },
                    set: function set(value) {
                      _snapToLines = !!value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "line", extend({}, baseObj, {
                    get: function get() {
                      return _line;
                    },
                    set: function set(value) {
                      if (typeof value !== "number" && value !== "auto") {
                        throw new SyntaxError("An invalid number or illegal string was specified.");
                      }
                      _line = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "lineAlign", extend({}, baseObj, {
                    get: function get() {
                      return _lineAlign;
                    },
                    set: function set(value) {
                      var setting = findAlignSetting(value);
                      if (!setting) {
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      }
                      _lineAlign = setting;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "position", extend({}, baseObj, {
                    get: function get() {
                      return _position;
                    },
                    set: function set(value) {
                      if (value < 0 || value > 100) {
                        throw new Error("Position must be between 0 and 100.");
                      }
                      _position = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "positionAlign", extend({}, baseObj, {
                    get: function get() {
                      return _positionAlign;
                    },
                    set: function set(value) {
                      var setting = findAlignSetting(value);
                      if (!setting) {
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      }
                      _positionAlign = setting;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "size", extend({}, baseObj, {
                    get: function get() {
                      return _size;
                    },
                    set: function set(value) {
                      if (value < 0 || value > 100) {
                        throw new Error("Size must be between 0 and 100.");
                      }
                      _size = value;
                      (this || _global).hasBeenReset = true;
                    }
                  }));
                  Object.defineProperty(cue, "align", extend({}, baseObj, {
                    get: function get() {
                      return _align;
                    },
                    set: function set(value) {
                      var setting = findAlignSetting(value);
                      if (!setting) {
                        throw new SyntaxError("An invalid or illegal string was specified.");
                      }
                      _align = setting;
                      (this || _global).hasBeenReset = true;
                    }
                  }));

                  /**
                   * Other <track> spec defined properties
                   */

                  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
                  cue.displayState = undefined;
                }

                /**
                 * VTTCue methods
                 */

                VTTCue.prototype.getCueAsHTML = function () {
                  // Assume WebVTT.convertCueToDOMTree is on the global.
                  var WebVTT = self.WebVTT;
                  return WebVTT.convertCueToDOMTree(self, (this || _global).text);
                };
                // this is a polyfill hack
                return VTTCue;
              }();

              /***/
            },

            /***/"./src/utils/vttparser.ts":
            /*!********************************!*\
              !*** ./src/utils/vttparser.ts ***!
              \********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"VTTParser": () => /* binding */VTTParser,
                /* harmony export */"fixLineBreaks": () => /* binding */fixLineBreaks,
                /* harmony export */"parseTimeStamp": () => /* binding */parseTimeStamp
                /* harmony export */
              });
              /* harmony import */
              var _vttcue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./vttcue */"./src/utils/vttcue.ts");
              /*
               * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
               */

              var StringDecoder = /*#__PURE__*/function () {
                function StringDecoder() {}
                var _proto = StringDecoder.prototype;
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                _proto.decode = function decode(data, options) {
                  if (!data) {
                    return "";
                  }
                  if (typeof data !== "string") {
                    throw new Error("Error - expected string data.");
                  }
                  return decodeURIComponent(encodeURIComponent(data));
                };
                return StringDecoder;
              }(); // Try to parse input as a time stamp.
              function parseTimeStamp(input) {
                function computeSeconds(h, m, s, f) {
                  return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
                }
                var m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
                if (!m) {
                  return null;
                }
                if (parseFloat(m[2]) > 59) {
                  // Timestamp takes the form of [hours]:[minutes].[milliseconds]
                  // First position is hours as it's over 59.
                  return computeSeconds(m[2], m[3], 0, m[4]);
                }
                // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
                return computeSeconds(m[1], m[2], m[3], m[4]);
              }

              // A settings object holds key/value pairs and will ignore anything but the first
              // assignment to a specific key.
              var Settings = /*#__PURE__*/function () {
                function Settings() {
                  (this || _global).values = Object.create(null);
                }
                var _proto2 = Settings.prototype;
                // Only accept the first assignment to any key.
                _proto2.set = function set(k, v) {
                  if (!this.get(k) && v !== "") {
                    (this || _global).values[k] = v;
                  }
                }
                // Return the value for a key, or a default value.
                // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
                // a number of possible default values as properties where 'defaultKey' is
                // the key of the property that will be chosen; otherwise it's assumed to be
                // a single value.
                ;

                _proto2.get = function get(k, dflt, defaultKey) {
                  if (defaultKey) {
                    return this.has(k) ? (this || _global).values[k] : dflt[defaultKey];
                  }
                  return this.has(k) ? (this || _global).values[k] : dflt;
                }
                // Check whether we have a value for a key.
                ;

                _proto2.has = function has(k) {
                  return k in (this || _global).values;
                }
                // Accept a setting if its one of the given alternatives.
                ;

                _proto2.alt = function alt(k, v, a) {
                  for (var n = 0; n < a.length; ++n) {
                    if (v === a[n]) {
                      this.set(k, v);
                      break;
                    }
                  }
                }
                // Accept a setting if its a valid (signed) integer.
                ;

                _proto2.integer = function integer(k, v) {
                  if (/^-?\d+$/.test(v)) {
                    // integer
                    this.set(k, parseInt(v, 10));
                  }
                }
                // Accept a setting if its a valid percentage.
                ;

                _proto2.percent = function percent(k, v) {
                  if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
                    var percent = parseFloat(v);
                    if (percent >= 0 && percent <= 100) {
                      this.set(k, percent);
                      return true;
                    }
                  }
                  return false;
                };
                return Settings;
              }(); // Helper function to parse input into groups separated by 'groupDelim', and
              // interpret each group as a key/value pair separated by 'keyValueDelim'.
              function parseOptions(input, callback, keyValueDelim, groupDelim) {
                var groups = groupDelim ? input.split(groupDelim) : [input];
                for (var i in groups) {
                  if (typeof groups[i] !== "string") {
                    continue;
                  }
                  var kv = groups[i].split(keyValueDelim);
                  if (kv.length !== 2) {
                    continue;
                  }
                  var _k = kv[0];
                  var _v = kv[1];
                  callback(_k, _v);
                }
              }
              var defaults = new _vttcue__WEBPACK_IMPORTED_MODULE_0__["default"](0, 0, "");
              // 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
              //  Safari doesn't yet support this change, but FF and Chrome do.
              var center = defaults.align === "middle" ? "middle" : "center";
              function parseCue(input, cue, regionList) {
                // Remember the original input if we need to throw an error.
                var oInput = input;
                // 4.1 WebVTT timestamp
                function consumeTimeStamp() {
                  var ts = parseTimeStamp(input);
                  if (ts === null) {
                    throw new Error("Malformed timestamp: " + oInput);
                  }

                  // Remove time stamp from input.
                  input = input.replace(/^[^\sa-zA-Z-]+/, "");
                  return ts;
                }

                // 4.4.2 WebVTT cue settings
                function consumeCueSettings(input, cue) {
                  var settings = new Settings();
                  parseOptions(input, function (k, v) {
                    var vals;
                    switch (k) {
                      case "region":
                        // Find the last region we parsed with the same region id.
                        for (var i = regionList.length - 1; i >= 0; i--) {
                          if (regionList[i].id === v) {
                            settings.set(k, regionList[i].region);
                            break;
                          }
                        }
                        break;
                      case "vertical":
                        settings.alt(k, v, ["rl", "lr"]);
                        break;
                      case "line":
                        vals = v.split(",");
                        settings.integer(k, vals[0]);
                        if (settings.percent(k, vals[0])) {
                          settings.set("snapToLines", false);
                        }
                        settings.alt(k, vals[0], ["auto"]);
                        if (vals.length === 2) {
                          settings.alt("lineAlign", vals[1], ["start", center, "end"]);
                        }
                        break;
                      case "position":
                        vals = v.split(",");
                        settings.percent(k, vals[0]);
                        if (vals.length === 2) {
                          settings.alt("positionAlign", vals[1], ["start", center, "end", "line-left", "line-right", "auto"]);
                        }
                        break;
                      case "size":
                        settings.percent(k, v);
                        break;
                      case "align":
                        settings.alt(k, v, ["start", center, "end", "left", "right"]);
                        break;
                    }
                  }, /:/, /\s/);

                  // Apply default values for any missing fields.
                  cue.region = settings.get("region", null);
                  cue.vertical = settings.get("vertical", "");
                  var line = settings.get("line", "auto");
                  if (line === "auto" && defaults.line === -1) {
                    // set numeric line number for Safari
                    line = -1;
                  }
                  cue.line = line;
                  cue.lineAlign = settings.get("lineAlign", "start");
                  cue.snapToLines = settings.get("snapToLines", true);
                  cue.size = settings.get("size", 100);
                  cue.align = settings.get("align", center);
                  var position = settings.get("position", "auto");
                  if (position === "auto" && defaults.position === 50) {
                    // set numeric position for Safari
                    position = cue.align === "start" || cue.align === "left" ? 0 : cue.align === "end" || cue.align === "right" ? 100 : 50;
                  }
                  cue.position = position;
                }
                function skipWhitespace() {
                  input = input.replace(/^\s+/, "");
                }

                // 4.1 WebVTT cue timings.
                skipWhitespace();
                cue.startTime = consumeTimeStamp(); // (1) collect cue start time
                skipWhitespace();
                if (input.slice(0, 3) !== "-->") {
                  // (3) next characters must match '-->'
                  throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
                }
                input = input.slice(3);
                skipWhitespace();
                cue.endTime = consumeTimeStamp(); // (5) collect cue end time

                // 4.1 WebVTT cue settings list.
                skipWhitespace();
                consumeCueSettings(input, cue);
              }
              function fixLineBreaks(input) {
                return input.replace(/<br(?: \/)?>/gi, "\n");
              }
              var VTTParser = /*#__PURE__*/function () {
                function VTTParser() {
                  (this || _global).state = "INITIAL";
                  (this || _global).buffer = "";
                  (this || _global).decoder = new StringDecoder();
                  (this || _global).regionList = [];
                  (this || _global).cue = null;
                  (this || _global).oncue = void 0;
                  (this || _global).onparsingerror = void 0;
                  (this || _global).onflush = void 0;
                }
                var _proto3 = VTTParser.prototype;
                _proto3.parse = function parse(data) {
                  var _this = this || _global;

                  // If there is no data then we won't decode it, but will just try to parse
                  // whatever is in buffer already. This may occur in circumstances, for
                  // example when flush() is called.
                  if (data) {
                    // Try to decode the data that we received.
                    _this.buffer += _this.decoder.decode(data, {
                      stream: true
                    });
                  }
                  function collectNextLine() {
                    var buffer = _this.buffer;
                    var pos = 0;
                    buffer = fixLineBreaks(buffer);
                    while (pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n") {
                      ++pos;
                    }
                    var line = buffer.slice(0, pos);
                    // Advance the buffer early in case we fail below.
                    if (buffer[pos] === "\r") {
                      ++pos;
                    }
                    if (buffer[pos] === "\n") {
                      ++pos;
                    }
                    _this.buffer = buffer.slice(pos);
                    return line;
                  }

                  // 3.2 WebVTT metadata header syntax
                  function parseHeader(input) {
                    parseOptions(input, function (k, v) {
                      // switch (k) {
                      // case 'region':
                      // 3.3 WebVTT region metadata header syntax
                      // console.log('parse region', v);
                      // parseRegion(v);
                      // break;
                      // }
                    }, /:/);
                  }

                  // 5.1 WebVTT file parsing.
                  try {
                    var line = "";
                    if (_this.state === "INITIAL") {
                      // We can't start parsing until we have the first line.
                      if (!/\r\n|\n/.test(_this.buffer)) {
                        return this || _global;
                      }
                      line = collectNextLine();
                      // strip of UTF-8 BOM if any
                      // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                      var m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                      if (!m || !m[0]) {
                        throw new Error("Malformed WebVTT signature.");
                      }
                      _this.state = "HEADER";
                    }
                    var alreadyCollectedLine = false;
                    while (_this.buffer) {
                      // We can't parse a line until we have the full line.
                      if (!/\r\n|\n/.test(_this.buffer)) {
                        return this || _global;
                      }
                      if (!alreadyCollectedLine) {
                        line = collectNextLine();
                      } else {
                        alreadyCollectedLine = false;
                      }
                      switch (_this.state) {
                        case "HEADER":
                          // 13-18 - Allow a header (metadata) under the WEBVTT line.
                          if (/:/.test(line)) {
                            parseHeader(line);
                          } else if (!line) {
                            // An empty line terminates the header and starts the body (cues).
                            _this.state = "ID";
                          }
                          continue;
                        case "NOTE":
                          // Ignore NOTE blocks.
                          if (!line) {
                            _this.state = "ID";
                          }
                          continue;
                        case "ID":
                          // Check for the start of NOTE blocks.
                          if (/^NOTE($|[ \t])/.test(line)) {
                            _this.state = "NOTE";
                            break;
                          }
                          // 19-29 - Allow any number of line terminators, then initialize new cue values.
                          if (!line) {
                            continue;
                          }
                          _this.cue = new _vttcue__WEBPACK_IMPORTED_MODULE_0__["default"](0, 0, "");
                          _this.state = "CUE";
                          // 30-39 - Check if self line contains an optional identifier or timing data.
                          if (line.indexOf("-->") === -1) {
                            _this.cue.id = line;
                            continue;
                          }
                        // Process line as start of a cue.
                        /* falls through */
                        case "CUE":
                          // 40 - Collect cue timings and settings.
                          if (!_this.cue) {
                            _this.state = "BADCUE";
                            continue;
                          }
                          try {
                            parseCue(line, _this.cue, _this.regionList);
                          } catch (e) {
                            // In case of an error ignore rest of the cue.
                            _this.cue = null;
                            _this.state = "BADCUE";
                            continue;
                          }
                          _this.state = "CUETEXT";
                          continue;
                        case "CUETEXT":
                          {
                            var hasSubstring = line.indexOf("-->") !== -1;
                            // 34 - If we have an empty line then report the cue.
                            // 35 - If we have the special substring '-->' then report the cue,
                            // but do not collect the line as we need to process the current
                            // one as a new cue.
                            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                              // We are done parsing self cue.
                              if (_this.oncue && _this.cue) {
                                _this.oncue(_this.cue);
                              }
                              _this.cue = null;
                              _this.state = "ID";
                              continue;
                            }
                            if (_this.cue === null) {
                              continue;
                            }
                            if (_this.cue.text) {
                              _this.cue.text += "\n";
                            }
                            _this.cue.text += line;
                          }
                          continue;
                        case "BADCUE":
                          // 54-62 - Collect and discard the remaining cue.
                          if (!line) {
                            _this.state = "ID";
                          }
                      }
                    }
                  } catch (e) {
                    // If we are currently parsing a cue, report what we have.
                    if (_this.state === "CUETEXT" && _this.cue && _this.oncue) {
                      _this.oncue(_this.cue);
                    }
                    _this.cue = null;
                    // Enter BADWEBVTT state if header was not parsed correctly otherwise
                    // another exception occurred so enter BADCUE state.
                    _this.state = _this.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
                  }
                  return this || _global;
                };
                _proto3.flush = function flush() {
                  var _this = this || _global;
                  try {
                    // Finish decoding the stream.
                    // _this.buffer += _this.decoder.decode();
                    // Synthesize the end of the current cue or region.
                    if (_this.cue || _this.state === "HEADER") {
                      _this.buffer += "\n\n";
                      _this.parse();
                    }
                    // If we've flushed, parsed, and we're still on the INITIAL state then
                    // that means we don't have enough of the stream to parse the first
                    // line.
                    if (_this.state === "INITIAL" || _this.state === "BADWEBVTT") {
                      throw new Error("Malformed WebVTT signature.");
                    }
                  } catch (e) {
                    if (_this.onparsingerror) {
                      _this.onparsingerror(e);
                    }
                  }
                  if (_this.onflush) {
                    _this.onflush();
                  }
                  return this || _global;
                };
                return VTTParser;
              }();

              /***/
            },

            /***/"./src/utils/webvtt-parser.ts":
            /*!************************************!*\
              !*** ./src/utils/webvtt-parser.ts ***!
              \************************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"generateCueId": () => /* binding */generateCueId,
                /* harmony export */"parseWebVTT": () => /* binding */parseWebVTT
                /* harmony export */
              });
              /* harmony import */
              var _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./src/polyfills/number */"./src/polyfills/number.ts");
              /* harmony import */
              var _vttparser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ./vttparser */"./src/utils/vttparser.ts");
              /* harmony import */
              var _demux_id3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__( /*! ../demux/id3 */"./src/demux/id3.ts");
              /* harmony import */
              var _timescale_conversion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__( /*! ./timescale-conversion */"./src/utils/timescale-conversion.ts");
              /* harmony import */
              var _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__( /*! ../remux/mp4-remuxer */"./src/remux/mp4-remuxer.ts");
              var LINEBREAKS = /\r\n|\n\r|\n|\r/g;

              // String.prototype.startsWith is not supported in IE11
              var startsWith = function startsWith(inputString, searchString, position) {
                if (position === void 0) {
                  position = 0;
                }
                return inputString.slice(position, position + searchString.length) === searchString;
              };
              var cueString2millis = function cueString2millis(timeString) {
                var ts = parseInt(timeString.slice(-3));
                var secs = parseInt(timeString.slice(-6, -4));
                var mins = parseInt(timeString.slice(-9, -7));
                var hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(":"))) : 0;
                if (!(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(ts) || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(secs) || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(mins) || !(0, _home_runner_work_hls_js_hls_js_src_polyfills_number__WEBPACK_IMPORTED_MODULE_0__.isFiniteNumber)(hours)) {
                  throw Error("Malformed X-TIMESTAMP-MAP: Local:" + timeString);
                }
                ts += 1000 * secs;
                ts += 60 * 1000 * mins;
                ts += 60 * 60 * 1000 * hours;
                return ts;
              };

              // From https://github.com/darkskyapp/string-hash
              var hash = function hash(text) {
                var hash = 5381;
                var i = text.length;
                while (i) {
                  hash = hash * 33 ^ text.charCodeAt(--i);
                }
                return (hash >>> 0).toString();
              };

              // Create a unique hash id for a cue based on start/end times and text.
              // This helps timeline-controller to avoid showing repeated captions.
              function generateCueId(startTime, endTime, text) {
                return hash(startTime.toString()) + hash(endTime.toString()) + hash(text);
              }
              var calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
                var currCC = vttCCs[cc];
                var prevCC = vttCCs[currCC.prevCC];

                // This is the first discontinuity or cues have been processed since the last discontinuity
                // Offset = current discontinuity time
                if (!prevCC || !prevCC.new && currCC.new) {
                  vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
                  currCC.new = false;
                  return;
                }

                // There have been discontinuities since cues were last parsed.
                // Offset = time elapsed
                while ((_prevCC = prevCC) !== null && _prevCC !== void 0 && _prevCC.new) {
                  var _prevCC;
                  vttCCs.ccOffset += currCC.start - prevCC.start;
                  currCC.new = false;
                  currCC = prevCC;
                  prevCC = vttCCs[currCC.prevCC];
                }
                vttCCs.presentationOffset = presentationTime;
              };
              function parseWebVTT(vttByteArray, initPTS, timescale, vttCCs, cc, timeOffset, callBack, errorCallBack) {
                var parser = new _vttparser__WEBPACK_IMPORTED_MODULE_1__.VTTParser();
                // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
                // Uint8Array.prototype.reduce is not implemented in IE11
                var vttLines = (0, _demux_id3__WEBPACK_IMPORTED_MODULE_2__.utf8ArrayToStr)(new Uint8Array(vttByteArray)).trim().replace(LINEBREAKS, "\n").split("\n");
                var cues = [];
                var initPTS90Hz = (0, _timescale_conversion__WEBPACK_IMPORTED_MODULE_3__.toMpegTsClockFromTimescale)(initPTS, timescale);
                var cueTime = "00:00.000";
                var timestampMapMPEGTS = 0;
                var timestampMapLOCAL = 0;
                var parsingError;
                var inHeader = true;
                parser.oncue = function (cue) {
                  // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
                  var currCC = vttCCs[cc];
                  var cueOffset = vttCCs.ccOffset;

                  // Calculate subtitle PTS offset
                  var webVttMpegTsMapOffset = (timestampMapMPEGTS - initPTS90Hz) / 90000;

                  // Update offsets for new discontinuities
                  if (currCC !== null && currCC !== void 0 && currCC.new) {
                    if (timestampMapLOCAL !== undefined) {
                      // When local time is provided, offset = discontinuity start time - local time
                      cueOffset = vttCCs.ccOffset = currCC.start;
                    } else {
                      calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
                    }
                  }
                  if (webVttMpegTsMapOffset) {
                    // If we have MPEGTS, offset = presentation time + discontinuity offset
                    cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
                  }
                  var duration = cue.endTime - cue.startTime;
                  var startTime = (0, _remux_mp4_remuxer__WEBPACK_IMPORTED_MODULE_4__.normalizePts)((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
                  cue.startTime = Math.max(startTime, 0);
                  cue.endTime = Math.max(startTime + duration, 0);

                  //trim trailing webvtt block whitespaces
                  var text = cue.text.trim();

                  // Fix encoding of special characters
                  cue.text = decodeURIComponent(encodeURIComponent(text));

                  // If the cue was not assigned an id from the VTT file (line above the content), create one.
                  if (!cue.id) {
                    cue.id = generateCueId(cue.startTime, cue.endTime, text);
                  }
                  if (cue.endTime > 0) {
                    cues.push(cue);
                  }
                };
                parser.onparsingerror = function (error) {
                  parsingError = error;
                };
                parser.onflush = function () {
                  if (parsingError) {
                    errorCallBack(parsingError);
                    return;
                  }
                  callBack(cues);
                };

                // Go through contents line by line.
                vttLines.forEach(function (line) {
                  if (inHeader) {
                    // Look for X-TIMESTAMP-MAP in header.
                    if (startsWith(line, "X-TIMESTAMP-MAP=")) {
                      // Once found, no more are allowed anyway, so stop searching.
                      inHeader = false;
                      // Extract LOCAL and MPEGTS.
                      line.slice(16).split(",").forEach(function (timestamp) {
                        if (startsWith(timestamp, "LOCAL:")) {
                          cueTime = timestamp.slice(6);
                        } else if (startsWith(timestamp, "MPEGTS:")) {
                          timestampMapMPEGTS = parseInt(timestamp.slice(7));
                        }
                      });
                      try {
                        // Convert cue time to seconds
                        timestampMapLOCAL = cueString2millis(cueTime) / 1000;
                      } catch (error) {
                        parsingError = error;
                      }
                      // Return without parsing X-TIMESTAMP-MAP line.
                      return;
                    } else if (line === "") {
                      inHeader = false;
                    }
                  }
                  // Parse line by default.
                  parser.parse(line + "\n");
                });
                parser.flush();
              }

              /***/
            },

            /***/"./src/utils/xhr-loader.ts":
            /*!*********************************!*\
              !*** ./src/utils/xhr-loader.ts ***!
              \*********************************/
            /***/
            (__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
              __webpack_require__.r(__webpack_exports__);
              /* harmony export */
              __webpack_require__.d(__webpack_exports__, {
                /* harmony export */"default": () => __WEBPACK_DEFAULT_EXPORT__
                /* harmony export */
              });
              /* harmony import */
              var _utils_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ../utils/logger */"./src/utils/logger.ts");
              /* harmony import */
              var _loader_load_stats__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__( /*! ../loader/load-stats */"./src/loader/load-stats.ts");
              var AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/m;
              var XhrLoader = /*#__PURE__*/function () {
                function XhrLoader(config /* HlsConfig */) {
                  (this || _global).xhrSetup = void 0;
                  (this || _global).requestTimeout = void 0;
                  (this || _global).retryTimeout = void 0;
                  (this || _global).retryDelay = void 0;
                  (this || _global).config = null;
                  (this || _global).callbacks = null;
                  (this || _global).context = void 0;
                  (this || _global).loader = null;
                  (this || _global).stats = void 0;
                  (this || _global).xhrSetup = config ? config.xhrSetup : null;
                  (this || _global).stats = new _loader_load_stats__WEBPACK_IMPORTED_MODULE_1__.LoadStats();
                  (this || _global).retryDelay = 0;
                }
                var _proto = XhrLoader.prototype;
                _proto.destroy = function destroy() {
                  (this || _global).callbacks = null;
                  this.abortInternal();
                  (this || _global).loader = null;
                  (this || _global).config = null;
                };
                _proto.abortInternal = function abortInternal() {
                  var loader = (this || _global).loader;
                  self.clearTimeout((this || _global).requestTimeout);
                  self.clearTimeout((this || _global).retryTimeout);
                  if (loader) {
                    loader.onreadystatechange = null;
                    loader.onprogress = null;
                    if (loader.readyState !== 4) {
                      (this || _global).stats.aborted = true;
                      loader.abort();
                    }
                  }
                };
                _proto.abort = function abort() {
                  var _this$callbacks;
                  this.abortInternal();
                  if ((_this$callbacks = (this || _global).callbacks) !== null && _this$callbacks !== void 0 && _this$callbacks.onAbort) {
                    (this || _global).callbacks.onAbort((this || _global).stats, (this || _global).context, (this || _global).loader);
                  }
                };
                _proto.load = function load(context, config, callbacks) {
                  if ((this || _global).stats.loading.start) {
                    throw new Error("Loader can only be used once.");
                  }
                  (this || _global).stats.loading.start = self.performance.now();
                  (this || _global).context = context;
                  (this || _global).config = config;
                  (this || _global).callbacks = callbacks;
                  (this || _global).retryDelay = config.retryDelay;
                  this.loadInternal();
                };
                _proto.loadInternal = function loadInternal() {
                  var config = (this || _global).config,
                    context = (this || _global).context;
                  if (!config) {
                    return;
                  }
                  var xhr = (this || _global).loader = new self.XMLHttpRequest();
                  var stats = (this || _global).stats;
                  stats.loading.first = 0;
                  stats.loaded = 0;
                  var xhrSetup = (this || _global).xhrSetup;
                  try {
                    if (xhrSetup) {
                      try {
                        xhrSetup(xhr, context.url);
                      } catch (e) {
                        // fix xhrSetup: (xhr, url) => {xhr.setRequestHeader("Content-Language", "test");}
                        // not working, as xhr.setRequestHeader expects xhr.readyState === OPEN
                        xhr.open("GET", context.url, true);
                        xhrSetup(xhr, context.url);
                      }
                    }
                    if (!xhr.readyState) {
                      xhr.open("GET", context.url, true);
                    }
                    var headers = (this || _global).context.headers;
                    if (headers) {
                      for (var header in headers) {
                        xhr.setRequestHeader(header, headers[header]);
                      }
                    }
                  } catch (e) {
                    // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
                    (this || _global).callbacks.onError({
                      code: xhr.status,
                      text: e.message
                    }, context, xhr);
                    return;
                  }
                  if (context.rangeEnd) {
                    xhr.setRequestHeader("Range", "bytes=" + context.rangeStart + "-" + (context.rangeEnd - 1));
                  }
                  xhr.onreadystatechange = (this || _global).readystatechange.bind(this || _global);
                  xhr.onprogress = (this || _global).loadprogress.bind(this || _global);
                  xhr.responseType = context.responseType;
                  // setup timeout before we perform request
                  self.clearTimeout((this || _global).requestTimeout);
                  (this || _global).requestTimeout = self.setTimeout((this || _global).loadtimeout.bind(this || _global), config.timeout);
                  xhr.send();
                };
                _proto.readystatechange = function readystatechange() {
                  var context = (this || _global).context,
                    xhr = (this || _global).loader,
                    stats = (this || _global).stats;
                  if (!context || !xhr) {
                    return;
                  }
                  var readyState = xhr.readyState;
                  var config = (this || _global).config;

                  // don't proceed if xhr has been aborted
                  if (stats.aborted) {
                    return;
                  }

                  // >= HEADERS_RECEIVED
                  if (readyState >= 2) {
                    // clear xhr timeout and rearm it if readyState less than 4
                    self.clearTimeout((this || _global).requestTimeout);
                    if (stats.loading.first === 0) {
                      stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                    }
                    if (readyState === 4) {
                      xhr.onreadystatechange = null;
                      xhr.onprogress = null;
                      var status = xhr.status;
                      // http status between 200 to 299 are all successful
                      var isArrayBuffer = xhr.responseType === "arraybuffer";
                      if (status >= 200 && status < 300 && (isArrayBuffer && xhr.response || xhr.responseText !== null)) {
                        stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                        var data;
                        var len;
                        if (isArrayBuffer) {
                          data = xhr.response;
                          len = data.byteLength;
                        } else {
                          data = xhr.responseText;
                          len = data.length;
                        }
                        stats.loaded = stats.total = len;
                        if (!(this || _global).callbacks) {
                          return;
                        }
                        var onProgress = (this || _global).callbacks.onProgress;
                        if (onProgress) {
                          onProgress(stats, context, data, xhr);
                        }
                        if (!(this || _global).callbacks) {
                          return;
                        }
                        var response = {
                          url: xhr.responseURL,
                          data: data
                        };
                        (this || _global).callbacks.onSuccess(response, stats, context, xhr);
                      } else {
                        // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                        if (stats.retry >= config.maxRetry || status >= 400 && status < 499) {
                          _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.error(status + " while loading " + context.url);
                          (this || _global).callbacks.onError({
                            code: status,
                            text: xhr.statusText
                          }, context, xhr);
                        } else {
                          // retry
                          _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.warn(status + " while loading " + context.url + ", retrying in " + (this || _global).retryDelay + "...");
                          // abort and reset internal state
                          this.abortInternal();
                          (this || _global).loader = null;
                          // schedule retry
                          self.clearTimeout((this || _global).retryTimeout);
                          (this || _global).retryTimeout = self.setTimeout((this || _global).loadInternal.bind(this || _global), (this || _global).retryDelay);
                          // set exponential backoff
                          (this || _global).retryDelay = Math.min(2 * (this || _global).retryDelay, config.maxRetryDelay);
                          stats.retry++;
                        }
                      }
                    } else {
                      // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                      self.clearTimeout((this || _global).requestTimeout);
                      (this || _global).requestTimeout = self.setTimeout((this || _global).loadtimeout.bind(this || _global), config.timeout);
                    }
                  }
                };
                _proto.loadtimeout = function loadtimeout() {
                  _utils_logger__WEBPACK_IMPORTED_MODULE_0__.logger.warn("timeout while loading " + (this || _global).context.url);
                  var callbacks = (this || _global).callbacks;
                  if (callbacks) {
                    this.abortInternal();
                    callbacks.onTimeout((this || _global).stats, (this || _global).context, (this || _global).loader);
                  }
                };
                _proto.loadprogress = function loadprogress(event) {
                  var stats = (this || _global).stats;
                  stats.loaded = event.loaded;
                  if (event.lengthComputable) {
                    stats.total = event.total;
                  }
                };
                _proto.getCacheAge = function getCacheAge() {
                  var result = null;
                  if ((this || _global).loader && AGE_HEADER_LINE_REGEX.test((this || _global).loader.getAllResponseHeaders())) {
                    var ageHeader = (this || _global).loader.getResponseHeader("age");
                    result = ageHeader ? parseFloat(ageHeader) : null;
                  }
                  return result;
                };
                return XhrLoader;
              }();
              /* harmony default export */
              const __WEBPACK_DEFAULT_EXPORT__ = XhrLoader;

              /***/
            },

            /***/"./node_modules/eventemitter3/index.js":
            /*!*********************************************!*\
              !*** ./node_modules/eventemitter3/index.js ***!
              \*********************************************/
            /***/
            module => {
              var has = Object.prototype.hasOwnProperty,
                prefix = "~";

              /**
               * Constructor to create a storage for our `EE` objects.
               * An `Events` instance is a plain object whose properties are event names.
               *
               * @constructor
               * @private
               */
              function Events() {}

              //
              // We try to not inherit from `Object.prototype`. In some engines creating an
              // instance in this way is faster than calling `Object.create(null)` directly.
              // If `Object.create(null)` is not supported we prefix the event names with a
              // character to make sure that the built-in object properties are not
              // overridden or used as an attack vector.
              //
              if (Object.create) {
                Events.prototype = Object.create(null);

                //
                // This hack is needed because the `__proto__` property is still inherited in
                // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
                //
                if (!new Events().__proto__) prefix = false;
              }

              /**
               * Representation of a single event listener.
               *
               * @param {Function} fn The listener function.
               * @param {*} context The context to invoke the listener with.
               * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
               * @constructor
               * @private
               */
              function EE(fn, context, once) {
                (this || _global).fn = fn;
                (this || _global).context = context;
                (this || _global).once = once || false;
              }

              /**
               * Add a listener for a given event.
               *
               * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
               * @param {(String|Symbol)} event The event name.
               * @param {Function} fn The listener function.
               * @param {*} context The context to invoke the listener with.
               * @param {Boolean} once Specify if the listener is a one-time listener.
               * @returns {EventEmitter}
               * @private
               */
              function addListener(emitter, event, fn, context, once) {
                if (typeof fn !== "function") {
                  throw new TypeError("The listener must be a function");
                }
                var listener = new EE(fn, context || emitter, once),
                  evt = prefix ? prefix + event : event;
                if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);else emitter._events[evt] = [emitter._events[evt], listener];
                return emitter;
              }

              /**
               * Clear event by name.
               *
               * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
               * @param {(String|Symbol)} evt The Event name.
               * @private
               */
              function clearEvent(emitter, evt) {
                if (--emitter._eventsCount === 0) emitter._events = new Events();else delete emitter._events[evt];
              }

              /**
               * Minimal `EventEmitter` interface that is molded against the Node.js
               * `EventEmitter` interface.
               *
               * @constructor
               * @public
               */
              function EventEmitter() {
                (this || _global)._events = new Events();
                (this || _global)._eventsCount = 0;
              }

              /**
               * Return an array listing the events for which the emitter has registered
               * listeners.
               *
               * @returns {Array}
               * @public
               */
              EventEmitter.prototype.eventNames = function eventNames() {
                var names = [],
                  events,
                  name;
                if ((this || _global)._eventsCount === 0) return names;
                for (name in events = (this || _global)._events) {
                  if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
                }
                if (Object.getOwnPropertySymbols) {
                  return names.concat(Object.getOwnPropertySymbols(events));
                }
                return names;
              };

              /**
               * Return the listeners registered for a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @returns {Array} The registered listeners.
               * @public
               */
              EventEmitter.prototype.listeners = function listeners(event) {
                var evt = prefix ? prefix + event : event,
                  handlers = (this || _global)._events[evt];
                if (!handlers) return [];
                if (handlers.fn) return [handlers.fn];
                for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
                  ee[i] = handlers[i].fn;
                }
                return ee;
              };

              /**
               * Return the number of listeners listening to a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @returns {Number} The number of listeners.
               * @public
               */
              EventEmitter.prototype.listenerCount = function listenerCount(event) {
                var evt = prefix ? prefix + event : event,
                  listeners = (this || _global)._events[evt];
                if (!listeners) return 0;
                if (listeners.fn) return 1;
                return listeners.length;
              };

              /**
               * Calls each of the listeners registered for a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @returns {Boolean} `true` if the event had listeners, else `false`.
               * @public
               */
              EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
                var evt = prefix ? prefix + event : event;
                if (!(this || _global)._events[evt]) return false;
                var listeners = (this || _global)._events[evt],
                  len = arguments.length,
                  args,
                  i;
                if (listeners.fn) {
                  if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                  switch (len) {
                    case 1:
                      return listeners.fn.call(listeners.context), true;
                    case 2:
                      return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                      return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                      return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                      return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                      return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                  }
                  for (i = 1, args = new Array(len - 1); i < len; i++) {
                    args[i - 1] = arguments[i];
                  }
                  listeners.fn.apply(listeners.context, args);
                } else {
                  var length = listeners.length,
                    j;
                  for (i = 0; i < length; i++) {
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch (len) {
                      case 1:
                        listeners[i].fn.call(listeners[i].context);
                        break;
                      case 2:
                        listeners[i].fn.call(listeners[i].context, a1);
                        break;
                      case 3:
                        listeners[i].fn.call(listeners[i].context, a1, a2);
                        break;
                      case 4:
                        listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                        break;
                      default:
                        if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
                          args[j - 1] = arguments[j];
                        }
                        listeners[i].fn.apply(listeners[i].context, args);
                    }
                  }
                }
                return true;
              };

              /**
               * Add a listener for a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @param {Function} fn The listener function.
               * @param {*} [context=this] The context to invoke the listener with.
               * @returns {EventEmitter} `this`.
               * @public
               */
              EventEmitter.prototype.on = function on(event, fn, context) {
                return addListener(this || _global, event, fn, context, false);
              };

              /**
               * Add a one-time listener for a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @param {Function} fn The listener function.
               * @param {*} [context=this] The context to invoke the listener with.
               * @returns {EventEmitter} `this`.
               * @public
               */
              EventEmitter.prototype.once = function once(event, fn, context) {
                return addListener(this || _global, event, fn, context, true);
              };

              /**
               * Remove the listeners of a given event.
               *
               * @param {(String|Symbol)} event The event name.
               * @param {Function} fn Only remove the listeners that match this function.
               * @param {*} context Only remove the listeners that have this context.
               * @param {Boolean} once Only remove one-time listeners.
               * @returns {EventEmitter} `this`.
               * @public
               */
              EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
                var evt = prefix ? prefix + event : event;
                if (!(this || _global)._events[evt]) return this || _global;
                if (!fn) {
                  clearEvent(this || _global, evt);
                  return this || _global;
                }
                var listeners = (this || _global)._events[evt];
                if (listeners.fn) {
                  if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
                    clearEvent(this || _global, evt);
                  }
                } else {
                  for (var i = 0, events = [], length = listeners.length; i < length; i++) {
                    if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
                      events.push(listeners[i]);
                    }
                  }

                  //
                  // Reset the array, or remove it completely if we have no more listeners.
                  //
                  if (events.length) (this || _global)._events[evt] = events.length === 1 ? events[0] : events;else clearEvent(this || _global, evt);
                }
                return this || _global;
              };

              /**
               * Remove all listeners, or those of the specified event.
               *
               * @param {(String|Symbol)} [event] The event name.
               * @returns {EventEmitter} `this`.
               * @public
               */
              EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
                var evt;
                if (event) {
                  evt = prefix ? prefix + event : event;
                  if ((this || _global)._events[evt]) clearEvent(this || _global, evt);
                } else {
                  (this || _global)._events = new Events();
                  (this || _global)._eventsCount = 0;
                }
                return this || _global;
              };

              //
              // Alias methods names because people roll like that.
              //
              EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
              EventEmitter.prototype.addListener = EventEmitter.prototype.on;

              //
              // Expose the prefix.
              //
              EventEmitter.prefixed = prefix;

              //
              // Allow `EventEmitter` to be imported as module namespace.
              //
              EventEmitter.EventEmitter = EventEmitter;

              //
              // Expose the module.
              //
              {
                module.exports = EventEmitter;
              }

              /***/
            },

            /***/"./node_modules/url-toolkit/src/url-toolkit.js":
            /*!*****************************************************!*\
              !*** ./node_modules/url-toolkit/src/url-toolkit.js ***!
              \*****************************************************/
            /***/
            function (module) {
              // see https://tools.ietf.org/html/rfc1808

              (function (root) {
                var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
                var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
                var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
                var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
                var URLToolkit = {
                  // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                  // E.g
                  // With opts.alwaysNormalize = false (default, spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                  // With opts.alwaysNormalize = true (not spec compliant)
                  // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                  buildAbsoluteURL: function (baseURL, relativeURL, opts) {
                    opts = opts || {};
                    // remove any remaining space and CRLF
                    baseURL = baseURL.trim();
                    relativeURL = relativeURL.trim();
                    if (!relativeURL) {
                      // 2a) If the embedded URL is entirely empty, it inherits the
                      // entire base URL (i.e., is set equal to the base URL)
                      // and we are done.
                      if (!opts.alwaysNormalize) {
                        return baseURL;
                      }
                      var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                      if (!basePartsForNormalise) {
                        throw new Error("Error trying to parse base URL.");
                      }
                      basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                      return URLToolkit.buildURLFromParts(basePartsForNormalise);
                    }
                    var relativeParts = URLToolkit.parseURL(relativeURL);
                    if (!relativeParts) {
                      throw new Error("Error trying to parse relative URL.");
                    }
                    if (relativeParts.scheme) {
                      // 2b) If the embedded URL starts with a scheme name, it is
                      // interpreted as an absolute URL and we are done.
                      if (!opts.alwaysNormalize) {
                        return relativeURL;
                      }
                      relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                      return URLToolkit.buildURLFromParts(relativeParts);
                    }
                    var baseParts = URLToolkit.parseURL(baseURL);
                    if (!baseParts) {
                      throw new Error("Error trying to parse base URL.");
                    }
                    if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== "/") {
                      // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                      // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                      var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                      baseParts.netLoc = pathParts[1];
                      baseParts.path = pathParts[2];
                    }
                    if (baseParts.netLoc && !baseParts.path) {
                      baseParts.path = "/";
                    }
                    var builtParts = {
                      // 2c) Otherwise, the embedded URL inherits the scheme of
                      // the base URL.
                      scheme: baseParts.scheme,
                      netLoc: relativeParts.netLoc,
                      path: null,
                      params: relativeParts.params,
                      query: relativeParts.query,
                      fragment: relativeParts.fragment
                    };
                    if (!relativeParts.netLoc) {
                      // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                      // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                      // (if any) of the base URL.
                      builtParts.netLoc = baseParts.netLoc;
                      // 4) If the embedded URL path is preceded by a slash "/", the
                      // path is not relative and we skip to Step 7.
                      if (relativeParts.path[0] !== "/") {
                        if (!relativeParts.path) {
                          // 5) If the embedded URL path is empty (and not preceded by a
                          // slash), then the embedded URL inherits the base URL path
                          builtParts.path = baseParts.path;
                          // 5a) if the embedded URL's <params> is non-empty, we skip to
                          // step 7; otherwise, it inherits the <params> of the base
                          // URL (if any) and
                          if (!relativeParts.params) {
                            builtParts.params = baseParts.params;
                            // 5b) if the embedded URL's <query> is non-empty, we skip to
                            // step 7; otherwise, it inherits the <query> of the base
                            // URL (if any) and we skip to step 7.
                            if (!relativeParts.query) {
                              builtParts.query = baseParts.query;
                            }
                          }
                        } else {
                          // 6) The last segment of the base URL's path (anything
                          // following the rightmost slash "/", or the entire path if no
                          // slash is present) is removed and the embedded URL's path is
                          // appended in its place.
                          var baseURLPath = baseParts.path;
                          var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf("/") + 1) + relativeParts.path;
                          builtParts.path = URLToolkit.normalizePath(newPath);
                        }
                      }
                    }
                    if (builtParts.path === null) {
                      builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                    }
                    return URLToolkit.buildURLFromParts(builtParts);
                  },
                  parseURL: function (url) {
                    var parts = URL_REGEX.exec(url);
                    if (!parts) {
                      return null;
                    }
                    return {
                      scheme: parts[1] || "",
                      netLoc: parts[2] || "",
                      path: parts[3] || "",
                      params: parts[4] || "",
                      query: parts[5] || "",
                      fragment: parts[6] || ""
                    };
                  },
                  normalizePath: function (path) {
                    // The following operations are
                    // then applied, in order, to the new path:
                    // 6a) All occurrences of "./", where "." is a complete path
                    // segment, are removed.
                    // 6b) If the path ends with "." as a complete path segment,
                    // that "." is removed.
                    path = path.split("").reverse().join("").replace(SLASH_DOT_REGEX, "");
                    // 6c) All occurrences of "<segment>/../", where <segment> is a
                    // complete path segment not equal to "..", are removed.
                    // Removal of these path segments is performed iteratively,
                    // removing the leftmost matching pattern on each iteration,
                    // until no matching pattern remains.
                    // 6d) If the path ends with "<segment>/..", where <segment> is a
                    // complete path segment not equal to "..", that
                    // "<segment>/.." is removed.
                    while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, "")).length) {}
                    return path.split("").reverse().join("");
                  },
                  buildURLFromParts: function (parts) {
                    return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
                  }
                };
                module.exports = URLToolkit;
              })();

              /***/
            }

            /******/
          };
          /************************************************************************/
          /******/ // The module cache
          /******/
          var __webpack_module_cache__ = {};
          /******/
          /******/ // The require function
          /******/
          function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/var cachedModule = __webpack_module_cache__[moduleId];
            /******/
            if (cachedModule !== undefined) {
              /******/return cachedModule.exports;
              /******/
            }
            /******/ // Create a new module (and put it into the cache)
            /******/
            var module = __webpack_module_cache__[moduleId] = {
              /******/ // no module.id needed
              /******/ // no module.loaded needed
              /******/exports: {}
              /******/
            };
            /******/
            /******/ // Execute the module function
            /******/
            __webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            /******/
            /******/ // Return the exports of the module
            /******/
            return module.exports;
            /******/
          }
          /******/
          /******/ // expose the modules object (__webpack_modules__)
          /******/
          __webpack_require__.m = __webpack_modules__;
          /******/
          /************************************************************************/
          /******/ /* webpack/runtime/compat get default export */
          /******/
          (() => {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/__webpack_require__.n = module => {
              /******/var getter = module && module.__esModule ? /******/() => module["default"] : /******/() => module;
              /******/
              __webpack_require__.d(getter, {
                a: getter
              });
              /******/
              return getter;
              /******/
            };
            /******/
          })();
          /******/
          /******/ /* webpack/runtime/define property getters */
          /******/
          (() => {
            /******/ // define getter functions for harmony exports
            /******/__webpack_require__.d = (exports, definition) => {
              /******/for (var key in definition) {
                /******/if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                  /******/Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                  });
                  /******/
                }
                /******/
              }
              /******/
            };
            /******/
          })();
          /******/
          /******/ /* webpack/runtime/hasOwnProperty shorthand */
          /******/
          (() => {
            /******/__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
            /******/
          })();
          /******/
          /******/ /* webpack/runtime/make namespace object */
          /******/
          (() => {
            /******/ // define __esModule on exports
            /******/__webpack_require__.r = exports => {
              /******/if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                /******/Object.defineProperty(exports, Symbol.toStringTag, {
                  value: "Module"
                });
                /******/
              }
              /******/
              Object.defineProperty(exports, "__esModule", {
                value: true
              });
              /******/
            };
            /******/
          })();
          /******/
          /************************************************************************/
          /******/
          /******/ // module factories are used so entry inlining is disabled
          /******/ // startup
          /******/ // Load entry module and return exports
          /******/
          var __webpack_exports__ = __webpack_require__("./src/hls.ts");
          /******/
          __webpack_exports__ = __webpack_exports__["default"];
          /******/
          /******/
          return __webpack_exports__;
          /******/
        })()
      );
    });
  })(hls);
  var HLSJS = /*@__PURE__*/getDefaultExportFromCjs(hls.exports);
  var now = Utils.now,
    assign = Utils.assign,
    listContainsIgnoreCase = Utils.listContainsIgnoreCase;
  var AUTO = -1;
  Events.register("PLAYBACK_FRAGMENT_CHANGED");
  Events.register("PLAYBACK_FRAGMENT_PARSING_METADATA");
  var HlsjsPlayback = /*#__PURE__*/function (_HTML5Video) {
    _inherits(HlsjsPlayback, _HTML5Video);
    var _super = _createSuper(HlsjsPlayback);
    function HlsjsPlayback() {
      var _this;
      _classCallCheck(this || _global, HlsjsPlayback);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this || _global].concat(args));
      // backwards compatibility (TODO: remove on 0.3.0)
      _this.options.playback = _objectSpread2(_objectSpread2({}, _this.options), _this.options.playback);
      _this.options.hlsPlayback = _objectSpread2(_objectSpread2({}, _this.defaultOptions), _this.options.hlsPlayback);
      _this._minDvrSize = typeof _this.options.hlsMinimumDvrSize === "undefined" ? 60 : _this.options.hlsMinimumDvrSize;
      // The size of the start time extrapolation window measured as a multiple of segments.
      // Should be 2 or higher, or 0 to disable. Should only need to be increased above 2 if more than one segment is
      // removed from the start of the playlist at a time. E.g if the playlist is cached for 10 seconds and new chunks are
      // added/removed every 5.
      _this._extrapolatedWindowNumSegments = !_this.options.playback || typeof _this.options.playback.extrapolatedWindowNumSegments === "undefined" ? 2 : _this.options.playback.extrapolatedWindowNumSegments;
      _this._playbackType = Playback.VOD;
      _this._lastTimeUpdate = {
        current: 0,
        total: 0
      };
      _this._lastDuration = null;
      // for hls streams which have dvr with a sliding window,
      // the content at the start of the playlist is removed as new
      // content is appended at the end.
      // this means the actual playable start time will increase as the
      // start content is deleted
      // For streams with dvr where the entire recording is kept from the
      // beginning this should stay as 0
      _this._playableRegionStartTime = 0;
      // {local, remote} remote is the time in the video element that should represent 0
      //                 local is the system time when the 'remote' measurment took place
      _this._localStartTimeCorrelation = null;
      // {local, remote} remote is the time in the video element that should represents the end
      //                 local is the system time when the 'remote' measurment took place
      _this._localEndTimeCorrelation = null;
      // if content is removed from the beginning then this empty area should
      // be ignored. "playableRegionDuration" excludes the empty area
      _this._playableRegionDuration = 0;
      // #EXT-X-PROGRAM-DATE-TIME
      _this._programDateTime = 0;
      // true when the actual duration is longer than hlsjs's live sync point
      // when this is false playableRegionDuration will be the actual duration
      // when this is true playableRegionDuration will exclude the time after the sync point
      _this._durationExcludesAfterLiveSyncPoint = false;
      // #EXT-X-TARGETDURATION
      _this._segmentTargetDuration = null;
      // #EXT-X-PLAYLIST-TYPE
      _this._playlistType = null;
      _this._recoverAttemptsRemaining = _this.options.hlsRecoverAttempts || 16;
      return _this;
    }
    _createClass(HlsjsPlayback, [{
      key: "name",
      get: function get() {
        return "hls";
      }
    }, {
      key: "supportedVersion",
      get: function get() {
        return {
          min: "0.4.27"
        };
      }
    }, {
      key: "levels",
      get: function get() {
        return (this || _global)._levels || [];
      }
    }, {
      key: "currentLevel",
      get: function get() {
        if ((this || _global)._currentLevel === null || (this || _global)._currentLevel === undefined) return AUTO;else return (this || _global)._currentLevel; //0 is a valid level ID
      },

      set: function set(id) {
        (this || _global)._currentLevel = id;
        this.trigger(Events.PLAYBACK_LEVEL_SWITCH_START);
        if ((this || _global).options.playback.hlsUseNextLevel) (this || _global)._hls.nextLevel = (this || _global)._currentLevel;else (this || _global)._hls.currentLevel = (this || _global)._currentLevel;
      }
    }, {
      key: "isReady",
      get: function get() {
        return (this || _global)._isReadyState;
      }
    }, {
      key: "_startTime",
      get: function get() {
        if ((this || _global)._playbackType === Playback.LIVE && (this || _global)._playlistType !== "EVENT") return (this || _global)._extrapolatedStartTime;
        return (this || _global)._playableRegionStartTime;
      }
    }, {
      key: "_now",
      get: function get() {
        return now();
      }

      // the time in the video element which should represent the start of the sliding window
      // extrapolated to increase in real time (instead of jumping as the early segments are removed)
    }, {
      key: "_extrapolatedStartTime",
      get: function get() {
        if (!(this || _global)._localStartTimeCorrelation) return (this || _global)._playableRegionStartTime;
        var corr = (this || _global)._localStartTimeCorrelation;
        var timePassed = (this || _global)._now - corr.local;
        var extrapolatedWindowStartTime = (corr.remote + timePassed) / 1000;
        // cap at the end of the extrapolated window duration
        return Math.min(extrapolatedWindowStartTime, (this || _global)._playableRegionStartTime + (this || _global)._extrapolatedWindowDuration);
      }

      // the time in the video element which should represent the end of the content
      // extrapolated to increase in real time (instead of jumping as segments are added)
    }, {
      key: "_extrapolatedEndTime",
      get: function get() {
        var actualEndTime = (this || _global)._playableRegionStartTime + (this || _global)._playableRegionDuration;
        if (!(this || _global)._localEndTimeCorrelation) return actualEndTime;
        var corr = (this || _global)._localEndTimeCorrelation;
        var timePassed = (this || _global)._now - corr.local;
        var extrapolatedEndTime = (corr.remote + timePassed) / 1000;
        return Math.max(actualEndTime - (this || _global)._extrapolatedWindowDuration, Math.min(extrapolatedEndTime, actualEndTime));
      }
    }, {
      key: "_duration",
      get: function get() {
        return (this || _global)._extrapolatedEndTime - (this || _global)._startTime;
      }

      // Returns the duration (seconds) of the window that the extrapolated start time is allowed
      // to move in before being capped.
      // The extrapolated start time should never reach the cap at the end of the window as the
      // window should slide as chunks are removed from the start.
      // This also applies to the extrapolated end time in the same way.
      //
      // If chunks aren't being removed for some reason that the start time will reach and remain fixed at
      // playableRegionStartTime + extrapolatedWindowDuration
      //
      //                                <-- window duration -->
      // I.e   playableRegionStartTime |-----------------------|
      //                               | -->   .       .       .
      //                               .   --> | -->   .       .
      //                               .       .   --> | -->   .
      //                               .       .       .   --> |
      //                               .       .       .       .
      //                                 extrapolatedStartTime
    }, {
      key: "_extrapolatedWindowDuration",
      get: function get() {
        if ((this || _global)._segmentTargetDuration === null) return 0;
        return (this || _global)._extrapolatedWindowNumSegments * (this || _global)._segmentTargetDuration;
      }
    }, {
      key: "bandwidthEstimate",
      get: function get() {
        return (this || _global)._hls && (this || _global)._hls.bandwidthEstimate;
      }
    }, {
      key: "defaultOptions",
      get: function get() {
        return {
          preload: true
        };
      }
    }, {
      key: "customListeners",
      get: function get() {
        return (this || _global).options.hlsPlayback && (this || _global).options.hlsPlayback.customListeners || [];
      }
    }, {
      key: "_setup",
      value: function _setup() {
        var _this2 = this || _global;
        (this || _global)._manifestParsed = false;
        (this || _global)._ccIsSetup = false;
        (this || _global)._ccTracksUpdated = false;
        (this || _global)._hls && (this || _global)._hls.destroy();
        (this || _global)._hls = new HLSJS(assign({}, (this || _global).options.playback.hlsjsConfig));
        (this || _global)._hls.once(HLSJS.Events.MEDIA_ATTACHED, function () {
          _this2.options.hlsPlayback.preload && _this2._hls.loadSource(_this2.options.src);
        });
        (this || _global)._hls.on(HLSJS.Events.MANIFEST_PARSED, function () {
          return _this2._manifestParsed = true;
        });
        (this || _global)._hls.on(HLSJS.Events.LEVEL_LOADED, function (evt, data) {
          return _this2._updatePlaybackType(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.LEVEL_UPDATED, function (evt, data) {
          return _this2._onLevelUpdated(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.LEVEL_SWITCHING, function (evt, data) {
          return _this2._onLevelSwitch(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.FRAG_CHANGED, function (evt, data) {
          return _this2._onFragmentChanged(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.FRAG_LOADED, function (evt, data) {
          return _this2._onFragmentLoaded(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.FRAG_PARSING_METADATA, function (evt, data) {
          return _this2._onFragmentParsingMetadata(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.ERROR, function (evt, data) {
          return _this2._onHLSJSError(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.SUBTITLE_TRACK_LOADED, function (evt, data) {
          return _this2._onSubtitleLoaded(evt, data);
        });
        (this || _global)._hls.on(HLSJS.Events.SUBTITLE_TRACKS_UPDATED, function () {
          return _this2._ccTracksUpdated = true;
        });
        this.bindCustomListeners();
        (this || _global)._hls.attachMedia((this || _global).el);
      }
    }, {
      key: "bindCustomListeners",
      value: function bindCustomListeners() {
        var _this3 = this || _global;
        (this || _global).customListeners.forEach(function (item) {
          var requestedEventName = item.eventName;
          var typeOfListener = item.once ? "once" : "on";
          requestedEventName && _this3._hls["".concat(typeOfListener)](requestedEventName, item.callback);
        });
      }
    }, {
      key: "unbindCustomListeners",
      value: function unbindCustomListeners() {
        var _this4 = this || _global;
        (this || _global).customListeners.forEach(function (item) {
          var requestedEventName = item.eventName;
          requestedEventName && _this4._hls.off(requestedEventName, item.callback);
        });
      }
    }, {
      key: "_onFragmentParsingMetadata",
      value: function _onFragmentParsingMetadata(evt, data) {
        this.trigger(Events.Custom.PLAYBACK_FRAGMENT_PARSING_METADATA, {
          evt: evt,
          data: data
        });
      }
    }, {
      key: "render",
      value: function render() {
        this._ready();
        return _get(_getPrototypeOf(HlsjsPlayback.prototype), "render", this || _global).call(this || _global);
      }
    }, {
      key: "_ready",
      value: function _ready() {
        if ((this || _global)._isReadyState) return;
        !(this || _global)._hls && this._setup();
        (this || _global)._isReadyState = true;
        this.trigger(Events.PLAYBACK_READY, (this || _global).name);
      }
    }, {
      key: "_recover",
      value: function _recover(evt, data, error) {
        if (!(this || _global)._recoveredDecodingError) {
          (this || _global)._recoveredDecodingError = true;
          (this || _global)._hls.recoverMediaError();
        } else if (!(this || _global)._recoveredAudioCodecError) {
          (this || _global)._recoveredAudioCodecError = true;
          (this || _global)._hls.swapAudioCodec();
          (this || _global)._hls.recoverMediaError();
        } else {
          Log.error("hlsjs: failed to recover", {
            evt: evt,
            data: data
          });
          error.level = PlayerError.Levels.FATAL;
          var formattedError = this.createError(error);
          this.trigger(Events.PLAYBACK_ERROR, formattedError);
          this.stop();
        }
      }

      // override
    }, {
      key: "_setupSrc",
      value: function _setupSrc(srcUrl) {// eslint-disable-line no-unused-vars
        // this playback manages the src on the video element itself
      }
    }, {
      key: "_startTimeUpdateTimer",
      value: function _startTimeUpdateTimer() {
        var _this5 = this || _global;
        if ((this || _global)._timeUpdateTimer) return;
        (this || _global)._timeUpdateTimer = setInterval(function () {
          _this5._onDurationChange();
          _this5._onTimeUpdate();
        }, 100);
      }
    }, {
      key: "_stopTimeUpdateTimer",
      value: function _stopTimeUpdateTimer() {
        if (!(this || _global)._timeUpdateTimer) return;
        clearInterval((this || _global)._timeUpdateTimer);
        (this || _global)._timeUpdateTimer = null;
      }
    }, {
      key: "getProgramDateTime",
      value: function getProgramDateTime() {
        return (this || _global)._programDateTime;
      }
      // the duration on the video element itself should not be used
      // as this does not necesarily represent the duration of the stream
      // https://github.com/clappr/clappr/issues/668#issuecomment-157036678
    }, {
      key: "getDuration",
      value: function getDuration() {
        return (this || _global)._duration;
      }
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        // e.g. can be < 0 if user pauses near the start
        // eventually they will then be kicked to the end by hlsjs if they run out of buffer
        // before the official start time
        return Math.max(0, (this || _global).el.currentTime - (this || _global)._startTime);
      }

      // the time that "0" now represents relative to when playback started
      // for a stream with a sliding window this will increase as content is
      // removed from the beginning
    }, {
      key: "getStartTimeOffset",
      value: function getStartTimeOffset() {
        return (this || _global)._startTime;
      }
    }, {
      key: "seekPercentage",
      value: function seekPercentage(percentage) {
        var seekTo = (this || _global)._duration;
        if (percentage > 0) seekTo = (this || _global)._duration * (percentage / 100);
        this.seek(seekTo);
      }
    }, {
      key: "seek",
      value: function seek(time) {
        if (time < 0) {
          Log.warn("Attempt to seek to a negative time. Resetting to live point. Use seekToLivePoint() to seek to the live point.");
          time = this.getDuration();
        }
        // assume live if time within 3 seconds of end of stream
        (this || _global).dvrEnabled && this._updateDvr(time < this.getDuration() - 3);
        time += (this || _global)._startTime;
        (this || _global).el.currentTime = time;
      }
    }, {
      key: "seekToLivePoint",
      value: function seekToLivePoint() {
        this.seek(this.getDuration());
      }
    }, {
      key: "_updateDvr",
      value: function _updateDvr(status) {
        this.trigger(Events.PLAYBACK_DVR, status);
        this.trigger(Events.PLAYBACK_STATS_ADD, {
          "dvr": status
        });
      }
    }, {
      key: "_updateSettings",
      value: function _updateSettings() {
        if ((this || _global)._playbackType === Playback.VOD) (this || _global).settings.left = ["playpause", "position", "duration"];else if ((this || _global).dvrEnabled) (this || _global).settings.left = ["playpause"];else (this || _global).settings.left = ["playstop"];
        (this || _global).settings.seekEnabled = this.isSeekEnabled();
        this.trigger(Events.PLAYBACK_SETTINGSUPDATE);
      }
    }, {
      key: "_onHLSJSError",
      value: function _onHLSJSError(evt, data) {
        var error = {
          code: "".concat(data.type, "_").concat(data.details),
          description: "".concat((this || _global).name, " error: type: ").concat(data.type, ", details: ").concat(data.details),
          raw: data
        };
        var formattedError;
        if (data.response) error.description += ", response: ".concat(JSON.stringify(data.response));
        // only report/handle errors if they are fatal
        // hlsjs should automatically handle non fatal errors
        if (data.fatal) {
          if ((this || _global)._recoverAttemptsRemaining > 0) {
            (this || _global)._recoverAttemptsRemaining -= 1;
            switch (data.type) {
              case HLSJS.ErrorTypes.NETWORK_ERROR:
                switch (data.details) {
                  // The following network errors cannot be recovered with HLS.startLoad()
                  // For more details, see https://github.com/video-dev/hls.js/blob/master/doc/design.md#error-detection-and-handling
                  // For "level load" fatal errors, see https://github.com/video-dev/hls.js/issues/1138
                  case HLSJS.ErrorDetails.MANIFEST_LOAD_ERROR:
                  case HLSJS.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
                  case HLSJS.ErrorDetails.MANIFEST_PARSING_ERROR:
                  case HLSJS.ErrorDetails.LEVEL_LOAD_ERROR:
                  case HLSJS.ErrorDetails.LEVEL_LOAD_TIMEOUT:
                    Log.error("hlsjs: unrecoverable network fatal error.", {
                      evt: evt,
                      data: data
                    });
                    formattedError = this.createError(error);
                    this.trigger(Events.PLAYBACK_ERROR, formattedError);
                    this.stop();
                    break;
                  default:
                    Log.warn("hlsjs: trying to recover from network error.", {
                      evt: evt,
                      data: data
                    });
                    error.level = PlayerError.Levels.WARN;
                    (this || _global)._hls.startLoad();
                    break;
                }
                break;
              case HLSJS.ErrorTypes.MEDIA_ERROR:
                Log.warn("hlsjs: trying to recover from media error.", {
                  evt: evt,
                  data: data
                });
                error.level = PlayerError.Levels.WARN;
                this._recover(evt, data, error);
                break;
              default:
                Log.error("hlsjs: could not recover from error.", {
                  evt: evt,
                  data: data
                });
                formattedError = this.createError(error);
                this.trigger(Events.PLAYBACK_ERROR, formattedError);
                this.stop();
                break;
            }
          } else {
            Log.error("hlsjs: could not recover from error after maximum number of attempts.", {
              evt: evt,
              data: data
            });
            formattedError = this.createError(error);
            this.trigger(Events.PLAYBACK_ERROR, formattedError);
            this.stop();
          }
        } else {
          // Transforms HLSJS.ErrorDetails.KEY_LOAD_ERROR non-fatal error to
          // playback fatal error if triggerFatalErrorOnResourceDenied playback
          // option is set. HLSJS.ErrorTypes.KEY_SYSTEM_ERROR are fatal errors
          // and therefore already handled.
          if ((this || _global).options.playback.triggerFatalErrorOnResourceDenied && this._keyIsDenied(data)) {
            Log.error("hlsjs: could not load decrypt key.", {
              evt: evt,
              data: data
            });
            formattedError = this.createError(error);
            this.trigger(Events.PLAYBACK_ERROR, formattedError);
            this.stop();
            return;
          }
          error.level = PlayerError.Levels.WARN;
          Log.warn("hlsjs: non-fatal error occurred", {
            evt: evt,
            data: data
          });
        }
      }
    }, {
      key: "_keyIsDenied",
      value: function _keyIsDenied(data) {
        return data.type === HLSJS.ErrorTypes.NETWORK_ERROR && data.details === HLSJS.ErrorDetails.KEY_LOAD_ERROR && data.response && data.response.code >= 400;
      }
    }, {
      key: "_onTimeUpdate",
      value: function _onTimeUpdate() {
        var update = {
          current: this.getCurrentTime(),
          total: this.getDuration(),
          firstFragDateTime: this.getProgramDateTime()
        };
        var isSame = (this || _global)._lastTimeUpdate && update.current === (this || _global)._lastTimeUpdate.current && update.total === (this || _global)._lastTimeUpdate.total;
        if (isSame) return;
        (this || _global)._lastTimeUpdate = update;
        this.trigger(Events.PLAYBACK_TIMEUPDATE, update, (this || _global).name);
      }
    }, {
      key: "_onDurationChange",
      value: function _onDurationChange() {
        var duration = this.getDuration();
        if ((this || _global)._lastDuration === duration) return;
        (this || _global)._lastDuration = duration;
        _get(_getPrototypeOf(HlsjsPlayback.prototype), "_onDurationChange", this || _global).call(this || _global);
      }
    }, {
      key: "_onProgress",
      value: function _onProgress() {
        if (!(this || _global).el.buffered.length) return;
        var buffered = [];
        var bufferedPos = 0;
        for (var i = 0; i < (this || _global).el.buffered.length; i++) {
          buffered = [].concat(_toConsumableArray(buffered), [{
            // for a stream with sliding window dvr something that is buffered my slide off the start of the timeline
            start: Math.max(0, (this || _global).el.buffered.start(i) - (this || _global)._playableRegionStartTime),
            end: Math.max(0, (this || _global).el.buffered.end(i) - (this || _global)._playableRegionStartTime)
          }]);
          if ((this || _global).el.currentTime >= buffered[i].start && (this || _global).el.currentTime <= buffered[i].end) bufferedPos = i;
        }
        var progress = {
          start: buffered[bufferedPos].start,
          current: buffered[bufferedPos].end,
          total: this.getDuration()
        };
        this.trigger(Events.PLAYBACK_PROGRESS, progress, buffered);
      }
    }, {
      key: "play",
      value: function play() {
        !(this || _global)._hls && this._setup();
        !(this || _global)._manifestParsed && !(this || _global).options.hlsPlayback.preload && (this || _global)._hls.loadSource((this || _global).options.src);
        _get(_getPrototypeOf(HlsjsPlayback.prototype), "play", this || _global).call(this || _global);
        this._startTimeUpdateTimer();
      }
    }, {
      key: "pause",
      value: function pause() {
        if (!(this || _global)._hls) return;
        (this || _global).el.pause();
        if ((this || _global).dvrEnabled) this._updateDvr(true);
      }
    }, {
      key: "stop",
      value: function stop() {
        this._stopTimeUpdateTimer();
        if ((this || _global)._hls) {
          _get(_getPrototypeOf(HlsjsPlayback.prototype), "stop", this || _global).call(this || _global);
          (this || _global)._hls.destroy();
          delete (this || _global)._hls;
        }
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this._stopTimeUpdateTimer();
        if ((this || _global)._hls) {
          (this || _global)._hls.destroy();
          delete (this || _global)._hls;
        }
        _get(_getPrototypeOf(HlsjsPlayback.prototype), "destroy", this || _global).call(this || _global);
      }
    }, {
      key: "_updatePlaybackType",
      value: function _updatePlaybackType(evt, data) {
        (this || _global)._playbackType = data.details.live ? Playback.LIVE : Playback.VOD;
        this._onLevelUpdated(evt, data);

        // Live stream subtitle tracks detection hack (may not immediately available)
        if ((this || _global)._ccTracksUpdated && (this || _global)._playbackType === Playback.LIVE && (this || _global).hasClosedCaptionsTracks) this._onSubtitleLoaded();
      }
    }, {
      key: "_fillLevels",
      value: function _fillLevels() {
        (this || _global)._levels = (this || _global)._hls.levels.map(function (level, index) {
          return {
            id: index,
            level: level,
            label: "".concat(level.bitrate / 1000, "Kbps")
          };
        });
        this.trigger(Events.PLAYBACK_LEVELS_AVAILABLE, (this || _global)._levels);
      }
    }, {
      key: "_onLevelUpdated",
      value: function _onLevelUpdated(evt, data) {
        (this || _global)._segmentTargetDuration = data.details.targetduration;
        (this || _global)._playlistType = data.details.type || null;
        var startTimeChanged = false;
        var durationChanged = false;
        var fragments = data.details.fragments;
        var previousPlayableRegionStartTime = (this || _global)._playableRegionStartTime;
        var previousPlayableRegionDuration = (this || _global)._playableRegionDuration;
        if (fragments.length === 0) return;

        // #EXT-X-PROGRAM-DATE-TIME
        if (fragments[0].rawProgramDateTime) (this || _global)._programDateTime = fragments[0].rawProgramDateTime;
        if ((this || _global)._playableRegionStartTime !== fragments[0].start) {
          startTimeChanged = true;
          (this || _global)._playableRegionStartTime = fragments[0].start;
        }
        if (startTimeChanged) {
          if (!(this || _global)._localStartTimeCorrelation) {
            // set the correlation to map to middle of the extrapolation window
            (this || _global)._localStartTimeCorrelation = {
              local: (this || _global)._now,
              remote: (fragments[0].start + (this || _global)._extrapolatedWindowDuration / 2) * 1000
            };
          } else {
            // check if the correlation still works
            var corr = (this || _global)._localStartTimeCorrelation;
            var timePassed = (this || _global)._now - corr.local;
            // this should point to a time within the extrapolation window
            var startTime = (corr.remote + timePassed) / 1000;
            if (startTime < fragments[0].start) {
              // our start time is now earlier than the first chunk
              // (maybe the chunk was removed early)
              // reset correlation so that it sits at the beginning of the first available chunk
              (this || _global)._localStartTimeCorrelation = {
                local: (this || _global)._now,
                remote: fragments[0].start * 1000
              };
            } else if (startTime > previousPlayableRegionStartTime + (this || _global)._extrapolatedWindowDuration) {
              // start time was past the end of the old extrapolation window (so would have been capped)
              // see if now that time would be inside the window, and if it would be set the correlation
              // so that it resumes from the time it was at at the end of the old window
              // update the correlation so that the time starts counting again from the value it's on now
              (this || _global)._localStartTimeCorrelation = {
                local: (this || _global)._now,
                remote: Math.max(fragments[0].start, previousPlayableRegionStartTime + (this || _global)._extrapolatedWindowDuration) * 1000
              };
            }
          }
        }
        var newDuration = data.details.totalduration;
        // if it's a live stream then shorten the duration to remove access
        // to the area after hlsjs's live sync point
        // seeks to areas after this point sometimes have issues
        if ((this || _global)._playbackType === Playback.LIVE) {
          var fragmentTargetDuration = data.details.targetduration;
          var hlsjsConfig = (this || _global).options.playback.hlsjsConfig || {};
          var liveSyncDurationCount = hlsjsConfig.liveSyncDurationCount || HLSJS.DefaultConfig.liveSyncDurationCount;
          var hiddenAreaDuration = fragmentTargetDuration * liveSyncDurationCount;
          if (hiddenAreaDuration <= newDuration) {
            newDuration -= hiddenAreaDuration;
            (this || _global)._durationExcludesAfterLiveSyncPoint = true;
          } else {
            (this || _global)._durationExcludesAfterLiveSyncPoint = false;
          }
        }
        if (newDuration !== (this || _global)._playableRegionDuration) {
          durationChanged = true;
          (this || _global)._playableRegionDuration = newDuration;
        }

        // Note the end time is not the playableRegionDuration
        // The end time will always increase even if content is removed from the beginning
        var endTime = fragments[0].start + newDuration;
        var previousEndTime = previousPlayableRegionStartTime + previousPlayableRegionDuration;
        var endTimeChanged = endTime !== previousEndTime;
        if (endTimeChanged) {
          if (!(this || _global)._localEndTimeCorrelation) {
            // set the correlation to map to the end
            (this || _global)._localEndTimeCorrelation = {
              local: (this || _global)._now,
              remote: endTime * 1000
            };
          } else {
            // check if the correlation still works
            var _corr = (this || _global)._localEndTimeCorrelation;
            var _timePassed = (this || _global)._now - _corr.local;
            // this should point to a time within the extrapolation window from the end
            var extrapolatedEndTime = (_corr.remote + _timePassed) / 1000;
            if (extrapolatedEndTime > endTime) {
              (this || _global)._localEndTimeCorrelation = {
                local: (this || _global)._now,
                remote: endTime * 1000
              };
            } else if (extrapolatedEndTime < endTime - (this || _global)._extrapolatedWindowDuration) {
              // our extrapolated end time is now earlier than the extrapolation window from the actual end time
              // (maybe a chunk became available early)
              // reset correlation so that it sits at the beginning of the extrapolation window from the end time
              (this || _global)._localEndTimeCorrelation = {
                local: (this || _global)._now,
                remote: (endTime - (this || _global)._extrapolatedWindowDuration) * 1000
              };
            } else if (extrapolatedEndTime > previousEndTime) {
              // end time was past the old end time (so would have been capped)
              // set the correlation so that it resumes from the time it was at at the end of the old window
              (this || _global)._localEndTimeCorrelation = {
                local: (this || _global)._now,
                remote: previousEndTime * 1000
              };
            }
          }
        }

        // now that the values have been updated call any methods that use on them so they get the updated values
        // immediately
        durationChanged && this._onDurationChange();
        startTimeChanged && this._onProgress();
      }
    }, {
      key: "_onFragmentChanged",
      value: function _onFragmentChanged(evt, data) {
        this.trigger(Events.Custom.PLAYBACK_FRAGMENT_CHANGED, data);
      }
    }, {
      key: "_onFragmentLoaded",
      value: function _onFragmentLoaded(evt, data) {
        this.trigger(Events.PLAYBACK_FRAGMENT_LOADED, data);
      }
    }, {
      key: "_onSubtitleLoaded",
      value: function _onSubtitleLoaded() {
        // This event may be triggered multiple times
        // Setup CC only once (disable CC by default)
        if (!(this || _global)._ccIsSetup) {
          this.trigger(Events.PLAYBACK_SUBTITLE_AVAILABLE);
          var trackId = (this || _global)._playbackType === Playback.LIVE ? -1 : (this || _global).closedCaptionsTrackId;
          (this || _global).closedCaptionsTrackId = trackId;
          (this || _global)._ccIsSetup = true;
        }
      }
    }, {
      key: "_onLevelSwitch",
      value: function _onLevelSwitch(evt, data) {
        if (!(this || _global).levels.length) this._fillLevels();
        this.trigger(Events.PLAYBACK_LEVEL_SWITCH_END);
        this.trigger(Events.PLAYBACK_LEVEL_SWITCH, data);
        var currentLevel = (this || _global)._hls.levels[data.level];
        if (currentLevel) {
          // TODO should highDefinition be private and maybe have a read only accessor if it's used somewhere
          (this || _global).highDefinition = currentLevel.height >= 720 || currentLevel.bitrate / 1000 >= 2000;
          this.trigger(Events.PLAYBACK_HIGHDEFINITIONUPDATE, (this || _global).highDefinition);
          this.trigger(Events.PLAYBACK_BITRATE, {
            height: currentLevel.height,
            width: currentLevel.width,
            bandwidth: currentLevel.bitrate,
            bitrate: currentLevel.bitrate,
            level: data.level
          });
        }
      }
    }, {
      key: "dvrEnabled",
      get: function get() {
        // enabled when:
        // - the duration does not include content after hlsjs's live sync point
        // - the playable region duration is longer than the configured duration to enable dvr after
        // - the playback type is LIVE.
        return (this || _global)._durationExcludesAfterLiveSyncPoint && (this || _global)._duration >= (this || _global)._minDvrSize && this.getPlaybackType() === Playback.LIVE;
      }
    }, {
      key: "getPlaybackType",
      value: function getPlaybackType() {
        return (this || _global)._playbackType;
      }
    }, {
      key: "isSeekEnabled",
      value: function isSeekEnabled() {
        return (this || _global)._playbackType === Playback.VOD || (this || _global).dvrEnabled;
      }
    }], [{
      key: "HLSJS",
      get: function get() {
        return HLSJS;
      }
    }]);
    return HlsjsPlayback;
  }(HTML5Video);
  HlsjsPlayback.canPlay = function (resource, mimeType) {
    var resourceParts = resource.split("?")[0].match(/.*\.(.*)$/) || [];
    var isHls = resourceParts.length > 1 && resourceParts[1].toLowerCase() === "m3u8" || listContainsIgnoreCase(mimeType, ["application/vnd.apple.mpegurl", "application/x-mpegURL"]);
    return !!(HLSJS.isSupported() && isHls);
  };
  BaseExports.Loader.registerPlayback(HlsjsPlayback);
  var main = _objectSpread2$2(_objectSpread2$2({}, BaseExports), {}, {
    HLS: HlsjsPlayback
  });
  return main;
});
//# sourceMappingURL=clappr.js.map
export default exports;
export const __esModule = exports.__esModule;